webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(341);
	__webpack_require__(345);
	__webpack_require__(338);
	__webpack_require__(340);
	__webpack_require__(337);
	__webpack_require__(344);
	__webpack_require__(343);
	__webpack_require__(342);
	__webpack_require__(712);
	__webpack_require__(11);
	__webpack_require__(360);
	__webpack_require__(368);
	__webpack_require__(363);
	__webpack_require__(364);
	__webpack_require__(361);
	__webpack_require__(362);
	__webpack_require__(365);
	__webpack_require__(366);
	__webpack_require__(367);
	__webpack_require__(115);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(302);
	__webpack_require__(309);
	__webpack_require__(304);
	__webpack_require__(1281);
	__webpack_require__(336);
	__webpack_require__(719);
	__webpack_require__(1217);
	__webpack_require__(1280);
	__webpack_require__(1221);
	__webpack_require__(1218);
	__webpack_require__(1220);
	__webpack_require__(1222);
	__webpack_require__(1223);
	__webpack_require__(1219);
	__webpack_require__(1224);
	__webpack_require__(1294);
	__webpack_require__(1295);
	__webpack_require__(1296);
	__webpack_require__(1297);
	__webpack_require__(1289);
	__webpack_require__(1291);
	__webpack_require__(1292);
	__webpack_require__(1293);
	__webpack_require__(1290);
	__webpack_require__(1287);
	__webpack_require__(1288);
	__webpack_require__(1298);
	__webpack_require__(317);
	__webpack_require__(307);
	__webpack_require__(316);
	__webpack_require__(303);
	__webpack_require__(315);
	__webpack_require__(320);
	__webpack_require__(1228);
	__webpack_require__(1);
	__webpack_require__(1284);
	__webpack_require__(1285);
	__webpack_require__(716);
	__webpack_require__(1283);
	__webpack_require__(1282);
	__webpack_require__(1286);
	__webpack_require__(715);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(140);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(649);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(653);
	__webpack_require__(654);
	__webpack_require__(655);
	__webpack_require__(656);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(661);
	__webpack_require__(662);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(666);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(669);
	__webpack_require__(670);
	__webpack_require__(671);
	__webpack_require__(674);
	__webpack_require__(675);
	__webpack_require__(676);
	__webpack_require__(677);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(672);
	__webpack_require__(673);
	__webpack_require__(680);
	__webpack_require__(681);
	__webpack_require__(682);
	__webpack_require__(683);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(690);
	__webpack_require__(691);
	__webpack_require__(140);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(694);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(699);
	__webpack_require__(700);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(706);
	__webpack_require__(707);
	__webpack_require__(708);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(711);
	__webpack_require__(314);
	__webpack_require__(136);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(587);
	__webpack_require__(588);
	__webpack_require__(589);
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(592);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(598);
	__webpack_require__(599);
	__webpack_require__(600);
	__webpack_require__(601);
	__webpack_require__(602);
	__webpack_require__(603);
	__webpack_require__(604);
	__webpack_require__(605);
	__webpack_require__(606);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(609);
	__webpack_require__(610);
	__webpack_require__(611);
	__webpack_require__(136);
	__webpack_require__(134);
	__webpack_require__(476);
	__webpack_require__(477);
	__webpack_require__(134);
	__webpack_require__(130);
	__webpack_require__(413);
	__webpack_require__(414);
	__webpack_require__(130);
	__webpack_require__(415);
	__webpack_require__(416);
	__webpack_require__(135);
	__webpack_require__(486);
	__webpack_require__(485);
	__webpack_require__(488);
	__webpack_require__(487);
	__webpack_require__(490);
	__webpack_require__(491);
	__webpack_require__(489);
	__webpack_require__(493);
	__webpack_require__(492);
	__webpack_require__(495);
	__webpack_require__(494);
	__webpack_require__(496);
	__webpack_require__(498);
	__webpack_require__(497);
	__webpack_require__(499);
	__webpack_require__(500);
	__webpack_require__(501);
	__webpack_require__(502);
	__webpack_require__(503);
	__webpack_require__(504);
	__webpack_require__(478);
	__webpack_require__(479);
	__webpack_require__(480);
	__webpack_require__(481);
	__webpack_require__(482);
	__webpack_require__(483);
	__webpack_require__(484);
	__webpack_require__(505);
	__webpack_require__(506);
	__webpack_require__(507);
	__webpack_require__(508);
	__webpack_require__(509);
	__webpack_require__(510);
	__webpack_require__(511);
	__webpack_require__(512);
	__webpack_require__(513);
	__webpack_require__(514);
	__webpack_require__(515);
	__webpack_require__(516);
	__webpack_require__(517);
	__webpack_require__(518);
	__webpack_require__(519);
	__webpack_require__(520);
	__webpack_require__(521);
	__webpack_require__(522);
	__webpack_require__(523);
	__webpack_require__(524);
	__webpack_require__(525);
	__webpack_require__(526);
	__webpack_require__(527);
	__webpack_require__(528);
	__webpack_require__(529);
	__webpack_require__(530);
	__webpack_require__(531);
	__webpack_require__(532);
	__webpack_require__(533);
	__webpack_require__(534);
	__webpack_require__(535);
	__webpack_require__(536);
	__webpack_require__(537);
	__webpack_require__(538);
	__webpack_require__(539);
	__webpack_require__(540);
	__webpack_require__(541);
	__webpack_require__(542);
	__webpack_require__(543);
	__webpack_require__(544);
	__webpack_require__(545);
	__webpack_require__(546);
	__webpack_require__(547);
	__webpack_require__(548);
	__webpack_require__(549);
	__webpack_require__(550);
	__webpack_require__(551);
	__webpack_require__(552);
	__webpack_require__(553);
	__webpack_require__(555);
	__webpack_require__(554);
	__webpack_require__(556);
	__webpack_require__(557);
	__webpack_require__(558);
	__webpack_require__(559);
	__webpack_require__(561);
	__webpack_require__(560);
	__webpack_require__(562);
	__webpack_require__(563);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(567);
	__webpack_require__(135);
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(575);
	__webpack_require__(576);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(574);
	__webpack_require__(56);
	__webpack_require__(312);
	__webpack_require__(128);
	__webpack_require__(128);
	__webpack_require__(370);
	__webpack_require__(371);
	__webpack_require__(372);
	__webpack_require__(373);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(376);
	__webpack_require__(131);
	__webpack_require__(417);
	__webpack_require__(418);
	__webpack_require__(419);
	__webpack_require__(420);
	__webpack_require__(421);
	__webpack_require__(422);
	__webpack_require__(423);
	__webpack_require__(424);
	__webpack_require__(425);
	__webpack_require__(426);
	__webpack_require__(427);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(430);
	__webpack_require__(431);
	__webpack_require__(432);
	__webpack_require__(131);
	__webpack_require__(433);
	__webpack_require__(434);
	__webpack_require__(435);
	__webpack_require__(436);
	__webpack_require__(437);
	__webpack_require__(438);
	__webpack_require__(439);
	__webpack_require__(440);
	__webpack_require__(441);
	__webpack_require__(442);
	__webpack_require__(443);
	__webpack_require__(137);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(614);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(618);
	__webpack_require__(617);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(619);
	__webpack_require__(620);
	__webpack_require__(621);
	__webpack_require__(622);
	__webpack_require__(623);
	__webpack_require__(624);
	__webpack_require__(625);
	__webpack_require__(626);
	__webpack_require__(627);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(631);
	__webpack_require__(632);
	__webpack_require__(633);
	__webpack_require__(634);
	__webpack_require__(635);
	__webpack_require__(138);
	__webpack_require__(636);
	__webpack_require__(637);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(313);
	__webpack_require__(133);
	__webpack_require__(475);
	__webpack_require__(133);
	__webpack_require__(139);
	__webpack_require__(640);
	__webpack_require__(641);
	__webpack_require__(642);
	__webpack_require__(643);
	__webpack_require__(644);
	__webpack_require__(645);
	__webpack_require__(139);
	__webpack_require__(132);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(444);
	__webpack_require__(445);
	__webpack_require__(446);
	__webpack_require__(447);
	__webpack_require__(132);
	__webpack_require__(448);
	__webpack_require__(449);
	__webpack_require__(450);
	__webpack_require__(451);
	__webpack_require__(452);
	__webpack_require__(453);
	__webpack_require__(454);
	__webpack_require__(455);
	__webpack_require__(456);
	__webpack_require__(457);
	__webpack_require__(458);
	__webpack_require__(459);
	__webpack_require__(460);
	__webpack_require__(461);
	__webpack_require__(462);
	__webpack_require__(463);
	__webpack_require__(464);
	__webpack_require__(465);
	__webpack_require__(466);
	__webpack_require__(467);
	__webpack_require__(468);
	__webpack_require__(469);
	__webpack_require__(470);
	__webpack_require__(471);
	__webpack_require__(472);
	__webpack_require__(473);
	__webpack_require__(474);
	__webpack_require__(129);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(379);
	__webpack_require__(380);
	__webpack_require__(381);
	__webpack_require__(382);
	__webpack_require__(383);
	__webpack_require__(384);
	__webpack_require__(129);
	__webpack_require__(385);
	__webpack_require__(386);
	__webpack_require__(387);
	__webpack_require__(388);
	__webpack_require__(389);
	__webpack_require__(390);
	__webpack_require__(391);
	__webpack_require__(392);
	__webpack_require__(393);
	__webpack_require__(394);
	__webpack_require__(395);
	__webpack_require__(396);
	__webpack_require__(397);
	__webpack_require__(398);
	__webpack_require__(399);
	__webpack_require__(400);
	__webpack_require__(401);
	__webpack_require__(402);
	__webpack_require__(403);
	__webpack_require__(404);
	__webpack_require__(405);
	__webpack_require__(406);
	__webpack_require__(407);
	__webpack_require__(408);
	__webpack_require__(409);
	__webpack_require__(410);
	__webpack_require__(411);
	__webpack_require__(412);
	__webpack_require__(369);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(724);
	__webpack_require__(725);
	__webpack_require__(726);
	__webpack_require__(727);
	__webpack_require__(728);
	__webpack_require__(729);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(736);
	__webpack_require__(737);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(754);
	__webpack_require__(753);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(758);
	__webpack_require__(757);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(763);
	__webpack_require__(764);
	__webpack_require__(766);
	__webpack_require__(765);
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(769);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(773);
	__webpack_require__(774);
	__webpack_require__(775);
	__webpack_require__(776);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(781);
	__webpack_require__(782);
	__webpack_require__(783);
	__webpack_require__(784);
	__webpack_require__(785);
	__webpack_require__(786);
	__webpack_require__(787);
	__webpack_require__(788);
	__webpack_require__(789);
	__webpack_require__(790);
	__webpack_require__(791);
	__webpack_require__(792);
	__webpack_require__(793);
	__webpack_require__(794);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(798);
	__webpack_require__(799);
	__webpack_require__(800);
	__webpack_require__(801);
	__webpack_require__(802);
	__webpack_require__(803);
	__webpack_require__(804);
	__webpack_require__(805);
	__webpack_require__(806);
	__webpack_require__(807);
	__webpack_require__(808);
	__webpack_require__(809);
	__webpack_require__(810);
	__webpack_require__(811);
	__webpack_require__(812);
	__webpack_require__(813);
	__webpack_require__(814);
	__webpack_require__(815);
	__webpack_require__(816);
	__webpack_require__(817);
	__webpack_require__(818);
	__webpack_require__(819);
	__webpack_require__(820);
	__webpack_require__(821);
	__webpack_require__(822);
	__webpack_require__(823);
	__webpack_require__(824);
	__webpack_require__(825);
	__webpack_require__(826);
	__webpack_require__(827);
	__webpack_require__(828);
	__webpack_require__(829);
	__webpack_require__(830);
	__webpack_require__(831);
	__webpack_require__(832);
	__webpack_require__(833);
	__webpack_require__(834);
	__webpack_require__(835);
	__webpack_require__(836);
	__webpack_require__(837);
	__webpack_require__(838);
	__webpack_require__(839);
	__webpack_require__(840);
	__webpack_require__(841);
	__webpack_require__(856);
	__webpack_require__(854);
	__webpack_require__(855);
	__webpack_require__(859);
	__webpack_require__(857);
	__webpack_require__(858);
	__webpack_require__(862);
	__webpack_require__(863);
	__webpack_require__(860);
	__webpack_require__(861);
	__webpack_require__(867);
	__webpack_require__(864);
	__webpack_require__(865);
	__webpack_require__(866);
	__webpack_require__(870);
	__webpack_require__(868);
	__webpack_require__(869);
	__webpack_require__(871);
	__webpack_require__(874);
	__webpack_require__(872);
	__webpack_require__(873);
	__webpack_require__(875);
	__webpack_require__(876);
	__webpack_require__(877);
	__webpack_require__(878);
	__webpack_require__(879);
	__webpack_require__(880);
	__webpack_require__(881);
	__webpack_require__(842);
	__webpack_require__(843);
	__webpack_require__(844);
	__webpack_require__(845);
	__webpack_require__(846);
	__webpack_require__(847);
	__webpack_require__(848);
	__webpack_require__(849);
	__webpack_require__(850);
	__webpack_require__(851);
	__webpack_require__(852);
	__webpack_require__(853);
	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(884);
	__webpack_require__(885);
	__webpack_require__(886);
	__webpack_require__(887);
	__webpack_require__(888);
	__webpack_require__(889);
	__webpack_require__(890);
	__webpack_require__(891);
	__webpack_require__(892);
	__webpack_require__(893);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(896);
	__webpack_require__(897);
	__webpack_require__(898);
	__webpack_require__(901);
	__webpack_require__(899);
	__webpack_require__(900);
	__webpack_require__(902);
	__webpack_require__(903);
	__webpack_require__(904);
	__webpack_require__(905);
	__webpack_require__(906);
	__webpack_require__(907);
	__webpack_require__(908);
	__webpack_require__(909);
	__webpack_require__(910);
	__webpack_require__(911);
	__webpack_require__(912);
	__webpack_require__(913);
	__webpack_require__(915);
	__webpack_require__(916);
	__webpack_require__(917);
	__webpack_require__(918);
	__webpack_require__(914);
	__webpack_require__(919);
	__webpack_require__(920);
	__webpack_require__(921);
	__webpack_require__(922);
	__webpack_require__(923);
	__webpack_require__(924);
	__webpack_require__(925);
	__webpack_require__(926);
	__webpack_require__(927);
	__webpack_require__(928);
	__webpack_require__(929);
	__webpack_require__(930);
	__webpack_require__(931);
	__webpack_require__(932);
	__webpack_require__(933);
	__webpack_require__(934);
	__webpack_require__(935);
	__webpack_require__(936);
	__webpack_require__(937);
	__webpack_require__(938);
	__webpack_require__(940);
	__webpack_require__(939);
	__webpack_require__(941);
	__webpack_require__(943);
	__webpack_require__(944);
	__webpack_require__(942);
	__webpack_require__(945);
	__webpack_require__(946);
	__webpack_require__(948);
	__webpack_require__(949);
	__webpack_require__(950);
	__webpack_require__(951);
	__webpack_require__(947);
	__webpack_require__(952);
	__webpack_require__(953);
	__webpack_require__(954);
	__webpack_require__(956);
	__webpack_require__(955);
	__webpack_require__(957);
	__webpack_require__(958);
	__webpack_require__(959);
	__webpack_require__(960);
	__webpack_require__(961);
	__webpack_require__(962);
	__webpack_require__(963);
	__webpack_require__(964);
	__webpack_require__(965);
	__webpack_require__(966);
	__webpack_require__(967);
	__webpack_require__(968);
	__webpack_require__(969);
	__webpack_require__(970);
	__webpack_require__(971);
	__webpack_require__(972);
	__webpack_require__(973);
	__webpack_require__(974);
	__webpack_require__(975);
	__webpack_require__(976);
	__webpack_require__(977);
	__webpack_require__(979);
	__webpack_require__(978);
	__webpack_require__(980);
	__webpack_require__(981);
	__webpack_require__(982);
	__webpack_require__(984);
	__webpack_require__(983);
	__webpack_require__(985);
	__webpack_require__(986);
	__webpack_require__(987);
	__webpack_require__(988);
	__webpack_require__(989);
	__webpack_require__(990);
	__webpack_require__(991);
	__webpack_require__(992);
	__webpack_require__(993);
	__webpack_require__(994);
	__webpack_require__(995);
	__webpack_require__(996);
	__webpack_require__(997);
	__webpack_require__(998);
	__webpack_require__(999);
	__webpack_require__(1000);
	__webpack_require__(1001);
	__webpack_require__(1002);
	__webpack_require__(1004);
	__webpack_require__(1003);
	__webpack_require__(1005);
	__webpack_require__(1006);
	__webpack_require__(1007);
	__webpack_require__(1008);
	__webpack_require__(1009);
	__webpack_require__(1010);
	__webpack_require__(1011);
	__webpack_require__(1012);
	__webpack_require__(1013);
	__webpack_require__(1014);
	__webpack_require__(1015);
	__webpack_require__(1016);
	__webpack_require__(1017);
	__webpack_require__(1018);
	__webpack_require__(1019);
	__webpack_require__(1020);
	__webpack_require__(1021);
	__webpack_require__(1022);
	__webpack_require__(1023);
	__webpack_require__(1024);
	__webpack_require__(1025);
	__webpack_require__(1026);
	module.exports = __webpack_require__(1027);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = angular.module('octopusApp.projects');
	
	var StepTemplateLogo = _react2.default.createClass({
	    displayName: 'StepTemplateLogo',
	
	    propTypes: {
	        url: _react2.default.PropTypes.string.isRequired,
	        resolveLink: _react2.default.PropTypes.func,
	        size: _react2.default.PropTypes.string.isRequired,
	        class: _react2.default.PropTypes.string,
	        enableCacheBreaker: _react2.default.PropTypes.bool
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            enableCacheBreaker: true
	        };
	    },
	
	    // You might be wondering why we need to have this ugly hack here. TL;DR; eTags don't work reliably in all browsers.
	    // Full story is here: https://trello.com/c/UDY5VW7x/343-perf-enable-client-side-browser-caching-of-project-and-tenant-logos
	    applyCacheBreaker: function applyCacheBreaker(url) {
	        var cacheBreaker = Math.round(new Date().getTime() / 1000);
	        return url + '?cb=' + cacheBreaker;
	    },
	    sizeToStyles: function sizeToStyles(size) {
	        switch (size) {
	            case "xx-small":
	                return { width: "24px", height: "24px", borderRadius: "1px" };
	            case "x-small":
	                return { width: "40px", height: "40px", borderRadius: "2px" };
	            case "small":
	                return { width: "50px", height: "50px", borderRadius: "2px" };
	            case "medium":
	                return { width: "70px", height: "70px", borderRadius: "2px" };
	            case "large":
	                return { width: "100px", height: "100px", borderRadius: "4px" };
	            default:
	                throw size + " is an unknown size";
	        }
	    },
	
	    render: function render() {
	        var resolveLink = this.props.resolveLink || function (url) {
	            return url;
	        };
	        var url = resolveLink(this.props.url);
	        url = this.props.enableCacheBreaker ? this.applyCacheBreaker(url) : url;
	
	        var styles = this.sizeToStyles(this.props.size);
	        return _react2.default.createElement('img', { className: this.props.class + " step-template-logo", style: styles, src: url });
	    }
	});
	
	_module.directive('stepTemplateLogo', function (reactDirective, octopusClient) {
	    return reactDirective(StepTemplateLogo);
	});
	
	exports.default = StepTemplateLogo;

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "octopus.9edfb27b59f3259a3ec6501e41aa6748.hashedasset.svg";

/***/ },
/* 112 */,
/* 113 */,
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Server-CalamariNeedsUpgrade.Ssh.png": 1232,
		"./Server-CalamariNeedsUpgrade.TentacleActive.png": 1233,
		"./Server-CalamariNeedsUpgrade.TentaclePassive.png": 1234,
		"./Server-Disabled.AzureCloudService.png": 1235,
		"./Server-Disabled.AzureWebApp.png": 1236,
		"./Server-Disabled.Ftp.png": 1237,
		"./Server-Disabled.None.png": 1238,
		"./Server-Disabled.OfflineDrop.png": 1239,
		"./Server-Disabled.Ssh.png": 1240,
		"./Server-Disabled.TentacleActive.png": 1241,
		"./Server-Disabled.TentaclePassive.png": 1242,
		"./Server-HasWarnings.Ssh.png": 1243,
		"./Server-HasWarnings.TentacleActive.png": 1244,
		"./Server-HasWarnings.TentaclePassive.png": 1245,
		"./Server-Healthy.AzureCloudService.png": 1246,
		"./Server-Healthy.AzureWebApp.png": 1247,
		"./Server-Healthy.Ftp.png": 1248,
		"./Server-Healthy.None.png": 1249,
		"./Server-Healthy.OfflineDrop.png": 1250,
		"./Server-Healthy.Ssh.png": 1251,
		"./Server-Healthy.TentacleActive.png": 1252,
		"./Server-Healthy.TentaclePassive.png": 1253,
		"./Server-NeedsUpgrade.TentacleActive.png": 1254,
		"./Server-NeedsUpgrade.TentaclePassive.png": 1255,
		"./Server-Unavailable.AzureCloudService.png": 1256,
		"./Server-Unavailable.AzureWebApp.png": 1257,
		"./Server-Unavailable.Ftp.png": 1258,
		"./Server-Unavailable.OfflineDrop.png": 1259,
		"./Server-Unavailable.Ssh.png": 1260,
		"./Server-Unavailable.TentacleActive.png": 1261,
		"./Server-Unavailable.TentaclePassive.png": 1262,
		"./Server-Unhealthy.Ssh.png": 1263,
		"./Server-Unhealthy.TentacleActive.png": 1264,
		"./Server-Unhealthy.TentaclePassive.png": 1265,
		"./Server-Unknown.AzureCloudService.png": 1266,
		"./Server-Unknown.AzureWebApp.png": 1267,
		"./Server-Unknown.Ftp.png": 1268,
		"./Server-Unknown.OfflineDrop.png": 1269,
		"./Server-Unknown.Ssh.png": 1270,
		"./Server-Unknown.TentacleActive.png": 1271,
		"./Server-Unknown.TentaclePassive.png": 1272
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 114;


/***/ },
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.accounts', []);
	
	module.config(function($stateProvider) {
	    $stateProvider.state('app.accounts', {
	        url: '/accounts',
	        template: '<ui-view></ui-view>',
	        layout: {
	            tab: 'environments'
	        },
	        defaultSubRoute: "app.accounts.list"
	    });
	
	    $stateProvider.state("app.accounts.list", {
	        url: '',
	        templateUrl: 'areas/accounts/views/index.html',
	        controller: 'AccountsIndexController',
	        layout: {
	            title: 'Accounts',
	        }
	    });
	
	    $stateProvider.state("app.accounts.new", {
	        url: '/new',
	        templateUrl: 'areas/accounts/views/edit.html',
	        controller: 'AccountEditController',
	        controllerAs: 'vm',
	        layout: {
	            title: 'New Account'
	        }
	    });
	
	    $stateProvider.state("app.accounts.edit", {
	        url: '/:accountId',
	        templateUrl: 'areas/accounts/views/edit.html',
	        controller: 'AccountEditController',
	        controllerAs: 'vm',
	        layout: {
	            title: 'Edit Account'
	        }
	    });
	});

/***/ },
/* 129 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration', []);
	
	module.config(function($stateProvider, stateHelperProvider) {
	    $stateProvider.state("app.configuration", {
	        url: '/configuration',
	        templateUrl: 'areas/configuration/views/configuration_layout.html',
	        layout: {
	            tab: 'configuration'
	        },
	        defaultSubRoute: 'app.configuration.overview'
	    });
	
	    $stateProvider.state("app.configuration.overview", {
	        url: '',
	        layout: {
	            title: 'Configuration',
	            configTab: "overview"
	        },
	        templateUrl: 'areas/configuration/overview/index.html',
	        controller: 'ConfigurationIndexController'
	    });
	
	
	    { //Audit & Subscriptions
	        $stateProvider.state('app.configuration.audit', {
	            url: '/audit',
	            template: stateHelperProvider.withBreadcrumb('Audit', '#/configuration/audit'),
	            layout: {
	                configTab: 'audit'
	            },
	            defaultSubRoute: 'app.configuration.audit.list'
	        });
	
	        $stateProvider.state('app.configuration.audit.list', {
	            url: '',
	            templateUrl: 'areas/configuration/audit/views/index.html',
	            controller: 'AuditIndexController',
	            controllerAs: 'vm',
	            layout: {
	                title: 'Audit'
	            }
	        });
	
	        $stateProvider.state('app.configuration.audit.subscriptions', {
	            url: '/subscriptions',
	            template: stateHelperProvider.withBreadcrumb('Subscriptions', '#/configuration/audit/subscriptions'),
	            defaultSubRoute: 'app.configuration.audit.subscriptions.list'
	        });
	
	        $stateProvider.state('app.configuration.audit.subscriptions.list', {
	            url: '',
	            templateUrl: 'areas/configuration/audit/subscriptions/views/index.html',
	            controller: 'SubscriptionsController',
	            layout: {
	                title: 'Subscriptions'
	            }
	        });
	
	        $stateProvider.state('app.configuration.audit.subscriptions.new', {
	            url: '/new',
	            templateUrl: 'areas/configuration/audit/subscriptions/views/create.html',
	            controller: 'SubscriptionEditController',
	            controllerAs: 'vm',
	            bindToController: true,
	            layout: {
	                title: 'New Subscription'
	            }
	        });
	
	        $stateProvider.state('app.configuration.audit.subscriptions.edit', {
	            url: '/:subscriptionId',
	            templateUrl: 'areas/configuration/audit/subscriptions/views/edit.html',
	            controller: 'SubscriptionEditController',
	            controllerAs: 'vm',
	            bindToController: true,
	            layout: {
	                title: 'Edit Subscription'
	            }
	        });
	    }
	
	    $stateProvider.state('app.configuration.backup', {
	        url: '/backup',
	        templateUrl: 'areas/configuration/backup/views/edit.html',
	        controller: 'BackupEditController',
	        layout: {
	            title: 'Backup',
	            configTab: 'backup'
	        }
	    });
	
	    $stateProvider.state('app.configuration.certificates', {
	        url: '/certificates',
	        templateUrl: 'areas/configuration/certificates/views/index.html',
	        controller: 'CertificatesIndexController',
	        layout: {
	            title: 'Certificates',
	            configTab: 'certificates'
	        }
	    });
	
	    //Diagnostics
	    {
	        $stateProvider.state('app.configuration.diagnostics', {
	            url: '/diagnostics',
	            templateUrl: 'areas/configuration/diagnostics/views/layout.html',
	            layout: {
	                configTab: 'diagnostics'
	            },
	            defaultSubRoute: 'app.configuration.diagnostics.serverlogs'
	        });
	
	        $stateProvider.state('app.configuration.diagnostics.serverlogs', {
	            url: '',
	            templateUrl: 'areas/configuration/diagnostics/views/server_logs.html',
	            controller: 'DiagnosticsIndexController',
	            controllerAs: 'vm',
	            layout: {
	                title: 'Diagnostics - Server Logs',
	                diagnosticTab: 'serverLogs'
	            }
	        });
	
	
	        $stateProvider.state('app.configuration.diagnostics.detailedserverlogs', {
	            url: '/logs',
	            views: {
	                "@app.configuration": {
	                    templateUrl: 'areas/configuration/diagnostics/views/logs.html',
	                    controller: 'DiagnosticsLogsController'
	                }
	            },
	            layout: {
	                title: 'Diagnostice - Auto Deploy Logs'
	            }
	        });
	
	        $stateProvider.state('app.configuration.diagnostics.environmentcleanup', {
	            url: '/environment_cleanup',
	            templateUrl: 'areas/configuration/diagnostics/views/scheduled_task.html',
	            controller: 'DiagnosticsScheduledTaskController',
	            layout: {
	                title: 'Diagnostice - Environment Cleanup',
	                diagnosticTab: 'environmentCleanupLogs'
	            },
	            data: {
	                scheduledTaskName: 'CleanUnavailableMachines'
	            }
	        });
	
	        $stateProvider.state('app.configuration.diagnostics.autodeploy', {
	            url: '/auto_deployment_activity',
	            templateUrl: 'areas/configuration/diagnostics/views/scheduled_task.html',
	            controller: 'DiagnosticsScheduledTaskController',
	            layout: {
	                title: 'Diagnostice - Auto Deployment',
	                diagnosticTab: 'autoDeploymentLogs'
	            },
	            data: {
	                scheduledTaskName: 'ProcessAutoDeployments'
	            }
	        });
	
	        $stateProvider.state('app.configuration.diagnostics.subscript', {
	            url: '/subscription_activity',
	            templateUrl: 'areas/configuration/diagnostics/views/scheduled_task.html',
	            controller: 'DiagnosticsScheduledTaskController',
	            layout: {
	                title: 'Diagnostice - Subscription Activity',
	                diagnosticTab: 'subscriptionLogs'
	            },
	            data: {
	                scheduledTaskName: 'ProcessSubscriptions'
	            }
	        });
	    }
	
	    $stateProvider.state('app.configuration.features', {
	        url: '/features',
	        templateUrl: 'areas/configuration/features/views/edit.html',
	        controller: 'FeaturesEditController',
	        layout: {
	            title: 'Features',
	            configTab: 'features'
	        }
	    });
	
	    $stateProvider.state('app.configuration.license', {
	        url: '/license',
	        templateUrl: 'areas/configuration/license/views/index.html',
	        controller: 'LicenseIndexController',
	        layout: {
	            title: 'License',
	            configTab: 'license'
	        }
	    });
	
	    $stateProvider.state('app.configuration.maintenance', {
	        url: '/maintenance',
	        templateUrl: 'areas/configuration/maintenance/views/edit.html',
	        controller: 'MaintenanceEditController',
	        layout: {
	            title: 'Maintenance',
	            configTab: 'maintenance'
	        }
	    });
	
	    $stateProvider.state('app.configuration.nodes', {
	        url: '/nodes',
	        templateUrl: 'areas/configuration/nodes/views/index.html',
	        controller: 'NodesIndexController',
	        layout: {
	            title: 'Nodes',
	            configTab: 'nodes'
	        }
	    });
	
	    $stateProvider.state('app.configuration.nodeconfig', {
	        url: '/nodes/config',
	        templateUrl: 'areas/configuration/nodes/config/views/edit.html',
	        controller: 'ServerEditController',
	        layout: {
	            title: 'Nodes',
	            configTab: 'nodes'
	        }
	    });
	
	    $stateProvider.state('app.configuration.smtp', {
	        url: '/smtp',
	        templateUrl: 'areas/configuration/smtp/views/edit.html',
	        controller: 'SmtpEditController',
	        layout: {
	            title: 'SMTP Configuration',
	            configTab: 'smtp'
	        }
	    });
	
	    // Teams
	    {
	        $stateProvider.state('app.configuration.teams', {
	            url: '/teams',
	            template: stateHelperProvider.withBreadcrumb('Teams', '#/configuration/teams'),
	            layout: {
	                title: 'Teams',
	                configTab: 'teams'
	            },
	            defaultSubRoute: 'app.configuration.teams.list'
	        });
	
	        $stateProvider.state('app.configuration.teams.list', {
	            url: '',
	            templateUrl: 'areas/configuration/teams/views/index.html',
	            controller: 'TeamIndexController'
	        });
	
	        $stateProvider.state('app.configuration.teams.new', {
	            url: '/new',
	            templateUrl: 'areas/configuration/teams/views/edit.html',
	            controller: 'TeamEditController',
	            layout: {
	                title: 'New Team'
	            }
	        });
	
	        $stateProvider.state('app.configuration.teams.test', {
	            url: '/test',
	            templateUrl: 'areas/configuration/teams/views/test.html',
	            controller: 'TeamTestController',
	            layout: {
	                title: 'Test Permissions'
	            }
	        });
	
	        $stateProvider.state('app.configuration.teams.edit', {
	            url: '/:id',
	            templateUrl: 'areas/configuration/teams/views/edit.html',
	            controller: 'TeamEditController',
	            layout: {
	                title: 'Edit Team'
	            }
	        });
	    }
	
	
	    // Roles
	    {
	        $stateProvider.state('app.configuration.teams.roles', {
	            url: '^/configuration/roles',
	            template: stateHelperProvider.withBreadcrumb('User Roles', '#/configuration/roles'),
	            layout: {
	                title: 'User Roles'
	            },
	            defaultSubRoute: 'app.configuration.teams.roles.list'
	        });
	
	        $stateProvider.state('app.configuration.teams.roles.list', {
	            url: '',
	            templateUrl: 'areas/configuration/roles/views/index.html',
	            controller: 'UserRoleIndexController'
	        });
	
	        $stateProvider.state('app.configuration.teams.roles.create', {
	            url: '/new',
	            templateUrl: 'areas/configuration/roles/views/edit.html',
	            controller: 'UserRoleEditController',
	            layout: {
	                title: 'New User Role'
	            }
	        });
	
	        $stateProvider.state('app.configuration.teams.roles.edit', {
	            url: '/:id',
	            templateUrl: 'areas/configuration/roles/views/edit.html',
	            controller: 'UserRoleEditController',
	            layout: {
	                title: 'Edit User Role'
	            }
	        });
	    }
	
	    // Users
	    {
	        $stateProvider.state('app.configuration.users', {
	            url: '^/configuration/users',
	            template: stateHelperProvider.withBreadcrumb('Users', '#/configuration/users'),
	            layout: {
	                title: 'Users',
	                configTab: 'users'
	            },
	            defaultSubRoute: 'app.configuration.users.list'
	        });
	
	        $stateProvider.state('app.configuration.users.list', {
	            url: '',
	            templateUrl: 'areas/configuration/users/views/index.html',
	            controller: 'UsersIndexController'
	        });
	
	        $stateProvider.state('app.configuration.users.new', {
	            url: '/new',
	            templateUrl: 'areas/configuration/users/views/create.html',
	            controller: 'UserEditController',
	            layout: {
	                title: 'Create User'
	            }
	        });
	
	        $stateProvider.state('app.configuration.users.invite', {
	            url: '/invite',
	            templateUrl: 'areas/configuration/users/views/invite.html',
	            controller: 'UsersInviteController',
	            layout: {
	                title: 'Invite User'
	            }
	        });
	
	        $stateProvider.state('app.configuration.users.edit', {
	            url: '/:id',
	            templateUrl: 'areas/configuration/users/views/edit.html',
	            controller: 'UserEditController',
	            layout: {
	                title: 'Edit User'
	            }
	        });
	    }
	});

/***/ },
/* 130 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.dashboard', []);
	
	module.config(function($stateProvider, $urlRouterProvider) {
	
	    $stateProvider.state('app.dashboard',  {
	        url: '/',
	        templateUrl: 'areas/dashboard/views/dashboard.html',
	        controller: 'DashboardController',
	        layout: {
	            title: 'Dashboard',
	            tab: 'dashboard'
	        }
	    });
	
	    $urlRouterProvider.when('', function ($state) {
	        $state.go('app.dashboard');
	    });
	
	
	    $stateProvider.state('app.dashboard-configure',  {
	        url: '^/dashboard/configure',
	        templateUrl: 'areas/dashboard/views/dashboard_configure.html',
	        controller: 'DashboardConfigureController',
	        layout: {
	            title: 'Dashboard Configuration',
	            tab: 'dashboard'
	        }
	    });
	});


/***/ },
/* 131 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments', []);
	
	module.config(function($stateProvider, stateHelperProvider, machineStateProvider) {
	
	    $stateProvider.state('app.environments', {
	        url: '/environments',
	        template: stateHelperProvider.withBreadcrumb('Environments', '#/environments'),
	        layout: {
	            tab: 'environments',
	            title: 'Environments'
	        },
	        defaultSubRoute: "app.environments.list"
	    });
	
	    $stateProvider.state("app.environments.list", {
	        url: '',
	        templateUrl: 'areas/environments/views/index.html',
	        controller: 'EnvironmentIndexController'
	    });
	
	    $stateProvider.state("app.environments.new", {
	        url: '/new',
	        templateUrl: 'areas/environments/views/edit.html',
	        controller: 'EnvironmentEditController',
	        layout: {
	            title: 'New Environments'
	        }
	    });
	
	
	    {  //Machine Policies
	        $stateProvider.state('app.environments.machinepolicies', {
	            url: '/machinepolicies',
	            template: stateHelperProvider.withBreadcrumb('Machine policies', '#/environments/machinepolicies'),
	            layout: {
	                title: 'Machine Policies'
	            },
	            defaultSubRoute: "app.environments.machinepolicies.list"
	        });
	
	        $stateProvider.state("app.environments.machinepolicies.list", {
	            url: '',
	            templateUrl: 'areas/environments/machinepolicies/views/index.html',
	            controller: 'MachinePolicyIndexController',
	            layout: {
	                title: 'Machine Policies'
	            }
	        });
	
	        $stateProvider.state("app.environments.machinepolicies.new", {
	            url: '/new',
	            templateUrl: 'areas/environments/machinepolicies/views/create.html',
	            controller: 'MachinePolicyEditController',
	            layout: {
	                title: 'New Machine Policy'
	            }
	        });
	
	        $stateProvider.state("app.environments.machinepolicies.edit", {
	            url: '/:id',
	            templateUrl: 'areas/environments/machinepolicies/views/edit.html',
	            controller: 'MachinePolicyEditController',
	            layout: {
	                title: 'Edit Machine Policy'
	            }
	        });
	    }
	
	    { // Proxies
	        $stateProvider.state('app.environments.proxies', {
	            url: '/proxies',
	            template: stateHelperProvider.withBreadcrumb('Proxies', '#/environments/proxies'),
	            layout: {
	                title: 'Proxies',
	            },
	            defaultSubRoute: "app.environments.proxies.list"
	        });
	
	        $stateProvider.state("app.environments.proxies.list", {
	            url: '',
	            templateUrl: 'areas/environments/proxies/views/index.html',
	            controller: 'ProxyIndexController',
	            layout: {
	                title: 'Proxies'
	            }
	        });
	        $stateProvider.state("app.environments.proxies.new", {
	            url: '/new',
	            templateUrl: 'areas/environments/proxies/views/edit.html',
	            controller: 'ProxyEditController',
	            layout: {
	                title: 'New Proxy'
	            }
	        });
	
	        $stateProvider.state("app.environments.proxies.edit", {
	            url: '/:id',
	            templateUrl: 'areas/environments/proxies/views/edit.html',
	            controller: 'ProxyEditController',
	            layout: {
	                title: 'Edit Proxy'
	            }
	        });
	    }
	
	    { //machines
	        $stateProvider.state("app.environments.machines", {
	            url: '^/machines',
	            template: stateHelperProvider.withBreadcrumb('Deployment Targets'),
	            abstract: true
	        });
	
	        $stateProvider.state("app.environments.machines.new", {
	            url: '/new',
	            templateUrl: 'areas/environments/machines/discover.html',
	            controller: 'MachineDiscoverController',
	            layout: {
	                title: 'New Deployment Target'
	            }
	        });
	
	        $stateProvider.state("app.environments.machines.manual", {
	            url: '/new/manual',
	            templateUrl: 'areas/environments/machines/edit_machine.html',
	            controller: 'MachineEditController',
	            resolve: {
	                machineState: function () { // needed because we share controller with the real edit
	                    return null;
	                }
	            }
	
	        });
	
	        $stateProvider.state("app.environments.machines.edit", {
	            url: '/:machineId',
	            templateUrl: 'areas/environments/machines/machine_layout.html',
	            controller: 'MachineLayoutController',
	            resolve: {
	                machineState: machineStateProvider.$get
	            },
	            defaultSubRoute: 'app.environments.machines.edit.details'
	        });
	
	        $stateProvider.state("app.environments.machines.edit.details", {
	            url: '',
	            templateUrl: 'areas/environments/machines/edit_machine.html',
	            controller: 'MachineEditController',
	            layout: {
	                title: 'Edit Deployment Target',
	                machineTab: 'settings'
	            }
	        });
	
	
	        $stateProvider.state("app.environments.machines.edit.connectivity", {
	            url: '/connection',
	            templateUrl: 'areas/environments/machines/machine_connection.html',
	            controller: 'MachineConnectionController',
	            layout: {
	                title: 'Deployment Target Connectivity',
	                machineTab: 'connection'
	            }
	        });
	
	        $stateProvider.state("app.environments.machines.edit.deployments", {
	            url: '/deployments',
	            templateUrl: 'areas/environments/machines/machine_deployments.html',
	            controller: 'MachineDeploymentsController',
	            layout: {
	                title: 'Deployment History',
	                machineTab: 'deployments'
	            }
	        });
	
	        $stateProvider.state("app.environments.machines.edit.events", {
	            url: '/events',
	            templateUrl: 'areas/environments/machines/machine_events.html',
	            controller: 'MachineEventsController',
	            layout: {
	                title: 'Event History',
	                machineTab: 'events'
	            }
	        });
	    }
	
	    $stateProvider.state("app.environments.edit", {
	        url: '/:id',
	        templateUrl: 'areas/environments/views/edit.html',
	        controller: 'EnvironmentEditController',
	        layout: {
	            title: 'Edit Environment'
	        }
	    });
	
	
	});

/***/ },
/* 132 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library', []);
	
	
	module.config(function($stateProvider, $urlRouterProvider) {
	
	    $stateProvider.state("app.library", {
	        url: '/library',
	        templateUrl: 'areas/library/views/library_layout.html',
	        layout: {
	            tab: 'library'
	        },
	        defaultSubRoute: 'app.library.packages'
	    });
	
	    $stateProvider.state("app.library.packages", {
	        url: '/packages',
	        layout: {
	            title: 'Packages',
	            libraryTab: "packages"
	        },
	        templateUrl: 'areas/library/packages/views/index.html',
	        controller: 'PackagesIndexController'
	    });
	
	    $stateProvider.state("app.library.lifecycles", {
	        url: '/lifecycles',
	        templateUrl: 'areas/library/lifecycles/views/index.html',
	        controller: 'LifecycleIndexController',
	        layout: {
	            title: 'Lifecycles',
	            libraryTab: "lifecycles"
	        }
	    });
	
	    $stateProvider.state("app.library.lifecycles.new", {
	        url: '/new',
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/lifecycles/views/create.html',
	                controller: 'LifecycleEditController'
	            }
	        },
	        layout: {
	            title: 'New Lifecycle'
	        }
	    });
	
	    $stateProvider.state("app.library.lifecycles.edit", {
	        url: '/:id',
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/lifecycles/views/edit.html',
	                controller: 'LifecycleEditController'
	            }
	        },
	        layout: {
	            title: 'Edit Lifecycle'
	        }
	    });
	
	
	    $stateProvider.state("app.library.feeds", {
	        url: '/feeds',
	        layout: {
	            title: 'External feeds',
	            libraryTab: "feeds"
	        },
	        templateUrl: 'areas/library/feeds/views/index.html',
	        controller: 'FeedsIndexController'
	    });
	
	
	    $stateProvider.state("app.library.feeds.new", {
	        url: '/new',
	        layout: {
	            title: 'New Feed'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/feeds/views/create.html',
	                controller: 'FeedEditController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.feeds.edit", {
	        url: '/:id',
	        layout: {
	            title: 'Edit Feed'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/feeds/views/edit.html',
	                controller: 'FeedEditController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.feeds.edit.test", {
	        url: '/test',
	        layout: {
	            title: 'Test Feed'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/feeds/views/test.html',
	                controller: 'FeedTestController'
	            }
	        }
	    });
	
	
	    $stateProvider.state("app.library.packages.upload", {
	        url: '/upload',
	        layout: {
	            title: 'Test Feed'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/packages/views/upload.html',
	                controller: 'PackageUploadController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.packages.retention", {
	        url: '/retention',
	        layout: {
	            title: 'Retention'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/packages/views/retention.html',
	                controller: 'PackageRepositoryRetentionController'
	            }
	        }
	    });
	
	
	    $stateProvider.state("app.library.packages.versions", {
	        url: '/versions/:packageId',
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/packages/views/package_versions.html',
	                controller: 'PackageVersionsController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.packages.details", {
	        url: '/:packageId',
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/packages/views/package_details.html',
	                controller: 'PackageDetailsController'
	            }
	        }
	    });
	
	
	
	    $stateProvider.state("app.library.scripts", {
	        url: '/scripts',
	        layout: {
	            title: 'Script Modules',
	            libraryTab: "scripts"
	        },
	        templateUrl: 'areas/library/scripts/views/index.html',
	        controller: 'ScriptModulesIndexController'
	    });
	
	    $stateProvider.state("app.library.scripts.new", {
	        url: '/new',
	        layout: {
	            title: 'New Script Module'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/scripts/views/create.html',
	                controller: 'ScriptModuleEditController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.scripts.edit", {
	        url: '/:scriptModuleId',
	        layout: {
	            title: 'Edit Script Module'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/scripts/views/edit.html',
	                controller: 'ScriptModuleEditController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.steptemplates", {
	        url: '/steptemplates',
	        layout: {
	            title: 'Step Templates',
	            libraryTab: "steptemplates"
	        },
	        templateUrl: 'areas/library/steps/views/index.html',
	        controller: 'StepTemplatesIndexController'
	    });
	    $urlRouterProvider.when('/library/steps', '/library/steptemplates');
	
	
	    $stateProvider.state("app.library.steptemplates.new", {
	        url: '/new/:actionType',
	        layout: {
	            title: 'New Step Template'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/steps/views/edit.html',
	                controller: 'StepTemplateEditController'
	            }
	        }
	    });
	    $urlRouterProvider.when('/library/steps/new/:actionType', '/library/steptemplates/new/:actionType');
	
	
	
	    // StepTemplates - Community
	    $stateProvider.state("app.library.steptemplates.community", {
	        url: '/community',
	        layout: {
	            title: 'Community Step templates'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/steps/views/step_templates.html',
	                controller: 'LibraryStepTemplatesController'
	            }
	        }
	    });
	    $urlRouterProvider.when('/library/steps/community', '/library/steptemplates/community');
	
	
	
	    $stateProvider.state("app.library.steptemplates.community.details", {
	        url: '/:id/details',
	        layout: {
	            title: 'Step template details'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/steps/views/community_step_template_details.html',
	                controller: 'StepTemplateDetailsController'
	            }
	        }
	    });
	    $urlRouterProvider.when('/library/steps/community/:id/details', '/library/steptemplates/community/:id/details');
	
	
	    $stateProvider.state("app.library.steptemplates.builtin", {
	        url: '/builtin',
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/steps/views/step_templates.html',
	                controller: 'LibraryStepTemplatesController'
	            }
	        },
	        reloadOnSearch: true
	    });
	    $urlRouterProvider.when('/library/steps/builtin', '/library/steptemplates/builtin');
	
	    $stateProvider.state("app.library.steptemplates.edit", {
	        url: '/:id',
	        layout: {
	            title: 'Edit Step Template'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/steps/views/edit.html',
	                controller: 'StepTemplateEditController'
	            }
	        }
	    });
	    $urlRouterProvider.when('/library/steps/:id', '/library/steptemplates/:id');
	
	
	    $stateProvider.state("app.library.steptemplates.edit.logo", {
	        url: '/logo',
	        layout: {
	            title: 'Step Template Logo'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/steps/views/change_logo.html',
	                controller: 'ActionTemplateLogoController'
	            }
	        }
	    });
	    $urlRouterProvider.when('/library/steps/:id', '/library/steptemplates/:id');
	
	
	    $stateProvider.state("app.library.steptemplates.edit.run", {
	        url: '/run',
	        layout: {
	            title: 'Run Step Template'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/steps/views/run.html',
	                controller: 'StepTemplateRunController'
	            }
	        },
	        reloadOnSearch: false
	    });
	    $urlRouterProvider.when('/library/steps/:id/run', '/library/steptemplates/:id/run');
	
	    $stateProvider.state("app.library.tagsets", {
	        url: '/tagsets',
	        layout: {
	            title: 'Tag Sets',
	            libraryTab: "tagsets"
	        },
	        templateUrl: 'areas/library/tagsets/views/index.html',
	        controller: 'TagSetsIndexController'
	    });
	
	    $stateProvider.state("app.library.tagsets.new", {
	        url: '/new',
	        layout: {
	            title: 'New Tenant Tag Set'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/tagsets/views/create_tag_set.html',
	                controller: 'TagSetEditController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.tagsets.edit", {
	        url: '/:id',
	        layout: {
	            title: 'Edit Tenant Tag Set'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/tagsets/views/edit_tag_set.html',
	                controller: 'TagSetEditController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.variables", {
	        url: '/variables',
	        layout: {
	            title: 'Variables Sets',
	            libraryTab: "variables"
	        },
	        templateUrl: 'areas/library/variables/views/index.html',
	        controller: 'VariableSetsIndexController'
	    });
	
	    $stateProvider.state("app.library.variables.new", {
	        url: '/new',
	        layout: {
	            title: 'New Variable Set'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/variables/views/create_variable_set.html',
	                controller: 'VariableSetEditController'
	            }
	        }
	    });
	
	    $stateProvider.state("app.library.variables.edit", {
	        url: '/:id',
	        layout: {
	            title: 'Edit Variable Set'
	        },
	        views: {
	            "@app.library": {
	                templateUrl: 'areas/library/variables/views/edit_variable_set.html',
	                controller: 'VariableSetEditController'
	            }
	        }
	    });
	});

/***/ },
/* 133 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.management', []);
	
	module.config(function($stateProvider) {
	    $stateProvider.state("app.console", {
	        url: '/manage/console',
	        templateUrl: 'areas/management/views/console.html',
	        controller: 'ScriptConsoleController',
	        controllerAs: 'vm',
	        layout: {
	            title: 'Script Console',
	            tab: 'tasks'
	        }
	    });
	});

/***/ },
/* 134 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.master', []);


/***/ },
/* 135 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects', ['octopusApp.infrastructure', 'octopusApp.accounts']);
	
	module.config(function($stateProvider,$urlRouterProvider, stateHelperProvider, projectStateProvider) {
	    $stateProvider.state('app.projects', {
	        url: '/projects',
	        template: stateHelperProvider.withBreadcrumb('Projects', '#/projects'),
	        layout: {
	            tab: 'projects',
	            title: 'Projects'
	        },
	        defaultSubRoute: 'app.projects.list'
	    });
	
	    $stateProvider.state('app.projects.list', {
	        url: '',
	        templateUrl: 'areas/projects/views/index.html',
	        controller: 'ProjectIndexController'
	    });
	
	    $stateProvider.state('app.projects.new', {
	        url: '/new',
	        templateUrl: 'areas/projects/views/create.html',
	        controller: 'ProjectEditController',
	        layout: {
	            title: 'New Project'
	        }
	    });
	
	    $stateProvider.state('app.projects.newwithgroup', {
	        url: '/new/:grpid',
	        templateUrl: 'areas/projects/views/create.html',
	        controller: 'ProjectEditController',
	        layout: {
	            title: 'New Project'
	        }
	    });
	
	    $stateProvider.state('app.project', {
	        url: '/projects/:projectId',
	        templateUrl: 'areas/projects/views/project_layout.html',
	        controller: 'ProjectLayoutController',
	        resolve: {
	            projectState: projectStateProvider.$get
	        },
	        layout: {
	            title: 'View Project',
	            tab: 'projects'
	        },
	        abstract:true
	    });
	
	    $stateProvider.state('app.project.overview', {
	        url: '^/projects/:projectId?release&tenants&tags', //Using absolute due to issues with search params, we want this state to resolve instead of abstract above
	        templateUrl:  'areas/projects/views/overview.html',
	        controller: 'ProjectOverviewController',
	        controllerAs: 'vm',
	        layout: {
	            projectTab: 'overview'
	        }
	    });
	
	    $stateProvider.state('app.project.settings', {
	        url: '/settings',
	        templateUrl:  'areas/projects/views/edit.html',
	        controller: 'ProjectEditController',
	        layout: {
	            projectTab: 'settings'
	        }
	    });
	
	    $stateProvider.state('app.project.logo', {
	        url:  '/logo',
	        templateUrl:  'areas/projects/views/change_logo.html',
	        controller: 'ProjectLogoController',
	        layout: {
	            title: 'Project Logo',
	            projectTab: 'settings'
	        }
	    });
	
	    $stateProvider.state('app.project.process', {
	        url:  '/process',
	        templateUrl:  'areas/projects/views/process.html',
	        controller: 'ProjectProcessController',
	        layout: {
	            title: 'Project Process',
	            projectTab: 'process'
	        }
	    });
	
	    $stateProvider.state('app.project.steptemplates', {
	        url:  '/steptemplates',
	        templateUrl:  'areas/projects/step-templates/step_templates.html',
	        controller: 'StepTemplatesController',
	        layout: {
	            title: 'Step Templates',
	            projectTab: 'process'
	        }
	    });
	
	    $stateProvider.state('app.project.childsteptemplates', {
	        url:  '/childsteptemplates/:parentStepId',
	        templateUrl:  'areas/projects/step-templates/step_templates.html',
	        controller: 'StepTemplatesController',
	        layout: {
	            title: 'Step Templates',
	            projectTab: 'process'
	        }
	    });
	
	
	    //Below repetition is PITA atm because cant seem to easily get ui-router to support multiple urls for same state
	    $stateProvider.state('app.project.processnewactiontype-A', {
	        url:  '/process/step/:stepId/new/:actionType',
	        templateUrl:  'areas/projects/views/process_step_edit.html',
	        controller: 'ProjectProcessStepEditController',
	        layout: {
	            title: 'Project Process Step Editor',
	            projectTab: 'process'
	        }
	    });
	    $stateProvider.state('app.project.processnewactiontype-B', {
	        url:  '/process/step/:stepId/new/:actionType/:template',
	        templateUrl:  'areas/projects/views/process_step_edit.html',
	        controller: 'ProjectProcessStepEditController',
	        layout: {
	            title: 'Project Process Step Editor',
	            projectTab: 'process'
	        }
	    });
	
	    $stateProvider.state('app.project.processnewactiontype-C', {
	        url:  '/process/step/:stepId',
	        templateUrl:  'areas/projects/views/process_step_edit.html',
	        controller: 'ProjectProcessStepEditController',
	        layout: {
	            title: 'Project Process Step Editor',
	            projectTab: 'process'
	        }
	    });
	
	    $stateProvider.state('app.project.processnewactiontype-D', {
	        url:  '/process/step/new/:actionType',
	        templateUrl:  'areas/projects/views/process_step_edit.html',
	        controller: 'ProjectProcessStepEditController',
	        layout: {
	            title: 'Project Process Step Editor',
	            projectTab: 'process'
	        }
	    });
	    $stateProvider.state('app.project.processnewactiontype-E', {
	        url:  '/process/step/new/:actionType/:template',
	        templateUrl:  'areas/projects/views/process_step_edit.html',
	        controller: 'ProjectProcessStepEditController',
	        layout: {
	            title: 'Project Process Step Editor',
	            projectTab: 'process'
	        }
	    });
	
	    // Releases Start
	    $stateProvider.state('app.project.releases', {
	        url:  '/releases',
	        template: stateHelperProvider.withBreadcrumb('Releases', '#/projects/{{ project.Slug }}/releases'),
	        layout: {
	            projectTab: 'releases'
	        },
	        defaultSubRoute: 'app.project.releases.list'
	    });
	
	
	    $stateProvider.state('app.project.releases.list', {
	        url:  '/list',
	        templateUrl:  'areas/projects/views/releases.html',
	        controller: 'ProjectReleasesController',
	        layout: {
	            title: 'Project Releases'
	        }
	    });
	
	    $stateProvider.state('app.project.releases.create', {
	        url:  '/create',
	        templateUrl:  'areas/projects/views/release_create.html',
	        controller: 'ProjectReleaseEditController',
	        layout: {
	            title: 'Create release'
	        }
	    });
	
	    $stateProvider.state('app.project.releases.release', {
	        url:  '/:version',
	        template: '<ui-view></ui-view>',
	        layout: {
	            title: 'Release Details'
	        },
	        defaultSubRoute: 'app.project.releases.release.details'
	    });
	
	    $stateProvider.state('app.project.releases.release.details', {
	        url:  '',
	        templateUrl:  'areas/projects/views/release.html',
	        controller: 'ProjectReleaseController'
	    });
	
	    $stateProvider.state('app.project.releases.release.edit', {
	        url:  '/edit',
	        templateUrl:  'areas/projects/views/release_edit.html',
	        controller: 'ProjectReleaseEditController',
	        layout: {
	            title: 'Edit Details'
	        }
	    });
	
	    $stateProvider.state('app.release',
	        stateHelperProvider.redirectRoute('/releases/:releaseId', function($stateParams, octopusRepository){
	            return octopusRepository.Releases.get($stateParams.releaseId).then(function (release) {
	                return '/projects/' + release.ProjectId + '/releases/' + release.Version;
	            });
	        }));
	
	    $stateProvider.state('app.project.releases.release.deployment-create-A', {
	        url:  '/deployments/create',
	        templateUrl: 'areas/projects/views/deployment_create.html',
	        controller: 'ProjectDeploymentCreateController',
	        layout: {
	            title: 'Create deployment'
	        }
	    });
	
	    $stateProvider.state('app.project.releases.release.deployment-create-B', {
	        url:  '/deployments/create/:goal/:previousId',
	        templateUrl: 'areas/projects/views/deployment_create.html',
	        controller: 'ProjectDeploymentCreateController',
	        layout: {
	            title: 'Create deployment'
	        }
	    });
	
	    $stateProvider.state('app.project.releases.release.deployment-details', {
	        url:  '/deployments/:depid',
	        templateUrl: 'areas/tasks/views/task.html',
	        controller: 'TaskController',
	        layout: {
	            title: 'Deployment details'
	        },
	        resolve: {
	            'forceProjectLoad': function(projectState) {
	                if(!projectState.projectAsync) {
	                    projectState.load();
	                }
	            }
	        }
	    });
	
	    $stateProvider.state('app.deployments',
	        stateHelperProvider.redirectRoute('/deployments/:deploymentId', function($stateParams, octopusRepository){
	            return octopusRepository.Deployments.get($stateParams["deploymentId"]).then(function (deployment) {
	                return octopusRepository.Releases.get(deployment.ReleaseId).then(function (release) {
	                    return '/projects/' + release.ProjectId + '/releases/' + release.Version + '/deployments/' + deployment.Id;
	                });
	            });
	        }));
	
	    //Channels Start
	    $stateProvider.state('app.project.channels', {
	        url:  '/channels',
	        template: '<script octo-section="breadcrumbs" type="text/ng-template"><li><a href="#/projects/{{ project.Slug }}/channels">Channels</a></li></script><ui-view></ui-view>',
	        layout: {
	            projectTab: 'channels'
	        },
	        defaultSubRoute: 'app.project.channels.list'
	    });
	
	    $stateProvider.state('app.project.channels.list', {
	        url:  '/list',
	        templateUrl:  'areas/projects/channels/channels.html',
	        controller: 'ChannelsController',
	        layout: {
	            title: 'Project Channels'
	        }
	    });
	
	    $stateProvider.state('app.project.channels.create', {
	        url:  '/create',
	        templateUrl:  'areas/projects/channels/channel_create.html',
	        controller: 'ChannelEditController',
	        layout: {
	            title: 'Create Channel'
	        }
	    });
	
	    $stateProvider.state('app.project.channels.edit', {
	        url:  '/edit/:channelId',
	        templateUrl:  'areas/projects/channels/channel_edit.html',
	        controller: 'ChannelEditController',
	        layout: {
	            title: 'Create Channel'
	        }
	    });
	
	    $stateProvider.state('app.project.triggers', {
	        url:  '/triggers',
	        template: stateHelperProvider.withBreadcrumb('Triggers', '#/projects/{{ project.Slug }}/triggers'),
	        layout: {
	            projectTab: 'triggers'
	        },
	        defaultSubRoute: 'app.project.triggers.list'
	    });
	
	    $stateProvider.state('app.project.triggers.list', {
	        url:  '/list',
	        templateUrl:  'areas/projects/triggers/triggers.html',
	        controller: 'ProjectTriggersController',
	        layout: {
	            title: 'Project Triggers'
	        }
	    });
	
	    $stateProvider.state('app.project.triggers.create', {
	        url:  '/create',
	        templateUrl:  'areas/projects/triggers/trigger_create.html',
	        controller: 'ProjectTriggerEditController',
	        layout: {
	            title: 'Create Trigger'
	        }
	    });
	
	    $stateProvider.state('app.project.triggers.edit', {
	        url:  '/edit/:triggerId',
	        templateUrl:  'areas/projects/triggers/trigger_edit.html',
	        controller: 'ProjectTriggerEditController',
	        layout: {
	            title: 'Edit Trigger'
	        }
	    });
	
	    $stateProvider.state('app.project.triggers.autoDeployReleaseOverrides', {
	        url:  '/autoDeployReleaseOverrides',
	        templateUrl:  'areas/projects/triggers/override_auto_deploy_release.html',
	        controller: 'ProjectTriggerEditController',
	        layout: {
	            title: 'Edit Trigger'
	        }
	    });
	});
	
	module.run(function($rootScope, $state, $q, octopusRepository){
	
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	        if (toState.name === "app.tasks.details" && !$state.current.$transitioning) {
	            var taskId = toParams.taskId;
	            event.preventDefault();
	
	            octopusRepository.Tasks.get(taskId).then(function(task){
	                toParams.task = task;
	
	                if (task.Name !== 'Deploy' || !task.Arguments.DeploymentId) {
	                    $state.current.$transitioning = true;
	                    $state.go(toState.name, toParams);
	                    $state.current.$transitioning = false;
	                    return;
	                }
	
	                return octopusRepository.Deployments.get(task.Arguments.DeploymentId).then(function (deployment) {
	                    return $q.all([octopusRepository.Projects.get(deployment.ProjectId),
	                        octopusRepository.Releases.get(deployment.ReleaseId)])
	                        .then(function(results){
	                            var project = results[0];
	                            var release = results[1];
	                            $state.transitionTo('app.project.releases.release.deployment-details', {
	                                depid: deployment.Id,
	                                version: release.Version,
	                                projectId: project.Slug
	                            });
	                        });
	                });
	            });
	        }
	    });
	});

/***/ },
/* 136 */
/***/ function(module, exports) {

	angular.module('octopusApp.shared', []);

/***/ },
/* 137 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tasks', []);
	
	module.config(function($stateProvider) {
	    $stateProvider.state("app.tasks", {
	        url: '/tasks',
	        templateUrl: 'areas/tasks/views/index.html',
	        controller: 'TasksIndexController',
	        layout: {
	            title: 'Tasks',
	            tab: 'tasks'
	        }
	    });
	
	    $stateProvider.state("app.tasks.details", {
	        url: '/:taskId',
	        views: {
	            "@app": {
	                templateUrl: 'areas/tasks/views/task.html',
	                controller: 'TaskController'
	            }
	        },
	        params: {task: null}
	    });
	
	
	    $stateProvider.state("app.tasks.raw", {
	        url: '/:taskId/raw',
	        views: {
	            "@app": {
	                templateUrl: 'areas/tasks/views/task-raw.html',
	                controller: 'TaskRawController'
	            }
	        },
	        params: {task: null}
	    });
	});
	


/***/ },
/* 138 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tenants', []);
	
	module.config(function($stateProvider, stateHelperProvider, tenantStateProvider, tenantVariablesStateProvider) {
	    $stateProvider.state('app.tenants', {
	        url: '/tenants',
	        template: stateHelperProvider.withBreadcrumb('Tenants', '#/tenants'),
	        layout: {
	            tab: 'tenants'
	        },
	        defaultSubRoute: 'app.tenants.list'
	    });
	
	    $stateProvider.state('app.tenants.list', {
	        url: '',
	        templateUrl: 'areas/tenants/views/index.html',
	        controller: 'TenantIndexController',
	        controllerAs: 'vm',
	        bindToController: true
	    });
	
	    $stateProvider.state('app.tenants.new', {
	        url: '/new',
	        templateUrl: 'areas/tenants/views/create.html',
	        controller: 'TenantSettingsController',
	        controllerAs: 'vm',
	        bindToController: true,
	        layout: {
	            title: 'Create Tenant'
	        }
	    });
	
	    $stateProvider.state('app.tenants.edit', {
	        url: '/:tenantId',
	        templateUrl: 'areas/tenants/views/tenant_layout.html',
	        controller: 'TenantLayoutController',
	        controllerAs: 'vm',
	        bindToController: true,
	        resolve: {
	            tenantState: tenantStateProvider.$get
	        },
	        defaultSubRoute: 'app.tenants.edit.overview'
	    });
	
	    $stateProvider.state('app.tenants.edit.overview', {
	        url: '/overview',
	        templateUrl: 'areas/tenants/views/overview.html',
	        controller: 'TenantOverviewController',
	        controllerAs: 'vm',
	        bindToController: true,
	        layout: {
	            tenantTab: 'overview'
	        }
	    });
	
	    $stateProvider.state('app.tenants.edit.settings', {
	        url: '/settings',
	        templateUrl: 'areas/tenants/views/settings.html',
	        controller: 'TenantSettingsController',
	        controllerAs: 'vm',
	        bindToController: true,
	        layout: {
	            tenantTab: 'settings'
	        }
	    });
	
	    $stateProvider.state('app.tenants.edit.logo', {
	        url: '/logo',
	        templateUrl: 'areas/tenants/views/change_logo.html',
	        controller: 'TenantLogoController',
	        controllerAs: 'vm',
	        bindToController: true,
	        layout: {
	            title: 'Tenant Logo',
	            tenantTab: 'settings'
	        }
	    });
	
	    $stateProvider.state('app.tenants.edit.variables', {
	        url: '/variables',
	        templateUrl: 'areas/tenants/variables/tenant_variables_tab.html',
	        controller: 'TenantVariablesLayoutController',
	        controllerAs: 'vm',
	        bindToController: true,
	        resolve: {
	            tabState: tenantVariablesStateProvider.$get
	        },
	        layout: {
	            title: 'Tenant Variables',
	            tenantTab: 'variables'
	        },
	        defaultSubRoute: 'app.tenants.edit.variables.library'
	    });
	
	
	    $stateProvider.state('app.tenants.edit.variables.library', {
	        url: '/library',
	        templateUrl: 'areas/tenants/variables/tenant_variables_library.html',
	        controller: 'TenantVariablesLibraryController',
	        controllerAs: 'vm',
	        bindToController: true,
	        layout: {
	            variableTab: 'library'
	        }
	    });
	
	    $stateProvider.state('app.tenants.edit.variables.projects', {
	        url: '/projects',
	        templateUrl: 'areas/tenants/variables/tenant_variables_projects.html',
	        controller: 'TenantVariablesProjectsController',
	        controllerAs: 'vm',
	        bindToController: true,
	        layout: {
	            variableTab: 'projects'
	        }
	    });
	});

/***/ },
/* 139 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.users', []);
	
	module.config(function($stateProvider) {
	
	    $stateProvider.state("app.signin", {
	        url: '/users/sign-in',
	        templateUrl:  'areas/users/views/sign-in.html',
	        controller: 'SignInController',
	        layout: {
	            tab: 'user',
	            title: 'Sign in',
	            layout: "layout-blank"
	        }
	    });
	
	    $stateProvider.state("app.signout", {
	        url: '/users/sign-out',
	        templateUrl:  'areas/users/views/sign-out.html',
	        controller: 'SignOutController',
	        layout: {
	            tab: 'user',
	            title: 'Sign in',
	            layout: "layout-blank"
	        }
	    });
	
	    $stateProvider.state("app.profile", {
	        url: '/users/me',
	        templateUrl:  'areas/users/views/profile.html',
	        controller: 'ProfileController',
	        layout: {
	            tab: 'user',
	            title: 'My profile'
	        }
	    });
	
	    $stateProvider.state("app.register", {
	        url: '/users/register',
	        templateUrl:  'areas/users/views/register.html',
	        controller: 'RegisterController',
	        layout: {
	            title: 'Register a user account',
	            layout: 'layout-blank'
	        }
	    });
	
	    $stateProvider.state("app.register.invite", {
	        url: '/:invitation'
	    });
	});

/***/ },
/* 140 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure', []);
	
	module.config(function($stateProvider) {
	
	    $stateProvider.state('app.style-guide',{
	        url :'/style-guide',
	        templateUrl: 'infrastructure/style-guide/style_guide.html',
	        controller: 'StyleGuideController',
	        layout: {
	            title: 'Live Style Guide',
	            tab: null
	        }
	    });
	});


/***/ },
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "tenant-tag-sets.9d0c36838b894a69ca051229b5fdd530.hashedasset.png";

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "work_team.ecd57b41ebc1cdff9b9b3c0f5208c307.hashedasset.png";

/***/ },
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step_template_logo = __webpack_require__(56);
	
	var _step_template_logo2 = _interopRequireDefault(_step_template_logo);
	
	var _showdown = __webpack_require__(110);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	var _xss = __webpack_require__(296);
	
	var _xss2 = _interopRequireDefault(_xss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = angular.module('octopusApp.projects');
	
	
	var markdownConverter = new _showdown2.default.Converter({
	    simplifiedAutoLink: true,
	    literalMidWordUnderscores: true
	});
	
	function Info(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'alert alert-info margin', role: 'alert' },
	                props.children
	            )
	        )
	    );
	}
	
	function Warning(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'alert alert-warning margin', role: 'alert' },
	                props.children
	            )
	        )
	    );
	}
	
	TemplateSummary.propTypes = {
	    name: _react2.default.PropTypes.string.isRequired,
	    author: _react2.default.PropTypes.string.isRequired,
	    version: _react2.default.PropTypes.number.isRequired,
	    websiteUrl: _react2.default.PropTypes.string.isRequired,
	    onCancel: _react2.default.PropTypes.func.isRequired,
	    cancelButtonName: _react2.default.PropTypes.string,
	    onUpdate: _react2.default.PropTypes.func.isRequired,
	    updateButtonName: _react2.default.PropTypes.string,
	    onInstall: _react2.default.PropTypes.func.isRequired,
	    installButtonName: _react2.default.PropTypes.string,
	    isUpdateAvailable: _react2.default.PropTypes.bool.isRequired,
	    descriptionHtml: _react2.default.PropTypes.object.isRequired
	};
	
	function TemplateSummary(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'template-summary-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'margin-bottom-5' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    props.name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'template-external-resources' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Version ',
	                            props.version
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'divider' },
	                        '|'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'By ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://github.com/' + props.author, target: '_blank' },
	                            props.author
	                        ),
	                        ' ',
	                        _react2.default.createElement('i', { className: 'fa fa-users template-icon', 'aria-hidden': 'true' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'divider' },
	                        '|'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: props.websiteUrl, target: '_blank' },
	                            'View website'
	                        ),
	                        ' ',
	                        _react2.default.createElement('i', { className: 'fa fa-globe template-icon', 'aria-hidden': 'true' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'template-button-container' },
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'btn btn template-button', onClick: props.onCancel },
	                    props.cancelButtonName ? props.cancelButtonName : 'Cancel'
	                ),
	                !props.isUpdateAvailable ? _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'btn btn-success template-button', onClick: props.onInstall },
	                    props.installButtonName ? props.installButtonName : 'Install and add step'
	                ) : null,
	                props.isUpdateAvailable ? _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'btn btn-success template-button', onClick: props.onUpdate },
	                    props.updateButtonName ? props.updateButtonName : 'Update and add step'
	                ) : null
	            )
	        ),
	        _react2.default.createElement('hr', { className: 'no-margin-t' }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: props.descriptionHtml })
	    );
	};
	
	TemplateParameters.propTypes = {
	    templateParameters: _react2.default.PropTypes.array.isRequired
	};
	
	function TemplateParameters(props) {
	    return _react2.default.createElement(
	        'table',
	        { className: 'table table-bordered table-striped' },
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    'Name'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    'Description'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            props.templateParameters.map(function (param) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: param.Name },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        !param.Label ? param.Name : param.Label
	                    ),
	                    _react2.default.createElement('td', { dangerouslySetInnerHTML: param.HelpHtml })
	                );
	            })
	        )
	    );
	};
	
	var AceEditor = _react2.default.createClass({
	    displayName: 'AceEditor',
	
	    propTypes: {
	        mode: _react2.default.PropTypes.string,
	        code: _react2.default.PropTypes.string
	    },
	    getInitialState: function getInitialState() {
	        return {
	            mode: 'powershell',
	            code: ''
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.editor = ace.edit('sourceCodeEditor');
	        this.editor.$blockScrolling = Infinity;
	        this.editor.getSession().setMode("ace/mode/" + this.props.mode);
	        this.editor.setOptions({ readOnly: true });
	        this.editor.setOptions({ minLines: 25 });
	        this.editor.setOptions({ maxLines: 25 });
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.editor.setValue(nextProps.code, null);
	        this.editor.clearSelection();
	    },
	    render: function render() {
	        var style = { fontSize: '14px !important', border: '1px solid lightgray' };
	        return _react2.default.DOM.div({
	            id: 'sourceCodeEditor',
	            style: style
	        });
	    }
	});
	
	function TemplateHelperLinks() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'span',
	            { className: 'pull-right' },
	            'Provided under the ',
	            _react2.default.createElement(
	                'a',
	                { href: 'http://g.octopushq.com/CommunityLibraryLicense', target: '_blank' },
	                'Apache License version 2.0.'
	            )
	        )
	    );
	};
	
	var LibraryStepTemplateDetails = _react2.default.createClass({
	    displayName: 'LibraryStepTemplateDetails',
	
	    propTypes: {
	        template: _react2.default.PropTypes.object.isRequired,
	        onInstall: _react2.default.PropTypes.func.isRequired,
	        installButtonName: _react2.default.PropTypes.string,
	        onUpdate: _react2.default.PropTypes.func.isRequired,
	        updateButtonName: _react2.default.PropTypes.string,
	        onCancel: _react2.default.PropTypes.func.isRequired,
	        cancelButtonName: _react2.default.PropTypes.string,
	        currentVersion: _react2.default.PropTypes.number,
	        resolveLink: _react2.default.PropTypes.func.isRequired
	    },
	    getInitialState: function getInitialState() {
	        return { tab: 'Parameters' };
	    },
	    getSelectedTabCssClassName: function getSelectedTabCssClassName(tabName) {
	        return tabName === this.state.tab ? 'active' : '';
	    },
	    selectTab: function selectTab(e) {
	        this.setState({
	            tab: e.target.text
	        });
	    },
	    render: function render() {
	
	        var inputTabClasses = 'tab-pane ' + this.getSelectedTabCssClassName('Parameters');
	        var sourceCodeTabClasses = 'tab-pane ' + this.getSelectedTabCssClassName('Source code');
	
	        var templateDescriptionHtml = { __html: (0, _xss2.default)(markdownConverter.makeHtml(this.props.template.Description || '')) };
	
	        var templateParameters = [];
	        if (this.props.template.Parameters) {
	            templateParameters = this.props.template.Parameters.map(function (p) {
	                var param = p;
	                param.HelpHtml = { __html: (0, _xss2.default)(markdownConverter.makeHtml(p.HelpText || '')) };
	                return param;
	            });
	        }
	
	        var scriptSyntax = 'powershell';
	        var scriptSourceCode = 'Not available';
	        if (this.props.template.Properties) {
	            var tmpScriptSyntax = this.props.template.Properties['Octopus.Action.Script.Syntax'] || scriptSyntax;
	            scriptSyntax = tmpScriptSyntax.toLowerCase();
	            scriptSourceCode = this.props.template.Properties['Octopus.Action.Script.ScriptBody'] || scriptSourceCode;
	            if (this.props.template.Type !== 'Octopus.Script') {
	                scriptSourceCode = 'Source code is not available for this step template because it is not a script template.';
	            }
	        }
	
	        var isUpdateAvailable = this.props.currentVersion !== undefined && this.props.currentVersion < this.props.template.Version;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'step-templates-details' },
	            !isUpdateAvailable ? _react2.default.createElement(
	                Info,
	                null,
	                'This is a community contributed step that will be installed into your ',
	                _react2.default.createElement(
	                    'a',
	                    { className: 'alert-link', href: '#/library/steptemplates' },
	                    'Step templates'
	                ),
	                ' library. Read our ',
	                _react2.default.createElement(
	                    'a',
	                    { className: 'alert-link', href: 'http://g.octopushq.com/CommunityContributedStepTemplates', target: '_blank' },
	                    'community step documentation'
	                ),
	                ' for more information.'
	            ) : null,
	            isUpdateAvailable ? _react2.default.createElement(
	                Warning,
	                null,
	                'Update available. Please review ',
	                _react2.default.createElement(
	                    'a',
	                    { className: 'alert-link', href: this.props.template.HistoryUrl, target: '_blank' },
	                    'the history of this template'
	                ),
	                ' to find out what\'s changed between currently installed version ',
	                _react2.default.createElement(
	                    'span',
	                    { className: 'template-version' },
	                    this.props.currentVersion
	                ),
	                ' and new version ',
	                _react2.default.createElement(
	                    'span',
	                    { className: 'template-version' },
	                    this.props.template.Version
	                ),
	                '.'
	            ) : null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'template-logo-container' },
	                    _react2.default.createElement(_step_template_logo2.default, { size: 'large', 'class': 'template-logo', url: this.props.template.Links.Logo, resolveLink: this.props.resolveLink })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'template-details-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row margin-5' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 no-padding-hr' },
	                            _react2.default.createElement(TemplateSummary, { name: this.props.template.Name, descriptionHtml: templateDescriptionHtml, author: this.props.template.Author,
	                                version: this.props.template.Version, websiteUrl: this.props.template.Website, isUpdateAvailable: isUpdateAvailable,
	                                onInstall: this.props.onInstall, installButtonName: this.props.installButtonName,
	                                onUpdate: this.props.onUpdate, updateButtonName: this.props.updateButtonName,
	                                onCancel: this.props.onCancel, cancelButtonName: this.props.cancelButtonName }),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'nav nav-tabs nav-tabs-simple' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: this.getSelectedTabCssClassName('Parameters') },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                className: 'clickable', onClick: this.selectTab },
	                                            'Parameters'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: this.getSelectedTabCssClassName('Source code') },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                className: 'clickable', onClick: this.selectTab },
	                                            'Source code'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'tabbable tabs-top' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'tab-content pills-content' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: inputTabClasses },
	                                        templateParameters != null && templateParameters.length > 0 ? _react2.default.createElement(TemplateParameters, { templateParameters: templateParameters }) : _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            'This template has no parameters.'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: sourceCodeTabClasses },
	                                        _react2.default.createElement(AceEditor, { mode: scriptSyntax, code: scriptSourceCode })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(TemplateHelperLinks, null)
	        );
	    }
	});
	
	_module.directive('libraryStepTemplateDetails', function (reactDirective) {
	    return reactDirective(LibraryStepTemplateDetails);
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(82);
	
	var _step_template_logo = __webpack_require__(56);
	
	var _step_template_logo2 = _interopRequireDefault(_step_template_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = angular.module('octopusApp.library');
	
	Templates.propTypes = {
	    name: _react2.default.PropTypes.string.isRequired,
	    enabled: _react2.default.PropTypes.bool.isRequired,
	    actionName: _react2.default.PropTypes.string.isRequired,
	    actionUrl: _react2.default.PropTypes.string.isRequired,
	    templates: _react2.default.PropTypes.array.isRequired,
	    resolveLink: _react2.default.PropTypes.func.isRequired,
	    emptyState: _react2.default.PropTypes.element.isRequired,
	    allowRunningScriptTemplates: _react2.default.PropTypes.bool,
	    actions: _react2.default.PropTypes.element.isRequired,
	    promptWhenEmpty: _react2.default.PropTypes.element.isRequired
	};
	
	function Templates(props) {
	    var hasTemplates = props.templates != null && props.templates.length > 0;
	
	    var templateInstalled = _.find(props.templates, function (template) {
	        return template.hasOwnProperty('stepInstalledSuccessfully');
	    });
	    var stepInstallSuccessfully = hasTemplates && templateInstalled != null;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h4',
	            null,
	            props.name,
	            props.enabled && props.actions
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'margin-top-15' },
	            props.enabled || _react2.default.createElement(
	                'div',
	                { className: 'alert alert-info' },
	                props.emptyState
	            ),
	            stepInstallSuccessfully && _react2.default.createElement(
	                'div',
	                { className: 'alert alert-success' },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'alert-link', href: "#/library/steptemplates/" + templateInstalled.Id },
	                    templateInstalled.Name
	                ),
	                ' was installed successfully'
	            ),
	            hasTemplates ? _react2.default.createElement(
	                _reactBootstrap.Table,
	                { striped: true, condensed: true },
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    props.templates.map(function (template) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: template.Id },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'pull-left' },
	                                    _react2.default.createElement(_step_template_logo2.default, { 'class': 'logo', size: 'x-small', url: template.Links.Logo, resolveLink: props.resolveLink })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-10 col-sm-9 col-xs-10 cell-height-sm' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: "#/library/steptemplates/" + template.Id },
	                                        template.Name
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                props.allowRunningScriptTemplates && template.Type === 'Octopus.Script' && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: 'pull-right', bsStyle: 'info', href: '#/library/steptemplates/' + template.Id + '/run' },
	                                    'Run'
	                                )
	                            )
	                        );
	                    })
	                )
	            ) : props.enabled && _react2.default.createElement(
	                'div',
	                { className: 'alert alert-info' },
	                props.promptWhenEmpty
	            )
	        )
	    );
	}
	
	InstalledStepTemplates.propTypes = {
	    userInstalledTemplates: _react2.default.PropTypes.array.isRequired,
	    addCustomStepTemplateUrl: _react2.default.PropTypes.string.isRequired,
	    communityStepTemplatesEnabled: _react2.default.PropTypes.bool.isRequired,
	    communityInstalledTemplates: _react2.default.PropTypes.array.isRequired,
	    installCommunityStepTemplateUrl: _react2.default.PropTypes.string.isRequired,
	    resolveLink: _react2.default.PropTypes.func.isRequired,
	    import: _react2.default.PropTypes.func.isRequired
	};
	
	function InstalledStepTemplates(props) {
	
	    var userInstalledTemplates = props.userInstalledTemplates != null ? props.userInstalledTemplates : [];
	    var communityInstalledTemplates = props.communityInstalledTemplates != null ? props.communityInstalledTemplates : [];
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 col-lg-12' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Step templates'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Step templates are pre-configured steps that can be reused in multiple projects. If the Community library is disabled, visit the ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'http://g.octopushq.com/CommunityLibrary', target: '_blank' },
	                        'community library website'
	                    ),
	                    ' to browse and import step templates manually.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-md-6 col-lg-6' },
	                _react2.default.createElement(Templates, { name: 'Custom step templates',
	                    enabled: true,
	                    actionName: 'Add',
	                    actions: _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-link', onClick: props.import },
	                            'Import'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-success', href: props.addCustomStepTemplateUrl },
	                            'Add'
	                        )
	                    ),
	                    promptWhenEmpty: _react2.default.createElement(
	                        'a',
	                        { className: 'alert-link', href: props.addCustomStepTemplateUrl },
	                        'Add your first custom step template.'
	                    ),
	                    actionUrl: props.addCustomStepTemplateUrl,
	                    templates: userInstalledTemplates,
	                    resolveLink: props.resolveLink,
	                    allowRunningScriptTemplates: true,
	                    emptyState: _react2.default.createElement(
	                        'span',
	                        null,
	                        'Custom step templates will be listed here'
	                    ) })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-md-6 col-lg-6' },
	                _react2.default.createElement(Templates, { name: 'Community step templates',
	                    enabled: props.communityStepTemplatesEnabled,
	                    actions: _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success pull-right', href: props.installCommunityStepTemplateUrl },
	                        'Install'
	                    ),
	                    promptWhenEmpty: _react2.default.createElement(
	                        'a',
	                        { className: 'alert-link', href: props.installCommunityStepTemplateUrl },
	                        'Install your first community step template.'
	                    ),
	                    actionName: 'Install',
	                    actionUrl: props.installCommunityStepTemplateUrl,
	                    templates: communityInstalledTemplates,
	                    resolveLink: props.resolveLink,
	                    allowRunningScriptTemplates: false,
	                    emptyState: _react2.default.createElement(
	                        'span',
	                        null,
	                        'Community library integration is disabled.  If you want to take advantage of hundreds great templates developed by the members of our community then please ',
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'alert-link', href: '#/configuration/features' },
	                            'enable the integration feature.'
	                        )
	                    ) })
	            )
	        )
	    );
	}
	
	_module.directive('installedStepTemplates', function (reactDirective) {
	    return reactDirective(InstalledStepTemplates);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, _) {'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactCSSTransitionGroup = __webpack_require__(1203);
	
	var _ReactCSSTransitionGroup2 = _interopRequireDefault(_ReactCSSTransitionGroup);
	
	var _reactBootstrap = __webpack_require__(82);
	
	var _step_template_logo = __webpack_require__(56);
	
	var _step_template_logo2 = _interopRequireDefault(_step_template_logo);
	
	var _showdown = __webpack_require__(110);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	var _xss = __webpack_require__(296);
	
	var _xss2 = _interopRequireDefault(_xss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = angular.module('octopusApp.projects');
	
	var markdownConverter = new _showdown2.default.Converter({
	    simplifiedAutoLink: true,
	    literalMidWordUnderscores: true
	});
	
	StepTemplate.propTypes = {
	    template: _react2.default.PropTypes.object.isRequired,
	    onAdditionRequested: _react2.default.PropTypes.func.isRequired,
	    addButtonName: _react2.default.PropTypes.string,
	    onInstallationRequested: _react2.default.PropTypes.func.isRequired,
	    installButtonName: _react2.default.PropTypes.string,
	    onUpdateRequested: _react2.default.PropTypes.func.isRequired,
	    onDetailsRequested: _react2.default.PropTypes.func.isRequired,
	    resolveLink: _react2.default.PropTypes.func.isRequired
	};
	
	function StepTemplate(props) {
	
	    function getStatusText(template) {
	        if (template.IsBuiltIn) {
	            return "by Octopus Deploy";
	        }
	
	        if (template.IsInstalled) {
	            return "Installed";
	        }
	
	        return formatText(template.Author, 24);
	    }
	
	    function getStatusClass(template) {
	        if (template.IsBuiltIn) {
	            return "template-status-built-in";
	        }
	
	        if (template.IsInstalled) {
	            return "template-status-installed";
	        }
	
	        return "template-status-not-installed";
	    }
	
	    function getStatusLogo(template) {
	        if (template.IsBuiltIn) {
	            return _react2.default.createElement('i', { className: 'fontoctopus-octopus' });
	        }
	
	        if (template.IsInstalled) {
	            return _react2.default.createElement('i', { className: 'fa fa-check-square-o', 'aria-hidden': 'true' });
	        }
	
	        return _react2.default.createElement('i', { className: 'fa fa-users', 'aria-hidden': 'true' });
	    }
	
	    function getAddAction(template, onAdditionRequested, onInstallationRequested) {
	        if (template.IsInstalled) {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-success add', type: 'button', onClick: onAdditionRequested },
	                props.addButtonName ? props.addButtonName : "Add step"
	            );
	        }
	        return _react2.default.createElement(
	            'button',
	            { className: 'btn btn-success install', type: 'button', onClick: onInstallationRequested },
	            props.installButtonName ? props.installButtonName : "Install and add step"
	        );
	    };
	
	    function getAddActionDetailsClass(template) {
	        if (!template.IsInstalled) {
	            return "add-action-details-not-installed";
	        }
	
	        if (template.HasUpdate) {
	            return "add-action-details-update";
	        }
	
	        return "add-action-details-installed";
	    };
	
	    function ensureWholeWordsOnly(value) {
	        var indexToTruncateAt = value.lastIndexOf(" ");
	        if (indexToTruncateAt != -1) {
	            value = value.substring(0, indexToTruncateAt).trim();
	        }
	
	        if (value[value.length - 1] === ".") value = value.substring(0, value.length - 1);
	
	        return value;
	    }
	
	    // Truncates text and optionally converts markdown to HTML and sanitizes for XSS
	    function formatText(value, maxCharacters, convertMarkdown) {
	        value = (value || '').trim().replace(/\r?\n|\r/g, " ");
	
	        if (convertMarkdown) {
	            value = (0, _xss2.default)(markdownConverter.makeHtml(value));
	        }
	
	        return jQuery.truncate(value, {
	            length: maxCharacters,
	            words: true,
	            noBreaks: true
	        });
	    }
	
	    function getAddActionDetailsContent(template, onDetailsRequested, onUpdateRequested) {
	        if (!template.IsInstalled) {
	            return _react2.default.createElement(
	                'a',
	                { onClick: onDetailsRequested },
	                'View details'
	            );
	        }
	
	        if (template.HasUpdate) {
	            return _react2.default.createElement(
	                'a',
	                { onClick: onUpdateRequested },
	                'Update available'
	            );
	        }
	
	        return "";
	    }
	
	    var templateDescriptionHtml = { __html: formatText(props.template.Description, 76, true) };
	
	    return _react2.default.createElement(
	        'li',
	        { className: 'step-template animated', onClick: props.template.IsInstalled ? props.onAdditionRequested : props.onInstallationRequested },
	        _react2.default.createElement(_step_template_logo2.default, { 'class': 'logo', size: 'medium', url: props.template.Links.Logo, resolveLink: props.resolveLink, enableCacheBreaker: false }),
	        _react2.default.createElement(
	            'div',
	            { className: 'name' },
	            formatText(props.template.Name, 36)
	        ),
	        _react2.default.createElement('div', { className: 'description', dangerouslySetInnerHTML: templateDescriptionHtml }),
	        _react2.default.createElement(
	            'div',
	            { className: "template-status " + getStatusClass(props.template) },
	            _react2.default.createElement(
	                'span',
	                null,
	                getStatusText(props.template)
	            ),
	            getStatusLogo(props.template)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'add-action' },
	            getAddAction(props.template, props.onAdditionRequested, props.onInstallationRequested),
	            _react2.default.createElement(
	                'div',
	                { className: "add-action-details " + getAddActionDetailsClass(props.template) },
	                getAddActionDetailsContent(props.template, props.onDetailsRequested, props.onUpdateRequested)
	            )
	        )
	    );
	};
	
	var StepTemplateCategory = _react2.default.createClass({
	    displayName: 'StepTemplateCategory',
	
	    propTypes: {
	        name: _react2.default.PropTypes.string.isRequired,
	        templates: _react2.default.PropTypes.array.isRequired,
	        resolveLink: _react2.default.PropTypes.func.isRequired,
	        onCategorySelected: _react2.default.PropTypes.func.isRequired
	    },
	    render: function render() {
	
	        var firstTemplate = this.props.templates[0];
	
	        return _react2.default.createElement(
	            'li',
	            { className: 'step-category animated', onClick: this.props.onCategorySelected },
	            _react2.default.createElement(_step_template_logo2.default, { size: 'medium', url: firstTemplate.Links.Logo, resolveLink: this.props.resolveLink, enableCacheBreaker: false }),
	            _react2.default.createElement(
	                'div',
	                { className: 'category-name' },
	                this.props.name
	            )
	        );
	    }
	});
	
	var StepTemplates = _react2.default.createClass({
	    displayName: 'StepTemplates',
	
	    propTypes: {
	        templates: _react2.default.PropTypes.array.isRequired,
	        onAdditionRequested: _react2.default.PropTypes.func.isRequired,
	        addButtonName: _react2.default.PropTypes.string,
	        onInstallationRequested: _react2.default.PropTypes.func.isRequired,
	        installButtonName: _react2.default.PropTypes.string,
	        onUpdateRequested: _react2.default.PropTypes.func.isRequired,
	        onDetailsRequested: _react2.default.PropTypes.func.isRequired,
	        resolveLink: _react2.default.PropTypes.func.isRequired,
	        enableGrouping: _react2.default.PropTypes.bool
	    },
	    categoriseTemplates: function categoriseTemplates(templates) {
	        var categorised = _.groupBy(templates, function (t) {
	            return t.Category;
	        });
	        return _.keys(categorised).sort(function (category1, cateogry2) {
	            return category1.toLowerCase().localeCompare(cateogry2.toLowerCase());
	        }).map(function (categoryName) {
	            return { name: categoryName, templates: categorised[categoryName] };
	        });
	    },
	    getInitialState: function getInitialState() {
	        return {
	            showModal: false,
	            templateId: '',
	            templateName: '',
	            categoryTemplates: [],
	            categories: this.categoriseTemplates(this.props.templates)
	        };
	    },
	    popupConfirmation: function popupConfirmation(templateId, templateName) {
	        this.setState({ templateId: templateId });
	        this.setState({ templateName: templateName });
	        this.setState({ showModal: true });
	    },
	    showDetails: function showDetails() {
	        this.props.onDetailsRequested(this.state.templateId);
	    },
	    installStepAndAdd: function installStepAndAdd() {
	        this.props.onInstallationRequested(this.state.templateId).then(this.close(), this.close());
	    },
	    close: function close() {
	        this.setState({ showModal: false });
	    },
	    showCategoryTemplates: function showCategoryTemplates(templates) {
	        // We are setting min-hight here to avoid "screen jumping" when the user switches from categories to templates.
	        // Ideally this would be handled by a CSS transform but it did not work.
	        this.categoryTemplatesElement.style.minHeight = this.categoriesElement.clientHeight + "px";
	        this.setState({ categoryTemplates: templates, categories: [] });
	    },
	    showCategories: function showCategories() {
	        this.setState({ categoryTemplates: [], categories: this.categoriseTemplates(this.props.templates) });
	    },
	    showAllTemplates: function showAllTemplates() {
	        this.setState({ categoryTemplates: this.props.templates, categories: [] });
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setState({ categories: this.categoriseTemplates(nextProps.templates) });
	    },
	    isInCategoryMode: function isInCategoryMode() {
	        return this.state.categoryTemplates.length === 0 && this.state.categories.length > 0;
	    },
	    isInCategoryTemplatesMode: function isInCategoryTemplatesMode() {
	        return this.state.categoryTemplates.length > 0 && this.state.categories.length === 0;
	    },
	    render: function render() {
	        var _this = this;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            this.props.enableGrouping ? _react2.default.createElement(
	                'div',
	                null,
	                this.isInCategoryMode() && _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-link pull-right', onClick: this.showAllTemplates },
	                    'Show all'
	                ),
	                this.isInCategoryTemplatesMode() && _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-link pull-right', onClick: this.showCategories },
	                    'Back'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'grouping-container' },
	                    _react2.default.createElement(
	                        'ol',
	                        { className: 'categories', ref: function ref(element) {
	                                return _this.categoriesElement = element;
	                            } },
	                        _react2.default.createElement(
	                            _ReactCSSTransitionGroup2.default,
	                            {
	                                transitionName: { enter: 'zoomIn', leave: 'zoomOut' },
	                                transitionEnterTimeout: 1000,
	                                transitionLeaveTimeout: 1000 },
	                            this.state.categories.map(function (category) {
	                                return _react2.default.createElement(StepTemplateCategory, { key: category.name, name: category.name, templates: category.templates,
	                                    resolveLink: _this.props.resolveLink,
	                                    onCategorySelected: function onCategorySelected() {
	                                        return _this.showCategoryTemplates(category.templates);
	                                    } });
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        { className: 'category-templates', ref: function ref(element) {
	                                return _this.categoryTemplatesElement = element;
	                            } },
	                        _react2.default.createElement(
	                            _ReactCSSTransitionGroup2.default,
	                            {
	                                transitionName: { enter: 'fadeIn', leave: 'fadeOut' },
	                                transitionEnterTimeout: 1000,
	                                transitionLeaveTimeout: 1000
	                            },
	                            this.state.categoryTemplates.map(function (template) {
	                                return _react2.default.createElement(StepTemplate, { key: template.key, template: template,
	                                    onAdditionRequested: function onAdditionRequested() {
	                                        return _this.props.onAdditionRequested(template.Type, template.Id);
	                                    },
	                                    addButtonName: _this.props.addButtonName,
	                                    onInstallationRequested: function onInstallationRequested() {
	                                        return _this.popupConfirmation(template.Id, template.Name);
	                                    },
	                                    installButtonName: _this.props.installButtonName,
	                                    onUpdateRequested: function onUpdateRequested() {
	                                        return _this.props.onUpdateRequested(template.CommunityActionTemplateId);
	                                    },
	                                    onDetailsRequested: function onDetailsRequested() {
	                                        return _this.props.onDetailsRequested(template.Id);
	                                    },
	                                    resolveLink: _this.props.resolveLink });
	                            })
	                        )
	                    )
	                )
	            ) : _react2.default.createElement(
	                'ol',
	                null,
	                this.props.templates.map(function (template) {
	                    return _react2.default.createElement(StepTemplate, { key: template.key, template: template,
	                        onAdditionRequested: function onAdditionRequested() {
	                            return _this.props.onAdditionRequested(template.Type, template.Id);
	                        }, addButtonName: _this.props.addButtonName,
	                        onInstallationRequested: function onInstallationRequested() {
	                            return _this.popupConfirmation(template.Id, template.Name);
	                        }, installButtonName: _this.props.installButtonName,
	                        onUpdateRequested: function onUpdateRequested() {
	                            return _this.props.onUpdateRequested(template.CommunityActionTemplateId);
	                        },
	                        onDetailsRequested: function onDetailsRequested() {
	                            return _this.props.onDetailsRequested(template.Id);
	                        },
	                        resolveLink: _this.props.resolveLink });
	                })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showModal, onHide: this.close },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        this.props.installButtonName ? this.props.installButtonName : 'Install and add step'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        this.state.templateName
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-info margin margin-top-10', role: 'alert' },
	                        'This is a community contributed step that will be installed into your ',
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'alert-link', href: '#/library/steptemplates' },
	                            'Step templates'
	                        ),
	                        ' library. Read our ',
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'alert-link', href: 'http://g.octopushq.com/CommunityContributedStepTemplates', target: '_blank' },
	                            'community step documentation'
	                        ),
	                        ' for more information.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-link pull-left', onClick: this.showDetails },
	                        'View details'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: this.close },
	                        'Cancel'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { className: 'btn btn-success', onClick: this.installStepAndAdd },
	                        this.props.installButtonName ? this.props.installButtonName : 'Install and add'
	                    )
	                )
	            )
	        );
	    }
	});
	
	_module.directive('stepTemplates', function (reactDirective) {
	    return reactDirective(StepTemplates);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = angular.module('octopusApp.tenants');
	
	app.factory("TenantList", function (octopusRepository, octopusTagSets, $filter) {
	    return _react2.default.createClass({
	        propTypes: {
	            tenants: _react2.default.PropTypes.array.isRequired
	        },
	
	        getInitialState: function getInitialState() {
	            return { allTagSets: [], tenantsMissingVariables: [] };
	        },
	
	        getDefaultProps: function getDefaultProps() {
	            return { tenants: [] };
	        },
	
	        componentDidMount: function componentDidMount() {
	            var self = this;
	            octopusTagSets.getAll().then(function (tagSets) {
	                octopusRepository.Tenants.missingVariables(false).then(function (result) {
	                    self.setState({ allTagSets: tagSets, tenantsMissingVariables: _.pluck(result, 'TenantId') });
	                });
	            });
	        },
	
	        getTag: function getTag(canonicalTagName) {
	            var tagSetName = canonicalTagName.split("/")[0];
	            for (var i in this.state.allTagSets) {
	                var tagSet = this.state.allTagSets[i];
	                if (tagSet.Name !== tagSetName) {
	                    continue;
	                }
	
	                for (var j in tagSet.Tags) {
	                    var tag = tagSet.Tags[j];
	                    if (canonicalTagName === tag.CanonicalTagName) {
	                        return tag;
	                    }
	                }
	            }
	            return null;
	        },
	
	        isTenantMissingVariable: function isTenantMissingVariable(tenant) {
	            if (!this.state.tenantsMissingVariables) {
	                return null;
	            }
	            return this.state.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
	        },
	
	        render: function render() {
	            var self = this;
	            var tooltip = _react2.default.createElement(_reactBootstrap.Tooltip, { id: 'tooltip' }, 'Some of the required variable values have not been set.');
	
	            var tenantList = this.props.tenants.map(function (tenant, i) {
	                var tenantStatus = null;
	                if (self.isTenantMissingVariable(tenant)) {
	                    tenantStatus = _react2.default.createElement(_reactBootstrap.OverlayTrigger, { key: 'overlayTrigger.' + i, placement: 'top', overlay: tooltip }, _react2.default.DOM.a({ key: 'tenant.status.0.' + i, className: 'tenant-status warning', href: '#/tenants/' + tenant.Id + '/variables' }, [_react2.default.DOM.i({ key: 'tenant.status.0.2.' + i, 'data-uib-tooltip': 'Some of the required variable values have not been set.', className: 'fa fa-fw fa-warning' }, '')]));
	                }
	
	                return _react2.default.DOM.div({ key: 'tenants.0.' + i, className: '' }, _react2.default.DOM.div({ key: 'tenants.1.' + i, className: 'octo-list-group' }, _react2.default.DOM.div({ key: 'tenants.2.' + i, className: 'octo-list-group-item tenant-tile' }, [_react2.default.DOM.a({ key: 'tenants.2.0.' + i, href: '#/tenants/' + tenant.Id }, [_react2.default.DOM.div({ key: 'tenants.3.0.' + i, className: 'octo-list-group-item-icon' }, [_react2.default.DOM.img({ key: 'tenants.3.1.' + i, src: $filter('resolveLink')(tenant.Links['Logo']), style: { maxHeight: '100px', maxWidth: '100px' } })]), _react2.default.DOM.h4({ key: 'tenants.5.' + i, className: 'octo-list-group-item-heading' }, tenant.Name)]), _react2.default.DOM.div({ key: 'tenants.6.' + i, className: 'tenant-tags' }, tenant.TenantTags.map(function (canonicalTag, j) {
	                    var tag = self.getTag(canonicalTag);
	                    if (!tag) {
	                        return null;
	                    }
	                    var tagTooltip = _react2.default.createElement(_reactBootstrap.Tooltip, { id: 'tagTooltip' }, tag.Name);
	                    return _react2.default.createElement(_reactBootstrap.OverlayTrigger, { key: 'tagOverlayTrigger.' + i + '.' + j, placement: 'top', overlay: tagTooltip }, _react2.default.DOM.i({ key: 'tenant.tag.0.' + j, className: 'fa fa-square tag-swatch', style: { color: tag.Color } }, ''));
	                })), _react2.default.DOM.div({ key: 'tenants.7.' + i, className: 'tenant-status-group' }, [tenantStatus])])));
	            });
	            return _react2.default.DOM.div({ className: 'row tenant-list' }, tenantList);
	        }
	    });
	});
	
	app.directive('tenantList', function (reactDirective) {
	    return reactDirective('TenantList');
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = angular.module('octopusApp.infrastructure');
	
	
	var Card = _react2.default.createClass({
	    displayName: 'Card',
	
	    propTypes: {
	        logoUrl: _react2.default.PropTypes.string.isRequired,
	        title: _react2.default.PropTypes.string.isRequired,
	        content: _react2.default.PropTypes.string.isRequired,
	        footer: _react2.default.PropTypes.element
	    },
	    render: function render() {
	        return _react2.default.createElement(
	            'li',
	            { className: 'card col-lg-2 col-md-3 col-sm-3 col-xs-4' },
	            _react2.default.createElement(
	                'div',
	                { className: 'card-content animated' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'logo logo-md' },
	                    ' ',
	                    _react2.default.createElement('img', { src: this.props.logoUrl })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-details' },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        this.props.title
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.content
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-footer background-blue' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'card-footer background-blue'
	                    ),
	                    _react2.default.createElement('i', { className: 'fontoctopus-octopus' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'add-action' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-success add', type: 'button' },
	                        'Add step'
	                    ),
	                    _react2.default.createElement('div', { className: 'add-action-details add-action-details-installed' })
	                )
	            )
	        );
	    }
	});
	
	var CardBlock = _react2.default.createClass({
	    displayName: 'CardBlock',
	
	    propTypes: {
	        data: _react2.default.PropTypes.array.isRequired
	    },
	    render: function render() {
	        return _react2.default.createElement(
	            'ol',
	            { 'class': 'card-block' },
	            this.props.data.map(function (item) {
	                return _react2.default.createElement(Card, { title: item.title, content: item.content, logoUrl: item.logoUrl });
	            })
	        );
	    }
	});
	
	_module.directive('cardBlock', function (reactDirective) {
	    return reactDirective(CardBlock);
	});

/***/ },
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
338,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
338,
/* 343 */
338,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {// nothing references these libraries directly so we need to load them here
	
	__webpack_require__(308);
	__webpack_require__(718);
	__webpack_require__(339);
	__webpack_require__(359);
	var URI = __webpack_require__(71);
	
	(function() {
	    Octopus.App = angular.module('octopusApp', [
	        'ngRoute',
	        'ngAnimate',
	        'ngSanitize',
	        'ngStorage',
	        'ui.bootstrap',
	        'ui.select',
	        'ui.sortable',
	        'ui.ace',
	        'ui.router',
	        'frapontillo.bootstrap-switch',
	        'autofill-directive',
	        'angularFileUpload',
	        'react',
	        'octopusApp.infrastructure',
	        'octopusApp.shared',
	        'octopusApp.master',
	        'octopusApp.dashboard',
	        'octopusApp.projects',
	        'octopusApp.tasks',
	        'octopusApp.users',
	        'octopusApp.configuration',
	        'octopusApp.library',
	        'octopusApp.environments',
	        'octopusApp.management',
	        'octopusApp.accounts',
	        'octopusApp.tenants'
	    ]).config(function($routeProvider) {
	
	    }).config(function(uiSelectConfig) {
	        uiSelectConfig.theme = 'select2';
	    }).config(function ($uibTooltipProvider) {
	        //TODO: ui-bootstrap has bug whereby popover-append-to-body="true" is not being respected
	        $uibTooltipProvider.options({ appendToBody: true });
	    }).config(function (uiAceConfig) {
	        var options = uiAceConfig.ace || {};
	        options.useWrapMode = false;
	        options.showGutter = true;
	        options.theme = 'textmate';
	        uiAceConfig.ace = options;
	    }).run(function($rootScope, $state, $localStorage, octopusClient) {
	        $rootScope.octopusVersion = octopusClient.rootDocument().Version;
	        $rootScope.isEarlyAccessProgram = octopusClient.rootDocument().IsEarlyAccessProgram || false;
	        $rootScope.$storage = $localStorage.$default({});
	        $rootScope.ExtensionsCSS = octopusClient.rootDocument().ExtensionsCSS;
	        $rootScope.ExtensionsJavascript = octopusClient.rootDocument().ExtensionsJavascript;
	        $rootScope.pageTitle = "Home";
	
	        // Synchronize some navigation properties with the current route
	        $rootScope.$on('$stateChangeSuccess', function() {
	
	            // Ensure all inherited layout data is added to $rootscope for view rendering
	            if ($state.current) {
	                $rootScope.layout = {};
	                Object.keys($state.$current.includes).forEach(function(a) {
	                    _.assign($rootScope.layout, ($state.get(a)|| {}).layout);
	                }, $rootScope);
	
	                $rootScope.pageTitle = $rootScope.layout.title;
	            }
	
	            $("#dynamicallyGeneratedContent").empty();
	        });
	    }).config(function($stateProvider, $urlMatcherFactoryProvider, $urlRouterProvider) {
	        $urlMatcherFactoryProvider.caseInsensitive(true);
	        $urlMatcherFactoryProvider.strictMode(false);
	        //$urlRouterProvider.when('', '/');
	
	        $stateProvider.state('app', {
	            state: 'app',
	            name: 'Application',
	            redirectTo: 'app.dashboard',
	            templateUrl: 'areas/master/views/layout.html',
	            data: {
	                layoutType: 'full'
	            },
	            controller: function($rootScope, $state){
	                $rootScope.$state = $state;
	            }
	        });
	
	        $stateProvider.state("app.not-found", {
	            url: "*path",
	            templateUrl: "areas/shared/views/not-found.html"
	        });
	    });
	
	    // We defer startup of Angular until we've established a connection to Octopus
	    Octopus.App.start = function() {
	        $(function(){
	            var body = $("body");
	            var navMain = $("#main-navbar");
	
	            navMain.on("click", "a:not(.dropdown-toggle)", null, function (e) {
	                $("#main-navbar-collapse").collapse('hide');
	            });
	
	            var loader = $('#initial-page-loader');
	            var connecting = $('.when-connecting', loader);
	            var loadingMessage = $('.loading-message', connecting);
	            var progressBar = $('.progress', connecting);
	            var failed = $('.connection-failed', loader);
	            var whyFailed = $('p.why', failed);
	            var tryAgain = $('button.try-again', failed);
	
	            tryAgain.click(function() {
	                location.reload();
	            });
	
	            var configuration = {};
	            var serverUri = URI(window.location);
	            serverUri.hasQuery("octopus.server", function (baz) {
	                configuration.serverEndpoint = baz;
	            });
	
	            Octopus.App.Client = new Octopus.Client.OctopusClient(configuration);
	
	            Octopus.App.resolveLink = function(link) {
	                return Octopus.App.Client.resolve(link);
	            };
	
	            var loadScripts = function(remainingScripts, onComplete) {
	                if (remainingScripts.length === 0) {
	                    onComplete();
	                    return;
	                }
	                var js = remainingScripts[0];
	                $.getScript(Octopus.App.Client.resolve(js))
	                    .done(function(script) {
	                        remainingScripts.shift();
	                        loadScripts(remainingScripts, onComplete);
	                    });
	            };
	
	            Octopus.App.Client.connect(function (progress, indicator) {
	                loadingMessage.text(progress);
	                progressBar.removeClass("progress-success");
	                progressBar.removeClass("progress-warning");
	                progressBar.removeClass("progress-danger");
	                progressBar.addClass("progress-" + indicator);
	            }).then(function () {
	
	                loadScripts(Octopus.App.Client.rootDocument().ExtensionsJavascript, function () {
	
	                    _.forEach(Octopus.App.Client.rootDocument().ExtensionAngularModules, function (m) {
	                        Octopus.App.requires.push(m);
	                    });
	
	                    var repository = new Octopus.Client.Repository(Octopus.App.Client);
	                    repository.Users.getCurrent().then(function(user) {
	                        return repository.Users.getPermissions(user).then(function(permissionSet){
	                            loader.remove();
	
	                            Octopus.App.currentUser = user;
	                            Octopus.App.currentPermissionSet = permissionSet.Permissions;
	
	                            body.addClass("initialized");
	                            angular.bootstrap(document, ['octopusApp']);
	                        });
	                    }).catch(function (err) {
	                        if (err.StatusCode === 401) {
	                            loader.remove();
	                            body.addClass("initialized");
	                            angular.bootstrap(document, ['octopusApp']);
	                            return;
	                        }
	
	                        whyFailed.text(err.ErrorMessage);
	                        connecting.hide();
	                        failed.removeClass('hide');
	                        failed.show();
	                    });
	                });
	            }).catch(function (err) {
	                whyFailed.text(err.ErrorMessage);
	                if (err.Errors.length > 0) {
	                    whyFailed.text(err.Errors[0]);
	                }
	                connecting.hide();
	                failed.removeClass('hide');
	                failed.show();
	            });
	        });
	    };
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 370 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.accounts');
	
	module.controller('AccountEditController', function($scope, $q, $stateParams, busy, octopusRepository, $location, pollLoop, octopusLog) {
	    var vm = this;
	    var isLoading = vm.isLoading = busy.create();
	    var isSaving = vm.isSaving = busy.create();
	    var isTesting = vm.isTesting = busy.create();
	
	    var id = $stateParams.accountId;
	    var accountType = $location.search().accountType;
	    var loop;
	    var unavailableTenants = [];
	    var unavailableEnvironments = [];
	
	    vm.save = save;
	    vm.teamSensitiveValues = { EnvironmentIds: [], TenantIds: [] };
	
	    function init() {
	        var tenantsP = octopusRepository.Tenants ? octopusRepository.Tenants.all().then(function (tenants) {
	            vm.availableTenants = tenants;
	        }) : $q.resolve([]);
	
	        var environmentsP = octopusRepository.Environments.all().then(function (environments) {
	            vm.environments = environments;
	        });
	
	        isLoading.promise($q.all([tenantsP, environmentsP]).then(function () {
	            if (id) {
	                configureFromExisting();
	            } else {
	                configureFromNew();
	            }
	        }));
	    }
	
	    function configureFromNew(){
	        vm.account = { AccountType: accountType, EnvironmentIds: [] };
	    }
	
	    function configureFromExisting(){
	        isLoading.promise(octopusRepository.Accounts.get(id).then(function (account) {
	            vm.account = account;
	
	            vm.teamSensitiveValues.EnvironmentIds = vm.environments.filter(function(m){ return account.EnvironmentIds.indexOf(m.Id) !== -1; }).map(function(e){return e.Id;});
	            vm.teamSensitiveValues.TenantIds = vm.availableTenants
	                ? vm.availableTenants.filter(function(t){return account.TenantIds.indexOf(t.Id) !== -1;}).map(function(e){return e.Id;})
	                : [];
	
	            unavailableTenants = account.TenantIds.filter(function(tid) { return vm.teamSensitiveValues.TenantIds.indexOf(tid) === -1; });
	            unavailableEnvironments = account.EnvironmentIds.filter(function(tid) { return vm.teamSensitiveValues.EnvironmentIds.indexOf(tid) === -1; });
	        }));
	    }
	
	    function save(testAzureAccount) {
	        vm.account.EnvironmentIds = [].concat(unavailableEnvironments).concat(vm.teamSensitiveValues.EnvironmentIds);
	        vm.account.TenantIds = [].concat(unavailableTenants).concat(vm.teamSensitiveValues.TenantIds);
	
	        isSaving.promise(octopusRepository.Accounts.save(vm.account).then(function(saved){
	            if (testAzureAccount)
	            {
	                vm.account = saved;
	                var task = {
	                    Name: 'TestAzureAccount',
	                    Description: 'Test Azure account',
	                    Arguments: { AccountId: saved.Id }
	                };
	
	                isSaving.promise(octopusRepository.Tasks.create(task).then(function(task){
	                    $scope.accountTestTask = task;
	                    loop = pollLoop.create($scope, function () { return refreshAccountTest(); }, 1000);
	                    loop.startImmediately();
	                }));
	            }
	            else {
	                $location.path("/accounts");
	            }
	        }));
	    }
	
	    var refreshAccountTest = function () {
	        return isTesting.promise(octopusRepository.Tasks.get($scope.accountTestTask.Id)).then(function(task) {
	            $scope.accountTestTask = task;
	            if (task.State === "Success" || task.State === "Failed" || task.State === "TimedOut") {
	                octopusLog.log("Task has finished; no more refreshing");
	                loop.stop();
	            }
	        });
	    };
	
	    init();
	});

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.accounts');
	
	module.controller('AccountsIndexController', function ($scope, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.accountTypes = [
	    // Azure
	    { Name: "Azure Subscription", Id: "AzureSubscription",
	      SubTypes: [{Id: "AzureSubscription", Description: "Management Certificates"}, {Id: "AzureServicePrincipal", Description: "Service Principals"}],
	      Description: "Use _Azure Subscriptions_ to set subscription IDs, management certificates, and service principals to use when deploying to Microsoft Azure."
	    },
	
	    // SSH
	    {
	      Name: "SSH Key Pair", Id: "SshKeyPair", Description: "_SSH Key Pairs_ are used when authenticating to machines running Linux or another Unix-like operating system."
	    },
	
	    // Username/Password
	    {
	      Name: "Username/Password", Id: "UsernamePassword", Plural: "Usernames/Passwords", Description: "Records a username and password pair to use with SSH servers."
	    }
	  ];
	
	  isLoading.promise(octopusRepository.Accounts.all().then(function(accounts){
	    isLoading.promise(octopusRepository.Environments.all().then(function(environments) {
	      _.each(accounts, function (account) {
	        account.environments = getTags(account.EnvironmentIds, environments);
	      });
	
	      _.each($scope.accountTypes, function(accountType){
	        accountType.Accounts = !accountType.SubTypes
	         ? _.chain(accounts)
	           .filter(function(account){ return accountType.Id === account.AccountType;})
	           .sortBy('Name')
	           .value()
	         : _.chain(accounts)
	           .filter(function(account){return _.some(accountType.SubTypes, function(subType){ return subType.Id === account.AccountType;});})
	           .groupBy(function(account){ return _.find(accountType.SubTypes, function(subType){ return subType.Id === account.AccountType;}).Description;})
	           .value();
	      });
	    }));
	  }));
	
	  var getTags = function(allOptions, selectedOptions) {
	    if (allOptions.length === 0) {
	      return "";
	    }
	
	    var result = [];
	
	    _.each(selectedOptions, function (e) {
	      if (allOptions.indexOf(e.Id) >= 0) {
	        result.push(e.Name);
	      }
	    });
	
	    return result.join(",");
	  };
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.accounts');
	
	module.directive('accountSelector', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            endpoint: '=',
	            type: '@'
	        },
	        templateUrl: 'areas/accounts/views/account_selector.html',
	        controller: function ($scope, octopusRepository, busy) {
	            $scope.isLoadingAccounts = busy.create();
	            $scope.accounts = [];
	            $scope.refresh = refresh;
	            $scope.something = {};
	            $scope.warning = "";
	
	            if($scope.type === "AzureSubscription"){
	                $scope.warning = "Only Azure management-certificate accounts may be selected.";
	            }
	
	            if($scope.type === "AzureServicePrincipal"){
	                $scope.warning = "Only Azure service principal accounts may be selected.";
	            }
	
	            function getAccountById() {
	                return $scope.accounts.filter(function (acc) {
	                    return acc.Id === $scope.endpoint.AccountId;
	                })[0];
	            }
	
	            $scope.$watch(function () {
	                return $scope.accounts;
	            }, function () {
	                $scope.something.Account = getAccountById();
	            });
	
	            $scope.$watch(function () {
	                return $scope.something.Account;
	            }, function (account) {
	                if (account) {
	                    $scope.endpoint.AccountId = $scope.something.Account.Id;
	                    $scope.endpoint.AccountType = $scope.something.Account.AccountType;
	                }
	            });
	
	            function setAccounts(accounts) {
	                var types = $scope.type.split(',');
	                $scope.accounts = _.filter(accounts, function (a) {
	                    return _.find(types, function (type) {
	                        return type === a.AccountType;
	                    });
	                });
	            }
	
	            function refresh() {
	                $scope.isLoadingAccounts.promise(octopusRepository.Accounts.all().then(function (accounts) {
	                    setAccounts(accounts);
	                }));
	            }
	
	            refresh();
	        }
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 373 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.accounts');
	
	module.directive('accountSummary', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      account: '=',
	    },
	    templateUrl: 'areas/accounts/views/account_summary.html'
	  };
	});
	


/***/ },
/* 374 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.accounts');
	
	module.directive('azureAccount', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      account: '=model'
	    },
	    templateUrl: 'areas/accounts/views/azure_account.html',
	    link: function(scope) {
	    }
	  };
	});


/***/ },
/* 375 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.accounts');
	
	module.directive('sshKeyPairAccount', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      account: '=model'
	    },
	    templateUrl: 'areas/accounts/views/ssh_key_pair_account.html',
	    link: function(scope) {
	      var link = function() {
	        if (!scope.account.PrivateKeyFile) {
	          scope.account.PrivateKeyFile = { HasValue: false };
	        }
	        if (!scope.account.PrivateKeyPassphrase) {
	          scope.account.PrivateKeyPassphrase = { HasValue: false };
	        }
	      };
	
	      if (scope.account) {
	        link();
	      } else {
	        var unwatch = scope.$watch('account', function(nv) {
	          if (nv && !scope.view) {
	            link();
	            unwatch();
	          }
	        });
	      }
	    }
	  };
	});


/***/ },
/* 376 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.accounts');
	
	module.directive('usernamePasswordAccount', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      account: '=model'
	    },
	    templateUrl: 'areas/accounts/views/username_password_account.html'
	  };
	});


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {angular.module('octopusApp.configuration')
	    .controller('AuditFilterDialogController', function ($scope, $q, $uibModalInstance, $location, busy, octopusPermissionSet, visibleTenantFilter, octopusRepository, selectedValues, systemUserFactory, octopusTagSets) { 
	        var vm = this;
	        vm.isLoading = busy.create();
	        vm.close = $uibModalInstance.close;
	        vm.save = save;
	
	        function refreshSelectedValues() {
	          vm.selectedFilters = {
	            users: selectedValues.selectedUsers || [],
	            projects: selectedValues.selectedProjects || [],
	            environments: selectedValues.selectedEnvironments || [],
	            eventGroups: selectedValues.selectedEventGroups || [],
	            eventCategories: selectedValues.selectedEventCategories || [],
	            tenants: selectedValues.selectedTenants || [],
	            tagSets: selectedValues.selectedTags || [],
	            eventGroupCategories: []
	          };
	        }
	
	        var allTenants = [];
	        var systemUser = systemUserFactory;
	
	        var getTags = function(selectedOptions, allOptions) {
	            if (!selectedOptions || selectedOptions.length === 0 || allOptions.length === 0) {
	                return "";
	            }
	            var selectedOptionsArray = selectedOptions.split(",");
	            var result = [];
	            _.each(allOptions, function (e) {
	                if (_.contains(selectedOptionsArray, e.Id)) {
	                    result.push(e.Name);
	                }
	            });
	            return result.join(",");
	        };
	
	        function save() {
	            $uibModalInstance.close({
	                selectedUsers: vm.selectedFilters.users || [],
	                selectedProjects: vm.selectedFilters.projects || [],
	                selectedEnvironments: vm.selectedFilters.environments || [],
	                selectedEventGroups: vm.selectedFilters.eventGroups || [],
	                selectedEventCategories: vm.selectedFilters.eventCategories || [],
	                selectedTenants: vm.selectedFilters.tenants || [],
	                selectedTags: vm.selectedFilters.tagSets || []
	            });
	        }
	
	        function init() {
	            var perm = 'AuditView';
	            octopusPermissionSet.isAuthorized({ permission: perm }).then(function(yn) {
	                if(yn) {
	                    var promises = [];
	                    promises.push(octopusRepository.Users.all().then(function(users) {
	                        vm.usersByUsername = {};
	                        vm.users = users;
	                        vm.users.unshift(systemUser);
	                        _.each(users, function(user) {
	                            vm.usersByUsername[user.Username] = user;
	                        });
	                    }));
	                    promises.push(octopusRepository.Projects.all().then(function(projects) {
	                        vm.projects = projects;
	                    }));
	                    promises.push(octopusRepository.Environments.all().then(function(environments) {
	                        vm.environments = environments;
	                    }));
	                    promises.push(octopusRepository.Events.categories().then(function (eventCategories) {
	                        vm.eventCategories = eventCategories;
	                    }));
	                    promises.push(octopusRepository.Events.groups().then(function (eventGroups) {
	                        vm.eventGroups = eventGroups;
	                    }));
	                    if (octopusRepository.Tenants) {
	                        promises.push(octopusTagSets.getAll().then(function (tagSets) {
	                            vm.tagSets = tagSets.filter(function (ts) {
	                                return ts.Tags.length > 0;
	                            });
	                            vm.selectedTags = _.clone(selectedValues.selectedTags);
	                        }));
	                        promises.push(octopusRepository.Tenants.all().then(function (tenants) {
	                            allTenants = tenants;
	                            vm.availableTenants = allTenants.filter(function (tenant) {
	                                return !visibleTenantFilter(tenant);
	                            });
	                        }));
	                    }
	 
	                    vm.isLoading.promises(promises).then(function() {
	                      refreshSelectedValues();
	                    });
	                } else {
	                    vm.isLoading.showError("You do not have permission to perform this action. Please contact your Octopus administrator. Missing permission: "+ perm);
	                }
	            });
	        }
	 
	        init();
	    });
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.configuration');
	
	module.controller('AuditIndexController', function($scope, $location, busy, octopusRepository, eventFormatter, octopusPermissionSet, octopusTagSets, $q, $uibModal) {
	    var vm = this;
	    var isLoading = vm.isLoading = $scope.isLoading = busy.create();
	    var dateFormat = 'YYYY-MM-DDTHH:mm:ss.Z'; // This matches the server-side date format for subscription notification deep links, play carefully!
	
	    vm.openFilterDialog = openFilterDialog;
	    vm.availableTenants = [];
	    vm.tenantPromotions = {};
	    vm.dashboardFilter = {
	        showAll: true,
	        selectedUsers: [],
	        selectedProjects: [],
	        selectedEnvironments: [],
	        selectedEventGroups: [],
	        selectedEventCategories: [],
	        selectedTags: [],
	        selectedTenants: [],
	        dates: {
	            startDate: moment().subtract(30, 'days').startOf('day'),
	            endDate: moment().add(1, 'day').startOf('day').subtract(1, 'seconds')
	        },
	        skip: 0
	    };
	    vm.isFiltered = false;
	    vm.clearFilters = false;
	    vm.wasLoaded = false;
	
	    var clearAllFilters = function () {
	        vm.dashboardFilter.selectedUsers = [];
	        vm.dashboardFilter.selectedProjects = [];
	        vm.dashboardFilter.selectedEnvironments = [];
	        vm.dashboardFilter.selectedEventGroups = [];
	        vm.dashboardFilter.selectedEventCategories = [];
	        vm.dashboardFilter.selectedTags = [];
	        vm.dashboardFilter.selectedTenants = [];
	        vm.dashboardFilter.dates.startDate = moment().subtract(30, 'days').startOf('day');
	        vm.dashboardFilter.dates.endDate = moment().add(1, 'day').startOf('day').subtract('seconds', 1);
	        vm.isFiltered = false;
	        $location.search("users", null);
	        $location.search("projects", null);
	        $location.search("environments", null);
	        $location.search("eventGroups", null);
	        $location.search("eventCategories", null);
	        $location.search("tenants", null);
	        $location.search("tags", null);
	        $location.search("from", null);
	        $location.search("to", null);
	        vm.refresh();
	        return false;
	    };
	
	    function extractFilterParams() {
	        vm.isFiltered = false; // reset
	        if ($location.search().users){
	            var usersVal = $location.search().users;
	            if (typeof usersVal === "string") {
	                usersVal = [usersVal];
	            }
	            vm.dashboardFilter.selectedUsers = usersVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().projects){
	            var projectsVal = $location.search().projects;
	            if (typeof projectsVal === "string") {
	                projectsVal = [projectsVal];
	            }
	            vm.dashboardFilter.selectedProjects = projectsVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().environments){
	            var environmentsVal = $location.search().environments;
	            if (typeof environmentsVal === "string") {
	                environmentsVal = [environmentsVal];
	            }
	            vm.dashboardFilter.selectedEnvironments = environmentsVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().eventGroups){
	            var eventGroupsVal = $location.search().eventGroups;
	            if (typeof eventGroupsVal === "string") {
	                eventGroupsVal = [eventGroupsVal];
	            }
	            vm.dashboardFilter.selectedEventGroups = eventGroupsVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().eventCategories){
	            var eventCategoriesVal = $location.search().eventCategories;
	            if (typeof eventCategoriesVal === "string") {
	                eventCategoriesVal = [eventCategoriesVal];
	            }
	            vm.dashboardFilter.selectedEventCategories = eventCategoriesVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().tenants){
	            var tenantVal = $location.search().tenants;
	            if (typeof tenantVal === "string") {
	                tenantVal = [tenantVal];
	            }
	            vm.dashboardFilter.selectedTenants = tenantVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().tags){
	            var tagVal = $location.search().tags;
	            if (typeof tagVal === "string") {
	                tagVal = [tagVal];
	            }
	            vm.dashboardFilter.selectedTags = tagVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().from){
	            var fromVal = $location.search().from;
	            if (typeof fromVal === "string") {
	                fromVal = [fromVal];
	            }
	            vm.dashboardFilter.dates.startDate = moment(fromVal, dateFormat);
	            // This setting is not part of the filter dialog, so do not set vm.isFiltered here.
	        }
	        if ($location.search().to){
	            var toVal = $location.search().to;
	            if (typeof toVal === "string") {
	                toVal = [toVal];
	            }
	            vm.dashboardFilter.dates.endDate = moment(toVal, dateFormat);
	            // This setting is not part of the filter dialog, so do not set vm.isFiltered here.
	        }
	    }
	
	    function openFilterDialog() {
	        if (vm.clearFilters) {
	            clearAllFilters();
	            vm.clearFilters = false;
	            return;
	        }
	
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/configuration/audit/views/audit_filter_dialog.html',
	            controller: 'AuditFilterDialogController',
	            controllerAs: 'vm',
	            bindToController: true,
	            resolve: {
	                selectedValues: function () {
	                    return {
	                        selectedUsers: vm.dashboardFilter.selectedUsers,
	                        selectedProjects: vm.dashboardFilter.selectedProjects,
	                        selectedEnvironments: vm.dashboardFilter.selectedEnvironments,
	                        selectedEventGroups: vm.dashboardFilter.selectedEventGroups,
	                        selectedEventCategories: vm.dashboardFilter.selectedEventCategories,
	                        selectedTenants: vm.dashboardFilter.selectedTenants,
	                        selectedTags: vm.dashboardFilter.selectedTags
	                    };
	                },
	                visibleTenantFilter: function () {
	                    return function (tenant) {
	                        return false;
	                    };
	                }
	            }
	        }).result.then(function (result) {
	            if (!result) {
	                return;
	            }
	            vm.dashboardFilter.selectedUsers = result.selectedUsers;
	            vm.dashboardFilter.selectedProjects = result.selectedProjects;
	            vm.dashboardFilter.selectedEnvironments = result.selectedEnvironments;
	            vm.dashboardFilter.selectedEventGroups = result.selectedEventGroups;
	            vm.dashboardFilter.selectedEventCategories = result.selectedEventCategories;
	            vm.dashboardFilter.selectedTenants = result.selectedTenants;
	            vm.dashboardFilter.selectedTags = result.selectedTags;
	            vm.isFiltered = result.selectedUsers.length > 0
	             || result.selectedProjects.length > 0
	             || result.selectedEnvironments.length > 0 
	             || result.selectedEventGroups.length > 0 
	             || result.selectedEventCategories.length > 0 
	             || result.selectedTenants.length > 0 
	             || result.selectedTags.length > 0;
	
	            if (vm.dashboardFilter.selectedUsers && vm.dashboardFilter.selectedUsers.length > 0) {
	                $location.search('users', vm.dashboardFilter.selectedUsers);
	            } else {
	                $location.search('users', undefined);
	            }
	
	            if (vm.dashboardFilter.selectedProjects && vm.dashboardFilter.selectedProjects.length > 0) {
	                $location.search('projects', vm.dashboardFilter.selectedProjects);
	            } else {
	                $location.search('projects', undefined);
	            }
	
	            if (vm.dashboardFilter.selectedEnvironments && vm.dashboardFilter.selectedEnvironments.length > 0) {
	                $location.search('environments', vm.dashboardFilter.selectedEnvironments);
	            } else {
	                $location.search('environments', undefined);
	            }
	
	            if (vm.dashboardFilter.selectedEventGroups && vm.dashboardFilter.selectedEventGroups.length > 0) {
	                $location.search('eventGroups', vm.dashboardFilter.selectedEventGroups);
	            } else {
	                $location.search('eventGroups', undefined);
	            }
	
	            if (vm.dashboardFilter.selectedEventCategories && vm.dashboardFilter.selectedEventCategories.length > 0) {
	                $location.search('eventCategories', vm.dashboardFilter.selectedEventCategories);
	            } else {
	                $location.search('eventCategories', undefined);
	            }
	
	            if (vm.dashboardFilter.selectedTenants && vm.dashboardFilter.selectedTenants.length > 0) {
	                $location.search('tenants', vm.dashboardFilter.selectedTenants);
	            } else {
	                $location.search('tenants', undefined);
	            }
	
	            if (vm.dashboardFilter.selectedTags && vm.dashboardFilter.selectedTags.length > 0) {
	                $location.search('tags', vm.dashboardFilter.selectedTags);
	            } else {
	                $location.search('tags', undefined);
	            }
	
	            vm.refresh();
	        });
	    }
	
	    vm.selectPage = function(skip) {
	        vm.dashboardFilter.skip = skip;
	        reload();
	    };
	
	    vm.formatMessageHtml = eventFormatter.format;
	
	    vm.showDetails = function (e) {
	      if (typeof e.detailsVisible === 'undefined' || e.detailsVisible === null) {
	        e.detailsVisible = true;
	      } else {
	        e.detailsVisible = !e.detailsVisible;
	      }
	    };
	
	    vm.formatDiff = function(diff) {
	      if (!diff) {
	        return diff;
	      }
	      var replaced = diff.replace(new RegExp("\r&para;", 'g'), "");
	      return replaced;
	    };
	
	    vm.refresh = function() {
	        vm.dashboardFilter.skip = 0;
	        reload();
	    };
	
	    vm.refreshDates = function() {
	        if (vm.dashboardFilter.dates.startDate) {
	            $location.search('from', vm.dashboardFilter.dates.startDate.utc().format(dateFormat));
	        } else {
	            $location.search('from', undefined);
	        }
	
	        if (vm.dashboardFilter.dates.endDate) {
	            $location.search('to', vm.dashboardFilter.dates.endDate.utc().format(dateFormat));
	        } else {
	            $location.search('to', undefined);
	        }
	
	        vm.refresh();
	    };
	
	    vm.openSubscriptions = function() {
	        $location.path('/configuration/audit/subscriptions')
	            .search('users', null)
	            .search('projects', null)
	            .search('environments', null)
	            .search('eventGroups', null)
	            .search('eventCategories', null)
	            .search('tags', null)
	            .search('tenants', null);
	    };
	
	    vm.openNewSubscription = function() {
	        $location.path('/configuration/audit/subscriptions/new')
	            .search('users', vm.dashboardFilter.selectedUsers)
	            .search('projects', vm.dashboardFilter.selectedProjects)
	            .search('environments', vm.dashboardFilter.selectedEnvironments)
	            .search('eventGroups', vm.dashboardFilter.selectedEventGroups)
	            .search('eventCategories', vm.dashboardFilter.selectedEventCategories)
	            .search('tags', vm.dashboardFilter.selectedTags)
	            .search('tenants', vm.dashboardFilter.selectedTenants);
	    };
	
	    var reload = function() {
	      if(!vm.wasLoaded) {
	          return;
	      }
	      extractFilterParams();
	      var eventListOptions = {};
	
	      if (vm.dashboardFilter.selectedUsers) {
	          eventListOptions.users = vm.dashboardFilter.selectedUsers;
	      }
	      if (vm.dashboardFilter.selectedProjects) {
	          eventListOptions.projects = vm.dashboardFilter.selectedProjects;
	      }
	      if (vm.dashboardFilter.selectedEnvironments) {
	          eventListOptions.environments = vm.dashboardFilter.selectedEnvironments;
	      }
	      if (vm.dashboardFilter.selectedEventGroups) {
	          eventListOptions.eventGroups = vm.dashboardFilter.selectedEventGroups;
	      }
	      if (vm.dashboardFilter.selectedEventCategories) {
	          eventListOptions.eventCategories = vm.dashboardFilter.selectedEventCategories;
	      }
	      if (vm.dashboardFilter.selectedTags) {
	          eventListOptions.tags = vm.dashboardFilter.selectedTags;
	      }
	      if (vm.dashboardFilter.selectedTenants) {
	          eventListOptions.tenants = vm.dashboardFilter.selectedTenants;
	      }
	      if (vm.dashboardFilter.dates.startDate) {
	          eventListOptions.from = vm.dashboardFilter.dates.startDate.format();
	      }
	      if (vm.dashboardFilter.dates.endDate) {
	          eventListOptions.to = vm.dashboardFilter.dates.endDate.format();
	      }
	      if (vm.dashboardFilter.skip) {
	          eventListOptions.skip = vm.dashboardFilter.skip;
	      }
	
	      isLoading.promise(octopusRepository.Events.list(eventListOptions).then(function(events){
	          vm.events = events;
	      }));
	    };
	
	    function init(){
	        var perm = 'AuditView';
	        octopusPermissionSet.isAuthorized({ permission: perm }).then(function(yn) {
	            if(yn) {
	                extractFilterParams();
	                vm.wasLoaded  = true;
	                vm.refresh();
	            } else {
	                isLoading.showError("You do not have permission to perform this action. Please contact your Octopus administrator. Missing permission: " + perm);
	            }
	        });
	    }
	
	    init();
	});


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.directive("eventFilter", function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      projects: '=',
	      environments: '=',
	      roles: '=',
	      users: '=',
	      tenants: '=',
	      tagSets: '=',
	      eventGroups: '=',
	      eventCategories: '=',
	      selectedFilters: '='
	    },
	    templateUrl: 'areas/configuration/audit/views/event_filter.html',
	    controller: function($scope) {
	      var vm = this;
	
	      var getTags = function(selectedOptions, allOptions) {
	        if (!selectedOptions || selectedOptions.length === 0 || allOptions.length === 0) {
	          return "";
	        }
	        var selectedOptionsArray = selectedOptions.split(",");
	        var result = [];
	        _.each(allOptions, function (e) {
	          if (_.contains(selectedOptionsArray, e.Id)) {
	            result.push(e.Name);
	          }
	        });
	        return result.join(",");
	      };
	
	      var refreshEventGroupCategories = function () {
	        if (!vm.selectedFilters)
	        {
	          return;
	        }
	
	        if (vm.selectedFilters.eventGroups.length > 0) {
	          var selectedGroups = _.filter(vm.eventGroups, function (eventGroup) {
	            return vm.selectedFilters.eventGroups.indexOf(eventGroup.Id) > -1;
	          });
	          var selectedEventCategoryIds = _.flatten(_.map(selectedGroups, function (selectedGroup) {
	            return selectedGroup.EventCategories;
	          })).join(",");
	          vm.selectedFilters.selectedEventGroupCategories = getTags(selectedEventCategoryIds, vm.eventCategories);
	        } else {
	          vm.selectedFilters.selectedEventGroupCategories = [];
	        }
	      };
	
	      $scope.$watch(function () { return vm.selectedFilters ? vm.selectedFilters.eventGroups : vm.selectedFilters; }, function() {
	        refreshEventGroupCategories();
	      });
	    },
	    controllerAs: 'vm',
	    bindToController: true
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('SubscriptionEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octopusTagSets, octoDialog, unsavedChanges, systemUserFactory) {
	    var vm = this;
	    var isLoading = vm.isLoading =  $scope.isLoading = busy.create();
	    var isSaving = vm.isSaving = $scope.isSaving = busy.create();
	    var subscriptionId = $stateParams.subscriptionId;
	    var repository = octopusRepository.Subscriptions;
	    var systemUser = systemUserFactory;
	
	    vm.subscription = null;
	    vm.smtpConfigured = false;
	    vm.serverUriExists = false;
	    vm.serverUri = undefined;
	
	    vm.selectedValues = {
	        users: [],
	        projects: [],
	        environments: [],
	        eventGroups: [],
	        eventCategories: [],
	        tenants: [],
	        tagSets: [],
	        selectedEventGroupCategories: []
	    };
	
	    vm.save = function() {
	        if (vm.emailFrequencyPeriod.Days == null) {
	            vm.emailFrequencyPeriod.Days = 0;
	        }
	        if (vm.emailFrequencyPeriod.Hours == null) {
	            vm.emailFrequencyPeriod.Hours = 0;
	        }
	        if (vm.emailFrequencyPeriod.Minutes == null) {
	            vm.emailFrequencyPeriod.Minutes = 0;
	        }
	
	        vm.subscription.EventNotificationSubscription.EmailFrequencyPeriod = vm.emailFrequencyPeriod.Days + "." + pad(vm.emailFrequencyPeriod.Hours) + ":" + pad(vm.emailFrequencyPeriod.Minutes) + ":00";
	
	        mapSelectedValuesToSubscription();
	
	        isSaving.promise(repository.save(vm.subscription).then(function(saved){
	            unsavedChanges.saved();
	            $location.path('/configuration/audit/subscriptions/');
	        }));
	    };
	
	    var getTags = function(selectedOptions, allOptions) {
	        if (!selectedOptions || selectedOptions.length === 0 || allOptions.length === 0) {
	            return "";
	        }
	        var selectedOptionsArray = selectedOptions.split(",");
	        var result = [];
	        _.each(allOptions, function (e) {
	            if (_.contains(selectedOptionsArray, e.Id)) {
	                result.push(e.Name);
	            }
	        });
	        return result.join(",");
	    };
	
	    function mapSubscriptionToSelectedValues()
	    {
	        vm.selectedValues.users = vm.subscription.EventNotificationSubscription.Filter.Users;
	        vm.selectedValues.projects = vm.subscription.EventNotificationSubscription.Filter.Projects;
	        vm.selectedValues.environments = vm.subscription.EventNotificationSubscription.Filter.Environments;
	        vm.selectedValues.eventGroups = vm.subscription.EventNotificationSubscription.Filter.EventGroups;
	        vm.selectedValues.eventCategories = vm.subscription.EventNotificationSubscription.Filter.EventCategories;
	        vm.selectedValues.tenants = vm.subscription.EventNotificationSubscription.Filter.Tenants;
	        vm.selectedValues.tagSets = vm.subscription.EventNotificationSubscription.Filter.Tags;
	    }
	
	    function mapSelectedValuesToSubscription()
	    {
	        vm.subscription.EventNotificationSubscription.Filter.Users = vm.selectedValues.users;
	        vm.subscription.EventNotificationSubscription.Filter.Projects = vm.selectedValues.projects;
	        vm.subscription.EventNotificationSubscription.Filter.Environments = vm.selectedValues.environments;
	        vm.subscription.EventNotificationSubscription.Filter.EventGroups = vm.selectedValues.eventGroups;
	        vm.subscription.EventNotificationSubscription.Filter.EventCategories = vm.selectedValues.eventCategories;
	        vm.subscription.EventNotificationSubscription.Filter.Tenants = vm.selectedValues.tenants;
	        vm.subscription.EventNotificationSubscription.Filter.Tags = vm.selectedValues.tagSets;
	    }
	
	    function extractFilterParams() {
	        if ($location.search().users){
	            var usersVal = $location.search().users;
	            if (typeof usersVal === "string") {
	                usersVal = [usersVal];
	            }
	            vm.selectedValues.users = usersVal;
	        }
	        if ($location.search().projects){
	            var projectsVal = $location.search().projects;
	            if (typeof projectsVal === "string") {
	                projectsVal = [projectsVal];
	            }
	            vm.selectedValues.projects = projectsVal;
	        }
	        if ($location.search().environments){
	            var environmentsVal = $location.search().environments;
	            if (typeof environmentsVal === "string") {
	                environmentsVal = [environmentsVal];
	            }
	            vm.selectedValues.environments = environmentsVal;
	        }
	        if ($location.search().eventGroups){
	            var eventGroupsVal = $location.search().eventGroups;
	            if (typeof eventGroupsVal === "string") {
	                eventGroupsVal = [eventGroupsVal];
	            }
	            vm.selectedValues.eventGroups = eventGroupsVal;
	        }
	        if ($location.search().eventCategories){
	            var eventCategoriesVal = $location.search().eventCategories;
	            if (typeof eventCategoriesVal === "string") {
	                eventCategoriesVal = [eventCategoriesVal];
	            }
	            vm.selectedValues.eventCategories = eventCategoriesVal;
	        }
	        if ($location.search().tenants){
	            var tenantVal = $location.search().tenants;
	            if (typeof tenantVal === "string") {
	                tenantVal = [tenantVal];
	            }
	            vm.selectedValues.tenants = tenantVal;
	        }
	        if ($location.search().tags){
	            var tagVal = $location.search().tags;
	            if (typeof tagVal === "string") {
	                tagVal = [tagVal];
	            }
	            vm.selectedValues.tagSets = tagVal;
	        }
	    }
	
	    function refreshEmailFrequencyPeriod() {
	        var emailFrequencyPeriodParts = vm.subscription.EventNotificationSubscription.EmailFrequencyPeriod.split(":");
	
	        var days = 0;
	        var hours = 0;
	        var mins = 0;
	        var tsPart1 = emailFrequencyPeriodParts[0];
	        if (tsPart1.indexOf(".") !== -1) {
	            // days included
	            var daysAndHours = tsPart1.split(".");
	            days = parseInt(daysAndHours[0]);
	            hours = parseInt(daysAndHours[1]);
	            mins = parseInt(emailFrequencyPeriodParts[1]);
	        } else {
	            // no days
	            hours = parseInt(emailFrequencyPeriodParts[0]);
	            mins = parseInt(emailFrequencyPeriodParts[1]);
	        }
	        vm.emailFrequencyPeriod = {
	            Days: days,
	            Hours: hours,
	            Minutes: mins
	        };
	    }
	
	    function pad(num){
	        return ("00" + num).substr(-2);
	    }
	
	
	    function init() { 
	        var promises = [];
	        promises.push(octopusRepository.Teams.all().then(function(teams) {
	            vm.teams = teams;
	        }));
	        promises.push(octopusRepository.SmtpConfiguration.get().then(function (smtp) {
	            if (smtp.SmtpHost && smtp.SmtpPort > 0 && smtp.SendEmailFrom) {
	                vm.smtpConfigured = true;
	            }
	        }));
	        promises.push(octopusRepository.ServerConfiguration.get().then(function (config) {
	            if (config.ServerUri) {
	                vm.serverUri = config.ServerUri;
	                vm.serverUriExists = true;
	            }
	        }));
	        promises.push(octopusRepository.Users.all().then(function(users) {
	            vm.usersByUsername = {};
	            vm.users = users;
	            vm.users.unshift(systemUser);
	            _.each(users, function(user) {
	                vm.usersByUsername[user.Username] = user;
	            });
	        }));
	        promises.push(octopusRepository.Projects.all().then(function(projects) {
	            vm.projects = projects;
	        }));
	        promises.push(octopusRepository.Environments.all().then(function(environments) {
	            vm.environments = environments;
	        }));
	        promises.push(octopusRepository.Events.categories().then(function (eventCategories) {
	            vm.eventCategories = eventCategories;
	        }));
	        promises.push(octopusRepository.Events.groups().then(function (eventGroups) {
	            vm.eventGroups = eventGroups;
	        }));
	        if (octopusRepository.Tenants) {
	            promises.push(octopusTagSets.getAll().then(function (tagSets) {
	                vm.tagSets = tagSets.filter(function (ts) {
	                    return ts.Tags.length > 0;
	                });
	            }));
	            promises.push(octopusRepository.Tenants.all().then(function (tenants) {
	                vm.availableTenants = tenants;
	            }));
	        }
	        promises.push(octopusRepository.ServerStatus.getTimezones().then(function (timezones) {
	            vm.timezones = timezones;
	        }));
	
	        isLoading.promises(promises).then(function() {
	            if (subscriptionId) {
	                isLoading.promise(repository.get(subscriptionId).then(function (subscription) {
	                    vm.subscription = subscription;
	                    refreshEmailFrequencyPeriod();
	                    mapSubscriptionToSelectedValues();
	                    pageTitle(subscription.Name);
	                }));
	            } else {
	                var serverLocalTimezones = vm.timezones.filter(function(tz) {
	                    return tz.IsLocal === true;
	                });
	                vm.subscription = {
	                    Name: "",
	                    Type: "Event",
	                    EventNotificationSubscription: {
	                        Filter: {
	                            Users: [],
	                            Projects: [],
	                            Environments: [],
	                            EventGroups: [],
	                            EventCategories: [],
	                            Tenants: [],
	                            Tags: []
	                        },
	                        EmailFrequencyPeriod: "0.01:00",
	                        EmailShowDatesInTimeZoneId: (serverLocalTimezones.length > 0 ? serverLocalTimezones[0].Id : null),
	                        Teams: []
	                    }
	                };
	                mapSubscriptionToSelectedValues();
	                refreshEmailFrequencyPeriod();
	                extractFilterParams();
	                pageTitle('Create Subscription');
	            }
	        });
	    }
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('SubscriptionsController', function($scope, $location, busy, octopusRepository, octopusClient) {
	    var isLoading = $scope.isLoading = busy.create();
	
	    function parseTimeSpan(timeSpan)
	    {
	        var timeSpanParts = timeSpan.split(":");
	        
	        var days = 0;
	        var hours = 0;
	        var mins = 0;
	        var tsPart1 = timeSpanParts[0];
	        if (tsPart1.indexOf(".") !== -1) {
	            // days included
	            var daysAndHours = tsPart1.split(".");
	            days = parseInt(daysAndHours[0]);
	            hours = parseInt(daysAndHours[1]);
	            mins = parseInt(timeSpanParts[1]);
	        } else {
	            // no days
	            hours = parseInt(timeSpanParts[0]);
	            mins = parseInt(timeSpanParts[1]);
	        }
	        return {
	            Days: days,
	            Hours: hours,
	            Minutes: mins
	        };
	    }
	
	    isLoading.promise(octopusRepository.Subscriptions.all().then(function(subscriptions) {
	        isLoading.promise(octopusRepository.Teams.all().then(function(teams) {
	            _.each(subscriptions, function (subscription) {
	                var emailFrequencyPeriod = parseTimeSpan(subscription.EventNotificationSubscription.EmailFrequencyPeriod);
	                var emailFrequencyPeriodText = 'Send email notifications every';
	                if (emailFrequencyPeriod.Days > 0) {
	                    emailFrequencyPeriodText += ' ' + emailFrequencyPeriod.Days + ' day' + (emailFrequencyPeriod.Days === 1 ? '' : 's');
	                }
	                if (emailFrequencyPeriod.Hours > 0) {
	                    emailFrequencyPeriodText += ' ' + emailFrequencyPeriod.Hours + ' hour' + (emailFrequencyPeriod.Hours === 1 ? '' : 's');
	                }
	                if (emailFrequencyPeriod.Minutes > 0 || emailFrequencyPeriod.Hours === 0) {
	                    emailFrequencyPeriodText += ' ' + emailFrequencyPeriod.Minutes + ' minute' + (emailFrequencyPeriod.Minutes === 1 ? '' : 's');
	                }
	                subscription.emailFrequencyPeriodText = emailFrequencyPeriodText;
	                subscription.emailTeams = getTags(subscription.EventNotificationSubscription.EmailTeams, teams);
	                subscription.webhookTeams = getTags(subscription.EventNotificationSubscription.WebhookTeams, teams);
	            });
	            $scope.subscriptions = subscriptions;
	        }));
	    }));
	
	    var getTags = function(allOptions, selectedOptions) {
	        if (allOptions.length === 0) {
	            return "";
	        }
	        var result = [];
	        _.each(selectedOptions, function (e) {
	            if (allOptions.indexOf(e.Id) >= 0) {
	                result.push(e.Name);
	            }
	        });
	        return result.join(",");
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 382 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.directive('subscriptionEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/configuration/audit/subscriptions/views/editor.html'
	  };
	});


/***/ },
/* 383 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('BackupEditController', function($scope, $location, busy, octopusRepository, unsavedChanges) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	});
	
	
	


/***/ },
/* 384 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('CertificatesIndexController', function($scope, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  var certs = octopusRepository.Certificates;
	
	  isLoading.promises([
	    certs.getOctopusCertificate().then(function(octo) {
	      $scope.octopusCertificate = octo;
	    })
	  ]);
	});
	


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('DiagnosticsIndexController', function($scope, busy, octopusRepository, pollLoop, octoDialog, $state, $location) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isChecking = $scope.isChecking = busy.create();
	  var isCollecting = $scope.isCollecting = busy.create();
	  var ssr = octopusRepository.ServerStatus;
	
	  $scope.diagnosticTab = 'serverLogs';
	  $scope.showSystemReportWarning = false;
	
	  isLoading.promise(ssr.getExtensionStats().then(function(extensionStats) {
	    $scope.extensions = extensionStats;
	  }));
	
	  var refresh = function() {
	    return isLoading.promise(ssr.getServerStatus().then(function(status) {
	      return isLoading.promise(ssr.getLogs(status).then(function (logs) {
	        return isLoading.promise(ssr.getSystemInfo(status).then(function (info) {
	          $scope.status = status;
	          $scope.info = info;
	          $scope.logs = logs.slice(-5);
	          $scope.more = logs.length - 5;
	          $scope.systemReportLink = octopusRepository.resolve(status.Links["SystemReport"]);
	        }));
	      }));
	    }));
	  };
	
	  var loop = pollLoop.create($scope, refresh);
	  loop.startImmediately();
	
	  $scope.gcCollect = function() {
	    ssr.gcCollect($scope.status).then(function (info) {
	      $state.reload();
	    });
	  };
	
	  $scope.deepCount = function(activities) {
	    if (!activities) {
	      return 0;
	    }
	    var count = activities.length;
	    _.each(activities, function(activity) {
	      count += $scope.deepCount(activity.SupervisedActivities);
	    });
	    return count;
	  };
	
	  $scope.checkSystemIntegrity = function()
	  {
	    isChecking.promise(octopusRepository.Tasks.create({
	      Name: 'SystemIntegrityCheck',
	      Description: 'Check System Integrity'
	    }).then(function (newTask) {
	      $location.path("/tasks/" + newTask.Id);
	    }));
	  };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 386 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('DiagnosticsLogsController', function($scope, busy, octopusRepository, pollLoop) {
	  var isLoading = $scope.isLoading = busy.create();
	  $scope.refresh = function() {
	    return isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
	      return isLoading.promise(octopusRepository.ServerStatus.getLogs(status).then(function (logs) {
	        $scope.logs = logs;
	      }));
	    }));
	  };
	
	  $scope.refresh();
	});
	
	
	
	
	
	


/***/ },
/* 387 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('DiagnosticsScheduledTaskController', function ($scope, $timeout, $state, octopusLog, busy, octopusRepository, $location, pollLoop, $q) {
	    var isLoading = $scope.isLoading = busy.create();
	
	    $scope.scheduledTaskName = $state.current.data.scheduledTaskName;
	    // $scope.diagnosticTab = $route.current.$$route.diagnosticTab;
	
	    $scope.rootNode = new Octopus.Model.LogTreeNode();
	    $scope.rootNode.isExpanded = true;
	    $scope.isVerbose = false;
	    $scope.isTail = true;
	
	    var rebuildTree = function rebuildTreeCallback(activityLog) {
	        if (!activityLog) {
	            return;
	        }
	        $scope.rootNode.refresh(activityLog);
	    };
	
	    $scope.toggleGap = function () {
	        $scope.isTail = false;
	        reload();
	    };
	
	    var reload = function () {
	        var taskDetailOptions = {
	            verbose: $scope.isVerbose
	        };
	        if ($scope.isTail) {
	            taskDetailOptions.tail = 20;
	        }
	
	        var all = [
	          isLoading.promise(octopusRepository.Scheduler.getDetails($scope.scheduledTaskName, taskDetailOptions))
	        ];
	
	        return $q.all(all).then(function (result) {
	            var details = result[0];
	            rebuildTree(details.ActivityLog);
	        });
	    };
	
	    $scope.showVerbose = function() {
	        $scope.isVerbose = true;
	        reload();
	    };
	    reload();
	});


/***/ },
/* 388 */
/***/ function(module, exports) {

	// http://stackoverflow.com/questions/11854514/is-it-possible-to-make-a-tree-view-with-angular
	
	var module = angular.module('octopusApp.configuration');
	
	module.directive("serverActivity", function($compile) {
	  return {
	    restrict: "E",
	    scope: {
	      activity: '='
	    },
	    templateUrl: 'areas/configuration/diagnostics/views/server_activity.html',
	    compile: function(el, attr) {
	      var contents = el.contents().remove();
	      var compiledContents;
	      return function(scope, _el, _attr) {
	        if(!compiledContents) {
	          compiledContents = $compile(contents);
	        }
	        compiledContents(scope, function(clone, scope) {
	          _el.append(clone);
	        });
	      };
	    }
	  };
	});
	


/***/ },
/* 389 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.directive('masterKeyClippy', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {},
	    templateUrl: 'areas/configuration/views/master_key_clippy.html',
	    controller: function($scope, $state, octopusRepository) {
	      octopusRepository.Backups.getConfiguration().then(function(backup){
	        $scope.backup = backup;
	      });
	
	      $scope.okayIveDoneThis = function() {
	        $scope.backup.IsMasterKeyBackedUp = true;
	        octopusRepository.Backups.updateConfiguration($scope.backup).then(function(backup){
	          $scope.backup = backup;
	          $state.reload();
	        });
	      };
	    }
	  };
	});
	
	


/***/ },
/* 390 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.factory('systemUserFactory', function() {
	    var systemUser = { 
	        Id: 'users-system', 
	        DisplayName: 'System', 
	        Username: 'system', 
	    };
	    return systemUser;
	});

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('FeaturesEditController', function($scope, $q, $location, busy, octopusRepository, unsavedChanges, $window) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.config = {
	        IsMultiTenancyEnabled: false,
	        IsDockerEnabled: false,
	        IsCommunityActionTemplatesEnabled: true
	    };
	
	    $scope.lastSync = 'Not run';
	    $scope.lastSyncTextClass = 'library-step-sync-default';
	    $scope.lastSyncFailed = false;
	    $scope.lastSyncTaskUrl = '';
	
	    function init() {
	        isLoading.promise(octopusRepository.FeaturesConfiguration.get().then(function (config) {
	            $scope.config = config;
	            $scope.IsCommunityActionTemplatesEnabledOnLoad = config.IsCommunityActionTemplatesEnabled;
	
	            var queries = [];
	
	            if ($scope.config.IsMultiTenancyEnabled) {
	                queries.push(octopusRepository.Tenants.all().then(function(tenants) {
	                    $scope.hasTenants = _.size(tenants) > 0;
	                }));
	            }
	
	            if ($scope.config.IsCommunityActionTemplatesEnabled) {
	                queries.push(octopusRepository.Tasks.filter({name: 'SyncCommunityActionTemplates', take: 1}).then(function(tasks) {
	                    if (_.size(tasks.Items) > 0) {
	                        var tasksByCompleted = _.sortBy(tasks.Items, 'CompletedTime');
	                        var task = _.last(tasksByCompleted);
	                        $scope.lastSync = task.CompletedTime;
	                        $scope.lastSyncTextClass = task.FinishedSuccessfully ? 'library-step-sync-success' : 'library-step-sync-failed';
	                        $scope.lastSyncFailed = !task.FinishedSuccessfully;
	                        $scope.lastSyncTaskUrl = '#/tasks/' + task.Id;
	                    }
	                }));
	            }
	
	            if (queries.length > 0) {
	                return $q.all(queries);
	            }
	        }));
	    }
	
	    $scope.save = function() {
	        isSaving.promise(octopusRepository.FeaturesConfiguration.modify($scope.config).then(function(config) {
	            $scope.config = config;
	            unsavedChanges.saved();
	            $window.location.reload();
	        }));
	    };
	
	    $scope.synchronizeLibrarySteps = function() {
	
	        var task = {
	            Name: 'SyncCommunityActionTemplates',
	            Description: 'Synchronize Community Step Templates'
	        };
	        $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
	            $location.path("/tasks/" + result.Id);
	        }));
	
	    };
	
	    init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 392 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('LicenseIndexController', function($scope, busy, octopusRepository, unsavedChanges, $window) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  $scope.license = null;
	  $scope.config = null;
	  
	  var loadingPromises = [];
	  loadingPromises.push(octopusRepository.Licenses.getCurrent().then(function(license) {
	      $scope.license = license;
	  }));
	  loadingPromises.push(octopusRepository.UpgradeConfiguration.get().then(function (config) {
	      $scope.config = config;
	  }));
	  isLoading.promises(loadingPromises).then(function() {
	      // Move along, nothing to see here.
	  });
	
	  $scope.save = function() {
	    var savingPromises = [];
	    savingPromises.push(octopusRepository.Licenses.save($scope.license).then(function(saved){ }));
	    savingPromises.push(octopusRepository.UpgradeConfiguration.modify($scope.config).then(function(saved){ }));
	    isSaving.promises(savingPromises).then(function() {
	        // Force a window reload as these config settings affect the top-menu area of the Octopus portal UI.
	        unsavedChanges.saved();
	        $window.location.reload();
	    });
	  };
	});


/***/ },
/* 393 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('MaintenanceEditController', function ($scope, $location, busy, octopusRepository, unsavedChanges, $window) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  $scope.status = { ready: false };
	
	  $scope.config = null;
	  isLoading.promise(octopusRepository.MaintenanceConfiguration.get().then(function (config) {
	    $scope.config = config;
	
	    setTimeout(function () {
	      $scope.$apply(function () {
	        $scope.status.ready = true;
	      });
	    }, 100);
	
	  }));
	
	  $scope.save = function() {
	    isSaving.promise(octopusRepository.MaintenanceConfiguration.modify($scope.config).then(function (config) {
	      unsavedChanges.saved();
	      $window.location.reload();
	    }));
	  };
	
	});

/***/ },
/* 394 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('ServerEditController', function($scope, $q, $location, busy, octopusRepository, unsavedChanges, $window) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.status = { 
	        ready: false 
	    };
	
	    $scope.saveServerConfiguration = function() {
	        isSaving.promise(octopusRepository.ServerConfiguration.modify($scope.config).then(function(config) {
	            $scope.config = config;
	            unsavedChanges.saved();
	        }));
	    };
	
	    function init() {
	        isLoading.promise(octopusRepository.ServerConfiguration.get().then(function (config) {
	            $scope.config = config;
	        }));
	
	        isLoading.promise(octopusRepository.ServerConfiguration.settings().then(function (configSettings) {
	            $scope.configSettings = configSettings;
	        }));
	    }
	
	    init();
	});

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.configuration');
	
	module.controller('NodesIndexController', function($scope, busy, octopusRepository, unsavedChanges, pollLoop, $window, $q) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	  
	  var loop = pollLoop.create($scope, function () { return refresh(); });
	  var hardRefreshAt = moment().add(5,'hours');
	
	  $scope.save = function(node) {
	    isSaving.promise(octopusRepository.OctopusServerNodes.modify(node).then(function (result) {
	      unsavedChanges.saved();
	    }));
	  };
	
	  var refresh = function() {
	    if (unsavedChanges.hasUnsavedChanges()) {
	      return $q(function(resolve) { resolve(); });
	    }
	    
	    if (moment() > hardRefreshAt) {
	      $window.location.reload();
	      loop.stop();
	      return $q.defer().promise; // Never resolved
	    }
	    
	    return isLoading.promise(octopusRepository.OctopusServerNodes.get().then(function(nodes) {
	      $scope.nodes = nodes;
	      if (!$scope.nodeTaskCount) {
	        $scope.nodeTaskCount = [];
	      }
	      _.each(nodes.Items, function (node) {
	        // Use the paging collection to figure out task TotalResults for each node (hence the take:1).
	        isLoading.promise(octopusRepository.Tasks.filter({ node: node.Id, running: true, take:1 }).then(function (response) {
	          $scope.nodeTaskCount[node.Id] = response.TotalResults;
	        }));
	      });
	    }));
	  };
	  
	  loop.startImmediately();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 396 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('ConfigurationIndexController', function($scope, busy, octopusRepository, octopusPermissionSet, $location) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.currentTab = 'teams';
	  $scope.checklist = [];
	
	  octopusPermissionSet.firstAuthorized(["AdministerSystem", "AuditView", "TeamView"]).then(function (p) {
	    switch (p) {
	      case "AdministerSystem":
	        load();
	        break;
	      case "AuditView":
	        $location.path('/configuration/audit');
	        break;
	      case "TeamView":
	        $location.path('/configuration/teams');
	    }
	  });
	
	  var load = function() {
	    isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status){
	      isLoading.promise(octopusRepository.Machines.list().then(function(machines){
	        isLoading.promise(octopusRepository.Feeds.list().then(function(feeds){
	          isLoading.promise(octopusRepository.Projects.list().then(function(projects){
	            isLoading.promise(octopusRepository.Users.list().then(function(users){
	              $scope.status = status;
	              $scope.checklist.push({ completed: machines.Items.length > 0, html: 'Create <a href="#/environments">environments and deployment targets</a>' });
	              $scope.checklist.push({ completed: feeds.Items.length > 0, html: 'Add <a href="#/library/feeds">NuGet feeds</a> containing application packages' });
	              $scope.checklist.push({ completed: projects.Items.length > 0, html: 'Create some <a href="#/projects">projects</a> to deploy' });
	              $scope.checklist.push({ completed: users.Items.length > 1, html: 'Invite some <a href="#/configuration/users">users</a>' });
	            }));
	          }));
	        }));
	      }));
	    }));
	  };
	});
	
	


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('UserRoleEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    var roleId = $stateParams["id"];
	
	    $scope.team = null;
	    $scope.availablePermissions = [];
	    $scope.title = null;
	
	    var buildAvailable = function(permissionDescriptions) {
	        $scope.availablePermissions = _.chain(permissionDescriptions).map(function (d, k) {
	            return {
	                id: k,
	                description: d.Description,
	                selected: $scope.role.GrantedPermissions.indexOf(k) >= 0
	            };
	        }).sortBy("id").value();
	    };
	
	    isLoading.promise(octopusRepository.PermissionDescriptions.all().then(function (permissionDescriptions) {
	        if (roleId) {
	            isLoading.promise(octopusRepository.UserRoles.get(roleId).then(function (result) {
	                $scope.role = result;
	                $scope.role.CanBeRenamed = result.CanbeDeleted;
	                pageTitle($scope.role.Name);
	                $scope.title = $scope.role.Name;
	                buildAvailable(permissionDescriptions);
	            }));
	        } else {
	            $scope.role = { Id: null, Name: '', CanBeRenamed: true, CanBeDeleted: false, GrantedPermissions: [] };
	            pageTitle("Create custom role");
	            $scope.title = "Create custom role";
	            buildAvailable(permissionDescriptions);
	        }
	    }));
	
	    $scope.save = function() {
	        $scope.role.GrantedPermissions = _.chain($scope.availablePermissions).filter(function (p) {
	            return p.selected;
	        }).map(function (p) {
	            return p.id;
	        }).value();
	
	        isSaving.promise(octopusRepository.UserRoles.save($scope.role).then(function (result) {
	            unsavedChanges.saved();
	            $location.path("/configuration/roles");
	        }));
	    };
	});
	
	
	
	
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 398 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('UserRoleIndexController', function($scope, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  isLoading.promise(octopusRepository.UserRoles.list().then(function (results) {
	    $scope.roles = results;
	  }));
	});
	
	


/***/ },
/* 399 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('SmtpEditController', function($scope, $location, $state, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  $scope.view = {};
	  $scope.view.hasExistingPassword = false;
	  $scope.view.showPasswordChange = false;
	
	  isLoading.promise(octopusRepository.SmtpConfiguration.get().then(function (smtp) {
	    $scope.smtp = smtp;
	    if (!smtp.SmtpLogin) {
	      $scope.view.showPasswordChange = true;
	    } else {
	      $scope.view.hasExistingPassword = true;
	    }
	  }));
	
	  $scope.save = function(sendTestEmail) {
	    isSaving.promise(octopusRepository.SmtpConfiguration.modify($scope.smtp).then(function (result) {
	      unsavedChanges.saved();
	      if (!sendTestEmail) {
	          $state.reload();
	        return;
	      }
	
	      octoDialog.prompt({
	        title: "Test email",
	        message: "Who would you like to send the test email to?",
	        answer: "test@test.com",
	        executeButtonText: "Send",
	        executeButtonClass: "btn-success",
	        execute: function(dialog) {
	          var task = {
	            Name: 'TestEmail',
	            Description: 'Send test email',
	            Arguments: { EmailAddress: dialog.answer }
	          };
	
	          dialog.busy.promise(octopusRepository.Tasks.create(task).then(function(result){
	            dialog.dismiss();
	            $location.path("/tasks/" + result.Id);
	          }));
	        }
	      });
	    }));
	  };
	});
	
	
	
	
	


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('TeamAddDomainGroupDialogController', function($scope, busy, $uibModalInstance, octopusRepository, lookupUri) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.results = null;
	  $scope.adding = { members: [] };
	
	  $scope.search = {
	    groupName: "",
	
	    hasSearched: false,
	
	    perform: function() {
	      isLoading.promise(octopusRepository.ExternalSecurityGroups.search(lookupUri, $scope.search.groupName).then(function (results) {
	        $scope.results = results;
	        $scope.hasSearched = true;
	      }));
	    }
	  };
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    $uibModalInstance.close(_.filter($scope.results, function (r) { return r.Selected; }));
	  };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 401 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('TeamAddExternalRoleDialogController', function($scope, busy, $uibModalInstance) {
	
	  $scope.role = {};
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    $uibModalInstance.close({ Id: $scope.role.id, DisplayName: $scope.role.displayName, DisplayIdAndName: true });
	  };
	});
	


/***/ },
/* 402 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('TeamAddMembersDialogController', function($scope, busy, $uibModalInstance, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.users = null;
	  $scope.adding = { members: [] };
	
	  isLoading.promise(octopusRepository.Users.all().then(function (users) {
	    $scope.users = users;
	  }));
	
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    $uibModalInstance.close($scope.adding.members);
	  };
	});
	


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('TeamEditController', function($scope, $q, $stateParams, $location, $uibModal, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    var teamId = $stateParams["id"];
	
	    var deletedThing = { Name: "(Deleted)" };
	    var usersById = {};
	    var rolesById = {};
	
	    function init() {
	        isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
	            $scope.environments = environments;
	        }));
	
	        isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
	            $scope.status = status;
	        }));
	
	        isLoading.promise(octopusRepository.Projects.all().then(function (projects) {
	            $scope.projects = projects;
	        }));
	        
	        isLoading.promise(octopusRepository.ProjectGroups.all().then(function (projectGroups) {
	            $scope.projectGroups = projectGroups;
	        }));
	
	        isLoading.promise(octopusRepository.ExternalSecurityGroupProviders.all().then(function (providers) {
	            $scope.externalGroupProviders = _.filter(providers, function (p) { return !p.IsRoleBased && p.SupportsGroupLookup; });
	            $scope.hasRoleBasedGroupProviders = _.any(providers, function (p) { return p.IsRoleBased; });
	        }));
	
	        //Remote once we support tags and AdvancedTenant selector can be used.
	        isLoading.promise((octopusRepository.Tenants ? octopusRepository.Tenants.all()  : $q.resolve([])).then(function (tenants) {
	            $scope.allTenants = tenants;
	        }));
	
	        isLoading.promise(octopusRepository.UserRoles.all().then(function (userRoles) {
	            isLoading.promise(octopusRepository.Users.all().then(function (users) {
	                _.each(users, function (u) {
	                    usersById[u.Id] = u;
	                });
	                _.each(userRoles, function (u) {
	                    rolesById[u.Id] = u;
	                });
	
	                if (teamId) {
	                    isLoading.promise(octopusRepository.Teams.get(teamId).then(function (result) {
	                        $scope.team = result;
	                        $scope.team.MemberUserIds = _.filter($scope.team.MemberUserIds, function (id) {
	                            return !!usersById[id];
	                        });
	                        $scope.team.UserRoleIds = _.filter($scope.team.UserRoleIds, function (id) {
	                            return !!rolesById[id];
	                        });
	                        pageTitle($scope.team.Name);
	
	                    }));
	                } else {
	                    $scope.team = {
	                        UserRoleIds: [],
	                        ProjectIds: [],
	                        TenantIds: [],
	                        EnvironmentIds: [],
	                        MemberUserIds: [],
	                        ExternalSecurityGroups: [],
	                        CanBeRenamed: true,
	                        CanChangeRoles: true,
	                        CanChangeMembers: true
	                    };
	                    pageTitle("Create team");
	                }
	
	                $scope.getRole = function (userRoleId) {
	                    return rolesById[userRoleId] || deletedThing;
	                };
	                $scope.getUser = function (userId) {
	                    return usersById[userId] || deletedThing;
	                };
	                $scope.removeMember = function (userId) {
	                    $scope.team.MemberUserIds.splice($scope.team.MemberUserIds.indexOf(userId), 1);
	                    unsavedChanges.unsaved();
	                };
	                $scope.removeExternalGroup = function (group) {
	                    $scope.team.ExternalSecurityGroups.splice($scope.team.ExternalSecurityGroups.indexOf(group), 1);
	                    unsavedChanges.unsaved();
	                };
	                $scope.removeRole = function (userRoleId) {
	                    $scope.team.UserRoleIds.splice($scope.team.UserRoleIds.indexOf(userRoleId), 1);
	                    unsavedChanges.unsaved();
	                };
	                $scope.deleteTeam = function () {
	                    var dlg = octoDialog.confirmDelete('team', function () {
	                        return octopusRepository.Teams.del($scope.team);
	                    });
	                    dlg.then(function (result) {
	                        if (result) {
	                            unsavedChanges.saved();
	                            $location.path("/configuration/teams");
	                        }
	                    });
	                };
	            }));
	        }));
	    }
	
	    var openRoleEditor = function(callback){
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/configuration/teams/views/edit_role_dialog.html',
	            controller: 'TeamEditRoleDialogController'
	        }).result.then(function(result) {
	            if (result) {
	                callback(result);
	            }
	        });
	    };
	
	    $scope.addRole = function(){
	        openRoleEditor(function(result) {
	            if (_.contains($scope.team.UserRoleIds, result)) {
	                return;
	            }
	            unsavedChanges.unsaved();
	            $scope.team.UserRoleIds.push(result);
	        });
	    };
	
	    $scope.addMembers = function(){
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/configuration/teams/views/add_members_dialog.html',
	            controller: 'TeamAddMembersDialogController'
	        }).result.then(function(result) {
	            if (result) {
	                unsavedChanges.unsaved();
	                _.each(result, function(member){
	                    if (!_.contains($scope.team.MemberUserIds, member)) {
	                        $scope.team.MemberUserIds.push(member);
	                    }
	                });
	            }
	        });
	    };
	
	    $scope.addExternalGroup = function(lookupUri){
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/configuration/teams/views/add_domain_group_dialog.html',
	            controller: 'TeamAddDomainGroupDialogController',
	            resolve: { lookupUri: function () { return lookupUri; } }
	        }).result.then(function(result) {
	            if (result) {
	                unsavedChanges.unsaved();
	                _.each(result, function(member){
	                    $scope.team.ExternalSecurityGroups.push(member);
	                });
	            }
	        });
	    };
	
	    $scope.addExternalRole = function(){
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/configuration/teams/views/add_external_role_dialog.html',
	            controller: 'TeamAddExternalRoleDialogController'
	        }).result.then(function(result) {
	            if (result) {
	                unsavedChanges.unsaved();
	                $scope.team.ExternalSecurityGroups.push(result);
	            }
	        });
	    };
	
	    $scope.save = function() {
	        isSaving.promise(octopusRepository.Teams.save($scope.team).then(function (result) {
	            unsavedChanges.saved();
	            $location.path("/configuration/teams");
	        }));
	    };
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('TeamEditRoleDialogController', function($scope, busy, $uibModalInstance, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  isLoading.promise(octopusRepository.UserRoles.all().then(function (userRoles) {
	    $scope.roleParticipation = { userRoleId: null };
	    $scope.userRoles = userRoles;
	  }));
	
	  $scope.getRole = function() {
	    return _.find($scope.userRoles, function (a) {
	      return a.Id === $scope.roleParticipation.userRoleId;
	    });
	  };
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    if ($scope.roleParticipation.userRoleId) {
	      $uibModalInstance.close($scope.roleParticipation.userRoleId);
	    }
	  };
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 405 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('TeamIndexController', function($scope, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  isLoading.promise(octopusRepository.Teams.list().then(function (results) {
	    $scope.teams = results;
	  }));
	  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
	    $scope.status = status;
	  }));
	});
	
	


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('TeamTestController', function($scope, busy, $q, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.filter = {
	    selectedUser: ""
	  };
	
	  var promises = $q.all([
	    octopusRepository.Users.all(),
	    octopusRepository.Projects.all(),
	    octopusRepository.Environments.all(),
	    octopusRepository.PermissionDescriptions.all(),
	    octopusRepository.Tenants ? octopusRepository.Tenants.all() : $q.resolve([]),
	    octopusRepository.ProjectGroups.all()
	
	  ]);
	
	  isLoading.promise(promises.then(function (results) {
	    $scope.users = results[0];
	    $scope.projects = _.indexBy(results[1], "Id");
	    $scope.environments = _.indexBy(results[2], "Id");
	    $scope.permissionInfo = results[3];
	    $scope.tenants = _.indexBy(results[4], "Id");
	    $scope.projectGroups = _.indexBy(results[5], "Id");
	  }));
	
	  $scope.test = function() {
	    var user = _.find($scope.users, function (u) { return u.Id === $scope.filter.selectedUser.Id; });
	    $scope.user = user;
	
	    isLoading.promise(octopusRepository.Users.getPermissions(user).then(function (results) {
	      $scope.exportUrl = octopusRepository.resolve(results.Links["Export"]);
	      $scope.teams = results.Teams;
	      $scope.permissions = [];
	
	      var grantedPermissions = _.chain(results.Permissions).map(function (a,b) { return { perms: a, name: b }; }).indexBy("name").value();
	      _.each($scope.permissionInfo, function(p, k) {
	        if (grantedPermissions[k]) {
	          _.each(grantedPermissions[k].perms, function (perm) {
	            $scope.permissions.push({ name: k, perms: perm, info: p });
	          });
	        }
	      });
	
	      $scope.permissions = _.sortBy($scope.permissions, "name");
	
	      var prev = "";
	      _.each($scope.permissions, function (p) {
	        if (prev === p.name) {
	          p.sameAsPrevious = true;
	        } else {
	          p.sameAsPrevious = false;
	        }
	        prev = p.name;
	      });
	    }));
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 407 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('CreateApiKeyDialogController', function ($scope, busy, octopusRepository, user, $uibModalInstance) {
	  var isWorking = $scope.isWorking = busy.create();
	  $scope.user = user;
	  $scope.createParams = { purpose: '' };
	
	  $scope.close = function() {
	    $uibModalInstance.close(true);
	  };
	
	  $scope.cancel = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.execute = function() {
	    isWorking.promise(octopusRepository.Users.createApiKey($scope.user, $scope.createParams.purpose).then(function(apiKey) {
	      $scope.apiKey = apiKey;
	    }));
	  };
	});
	
	


/***/ },
/* 408 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('UserEditController', function($scope, $location, $stateParams, octoDialog, busy, octopusRepository, octopusClient) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	  var userId = $stateParams["id"];
	
	  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
	    $scope.status = status;
	
	    if (userId) {
	      isLoading.promise(octopusRepository.Users.get(userId).then(function(user){
	        $scope.user = user;
	        $scope.view = { showPasswordChange: false };
	      }));
	    } else {
	      var root = octopusClient.rootDocument();
	      $scope.user = { IsActive: true };
	      $scope.view = { showPasswordChange: true };
	    }
	  }));
	
	  $scope.save = function() {
	    if ($scope.user.IsActive && $scope.view.showPasswordChange && !$scope.user.IsService) {
	      if ($scope.user.Password !== $scope.view.confirmNewPassword) {
	        isSaving.showError('The passwords do not match');
	        return;
	      }
	    } else {
	      $scope.user.Password = null;
	    }
	    isSaving.promise(octopusRepository.Users.save($scope.user).then(function() {
	      $location.path('/configuration/users');
	    }));
	  };
	
	});


/***/ },
/* 409 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.controller('UsersIndexController', function($scope, busy, octopusRepository, octopusClient) {
	  var isLoading = $scope.isLoading = busy.create();
	  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
	    isLoading.promise(octopusRepository.Users.list().then(function (users) {
	      $scope.users = users;
	      $scope.status = status;
	
	      var root = octopusClient.rootDocument();
	      $scope.canInviteUsers = root.AnyAuthenticationProvidersSupportPasswordManagement;
	    }));
	  }));
	});
	
	


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.configuration');
	
	module.controller('UsersInviteController', function($scope, busy, octopusRepository, octopusClient) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isGenerating = $scope.isGenerating = busy.create();
	
	  $scope.invitation = { quantity: 1, teams: [] };
	
	  isLoading.promise(octopusRepository.Teams.all().then(function(teams){
	    $scope.teams = _.filter(teams, function(t) { return t.Id !== "teams-everyone"; });
	
	  }));
	
	  $scope.generateInvitations = function() {
	    if ($scope.invitation.quantity <= 0) {
	      isGenerating.showError('At least one invitation must be created');
	      return;
	    }
	
	    $scope.invitations = [];
	    var push = function(invitation) {
	      $scope.invitations.push(invitation);
	    };
	
	    // Need to add a bulk API
	    var countRemaining = $scope.invitation.quantity;
	    var all = [];
	    while (countRemaining > 0) {
	      countRemaining--;
	      var teamIds = $scope.invitation.teams.map(function(team){return team.Id;});
	      all.push(octopusRepository.Users.invite(teamIds).then(push));
	    }
	    isGenerating.promises(all);
	  };
	
	  $scope.resolveLink = function(link) {
	    return octopusClient.resolve(link);
	  };
	
	  $scope.more = function() {
	    $scope.invitations = [];
	  };
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 411 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.directive('private', function() {
	  return {
	    restrict: 'E',
	    transclude: true,
	    replace: true,
	    template: '<div><button type="button" class="btn btn-link" ng-show="isPrivate" ng-click="show()">Show &raquo;</button><div class="transcluded" ng-hide="isPrivate" ng-transclude></div></div>',
	    scope: { },
	    link: function (scope, element, attrs) {
	      scope.isPrivate = true;
	      scope.show = function() {
	        scope.isPrivate = false;
	      };
	    }
	  };
	});
	
	
	


/***/ },
/* 412 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.configuration');
	
	module.directive('userApiKeys', function(){
	  return {
	    restrict: 'E',
	    templateUrl: 'areas/configuration/users/views/user_api_keys.html',
	    controller: function($scope, busy, octopusRepository, $uibModal, octoDialog) {
	
	      var loaded = false;
	      $scope.$watch('user', function(nv, ov){
	        if (loaded || !nv) {
	          return;
	        }
	        loaded = true;
	        load();
	      });
	
	      var load = function() {
	        var isLoading = $scope.isLoading = busy.create();
	        isLoading.promise(octopusRepository.Users.listApiKeys($scope.user).then(function(apiKeys){
	          $scope.userApiKeys = apiKeys;
	
	          $scope.newApiKey = function() {
	            $uibModal.open({
	              backdrop: 'static',
	              keyboard: true,
	              templateUrl: 'areas/configuration/users/views/create_api_key.html',
	              controller: 'CreateApiKeyDialogController',
	              dialogClass: 'modal',
	              resolve: {
	                user: function() { return $scope.user; }
	              }
	            }).result.then(function(result){
	              if (result) {
	                load();
	              }
	            });
	          };
	
	          $scope.revoke = function(apiKey){
	            var dlg = octoDialog.confirmDelete('API key', function() {
	              return octopusRepository.Users.revokeApiKey(apiKey);
	            });
	            dlg.then(function(result) {
	              if (result) {
	                load();
	              }
	            });
	          };
	        }));
	      };
	    }
	  };
	});
	
	


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.dashboard');
	
	module.controller('DashboardConfigureController', function ($scope, $timeout, busy, octopusRepository, $location){
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  $scope.radios = {};
	  $scope.selectedTenants = [];
	  $scope.selectedTags = [];
	
	  isLoading.promise(octopusRepository.DashboardConfiguration.get().then(function (configuration) {
	    isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
	      isLoading.promise(octopusRepository.Projects.all().then(function (projects) {
	        isLoading.promise(octopusRepository.ProjectGroups.all().then(function (projectGroups) {
	          var projectGroupNamesById = {};
	          _.each(projectGroups, function (projectGroup) { projectGroupNamesById[projectGroup.Id] = projectGroup.Name; });
	
	          $scope.projects = _.map(projects, function (proj) { return { Id: proj.Id, Sort: proj.Name, Group: projectGroupNamesById[proj.ProjectGroupId], Name: proj.Name }; });
	          $scope.environments = _.map(environments, function (env) { return { Id: env.Id, Group: "", Sort: env.SortOrder, Name: env.Name }; });
	          $scope.configuration = configuration;
	
	          $scope.radios.isAllProjects = configuration.IncludedProjectIds.length === 0 ? "true" : "false";
	          $scope.radios.isAllEnvironments = configuration.IncludedEnvironmentIds.length === 0 ? "true" : "false";
	        }));
	      }));
	    }));
	  }));
	
	  $scope.save = function() {
	    if ($scope.radios.isAllProjects === "true") {
	      $scope.configuration.IncludedProjectIds = [];
	    }
	    if ($scope.radios.isAllEnvironments === "true") {
	      $scope.configuration.IncludedEnvironmentIds = [];
	    }
	
	    isSaving.promise(octopusRepository.DashboardConfiguration.modify($scope.configuration).then(function (config) {
	      $location.path("/");
	    }));
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.dashboard');
	
	module.controller('DashboardController', function ($scope, $timeout, busy, pollLoop, octopusRepository, $window, $q){
	  var isLoading = $scope.isLoading = busy.create();
	
	  var loop = pollLoop.create($scope, function () { return refresh(); });
	  var hardRefreshAt = moment().add(5, 'hours');
	  $scope.projectLimit = 50;
	  $scope.defaultProjectLimit = 50;
	  $scope.dashboardLoaded = false;
	
	  $scope.$watch('projectFilter', function() { applyFilterAndLimit(); });
	  $scope.$watch('groupFilter', function() { applyFilterAndLimit(); });
	
	  var refresh = function() {
	    if (moment() > hardRefreshAt) {
	      $window.location.reload();
	      loop.stop();
	      return $q.defer().promise; // Never resolved
	    }
	    return isLoading.promise(octopusRepository.Dashboards.getDashboard().then(function(dashboardData) {
	      $scope.fullDashboardData = dashboardData;
	      $scope.projectCount = $scope.fullDashboardData.Projects.length;
	      $scope.projectLimit = $scope.fullDashboardData.ProjectLimit ? $scope.fullDashboardData.ProjectLimit : $scope.defaultProjectLimit;
	      applyFilterAndLimit();
	      $scope.projectGroups = _.sortBy($scope.fullDashboardData.ProjectGroups, function(group) {
	        return group.Name;
	      });
	      $scope.dashboardLoaded = true;
	    }));
	  };
	
	  var applyFilterAndLimit = function()
	  {
	    if(!$scope.fullDashboardData) {
	      return;
	    }
	
	    var data = _.clone($scope.fullDashboardData);
	
	    var isOverLimit = function(d) { return d.Projects.length > $scope.projectLimit; };
	    $scope.useFilter = isOverLimit(data);
	
	    if(isOverLimit(data)) {
	      applyFilter(data);
	
	      if (isOverLimit(data)) {
	        limitProjects(data);
	      }
	
	      removeGroupsWithoutProjects(data);
	    }
	
	    $scope.dashboardData = data;
	  };
	
	  var applyFilter = function(data) {
	    if($scope.projectFilter)
	    {
	      data.Projects = data.Projects.filter(function(p) { return p.Name.toLocaleUpperCase().indexOf($scope.projectFilter.toLocaleUpperCase()) > -1; });
	    }
	    if($scope.groupFilter)
	    {
	      data.Projects = data.Projects.filter(function(p) { return p.ProjectGroupId === $scope.groupFilter; });
	    }
	
	    $scope.matchCount = data.Projects.length;
	  };
	
	  var limitProjects = function(data) {
	    $scope.limited = true;
	    var included = _.take(data.Projects, $scope.projectLimit);
	
	    var erroredOrRunning = data.Items.filter(function(p) { return p.HasWarningsOrErrors || !p.IsCompleted; });
	
	    var keep = _.chain(data.Projects)
	      .rest($scope.projectLimit)
	      .filter(function(p) {
	        return _.any(erroredOrRunning, function(e) { return (e.ProjectId === p.Id); });
	      })
	      .value();
	
	    data.Projects = included.concat(keep);
	  };
	
	  var removeGroupsWithoutProjects = function(data) {
	    var groupIds = data.Projects.map(function(p) { return p.ProjectGroupId; });
	    data.ProjectGroups = _.filter(data.ProjectGroups, function(g) { return _.contains(groupIds, g.Id); });
	  };
	
	  loop.startImmediately();
	});
	
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var module = angular.module('octopusApp.dashboard');
	var unTenantedDeploymentLogo = __webpack_require__(1274);
	var tenantNotConnected = __webpack_require__(1273);
	
	module.directive('fastboard', function (octoUtil, taskStatusRenderer, octopusClient) {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            dashboardData: '=',
	            dashboardType: '=',
	            project: '=',
	            release: '=',
	            isTenantFiltered: '='
	        },
	        link: function (scope, element) {
	            var previousHeadings = "";
	
	            function fullRenderRequired(dashboardData) {
	                var headings = angular.toJson({ a: dashboardData.Projects, b: dashboardData.Environments, c: dashboardData.ProjectGroups, d: dashboardData.Tenants, e: dashboardData.TenantPromotions, f: dashboardData.Groups });
	                var required = headings !== previousHeadings;
	                previousHeadings = headings;
	                return required;
	            }
	
	            function nodeKey(envId, projId) { return [envId, "__", projId].join(''); }
	
	            function sliceByProjectGroup(data) {
	                var slices = {};
	                _.each(data.ProjectGroups, function (projectGroup) {
	                    var list = [];
	                    if (projectGroup.EnvironmentIds.length === 0) {
	                        list = data.Environments;
	                    } else {
	                        list = _.filter(data.Environments, function(env) {
	                            return _.find(projectGroup.EnvironmentIds, function(id) {
	                                return id === env.Id;
	                            });
	                        });
	                    }
	
	                    slices[projectGroup.Id] = {
	                        environments: list,
	                        projects: [],
	                        projectIds: {}
	                    };
	                });
	
	                _.each(data.Projects, function(project) {
	                    slices[project.ProjectGroupId].projects.push(project);
	                    slices[project.ProjectGroupId].projectIds[project.Id] = project;
	                });
	
	                return slices;
	            }
	
	            function getItemsForSlice(items, slice) {
	                var itemDictionary = {};
	
	                _.each(items, function(item) {
	                    if (slice.projectIds[item.ProjectId]) {
	                        var itemKey = nodeKey(item.EnvironmentId, item.ProjectId);
	                        if (!itemDictionary[itemKey]) {
	                            itemDictionary[itemKey] = [];
	                        }
	                        itemDictionary[itemKey].push(item);
	                    }
	                });
	
	                return itemDictionary;
	            }
	
	            function getItemsForTenants(items, tenants) {
	                var itemDictionary = {};
	
	                _.each(items, function(item) {
	                    if (item.TenantId === null || _.findIndex(tenants, function (tenant) { return tenant.Id === item.TenantId; }) !== -1) {
	                        var itemKey = nodeKey(item.EnvironmentId, item.TenantId);
	                        if (!itemDictionary[itemKey]) {
	                            itemDictionary[itemKey] = [];
	                        }
	                        itemDictionary[itemKey].push(item);
	                    }
	                });
	
	                return itemDictionary;
	            }
	
	
	            function getProjectEnvironmentTenantIndex(projects, environments, tenants) {
	                var environmentIds = environments.map(function(e) { return e.Id; });
	
	                var idx = {};
	                projects.forEach(function(project) {
	                    tenants.forEach(function(tenant) {
	                        (tenant.ProjectEnvironments[project.Id] || []).forEach(function(envId){
	                            if (environmentIds.indexOf(envId) === -1) {
	                                return;
	                            }
	                            var key = nodeKey(envId, project.Id);
	                            idx[key] = (idx[key] || []);
	                            idx[key].push(tenant.Id);
	                        }); });
	                });
	                return idx;
	            }
	
	            function getEnvironmentTenantIndex(project, environments, tenants) {
	                var environmentIds = environments.map(function(e) { return e.Id; });
	
	                var idx = {};
	                tenants.forEach(function(tenant) {
	                    (tenant.ProjectEnvironments[project.Id] || []).forEach(function(envId){
	                        if (environmentIds.indexOf(envId) === -1) {
	                            return;
	                        }
	                        var key = nodeKey(envId, tenant.Id);
	                        idx[key] = (idx[key] || []);
	                        idx[key].push(tenant.Id);
	                    }); 
	                });
	                return idx;
	            }
	
	            function bindPopovers(domElements) {
	                domElements.each(function () {
	                    var domElement = $(this);
	                    domElement.popover({
	                        content: domElement.data("tip"),
	                        trigger: 'hover',
	                        placement: "bottom",
	                        container: '#dynamicallyGeneratedContent'
	                    });
	                });
	            }
	
	            var matrices = [];
	            var fullRender = function(data) {
	                matrices = [];
	                element.empty();
	                switch (scope.dashboardType) {
	                    case 'project':
	                        renderProjectDashboard(data);
	                        break;
	                    default: 
	                        renderDashboard(data);
	                        break;
	                }
	
	                bindPopovers($('.tenant-status'), element);
	            };
	
	            function getTenantList(data, group, canPerformUntenantedDeployments, hasUntenantedDeployments){
	                var tenants = data.Tenants;
	
	                var untenantedProjectEnvironments = {};
	                untenantedProjectEnvironments[scope.project.Id] = data.Environments.map(function (env) { return env.Id; });
	                var untenantedObject = {
	                    Id: '',
	                    Name: 'Un-tenanted',
	                    ProjectEnvironments: untenantedProjectEnvironments
	                };
	
	                if (group.CanonicalTagName) {
	                    tenants = _.filter(tenants, function (tenant) {
	                        return tenant.TenantTags.indexOf(group.CanonicalTagName) !== -1;
	                    });
	                } else if (group.IsGrouped) {
	                    tenants = _.union((hasUntenantedDeployments ? [untenantedObject] : []), _.filter(tenants, function (tenant) { return tenant.TenantTags.length === 0; }));
	                } else {
	                    if (hasUntenantedDeployments || (canPerformUntenantedDeployments && !scope.isTenantFiltered)) {
	                        tenants = _.union([untenantedObject], tenants);
	                    }
	                }
	
	                return tenants;
	            }
	
	            var renderProjectDashboard = function (data) {
	                if (!data.Items) {
	                    return;
	                }
	                var canPerformUntenantedDeployments = data.Projects[0].CanPerformUntenantedDeployment;
	                var hasUntenantedDeployments = _.filter(data.Items, function (item) {
	                    return item.TenantId === null;
	                }).length > 0;
	
	                _.each((data.Groups || [{Name: 'Tenant'}]), function (group) {
	                    var tenants = getTenantList(data, group, canPerformUntenantedDeployments, hasUntenantedDeployments);
	                    if (tenants.length > 0) {
	                        var groupItems = getItemsForTenants(data.Items, tenants);
	                        var environmentTenantIndex = getEnvironmentTenantIndex(scope.project, data.Environments, tenants);
	
	                        var undeployedTenantsInEnvironment = {};
	                        _.each(data.Environments, function (environment) {
	                            undeployedTenantsInEnvironment[environment.Id] = [];
	                            if (_.filter(data.PromoteTo, function (promote) { return promote.Id === environment.Id; }).length > 0) {
	                                _.each(tenants, function (tenant) {
	                                    var key = nodeKey(environment.Id, tenant.Id);
	                                    if (environmentTenantIndex[key]) {
	                                        if (!groupItems[key]) {
	                                            undeployedTenantsInEnvironment[environment.Id].push(tenant.Id);
	                                        }
	                                    }
	                                });
	                            }
	                        });
	
	                        var matrixElement = $("<div></div>");
	                        element.append(matrixElement);
	
	                        var matrix = new Octopus.ReleaseMatrix(matrixElement, taskStatusRenderer, octoUtil);
	                        matrix.environments = data.Environments;
	                        matrix.rows = tenants || data.Tenants;
	                        matrix.heading = group.Name;
	                        matrix.items = groupItems;
	                        matrix.promotions = data.TenantPromotions;
	                        matrix.promoteTo = data.PromoteTo;
	                        matrix.environmentTenantIndex = environmentTenantIndex;
	                        matrix.keyFromPair = function (env, tenant) { return nodeKey(env.Id, tenant.Id); };
	                        matrix.renderGroupDeployButton = function (env, html) {
	                            if (scope.release && group.CanonicalTagName && undeployedTenantsInEnvironment[env.Id].length > 0) {
	                                var tagsQueryString = '';
	                                if (data.SelectedTags) {
	                                    tagsQueryString = '&tags=' + data.SelectedTags.join('&tags=');
	                                }
	                                var tenantsQueryString = '';
	                                if (data.SelectedTenants) {
	                                    tenantsQueryString = '&tenantIds=' + data.SelectedTenants.join('&tenantIds=');
	                                }
	                                html.push('<div class=""><a class="btn btn-xs" href="#/projects/' + scope.project.Slug + '/releases/' + scope.release.Version + '/deployments/create/to/' + env.Id + '?tags=' + group.CanonicalTagName + tagsQueryString + tenantsQueryString + '">Deploy to all</a></div>');
	                            }
	                        };
	                        matrix.renderEmptyCell = function (key, html, promotion, tenant, environment) {
	                            if (promotion) {
	                                if (promotion.tenantId) {
	                                    html.push('<div class="deploy-buttons"><a class="btn" href="#/projects/' + scope.project.Slug + '/releases/' + scope.release.Version + '/deployments/create/to/' + promotion.environment.Id + '?tenantIds=' + promotion.tenantId + '">Deploy</a></div>');
	                                } else {
	                                    html.push('<div class="deploy-buttons"><a class="btn" href="#/projects/' + scope.project.Slug + '/releases/' + scope.release.Version + '/deployments/create/to/' + promotion.Id + '">Deploy</a></div>');
	                                }
	                            } else {
	                                var helpText = '';
	                                if (!matrix.environmentTenantIndex[key]) {
	                                    helpText = tenant.Name + ' is not connected to the ' + environment.Name + ' environment for this project';
	                                    html.push('<div class="media"><div class="media-right media-middle"><span class="tenant-status" data-tip="' + helpText + '"><img class="media-object" style="width: 37px;opacity: 0.05" src="' + tenantNotConnected + '" /></span></div></div>');
	                                } else if (!scope.release) {
	                                    html.push('<div class="deploy-buttons" style="display: inline-block">');
	                                    html.push('    <div class="tenant-status" data-tip="Please select a release from the dropdown above to enable deployment">');
	                                    html.push('        <button class="btn disabled">Deploy</button>');
	                                    html.push('    </div>');
	                                    html.push('</div>');
	                                } else {
	                                    helpText = 'Release ' + scope.release.Version + ' can not be deployed to the ' + environment.Name + ' environment';
	                                    html.push('<div class="media"><div class="media-right media-middle"><span class="tenant-status" data-tip="' + helpText + '"><img class="media-object" style="width: 37px;opacity: 0.05" src="' + tenantNotConnected + '" /></span></div></div>');
	                                }
	                            }
	                        };
	                        matrix.renderRowHeading = function (tenant, html) {
	                            html.push('<div class="media">');
	                            if (!tenant.Id) {
	                                html.push('<div class="media-left media-middle"><img class="media-object" style="opacity: 0.1" src="' + unTenantedDeploymentLogo + '" /></div><div class="media-body media-middle">Un-tenanted</div>');
	                            } else {
	                                html.push('<div class="media-left media-middle"><a href="#/tenants/' + tenant.Id + '"><img class="media-object" src="' + octopusClient.resolve(tenant.Links['Logo']) + '" /></a></div><div class="media-body media-middle"><a href="#/tenants/' + tenant.Id + '">' + octoUtil.escapeHtml(tenant.Name) + '</a></div>');
	                                if (tenant.isMissingVariable()) {
	                                    html.push('<div class="media-right media-middle tenant-status" data-tip="Some of the required variable values have not been set."><a href="#/tenants/' + tenant.Id + '/variables/"><span class="text-warning"><i class="fa fa-warning "></i></span></a></div>');
	                                }
	                            }
	                            html.push('</div>');
	                        };
	
	                        matrix.render();
	                        matrices.push(matrix);
	                    }
	                });
	            };
	
	            var renderDashboard = function (data) {
	                var projectGroups = _.sortBy(data.ProjectGroups, function (pg) { return pg.Name.toLowerCase(); });
	                var slices = sliceByProjectGroup(data);
	                var projectEnvironmentTenantIndex = getProjectEnvironmentTenantIndex(data.Projects, data.Environments, data.Tenants);
	
	                _.each(projectGroups, function (projectGroup) {
	                    var slice = slices[projectGroup.Id];
	
	                    var matrixElement = $("<div></div>");
	                    element.append(matrixElement);
	
	                    var matrix = new Octopus.ReleaseMatrix(matrixElement, taskStatusRenderer, octoUtil);
	                    matrix.environments = slice.environments;
	                    matrix.rows = slice.projects;
	                    matrix.heading = projectGroup.Name;
	                    matrix.items = getItemsForSlice(data.Items, slice);
	                    matrix.projectEnvironmentTenantIndex = projectEnvironmentTenantIndex;
	                    matrix.slice = slice;
	                    matrix.keyFromPair = function (env, project) { return nodeKey(env.Id, project.Id); };
	                    matrix.renderRowHeading = function (project, html) {
	                        html.push('<div class="media"><div class="media-left media-middle"><a href="#/projects/' + project.Slug + '"><img class="media-object" src="' + octopusClient.resolve(project.Links['Logo']) + '" /></a></div><div class="media-body media-middle"><a href="#/projects/' + project.Slug + '">' + octoUtil.escapeHtml(project.Name) + '</a></div></div>');
	                    };
	
	                    matrix.render();
	                    matrices.push(matrix);
	                });
	            };
	
	            var partialRender = function(data) {
	                _.each(matrices, function (matrix) {
	                    if (matrix.slice) {
	                        matrix.items = getItemsForSlice(data.Items, matrix.slice);
	                    } else {
	                        matrix.items = getItemsForTenants(data.Items, data.Tenants);
	                        matrix.promoteTo = data.PromoteTo;
	                    }
	                    matrix.update();
	                });
	            };
	
	            scope.$watch("dashboardData", function (data) {
	                if (!data) {
	                    return;
	                }
	
	                if (fullRenderRequired(data)) {
	                    fullRender(data);
	                } else {
	                    partialRender(data);
	                }
	            });
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var moment = __webpack_require__(3);
	var _ = __webpack_require__(1);
	
	Octopus.ReleaseMatrix = function ReleaseMatrix(element, taskStatusRenderer, octoUtil) {
	    // Draws the release matrix table used on either the dashboard, or project overview.
	    // Usage:
	    //
	    //    var matrix = new ReleaseMatrix(element, taskStatusRenderer, octoUtil);
	    //    // configure properties (see below)
	    //
	
	    var matrix = this;
	    matrix.rows = [];                       // Array of whatever will be rows of data (projects for the dashboard, releases for project overview)
	    matrix.environments = [];               // Array of Octopus Environment resources
	    matrix.heading = "";                    // Heading to show in the top left corner
	    matrix.items = {};                      // Dictionary of items to show
	    matrix.keyFromPair = function () {};    // Function that takes a column and row, and returns a unique string key from it
	    matrix.environmentsById = {};
	    matrix.promotions = {};
	    matrix.previousDeployments = {};
	    matrix.projectEnvironmentTenantIndex = {};
	    matrix.environmentTenantIndex = {};
	    matrix.promoteTo = [];
	
	    matrix.renderEmptyRow = function (html) { };
	    matrix.renderEmptyCell = function(key, html) { };
	    matrix.renderGroupDeployButton = function (env, html) { };
	
	    var previousItems = {};
	
	    matrix.render = function() {
	        if (hasGreaterThanTenEnvironments()) {
	            applySparseboard();
	        }
	        fullRender();
	        previousItems = matrix.items;
	    };
	
	    matrix.update = function() {
	        if (hasGreaterThanTenEnvironments()) {
	            applySparseboard();
	        }
	        partialRender();
	        previousItems = matrix.items;
	    };
	
	    var fullRender = function() {
	        element.html(renderTable());
	        taskStatusRenderer.bindPopovers($(".status", element));
	        $("#dynamicallyGeneratedContent").empty();
	    };
	
	    var hasGreaterThanTenEnvironments = function() {
	
	        var hasGreaterThanTenEnvironments = matrix.environments.length > 10;
	        return hasGreaterThanTenEnvironments;
	
	    };
	
	    var applySparseboard = function() {
	
	        var keys = _.keys(matrix.items);
	
	        // Filter Environments
	        matrix.environments = _.filter(matrix.environments, function (env) {
	
	            var hasDeploymentInEnv = _.some(keys, function (key) {
	                return key.indexOf(env.Id + "__") >= 0;
	            });
	
	            return hasDeploymentInEnv;
	        });
	    };
	
	    var renderTable = function() {
	        var html = [];
	        html.push('<div class="margin-bottom-30">');
	        html.push(  '<div class="matrix-container ">');
	        html.push(    '<div class="overflow-scroll">');
	        html.push(      '<table class="matrix">');
	        renderHeadings(html);
	        html.push(        '<tbody>');
	        renderRows(html);
	        html.push(        '</tbody>');
	        html.push(      '</table>');
	        html.push(    '</div>');
	        html.push(  '</div>');
	        html.push('</div>');
	        return html.join('');
	    };
	
	    var renderHeadings = function(html) {
	        html.push('<thead>');
	        html.push(  '<tr>');
	        html.push(    '<th>');
	        html.push(      octoUtil.escapeHtml(matrix.heading));
	        html.push(    '</th>');
	        _.each(matrix.environments, function (env) {
	            html.push('<th>');
	            html.push(  '<a href="#/environments">');
	            html.push(    octoUtil.escapeHtml(env.Name));
	            html.push(  '</a>');
	            matrix.renderGroupDeployButton(env, html);
	            html.push('</th>');
	        });
	        html.push(    '<th style="width: auto"></th>');
	        html.push(  '</tr>');
	        html.push('</thead>');
	    };
	
	    var getPromotion = function (key, envId) {
	        if (matrix.promotions) {
	            var promotion = matrix.promotions[key];
	            if (promotion) {
	                return promotion;
	            }
	        }
	    };
	
	    var renderRows = function(html) {
	        var rows = matrix.rows;
	        if (!rows || rows.length === 0) {
	            matrix.renderEmptyRow(html);
	        }
	
	        _.each(rows, function (row) {
	            html.push('<tr>');
	            html.push(  '<th class="relative">');
	            matrix.renderRowHeading(row, html);
	            html.push(  '</th>');
	            _.each(matrix.environments, function(col) {
	                var key = matrix.keyFromPair(col, row);
	                html.push('<td id="');
	                html.push(key);
	                html.push('"');
	                html.push('>');
	
	                var items = matrix.items[key];
	                var promotion = getPromotion(key, col.Id) || (!row.Id && matrix.promoteTo && _.find(matrix.promoteTo, function (env) { return env.Id === col.Id; }));
	                renderTile(key, items, html, promotion, row, col);
	
	                html.push('</td>');
	            });
	            html.push('<td class="last"></td>');
	            html.push('</tr>');
	        });
	    };
	
	    var getItemToShowOnDashboard = function (deployments) {
	        if (!deployments || !deployments[0]) {
	            return deployments;
	        }
	        var sortedDeployments = _.sortBy(deployments, 'ReleaseVersion').reverse();
	        var index = _.findIndex(sortedDeployments, function (item) {
	            return item.State === 'Executing' || 
	                item.State === 'Failed' || 
	                (item.State === 'Success' && item.HasWarningsOrErrors);
	        });
	        if (index > -1) {
	            return sortedDeployments[index];
	        }
	        return sortedDeployments[0];
	    };
	
	    var getCompletedItemsCount = function (currentItem, items, tenantsLinked) {
	        return _.filter(items, function (item) {
	            return tenantsLinked.indexOf(item.TenantId) !== -1 &&
	                item.State === 'Success' &&
	                item.ReleaseId === currentItem.ReleaseId;
	        }).length;
	    };
	
	    function getTileLink(matrix, item, hasTenants) {
	        if (matrix.slice && matrix.slice.projects && !!hasTenants) {
	            var project = _.find(matrix.slice.projects, function (a) {
	                return a.Id === item.ProjectId;
	            });
	            return '#/projects/' + project.Slug +'?release='+ item.ReleaseVersion;
	        } else {
	            return '#/tasks/' + item.TaskId;
	        }
	    }
	
	    var renderTile = function(key, items, html, promotion, row, col) {
	        if (!items) {
	            matrix.renderEmptyCell(key, html, promotion, row, col);
	            return;
	        }
	        var item = getItemToShowOnDashboard(items);
	        var releaseDate = moment(item.QueueTime);
	        var tenantsLinked = matrix.projectEnvironmentTenantIndex[key];
	        var hasTenants = !!tenantsLinked && tenantsLinked.length > 1;
	        html.push('<a class="deployment-square" href="');
	        html.push(getTileLink(matrix, item, hasTenants));
	        html.push('">');
	        taskStatusRenderer.render(html, item);
	        if (hasTenants) {
	            html.push('<div class="wrapper">');
	        }
	        html.push('<span class="deployment-square-info">');
	        html.push(  '<span class="version">');
	        html.push('    <span class="release-number" title="');
	        html.push(octoUtil.escapeHtml(item.ReleaseVersion));
	        html.push('">');
	        html.push(octoUtil.escapeHtml(item.ReleaseVersion));
	        html.push('    </span>');
	        html.push('  </span>');
	        html.push('  </span>');
	        if (hasTenants) {
	            var completedItems = getCompletedItemsCount(item, items, tenantsLinked);
	            html.push('    <span class="label tenant-count">');
	            html.push('<span class="progress-count">');
	            html.push(completedItems);
	            html.push('</span>');
	            html.push('<span class="total-count">');
	            html.push('/');
	            html.push(tenantsLinked.length);
	            html.push('</span>');
	            html.push('    </span>');
	        }
	        if (hasTenants) { html.push('</div> ');}
	        html.push(' <span class="release-date" title="');
	        html.push(octoUtil.escapeHtml(releaseDate.format('LLLL')));
	        html.push('">');
	        html.push(octoUtil.escapeHtml(releaseDate.format('MMMM Do YYYY')));
	        html.push('</span>');
	        html.push('</span>');
	        html.push('</a>');
	    };
	
	    var partialRender = function() {
	        _.each(matrix.environments, function(env) {
	            _.each(matrix.rows, function(row) {
	                var key = matrix.keyFromPair(env, row);
	                var promotion = getPromotion(key, env.Id) || (!row.Id && matrix.promoteTo && _.find(matrix.promoteTo, function (environment) { return environment.Id === env.Id; }));
	                var oldItem = previousItems[key];
	                var newItem = matrix.items[key];
	                if (itemHasChanged(oldItem, newItem)) {
	                    updateTile(key, newItem, $("#" + key, element), promotion);
	                }
	            });
	        });
	    };
	
	    var updateTile = function(key, item, domElement, promotion) {
	        var updatedItem = getItemToShowOnDashboard(item);
	        var anchor = $("a.deployment-square", domElement);
	        if (anchor.length === 0) {
	            var html = [];
	            renderTile(key, updatedItem, html);
	            domElement.html(html.join(""));
	        }
	
	        anchor = $("a.deployment-square", domElement);
	        if (anchor.length === 0) {
	            return;
	        }
	
	        if (!item) {
	            domElement.empty();
	        } else {
	            var releaseDate = moment(updatedItem.QueueTime);
	            var tenantsLinked = matrix.projectEnvironmentTenantIndex[key] || [];
	            var hasTenants = !!tenantsLinked && tenantsLinked.length > 1;
	            anchor.attr("href", getTileLink(matrix, item[0], hasTenants));
	            $(".version .release-number", anchor).text(updatedItem.ReleaseVersion);
	            if (hasTenants) {
	                var completedItems = getCompletedItemsCount(updatedItem, item, tenantsLinked);
	                $(".version .tenant-count .progress-count", anchor).text(completedItems);
	                $(".version .tenant-count .total-count", anchor).text('/' + tenantsLinked.length);
	            }
	            $(".release-date", anchor).attr("title", releaseDate.format('LLLL'));
	            $(".release-date", anchor).text(releaseDate.format('MMMM Do YYYY'));
	            taskStatusRenderer.update(updatedItem, $(".status", anchor));
	        }
	    };
	
	    var compareValues = function(oldValue, newValue) {
	        return angular.toJson(oldValue) !== angular.toJson(newValue);
	    };
	
	    var itemHasChanged = function(oldItem, newItem) {
	        if (!oldItem && newItem) {
	            // There wasn't a deployment here previously, and now there is
	            return true;
	        }
	
	        if (oldItem && !newItem) {
	            // There wasn't a deployment here previously, and now there is
	            return true;
	        }
	
	        if (!oldItem && !newItem) {
	            // Nothing to do
	            return false;
	        }
	
	        if (!oldItem[0] && newItem[0]) {
	            newItem = newItem[0];
	        }
	        
	        if (oldItem[0] && !newItem[0]) {
	            oldItem = oldItem[0];
	        }
	
	        if (oldItem[0] && newItem[0]) {
	            if (oldItem.length !== newItem.length) {
	                return true;
	            }
	
	            var oldItemStates = _.countBy(oldItem, function (item) { return item.State; });
	            var newItemStates = _.countBy(newItem, function (item) { return item.State; });
	            if (compareValues(oldItemStates, newItemStates)) {
	                return true;
	            }
	
	            var oldItemReleaseVersions = _.countBy(oldItem, function (item) { return item.ReleaseVersion; });
	            var newItemReleaseVersions = _.countBy(newItem, function (item) { return item.ReleaseVersion; });
	            if (compareValues(oldItemReleaseVersions, newItemReleaseVersions)) {
	                return true;
	            }
	        }
	
	        if (oldItem.State !== newItem.State) {
	            // Any changes to a task's state (queued -> failed)
	            return true;
	        }
	
	        if (oldItem.State === "Executing" || oldItem.State === "Queued" || oldItem.State === "Paused") {
	            // 'Running' tasks show durations, so we should always update them
	            return true;
	        }
	
	        // The task has been replaced by another task
	        return oldItem.Id !== newItem.Id;
	    };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var module = angular.module('octopusApp.environments');
	var machineImages = __webpack_require__(114);
	
	module.controller('MachineDiscoverController', function ($scope, busy, octopusRepository, $location, endpoints) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isDiscovering = $scope.isDiscovering = busy.create();
	
	  var endpointModule = function() {
	    var self = this;
	
	    this.communicationStyle = null;
	    this.host = null;
	    this.port = null;
	
	    this.canDiscover = function() {
	      return endpoints.canDiscover(self.communicationStyle);
	    };
	    this.isListeningTentacle = function() {
	      return endpoints.isListeningTentacle(self.communicationStyle);
	    };
	    this.isPollingTentacle = function() {
	      return endpoints.isPollingTentacle(self.communicationStyle);
	    };
	    this.defaultPort = function() {
	      return endpoints.getDefaultPort(self.communicationStyle);
	    };
	  };
	
	  $scope.endpoint = new endpointModule();
	
	  $scope.view = {};
	  $scope.view.machineUseProxy = !!$scope.endpoint.ProxyId;
	
	  $scope.machineImages = machineImages;
	  $scope.communicationStyles = endpoints.communicationStyles;
	  $scope.environmentId = $location.$$search["environment"];
	
	  isLoading.promise(octopusRepository.Proxies.list().then(function (proxies) {
	    $scope.proxies = proxies.Items;
	  }));
	
	  isLoading.promise(octopusRepository.Alerts.list().then(function(alerts) {
	    $scope.alerts = alerts;
	  }));
	
	  isLoading.promise(octopusRepository.Certificates.getOctopusCertificate().then(function(certificate) {
	    $scope.serverThumbprint = certificate.Thumbprint;
	  }));
	
	  $scope.discover = function () {
	    var addMachineUrl = "/machines/new/manual?environment=" + $scope.environmentId + "&type=" + $scope.endpoint.communicationStyle;
	
	    if ($scope.endpoint.canDiscover()) {
	      isDiscovering.promise(octopusRepository.Machines.discover($scope.endpoint.host, $scope.endpoint.port, $scope.endpoint.communicationStyle, $scope.endpoint.ProxyId).then(function(discovered) {
	
	        function str(x) {
	          return x || "";
	        }
	
	        if (discovered.Endpoint.CommunicationStyle === "TentaclePassive") {
	          addMachineUrl += (
	                "&uri=" + str(discovered.Endpoint.Uri)
	              + "&host=" + str(discovered.Endpoint.Host)
	              + "&port=" + str(discovered.Endpoint.Port)
	              + "&thumbprint=" + str(discovered.Endpoint.Thumbprint)
	              + "&proxyId=" + str($scope.endpoint.ProxyId)
	          );
	        } else if (discovered.Endpoint.CommunicationStyle === "Ssh") {
	          addMachineUrl += (
	                "&uri=" + str(discovered.Endpoint.Uri)
	              + "&host=" + str(discovered.Endpoint.Host)
	              + "&port=" + str(discovered.Endpoint.Port)
	              + "&fingerprint=" + str(discovered.Endpoint.Fingerprint)
	          );
	        }
	        $location.url(addMachineUrl);
	      }));
	    } else {
	      $location.url(addMachineUrl);
	    }
	  };
	
	  $scope.useProxyChanged = function(){
	    if(!$scope.view.machineUseProxy){
	      $scope.endpoint.ProxyId = null;
	    }
	  };
	
	});


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.environments');
	
	module.controller('EnvironmentEditController', function ($scope, $stateParams, $q, busy, pageTitle, octopusRepository, $location, octoDialog){
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.environment = null;
	
	    var environmentId = $stateParams["id"];
	
	    if (environmentId) {
	        isLoading.promise(octopusRepository.Environments.get(environmentId).then(function (result) {
	            $scope.environment = result;
	            pageTitle(result.Name + " settings");
	        }));
	    } else {
	        $scope.environment = {};
	        pageTitle("Create environment");
	    }
	
	    $scope.save = function() {
	        isSaving.promise(octopusRepository.Environments.save($scope.environment).then(function (result) {
	            $location.path("/environments");
	        }));
	    };
	
	    var confirmDeletingEnvironmentWhichHasScopedVariables = function(success) {
	        var allWarnings = [];
	        var additionalWarnings = [];
	        octopusRepository.Environments.variablesScopedOnlyToThisEnvironment($scope.environment)
	            .then(function(response) {
	                if (_.isEmpty(response.VariableMap) && 
	                    !response.HasUnauthorizedProjectVariables && 
	                    !response.HasUnauthorizedLibraryVariableSetVariables) {
	                    var dlg = octoDialog.confirmDelete('environment', success);
	                    dlg.then(function(result) {
	                        if (result) {
	                            $location.path("/environments");
	                        }
	                    });
	                    return;
	                }
	
	                allWarnings.push(_.flatten(_.map(response.VariableMap, function(map, key) {
	                    return _.map(map, function (value, name) {
	                        var variableSuffix = value > 1 ? "s" : "";
	                        return value + " variable" + variableSuffix + " in the <strong><em>" + name + "</em></strong> " + key.toLowerCase();
	                    });
	                })));
	
	                var shownWarnings = _.take(_.flatten(_.reduce(allWarnings, function (memo, warning) { return warning; }, [])), 5);
	
	                if (allWarnings[0].length > 5) {
	                    additionalWarnings = _.rest(_.flatten(_.reduce(allWarnings, function (memo, line) { return line; }, [])), 5);
	                }
	
	                var error;
	                if (response.HasUnauthorizedProjectVariables || response.HasUnauthorizedLibraryVariableSetVariables) {
	                    error = { Errors: [] };
	                    if (response.HasUnauthorizedProjectVariables) {
	                        error.Errors.push("Variables exist in projects for which you do not have edit permissions");
	                    }
	
	                    if (response.HasUnauthorizedLibraryVariableSetVariables) {
	                        error.Errors.push("Variables exist in library variable sets for which you do not have edit permissions");
	                    }
	                }
	                var warningMessage = shownWarnings.length > 0 
	                    ? "Deleting this environment will also delete <strong>ALL</strong> the variables that are scoped only to this environment in the following locations:<br/><br/><p class='text-left'>" + shownWarnings.join("<br/>") + "</p>" 
	                    : "";
	
	                octoDialog.asyncConfirm({
	                    title: "Variables scoped only to this environment exist",
	                    message: warningMessage,
	                    additionalDetails: additionalWarnings,
	                    executeButtonClass: "btn-warning",
	                    executeButtonText: "Delete anyway",
	                    error: error,
	                    execute: function (dialog) {
	                        dialog.busy.promise(success()).then(function() {
	                            dialog.dismiss();
	                            $location.path("/environments");
	                        });
	                    }
	                });
	            });
	    };
	
	    $scope.deleteEnvironment = function() {
	        confirmDeletingEnvironmentWhichHasScopedVariables(function () {
	            return octopusRepository.Environments.del($scope.environment);
	        });
	    };
	});
	
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.environments');
	
	module.controller('EnvironmentIndexController', function ($scope, $rootScope, $location, $state, $q, $localStorage, busy, octopusRepository, octoDialog, octopusTagSets) {
	    var isLoading = $scope.isLoading = busy.create();
	
	    var defaultMode = "default";
	    var hostedMode = "hosted";
	    $scope.page = {
	        mode: defaultMode,
	        modeName: function() {
	            return ($scope.page.mode === defaultMode) ? "Show Hosted Agent" : "Show Deployment Targets";
	        }
	    };
	    $scope.environments = null;
	    $scope.machines = {};
	    $scope.tentaclesUnavailable = [];
	    $scope.tagSets = null;
	    $scope.upgradesRequired = false;
	    $scope.showUpgrade = ($localStorage.ignoreUpgradeVersion !== $rootScope.octopusVersion);
	    $scope.showAzureTargetsWarning = false;
	    $scope.hasLoaded = false;
	
	    function isVisible(environment) {
	        return ($scope.page.mode === environment.showFor);
	    }
	
	    function init() {
	        var environmentsP  = octopusRepository.Environments.all().then(function(environments) {
	            environments.forEach(function(environment){
	                if (!environment.showFor) {
	                    environment.showFor = defaultMode;
	                }
	                environment.visible = isVisible;
	            });
	            $scope.environments = environments;
	        });
	
	        var machinesP = octopusRepository.Machines.all().then(function (machines) {
	            var hasDeprecatedAzureTargets = false;
	
	            machines.forEach(function (machine) {
	                octopusTagSets.getTag(machine.TenantTags).then(function (tags) {
	                    machine.selectedTags = tags;
	                });
	
	                machine.EnvironmentIds.forEach(function (environmentId) {
	                    var group = machine.HealthStatus;
	
	                    if (!$scope.machines[environmentId]) {
	                        $scope.machines[environmentId] = {};
	                    }
	                    
	                    if (!$scope.tentaclesUnavailable[environmentId]) {
	                        $scope.tentaclesUnavailable[environmentId] = [];
	                    }
	
	                    if (machine.IsDisabled) {
	                        group = "Disabled";
	                    }  else if (machine.HealthStatus === "Unavailable" && machine.Endpoint.TentacleVersionDetails) {
	                        $scope.tentaclesUnavailable[environmentId].push(machine);
	                    } else if (machine.HealthStatus !== "Unknown" && machine.HealthStatus !== "Unavailable" && machine.HealthStatus !== "Unhealthy") { // Upgrade status shouldn't override these states
	                        if (machine.Endpoint.TentacleVersionDetails &&
	                            machine.Endpoint.TentacleVersionDetails.UpgradeSuggested && !machine.Endpoint.TentacleVersionDetails.UpgradeLocked) {
	                            $scope.upgradesRequired = true;
	                            group = "NeedsUpgrade";
	                        } else if (!machine.HasLatestCalamari) {
	                            group = "CalamariNeedsUpgrade";
	                        }
	                    }
	
	                    if (machine.Endpoint.CommunicationStyle === 'AzureWebApp' ||
	                        machine.Endpoint.CommunicationStyle === 'AzureCloudService') {
	                        hasDeprecatedAzureTargets = true;
	                    }
	
	                    if (!$scope.machines[environmentId][group]) {
	                        $scope.machines[environmentId][group] = [];
	                    }
	                    $scope.machines[environmentId][group].push(machine);
	                });
	            });
	
	            $scope.showAzureTargetsWarning = hasDeprecatedAzureTargets && !$localStorage.ignoreAzureTargetsWarning;
	        });
	
	        isLoading.promise($q.all([environmentsP, machinesP]).then(function(){
	            $scope.hasLoaded = true;
	        }));
	    }
	
	    $scope.toggleVisibility = function() {
	        if ($scope.page.mode === defaultMode) {
	            $scope.page.mode = hostedMode;
	        } else {
	            $scope.page.mode = defaultMode;
	        }
	    };
	
	    $scope.checkHealth = function (environment) {
	        var task = {
	            Name: 'Health',
	            Description: 'Check Deployment Target health',
	            Arguments: { Timeout: '00:05:00' }
	        };
	
	        if (environment) {
	            task.Description += ' in ' + environment.Name;
	            task.Arguments.EnvironmentId = environment.Id;
	        }
	
	        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result){
	            $location.path("/tasks/" + result.Id);
	        }));
	    };
	
	    $scope.upgradeTentaclesInEnvironment = function (environment) {
	        var task = {
	            Name: 'Upgrade',
	            Description: 'Upgrade Tentacles',
	            Arguments: { }
	        };
	
	        if (environment) {
	            task.Description += ' in ' + environment.Name;
	            task.Arguments.EnvironmentId = environment.Id;
	        }
	
	        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result){
	            $location.path("/tasks/" + result.Id);
	        }));
	    };
	
	    $scope.upgradeCalamariOnDeploymentTargets = function (environment) {
	        var machineIdsThatNeedsCalamariUpgrade = _.map($scope.machines[environment.Id]['CalamariNeedsUpgrade'], function (m) { return m.Id; });
	        var task = {
	            Name: 'UpdateCalamari',
	            Description: 'Update Calamari on Deployment Targets',
	            Arguments: { 
	                MachineIds: machineIdsThatNeedsCalamariUpgrade
	            }
	        };
	
	        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result) {
	            $location.path('/tasks/' + result.Id);
	        }));
	    };
	
	    $scope.upgradeTentacles = function () {
	        var task = {
	            Name: 'Upgrade',
	            Description: 'Upgrade Tentacles'
	        };
	
	        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result){
	            $location.path("/tasks/" + result.Id);
	        }));
	    };
	
	    $scope.dismissTentacleUpgrade = function() {
	        $localStorage.ignoreUpgradeVersion = $rootScope.octopusVersion;
	        $scope.showUpgrade = false;
	    };
	  
	    $scope.dismissAzureTargetsWarning = function() {
	        $localStorage.ignoreAzureTargetsWarning = true;
	        $scope.showAzureTargetsWarning = false;
	    };
	
	    $scope.show = function(machine) {
	        $location.path('/machines/' + machine.Id);
	    };
	
	    $scope.reorder = function() {
	        octoDialog.sort({
	            title: "Reorder Environments",
	            saveButtonText: "Save",
	            load: function(dialog) {
	                dialog.render(_.map($scope.environments, function (environment) {
	                    return {
	                        id: environment.Id,
	                        name: environment.Name
	                    };
	                }));
	            },
	            save: function (items, dialog) {
	                dialog.busy.promise(octopusRepository.Environments.sort(items).then(function() {
	                    dialog.dismiss();
	                    $state.reload();
	                }));
	            }
	        });
	    };
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 420 */
/***/ function(module, exports) {

	angular.module('octopusApp.environments')
	    .controller('MachineLayoutController', function MachineLayoutController($scope, machineState) {
	        var self = $scope;
	        self.machine = null;
	        self.machineId = machineState.machineId;
	        self.isLoading = machineState.isLoading;
	        self.isSaving = machineState.isSaving;
	        $scope.$watch(function () {
	            return machineState.machine;
	        }, function (machine) {
	            self.machine = machine;
	        });
	    }).provider('machineState', function machineState() {
	        this.$get = function ($stateParams, $timeout, busy, octopusRepository) {
	            var state = {
	                isLoading: busy.create(),
	                isSaving: busy.create(),
	                machineId: $stateParams.machineId,
	                machineAsync: null,
	                machine: null
	            };
	
	            function load() {
	                state.machineAsync = octopusRepository.Machines.get(state.machineId);
	                state.isLoading.promise(state.machineAsync.then(function (machine) {
	                    state.machine = machine;
	                }));
	                return state.machineAsync;
	            }
	
	            state.load = load;
	
	            $timeout(function() {
	                if (!state.machineAsync) {
	                    console.warn("Machine State was not populated by content controller.");
	                    load();
	                }
	            }, 5000);
	
	            return state;
	        };
	});

/***/ },
/* 421 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('azureCloudServiceEndpoint', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      endpoint: '='
	    },
	    templateUrl: 'areas/environments/views/endpoints/azure_cloud_service_endpoint.html',
	    link: function($scope, el, attr) {
	      var unwatch = $scope.$watch('endpoint', function() {
	        if (!$scope.endpoint) {
	          return;
	        }
	        if(!$scope.endpoint.Slot) {
	          $scope.endpoint.Slot = 'Staging';
	        }
	        if (!$scope.endpoint.hasOwnProperty('SwapIfPossible')) {
	          $scope.endpoint.SwapIfPossible = false;
	          $scope.endpoint.UseCurrentInstanceCount = true;
	        }
	        unwatch();
	      });
	    }
	  };
	});


/***/ },
/* 422 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('azureCloudServiceSelectorDeprecated', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      endpoint: '=',
	      type: '@'
	    },
	    templateUrl: 'areas/environments/views/endpoints/azure_cloud_service_selector.html',
	    controllerAs: 'vm',
	    bindToController: true,
	    controller: function ($scope, $q, octopusRepository, busy) {
	      var vm = this;
	      vm.isLoading = busy.create();
	
	      vm.selectedCloudService = null;
	      vm.selectedStorageAccount = null;
	
	
	      vm.changed = function changed() {
	        vm.endpoint.CloudServiceName = vm.selectedCloudService ? vm.selectedCloudService.Name : null;
	        vm.endpoint.StorageAccountName = vm.selectedStorageAccount ? vm.selectedStorageAccount.Name : null;
	      };
	
	
	      $scope.$watch(function () {
	                return vm.endpoint.AccountId;
	              },
	              function () {
	                if (!vm.endpoint.AccountId) {
	                  vm.cloudServices = [];
	                  return;
	                }
	
	
	                vm.isLoading.promise(octopusRepository.Accounts.get(vm.endpoint.AccountId)
	                        .then(function (account) {
	
	                          vm.isLoading.promise(octopusRepository.Accounts.getCloudServices(account)
	                                  .then(function (services) {
	                                    vm.cloudServices = services;
	
	                                    if (vm.endpoint.CloudServiceName) {
	                                      vm.selectedCloudService = services.filter(function (service) {
	                                        return vm.endpoint.CloudServiceName === service.Name;
	                                      })[0];
	                                    }
	                                  }));
	
	                          vm.isLoading.promise(octopusRepository.Accounts.getStorageAccounts(account)
	                                  .then(function (storageAccounts) {
	                                    vm.storageAccounts = storageAccounts;
	
	                                    if (vm.endpoint.StorageAccountName) {
	                                      vm.selectedStorageAccount = storageAccounts.filter(function (storage) {
	                                        return vm.endpoint.StorageAccountName === storage.Name;
	                                      })[0];
	                                    }
	                                  }));
	                        }));
	              }
	      );
	    }
	  };
	});


/***/ },
/* 423 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('azureWebAppEndpoint', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            endpoint: '='
	        },
	        templateUrl: 'areas/environments/views/endpoints/azure_web_app_endpoint.html'
	    };
	});


/***/ },
/* 424 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('azureWebSiteSelectorDeprecated', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            endpoint: '='
	        },
	        templateUrl: 'areas/environments/views/endpoints/azure_web_site_selector.html',
	        controllerAs: 'vm',
	        bindToController: true,
	        controller: function ($scope, octopusRepository, busy) {
	            var vm = this;
	            vm.isLoading = busy.create();
	            vm.changed = changed;
	
	            function changed() {
	                if (vm.selectedWebApp) {
	                    vm.endpoint.WebSpaceName = vm.selectedWebApp.WebSpace;
	                    vm.endpoint.WebAppName = vm.selectedWebApp.Name;
	                } else {
	                    vm.endpoint.WebSpaceName = null;
	                    vm.endpoint.WebAppName = null;
	                }
	            }
	
	            $scope.$watch(function () {
	                    return vm.endpoint.AccountId;
	                },
	                function () {
	                    if(!vm.endpoint.AccountId){
	                        vm.webSites = [];
	                        vm.selectedWebApp = null;
	                    } else {
	                        vm.isLoading.promise(octopusRepository.Accounts.get(vm.endpoint.AccountId)
	                            .then(function (account) {
	                                return octopusRepository.Accounts.getWebSites(account)
	                                        .then(function (webSites) {
	                                            vm.webSites = webSites;
	
	                                            if (vm.endpoint.WebAppName) {
	                                                vm.selectedWebApp = webSites.filter(function (website) {
	                                                    return website.Name === vm.endpoint.WebAppName;
	                                                })[0];
	                                            }
	                                        });
	                            })
	                        );
	                    }
	                }
	            );
	        }
	    };
	});


/***/ },
/* 425 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('cloudRegionEndpoint', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            endpoint: '='
	        },
	        templateUrl: 'areas/environments/views/endpoints/cloud_region_endpoint.html'
	    };
	});


/***/ },
/* 426 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('offlineDropEndpoint', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      endpoint: '='
	    },
	    templateUrl: 'areas/environments/views/endpoints/offline_drop_endpoint.html'
	  };
	});


/***/ },
/* 427 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('sshEndpoint', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            endpoint: '='
	        },
	        templateUrl: 'areas/environments/views/endpoints/ssh_endpoint.html',
	        controller: function($scope, octopusRepository, busy) {
	          var isLoading = $scope.isLoading = busy.create();
	
	          $scope.view = {};
	          $scope.view.sshUseProxy = !!$scope.endpoint.ProxyId;
	
	          isLoading.promise(octopusRepository.Proxies.list().then(function (proxies) {
	            $scope.proxies = proxies.Items;
	          }));
	
	          $scope.useProxyChanged = function () {
	            if (!$scope.view.sshUseProxy) {
	              $scope.endpoint.ProxyId = null;
	            }
	          };
	        }
	    };
	});


/***/ },
/* 428 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('tentacleActiveEndpoint', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      endpoint: '='
	    },
	    templateUrl: 'areas/environments/views/endpoints/tentacle_active_endpoint.html',
	    controller: function($scope, octopusRepository, busy) {
	      var isLoading = $scope.isLoading = busy.create();
	      isLoading.promise(octopusRepository.Certificates.getOctopusCertificate().then(function(certificate) {
	        $scope.serverThumbprint = certificate.Thumbprint;
	      }));
	    }
	  };
	});


/***/ },
/* 429 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('tentaclePassiveEndpoint', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      endpoint: '='
	    },
	    templateUrl: 'areas/environments/views/endpoints/tentacle_passive_endpoint.html',
	    controller: function($scope, octopusRepository, busy) {
	      var isLoading = $scope.isLoading = busy.create();
	
	      $scope.view = {};
	      $scope.view.tentacleUseProxy = !!$scope.endpoint.ProxyId;
	
	      isLoading.promise(octopusRepository.Certificates.getOctopusCertificate().then(function (certificate) {
	        isLoading.promise(octopusRepository.Proxies.list().then(function (proxies) {
	          $scope.serverThumbprint = certificate.Thumbprint;
	          $scope.proxies = proxies.Items;
	        }));
	      }));
	
	      $scope.useProxyChanged = function(){
	        if(!$scope.view.tentacleUseProxy){
	          $scope.endpoint.ProxyId = null;
	        }
	      };
	
	    }
	  };
	});


/***/ },
/* 430 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('machineList', function (octoUtil, octopusTagSets, octopusFeatures, targetStateMapper) {
	    return {
	        restrict: 'E',
	        replace: false,
	        scope: {
	            machines: '=',
	            show:'='
	        },
	        link: function(scope, element, attr) {
	
	            var ensureMachineList = function (machines, element) {
	
	                var renderMachineList = function() {
	                    var html = [];
	
	                    html.push('<ul class="octo-tiles">');
	                    for (var i = 0; i < machines.length; i++) {
	                        var machine = machines[i];
	
	                        html.push('<li class="container-fluid machine clickable">');
	                        html.push('<a href="#/machines/');
	                        html.push(octoUtil.escapeHtml(machine.Id));
	                        html.push('">');
	
	                        html.push('<div class="row">');
	
	                        renderStatus(html, machine);
	
	                        html.push('<div class="machine-summary col-xs-9">');
	                        html.push('<h5 title="' + octoUtil.escapeHtml(machine.Name)  + '">');
	                        html.push(octoUtil.escapeHtml(machine.Name));
	                        html.push('</h5>');
	
	                        renderTags(html, machine);
	                        renderRoles(html, machine);
	
	                        html.push('</div>');
	                        html.push('</div>');
	
	                        html.push('</a>');
	                        html.push('</li>');
	                    }
	                    html.push('</ul>');
	
	                    return html.join('');
	                };
	
	                var update = function() {
	                    var html = renderMachineList();
	                    element.html(html);
	                };
	
	                update();
	            };
	
	            var render = function() {
	                if (!scope.machines) {
	                    return;
	                }
	                ensureMachineList(scope.machines, element);
	            };
	
	            var renderStatus = function(html, machine) {
	                html.push('<div class="machine-status col-xs-3">');
	                html.push('<img alt="');
	                html.push(octoUtil.escapeHtml(machine.StatusSummary));
	                html.push('" title="');
	                html.push(octoUtil.escapeHtml(machine.StatusSummary));
	                html.push('" src="');
	                html.push(targetStateMapper.calculateTargetIcon(machine));
	                html.push('" /></div>');
	            };
	
	            var renderRoles = function(html, machine) {
	                if (machine.Roles.length <= 0) {
	                    return;
	                }
	
	                html.push('<p>');
	                for (var roleCount = 0; roleCount < machine.Roles.length; roleCount++)
	                {
	                    var role = machine.Roles[roleCount];
	                    html.push('<span class="label truncate label-default">');
	                    html.push(octoUtil.escapeHtml(role));
	                    html.push('</span>');
	                }
	                html.push('</p>');
	            };
	
	            var renderTags = function(html, machine) {
	                if (!octopusFeatures.isEnabled('IsMultiTenancyEnabled') || (!machine.selectedTags || machine.selectedTags.length <= 0)) {
	                    return;
	                }
	
	                html.push('<div class="selected-tags-list">');
	
	                for (var tagIndex = 0; tagIndex < machine.selectedTags.length; tagIndex++) {
	                    var tag = machine.selectedTags[tagIndex];
	                    html.push('    <div>');
	                    html.push('        <i class="fa fa-square tag-swatch" style="color: ' + tag.Color + '" title="' + tag.Name + '"></i>');
	                    html.push('    </div>');
	                }
	        
	                html.push('</div>');
	            };
	
	            render();
	        }
	    };
	});


/***/ },
/* 431 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('machinePolicySummary', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	        machinePolicy: '=',
	        hideDescription: '='
	    },
	    templateUrl: 'areas/environments/machines/machine_policy_summary.html',
	    link: function(scope, element) {
	        function parseTimeSpan(timeSpan)
	        {
	            var timeSpanParts = timeSpan.split(":");
	            
	            var days = 0;
	            var hours = 0;
	            var mins = 0;
	            var tsPart1 = timeSpanParts[0];
	            if (tsPart1.indexOf(".") !== -1) {
	                // days included
	                var daysAndHours = tsPart1.split(".");
	                days = parseInt(daysAndHours[0]);
	                hours = parseInt(daysAndHours[1]);
	                mins = parseInt(timeSpanParts[1]);
	            } else {
	                // no days
	                hours = parseInt(timeSpanParts[0]);
	                mins = parseInt(timeSpanParts[1]);
	            }
	            return {
	                Days: days,
	                Hours: hours,
	                Minutes: mins
	            };
	        }
	
	        var reload = function() {
	            if (scope.machinePolicy == null) {
	                return;
	            }
	            var policy = scope.machinePolicy;
	
	            var healthCheckInterval = parseTimeSpan(policy.MachineHealthCheckPolicy.HealthCheckInterval);
	            var healthCheckIntervalHtml = 'Performs health checks every';
	            if (healthCheckInterval.Days > 0) {
	                healthCheckIntervalHtml += ' ' + healthCheckInterval.Days + ' day' + (healthCheckInterval.Days === 1 ? '' : 's');
	            }
	            if (healthCheckInterval.Hours > 0) {
	                healthCheckIntervalHtml += ' ' + healthCheckInterval.Hours + ' hour' + (healthCheckInterval.Hours === 1 ? '' : 's');
	            }
	            if (healthCheckInterval.Minutes > 0 || healthCheckInterval.Hours === 0) {
	                healthCheckIntervalHtml += ' ' + healthCheckInterval.Minutes + ' minute' + (healthCheckInterval.Minutes === 1 ? '' : 's');
	            }
	            scope.healthCheckIntervalHtml = healthCheckIntervalHtml;
	
	            var tentacleEndpointHealthCheckHtml = '';
	            if (policy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.RunType === 'InheritFromDefault') {
	                tentacleEndpointHealthCheckHtml = 'Inherits from the default machine policy';
	            } else if (policy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.RunType === 'Inline') {
	                tentacleEndpointHealthCheckHtml = 'Uses custom script';
	            }
	            scope.tentacleEndpointHealthCheckHtml = tentacleEndpointHealthCheckHtml;
	
	            var sshEndpointHealthCheckHtml = '';
	            if (policy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType === 'InheritFromDefault') {
	                sshEndpointHealthCheckHtml = 'Inherits from the default machine policy';
	            } else if (policy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType === 'Inline') {
	                sshEndpointHealthCheckHtml = 'Uses custom script';
	            }
	            scope.sshEndpointHealthCheckHtml = sshEndpointHealthCheckHtml;
	
	            var machineConnectivityHtml = '';
	            if (policy.MachineConnectivityPolicy.MachineConnectivityBehavior === 'ExpectedToBeOnline') {
	                machineConnectivityHtml = 'Fails when a machine is unavailable';
	            } else if (policy.MachineConnectivityPolicy.MachineConnectivityBehavior === 'MayBeOfflineAndCanBeSkipped') {
	                machineConnectivityHtml = 'Ignore unavailable machines';
	            }
	            scope.machineConnectivityHtml = machineConnectivityHtml;
	
	            var machineCalamariUpdatesHtml = '';
	            if (policy.MachineUpdatePolicy.CalamariUpdateBehavior === 'UpdateOnDeployment') {
	                machineCalamariUpdatesHtml = 'Automatically update when a machine is involved in a deployment';
	            } else if (policy.MachineUpdatePolicy.CalamariUpdateBehavior === 'UpdateOnNewMachine') {
	                machineCalamariUpdatesHtml = 'Automatically update the first time a machine comes online and then when it is involved in a deployment';
	            } else if (policy.MachineUpdatePolicy.CalamariUpdateBehavior === 'UpdateAlways') {
	                machineCalamariUpdatesHtml = 'Always keep up to date';
	            }
	            scope.machineCalamariUpdatesHtml = machineCalamariUpdatesHtml;
	
	            var machineTentacleUpdatesHtml = '';
	            if (policy.MachineUpdatePolicy.TentacleUpdateBehavior === 'NeverUpdate') {
	                machineTentacleUpdatesHtml = 'Do not update';
	            } else if (policy.MachineUpdatePolicy.TentacleUpdateBehavior === 'Update') {
	                machineTentacleUpdatesHtml = 'Automatically update';
	            }
	            scope.machineTentacleUpdatesHtml = machineTentacleUpdatesHtml;
	
	            var cleaningUpOfflineHtml = '';
	            if (policy.MachineCleanupPolicy.DeleteMachinesBehavior === 'DoNotDelete') {
	                cleaningUpOfflineHtml = 'Does not delete machines automatically';
	            } else if (policy.MachineCleanupPolicy.DeleteMachinesBehavior === 'DeleteUnavailableMachines') {
	                
	                var deleteMachinesElapsedTimeSpan = parseTimeSpan(policy.MachineCleanupPolicy.DeleteMachinesElapsedTimeSpan);
	                var deleteMachinesElapsedTimeSpanHtml = 'Automatically delete unavailable machines after';
	                if (deleteMachinesElapsedTimeSpan.Days > 0) {
	                    deleteMachinesElapsedTimeSpanHtml += ' ' + deleteMachinesElapsedTimeSpan.Days + ' day' + (deleteMachinesElapsedTimeSpan.Days === 1 ? '' : 's');
	                }
	                if (deleteMachinesElapsedTimeSpan.Hours > 0) {
	                    deleteMachinesElapsedTimeSpanHtml += ' ' + deleteMachinesElapsedTimeSpan.Hours + ' hour' + (deleteMachinesElapsedTimeSpan.Hours === 1 ? '' : 's');
	                }
	                if (deleteMachinesElapsedTimeSpan.Minutes > 0 || deleteMachinesElapsedTimeSpan.Hours === 0) {
	                    deleteMachinesElapsedTimeSpanHtml += ' ' + deleteMachinesElapsedTimeSpan.Minutes + ' minute' + (deleteMachinesElapsedTimeSpan.Minutes === 1 ? '' : 's');
	                }
	                cleaningUpOfflineHtml = deleteMachinesElapsedTimeSpanHtml;
	            }
	            scope.cleaningUpOfflineHtml = cleaningUpOfflineHtml;
	
	        };
	
	        scope.$watch("machinePolicy", function() {
	            reload();
	        });
	    }
	  };
	});


/***/ },
/* 432 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('machineStatus', function(){
	    return {
	        restrict: 'E',
	        replce: true,
	        scope: {
	            machine : '='
	        },
	        controllerAs: 'vm',
	        bindToController: true,
	        controller: function($scope, targetStateMapper) {
	            var self = this;
	            this.calculateTargetIcon = function calculateTargetIcon() {
	                return targetStateMapper.calculateTargetIcon(self.machine);
	            };
	        },
	        template: '<div class="machine-status" ng-if="vm.machine">' +
	        '   <img style="height: 1.5em" alt="{{::vm.machine.statusSummary}}" title="{{::vm.machine.statusSummary}}" ng-src="{{::vm.calculateTargetIcon()}}">' +
	        '</div>'
	    };
	});

/***/ },
/* 433 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.filter("cleanMachineUri", function() {
	    return function(uri) {
	        if (!uri || uri.length === 0) {
	            return "";
	        }
	
	        uri = uri.replace("https://", "");
	        uri = uri.replace("/", "");
	        uri = uri.replace(":10933", "");
	        return uri;
	    };
	});

/***/ },
/* 434 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.controller('MachinePolicyEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var machinePolicyId = $stateParams["id"];
	    var repository = octopusRepository.MachinePolicies;
	
	    $scope.machinePolicy = null;
	
	    if (machinePolicyId) {
	        isLoading.promise(repository.get(machinePolicyId).then(function (machinePolicy) {
	            isLoading.promise(repository.getMachines(machinePolicy).then(function (response) {
	                $scope.numberOfMachines = response.TotalResults;
	                $scope.machinesUsingPolicy = response;
	                $scope.machinePolicy = machinePolicy;
	                refreshHealthCheckInterval();
	                refreshDeleteMachinesElapsedTimeSpan();
	                pageTitle(machinePolicy.Name);
	            }));
	        }));
	    } else {
	        $scope.numberOfMachines = 0;
	        $scope.machinePolicy = {
	            Name: "",
	            Description: "",
	            IsDefault: false,
	            MachineHealthCheckPolicy: {
	                TentacleEndpointHealthCheckPolicy: {
	                    RunType: "InheritFromDefault",
	                    ScriptBody: ""
	                },
	                SshEndpointHealthCheckPolicy: {
	                    RunType: "InheritFromDefault",
	                    ScriptBody: ""
	                },
	                HealthCheckInterval: "0.01:00"
	            },
	            MachineCleanupPolicy: {
	                DeleteMachinesBehavior: "DoNotDelete",
	                DeleteMachinesElapsedTimeSpan: "0.01:00"
	            },
	            MachineUpdatePolicy: {
	                CalamariUpdateBehavior: "UpdateOnDeployment",
	                TentacleUpdateBehavior: "NeverUpdate"
	            },
	            MachineConnectivityPolicy: {
	                MachineConnectivityBehavior: "ExpectedToBeOnline"
	            }
	        };
	        refreshHealthCheckInterval();
	        refreshDeleteMachinesElapsedTimeSpan();
	        pageTitle('Create Machine Policy');
	    }
	
	    function refreshHealthCheckInterval()
	    {
	        var healthCheckIntervalParts = $scope.machinePolicy.MachineHealthCheckPolicy.HealthCheckInterval.split(":");
	
	        var days = 0;
	        var hours = 0;
	        var mins = 0;
	        var tsPart1 = healthCheckIntervalParts[0];
	        if (tsPart1.indexOf(".") !== -1) {
	            // days included
	            var daysAndHours = tsPart1.split(".");
	            days = parseInt(daysAndHours[0]);
	            hours = parseInt(daysAndHours[1]);
	            mins = parseInt(healthCheckIntervalParts[1]);
	        } else {
	            // no days
	            hours = parseInt(healthCheckIntervalParts[0]);
	            mins = parseInt(healthCheckIntervalParts[1]);
	        }
	        $scope.healthCheckInterval = {
	            Days: days,
	            Hours: hours,
	            Minutes: mins
	        };
	    }
	
	    function refreshDeleteMachinesElapsedTimeSpan()
	    {
	        var deleteMachinesElapsedTimeSpanParts = $scope.machinePolicy.MachineCleanupPolicy.DeleteMachinesElapsedTimeSpan.split(":");
	
	        var days = 0;
	        var hours = 0;
	        var mins = 0;
	        var tsPart1 = deleteMachinesElapsedTimeSpanParts[0];
	        if (tsPart1.indexOf(".") !== -1) {
	            // days included
	            var daysAndHours = tsPart1.split(".");
	            days = parseInt(daysAndHours[0]);
	            hours = parseInt(daysAndHours[1]);
	            mins = parseInt(deleteMachinesElapsedTimeSpanParts[1]);
	        } else {
	            // no days
	            hours = parseInt(deleteMachinesElapsedTimeSpanParts[0]);
	            mins = parseInt(deleteMachinesElapsedTimeSpanParts[1]);
	        }
	        $scope.deleteMachinesElapsedTimeSpan = {
	            Days: days,
	            Hours: hours,
	            Minutes: mins
	        };
	    }
	
	    $scope.save = function() {
	
	        if ($scope.deleteMachinesElapsedTimeSpan.Days == null) {
	            $scope.deleteMachinesElapsedTimeSpan.Days = 0;
	        }
	        if ($scope.deleteMachinesElapsedTimeSpan.Hours == null) {
	            $scope.deleteMachinesElapsedTimeSpan.Hours = 0;
	        }
	        if ($scope.deleteMachinesElapsedTimeSpan.Minutes == null) {
	            $scope.deleteMachinesElapsedTimeSpan.Minutes = 0;
	        }
	        $scope.machinePolicy.MachineCleanupPolicy.DeleteMachinesElapsedTimeSpan = $scope.deleteMachinesElapsedTimeSpan.Days + "." + pad($scope.deleteMachinesElapsedTimeSpan.Hours) + ":" + pad($scope.deleteMachinesElapsedTimeSpan.Minutes) + ":00";
	
	        if ($scope.healthCheckInterval.Days == null) {
	            $scope.healthCheckInterval.Days = 0;
	        }
	        if ($scope.healthCheckInterval.Hours == null) {
	            $scope.healthCheckInterval.Hours = 0;
	        }
	        if ($scope.healthCheckInterval.Minutes == null) {
	            $scope.healthCheckInterval.Minutes = 0;
	        }
	        $scope.machinePolicy.MachineHealthCheckPolicy.HealthCheckInterval = $scope.healthCheckInterval.Days + "." + pad($scope.healthCheckInterval.Hours) + ":" + pad($scope.healthCheckInterval.Minutes) + ":00";
	
	        isSaving.promise(repository.save($scope.machinePolicy).then(function(saved){
	            unsavedChanges.saved();
	            $location.path('/environments/machinepolicies/');
	        }));
	    };
	
	    function pad(num){
	        return ("00" + num).substr(-2);
	    }
	});


/***/ },
/* 435 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.controller('MachinePolicyIndexController', function($scope, $location, busy, octopusRepository, octopusClient) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  isLoading.promise(octopusRepository.MachinePolicies.all().then(function(machinePolicies){
	      $scope.machinePolicies = machinePolicies;
	  }));
	});


/***/ },
/* 436 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.directive('machinePolicyEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/environments/machinepolicies/views/editor.html'
	  };
	});


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.environments');
	
	module.controller('MachineEditController', function ($scope, $q, machineState, $location, $stateParams, busy, octopusLog, octopusRepository, octoDialog, endpoints) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    var environmentId = $location.$$search["environment"];
	    var endpoint = $location.$$search["type"];
	    var hostname = $location.$$search["host"];
	    var port = $location.$$search["port"];
	    var uri = $location.$$search["uri"];
	    var fingerprint = $location.$$search["fingerprint"];
	    var thumbprint = $location.$$search["thumbprint"];
	    var name = $location.$$search["name"];
	    var proxyId = $location.$$search["proxyId"];
	    $scope.machineId = $stateParams.machineId;
	    $scope.communicationStyles = endpoints.communicationStyles;
	    $scope.availableTenants = [];
	    $scope.environments = [];
	    $scope.teamSensitiveValues = { EnvironmentIds: [], TenantIds: [] };
	    $scope.save = save;
	    $scope.resetEndpoint = resetEndpoint;
	    $scope.deleteMachine = deleteMachine;
	
	    var unavailableTenants = [];
	    var unavailableEnvironments = [];
	    function configureFromExisting() {
	        isLoading.promise(machineState.load().then(function (machine) {
	            refreshMachinePolicy(machine.MachinePolicyId);
	            $scope.machine = machine;
	            $scope.teamSensitiveValues.EnvironmentIds = $scope.environments.filter(function(m){ return machine.EnvironmentIds.indexOf(m.Id) !== -1; }).map(function(e){return e.Id;});
	            $scope.teamSensitiveValues.TenantIds = $scope.availableTenants.filter(function(t){return machine.TenantIds.indexOf(t.Id) !== -1;}).map(function(e){return e.Id;});
	
	            unavailableTenants = machine.TenantIds.filter(function(tid) { return $scope.teamSensitiveValues.TenantIds.indexOf(tid) === -1; });
	            unavailableEnvironments = machine.EnvironmentIds.filter(function(tid) { return $scope.teamSensitiveValues.EnvironmentIds.indexOf(tid) === -1; });
	        }));
	    }
	
	    function configureFromNew(environments) {
	        $scope.machine = {Endpoint: {CommunicationStyle: endpoint}, Status: 'Unknown'};
	
	        if (environmentId) {
	            $scope.teamSensitiveValues.EnvironmentIds = environments.filter(function(m){ return m.Id === environmentId; }).map(function(e){return e.Id;});
	        }
	        if (thumbprint) {
	            $scope.machine.Endpoint.Thumbprint = thumbprint;
	        }
	        if (fingerprint) {
	            $scope.machine.Endpoint.Fingerprint = fingerprint;
	        }
	        if (hostname || port) {
	            $scope.machine.Name = hostname;
	            $scope.machine.Endpoint.Host = hostname;
	            $scope.machine.Endpoint.Port = port;
	        }
	        if (uri) {
	            $scope.machine.Endpoint.Uri = uri;
	        }
	        if (name) {
	            $scope.machine.Name = name;
	        }
	        if (proxyId) {
	            $scope.machine.Endpoint.ProxyId = proxyId;
	        }
	        var defaultMachinePolicy = _.find($scope.machinePolicies, function (u) { return u.IsDefault; });
	        $scope.machine.MachinePolicyId = defaultMachinePolicy.Id;
	    }
	
	    function refreshMachinePolicy(machinePolicyId) {
	        var machinePolicy = _.find($scope.machinePolicies, function(machinePolicy){ return machinePolicy.Id === machinePolicyId;});
	        if (machinePolicy == null) {
	            octopusLog.log('Failed to find machine policy.');
	        }
	        $scope.machinePolicy = machinePolicy;
	    }
	
	    function init() {
	        var tenantsP = octopusRepository.Tenants ? octopusRepository.Tenants.all().then(function (tenants) {
	            $scope.availableTenants = tenants;
	        }) : $q.resolve([]);
	
	        var machineRolesP = octopusRepository.MachineRoles.all().then(function (machineRoles) {
	            $scope.availableRoles = machineRoles;
	        });
	
	        var environmentsP = octopusRepository.Environments.all().then(function (environments) {
	            $scope.environments = environments;
	        });
	
	        var policiesP = octopusRepository.MachinePolicies.all().then(function (machinePolicies) {
	            $scope.machinePolicies = machinePolicies;
	        });
	
	        isLoading.promise($q.all([tenantsP, machineRolesP, environmentsP, policiesP]).then(function () {
	            if ($scope.machineId) {
	                configureFromExisting();
	            } else {
	                configureFromNew($scope.environments);
	            }
	        }));
	
	        $scope.$watch('machine.MachinePolicyId', function (nv) {
	            if (nv != null) {
	                refreshMachinePolicy(nv);
	            }
	        });
	    }
	
	    function save() {
	        $scope.machine.EnvironmentIds = [].concat(unavailableEnvironments).concat($scope.teamSensitiveValues.EnvironmentIds);
	        $scope.machine.TenantIds = [].concat(unavailableTenants).concat($scope.teamSensitiveValues.TenantIds);
	        isSaving.promise(octopusRepository.Machines.save($scope.machine).then(function (saved) {
	            $location.path('/environments');
	        }));
	    }
	
	    function resetEndpoint() {
	        delete $scope.machine.Endpoint.Thumbprint;
	        delete $scope.machine.Endpoint.Uri;
	    }
	
	    function deleteMachine() {
	        var dlg = octoDialog.confirmDelete('machine', function () {
	            return octopusRepository.Machines.del($scope.machine);
	        });
	        dlg.then(function (result) {
	            if (result) {
	                $location.path("/environments");
	            }
	        });
	    }
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 438 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.controller('MachineConnectionController', function ($scope, machineState, $location, busy, octopusRepository, pollLoop) {
	    $scope.machineId = machineState.machineId;
	    $scope.checkHealth = checkHealth;
	    $scope.upgradeTentacle = upgradeTentacle;
	    $scope.isLoading = busy.create();
	    $scope.isSaving = busy.create();
	    $scope.lockVersion = lockVersion;
	    $scope.tentacleDetails = null;
	
	    function lockVersion(isToBeLocked) {
	        $scope.machine.Endpoint.TentacleVersionDetails.UpgradeLocked = isToBeLocked;
	        $scope.isSaving.promise(octopusRepository.Machines.save($scope.machine).then(function (saved) {
	            $scope.machine = saved;
	            $scope.tentacleDetails = $scope.machine.Endpoint.TentacleVersionDetails;
	        }));
	    }
	
	    function upgradeTentacle() {
	        if (!$scope.tentacleDetails) {
	            return;
	        }
	
	        var task = {
	            Name: 'Upgrade',
	            Description: 'Upgrade ' + $scope.machine.Name + ' Tentacle',
	            Arguments: {
	                MachineIds: [$scope.machineId]
	            }
	        };
	        $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
	            $location.path("/tasks/" + result.Id);
	        }));
	    }
	
	    function checkHealth() {
	        var task = {
	            Name: 'Health',
	            Description: 'Check ' + $scope.machine.Name + ' health',
	            Arguments: {
	                Timeout: '00:05:00',
	                MachineIds: [$scope.machineId]
	            }
	        };
	        $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
	            $location.path("/tasks/" + result.Id);
	        }));
	    }
	
	    function refresh() {
	        return $scope.isLoading.promise(machineState.load().then(function (machine) {
	            $scope.machine = machine;
	            $scope.tentacleDetails = $scope.machine.Endpoint.TentacleVersionDetails;
	
	            return octopusRepository.Machines.getConnectionStatus(machine).then(function (status) {
	                $scope.status = status;
	
	                if (status.LastConnectionError) {
	                    $scope.lastFailureEvent = {
	                        Category: 'Error',
	                        OccurredAt: status.LastFailedConnectionAttempt,
	                        Detail: status.LastConnectionError,
	                        MessageText: null
	                    };
	                } else {
	                    $scope.lastFailureEvent = null;
	                }
	            });
	        }));
	    }
	    pollLoop.create($scope, refresh).startImmediately();
	});
	
	


/***/ },
/* 439 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.controller('MachineDeploymentsController', function ($scope, machineState, $location, busy, octopusRepository, pollLoop) {
	  $scope.machineId = machineState.machineId;
	  $scope.isLoading = busy.create();
	  $scope.isSaving = busy.create();
	  $scope.skip = 0;
	
	  $scope.loadPage = loadPage;
	
	  function loadPage(skip) {
	    $scope.skip = skip;
	    refresh();
	  }
	
	
	  function refresh() {
	    return $scope.isLoading.promise(machineState.load().then(function (machine) {
	      $scope.machine = machine;
	
	      return octopusRepository.Machines.getTasks(machine, { skip: $scope.skip }).then(function (tasks) {
	        $scope.tasks = tasks;
	      });
	    }));
	  }
	
	  pollLoop.create($scope, function () {
	    return refresh();
	  }).startImmediately();
	});

/***/ },
/* 440 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	
	module.controller('MachineEventsController', function ($scope, machineState, $location, busy, octopusRepository, pollLoop) {
	    $scope.machineId = machineState.machineId;
	    $scope.isLoading = busy.create();
	    $scope.isSaving = busy.create();
	    $scope.skip = 0;
	
	    $scope.loadPage = loadPage;
	
	    function loadPage(skip) {
	        $scope.skip = skip;
	        refresh();
	    }
	
	    function refresh() {
	        return $scope.isLoading.promise(machineState.load().then(function (machine) {
	            $scope.machine = machine;
	
	            return octopusRepository.Events.list({ regarding: $scope.machineId, skip: $scope.skip }).then(function (events) {
	                $scope.events = events;
	            });
	        }));
	    }
	
	
	    pollLoop.create($scope, function () {
	        return refresh();
	    }).startImmediately();
	});

/***/ },
/* 441 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.controller('ProxyEditController', function ($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.view = {};
	    $scope.view.hasExistingPassword = false;
	    $scope.view.showPasswordChange = true;
	
	    var proxyId = $stateParams["id"];
	
	    $scope.proxy = null;
	
	    isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
	        $scope.status = status;
	
	        if (proxyId) {
	            isLoading.promise(octopusRepository.Proxies.get(proxyId).then(function (result) {
	                $scope.proxy = result;
	                if (!result.Password) {
	                    result.Password = {HasValue: false};
	                }
	                if (!result.Username) {
	                    $scope.view.showPasswordChange = true;
	                    $scope.view.hasExistingPassword = false;
	                } else {
	                    $scope.view.hasExistingPassword = true;
	                    $scope.view.showPasswordChange = false;
	                }
	                pageTitle($scope.proxy.Name);
	            }));
	        } else {
	            $scope.proxy = {ProxyType: 'HTTP'};
	            pageTitle("Create proxy");
	        }
	
	        $scope.deleteProxy = function () {
	            var dlg = octoDialog.confirmDelete('proxy', function () {
	                return octopusRepository.Proxies.del($scope.proxy);
	            });
	            dlg.then(function (result) {
	                if (result) {
	                    unsavedChanges.saved();
	                    $location.path("/environments/proxies");
	                }
	            });
	        };
	    }));
	
	    $scope.save = function () {
	        isSaving.promise(octopusRepository.Proxies.save($scope.proxy).then(function (result) {
	            unsavedChanges.saved();
	            $location.path("/environments/proxies");
	        }));
	    };
	});


/***/ },
/* 442 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.environments');
	
	module.controller('ProxyIndexController', function($scope, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
	    isLoading.promise(octopusRepository.Proxies.list().then(function (results) {
	      $scope.proxies = results;
	    }));
	  }));
	});
	
	


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.environments');
	
	module.service('endpoints', function () {
	
	  this.communicationStyles = [
	    { label: 'Listening Tentacle', value: 'TentaclePassive', port: 10933, discoverable: true, helpHtml: 'Connect to a machine via a Tentacle in Listening mode' },
	    { label: 'Polling Tentacle', value: 'TentacleActive', port: 10933, helpHtml: 'Connect to a machine via a Tentacle in Polling mode' },
	    { label: 'SSH Connection', value: 'Ssh', port: 22, discoverable: true, helpHtml: 'Connect to a machine via Secure Shell (SSH)' },
	    { label: 'Offline Package Drop', value: 'OfflineDrop', helpHtml: 'Configure a location to drop Offline Deployment Packages' },
	    { label: 'Cloud Region', value: 'None', helpHtml: 'A convenient way to model multiple geographic regions' }
	  ];
	
	  this.canDiscover = function(value) {
	    if(value) {
	      return _.findWhere(this.communicationStyles, {value: value}).discoverable;
	    }
	  };
	
	  this.isListeningTentacle = function(value) {
	    return value === this.communicationStyles[0].value;
	  };
	
	  this.isPollingTentacle = function(value) {
	    return value === this.communicationStyles[1].value;
	  };
	
	  this.getDefaultPort = function (value) {
	    if(value) {
	      return _.findWhere(this.communicationStyles, {value: value}).port;
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 444 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('FeedEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    var feedId = $stateParams["id"];
	    $scope.feed = null;
	    $scope.feeds = {
	        "NuGet": "NuGet Feed",
	        "Docker": "Docker Container Registry"
	    };
	    $scope.updateOptions = updateOptions;
	    $scope.save = save;
	    $scope.defaultDownloadAttempts = 5;
	    $scope.defaultDownloadRetryBackoffSeconds = 10;
	
	    function updateOptions() {
	        if ($scope.feed.FeedType === "NuGet") {
	            if (!$scope.feed.DownloadAttempts) {
	                $scope.feed.DownloadAttempts = $scope.defaultDownloadAttempts;
	            }
	            if (!$scope.feed.DownloadRetryBackoffSeconds) {
	                $scope.feed.DownloadRetryBackoffSeconds = $scope.defaultDownloadRetryBackoffSeconds;
	            }
	        } else {
	            delete $scope.feed.DownloadAttempts;
	            delete $scope.feed.DownloadRetryBackoffSeconds;
	        }
	
	        if ($scope.feed.FeedType === "Docker") {
	            if (!$scope.feed.ApiVersion) {
	                $scope.feed.ApiVersion = "v2";
	            }
	        } else {
	            delete $scope.feed.ApiVersion;
	        }
	    }
	
	    function init() {
	        if (feedId) {
	            isLoading.promise(octopusRepository.Feeds.get(feedId).then(function (feed) {
	                $scope.feed = feed;
	                pageTitle(feed.Name);
	                $scope.showAdvanced =
	                    ($scope.feed.DownloadAttempts !== $scope.defaultDownloadAttempts) ||
	                    ($scope.feed.DownloadRetryBackoffSeconds !== $scope.defaultDownloadRetryBackoffSeconds);
	            }));
	        } else {
	            $scope.feed = {
	                Password: {},
	                FeedType: "NuGet"};
	            pageTitle('Create feed');
	        }
	    }
	
	    function save(redirectToTestPage) {
	        // Set defaults if they are missing
	        if ($scope.feed.FeedType === "NuGet") {
	            if ($scope.feed.DownloadAttempts === null) {
	                $scope.feed.DownloadAttempts = $scope.defaultDownloadAttempts;
	            }
	            if ($scope.feed.DownloadRetryBackoffSeconds === null) {
	                $scope.feed.DownloadRetryBackoffSeconds = $scope.defaultDownloadRetryBackoffSeconds;
	            }
	        }
	        isSaving.promise(octopusRepository.Feeds.save($scope.feed).then(function (saved) {
	            unsavedChanges.saved();
	            if (redirectToTestPage) {
	                $location.path('/library/feeds/' + saved.Id + '/test');
	            } else {
	                $location.path('/library/feeds/' + saved.Id);
	            }
	        }));
	    }
	
	    init();
	});
	


/***/ },
/* 445 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('FeedTestController', function($scope, $stateParams, $location, busy, octopusRepository) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isTesting = $scope.isTesting = busy.create();
	
	    var feedId = $stateParams["id"];
	
	    $scope.feed = null;
	    $scope.test = { searchTerm: null, started: false };
	    $scope.packages = null;
	
	    var repository = octopusRepository.Feeds;
	
	    isLoading.promise(repository.get(feedId).then(function (feed) {
	        $scope.feed = feed;
	    }));
	
	    $scope.hasVersion = function() {
	        return $scope.feed && $scope.feed.FeedType !== "Docker";
	    };
	
	    $scope.testFeed = function() {
	        $scope.test.started = true;
	        $scope.packages = null;
	        isTesting.promise(repository.search($scope.feed, {
	            packageId: $scope.test.searchTerm,
	            partialMatch: true,
	            take: 10
	        }).then(function(packages){
	            $scope.packages = packages;
	        }));
	    };
	});
	
	
	
	


/***/ },
/* 446 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('FeedsIndexController', function($scope, busy, octopusRepository, octopusClient) {
	  var isLoading = $scope.isLoading = busy.create();
	  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status)  {
	    isLoading.promise(octopusRepository.ServerStatus.getBuiltInFeedStats(status).then(function(builtIn) {
	      isLoading.promise(octopusRepository.Feeds.list().then(function(feeds)  {
	        $scope.feeds = feeds;
	        $scope.builtIn = {
	          feedId: 'feeds-builtin',
	          totalPackages: builtIn.TotalPackages,
	          indexingStatus: builtIn.IndexingStatus,
	          synchronizationStatus: builtIn.SynchronizationStatus,
	          pushUrl: octopusClient.resolve(builtIn.Links["NuGetPush"])
	        };
	      }));
	    }));
	  }));
	});
	


/***/ },
/* 447 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.directive('feedEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/library/feeds/views/editor.html'
	  };
	});
	
	


/***/ },
/* 448 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('LifecycleAddEnvironmentDialogController', function($scope, busy, $uibModalInstance, environments) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.users = null;
	  $scope.adding = { environmentId: '', trigger: 'Manual' };
	  $scope.environments = environments;
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    $uibModalInstance.close($scope.adding);
	  };
	});
	


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('LifecycleEditController', function($scope, $stateParams, $state, busy, pageTitle, octopusRepository, $uibModal, octoDialog, unsavedChanges) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  var lifecycleId = $stateParams["id"];
	
	  $scope.lifecycle = null;
	  $scope.environmentsById = {};
	
	  var repository = octopusRepository.Lifecycles;
	
	  $scope.removeEnvironment = function(phaseCollection, target) {
	    phaseCollection.splice(phaseCollection.indexOf(target), 1);
	    unsavedChanges.unsaved();
	  };
	
	  isLoading.promise(octopusRepository.Environments.all().then(function (envs) {
	    $scope.environments = envs;
	    $scope.environmentsById = _.object(_.pluck($scope.environments, "Id"), $scope.environments);
	
	    if (lifecycleId) {
	      isLoading.promise(repository.get(lifecycleId).then(function (lifecycle) {
	        isLoading.promise(octopusRepository.Lifecycles.projects(lifecycle).then(function (projects) {
	          $scope.lifecycle = lifecycle;
	          $scope.projects = projects;
	          pageTitle(lifecycle.Name);
	        }));
	      }));
	    } else {
	      $scope.lifecycle = {
	        Name: "",
	        Phases: [],
	          ReleaseRetentionPolicy: {
	              "ShouldKeepForever": true,
	              "QuantityToKeep": 0,
	              "Unit": "Items"
	          },
	          TentacleRetentionPolicy: {
	              "ShouldKeepForever": true,
	              "QuantityToKeep": 0,
	              "Unit": "Items"
	          }
	      };
	      pageTitle('Create lifecycle');
	    }
	  }));
	
	  $scope.envCount = function(phase) {
	    var count = _.union(phase.OptionalDeploymentTargets, phase.AutomaticDeploymentTargets).length;
	    if (phase.MinimumEnvironmentsBeforePromotion > count) {
	      phase.MinimumEnvironmentsBeforePromotion = count;
	    }
	    return count;
	  };
	
	  $scope.removePhase = function(phase) {
	    unsavedChanges.unsaved();
	    var ix = $scope.lifecycle.Phases.indexOf(phase);
	    if (ix >= 0) {
	      $scope.lifecycle.Phases.splice(ix, 1);
	    }
	  };
	
	  $scope.addPhase = function () {
	    unsavedChanges.unsaved();
	    $scope.lifecycle.Phases.push({
	      Name: "",
	      MinimumEnvironmentsBeforePromotion: 0,
	      AutomaticDeploymentTargets: [],
	      OptionalDeploymentTargets: []
	    });
	  };
	
	  $scope.save = function() {
	    isSaving.promise(repository.save($scope.lifecycle).then(function(saved){
	      unsavedChanges.saved();
	      $state.go("app.library.lifecycles");
	    }));
	  };
	
	  $scope.reorder = function() {
	    octoDialog.sort({
	      title: "Reorder Phases",
	      saveButtonText: "Save",
	      load: function(dialog) {
	        var id = -1;
	        dialog.render(_.map($scope.lifecycle.Phases, function (p) {
	          id++;
	          return {
	            id: id,
	            name: p.Name
	          };
	        }));
	      },
	      save: function (items, dialog) {
	        var newPhases = [];
	        _.each(items, function (ix) {
	          newPhases.push($scope.lifecycle.Phases[ix]);
	        });
	        $scope.lifecycle.Phases = newPhases;
	        unsavedChanges.unsaved();
	        dialog.dismiss();
	      }
	    });
	  };
	
	  $scope.getParentPolicy = function(phase, index) {
	    for (var i = index; i >= 0; i--) {
	      var parentPhase = $scope.lifecycle.Phases[i];
	      if (parentPhase.ReleaseRetentionPolicy) {
	        return parentPhase;
	      }
	    }
	
	    return $scope.lifecycle;
	  };
	
	  $scope.resetRetentionPolicy = function (phase) {
	    phase.ReleaseRetentionPolicy = null;
	    phase.TentacleRetentionPolicy = null;
	  };
	
	  $scope.changeRetentionPolicy = function (phaseOrLifecycle) {
	    var policy = {
	      ReleaseRetentionPolicy: {
	        "ShouldKeepForever": true,
	        "QuantityToKeep": 0,
	        "Unit": "Items"
	      },
	      TentacleRetentionPolicy: {
	        "ShouldKeepForever": true,
	        "QuantityToKeep": 0,
	        "Unit": "Items"
	      }
	    };
	
	    if (phaseOrLifecycle.ReleaseRetentionPolicy) {
	      policy.ReleaseRetentionPolicy = angular.copy(phaseOrLifecycle.ReleaseRetentionPolicy);
	      policy.TentacleRetentionPolicy = angular.copy(phaseOrLifecycle.TentacleRetentionPolicy);
	    }
	
	    $uibModal.open({
	      backdrop: true,
	      keyboard: true,
	      templateUrl: 'areas/library/lifecycles/views/policy_edit_dialog.html',
	      controller: 'LifecyclePolicyEditDialogController',
	      resolve: {
	        policy: function () { return policy; }
	      }
	    }).result.then(function(result) {
	      if (result) {
	        unsavedChanges.unsaved();
	        phaseOrLifecycle.ReleaseRetentionPolicy = result.ReleaseRetentionPolicy;
	        phaseOrLifecycle.TentacleRetentionPolicy = result.TentacleRetentionPolicy;
	      }
	    });
	  };
	
	  $scope.addEnvironment = function(phase) {
	    var environmentsInUse = {};
	    _.each($scope.lifecycle.Phases, function (p) {
	      _.each(p.AutomaticDeploymentTargets, function (e) { environmentsInUse[e] = true; });
	      _.each(p.OptionalDeploymentTargets, function (e) { environmentsInUse[e] = true; });
	    });
	
	    var candidateEnvironments = [];
	    _.each($scope.environments, function (e) {
	      if (!environmentsInUse[e.Id]) {
	        candidateEnvironments.push(e);
	      }
	    });
	
	    $uibModal.open({
	      backdrop: true,
	      keyboard: true,
	      templateUrl: 'areas/library/lifecycles/views/add_environment_dialog.html',
	      controller: 'LifecycleAddEnvironmentDialogController',
	      resolve: {
	        environments: function () { return candidateEnvironments; }
	      }
	    }).result.then(function(result) {
	      if (result) {
	        unsavedChanges.unsaved();
	        if (result.trigger === 'Automatic') {
	          phase.AutomaticDeploymentTargets.push(result.environmentId);
	        } else {
	          phase.OptionalDeploymentTargets.push(result.environmentId);
	        }
	      }
	    });
	  };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('LifecycleIndexController', function($scope, $location, busy, octopusRepository, octopusClient) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.previews = {};
	  isLoading.promise(octopusRepository.Lifecycles.all().then(function(lifecycles){
	    isLoading.promise(octopusRepository.Environments.all().then(function(environments){
	      $scope.lifecycles = lifecycles;
	      $scope.environments = environments;
	
	      _.each($scope.lifecycles, function(lc) {
	        isLoading.promise(octopusRepository.Lifecycles.preview(lc).then(function (preview) {
	          $scope.previews[lc.Id] = preview;
	        }));
	      });
	    }));
	  }));
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 451 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('LifecyclePolicyEditDialogController', function($scope, busy, $uibModalInstance, policy) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  $scope.policy = policy;
	
	  $scope.reset = function(policyItem) {
	    if (policyItem.ShouldKeepForever) {
	      policyItem.QuantityToKeep = 0;
	    } else {
	      policyItem.QuantityToKeep = 3;
	    }
	  };
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    $uibModalInstance.close($scope.policy);
	  };
	});
	


/***/ },
/* 452 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.directive('lifecycleEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/library/lifecycles/views/editor.html'
	  };
	});
	
	


/***/ },
/* 453 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.directive('retentionSummary', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    template: '<span>{{summary}}</span>',
	    scope: {
	      policy: "="
	    },
	    link: function(scope, element) {
	      scope.$watch("policy", function() {
	        if (!scope.policy) {
	          return;
	        }
	
	        if (scope.policy.ShouldKeepForever) {
	          scope.summary = "Keep all";
	        } else if (scope.policy.Unit === "Days") {
	          if (scope.policy.QuantityToKeep === 1) {
	            scope.summary = "Keep for " + scope.policy.QuantityToKeep + " day";
	          } else {
	            scope.summary = "Keep for " + scope.policy.QuantityToKeep + " days";
	          }
	        } else {
	          if (scope.policy.QuantityToKeep === 1) {
	            scope.summary = "Keep " + scope.policy.QuantityToKeep + " release";
	          } else {
	            scope.summary = "Keep " + scope.policy.QuantityToKeep + " releases";
	          }
	        }
	      });
	    }
	  };
	});
	


/***/ },
/* 454 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('PackageDetailsController', function($scope, $location, $stateParams, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  var packageId = $stateParams["packageId"];
	
	  isLoading.promise(octopusRepository.Packages.get(packageId, {includeNotes: true}).then(function(pkg){
	    $scope.package = pkg;
	  }));
	});


/***/ },
/* 455 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('PackageRepositoryRetentionController', function($scope, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  isLoading.promise(octopusRepository.PackageRepository.getConfiguration().then(function (repositoryConfiguration) {
	    $scope.repositoryConfiguration = repositoryConfiguration;
	    $scope.view = { KeepForever: !repositoryConfiguration.DeleteUnreleasedPackagesAfterDays };
	  }));
	
	  $scope.save = function() {
	    if ($scope.view.KeepForever){
	      $scope.repositoryConfiguration.DeleteUnreleasedPackagesAfterDays = null;
	    } else {
	      $scope.repositoryConfiguration.DeleteUnreleasedPackagesAfterDays = $scope.repositoryConfiguration.DeleteUnreleasedPackagesAfterDays || 0;
	    }
	    isSaving.promise(octopusRepository.PackageRepository.updateConfiguration($scope.repositoryConfiguration).then(function(){
	      unsavedChanges.saved();
	      $location.path('/library/packages');
	    }));
	  };
	
	});
	


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.library');
	
	module.controller('PackageUploadController', function($scope, $location, busy, octopusRepository, octoUploader) {
	  var octoUpload = octoUploader.create($scope);
	
	  $scope.isLoading = busy.create();
	  $scope.isUploading = busy.create();
	  $scope.octoUpload = octoUpload;
	  $scope.uploadOptions = {
	    replace: false
	  };
	  $scope.beginUpload = beginUpload;
	
	  $scope.cancel = function() {
	    octoUpload.cancel();
	
	    var form = $("#packageUpload")[0];
	    if (form) {
	      form.reset();
	    }
	  };
	
	  function beginUpload() {
	    var url = octopusRepository.Packages.getUploadUrl({ replace: $scope.uploadOptions.replace });
	    $scope.isUploading.promise(octoUpload.begin(url).then(function(uploaded){
	      $location.path('/library/packages/' + uploaded.Id);
	    }));
	  }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('PackageVersionsController', function($scope, $location, busy, $stateParams, $state, octopusRepository, octoDialog) {
	  var isLoading = $scope.isLoading = busy.create();
	
	  var packageId = $stateParams["packageId"];
	  $scope.routePackageId = packageId;
	
	  isLoading.promise(octopusRepository.Packages.list({ nuGetPackageId: packageId }).then(function(versions){
	    $scope.package = versions.Items[0];
	    $scope.packageVersions = versions;
	    $scope.view = { allSelected: false };
	    $scope.noneSelected = function() {
	      if (_.find($scope.packageVersions.Items, function(item){ return item.IsSelected; })) {
	        return false;
	      }
	      return true;
	    };
	    $scope.$watch("view.allSelected", function(nv){
	      if (!nv) {
	        if (_.find($scope.packageVersions.Items, function(item){ return !item.IsSelected; })){
	          return;
	        }
	      }
	      _.each($scope.packageVersions.Items, function(item){
	        item.IsSelected = nv;
	      });
	    });
	
	    $scope.deleteSelected = function() {
	      var w = 'Deleting packages will permanently remove files from disk. Are you sure you want to delete these packages?';
	      var packageIds = _.map(
	        _.filter(
	          $scope.packageVersions.Items,
	          function(item) { return item.IsSelected; }),
	        function(item){
	          return item.Id;
	        }).join(',');
	
	      octoDialog.asyncConfirm({
	        title: "Delete packages",
	        message: w,
	        executeButtonClass: "btn-danger",
	        executeButtonText: "Delete",
	        execute: function (dialog) {
	          dialog.busy.promise(octopusRepository.Packages.deleteMany(packageIds).then(function () {
	            dialog.dismiss();
	            $state.reload();
	          }));
	        }
	      });
	    };
	  }));
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('PackagesIndexController', function($scope, $location, busy, octopusRepository, octopusClient, octopusPermissionSet, $q) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isFiltering = $scope.isFiltering = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    function init() {
	        octopusPermissionSet.firstAuthorized(["FeedView", "LifecycleEdit", "VariableView", "ActionTemplateView"]).then(function (p) {
	            if (p === "FeedView") {
	                load();
	            } else if (p === "LifecycleEdit") {
	                $location.path('/library/lifecycles');
	            } else if (p === "VariableView") {
	                $location.path('/library/scripts');
	            } else if (p === "ActionTemplateView") {
	                $location.path('/library/steptemplates');
	            }
	        });
	    }
	
	    $scope.lastSyncTextClass = 'built-in-repository-sync-default';
	    $scope.lastSyncFailed = false;
	    $scope.lastSyncTaskUrl = '';
	    $scope.config = {
	        isBuiltInRepoSyncEnabled: false
	    };
	
	    var load = function() {
	        var serverStatusPromise = octopusRepository.ServerStatus.getServerStatus().then(function(status){
	            return octopusRepository.ServerStatus.getBuiltInFeedStats(status).then(function(builtIn){
	                $scope.builtIn = {
	                    feedId: 'feeds-builtin',
	                    totalPackages: builtIn.TotalPackages,
	                    indexingStatus: builtIn.IndexingStatus,
	                    synchronizationStatus: builtIn.SynchronizationStatus,
	                    nuGetPushUrl: octopusClient.resolve(builtIn.Links["NuGetPush"]),
	                    apiPushUrl: octopusClient.resolve(builtIn.Links["ApiPush"])
	                };
	            });
	        });
	        var packagesPromise = octopusRepository.Packages.list({ latest: true }).then(function(packages){
	            $scope.packages = packages;
	        });
	        var configurationPromise = octopusRepository.FeaturesConfiguration.get().then(function (config) {
	            $scope.config = config;
	        });
	        var packageRepositoryPromise = octopusPermissionSet.isAuthorized({ permission: 'AdministerSystem' }).then(function(yn) {
	            if (yn){
	                return isLoading.promise(octopusRepository.PackageRepository.getConfiguration().then(function(repository){
	                    $scope.repository = repository;
	                }));
	            }
	        });
	
	        isLoading.promise($q.all([serverStatusPromise, packagesPromise, configurationPromise, packageRepositoryPromise]).then(function () {
	            $scope.view = { filter: '', filtering: false };
	            $scope.filter = function () {
	                isFiltering.promise(octopusRepository.Packages.list({ filter: $scope.view.filter, latest: true }).then(function(packages){
	                    $scope.packages = packages;
	                    $scope.view.filtering = true;
	                }));
	            };
	
	            octopusRepository.Tasks.filter({name: 'SynchronizeBuiltInPackageRepositoryIndex', take: 1}).then(function(tasks) {
	                if (_.size(tasks.Items) > 0) {
	                    var completedTasks = _.filter(tasks.Items, function(value) { return value.CompletedTime != null; });
	                    var tasksByCompleted = _.sortBy(completedTasks, 'CompletedTime');
	
	                    var task = _.last(tasksByCompleted);
	                    $scope.lastSyncTextClass = task.FinishedSuccessfully ? 'built-in-repository-sync-success' : 'built-in-repository-sync-failed';
	                    $scope.lastSyncFailed = !task.FinishedSuccessfully;
	                    $scope.lastSyncTaskUrl = '#/tasks/' + task.Id;
	                }
	            });
	        }));
	    };
	
	    $scope.save = function() {
	        isSaving.promise(octopusRepository.FeaturesConfiguration.modify($scope.config).then(function(config) {
	        $scope.config = config;
	    }));
	    };
	
	    $scope.synchronizeBuiltInPackageRepositoryIndex = function() {
	        octopusPermissionSet.isAuthorized({ permission: 'AdministerSystem' }).then(function(yn) {
	            if (yn){
	                var task = {
	            Name: 'SynchronizeBuiltInPackageRepositoryIndex',
	            Description: 'Re-index built-in package repository'
	        };
	                $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
	            $location.path("/tasks/" + result.Id);
	        }));
	            }
	        });
	    };
	
	    init();
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('ScriptModuleEditController', function($scope, $stateParams, $state, $location, busy, pageTitle, octopusRepository, unsavedChanges) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  var scriptModuleId = $stateParams["scriptModuleId"];
	  $scope.tab = 'body';
	  $scope.changeTab = function (v) { $scope.tab = v; };
	
	  $scope.scriptModule = null;
	  $scope.view = { scriptBody: null };
	  $scope.vs = null;
	
	  var load = function() {
	    if (scriptModuleId) {
	      isLoading.promise(octopusRepository.LibraryVariableSets.get(scriptModuleId).then(function (scriptModule) {
	        isLoading.promise(octopusRepository.Variables.get(scriptModule.VariableSetId).then(function(vs){
	          $scope.scriptModule = scriptModule;
	          pageTitle(scriptModule.Name);
	
	          $scope.vs = vs;
	
	          $scope.bodyVar = _.find(vs.Variables, function(v){
	            return v.Name.startsWith('Octopus.Script.Module[');
	          });
	
	          if ($scope.bodyVar) {
	            $scope.view.scriptBody = $scope.bodyVar.Value;
	          } else {
	            $scope.view.scriptBody = 'function Say-Hello()\r\n{\r\n    Write-Output "Hello, Octopus!"\r\n}\r\n';
	          }
	        }));
	      }));
	    } else {
	      $scope.scriptModule = { ContentType: 'ScriptModule' };
	      pageTitle('New Script Module');
	    }
	  };
	
	  $scope.save = function() {
	    if ($scope.scriptModule.Id) {
	      var v = $scope.bodyVar;
	      if (!v) {
	        v = {};
	        $scope.vs.Variables.push(v);
	      }
	
	      v.Name = 'Octopus.Script.Module[' + $scope.scriptModule.Name + ']';
	      v.Value = $scope.view.scriptBody;
	
	      isSaving.promise(octopusRepository.LibraryVariableSets.modify($scope.scriptModule).then(function() {
	        isSaving.promise(octopusRepository.Variables.modify($scope.vs).then(function(){
	          unsavedChanges.saved();
	          $state.reload();
	        }));
	      }));
	    } else {
	      isSaving.promise(octopusRepository.LibraryVariableSets.create($scope.scriptModule).then(function(scriptModule){
	        unsavedChanges.saved();
	        $location.path('/library/scripts/' + scriptModule.Id);
	      }));
	    }
	  };
	
	  load();
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 460 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('ScriptModulesIndexController', function($scope, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  isLoading.promise(octopusRepository.LibraryVariableSets.list({contentType: 'ScriptModule'}).then(function (scriptModules) {
	    $scope.scriptModules = scriptModules;
	  }));
	});
	


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.library');
	
	module.controller('ActionTemplateLogoController', function ($scope, $location, $stateParams, busy, octopusRepository, octoUploader, octopusClient, $filter) {
	    var id = $stateParams["id"];
	    var octoUpload = octoUploader.create($scope);
	
	    $scope.resolveLink = $filter('resolveLink');
	    $scope.isLoading = busy.create();
	    $scope.isUploading = busy.create();
	    $scope.octoUpload = octoUpload;
	    $scope.beginReset = beginReset;
	    $scope.beginUpload = beginUpload;
	
	
	    $scope.cancel = function () {
	        octoUpload.cancel();
	
	        var form = $("#logoUpload")[0];
	        if (form) {
	            form.reset();
	        }
	    };
	
	    function init() {
	        $scope.isLoading.promise(octopusRepository.ActionTemplates.get(id).then(onActionTemplateLoaded));
	    }
	
	    function beginUpload() {
	        var url = octopusClient.resolve($scope.actionTemplate.Links['Logo']);
	        $scope.isUploading.promise(octoUpload.begin(url).then(function () {
	            $location.path('/library/steptemplates/' + $scope.actionTemplate.Id).search('activeTab', 'settings');
	        }));
	    }
	
	    function beginReset() {
	        $scope.isUploading.promise(octopusClient.put($scope.actionTemplate.Links['Logo'], null).then(function () {
	            $location.path('/library/steptemplates/' + $scope.actionTemplate.Id).search('activeTab', 'settings');
	        }));
	    }
	
	    function onActionTemplateLoaded(actionTemplate) {
	        $scope.actionTemplate = actionTemplate;
	    }
	
	    init();
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 462 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('StepTemplateDetailsController', function ($scope, busy, $stateParams, $location, octopusRepository, octopusPermissionSet, $filter, actionTemplateProcessor) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var source = $location.search().from;
	    var projectId = source !== 'communityinstall' && source !== 'communityupdate' ? source : null;
	
	    $location.search('activeTab', null); // Reset activeTab
	
	    $scope.projectIdUrlFragment = '?from=' + source;
	    $scope.templateId = $stateParams["id"];
	    $scope.resolveLink = $filter('resolveLink');
	
	    if (source === 'communityinstall') {
	        $scope.cancelButtonName = 'Cancel';
	        $scope.installButtonName = 'Install';
	    } else if (source === 'communityupdate') {
	        $scope.cancelButtonName = 'Cancel';
	        $scope.updateButtonName = 'Update';
	    }
	
	    $scope.cancel = function() {
	        $location.search("from", null);
	        if (projectId ) {
	            $location.path("/projects/" + projectId + "/steptemplates");
	        } else if (source === 'communityinstall') {
	            $location.path("/library/steptemplates/community/");
	        } else {
	            $location.path("/library/steptemplates/" + $scope.templateId).search("activeTab", "settings");
	        }
	    };
	
	    $scope.redirectToActionTemplateEditor = function(actionTemplate) {
	        if (projectId) {
	            $location.path("/projects/" + source + "/process/step/new/" + actionTemplate.ActionType + "/" + actionTemplate.Id);
	        }
	        else if (source === 'communityinstall') {
	            $location.path("/library/steptemplates/" + actionTemplate.Id);
	        }
	        else {
	            $location.path("/library/steptemplates/" + actionTemplate.Id).search("activeTab", "usage");
	        }
	    };
	
	    $scope.install = function() {
	        return actionTemplateProcessor.installCommunityActionTemplate($scope.communityTemplate, $scope.redirectToActionTemplateEditor, false, isSaving);
	    };
	
	    $scope.update = function() {
	        return actionTemplateProcessor.updateCommunityActionTemplateInstallation($scope.communityTemplate, $scope.redirectToActionTemplateEditor, isSaving);
	    };
	
	    if (projectId || source === 'communityinstall') {
	        isLoading.promise(octopusRepository.CommunityActionTemplates.get($scope.templateId).then(function (communityTemplate) {
	
	            $scope.communityTemplate = communityTemplate;
	            isLoading.promise(octopusRepository.ActionTemplates.getByCommunityTemplate(communityTemplate)).then(function(actionTemplate){
	                $scope.actionTemplate = actionTemplate;
	                $scope.currentVersion = actionTemplate.Version;
	            }).catch(function(error){
	                if (error.StatusCode === 404) {
	                    isLoading.clearError();
	                } else {
	                    throw error;
	                }
	            });
	        }));
	    }
	    else {
	        isLoading.promise(octopusRepository.ActionTemplates.get($scope.templateId)).then(function(actionTemplate){
	            $scope.actionTemplate = actionTemplate;
	            $scope.currentVersion = actionTemplate.Version;
	            isLoading.promise(octopusRepository.CommunityActionTemplates.get(actionTemplate.CommunityActionTemplateId).then(function (communityTemplate) {
	                $scope.communityTemplate = communityTemplate;
	            }).catch(function(error){
	                if (error.StatusCode === 404) {
	                    isLoading.clearError();
	                } else {
	                    throw error;
	                }
	            }));
	
	        });
	    }
	
	
	});
	
	
	


/***/ },
/* 463 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('CommunityStepTemplateSaveAsController', function ($scope, busy, octopusRepository, action, $uibModalInstance) {
	    $scope.newActionName = action.Name + ' Copy';
	    $scope.newActionDescription = action.Description;
	    $scope.action = action;
	
	    $scope.close = function() {
	        $uibModalInstance.close(true);
	    };
	
	    $scope.cancel = function() {
	        $uibModalInstance.close();
	    };
	
	    $scope.save = function() {
	        $uibModalInstance.close($scope.newActionName);
	    };
	});

/***/ },
/* 464 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('CommunityStepTemplateUpdateController', function ($scope, $location, busy, octopusRepository, actionTemplate, communityStepTemplate, $uibModalInstance) {
	    $scope.newActionName = actionTemplate.Name + ' Copy';
	    $scope.newActionDescription = actionTemplate.Description;
	    $scope.action = actionTemplate;
	    $scope.communityStepTemplate = communityStepTemplate;
	
	    $scope.close = function() {
	        $uibModalInstance.dismiss();
	    };
	
	    $scope.cancel = function() {
	        $uibModalInstance.dismiss();
	    };
	
	    $scope.showDetails = function() {
	        $uibModalInstance.dismiss();
	        $location.search('activeTab', null);
	        $location.path("/library/steptemplates/community/" + $scope.action.Id + "/details").search("from", "communityupdate");
	    };
	
	    $scope.update = function() {
	        var update = true;
	        $uibModalInstance.close(update);
	    };
	});

/***/ },
/* 465 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('DefaultActionPropertyValuesController', function ($scope, $uibModalInstance, parameters, defaultPropertyValues, actionTemplateName, isGlobalUpdate) {
	    $scope.parameters = parameters;
	    $scope.defaultPropertyValues = defaultPropertyValues;
	    $scope.actionTemplateName = actionTemplateName;
	    $scope.isGlobalUpdate = isGlobalUpdate;
	
	    $scope.apply = function () {
	        $uibModalInstance.close($scope.defaultPropertyValues);
	    };
	
	    $scope.cancel = function () {
	        $uibModalInstance.dismiss();
	    };
	});

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('StepTemplateEditController', function ($scope, $stateParams, $state, $location,
	                                                          busy, octopusRepository, unsavedChanges,
	                                                          templateParameterModal, pluginRegistry, $uibModal, $q, $filter, actionUpdater, actionTemplateProcessor) {
	    $scope.resolveLink = $filter('resolveLink');
	
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    var id = $stateParams["id"];
	    var actionType = $stateParams["actionType"];
	
	    $scope.isCommunityTemplate = false;
	
	    $scope.noprop = {};
	    var queryString = $location.search();
	    if (queryString.activeTab) {
	        $scope.tab = queryString.activeTab;
	    } else {
	        $scope.tab = id ? 'step' : 'settings';
	    }
	
	    $scope.changeTab = function (selectedTab) {
	        $scope.tab = selectedTab;
	        $scope.unsavedChanges.ignoreNextLocationChange();
	        $location.search('activeTab', selectedTab);
	    };
	
	    $scope.unsavedChanges = unsavedChanges;
	
	    var updateLocalNames = function () {
	        if ($scope.actionTemplate && $scope.actionTemplate.Parameters) {
	            $scope.localNames = _.pluck(_.sortBy($scope.actionTemplate.Parameters, 'Name'), 'Name');
	        } else {
	            $scope.localNames = [];
	        }
	    };
	
	    var validateFeatures = function () {
	        if ($scope.actionTemplate && $scope.actionTemplate.Properties && $scope.actionTemplate.Properties["Octopus.Action.EnabledFeatures"]) {
	            var enabledFeatures = $scope.actionTemplate.Properties["Octopus.Action.EnabledFeatures"].split(',');
	            var errors = [];
	            _.each(enabledFeatures, function (f) {
	                var feature = pluginRegistry.getFeature(f);
	                if (feature.validate) {
	                    feature.validate($scope.actionTemplate, $scope.step, errors);
	                }
	            });
	
	            if (errors.length > 0) {
	                isSaving.showErrors("There was a problem with your request.", errors);
	                return false;
	            }
	        }
	
	        return true;
	    };
	
	    var actionTemplateLoader;
	    if (id) {
	        actionTemplateLoader = octopusRepository.ActionTemplates.get(id);
	    } else {
	        actionTemplateLoader = octopusRepository.ActionTemplates.search().then(function(allStepTemplates) {
	            var tmpTemplate = _.find(allStepTemplates, function(template) {
	                return template.Type === actionType && template.IsBuiltIn && template.IsInstalled;
	            });
	
	            var template = {ActionType: actionType, Properties: {}, Parameters: [], Links: tmpTemplate.Links};
	            return template;
	        });
	    }
	
	    $scope.findAction = function (actionId, steps) {
	        var action = steps.map(function (step) {
	            return step.Actions;
	        })
	            .reduce(function (result, actions) {
	                return result.concat(actions);
	            })
	            .filter(function (action) {
	                return action.Id === actionId;
	            })[0];
	
	        return action;
	    };
	
	    $scope.getParametersRequiringManualIntervention = function(action, actionTemplate){
	        return actionTemplate.Parameters.filter(function(p)
	        {
	            var property = action.Properties[p.Name];
	            if (!property) {
	                return !actionUpdater.hasParameterDefaultValue(p);
	            } else {
	                return actionUpdater.isPropertySensitive(property) && !actionUpdater.isParameterSensitive(p);
	            }
	        });
	    };
	
	    $scope.updateDeploymentProcess = function (deploymentProcess, actionsToUpdate, actionTemplate, defaultPropertyValues) {
	        actionsToUpdate.forEach(function(actionToUpdate){
	            actionUpdater.update(actionToUpdate, actionTemplate, defaultPropertyValues);
	        });
	
	        return octopusRepository.DeploymentProcesses.modify(deploymentProcess);
	    };
	
	
	    $scope.getAllDeploymentProcesses = function(deploymentProcessIds){
	        var promises = deploymentProcessIds.map(function(deploymentProcessId){
	            return isLoading.promise(octopusRepository.DeploymentProcesses.get(deploymentProcessId));
	        });
	
	        return $q.all(promises);
	    };
	
	    $scope.mapActionsToDeploymentProcess = function(usages) {
	        var deploymentProcessIds = _.uniq(usages.map(function(u){ return u.DeploymentProcessId; }));
	        return $scope.getAllDeploymentProcesses(deploymentProcessIds).then(function(deploymentProcesses){
	            return deploymentProcesses.map(function(deploymentProcess){
	               return {
	                   deploymentProcess: deploymentProcess,
	                   actionsToUpdate: usages.filter(function(u){
	                                              return u.DeploymentProcessId === deploymentProcess.Id;
	                                           })
	                                            .map(function(u){
	                                                return $scope.findAction(u.ActionId, deploymentProcess.Steps);
	                                            })
	               };
	            });
	        });
	    };
	
	    $scope.updateAllProjects = function (usages) {
	        $scope.mapActionsToDeploymentProcess(usages).then(function(deploymentProcessesToActions){
	            var allActionsToUpdate =_.flatten(deploymentProcessesToActions.map(function(deploymentProcessToActions){
	                return deploymentProcessToActions.actionsToUpdate;
	            }));
	
	            var actionsByVersion = _.groupBy(allActionsToUpdate, function(action){
	               return action.Properties["Octopus.Action.Template.Version"];
	            });
	
	            var parameterHash = {};
	            Object.keys(actionsByVersion).forEach(function(version){
	                $scope.getParametersRequiringManualIntervention(actionsByVersion[version][0], $scope.actionTemplate)
	                    .forEach(function(p) {
	                        parameterHash[p.Name] = p;
	                    });
	            });
	
	            var parametersToSet = Object.keys(parameterHash).map(function(name){
	                return parameterHash[name];
	            });
	
	            $scope.gatherDefaultPropertyValues(parametersToSet, true)
	                    .then(function (defaultPropertyValues) {
	                        var promisses = deploymentProcessesToActions.map(function(group){
	                            return isSaving.promise($scope.updateDeploymentProcess(group.deploymentProcess, group.actionsToUpdate, $scope.actionTemplate, defaultPropertyValues));
	                        });
	
	                        $q.all(promisses).then(function(updated){
	                            $state.reload();
	                        });
	                    });
	        });
	    };
	
	    $scope.updateAction = function (deploymentProcessId, actionId) {
	        isSaving.promise(octopusRepository.DeploymentProcesses.get(deploymentProcessId).then(function(deploymentProcess){
	            var action = $scope.findAction(actionId, deploymentProcess.Steps);
	            var parametersToSet = $scope.getParametersRequiringManualIntervention(action, $scope.actionTemplate);
	            $scope.gatherDefaultPropertyValues(parametersToSet, false)
	                    .then(function (defaultPropertyValues) {
	                        isSaving.promise($scope.updateDeploymentProcess(deploymentProcess, [action], $scope.actionTemplate, defaultPropertyValues))
	                                .then(function (updated) {
	                                    $state.reload();
	                                });
	                    });
	        }));
	    };
	
	    $scope.gatherDefaultPropertyValues = function(parametersToSet, isGlobalUpdate){
	        if (!parametersToSet.length) {
	            var deferred = $q.defer();
	            deferred.resolve({});
	            return deferred.promise;
	        }
	
	        return $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/library/steps/views/default_action_property_values.html',
	            controller: 'DefaultActionPropertyValuesController',
	            dialogClass: 'modal modal-big',
	            resolve: {
	                parameters: function () {
	                    return parametersToSet;
	                },
	                defaultPropertyValues: function(){
	                    return {};
	                },
	                actionTemplateName : function(){
	                    return $scope.actionTemplate.Name;
	                },
	                isGlobalUpdate : function(){
	                    return isGlobalUpdate;
	                }
	            }
	        }).result;
	    };
	
	    isLoading.promise(actionTemplateLoader.then(function (actionTemplate) {
	
	        var stepTemplateLoader = actionTemplate.CommunityActionTemplateId ? octopusRepository.CommunityActionTemplates.get(actionTemplate.CommunityActionTemplateId) : $q.resolve([]);
	        var feedsLoader = octopusRepository.Feeds.all();
	        var loaders = [stepTemplateLoader, feedsLoader];
	
	        isLoading.promise($q.all(loaders).then(function (results) {
	
	            var communityStepTemplate = results[0];
	            var feeds = results[1];
	
	            $scope.actionTemplate = actionTemplate;
	            $scope.communityStepTemplate = communityStepTemplate;
	            $scope.hasUpdate = communityStepTemplate && actionTemplate.Version < communityStepTemplate.Version;
	            $scope.isCommunityTemplate = actionTemplate.CommunityActionTemplateId != null;
	            $scope.feeds = feeds;
	            $scope.hasFeatures = pluginRegistry.hasFeaturesForAction(actionTemplate.ActionType);
	
	            if (actionTemplate.Id) {
	                isLoading.promise(octopusRepository.ActionTemplates.getUsage(actionTemplate).then(function (usage) {
	                    $scope.usage = usage;
	
	                    $scope.pendingUpdates = 0;
	                    _.each(usage, function (u) {
	                        if (u.Version.toString() !== actionTemplate.Version.toString()) {
	                            $scope.pendingUpdates++;
	                        }
	                    });
	                }));
	            }
	
	            updateLocalNames();
	
	            $scope.templateEditor = templateParameterModal.create($scope.actionTemplate.Parameters, {
	                name: 'Step Template Parameter',
	                onChange: updateLocalNames
	            });
	
	            $scope.showAddFeaturesDialog = function () {
	                $uibModal.open({
	                    backdrop: true,
	                    keyboard: true,
	                    templateUrl: 'areas/projects/views/process_features_dialog.html',
	                    controller: 'ProjectProcessFeaturesController',
	                    dialogClass: 'modal modal-big',
	                    resolve: {
	                        currentAction: function () {
	                            return $scope.actionTemplate;
	                        },
	                        currentStep: function () {
	                            return null;
	                        }
	                    }
	                });
	            };
	
	            $scope.updateTemplate = function () {
	
	                $uibModal.open({
	                    backdrop: true,
	                    keyboard: true,
	                    templateUrl: 'areas/library/steps/views/community_step_template_update.html',
	                    controller: 'CommunityStepTemplateUpdateController',
	                    resolve: {
	                        actionTemplate: function () {
	                            return $scope.actionTemplate;
	                        },
	                        communityStepTemplate: function() {
	                            return $scope.communityStepTemplate;
	                        }
	                    }
	                }).result.then(function (update) {
	                    if (update) {
	                        return actionTemplateProcessor.updateCommunityActionTemplateInstallation($scope.communityStepTemplate, null, isSaving)
	                                                        .then(function () {
	                                                            $scope.changeTab('usage');
	                                                            $state.reload();
	                                                        });
	                    }
	                });
	
	            };
	
	            $scope.saveAsCopy = function () {
	                if (validateFeatures()) {
	                    $uibModal.open({
	                        backdrop: true,
	                        keyboard: true,
	                        templateUrl: 'areas/library/steps/views/community_step_template_saveas.html',
	                        controller: 'CommunityStepTemplateSaveAsController',
	                        resolve: {
	                            action: function () {
	                                return $scope.actionTemplate;
	                            }
	                        }
	                    }).result.then(function (newActionName) {
	                        if (newActionName) {
	                            actionTemplateProcessor.cloneActionTemplate(
	                                $scope.actionTemplate,
	                                newActionName,
	                                function(actionTemplate) { return "/library/steptemplates/" + actionTemplate.Id; },
	                                isSaving,
	                                function() { unsavedChanges.saved(); });
	                        }
	                    });
	                }
	            };
	
	            $scope.save = function () {
	                if (validateFeatures()) {
	                    var isNew = !id;
	                    isSaving.promise(octopusRepository.ActionTemplates.save($scope.actionTemplate).then(function (saved) {
	                        unsavedChanges.saved();
	                        if (isNew) {
	                            $location.path('/library/steptemplates/' + saved.Id);
	                        } else {
	                            $state.reload();
	                        }
	                    }));
	                }
	            };
	
	            $scope.export = function () {
	                // Prevent exporting until changes are saved
	                if (unsavedChanges.hasUnsavedChanges()) {
	                    return;
	                }
	
	                $uibModal.open({
	                    backdrop: true,
	                    keyboard: true,
	                    templateUrl: 'areas/shared/views/export_entity_dialog.html',
	                    controller: 'ExportEntityDialogController',
	                    dialogClass: 'modal modal-big',
	                    resolve: {
	                        entity: function () {
	                            return $scope.actionTemplate;
	                        },
	                        entityType: function () {
	                            return 'ActionTemplate';
	                        }
	                    }
	                });
	            };
	        }));
	    }));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('StepTemplateRunController', function ($scope, $stateParams, $location,
	                                                        busy, octopusRepository, unsavedChanges,
	                                                        templateParameterModal, pluginRegistry, $uibModal, $q, actionUpdater) {
	    $scope.resolveLink = octopusRepository.resolve;
	
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var id = $stateParams["id"];
	    var actionType = $stateParams["actionType"];
	    var retry = $stateParams["retry"];
	    
	    $scope.actionTemplate = null;
	    $scope.vm = {};
	    $scope.vm.selectionModes = ['Machines', 'Environments'];
	    $scope.vm.selectionMode = $scope.vm.selectionModes[0];
	    $scope.vm.environmentIds = [];
	    $scope.vm.targetRoles = [];
	    $scope.vm.machineIds = [];
	    $scope.action = { Properties: {} };
	
	    $scope.unsavedChanges = unsavedChanges;
	
	    var updateLocalNames = function () {
	        if ($scope.actionTemplate && $scope.actionTemplate.Parameters) {
	            $scope.localNames = _.pluck(_.sortBy($scope.actionTemplate.Parameters, 'Name'), 'Name');
	        } else {
	            $scope.localNames = [];
	        }
	    };
	
	    var dependsOnStepName = function(actionTemplate){
	        return actionTemplate.Parameters && actionTemplate.Parameters.some(function(p){
	                                                                                return p.DisplaySettings &&  p.DisplaySettings["Octopus.ControlType"] === "StepName";
	                                                                            });
	    };
	
	    var resources = [
	        octopusRepository.ActionTemplates.get(id),
	        octopusRepository.Environments.all(), 
	        octopusRepository.Machines.all(), 
	        octopusRepository.MachineRoles.all()
	    ];
	
	    isLoading.promise($q.all(resources).then(function (data) {
	        $scope.actionTemplate = data[0];
	        $scope.vm.environments = data[1];
	        $scope.vm.machines = data[2];
	        $scope.vm.availableRoles = data[3];
	        $scope.isCommunityTemplate = $scope.actionTemplate.CommunityActionTemplateId != null;
	        updateLocalNames();
	        unsavedChanges.saved();
	
	        $scope.dependsOnStepName = dependsOnStepName($scope.actionTemplate);
	
	        if (retry) {
	            isLoading.promise(octopusRepository.Tasks.get(retry).then(function (retried) {
	                $scope.action.Properties = retried.Arguments.Properties;
	                // Sensitive values for ad-hoc tasks aren't available to be re-used on the server - 
	                // the API needs to indicate that we have a value for the property, but running 
	                // a new task without changing those values will result in using no value (instead
	                // of the last saved value). This is correct behavior from the API/server and ensures
	                // no one can re-submit a task using sensitive values without knowing the values. 
	                // But it's misleading to our UI on this page to show that we have a value, as users
	                // would expect it to just work. So we clear any sensitive values here.
	                for (var prop in $scope.action.Properties) {  
	                    if (_.has($scope.action.Properties[prop], 'HasValue')) {
	                        $scope.action.Properties[prop] = null;
	                    }
	                }
	
	                if (retried.Arguments.MachineIds && retried.Arguments.MachineIds.length > 0) {
	                    $scope.vm.machineIds = retried.Arguments.MachineIds;
	                    $scope.vm.selectionMode = 'Machines';
	                } else {
	                    $scope.vm.environmentIds = retried.Arguments.EnvironmentIds;
	                    $scope.vm.targetRoles = retried.Arguments.TargetRoles;
	                    $scope.vm.selectionMode = 'Environments';
	                }
	
	                unsavedChanges.saved();
	            }));
	        }
	    }));
	
	    $scope.run = function() {
	        var task = {
	            Name: 'AdHocScript',
	            Description: 'Run step template: ' + $scope.actionTemplate.Name,
	            Arguments: {
	                ActionTemplateId: $scope.actionTemplate.Id,
	                Properties: $scope.action.Properties
	            }
	        };
	
	        if ($scope.vm.selectionMode === 'Machines') {
	            if ($scope.vm.machineIds.length === 0) {
	                isSaving.showError('At least one deployment target must be selected.');
	                return;
	            }
	            task.Arguments.MachineIds = $scope.vm.machineIds;
	        } else {
	            task.Arguments.EnvironmentIds = $scope.vm.environmentIds;
	            task.Arguments.TargetRoles = $scope.vm.targetRoles;
	        }
	
	        isSaving.promise(octopusRepository.Tasks.create(task).then(function (created) {
	            unsavedChanges.saved();
	            $location.path('/tasks/' + created.Id);
	        }));
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 468 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('LibraryStepTemplatesController', function ($scope, busy, $location, pageTitle, octopusRepository, octopusPermissionSet, $filter, actionTemplateProcessor) {
	
	    var isLoading = $scope.isLoading = busy.create();
	    var isInstalling = $scope.isInstalling = busy.create();
	
	    var addCustomStep = $location.path().indexOf('/library/steptemplates/builtin/') !== -1;
	    $scope.installCommunityStep = !addCustomStep;
	
	    $scope.installButtonName = "Install";
	    $scope.addButtonName = "Add";
	    $scope.resolveLink = $filter('resolveLink');
	
	    $scope.add = function (actionType) {
	        var url = "/library/steptemplates/new/" + actionType;
	        $location.path(url);
	    };
	
	    $scope.install = function (id) {
	        return isLoading.promise(octopusRepository.CommunityActionTemplates.get(id).then(function (template) {
	            return actionTemplateProcessor.installCommunityActionTemplate(template, function (actionTemplateId) {
	                return "/library/steptemplates";
	            }, true, isInstalling);
	        }));
	    };
	
	    $scope.update = function (id) {
	        // no updates
	    };
	
	    $scope.details = function (id) {
	        var url = "/library/steptemplates/community/" + id + "/details";
	        $location.path(url).search("from", "communityinstall");
	    };
	
	    $scope.allTemplates = [];
	    $scope.filteredLibraryTemplates = [];
	    $scope.enableGrouping = true;
	
	    $scope.filterTemplates = function () {
	        $scope.enableGrouping = !(!!this.inputText);
	
	        if (addCustomStep) {
	            // Add custom step
	            $scope.filteredBuiltInTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
	                return template.IsBuiltIn;
	            });
	            $scope.filteredLibraryTemplates = null;
	        }
	        else {
	            // Add community step
	            $scope.filteredBuiltInTemplates = null;
	            $scope.filteredLibraryTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
	                return !template.IsInstalled;
	            });
	        }
	    };
	
	    isLoading.promise(actionTemplateProcessor.getActionTemplates().then(function (templates) {
	        $scope.allTemplates = templates;
	        $scope.filterTemplates();
	
	        isLoading.promise(actionTemplateProcessor.getActionTemplatesAuthorizationAndFeatureConfig().then(function (results) {
	            $scope.showActionTemplateTeaser = !results.isAuthorized;
	            $scope.showLibraryTemplateTeaser = !results.configuration.IsCommunityActionTemplatesEnabled;
	        }));
	    }));
	
	});
	
	
	


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('StepTemplatesIndexController', function ($scope, $location, $uibModal, $q, busy, octopusRepository, $filter) {
	    var isLoading = $scope.isLoading = busy.create();
	
	    $scope.IsCommunityActionTemplatesEnabled = true;
	    $scope.addCustomStepTemplateUrl = "#/library/steptemplates/builtin/";
	    $scope.installCommunityStepTempalteUrl = "#/library/steptemplates/community/";
	    $scope.communityStepTemplates = [];
	    $scope.userStepTemplates = [];
	
	    $scope.resolve = octopusRepository.resolve;
	    $scope.resolveLink = $filter('resolveLink');
	
	    var stepTemplatesLoader = octopusRepository.ActionTemplates.search();
	    var featuresLoader = octopusRepository.FeaturesConfiguration.get();
	    var loaders = [stepTemplatesLoader, featuresLoader];
	
	    isLoading.promise($q.all(loaders).then(function(results) {
	
	        var allStepTemplates = results[0];
	        var featureConfig = results[1];
	        $scope.IsCommunityActionTemplatesEnabled = featureConfig.IsCommunityActionTemplatesEnabled;
	
	        $scope.userStepTemplates = _.filter(allStepTemplates, function (template) {
	            return template.IsInstalled && !template.IsBuiltIn && template.CommunityActionTemplateId == null;
	        });
	
	        $scope.communityStepTemplates = _.filter(allStepTemplates, function(template) {
	            return !template.IsBuiltIn && template.CommunityActionTemplateId != null;
	        });
	
	        var installedStepTemplateId = $location.search().installedStep;
	        var installedStepTemplate = _.find($scope.communityStepTemplates, function(template) { return template.Id === installedStepTemplateId; });
	        _.extend(installedStepTemplate, {stepInstalledSuccessfully: true});
	
	    }));
	
	    $scope.addCustomStepTemplate = function () {
	
	        $location.path("/library/" + $scope.project.Slug + "/steptemplates");
	
	    };
	
	    $scope.installCommunityStepTemplate = function () {
	
	        $location.path("/library/steptemplates/community/");
	
	    };
	
	    $scope.addImport = function () {
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/shared/views/import_entity_dialog.html',
	            controller: 'ImportEntityDialogController',
	            dialogClass: 'modal modal-big',
	            resolve: {
	                entityType: function () {
	                    return 'ActionTemplate';
	                },
	                doImport: function () {
	                    return function (result) {
	                        return octopusRepository.ActionTemplates.create(result).then(function (created) {
	                            $location.path("/library/steptemplates/" + created.Id);
	                        });
	                    };
	                }
	            }
	        });
	    };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 470 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.directive('colorPicker', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            color: '=',
	            selectColor: '&onSelectColor'
	        },
	        templateUrl: 'areas/library/tagsets/views/color_picker.html',
	        link: function (scope, element) {
	        },
	        controller: function ($scope) {
	            $scope.colorSet1 = ['#983230', '#A77B22', '#227647', '#52818C', '#203A88', '#752BA5', '#6e6e6e'];
	            $scope.colorSet2 = ['#E8634F', '#ECAD3F', '#36A766', '#77B7C5', '#3156B3', '#9786A7', '#9d9d9d'];
	        }
	    };
	});

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('TagSetEditController', function($scope, $timeout, $stateParams, $state, $location, busy, pageTitle, octopusRepository, unsavedChanges, octoDialog) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    var tagSetId = $stateParams["id"];
	
	    $scope.tagSet = null;
	    $scope.newTag = null;
	    $scope.tagToEdit = null;
	    $scope.showRemovedTagWarning = false;
	    $scope.colorSet1 = ['#983230', '#A77B22', '#227647', '#52818C', '#203A88', '#752BA5', '#6e6e6e'];
	    $scope.colorSet2 = ['#E8634F', '#ECAD3F', '#36A766', '#77B7C5', '#3156B3', '#9786A7', '#9d9d9d'];
	
	    var resetTagSetEditingInProgress = function()  {
	        if ($scope.tagSet != null && $scope.tagSet.Tags != null) {
	            _.map($scope.tagSet.Tags, function(tag) { tag.isEditing = false; });
	        }
	    };
	
	    var load = function() {
	        if (tagSetId) {
	            isLoading.promise(octopusRepository.TagSets.get(tagSetId).then(function (tagSet) {
	                $scope.tagSet = tagSet;
	                resetTagSetEditingInProgress();
	                pageTitle(tagSet.Name);
	            }));
	        } else {
	            $scope.tagSet = {};
	            pageTitle('New Tenant Tag Set');
	        }
	        $scope.newTag = { Color: _.last($scope.colorSet1) };
	    };
	
	    $scope.selectAddColor = function(colorString) {
	
	        $scope.newTag.Color = colorString;
	        
	    };
	
	    $scope.selectEditColor = function(colorString) {
	
	        $scope.tagToEdit.Color = colorString;
	
	    };
	
	    $scope.addTag = function() {
	
	        var newTag = $scope.newTag;
	        $scope.tagSet.Tags.push(newTag);
	
	        unsavedChanges.unsaved();
	
	        $scope.newTag = { Color: _.last($scope.colorSet1) };
	
	    };
	
	    $scope.editTag = function (tag) {
	        resetTagSetEditingInProgress();
	        $scope.tagToEdit = JSON.parse(JSON.stringify(tag)); // Simple Clone
	        tag.isEditing = true;
	    };
	
	    $scope.cancelEdit = function (tag) {
	        tag.isEditing = false;
	    };
	
	    $scope.updateTag = function(tag) {
	        tag.Name = $scope.tagToEdit.Name;
	        tag.Description = $scope.tagToEdit.Description;
	        tag.Color = $scope.tagToEdit.Color;
	        tag.isEditing = false;
	        unsavedChanges.unsaved();
	    };
	
	    $scope.removeTag = function(tag) {
	        if (tag.Id) {
	            $scope.showRemovedTagWarning = true;
	        }
	        tag.isEditing = false;
	        tag.shouldBeRemoved = true;
	        unsavedChanges.unsaved();
	    };
	
	    $scope.undoRemoveTag = function(tag) {
	        tag.shouldBeRemoved = false;
	    };
	
	    $scope.save = function() {
	        var tagSetCopy = (JSON.parse(JSON.stringify($scope.tagSet))); //copy tagset so if save fails removed tags are still there
	        tagSetCopy.Tags = _.filter(tagSetCopy.Tags, function(tag) { return !tag.shouldBeRemoved; });
	        if (tagSetCopy.Id) {
	            isSaving.promise(octopusRepository.TagSets.modify(tagSetCopy).then(function(tagSet){
	                unsavedChanges.saved();
	                $state.reload();
	            }));
	        } else {
	            isSaving.promise(octopusRepository.TagSets.create(tagSetCopy).then(function(tagSet){
	                unsavedChanges.saved();
	                $location.path('/library/tagsets/' + tagSet.Id);
	            }));
	        }
	    };
	
	
	    var getTagFromTagSet = function(tagId) {
	        return _.find($scope.tagSet.Tags, function(tag) { return tag.Id === tagId; });
	    };
	
	    $scope.reorder = function() {
	        octoDialog.sort({
	            title: "Reorder Tags",
	            saveButtonText: "Update",
	            load: function(dialog) {
	                dialog.render(_.map($scope.tagSet.Tags, function (tag) {
	                    return {
	                        id: tag.Id,
	                        name: tag.Name
	                    };
	                }));
	            },
	            save: function (items, dialog) {
	
	                for (var i = 0; i < items.length; i++) {
	                    var tag = getTagFromTagSet(items[i]);
	                    if (tag !== undefined) {
	                        tag.SortOrder = i;
	                    }
	                }
	
	                $scope.tagSet.Tags = _.sortBy($scope.tagSet.Tags, 'SortOrder');
	                unsavedChanges.unsaved();
	                dialog.dismiss();
	            }
	        });
	    };
	
	    load();
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.library');
	
	module.controller('TagSetsIndexController', function($scope, $location, $state, busy, octopusRepository, octoDialog, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    isLoading.promise(octopusRepository.TagSets.list({contentType: 'TagSets'}).then(function (tagSets) {
	        $scope.tagSets = tagSets;
	    }));
	
	    $scope.reorder = function() {
	        octoDialog.sort({
	            title: "Reorder Tag Sets",
	            saveButtonText: "Save",
	            load: function(dialog) {
	                dialog.render(_.map($scope.tagSets.Items, function (tagSet) {
	                    return {
	                        id: tagSet.Id,
	                        name: tagSet.Name
	                    };
	                }));
	            },
	            save: function (items, dialog) {
	                dialog.busy.promise(octopusRepository.TagSets.sort(items).then(function() {
	                    dialog.dismiss();
	                    //$state.reload();
	                    unsavedChanges.saved();
	                }));
	            }
	        });
	    };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 473 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('VariableSetEditController', function ($scope, $timeout, $stateParams, $state, $location, busy, pageTitle,
	                                                         templateParameterModal, octopusRepository, unsavedChanges, scopeValuesToScopeOptionsConverter) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    var lvsId = $stateParams["id"];
	
	    $scope.lvs = null;
	    $scope.vs = null;
	    $scope.variableTemplates = [];
	    $scope.tab = 'values';
	    $scope.changeTab = changeTab;
	    $scope.templateEditor = null;
	    $scope.save = save;
	
	    $scope.$on("variableEditor:changesApplied", function (e, vs) {
	        isSaving.promise(octopusRepository.Variables.modify(vs).then(function () {
	            unsavedChanges.saved();
	            $state.reload();
	        }));
	    });
	
	    $scope.$on("variableEditor:dirty", function (e, vs) {
	        unsavedChanges.unsaved();
	    });
	
	    $scope.$on("variableEditor:clean", function (e, vs) {
	        unsavedChanges.saved();
	    });
	
	    function init() {
	        if (lvsId) {
	            isLoading.promise(octopusRepository.LibraryVariableSets.get(lvsId).then(function (lvs) {
	                $scope.templateEditor = templateParameterModal.create(lvs.Templates, {
	                    name: 'Library Variable Template',
	                    isTemplate: true,
	                    requiredPermission: 'VariableEdit'
	                });
	                isLoading.promise(octopusRepository.Variables.get(lvs.VariableSetId).then(function (vs) {
	                    $scope.lvs = lvs;
	                    pageTitle(lvs.Name);
	
	                    $scope.vs = vs;
	
	                    $scope.variableEditorOptions = {
	                        variableSet: vs,
	                        scopeOptions: scopeValuesToScopeOptionsConverter(vs.ScopeValues),
	                        canEdit: true,
	                        canScopeToTenantTags: true
	                    };
	
	                    $timeout(function () {
	                        $scope.showVariableEditor = true;
	                    }, 100);
	                }));
	            }));
	        } else {
	            $scope.lvs = {};
	            pageTitle('New Variable Set');
	        }
	    }
	
	    function changeTab(v) {
	        $scope.tab = v;
	    }
	
	    function save() {
	        if ($scope.lvs.Id) {
	            isSaving.promise(octopusRepository.LibraryVariableSets.modify($scope.lvs).then(function (lvs) {
	                // ? $scope.lvsForm.$setPristine();
	                if (unsavedChanges.hasUnsavedChanges()) {
	                    $scope.$broadcast("variableEditor:applyChanges", $scope.vs);
	                } else {
	                    unsavedChanges.saved();
	                    $state.reload();  // Until $setPristine() likes me
	                }
	            }));
	        } else {
	            isSaving.promise(octopusRepository.LibraryVariableSets.create($scope.lvs).then(function (lvs) {
	                unsavedChanges.saved();
	                $location.path('/library/variables/' + lvs.Id);
	            }));
	        }
	    }
	
	    init();
	});
	


/***/ },
/* 474 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.library');
	
	module.controller('VariableSetsIndexController', function($scope, $location, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  isLoading.promise(octopusRepository.LibraryVariableSets.list({contentType: 'Variables'}).then(function (variableSets) {
	    $scope.variableSets = variableSets;
	  }));
	});
	


/***/ },
/* 475 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('ScriptConsoleController', function ($scope, $q, busy, octopusRepository, $location, unsavedChanges) {
	    var vm = this;
	    var isLoading = vm.isLoading = busy.create();
	    var isSaving = vm.isSaving = busy.create();
	    var retry = $location.search().retry;
	
	    vm.selectionModes = ['Machines', 'Environments'];
	    vm.run = run;
	    vm.environmentIds = [];
	    vm.targetRoles = [];
	    vm.machineIds = [];
	
	    vm.scriptBody = '';
	    vm.syntax = 'PowerShell';
	    vm.selectionMode = vm.selectionModes[0];
	
	    vm.availableRoles = [];
	    vm.environments = [];
	    vm.machines = [];
	
	
	    function init() {
	        var loadResources = $q.all([octopusRepository.Environments.all(), octopusRepository.Machines.all(), octopusRepository.MachineRoles.all()]).then(function (data) {
	            vm.availableRoles = data[2];
	            vm.environments = data[0];
	            vm.machines = data[1];
	        });
	
	
	        isLoading.promise(loadResources);
	
	        if (retry) {
	            var loadExistingValues = octopusRepository.Tasks.get(retry)
	                .then(function (retried) {
	                    vm.scriptBody = retried.Arguments.ScriptBody;
	                    vm.syntax = retried.Arguments.Syntax || 'PowerShell';
	                    if (retried.Arguments.MachineIds && retried.Arguments.MachineIds.length > 0) {
	                        vm.machineIds = retried.Arguments.MachineIds;
	                        vm.selectionMode = 'Machines';
	                    } else {
	                        vm.environmentIds = retried.Arguments.EnvironmentIds;
	                        vm.targetRoles = retried.Arguments.TargetRoles;
	                        vm.selectionMode = 'Environments';
	                    }
	                });
	            isLoading.promise(loadExistingValues);
	        }
	    }
	
	    function run() {
	        if (vm.scriptBody.trim().length === 0) {
	            isSaving.showError('A script body must be provided.');
	            return;
	        }
	
	        var task = {
	            Name: 'AdHocScript',
	            Description: 'Script run from management console',
	            Arguments: {
	                ScriptBody: vm.scriptBody,
	                Syntax: vm.syntax
	            }
	        };
	
	        if (vm.selectionMode === 'Machines') {
	            if (vm.machineIds.length === 0) {
	                isSaving.showError('At least one deployment target must be selected.');
	                return;
	            }
	            task.Arguments.MachineIds = vm.machineIds;
	        } else {
	            task.Arguments.EnvironmentIds = vm.environmentIds;
	            task.Arguments.TargetRoles = vm.targetRoles;
	        }
	
	        isSaving.promise(octopusRepository.Tasks.create(task).then(function (created) {
	            unsavedChanges.saved();
	            $location.path('/tasks/' + created.Id);
	        }));
	    }
	
	    init();
	});

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.master');
	
	module.directive('mainNavigationBar', function() {
	
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        templateUrl: 'areas/master/views/main_navigation_bar.html',
	        link: function(scope, element) {
	    },
	        controller: function ($scope, $rootScope, octopusAuthenticator, octopusRepository, pollLoop, octopusClient) {
	            $scope.tab = 'dashboard';
	            $scope.isAuthenticated = false;
	            $scope.searchEnabled = true;
	            $scope.hasProjects = false;
	            $scope.projectMenuItems = null;
	            $scope.showUpgradeBullhorn = false;
	
	            var root = $scope.rootDocument = octopusClient.rootDocument();
	
	            $scope.canChangePassword = function() {
	                return $rootScope.currentUser && $rootScope.currentUser.CanPasswordBeEdited && root.AnyAuthenticationProvidersSupportPasswordManagement;
	            };
	
	            var refreshProjects = function() {
	                return octopusRepository.Dashboards.getDashboard().then(function(dashboardData) {
	                    $scope.hasProjects = false;
	                    var projectGroups = _.sortBy(dashboardData.ProjectGroups, function (p) { return p.Name.toLowerCase(); });
	
	                    var projectsByGroup = { };
	                    _.each(projectGroups, function (pg) {
	                        projectsByGroup[pg.Id] = [];
	                    });
	
	                    _.each(_.sortBy(dashboardData.Projects, function (p) { return p.Name.toLowerCase(); }), function(project) {
	                        projectsByGroup[project.ProjectGroupId].push(project);
	                        $scope.hasProjects = true;
	                    });
	
	                    var allItems = [];
	                    var order = 0;
	                    _.each(projectGroups, function (pg) {
	                        order++;
	                        allItems.push( { Id: pg.Id, Order: order, Name: pg.Name, Slug: null });
	                        _.each(projectsByGroup[pg.Id], function (project) {
	                            order++;
	                            allItems.push( { Id: project.Id, Order: order, Name: project.Name, Slug: project.Slug });
	                        });
	                    });
	
	                    $scope.projectMenuItems = allItems;
	                });
	            };
	
	            $scope.beginRefreshProjects = function() {
	                refreshProjects();
	            };
	
	            octopusRepository.ServerStatus.getServerStatus().then(function(status) {
	
	                $scope.isUpgradeAvailable = status.IsUpgradeAvailable;
	                $scope.isMajorMinorUpgrade = status.IsMajorMinorUpgrade;
	
	                if (status.IsUpgradeAvailable) {
	                    $scope.maximumAvailableVersion = status.MaximumAvailableVersion;
	                    if (status.MaximumAvailableVersion === status.MaximumAvailableVersionCoveredByLicense) {
	                        $scope.canUpgradeFreeOfCharge = true;
	                    } else {
	                        $scope.canUpgradeFreeOfCharge = false;
	                        $scope.maximumAvailableVersionCoveredByLicense = status.MaximumAvailableVersionCoveredByLicense;
	                        $scope.maintenanceExpires = status.MaintenanceExpires;
	                    }
	
	                    // Check if we should show the upgrade bullhorn.
	                    octopusRepository.UpgradeConfiguration.get().then(function (config) {
	                        if (config.NotificationMode === 'AlwaysShow') {
	                            $scope.showUpgradeBullhorn = true;
	                        } else if (config.NotificationMode === 'ShowOnlyMajorMinor' && $scope.isMajorMinorUpgrade) {
	                            $scope.showUpgradeBullhorn = true;
	                        }
	                    });
	                }
	            });
	
	            var loop = pollLoop.create($scope, function() {
	                return refreshProjects();
	            }, 60000);
	
	            loop.startImmediately();
	        }
	    };
	});
	
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 477 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.master');
	
	module.directive('pageBanners', function(octopusPermissionSet, octopusRepository, pollLoop, octopusAuthenticator, octopusLog, $location, $rootScope) {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/master/views/page-banners.html',
	    scope: {},
	    controller: function ($scope) {
	      var refreshStatus = function() {
	        return octopusRepository.ServerStatus.getServerStatus().then(function(status){
	          $scope.isInMaintenanceMode = status.IsInMaintenanceMode;
	        });
	      };
	
	      var loop = pollLoop.create($scope, function(){
	        return refreshStatus();
	      }, 10000);
	      loop.startImmediately();
	    }
	  };
	});
	
	


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	  pluginRegistry.registerDeploymentAction("Octopus.Email", function(octopusRepository, busy) {
	    return {
	      executionLocation: actionExecutionLocations.alwaysOnServer,
	      canChooseRoles: false,
	      canHaveChildren: function() { return false; },
	      canBeChild: true,
	      hasPackages: function(action) { return false; },
	            summaryTemplateUrl: "areas/projects/actions/Octopus.Email_summary.html",
	            editTemplateUrl: "areas/projects/actions/Octopus.Email_edit.html",
	            editLink: function ($scope, element, action) {
	                var isLoading = $scope.isLoading = busy.create();
	
	                var hasCCBcc = false;
	                if (action.Properties["Octopus.Action.Email.CC"]
	                    || action.Properties["Octopus.Action.Email.CCTeamIds"]
	                    || action.Properties["Octopus.Action.Email.Bcc"]
	                    || action.Properties["Octopus.Action.Email.BccTeamIds"]) {
	                    hasCCBcc = true;
	                }
	                $scope.email = {showCCBcc: hasCCBcc};
	                $scope.showCCBcc = function () {
	                    $scope.email.showCCBcc = true;
	                };
	
	                $scope.selectedToTeamIds = [];
	                $scope.selectedCcTeamIds = [];
	                $scope.selectedBccTeamIds = [];
	                $scope.onChange = function () {
	                    action.Properties["Octopus.Action.Email.ToTeamIds"] = $scope.selectedToTeamIds.reduce(function (prev, team) {
	                        return (prev ? (prev + ',') : '') + team;
	                    });
	                    action.Properties["Octopus.Action.Email.CCTeamIds"] = $scope.selectedCcTeamIds.reduce(function (prev, team) {
	                        return (prev ? (prev + ',') : '') + team;
	                    });
	                    action.Properties["Octopus.Action.Email.BccTeamIds"] = $scope.selectedBccTeamIds.reduce(function (prev, team) {
	                        return (prev ? (prev + ',') : '') + team;
	                    });
	                };
	                $scope.$watch(function () {
	                    return action.Properties["Octopus.Action.Email.ToTeamIds"];
	                }, function () {
	                    $scope.selectedToTeamIds = (action.Properties["Octopus.Action.Email.ToTeamIds"] || '').split(',');
	                });
	                $scope.$watch(function () {
	                    return action.Properties["Octopus.Action.Email.CCTeamIds"];
	                }, function () {
	                    $scope.selectedCcTeamIds = (action.Properties["Octopus.Action.Email.CCTeamIds"] || '').split(',');
	                });
	                $scope.$watch(function () {
	                    return action.Properties["Octopus.Action.Email.BccTeamIds"];
	                }, function () {
	                    $scope.selectedBccTeamIds = (action.Properties["Octopus.Action.Email.BccTeamIds"] || '').split(',');
	                });
	
	                isLoading.promise(octopusRepository.Teams.all().then(function (teams) {
	                    $scope.teams = teams;
	                }));
	            },
	            summaryLink: function ($scope, element, action) {
	                var isLoading = $scope.isLoading = busy.create();
	                var getTags = function(allOptions, selectedOptions) {
	                    if (allOptions.length === 0) {
	                        return "";
	                    }
	                    var result = [];
	                    _.each(selectedOptions, function (e) {
	                        if (allOptions.indexOf(e.Id) >= 0) {
	                            result.push(e.Name);
	                        }
	                    });
	                    return result.join(",");
	                };
	
	                isLoading.promise(octopusRepository.Teams.all().then(function (teams) {
	                    $scope.teams = teams;
	                    if ($scope.action.Properties["Octopus.Action.Email.ToTeamIds"] !== undefined) {
	                        $scope.emailTeams = getTags($scope.action.Properties["Octopus.Action.Email.ToTeamIds"], teams);
	                    }
	                }));
	            }
	        };
	    });
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 479 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	  pluginRegistry.registerDeploymentAction("Octopus.HealthCheck", function() {
	    return {
	      executionLocation: actionExecutionLocations.alwaysOnServer,
	      canChooseRoles: true,
	      canHaveChildren: function() { return false; },
	      canBeChild: false,
	      hasPackages: function(action) { return false; },
	
	            summaryTemplateUrl: "areas/projects/actions/Octopus.HealthCheck_summary.html",
	            editTemplateUrl: "areas/projects/actions/Octopus.HealthCheck_edit.html",
	            editLink: function ($scope, element) {
	                if (!$scope.action.Properties["Octopus.Action.HealthCheck.Type"]) {
	                    $scope.action.Properties["Octopus.Action.HealthCheck.Type"] = "FullHealthCheck";
	                }
	                if (!$scope.action.Properties["Octopus.Action.HealthCheck.ErrorHandling"]) {
	                    $scope.action.Properties["Octopus.Action.HealthCheck.ErrorHandling"] = "TreatExceptionsAsErrors";
	                }
	                if (!$scope.action.Properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"]) {
	                    $scope.action.Properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] = "DoNotAlterMachines";
	                }
	
	            }
	        };
	    });
	});

/***/ },
/* 480 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.IIS", function(busy, octopusRepository) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnTarget,
	            canChooseRoles: true,
	            canHaveChildren: function() { return true; },
	            canBeChild: true,
	            hasPackages: function(action) { return true; },
	            features: {
	                permanent: ["Octopus.Features.IISWebSite"],
	                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
	                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
	                initial: ["Octopus.Features.ConfigurationTransforms","Octopus.Features.ConfigurationVariables"]
	            },
	
	            summaryTemplateUrl: "areas/projects/actions/Octopus.IIS_summary.html",
	
	            editTemplateUrl: "areas/projects/actions/Octopus.TentaclePackage_edit.html",
	            
	            summaryLink: function($scope, element) {
	                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
	                    $scope.feedName = feed.Name;
	                });
	            }
	        };
	    });
	});
	


/***/ },
/* 481 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	  pluginRegistry.registerDeploymentAction("Octopus.Manual", function(octopusRepository, busy) {
	    return {
	      executionLocation: actionExecutionLocations.alwaysOnServer,
	      canChooseRoles: false,
	      canHaveChildren: function() { return false; },
	      canBeChild: true,
	      hasPackages: function(action) { return false; },
	
	            summaryTemplateUrl: "areas/projects/actions/Octopus.Manual_summary.html",
	            editTemplateUrl: "areas/projects/actions/Octopus.Manual_edit.html",
	            editLink: function ($scope, element, action) {
	                var isLoading = $scope.isLoading = busy.create();
	                $scope.selectedTeams = [];
	                $scope.onChange = function () {
	                    action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"] = $scope.selectedTeams.reduce(function (prev, team) {
	                        return (prev ? (prev + ',') : '') + team;
	                    });
	                };
	
	                $scope.$watch(function () {
	                    return action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"];
	                }, function () {
	                    $scope.selectedTeams = (action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"] || '').split(',');
	                });
	
	                isLoading.promise(octopusRepository.Teams.all().then(function (teams) {
	                    $scope.teams = teams;
	                }));
	            }
	        };
	    });
	});
	


/***/ },
/* 482 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	  pluginRegistry.registerDeploymentAction("Octopus.Script", function() {
	    return {
	      executionLocation: actionExecutionLocations.targetOrServer,
	      canChooseRoles: true,
	      canHaveChildren: function(step)
	      {
	        return (typeof step.Properties['Octopus.Action.TargetRoles'] !== 'undefined');
	      },
	      canBeChild: true,
	      hasPackages: function(action)
	      {
	        if (action.Properties && action.Properties['Octopus.Action.Script.ScriptSource'] === 'Package')
	        {
	          return true;
	        }
	        return false;
	      },
	      summaryTemplateUrl: "areas/projects/actions/Octopus.Script_summary.html",
	      editTemplateUrl: "areas/projects/actions/Octopus.Script_edit.html",
	      preLink: function(scope) {
	        scope.editorLoaded = function(editor) {
	          scope.scriptEditor = editor;
	        };
	      },
	      editLink: function(scope) {
	        scope.$watch('action.Properties', function(nv) {
	          if (nv != null) {
	            if (nv['Octopus.Action.Script.ScriptSource']) {
	              var isRunFromPackage = nv['Octopus.Action.Script.ScriptSource'] === 'Package';
	              if(isRunFromPackage) {
	                nv['Octopus.Action.Script.Syntax'] = null;
	                nv['Octopus.Action.Script.ScriptBody'] = null;
	              } else {
	                if(!nv['Octopus.Action.Script.Syntax']) {
	                  nv['Octopus.Action.Script.Syntax'] = "PowerShell";
	                }
	                nv['Octopus.Action.Script.ScriptFileName'] = null;
	                nv['Octopus.Action.Package.FeedId'] = null;
	                nv['Octopus.Action.Package.PackageId'] = null;
	              }
	              
	              var canRunBeforeAcquisition = !isRunFromPackage;
	              if (scope.viewOptions) {
	                scope.viewOptions.canRunBeforeAcquisition = canRunBeforeAcquisition;
	              }
	              
	              if (scope.step.RequiresPackagesToBeAcquired === undefined) {
	                scope.step.RequiresPackagesToBeAcquired = canRunBeforeAcquisition ? 'false' : 'true';
	              }
	            }
	
	                        if (scope.action.Properties && scope.action.Properties['Octopus.Action.RunOnServer'] && scope.action.Properties['Octopus.Action.RunOnServer'] === 'true') {
	                            scope.syntaxFilter = "'PowerShell, CSharp, FSharp'";
	                        } else {
	                            scope.syntaxFilter = "'PowerShell, CSharp, Bash, FSharp'";
	                        }
	
	                    }
	                }, true);
	
	                if (scope.action &&
	                    scope.action.Properties &&
	                    scope.action.Properties['Octopus.Action.Script.Syntax'] &&
	                    scope.action.Properties['Octopus.Action.Script.ScriptSource'] &&
	                    scope.action.Properties['Octopus.Action.RunOnServer']) {
	                    return;
	                }
	
	                var unwatch = scope.$watch('action.Properties', function (nv) {
	                    if (nv != null) {
	                        if (!nv['Octopus.Action.Script.Syntax']) {
	                            nv['Octopus.Action.Script.Syntax'] = "PowerShell";
	                        }
	                        if (!nv['Octopus.Action.Script.ScriptSource']) {
	                            nv['Octopus.Action.Script.ScriptSource'] = "Inline";
	                        }
	                        if (!nv['Octopus.Action.RunOnServer']) {
	                            nv['Octopus.Action.RunOnServer'] = 'false';
	                        }
	                    }
	                    unwatch();
	                });
	
	            }
	        };
	    });
	});
	


/***/ },
/* 483 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	  pluginRegistry.registerDeploymentAction("Octopus.TentaclePackage", function(busy, octopusRepository) {
	    return {
	      executionLocation: actionExecutionLocations.alwaysOnTarget,
	      canChooseRoles: true,
	      canHaveChildren: function() { return true; },
	      canBeChild: true,
	      hasPackages: function(action) { return true; },
	      features: {
	        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
	          "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles",
	          "Octopus.Features.IisHome", "Octopus.Features.IISWebSite", "Octopus.Features.RedGateDatabase", "Octopus.Features.WindowsService"],
	        initial: ["Octopus.Features.ConfigurationTransforms","Octopus.Features.ConfigurationVariables"]
	      },
	
	            summaryTemplateUrl: "areas/projects/actions/Octopus.TentaclePackage_summary.html",
	
	            editTemplateUrl: "areas/projects/actions/Octopus.TentaclePackage_edit.html",
	            editLink: function ($scope, element) {
	                var isLoading = $scope.isLoading = busy.create();
	
	                if (!$scope.action.Properties["Octopus.Action.Package.FeedId"] && $scope.feeds.length > 0) {
	
	                    // We're adding a new action
	                    $scope.action.Properties["Octopus.Action.EnabledFeatures"] = "Octopus.Features.ConfigurationTransforms,Octopus.Features.ConfigurationVariables";
	                    pluginRegistry.getFeature("Octopus.Features.ConfigurationTransforms").enable($scope.action);
	                    pluginRegistry.getFeature("Octopus.Features.ConfigurationVariables").enable($scope.action);
	                }
	
	                if (!$scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"]) {
	                    $scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"] = "False";
	                }
	            },
	            summaryLink: function ($scope, element) {
	                var variableExpressionRegex = /^#{(.*?)}$/;
	                var matches = $scope.properties["Octopus.Action.Package.PackageId"].match(variableExpressionRegex);
	                $scope.packageId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.PackageId"];
	
	                matches = $scope.properties["Octopus.Action.Package.FeedId"].match(variableExpressionRegex);
	                $scope.feedId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.FeedId"];
	                return octopusRepository.Feeds.get($scope.feedId).then(function (feed) {
	                    $scope.feedName = feed.Name;
	                });
	            }
	        };
	    });
	});
	
	


/***/ },
/* 484 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.WindowsService", function(busy, octopusRepository) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnTarget,
	            canChooseRoles: true,
	            canHaveChildren: function() { return true; },
	            canBeChild: true,
	            hasPackages: function(action) { return true; },
	            features: {
	                permanent: ["Octopus.Features.WindowsService"],
	                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
	                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
	                initial: ["Octopus.Features.ConfigurationTransforms","Octopus.Features.ConfigurationVariables"]
	            },
	
	            summaryTemplateUrl: "areas/projects/actions/Octopus.WindowsService_summary.html",
	
	            editTemplateUrl: "areas/projects/actions/Octopus.TentaclePackage_edit.html",
	            
	            summaryLink: function($scope, element) {
	                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
	                    $scope.feedName = feed.Name;
	                });
	            }
	        };
	    });
	});


/***/ },
/* 485 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.AzureCloudService", function(octopusRepository) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnServer,
	            canChooseRoles: true,
	            canHaveChildren: false,
	            canBeChild: false,
	            hasPackages: function(action) { return true; },
	            features: {
	                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
	                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
	            },
	            summaryTemplateUrl: "areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_summary.html",
	            editTemplateUrl: "areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_edit.html",
	
	            preLink: function(scope) { 
	                scope.account = {
	                    AccountId: scope.action.Properties["Octopus.Action.Azure.AccountId"],
	                    bound: {}
	                };
	
	                scope.azure = {
	                    cloudServiceName: scope.action.Properties["Octopus.Action.Azure.CloudServiceName"],
	                    storageAccountName: scope.action.Properties["Octopus.Action.Azure.StorageAccountName"],
	                };
	
	                if (scope.action.Properties["Octopus.Action.Azure.SubscriptionId"] && !scope.action.Properties["Octopus.Action.Azure.AccountId"]) {
	                   scope.usingLegacySubscriptionId = true;
	                } 
	
	                scope.cloudServiceLockedToBound = function() {
	                   return scope.account.bound.isBound || 
	                        (scope.usingLegacySubscriptionId && !scope.action.Properties["Octopus.Action.Azure.AccountId"]);
	                };
	
	                scope.getAccountId = function() {
	                    return (!scope.account.bound.isBound) ? scope.action.Properties["Octopus.Action.Azure.AccountId"] : undefined;
	                };
	
	                scope.reset = {
	                    slot: "Staging",
	                    account: undefined 
	                };
	
	                scope.$watch(function() {
	                    return scope.account.AccountId;
	                },
	                function() {
	                    if (scope.action) {
	                        scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
	                    }
	                });
	
	                scope.$watch(function() {
	                    return scope.azure.cloudServiceName;
	                },
	                function() {
	                    if (scope.action) {
	                        scope.action.Properties["Octopus.Action.Azure.CloudServiceName"] = scope.azure.cloudServiceName;
	                    }
	                });
	
	                scope.$watch(function() {
	                    return scope.azure.storageAccountName;
	                },
	                function() {
	                    if (scope.action) {
	                        scope.action.Properties["Octopus.Action.Azure.StorageAccountName"] = scope.azure.storageAccountName;
	                    }
	                });
	            },
	
	            summaryLink: function($scope, element) {
	                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
	                  $scope.feedName = feed.Name;
	                });
	            }
	        };
	    });
	});


/***/ },
/* 486 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('azureCloudServiceSelector', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      model: '=',
	      projectId: '=',
	      getAccountId: '=',
	      lockedToBound: '=',
	      type: '@'
	    },
	    templateUrl: 'areas/projects/actions/azure_cloud_service/azure_cloud_service_selector.html',
	    controllerAs: 'vm',
	    controller: function ($scope, $q, octopusRepository, busy, $timeout) {
	      var vm = this;
	      vm.model = $scope.model;
	      vm.projectId = $scope.projectId;
	      vm.isLoading = busy.create();
	      var getAccountId = $scope.getAccountId;
	
	      vm.selectedCloudService = null;
	      vm.selectedStorageAccount = null;
	
	      vm.reset = {
	        cloudServiceName: vm.model.cloudServiceName,
	        storageAccountName: vm.model.storageAccountName 
	      };
	
	      vm.changed = function changed() {
	        vm.model.cloudServiceName = vm.selectedCloudService ? vm.selectedCloudService.Name : null;
	        vm.model.storageAccountName = vm.selectedStorageAccount ? vm.selectedStorageAccount.Name : null;
	      };
	
	      $scope.$watch(getAccountId,
	              function (accountId) {
	                if (!accountId) {
	                  vm.isLoading.promise($timeout(function(){
	                    vm.cloudServices = [];
	                    vm.storageAccounts = [];
	                  }, 100));
	                  return;
	                } 
	                
	                vm.isLoading.promise(octopusRepository.Accounts.get(getAccountId())
	                        .then(function (account) {
	
	                          return $q.all([
	                          octopusRepository.Accounts.getCloudServices(account)
	                                  .then(function (services) {
	                                    vm.cloudServices = services;
	
	                                    if (vm.model.cloudServiceName) {
	                                      vm.selectedCloudService = services.filter(function (service) {
	                                        return vm.model.cloudServiceName === service.Name;
	                                      })[0];
	                                    }
	                                  }),
	
	                          octopusRepository.Accounts.getStorageAccounts(account)
	                                  .then(function (storageAccounts) {
	                                    vm.storageAccounts = storageAccounts;
	
	                                    if (vm.model.storageAccountName) {
	                                      vm.selectedStorageAccount = storageAccounts.filter(function (storage) {
	                                        return vm.model.storageAccountName === storage.Name;
	                                      })[0];
	                                    }
	                                  })]);
	                        }));
	              }
	      );
	    }
	  };
	});


/***/ },
/* 487 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	  pluginRegistry.registerDeploymentAction("Octopus.AzurePowerShell", function() {
	    return {
	      executionLocation: actionExecutionLocations.alwaysOnServer,
	      canChooseRoles: true,
	      canHaveChildren: function() { return false; },
	      canBeChild: true,
	      hasPackages: function(action) { return false; },
	
	            summaryTemplateUrl: "areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_summary.html",
	            editTemplateUrl: "areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_edit.html",
	
	            preLink: function (scope) {
	                scope.account = {};
	
	                scope.getAccountId = function () {
	                    return (scope.action) ? scope.action.Properties['Octopus.Action.Azure.AccountId'] : undefined;
	                };
	            },
	
	            editLink: function (scope) {
	
	                scope.account.AccountId = scope.action.Properties["Octopus.Action.Azure.AccountId"];
	
	                scope.$watch(function () {
	                        return scope.account.AccountId;
	                    },
	                    function () {
	                        if (scope.action) {
	                            scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
	                        }
	                    });
	
	                scope.$watch('action.Properties', function (nv) {
	                    if (nv != null) {
	                        if (!nv['Octopus.Action.Script.ScriptSource']) {
	                            nv['Octopus.Action.Script.ScriptSource'] = "Inline";
	                        }
	
	                        var isRunFromPackage = nv['Octopus.Action.Script.ScriptSource'] === 'Package';
	                        if (isRunFromPackage) {
	                            nv['Octopus.Action.Script.ScriptBody'] = null;
	                        } else {
	                            nv['Octopus.Action.Script.ScriptFileName'] = null;
	                            nv['Octopus.Action.Package.FeedId'] = null;
	                            nv['Octopus.Action.Package.PackageId'] = null;
	                        }
	                    }
	                }, true);
	            }
	        };
	    });
	});
	


/***/ },
/* 488 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('azurePowershellAccountInfo', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/actions/azure_powershell/azure_powershell_account_info.html'
	    };
	});


/***/ },
/* 489 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	module.run(function (pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.AzureResourceGroup", function (octopusRepository, busy) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnServer,
	            canChooseRoles: true,
	            canHaveChildren: false,
	            canBeChild: false,
	            hasPackages: function(action) { return false; },
	            summaryTemplateUrl: "areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_summary.html",
	            editTemplateUrl: "areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_edit.html",
	            preLink: function (scope) {
	                scope.account = {
	                    AccountId: scope.action.Properties["Octopus.Action.Azure.AccountId"],
	                    bound: {}
	                };
	
	                scope.resourceGroup = {
	                    name: scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"],
	                };
	
	                scope.templateSource = {
	                    usePackage: !!scope.action.Properties["Octopus.Action.Package.PackageId"]
	                };
	
	                scope.isAccountBound = function () {
	                    return scope.account.bound.isBound;
	                };
	
	                scope.getAccountId = function () {
	                    return (!scope.isAccountBound()) ? scope.action.Properties["Octopus.Action.Azure.AccountId"] : undefined;
	                };
	
	                scope.$watch(function () {
	                        return scope.account.AccountId;
	                    },
	                    function () {
	                        if (scope.action) {
	                            scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
	                        }
	                    }
	                );
	
	                scope.$watch(function(){ return scope.resourceGroup.name; },
	                    function(){
	                        if (scope.action) {
	                            scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"] = scope.resourceGroup.name;
	                        }
	                    }
	                );
	            },
	
	            editLink: function (scope) {
	                scope.isLoading = busy.create();
	
	                var unwatch = scope.$watch('action.Properties', function (nv) {
	                    if (nv != null) {
	                        if (!nv['Octopus.Action.Azure.TemplateSource']) {
	                            nv['Octopus.Action.Azure.TemplateSource'] = "Inline";
	                        }
	                        unwatch();
	                    }
	                });
	
	                scope.$watch('action.Properties["Octopus.Action.Azure.TemplateSource"]', function (templateSource, oldVal) {
	                    if (!templateSource || (templateSource === oldVal)) {
	                        return;
	                    }
	
	                    scope.action.Properties["Octopus.Action.Azure.ResourceGroupTemplate"] = undefined;
	                    scope.action.Properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = undefined;
	
	                    if (templateSource === "Inline") {
	                        scope.action.Properties["Octopus.Action.Package.PackageId"] = undefined;
	                        scope.action.Properties["Octopus.Action.Package.FeedId"] = undefined;
	                    }
	
	                });
	
	                scope.editorLoaded = function (editor) {
	                    scope.editor = editor;
	                    editor.$blockScrolling = Infinity;
	                };
	            }
	        };
	    });
	});


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('azureResourceGroupParameters', function(octopusRepository){
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/projects/actions/azure_resource_group/azure_resource_group_parameters.html',
	    scope: {
	      project: '=',
	      action: '='
	    },
	    link: function ($scope) {
	      $scope.parameterValues = {};
	      $scope.parameters = {};
	      $scope.source = { octopus: "octopus", azureKeyVault: "azureKeyVault"};
	
	      var armJsonParamTypes = ["array", "object", "secureObject"];
	
	      function populateValuesWithTemplateParameters(parameters) {
	        removeOrphanParameterValues(parameters);
	        addMissingParameterValues(parameters);
	        provideDefaults(parameters);
	      }
	
	      function populateValuesWithTemplateParameterValues(armParameters, parameters) {
	        _.each(armParameters, function(parameter, parameterName) {
	          var parameterValue = {};
	
	          if (parameter.reference) {
	            parameterValue.keyVaultId = parameter.reference.keyVault.id;
	            parameterValue.keyVaultSecretName = parameter.reference.secretName;
	            parameterValue.source = $scope.source.azureKeyVault;
	          } else {
	            setParameterValue(parameterValue, parameter.value);
	            parameterValue.source = $scope.source.octopus;
	          }
	
	          $scope.parameterValues[parameterName] = parameterValue;
	        });
	
	        provideDefaults(parameters);
	    }
	
	      function removeOrphanParameterValues(parameters){
	        _.each($scope.parameterValues, function(value, key){
	          if (parameters[key] === undefined) {
	            delete $scope.parameterValues[key];
	          }
	        });
	      }
	
	      function addMissingParameterValues(parameters){
	        _.each(parameters, function(value, parameterName) {
	          if ($scope.parameterValues[parameterName] === undefined) {
	            $scope.parameterValues[parameterName] = {};
	          }
	        });
	      }
	
	      function provideDefaults(parameters){
	        _.each(parameters, function(value, parameterName) {
	          var parameterValue =  $scope.parameterValues[parameterName];
	
	          if (parameterValue.value === undefined && value.defaultValue !== undefined) {
	            setParameterValue(parameterValue, value.defaultValue);
	          }
	
	          if (parameterValue.source === undefined) {
	            parameterValue.source = $scope.source.octopus;
	          }
	
	          if (parameterValue.type === undefined) {
	            parameterValue.type = normalizeType(value.type);
	          }
	
	          if (parameterValue.description === undefined && value.metadata !== undefined) {
	            parameterValue.description = value.metadata.description;
	          }
	
	          if (parameterValue.allowedValues === undefined) {
	            parameterValue.allowedValues = value.allowedValues;
	          }
	        });
	      }
	
	      function setParameterValue(parameterValue, value) {
	        if (_.isObject(value)) {
	          parameterValue.value = JSON.stringify(value, undefined, 4);
	        } else {
	          parameterValue.value = value;
	        }
	      }
	
	      //Technically speaking type names should follow camelCase naming convention as per https://azure.microsoft.com/en-us/documentation/articles/resource-group-authoring-templates/
	      //but even Visual Studio project does not follow it.
	      function normalizeType(type){
	        return type.toLowerCase();
	      }
	
	      //Parameters that are of type 'array', 'object' or 'secureObject' needs to be parsed as JSON,
	      //otherwise the template will not be deemed valid as they will be used as a string and the deployment
	      //will fail with an error message similar to the below:
	      //'Hyak.Common.CloudException: InvalidTemplate: Deployment template validation failed: 
	      //'The provided value for the template parameter '<parameterName>' at line 'x' and column 'y' is not valid.'. 
	      function shouldJsonParse(type) {
	        return armJsonParamTypes.indexOf(type) >= 0;
	      }
	
	      $scope.$watch("action.Properties['Octopus.Action.Azure.ResourceGroupTemplateParameters']",
	        function(newVal){
	          if (!newVal) {
	            return;
	          }
	
	          try {
	            var armParameters = angular.fromJson(newVal);
	            populateValuesWithTemplateParameterValues(armParameters, $scope.parameters);
	          } catch(e){
	            $scope.parameterValues = {};
	          }
	        });
	
	      $scope.$watch("action.Properties['Octopus.Action.Azure.ResourceGroupTemplate']",
	        function(newVal){
	          if (newVal) {
	            try {
	              var template = angular.fromJson(newVal);
	              if (template.parameters) {
	                $scope.parameters = template.parameters;
	              } else{
	                $scope.parameters = {};
	              }
	            } catch (e){}
	          } else {
	            $scope.parameters = {};
	          }
	          populateValuesWithTemplateParameters($scope.parameters);
	        }
	      );
	
	      // whenever parameter values are modified, serialize back into JSON parameter format, and save onto action
	      $scope.$watch("parameterValues",
	          function(parameterValues){
	            if (parameterValues) {
	              var armParams = {};
	              _.each(parameterValues, function(paramValue, paramName){
	
	                var armParameterValue = {};
	                if (paramValue.source !== $scope.source.azureKeyVault) {
	                  if (shouldJsonParse(paramValue.type)) {
	                    armParameterValue.value = JSON.parse(paramValue.value);
	                  } else {
	                    armParameterValue.value = paramValue.value;
	                  }
	                } else {
	                  armParameterValue.reference = {
	                    keyVault: {
	                      id: paramValue.keyVaultId
	                    },
	                    secretName: paramValue.keyVaultSecretName
	                  };
	                }
	
	                armParams[paramName] = armParameterValue;
	              });
	              $scope.action.Properties['Octopus.Action.Azure.ResourceGroupTemplateParameters'] = angular.toJson(armParams);
	            }
	          }, true);
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 491 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('azureResourceGroupSelector', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            model: '=',
	            projectId: '=',
	            getAccountId: '=',
	            isAccountBound: '='
	        },
	        templateUrl: 'areas/projects/actions/azure_resource_group/azure_resource_group_selector.html',
	        controllerAs: 'vm',
	        controller: function ($scope, octopusRepository, busy, $timeout) {
	            var vm = this;
	            vm.model = $scope.model;
	            vm.projectId = $scope.projectId;
	            var getAccountId = $scope.getAccountId;
	            vm.isLoading = busy.create();
	            vm.changed = changed;
	
	            vm.reset = {
	                name: undefined,
	            };
	
	            function changed() {
	                if (vm.selectedResourceGroup) {
	                    vm.model.name = vm.selectedResourceGroup.Name;
	                } else {
	                    vm.model.name = null;
	                }
	            }
	
	            $scope.$watch(getAccountId,
	                function () {
	                    if (!getAccountId()) {
	                        vm.isLoading.promise($timeout(function () {
	                            vm.resourceGroups = [];
	                        }, 100));
	                        return;
	                    }
	
	                    vm.isLoading.promise(octopusRepository.Accounts.get(getAccountId())
	                            .then(function (account) {
	                                return octopusRepository.Accounts.getResourceGroups(account)
	                                    .then(function (resourceGroups) {
	                                        vm.resourceGroups = resourceGroups;
	
	                                        if (vm.model.name) {
	                                            vm.selectedResourceGroup = resourceGroups.filter(function (resourceGroup) {
	                                                return resourceGroup.Name === vm.model.name;
	                                            })[0];
	                                        }
	                                    }, function (error) {
	                                        vm.resourceGroupError = error.ErrorMessage;
	                                    });
	                            })
	                    );
	                }
	            );
	        }
	    };
	});


/***/ },
/* 492 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function (pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.AzureWebApp", function (octopusRepository) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnServer,
	            canChooseRoles: true,
	            canHaveChildren: false,
	            canBeChild: false,
	            hasPackages: function(action) { return true; },
	            features: {
	                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
	                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
	            },
	            summaryTemplateUrl: "areas/projects/actions/azure_web_app/Octopus.AzureWebApp_summary.html",
	            editTemplateUrl: "areas/projects/actions/azure_web_app/Octopus.AzureWebApp_edit.html",
	
	            preLink: function (scope) {
	                scope.account = {
	                    AccountId: scope.action.Properties["Octopus.Action.Azure.AccountId"],
	                    bound: {}
	                };
	
	                scope.site = {
	                    resourceGroupName: scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"],
	                    name: scope.action.Properties["Octopus.Action.Azure.WebAppName"]
	                };
	
	                scope.isAccountBound = function () {
	                    return scope.account.bound.isBound;
	                };
	
	                scope.getAccountId = function () {
	                    return (!scope.isAccountBound()) ? scope.action.Properties["Octopus.Action.Azure.AccountId"] : undefined;
	                };
	
	                scope.$watch("action", function (action) {
	                    if (action) {
	                        if (action.Properties['Octopus.Action.Azure.UseChecksum'] === undefined) {
	                            action.Properties['Octopus.Action.Azure.UseChecksum'] = 'False';
	                        }
	                    }
	                });
	
	                scope.$watch(function () {
	                        return scope.account.AccountId;
	                    },
	                    function () {
	                        if (scope.action) {
	                            scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
	                        }
	                    });
	
	                scope.$watch(function () {
	                        return scope.site.resourceGroupName + "|" + scope.site.name;
	                    },
	                    function () {
	                        if (scope.action) {
	                            scope.action.Properties["Octopus.Action.Azure.WebAppName"] = scope.site.name;
	                            scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"] = scope.site.resourceGroupName;
	                        }
	                    });
	            },
	
	            summaryLink: function ($scope, element) {
	                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function (feed) {
	                    $scope.FeedName = feed.Name;
	                });
	            }
	        };
	    });
	});


/***/ },
/* 493 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('azureWebSiteSelector', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            model: '=',
	            projectId: '=',
	            getAccountId: '=',
	            isAccountBound: '='
	        },
	        templateUrl: 'areas/projects/actions/azure_web_app/azure_web_site_selector.html',
	        controllerAs: 'vm',
	        controller: function ($scope, octopusRepository, busy, $timeout) {
	            var vm = this;
	            vm.model = $scope.model;
	            vm.projectId = $scope.projectId;
	            var getAccountId = $scope.getAccountId;
	            vm.isLoading = busy.create();
	            vm.changed = changed;
	
	            vm.reset = {
	                name: undefined,
	                resourceGroupName: undefined
	            };
	
	            function changed() {
	                if (vm.selectedSite) {
	                    vm.model.name = vm.selectedSite.Name;
	                    vm.model.resourceGroupName = vm.selectedSite.ResourceGroup;
	                } else {
	                    vm.model.name = null;
	                    vm.model.resourceGroupName = null;
	                }
	            }
	
	            function getWebSites() {
	                vm.isLoading.promise(octopusRepository.Accounts.get(getAccountId())
	                    .then(function (account) {
	                        return octopusRepository.Accounts.getWebSites(account)
	                            .then(function (sites) {
	                                vm.sites = sites;
	
	                                if (vm.model.name) {
	                                    vm.selectedSite = sites.filter(function (site) {
	                                        return site.Name === vm.model.name && site.ResourceGroup === vm.model.resourceGroupName;
	                                    })[0];
	                                }
	                            });
	                    })
	                );
	            }
	
	            function resetWebSites() {
	                vm.isLoading.promise($timeout(function () {
	                    vm.sites = [];
	                }, 100));
	            }
	
	            $scope.$watch(function () { return vm.isBound; }, function () {
	                if (!vm.isBound && (!vm.sites || vm.sites.length === 0)) {
	                    getWebSites();
	                }
	            });
	
	            $scope.$watch(getAccountId, function () {
	                    if (!getAccountId()) {
	                        resetWebSites();
	                        return;
	                    }
	
	                    if (vm.isBound) {
	                        resetWebSites();
	                    }
	                    else {
	                        getWebSites();
	                    }
	                }
	            );
	        }
	    };
	});


/***/ },
/* 494 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.DockerNetwork", function(octopusRepository, octopusFeatures) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnTarget,
	            canHaveChildren: false,
	            canBeChild: false,
	            canChooseRoles: true,
	            canShow: function() { return octopusFeatures.isEnabled('IsDockerEnabled'); },
	            hasPackages: function(action) { return false; },
	            summaryTemplateUrl: "areas/projects/actions/docker_network/Octopus.DockerNetwork_summary.html",
	            editTemplateUrl: "areas/projects/actions/docker_network/Octopus.DockerNetwork_edit.html",
	            preLink: function(vm) {
	                vm.networkTypes = {
	                    "bridge": {
	                        name: "Bridge (Default)",
	                        description: "Connect the container to the bridge via veth interfaces."
	                    },
	                    "other": {
	                        name: "Custom",
	                        description: "Use an installed third party or own custom network driver."
	                    }
	                };
	
	                if (!vm.action.Properties["Octopus.Action.Docker.NetworkType"]) {
	                    vm.action.Properties["Octopus.Action.Docker.NetworkType"] = "bridge";
	                }
	            },
	            summaryLink: function($scope, element) {
	            }
	        };
	    });
	});

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('dualValueAdder', function($timeout) {
	    return {
	        restrict: 'E',
	        transclude: true,
	        templateUrl:'areas/projects/actions/docker_network/dual-value-adder.html',
	        require: 'ngModel',
	        scope: {
	            action: '=',
	            project: '=',
	            localNames: '=',
	            placeholder1: '@',
	            placeholder2: '@',
	            helptext: '@',
	            template: '@',
	            seperator: '@'
	        },
	
	        compile: function (tElem, attrs) {
	            tElem.find('.itemTemplate').html(attrs.template || "{{item.Item1}} = {{item.Item2}}");
	            delete attrs.template;
	            return {
	                pre: function ($scope, iElem, iAttrs, ngModel) {
	                    var vm = $scope.vm;
	                    vm.valuesUpdated = function valuesUpdated() {
	                        var newValue = JSON.stringify(vm.items.reduce(function(obj, item) {
	                            obj[item.itemVal1] = item.itemVal2;
	                            return obj;
	                        }, {}));
	                        ngModel.$setViewValue(newValue);
	                    };
	
	                    ngModel.$render = function onRender() {
	                        if (ngModel.$viewValue) {
	                            try {
	                                var obj = JSON.parse(ngModel.$viewValue);
	                                vm.items = _.map(obj, function (value, name) {
	                                    return {
	                                        itemVal1: name,
	                                        editItemVal1: name,
	                                        itemVal2:  value,
	                                        editItemVal2:  value
	                                    };
	                                });
	                            } catch (err) {
	                                console.error(err);
	                            }
	                        }
	                    };
	                }
	            };
	        },
	
	        controller: function() {
	            var vm = this;
	
	            vm.addItem = addItem;
	            vm.newItemVal1 = "";
	            vm.newItemVal2 = "";
	            vm.editContainer = "";
	           
	            vm.cancelEdit = cancelEdit;
	            vm.commitEdit = commitEdit;
	            vm.remove = remove;
	            vm.items = [];
	            vm.isEditing = false;
	
	            function addItem() {
	                vm.items.push({itemVal1: vm.newItemVal1, editItemVal1: vm.newItemVal1, itemVal2:  vm.newItemVal2, editItemVal2:  vm.newItemVal2});
	                vm.valuesUpdated();
	                vm.newItemVal1 = "";
	                vm.newItemVal2 = "";
	            }
	
	            function commitEdit(container) {
	                container.isEditing = false;
	                container.itemVal1 = container.editItemVal1;
	                container.itemVal2 = container.editItemVal2;
	                vm.valuesUpdated();
	            }
	
	            function remove(container) {
	                var idx = vm.items.indexOf(container);
	                if (idx >= 0) {
	                    vm.items.splice(idx, 1);
	                }
	                vm.valuesUpdated();
	            }
	
	            function cancelEdit(container) {
	                container.isEditing = false;
	                container.editItemVal1 = container.itemVal1;
	                container.editItemVal2 = container.itemVal2;
	            }
	        },
	        controllerAs: 'vm',
	        bindToController: true
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 496 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('singleValueAdder', function($timeout, octopusLog) {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/actions/docker_network/single-value-adder.html',
	        require: 'ngModel',
	        scope: {
	            action: '=',
	            project: '=',
	            localNames: '=',
	            placeholder: '@',
	            helptext: '@'
	        },
	        link: function($scope, $element, attrs, ngModel) {
	
	            $scope.vm.valuesUpdated = function valuesUpdated() {
	                ngModel.$setViewValue($scope.vm.items.map(function(c){ return c.name; }).join(','));
	            };
	
	            ngModel.$render = function onRender() {
	                if (ngModel.$viewValue) {
	                    $scope.vm.items = ngModel.$viewValue.split(',')
	                        .map(function (v) {
	                            return v.trim();
	                        })
	                        .filter(function (v) {
	                            return !!v && v !== '';
	                        })
	                        .map(function (v) {
	                            return {name: v, editName: v};
	                        });
	                }
	            };
	        },
	        controller: function() {
	            var vm = this;
	
	            vm.newContainer = "";
	            vm.editContainer = "";
	            vm.addContainer = addContainer;
	            vm.cancelEdit = cancelEdit;
	            vm.commitEdit = commitEdit;
	            vm.remove = remove;
	            vm.items = [];
	            vm.isEditing = false;
	
	            function addContainer() {
	                if (vm.items.indexOf(vm.newContainer) !== -1) {
	                    octopusLog.log("That address range is already covered by an existing selection.. Try again");
	                    return;
	                }
	
	                vm.items.push({name: vm.newContainer, editName:  vm.newContainer});
	                vm.valuesUpdated();
	                vm.newContainer = "";
	                vm.editContainer = "";
	            }
	
	            function commitEdit(container) {
	                container.isEditing = false;
	                container.name = container.editName;
	                vm.valuesUpdated();
	            }
	
	            function remove(container) {
	                var idx = vm.items.indexOf(container);
	
	                if (idx >= 0) {
	                    vm.items.splice(idx, 1);
	                }
	                vm.valuesUpdated();
	            }
	
	            function cancelEdit(container) {
	                container.isEditing = false;
	                container.editName = container.name;
	            }
	        },
	        controllerAs: 'vm',
	        bindToController: true
	    };
	});
	


/***/ },
/* 497 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations, octopusFeatures) {
	    pluginRegistry.registerDeploymentAction("Octopus.DockerRun", function(octopusRepository) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnTarget,
	            canHaveChildren: false,
	            canBeChild: false,
	            canChooseRoles: true,
	            canShow: function() { return octopusFeatures.isEnabled('IsDockerEnabled'); },
	            hasPackages: function(action) { return false; },
	            summaryTemplateUrl: "areas/projects/actions/docker_run/Octopus.DockerRun_summary.html",
	            editTemplateUrl: "areas/projects/actions/docker_run/Octopus.DockerRun_edit.html",
	
	            preLink: function(vm) {
	                vm.networkTypes = {
	                    "": {
	                        name: "",
	                        description: ""
	                    },
	                    "none": {
	                        name: "None",
	                        description: "No networking."
	                    },
	                    "bridge": {
	                        name: "Bridge (Linux Default)",
	                        description: "Connect the container to the bridge via veth interfaces."
	                    },
	                    "host": {
	                        name: "Host",
	                        description: "Use the host's network stack inside the container."
	                    },
	                    "container": {
	                        name: "Container",
	                        description: "Use the network stack of another container, specified via its *name* or *id*."
	                    },
	                    "network": {
	                        name: "Custom Network",
	                        description: "Connects the container to a user created network."
	                    }
	                };
	
	                if (!vm.action.Properties["Octopus.Action.Docker.NetworkType"]) {
	                    vm.action.Properties["Octopus.Action.Docker.NetworkType"] = "";
	                }
	
	                vm.restartPolicies = {
	                    "no": {
	                        name: "No (Default)",
	                        description: "Do not automatically restart the container when it exits. This is the default."
	                    },
	                    "on-failure": {
	                        name: "On Failure",
	                        description: "Restart only if the container exits with a non-zero exit status. " +
	                        "Optionally, limit the number of restart retries the Docker daemon attempts."
	                    },
	                    "always": {
	                        name: "Always",
	                        description: "Always restart the container regardless of the exit status. " +
	                        "When you specify always, the Docker daemon will try to restart the container indefinitely. " +
	                        "The container will also always start on daemon startup, regardless of the current state of the container."
	                    },
	                    "unless-stopped": {
	                        name: "Unless Stopped",
	                        description: "Always restart the container regardless of the exit status, but do not start it on daemon startup if the container has been put to a stopped state before."
	                    }
	                };
	
	                if (!vm.action.Properties["Octopus.Action.Docker.RestartPolicy"]) {
	                    vm.action.Properties["Octopus.Action.Docker.RestartPolicy"] = "no";
	                }
	            },
	            summaryLink: function($scope, element) {
	                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
	                    $scope.feedName = feed.Name;
	                });
	            }
	        };
	    });
	});

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('addedHost', function($timeout, octopusLog) {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/actions/docker_run/added-host.html',
	        scope: {
	            action: '=',
	            project: '=',
	            localNames: '='
	        },
	        controller: function() {
	            var vm = this;
	
	            vm.newHost = "";
	            vm.newIp = "";
	            vm.addNewHost = addNewHost;
	            vm.addedHosts = [];
	            vm.removeAddedHost = removeAddedHost;
	
	            function addNewHost() {
	                if (_.any(vm.addedHosts, function (mapping) {
	                        return mapping.ip === vm.newIp;
	                    })) {
	                    octopusLog.log("Mapping to that container port already exists.. Try again");
	                    return;
	                }
	
	                var pm = new PortMapping(vm.newHost, vm.newIp, true);
	                vm.addedHosts.push(pm);
	                vm.newHost = "";
	                vm.newIp = "";
	                pm.commitEdit();
	            }
	
	            function removeAddedHost(mapping){
	                var idx = vm.addedHosts.indexOf(mapping);
	                if (idx >= 0) {
	                    vm.addedHosts.splice(idx, 1);
	                }
	                setProperties();
	            }
	
	            function PortMapping(host, ip) {
	                var self = {
	                    ip: ip,
	                    editIp: ip,
	                    host: host,
	                    editHost: host,
	                    isEditing: false
	                };
	
	                self.formatted = formatMapping();
	                self.commitEdit = commitEdit;
	                self.cancelEdit = cancelEdit;
	
	                function cancelEdit() {
	                    self.editIp = self.ip;
	                    self.editHost = self.host;
	                    self.isEditing = false;
	                }
	
	                function commitEdit() {
	                    self.ip = self.editIp;
	                    self.host = self.editHost;
	                    self.isEditing = false;
	                    self.formatted = formatMapping();
	                    setProperties();
	                }
	
	                function formatMapping(){
	                    if (!self.host) {
	                        // containerPort
	                        return self.ip;
	                    }
	                    return self.host +" : " + self.ip;
	                }
	                return self;
	            }
	
	            function setProperties(){
	                vm.action.Properties["Octopus.Action.Docker.AddedHost"] =  JSON.stringify(vm.addedHosts.reduce(function(obj, mapping) {
	                    obj[mapping.host] = mapping.ip;
	                    return obj;
	                }, {}));
	            }
	
	            function init() {
	                var json = vm.action.Properties["Octopus.Action.Docker.AddedHost"];
	                if(!!json) {
	                    try {
	                        var obj = JSON.parse(json);
	                        vm.addedHosts = _.map(obj, function (ip, host) {
	                            return new PortMapping(host, ip);
	                        });
	
	                    } catch (err) {
	                        console.error(err);
	                    }
	                }
	            }
	
	            init();
	        },
	        controllerAs: 'vm',
	        bindToController: true
	    };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('portMapping', function($timeout, octopusLog) {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/actions/docker_run/port-mapping.html',
	        scope: {
	            action: '=',
	            project: '=',
	            localNames: '='
	        },
	        controller: function() {
	            var vm = this;
	
	            vm.newHost = "";
	            vm.newContainer = "";
	            vm.addPortMapping = addPortMapping;
	            vm.portMappings = [];
	            vm.removePortMapping = removePortMapping;
	
	            function addPortMapping() {
	                if (_.any(vm.portMappings, function (mapping) {
	                        return mapping.container === vm.newContainer;
	                    })) {
	                    octopusLog.log("Mapping to that container port already exists.. Try again");
	                    return;
	                }
	
	                var pm = new PortMapping(vm.newHost, vm.newContainer, true);
	                vm.portMappings.push(pm);
	                vm.newHost = "";
	                vm.newContainer = "";
	                pm.commitEdit();
	            }
	
	            function removePortMapping(mapping){
	                var idx = vm.portMappings.indexOf(mapping);
	                if (idx >= 0) {
	                    vm.portMappings.splice(idx, 1);
	                }
	                setProperties();
	            }
	
	            function PortMapping(host, container) {
	                var self = {
	                    container: container,
	                    editContainer: container,
	                    host: host,
	                    editHost: host,
	                    isEditing: false
	                };
	
	                self.formatted = formatMapping();
	                self.commitEdit = commitEdit;
	                self.cancelEdit = cancelEdit;
	
	                function cancelEdit() {
	                    self.editContainer = self.container;
	                    self.editHost = self.host;
	                    self.isEditing = false;
	                }
	
	                function commitEdit() {
	                    self.container = self.editContainer;
	                    self.host = self.editHost;
	                    self.isEditing = false;
	                    self.formatted = formatMapping();
	                    setProperties();
	                }
	
	                function formatMapping(){
	                    if (!self.host) {
	                        // containerPort
	                        return "<b>Container: </b>" + self.container;
	                    }
	                    return "<b>Host: </b>"+ self.host +" : <b>Container: </b>" + self.container;
	                }
	                return self;
	            }
	
	            function setProperties(){
	                vm.action.Properties["Octopus.Action.Docker.PortMapping"] =  JSON.stringify(vm.portMappings.reduce(function(obj, mapping) {
	                    obj[mapping.container] = mapping.host;
	                    return obj;
	                }, {}));
	            }
	
	            function init() {
	                var json = vm.action.Properties["Octopus.Action.Docker.PortMapping"];
	                if(!!json) {
	                    try {
	                        var obj = JSON.parse(json);
	                        vm.portMappings = _.map(obj, function (host, container) {
	                            return new PortMapping(host, container);
	                        });
	
	                    } catch (err) {
	                        console.error(err);
	                    }
	                }
	            }
	
	            init();
	        },
	        controllerAs: 'vm',
	        bindToController: true
	    };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('variableMapping', function($timeout, octopusLog) {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/actions/docker_run/variable-mapping.html',
	        scope: {
	            action: '=',
	            project: '=',
	            localNames: '='
	        },
	        link: function($scope, $element) {
	            //$scope.$element = $element;
	        },
	        controller: function() {
	            var vm = this;
	
	            vm.newValue = "";
	            vm.newVariable = "";
	            vm.addVariable = addVariable;
	            vm.removeVariable = removeVariable;
	            vm.variableMappings = [];
	
	            function removeVariable(variable){
	                var idx = vm.variableMappings.indexOf(variable);
	                if (idx >= 0) {
	                    vm.variableMappings.splice(idx, 1);
	                }
	                setProperties();
	            }
	
	            function addVariable() {
	                if (_.any(vm.variableMappings, function (mapping) {
	                        return mapping.variable === vm.newVariable;
	                    })) {
	                    octopusLog.log("Mapping to that container port already exists.. Try again");
	                    return;
	                }
	
	                var pm = new VariableMapping(vm.newVariable, vm.newValue, true);
	                vm.variableMappings.push(pm);
	                vm.newValue = "";
	                vm.newVariable = "";
	                pm.commitEdit();
	            }
	
	            function VariableMapping(variable, value) {
	                var self = {
	                    variable: variable,
	                    editVariable: variable,
	                    value: value,
	                    editValue: value,
	                    isEditing: false
	                };
	
	                self.formatted = formatMapping();
	                self.commitEdit = commitEdit;
	                self.cancelEdit = cancelEdit;
	
	                function cancelEdit() {
	                    self.editVariable = self.variable;
	                    self.editValue = self.value;
	                    self.isEditing = false;
	                }
	
	                function commitEdit(){
	                    self.variable = self.editVariable;
	                    self.value = self.editValue;
	                    self.isEditing = false;
	                    self.formatted = formatMapping();
	                    setProperties();
	                }
	
	                function formatMapping(){
	
	                    return self.variable +" = \"" + self.value + "\"";
	                }
	                return self;
	            }
	
	            function setProperties() {
	                vm.action.Properties["Octopus.Action.Docker.EnvVariable"] =  JSON.stringify(vm.variableMappings.reduce(function(obj, mapping) {
	                    obj[mapping.variable] = mapping.value;
	                    return obj;
	                }, {}));
	            }
	
	            function init() {
	                var json = vm.action.Properties["Octopus.Action.Docker.EnvVariable"];
	                if (!!json) {
	                    try {
	                        var obj = JSON.parse(json);
	                        vm.variableMappings = _.map(obj, function (value, name) {
	                            return new VariableMapping(name, value);
	                        });
	
	                    } catch (err) {
	                        console.error(err);
	                    }
	                }
	            }
	
	            init();
	        },
	        controllerAs: 'vm',
	        bindToController: true
	    };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 501 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	
	module.controller('VolumeBindingDialogController', function ($scope, busy,
	                                                             $uibModalInstance, projectId, binding, locals, existing) {
	    $scope.isSaving = busy.create();
	    $scope.locals = locals;
	    $scope.binding = binding;
	    binding.projectId = projectId;
	
	    $scope.close = function() {
	        $uibModalInstance.close();
	    };
	
	    $scope.save = function () {
	        if ($scope.binding.container === '') {
	            $scope.isSaving.showError('You must specify the container volume as an absolute path.');
	            return;
	        }
	        $uibModalInstance.close($scope.binding);
	    };
	});
	
	


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('volumeBinding', function($uibModal) {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/actions/docker_run/volume-binding.html',
	        scope: {
	            action: '=',
	            project: '=',
	            localNames: '='
	        },
	        link: function($scope, $element) {
	            //$scope.$element = $element;
	        },
	        controller: function() {
	            var vm = this;
	
	            vm.volumeBindings = [];
	            vm.formatBinding = formatBinding;
	            vm.openEditDialog = openEditDialog;
	            vm.removeVolumeBinding = removeVolumeBinding;
	
	            function openEditDialog(existingVolume) {
	                $uibModal.open({
	                    size: "lg",
	                    backdrop: true,
	                    keyboard: true,
	                    templateUrl: 'areas/projects/actions/docker_run/volume-binding-dialog.html',
	                    controller: "VolumeBindingDialogController",
	                    resolve: {
	                        "projectId" : function() {
	                            return vm.project.Id;
	                        },
	                        "locals": function() {
	                            return vm.locals;
	                        },
	                        "binding": function() {
	                            if (existingVolume) {
	                                return {
	                                    container: existingVolume.container,
	                                    host: existingVolume.host,
	                                    readOnly: existingVolume.readOnly,
	                                    noCopy: existingVolume.noCopy
	                                };
	                            } else {
	                                return {
	                                    container: '',
	                                    host: '',
	                                    readOnly: 'False',
	                                    noCopy: 'False'
	                                };
	                            }
	                        },
	                        "existing": function() {
	                            return null;
	                        }
	                    }
	                }).result.then(function(result) {
	                    if (!result) {
	                        return;
	                    }
	
	                    if (existingVolume) {
	                        removeVolumeBinding(existingVolume);
	                    }
	
	                    vm.volumeBindings.push(result);
	                    setProperties();
	                });
	            }
	
	            function removeVolumeBinding(binding) {
	                var idx = vm.volumeBindings.indexOf(binding);
	                if (idx >= 0) {
	                    vm.volumeBindings.splice(idx, 1);
	                }
	                setProperties();
	            }
	
	            function setProperties() {
	                vm.action.Properties["Octopus.Action.Docker.VolumeBindings"] =  JSON.stringify(vm.volumeBindings.reduce(function(obj, binding) {
	                    obj[binding.container] = {
	                        host: binding.host,
	                        readOnly: isTrue(binding.readOnly, 'readonly'),
	                        noCopy: isTrue(binding.noCopy, 'nocopy')
	                    };
	                    return obj;
	                }, {}));
	            }
	
	            function loadVolumeBindings() {
	                var json = vm.action.Properties["Octopus.Action.Docker.VolumeBindings"];
	                if (!!json) {
	                    try {
	                        var obj = JSON.parse(json);
	                        vm.volumeBindings = _.map(obj, function (binding, container) {
	                            return {
	                                container: container,
	                                host: binding.host,
	                                readOnly: isTrue(binding.readOnly, 'readonly'),
	                                noCopy: isTrue(binding.noCopy, 'nocopy')
	                            };
	                        });
	
	                    } catch (err) {
	                        console.error(err);
	                    }
	                }
	            }
	            
	
	            function isTrue(noCopy, trueString) {
	                return (!!noCopy && (noCopy === true || noCopy.toLowerCase() === "true" || noCopy.toLowerCase()  === trueString));
	            }
	
	            function formatBinding(binding) {
	                var format = binding.container;
	                if (binding.host) {
	                    format = "<b>Host: </b>"+ binding.host + " : <b>Container: </b>" + binding.container;
	                }
	                if (isTrue(binding.readOnly, 'readonly')) {
	                    format += " <b>readonly</b>";
	                }
	
	                if (isTrue(binding.noCopy, 'nocopy')) {
	                    format += " <b>nocopy</b>";
	                }
	                return format;
	            }
	
	            function init() {
	                loadVolumeBindings();
	            }
	            init();
	        },
	        controllerAs: 'vm',
	        bindToController: true
	    };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 503 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('volumesFrom', function($timeout, octopusLog) {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/actions/docker_run/volumes-from.html',
	        scope: {
	            action: '=',
	            project: '=',
	            localNames: '='
	        },
	        link: function($scope, $element) {
	            //$scope.$element = $element;
	        },
	        controller: function() {
	            var vm = this;
	
	            vm.newContainer = "";
	            vm.editContainer = "";
	            vm.addContainer = addContainer;
	            vm.cancelEdit = cancelEdit;
	            vm.commitEdit = commitEdit;
	            vm.remove = remove;
	            vm.containers = [];
	            vm.isEditing = false;
	
	            function addContainer() {
	                if (vm.containers.indexOf(vm.newContainer) !== -1) {
	                    octopusLog.log("Mapping to that container port already exists.. Try again");
	                    return;
	                }
	
	                vm.containers.push({name: vm.newContainer, editName:  vm.newContainer});
	                setOnProperties();
	                vm.newContainer = "";
	                vm.editContainer = "";
	            }
	
	            function commitEdit(container) {
	                container.isEditing = false;
	                container.name = container.editName;
	                setOnProperties();
	            }
	
	            function remove(container) {
	                var idx = vm.containers.indexOf(container);
	
	                if (idx >= 0) {
	                    vm.containers.splice(idx, 1);
	                }
	                setOnProperties();
	            }
	
	            function setOnProperties() {
	                vm.action.Properties["Octopus.Action.Docker.VolumesFrom"] = vm.containers.map(function(c){ return c.name; }).join(',');
	            }
	
	            function cancelEdit(container) {
	                container.isEditing = false;
	                container.editName = container.name;
	            }
	
	            function init() {
	                var volumesFrom = vm.action.Properties["Octopus.Action.Docker.VolumesFrom"] || '';
	                vm.containers = volumesFrom.split(',')
	                    .map(function(v){ return v.trim(); })
	                    .filter(function(v) { return !!v && v !== '';})
	                    .map(function(v) {
	                        return {name: v, editName: v};
	                    });
	            }
	
	            init();
	        },
	        controllerAs: 'vm',
	        bindToController: true
	    };
	});
	


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.DockerStop", function(octopusRepository, octopusFeatures) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnTarget,
	            canHaveChildren: false,
	            canBeChild: false,
	            canChooseRoles: true,
	            canShow: function() { return octopusFeatures.isEnabled('IsDockerEnabled'); },
	            hasPackages: function(action) { return false; },
	            summaryTemplateUrl: "areas/projects/actions/docker_stop/Octopus.DockerStop_summary.html",
	            editTemplateUrl: "areas/projects/actions/docker_stop/Octopus.DockerStop_edit.html",
	            preLink: function($scope) {
	
	                octopusRepository.DeploymentProcesses.get($scope.project.DeploymentProcessId).then(function(deployment) {
	                    $scope.actions = _.flatten(deployment.Steps.map(function(step, stepIndex){
	                       return step.Actions.map(function CalculateNumberedName(action, actionIndex) {
	                           var number = stepIndex + 1;
	                           if (step.Actions.length > 1) {
	                               number = number +"."+ (actionIndex + 1);
	                           }
	                           action.NumberedName = number +'. '+ action.Name;
	                           return action;
	                       });
	                   }))
	                        .filter(function(action) { return action.ActionType === 'Octopus.DockerNetwork' || action.ActionType === 'Octopus.DockerRun'; })
	                        .map(function(action) {
	                            return {Name: action.NumberedName, Id: action.Id};
	                        });
	                });
	
	                $scope.vm = {
	                    selectedActions: ($scope.action.Properties["Octopus.Action.Docker.RemoveSteps"] || "").split(",")
	                };
	
	                $scope.actionsChanged = function() {
	                    $scope.action.Properties["Octopus.Action.Docker.RemoveSteps"] = $scope.vm.selectedActions.join(',');
	                };
	
	                if (!$scope.action.Properties["Octopus.Action.Docker.Remove"]) {
	                    $scope.action.Properties["Octopus.Action.Docker.Remove"] = "True";
	                }
	
	                $scope.filterChanged = function(){
	                    $scope.action.Properties["Octopus.Action.Docker.RemoveByEnvironment"] = ($scope.filterBy.environment === "True") ? "True" : "False";
	                    $scope.action.Properties["Octopus.Action.Docker.RemoveByRelease"] = ($scope.filterBy.release === "True") ? "True" : "False";
	                    $scope.action.Properties["Octopus.Action.Docker.RemoveByTenant"] = ($scope.filterBy.tenant === "True") ? "True" : "False";
	                };
	
	                $scope.filterBy = {
	                    environment: $scope.action.Properties["Octopus.Action.Docker.RemoveByEnvironment"],
	                    release: $scope.action.Properties["Octopus.Action.Docker.RemoveByRelease"],
	                    tenant: $scope.action.Properties["Octopus.Action.Docker.RemoveByTenant"]
	                };
	
	            },
	            summaryLink: function($scope, element) {
	
	            }
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 505 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry, actionExecutionLocations) {
	    pluginRegistry.registerDeploymentAction("Octopus.TransferPackage", function(busy, octopusRepository) {
	        return {
	            executionLocation: actionExecutionLocations.alwaysOnTarget,
	            canChooseRoles: true,
	            canHaveChildren: function() { return true; },
	            canBeChild: true,
	            hasPackages: function(action) { return true; },
	            summaryTemplateUrl: "areas/projects/actions/transfer_package/Octopus.TransferPackage_summary.html",
	
	            editTemplateUrl: "areas/projects/actions/transfer_package/Octopus.TransferPackage_edit.html",
	            editLink: function ($scope, element) {
	                if (!$scope.action.Properties["Octopus.Action.NakedScripting"]) {
	                    $scope.action.Properties["Octopus.Action.NakedScripting"] = "False";
	                }
	            },
	            summaryLink: function ($scope, element) {
	                var variableExpressionRegex = /^#{(.*?)}$/;
	                var matches = $scope.properties["Octopus.Action.Package.PackageId"].match(variableExpressionRegex);
	                $scope.packageId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.PackageId"];
	
	                matches = $scope.properties["Octopus.Action.Package.FeedId"].match(variableExpressionRegex);
	                $scope.feedId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.FeedId"];
	                return octopusRepository.Feeds.get($scope.feedId).then(function (feed) {
	                    $scope.feedName = feed.Name;
	                });
	            }
	        };
	    });
	});
	
	


/***/ },
/* 506 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('ChannelAddStepController', function ($scope, busy, $uibModalInstance, steps) {
	
	   $scope.steps = steps;
	   $scope.adding = { stepName: undefined };
	
	   $scope.close = function() {
	    $uibModalInstance.close();
	   };
	
	   $scope.save = function () {
	    $uibModalInstance.close($scope.adding.stepName);
	   };
	});


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ChannelEditController', function ($scope, busy, $stateParams, projectState, $location, $uibModal, $q,
	                                                     pageTitle, octopusRepository, unsavedChanges) {
	
	    var channelId = $stateParams.channelId;
	    var projectId = $stateParams.projectId;
	    var isLoading = projectState.isLoading;
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.actionsByName = {};
	
	    if (!channelId) {
	        $scope.model = {
	            IsDefault: false,
	            Rules: []
	        };
	    }
	
	    function init() {
	        var promises = [];
	        promises.push(projectState.load()
	            .then(function (project) {
	                $scope.project = project;
	                return projectState.deploymentProcessAsync;
	            })
	            .then(function (deploymentProcess) {
	                $scope.actions = _.chain(deploymentProcess.Steps)
	                    .map(function (step) {
	                        return step.Actions;
	                    })
	                    .flatten()
	                    .filter(function (action) {
	                        return action.Properties['Octopus.Action.Package.PackageId'];
	                    })
	                    .value();
	                $scope.actionsByName = _.object(_.pluck($scope.actions, "Name"), $scope.actions);
	            }));
	
	        promises.push(octopusRepository.Lifecycles.all().then(function (lifecycles) {
	            $scope.lifecycles = lifecycles;
	        }));
	
	        isLoading.promises(promises).then(function () {
	            if (channelId) {
	                isLoading.promise(octopusRepository.Channels.get(channelId)).then(function (channel) {
	                    $scope.model = channel;
	                });
	            }
	        });
	    }
	
	    $scope.save = function () {
	        $scope.model.ProjectId = $scope.project.Id;
	        isSaving.promise(octopusRepository.Channels.save($scope.model).then(function () {
	            unsavedChanges.saved();
	            $location.path('/projects/' + $scope.project.Slug + '/channels');
	        }));
	    };
	
	    $scope.design = function (rule) {
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/channels/design_rule_dialog.html',
	            controller: 'ChannelDesignRuleController',
	            resolve: {
	                rule: function () {
	                    return {versionRange: rule.VersionRange, tag: rule.Tag};
	                },
	                samplePackages: function () {
	                    if (!rule.Actions) {
	                        return [];
	                    }
	                    return $q.all(rule.Actions
	                        .map(function (actionName) {
	                            var action = $scope.actionsByName[actionName];
	                            var feedId = action.Properties["Octopus.Action.Package.FeedId"];
	                            var searchOptions = {
	                                packageId: action.Properties["Octopus.Action.Package.PackageId"],
	                                partialMatch: false,
	                                includeMultipleVersions: true,
	                                includePreRelease: true,
	                                includeNotes: false,
	                                take: 5
	                            };
	                            return octopusRepository.Feeds.get(feedId).then(function (feed) {
	                                return octopusRepository.Feeds.search(feed, searchOptions);
	                            }).then(function (results) {
	                                return results.map(function (package) {
	                                    return package.Version;
	                                });
	                            });
	                        })).then(function (results) {
	                        return _.union.apply(_, results);
	                    });
	                }
	            }
	        }).result.then(function (result) {
	            if (!result) {
	                return;
	            }
	            rule.VersionRange = result.versionRange;
	            rule.Tag = result.tag;
	        });
	    };
	
	    $scope.addVersionRule = function () {
	        unsavedChanges.unsaved();
	        $scope.model.Rules.push({
	            Actions: []
	        });
	    };
	
	
	    $scope.removeVersionRule = function (rule) {
	        unsavedChanges.unsaved();
	        var ix = $scope.model.Rules.indexOf(rule);
	        if (ix >= 0) {
	            $scope.model.Rules.splice(ix, 1);
	        }
	    };
	
	    $scope.removeRuleStep = function (rule, stepName) {
	        rule.Actions.splice(rule.Actions.indexOf(stepName), 1);
	        unsavedChanges.unsaved();
	    };
	
	    $scope.addAction = function (rule) {
	
	        var alreadySelectedActions = _.flatten($scope.model.Rules.map(function (a) {
	            return a.Actions;
	        }));
	
	        var candidateActions = $scope.actions
	            .filter(function (action) {
	                return (alreadySelectedActions.indexOf(action.Name) === -1);
	            });
	
	        if (candidateActions.length === 1) {
	            addRuleStep(rule, candidateActions[0].Name);
	        } else {
	            $uibModal.open({
	                backdrop: true,
	                keyboard: true,
	                templateUrl: 'areas/projects/channels/add_step_dialog.html',
	                controller: 'ChannelAddStepController',
	                resolve: {
	                    steps: function () {
	                        return candidateActions;
	                    }
	                }
	            }).result.then(function (result) {
	                if (result) {
	                    addRuleStep(rule, result);
	                }
	            });
	        }
	    };
	
	    function addRuleStep(rule, stepName) {
	        rule.Actions.push(stepName);
	        unsavedChanges.unsaved();
	    }
	
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 508 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('channelEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/projects/channels/channel_editor.html'
	  };
	});


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ChannelsController', function ($scope, busy, $stateParams, projectState, pageTitle, octopusRepository) {
	    var isLoading = $scope.isLoading = busy.create();
	    var projectId = $stateParams.projectId;
	
	    $scope.lifecycles = [];
	
	    var loadChannels = function(){
	        isLoading.promise(octopusRepository.Projects.getChannels($scope.project).then(function (channels) {
	            $scope.channels = channels;
	        }));
	    };
	
	    isLoading.promise(projectState.load().then(function (project) {
	        pageTitle(project.Name + " channels");
	
	        $scope.project = project;
	        $scope.actionsByName = {};
	
	        isLoading.promise(octopusRepository.DeploymentProcesses.get(project.DeploymentProcessId).then(function (deploymentProcess) {
	            $scope.deploymentProcess = deploymentProcess;
	            var actions = _.chain(deploymentProcess.Steps).map(function(step){ return step.Actions; }).flatten().value();
	            $scope.actionsByName = _.object(_.pluck(actions, "Name"), actions);
	        }));
	
	        isLoading.promise(octopusRepository.Lifecycles.get().then(function (lifecycles) {
	            _.each(lifecycles.Items, function(lifecycle) {
	                $scope.lifecycles[lifecycle.Id] = lifecycle;
	            });
	        }));
	
	        loadChannels();
	
	        $scope.getActionPackageName = function(actionName){
	            var action = $scope.actionsByName[actionName];
	
	            if (!action) {
	                return;
	            }
	
	            return action.Properties['Octopus.Action.Package.PackageId'];
	        };
	
	        $scope.getLifecycleName = function(channel){
	
	            if (Object.keys($scope.lifecycles).length === 0) {
	                return null;
	            }
	      
	            if (channel.LifecycleId) {
	                return $scope.lifecycles[channel.LifecycleId].Name;
	            }
	
	            return $scope.lifecycles[$scope.project.LifecycleId].Name;
	        };
	    }));
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 510 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('ChannelDesignRuleController', function ($scope,$uibModalInstance, octopusRepository, rule, samplePackages) {
	  $scope.rule = {
	    versionRange: rule.versionRange,
	    tag: rule.tag
	  };
	  $scope.warnings = [];
	  $scope.close = $uibModalInstance.close;
	  $scope.save = save;
	  $scope.testVersion = testVersion;
	  $scope.samplePackages = samplePackages;
	
	  function save() {
	    $uibModalInstance.close($scope.rule);
	  }
	
	  function testVersion(version, done){
	    octopusRepository.Channels.ruleTest(version, { versionRange: $scope.rule.versionRange, preReleaseTag: $scope.rule.tag}).then(function(result){
	      showErrors(result);
	      done(version, result);
	    });
	  }
	
	  function showErrors(result) {
	    $scope.rangeClass = result.Errors.indexOf("Invalid Version Range") === -1 ? "" : "warning";
	    $scope.tagClass = result.Errors.indexOf("Invalid Pre-Release Tag") === -1 ? "" : "warning";
	
	    $scope.warnings = [];
	    $scope.error = null;
	
	    if($scope.rangeClass) {
	      $scope.warnings.push("The version range does not appear to be a valid NuGet version range.");
	    }
	    if($scope.tagClass) {
	      $scope.warnings.push("The pre-release tag appears to be an invalid .net regex patterm.");
	    }
	  }
	});


/***/ },
/* 511 */
/***/ function(module, exports) {

	/*global ace */
	
	ace.define("ace/mode/version_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(require, exports, module) {
	  "use strict";
	
	  var oop = require("../lib/oop");
	  var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
	
	  var escapeRe = "\\\\(?:[\\\\0abtrn;#=:]|x[a-fA-F\\d]{4})";
	
	  var VersionHighlightRules = function() {
	    this.$rules = {
	      start: [{
	        token: "keyword.version",
	        regex: "\\d+(\\.\\d+)+"
	      }, {
	        token: "keyword.tag",
	        regex: "-.*"
	      }]
	    };
	
	    this.normalizeRules();
	  };
	
	  oop.inherits(VersionHighlightRules, TextHighlightRules);
	
	  exports.VersionHighlightRules = VersionHighlightRules;
	});
	
	ace.define("ace/mode/version",
	        ["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/version_highlight_rules"],
	        function(require, exports) {
	  "use strict";
	
	  var oop = require("../lib/oop");
	  var TextMode = require("./text").Mode;
	  var VersionHighlightRules = require("./version_highlight_rules").VersionHighlightRules;
	
	  var Mode = function() {
	    this.HighlightRules = VersionHighlightRules;
	  };
	  oop.inherits(Mode, TextMode);
	
	  (function() {
	    this.$id = "ace/mode/version";
	  }).call(Mode.prototype);
	
	  exports.Mode = Mode;
	});


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.projects');
	
	module.directive('sampleVersions', function($timeout) {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            testVersion: "&",
	            tag: "=",
	            versionRange: "=",
	            initialData: "="
	        },
	        template: "<div ui-ace=\"{ mode: 'version', showGutter: false, onLoad: vm.aceLoaded, onChange: vm.aceChanged}\" ng-model=\"vm.versions\" ng-model-options=\"{ debounce: 100 }\"></div>",
	        link: function($scope, $element) {
	            $scope.$element = $element;
	        },
	        controller: function($scope) {
	            var vm = this;
	            var tested = {};
	            this.versions = ($scope.initialData && $scope.initialData.length) ? $scope.initialData.join("\n") : "1.0\n1.1.0\n1.1.0-bugfix";
	
	            this.aceLoaded = function(editor){
	                editor.setShowPrintMargin(false);
	                editor.setHighlightActiveLine(false);
	                editor.$blockScrolling = Infinity;
	            };
	
	            $scope.$watch(function () { return vm.versions; }, function(newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    invokeService();
	                }
	            });
	            $scope.$watch(function () {
	                return { tag: $scope.tag, versionRange: $scope.versionRange };
	            }, function() {
	                tested = {};
	                invokeService();
	            }, true);
	
	            function invokeService() {
	                vm.versions.split('\n').forEach(function (version) {
	                    if (tested[version]) {
	                        reApplyStyles();
	                    } else {
	                        $scope.testVersion({version: version, done: resultReturned});
	                    }
	                });
	            }
	
	            function reApplyStyles(){
	                $.each($scope.$element.find(".ace_line"), function(i, elem) {
	                    var $elem = $(elem);
	                    var result = tested[$elem.text()];
	                    if (result) {
	                        setStyle($elem, result);
	                    }
	                });
	            }
	
	            function setStyle($element, result) {
	                $element.removeClass("version-invalid")
	                        .removeClass("tag-error")
	                        .removeClass("tag-ok")
	                        .removeClass("range-error")
	                        .removeClass("range-ok");
	
	                if (result.Errors.indexOf("Invalid Version Number") !== -1) {
	                    $element.addClass("version-invalid");
	                } else {
	                    if ($element.find('.ace_tag').length === 0 && !result.SatisfiesPreReleaseTag) {
	                        $element.addClass("range-error");
	                    } else {
	                        $element.addClass(result.SatisfiesPreReleaseTag ? "tag-ok" : "tag-error");
	                        $element.addClass(result.SatisfiesVersionRange ? "range-ok" : "range-error");
	                    }
	                }
	            }
	
	            function resultReturned(version, result) {
	                tested[version] = result;
	
	                $.each($scope.$element.find(".ace_line"), function(i, elem){
	                    var $elem = $(elem);
	                    if ($elem.text() === version) {
	                        setStyle($elem, result);
	                    }
	                });
	            }
	        },
	        controllerAs: 'vm'
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectDeploymentCreateController', function ($scope, $q, $timeout, $location, $stateParams, projectState, busy, pageTitle, octopusLog, octopusRepository, octopusPermissionSet) {
	    var machinesPromise;
	    var isLoading = $scope.isLoading = busy.create();
	    var isPreviewing = $scope.isPreviewing = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.allTenants = [];
	    var projectId = $stateParams.projectId;
	    var goal = $stateParams["goal"];
	    var previousDeploymentId = $stateParams["previousId"];
	    var releaseVersion = $stateParams.version;
	    var tenantIds = $location.search().tenantIds; //tenantIds
	    var tags = $location.search().tags;
	
	    if (goal === "to") {
	        previousDeploymentId = null;
	    }
	    $scope.view = {
	        queueTime: null,
	        queueTimeExpiry: null,
	        deploymentType: 'normal',
	        showAdvanced: $scope.$storage.alwaysShowAdvancedDeploymentOptions,
	        selectedEnvironments: [],
	        selectedTenants: [],
	        selectedTenantTags: [],
	        resultantTenants: [],
	        resultantTenantCount: 0,
	        loadMatchingTenants: function(){ },
	        modifyDestination: true,
	        selectedSpecificMachineOption: 'all',
	        includeSpecificMachineIds: [],
	        excludeSpecificMachineIds: []
	    };
	    $scope.previous = null;
	    $scope.canSkipAll = false;
	    $scope.latest = {};
	    $scope.errors = {};
	    $scope.success = {};
	
	    $scope.canDeploy = function canDeploy(){
	
	        var isStandardView = !$scope.view.showAdvanced;
	        var isNormalDeploymentWithEnvironmentSelected = ($scope.view.deploymentType === 'normal' && $scope.view.selectedEnvironments.length > 0);
	        var isTenantDeploymentWithTenantsSelected = ($scope.view.deploymentType === 'tenant' && ($scope.view.selectedTenants.length + $scope.view.selectedTenantTags.length > 0));
	
	        return isStandardView && (isNormalDeploymentWithEnvironmentSelected || isTenantDeploymentWithTenantsSelected);
	    };
	
	    function getPromoteToEnvironments() {
	        if ($scope.template.PromoteTo.length === 0 && $scope.template.TenantPromotions.length === 0) {
	            return [];
	        }
	
	        if ($scope.template.PromoteTo.length > 0) {
	            return $scope.template.PromoteTo;
	        }
	
	        var promoteTo = [];
	        _.each($scope.template.TenantPromotions, function (p) {
	            if (p.PromoteTo.length !== 0) {
	                _.each(p.PromoteTo, function (o) {
	                    if (!_.find(promoteTo, function (a) { return a.Id === o.Id; })) {
	                        promoteTo.push(o);
	                    }
	                });
	            }
	        });
	        return promoteTo;
	    }
	
	    $scope.channel = null;
	    $scope.isMultitenancyEnabled = !!octopusRepository.Tenants;
	    $scope.requireTenantedDeployment = false;
	
	    function init() {
	        var load = function() {
	
	            $scope.$watchCollection(function(){ return $scope.view.selectedEnvironments; }, function() { $scope.refreshPreview(); });
	            $scope.$watchCollection(function() { return $scope.view.resultantTenants; }, function() { $scope.refreshPreview(); });
	            $scope.$watch(function() { return $scope.view.deploymentType; }, function() { $scope.refreshPreview(); });
	            $scope.$watchCollection(function() { return $scope.view.selectedSpecificMachineOption; }, function() { updateSpecificMachineSelection(); });
	            $scope.$watchCollection(function() { return $scope.view.includeSpecificMachineIds; }, function() { updateSpecificMachineSelection(); });
	            $scope.$watchCollection(function() { return $scope.view.excludeSpecificMachineIds; }, function() { updateSpecificMachineSelection(); });
	
	            // Only for tenants
	            var tenantsLoader = (octopusRepository.Tenants ? octopusRepository.Tenants.all() : $q.resolve([])).then(function (tenants) {
	                $scope.allTenants = tenants;
	                return tenants;
	            });
	
	            var projectLoader = projectState.load().then(function(project) {
	                $scope.project = project;
	                $scope.allowDeploymentsToNoTargets = project.ProjectConnectivityPolicy.AllowDeploymentsToNoTargets;
	                $scope.requireTenantedDeployment = project.RequireTenantedDeployment;
	                if ($scope.requireTenantedDeployment) {
	                    $scope.view.deploymentType = 'tenant';
	                }
	
	                return project;
	            });
	      
	            isLoading.promise(tenantsLoader);
	            isLoading.promise(projectLoader.then(function (project) {
	
	                return octopusRepository.Projects.getReleaseByVersion(project, releaseVersion).then(function (release) {
	
	                    // Only for tenants
	                    $scope.canPerformTenantedDeployments = function canPerformTenantedDeployments() {
	                        return $scope.project.TenantedDeploymentMode === 'TenantedOrUntenanted' || $scope.project.TenantedDeploymentMode === 'Tenanted';
	                    };
	
	                    isLoading.promise(octopusRepository.Channels.get(release.ChannelId).then(function (channel) {
	                        $scope.channel = channel;
	                    }));
	
	                    isLoading.promise(octopusRepository.Projects.getTriggers($scope.project).then(function (triggers) {
	                        $scope.triggers = triggers;
	                    }));
	
	                    return octopusRepository.Releases.getDeploymentTemplate(release).then(function (template) {
	
	                        if ($scope.project.TenantedDeploymentMode === 'Tenanted') {
	                            $scope.view.deploymentType = 'tenant';
	                            $scope.requireTenantedDeployment = true;
	                        }
	
	                        $scope.release = release;
	                        $scope.template = template;
	                        $scope.promotionDictionary = {};
	                        if (template.PromoteTo.length === 0 && template.TenantPromotions.length === 0) {
	                            // User can see empty "environments" list
	                            return;
	                        }
	
	                        $scope.promoteTo = getPromoteToEnvironments();
	                        _.each($scope.promoteTo, function (o) {
	                            $scope.promotionDictionary[o.Id] = o;
	                        });
	
	                        $scope.deployment = {
	                            ReleaseId: release.Id,
	                            UseGuidedFailure: true,
	                            SkipActions: [],
	                            SpecificMachineIds: [],
	                            ForcePackageDownload: $scope.previous ? $scope.previous.ForcePackageDownload : false
	                        };
	
	                        if ($scope.previous && goal === "try-again") {
	                            $scope.view.selectedEnvironments.push($scope.previous.EnvironmentId);
	                            $scope.view.modifyDestination = false;
	                            if ($scope.previous.TenantId) {
	                                $scope.view.deploymentType = 'tenant';
	                                $scope.view.selectedTenants = [$scope.previous.TenantId];
	                            }
	                        }
	
	                        if (goal === "to") {
	                            _.each(($stateParams["previousId"] || "").split(','), function (id) {
	                                $scope.view.selectedEnvironments.push(id);
	                            });
	                            if (tenantIds) {
	                                $scope.view.deploymentType = 'tenant';
	                                if (typeof tenantIds === 'string') {
	                                    tenantIds = [tenantIds];
	                                }
	                                $scope.view.selectedTenants = tenantIds;
	                            }
	
	                            if (tags) {
	                                if (typeof tags === 'string') {
	                                    tags = [tags];
	                                }
	                                $scope.view.selectedTenantTags = tags;
	                                $scope.view.deploymentType = 'tenant';
	                            }
	                        }
	
	                        if ($scope.view.selectedEnvironments.length === 1) {
	                            $scope.view.selectedEnvironment = $scope.view.selectedEnvironments[0];
	                        }
	
	
	                        if ($scope.view.selectedEnvironments.length > 0) {
	                            $scope.view.modifyDestination = false;
	                            $scope.refreshPreview();
	                        }
	                    });
	                });
	            }));
	        };
	
	        octopusPermissionSet.isAuthorized({ permission: 'MachineView', projectId: projectId, environmentId: '*' }).then(function(yn) {
	            if (yn) {
	                machinesPromise = octopusRepository.Machines.all();
	                isLoading.promise(machinesPromise);
	            }
	        });
	
	        if (previousDeploymentId) {
	            isLoading.promise(octopusRepository.Deployments.get(previousDeploymentId).then(function (previous) {
	                $scope.previous = previous;
	                load();
	            }));
	        } else {
	            load();
	        }
	    }
	
	    $scope.skipAll = function () {
	        _.each($scope.steps, function (step) {
	            if (step.details.CanBeSkipped) {
	                step.enable = false;
	            }
	        });
	    };
	
	    $scope.skipNone = function () {
	        _.each($scope.steps, function (step) {
	            if (step.details.CanBeSkipped) {
	                step.enable = true;
	            }
	        });
	    };
	
	    $scope.showSkippedStepsWillAffectAutoDeploymentsWarning = function() {
	        var hasTriggers = $scope.triggers && $scope.triggers.Items.length > 0;
	
	        var hasSkippedSteps = $scope.steps && _.any($scope.steps, function(s) {
	                return s.enable === false;
	            });
	
	        return hasTriggers && hasSkippedSteps;
	    };
	
	    $scope.refreshPreview = function() {
	        if ($scope.view.selectedEnvironments.length === 0) {
	            return;
	        }
	
	        var promises = _.map($scope.view.selectedEnvironments, function(e) {
	            return octopusRepository.Releases.getDeploymentPreview($scope.promotionDictionary[e]);
	        });
	
	        isPreviewing.promise($q.all(promises).then(function (previews) {
	
	            var stepGroups = _.chain(previews).map(function (p) {
	                return p.StepsToExecute;
	            }).flatten().groupBy('ActionId').value();
	
	            $scope.steps = [];
	
	            $scope.steps = _.chain(stepGroups).map(function (steps, actionId) {
	                var wasSkipped = $scope.previous ? $scope.previous.SkipActions.indexOf(actionId) >= 0 : false;
	                var firstStep = steps[0];
	                var applicable = false;
	                _.each(steps, function (step) {
	                    if (!step.HasNoApplicableMachines) {
	                        applicable = true;
	                    }
	                });
	
	                var unavailableIds = {};
	                var unavailableMachines = _.chain(steps)
	                      .map(function (s) {
	                          return s.UnavailableMachines;
	                      })
	                      .flatten()
	                      .uniq(function (m) {
	                          return m.Id;
	                      })
	                      .each(function (m) {
	                          unavailableIds[m.Id] = m;
	                      })
	                      .value();
	
	                var allMachines = _.chain(steps)
	                      .map(function (s) {
	                          return s.Machines;
	                      })
	                      .flatten()
	                      .uniq(function (m) {
	                          return m.Id;
	                      })
	                      .each(function (m) {
	                          if (unavailableIds[m.Id]) {
	                              m.isUnavailable = true;
	                          }
	                      })
	                      .value();
	
	                var hasOldCalamariVersion = _.any(allMachines, function (m) {
	                    return !m.HasLatestCalamari;
	                });
	
	                return {
	                    details: {
	                        ActionId: firstStep.ActionId,
	                        ActionName: firstStep.ActionName,
	                        ActionNumber: firstStep.ActionNumber,
	                        CanBeSkipped: firstStep.CanBeSkipped,
	                        Machines: allMachines,
	                        UnavailableMachines: unavailableMachines,
	                        HasNoApplicableMachines: !applicable,
	                        HasOldCalamariVersion: hasOldCalamariVersion
	                    },
	                    enable: !wasSkipped
	                };
	            }).sortBy(function (s) {
	                return parseInt(s.details.ActionNumber);
	            }).value();
	
	            $scope.canSkipAll = $scope.steps.length >= 3;
	            $scope.specificMachines = [];
	            $scope.excludedMachines = [];
	            resetSpecificMachineSelections();
	
	            $scope.machinesApplicableToThisDeployment = [];
	            octopusPermissionSet.isAuthorized({ permission: 'MachineView', projectId: projectId, environmentId: '*' }).then(function(yn) {
	                if (yn) {
	                    machinesPromise.then(function (availableMachines) {
	                        $scope.machinesApplicableToThisDeployment = availableMachines.filter(function (machine) {
	                            if ($scope.view.deploymentType === 'tenant') {
	                                return ($scope.view.resultantTenants && $scope.view.resultantTenants.length > 0 && $scope.view.resultantTenants.filter(function (tenantId) {
	                                        return machine.TenantIds.indexOf(tenantId) >= 0;
	                                    }).length > 0)
	                                    || ($scope.view.selectedTenantTags && $scope.view.selectedTenantTags.length > 0 && $scope.view.selectedTenantTags.filter(function (tag) {
	                                        return machine.TenantTags.indexOf(tag) >= 0;
	                                    }).length > 0) 
	                                    || machine.TenantTags.length !== 0;
	                            }
	
	                            return (machine.TenantIds.length === 0 && machine.TenantTags.length === 0);
	                        });
	
	                        $scope.specificMachines = $scope.machinesApplicableToThisDeployment.filter(function (machine) {
	                            return $scope.steps.filter(function (step) {
	                                return step.details.Machines.filter(function (stepMachine) {
	                                    return stepMachine.Id === machine.Id;
	                                }).length > 0;
	                            }).length > 0;
	                        });
	                    });
	                }
	            });
	            $scope.unavailableMachines = _.chain($scope.steps).map(function (s) {
	                return s.details.UnavailableMachines;
	            }).flatten().uniq(function (m) {
	                return m.Id;
	            }).value();
	            $scope.deployment.SpecificMachineIds = [];
	            $scope.deployment.ExcludedMachineIds = [];
	            $scope.deployment.UseGuidedFailure = _.any(previews, function (p) {
	                return p.UseGuidedFailureModeByDefault;
	            });
	
	            var hasWarnings = false;
	            _.each($scope.steps, function (step) {
	                if (step.details.HasNoApplicableMachines) {
	                    hasWarnings = true;
	                }
	            });
	
	            if (hasWarnings) {
	                $scope.view.showAdvanced = true;
	            }
	
	            $scope.hasMachineWithOldCalamariVersion = false;
	            _.each($scope.steps, function (step) {
	                if (step.details.HasOldCalamariVersion) {
	                    $scope.hasMachineWithOldCalamariVersion = true;
	                }
	            });
	
	            var form = {Elements: [], Values: {}};
	            _.each(previews, function (preview) {
	                if (!preview || !preview.Form) {
	                    return;
	                }
	
	                if (preview.Form.Values) {
	                    _.each(preview.Form.Values, function (v, k) {
	                        form.Values[k] = v;
	                    });
	                }
	
	                if (preview.Form.Elements) {
	                    _.each(preview.Form.Elements, function (c) {
	                        if (!_.find(form.Elements, function (e) {
	                            return e.Name === c.Name;
	                        })) {
	                            form.Elements.push(c);
	                        }
	                    });
	                }
	            });
	
	            $scope.preview = {Form: form};
	        }));
	    };
	    
	    $scope.isMachineIncludedInDeployment = function (id) {
	        if ($scope.deployment.SpecificMachineIds.length > 0 && $scope.deployment.SpecificMachineIds.indexOf(id) < 0)
	        {
	            return false;
	        }
	
	        if ($scope.deployment.ExcludedMachineIds.length > 0 && $scope.deployment.ExcludedMachineIds.indexOf(id) >= 0)
	        {
	            return false;
	        }
	
	        return true;
	    };
	
	    $scope.isMachineApplicableToThisDeployment = function (id) {
	        return $scope.machinesApplicableToThisDeployment.length !== 0 
	            && _.find($scope.machinesApplicableToThisDeployment, function (machine) { return machine.Id === id; });
	    };
	
	    $scope.canSelectSpecificMachines = function () {
	        return $scope.view.selectedEnvironments.length === 1 && $scope.deployment && $scope.specificMachines;
	    };
	
	    function updateSpecificMachineSelection() {
	        if (!$scope.canSelectSpecificMachines()) {
	            resetSpecificMachineSelections();
	            return;
	        }
	
	        if ($scope.view.selectedSpecificMachineOption === 'all') {
	            $scope.deployment.SpecificMachineIds = [];
	            $scope.deployment.ExcludedMachineIds = [];
	            return;
	        }
	
	        var allApplicableMachineIds = _.map($scope.specificMachines, function(m) { return m.Id; });
	        
	        if ($scope.view.selectedSpecificMachineOption === 'include') {
	            $scope.deployment.SpecificMachineIds = ($scope.view.includeSpecificMachineIds.length > 0)
	                ? $scope.view.includeSpecificMachineIds
	                : allApplicableMachineIds;
	
	            $scope.deployment.ExcludedMachineIds = [];
	            return;
	        }
	        
	        if ($scope.view.selectedSpecificMachineOption === 'exclude') {
	            $scope.deployment.SpecificMachineIds = [];
	            $scope.deployment.ExcludedMachineIds = $scope.view.excludeSpecificMachineIds;
	            return;
	        }
	        
	        // If in doubt just reset everything...
	        resetSpecificMachineSelections();
	    }
	    
	    $scope.onlyIncludeAvailableMachines = function() {
	        var unavailableMachineIds = _.map($scope.unavailableMachines, function(m) { return m.Id; });
	        $scope.view.selectedSpecificMachineOption = 'exclude';
	        $scope.view.excludeSpecificMachineIds = _.union($scope.view.excludeSpecificMachineIds, unavailableMachineIds);
	        updateSpecificMachineSelection();
	    };
	
	    $scope.isTargetingAnyUnavailableMachines = function() {
	        if (!$scope.unavailableMachines || !$scope.deployment.SpecificMachineIds) {
	            return false;
	        }
	
	        var unavailableMachineIds = _.map($scope.unavailableMachines, function(m) { return m.Id; });
	
	        return ($scope.deployment.SpecificMachineIds.length === 0 && unavailableMachineIds.length > 0)
	            || (_.intersection($scope.deployment.SpecificMachineIds, unavailableMachineIds).length > 0);
	    };
	
	    function resetSpecificMachineSelections() {
	        if ($scope.view) {
	            $scope.view.selectedSpecificMachineOption = 'all';
	            $scope.view.includeSpecificMachineIds = [];
	            $scope.view.excludeSpecificMachineIds = [];
	        }
	        if ($scope.deployment) {
	            $scope.deployment.SpecificMachineIds = [];
	            $scope.deployment.ExcludedMachineIds = [];
	        }
	    }
	
	    $scope.newDeployments = {};
	
	    $scope.deploy = function () {
	        $scope.view.modifyDestination = false;
	
	        var deployments;
	        if ($scope.view.deploymentType === "normal") {
	            deployments = createEnvironmentDeployments();
	        } else if ($scope.view.deploymentType === "tenant") {
	            deployments = createTenantDeployments();
	        } else {
	            throw "Unknown Deployment Type";
	        }
	
	        isSaving.promise(deployments.then(function(tasks){
	            return $q.all(tasks.map(function(item) {
	                return item.deployment.then(function(deployment) {
	                    setDeploymentState(item.environmentId, item.tenantId, {state: 'success', deployment: deployment});
	                    checkCanRedirect();
	                }, function(error){
	                    setDeploymentState(item.environmentId, item.tenantId, {state: 'error', error: error});
	                });
	            }));
	        }).then(checkCanRedirect));
	
	        function checkCanRedirect() {
	            var first, last;
	            for (var environmentId in $scope.newDeployments) {
	                for (var tenantId in $scope.newDeployments[environmentId]) {
	                    first = first || $scope.newDeployments[environmentId][tenantId];
	                    last =  $scope.newDeployments[environmentId][tenantId];
	                    if ($scope.newDeployments[environmentId][tenantId].state !== 'success'){
	                        return;
	                    }
	                }
	            }
	
	            if (!first) { //none have returned
	                return;
	            }
	
	            if (first === last) { // only one request
	                $location.path('/projects/' + $scope.project.Slug + '/releases/' + $scope.release.Version + '/deployments/' + last.deployment.Id);
	            } else {
	                $location.path('/projects/' + $scope.project.Slug + '/releases/' + $scope.release.Version);
	            }
	        }
	    };
	
	    function setDeploymentState(environmentId, tenantId, state){
	        $scope.newDeployments[environmentId] = $scope.newDeployments[environmentId] || {};
	        $scope.newDeployments[environmentId][tenantId] = state;
	    }
	
	    function createEnvironmentDeployments(){
	      var tenantId = null;
	
	      return $q.resolve($scope.view.selectedEnvironments.filter(function(environmentId){
	          return !$scope.newDeployments[environmentId] ||
	              !$scope.newDeployments[environmentId][tenantId] ||
	              $scope.newDeployments[environmentId][tenantId].state !== "success";
	      }).map(function(environmentId) {
	          return createDeployment(environmentId, tenantId);
	      }));
	    }
	
	    function createDeployment(environmentId, tenantId) {
	        var deployment = {
	            ReleaseId: $scope.release.Id,
	            EnvironmentId: environmentId,
	            TenantId: tenantId,
	            SkipActions: $scope.steps.filter(function (step) {
	                return !step.enable;
	            }).map(function (step) {
	                return step.details.ActionId;
	            }),
	            QueueTime: $scope.view.queueTime,
	            QueueTimeExpiry: $scope.view.queueTimeExpiry,
	            FormValues: $scope.preview.Form.Values,
	            ForcePackageDownload: $scope.deployment.ForcePackageDownload,
	            UseGuidedFailure: $scope.deployment.UseGuidedFailure,
	            SpecificMachineIds: $scope.deployment.SpecificMachineIds,
	            ExcludedMachineIds: $scope.deployment.ExcludedMachineIds,
	            ForcePackageRedeployment: $scope.deployment.ForcePackageRedeployment
	        };
	
	        setDeploymentState(environmentId, tenantId, {state: 'running'});
	
	        return {
	            tenantId: tenantId,
	            environmentId: environmentId,
	            deployment: octopusRepository.Deployments.create(deployment)
	        };
	    }
	
	    function createTenantDeployments(){
	        var environmentId = $scope.view.selectedEnvironments[0];
	
	        return getTenants().then(function(tenantIds) {
	            return tenantIds.filter(function(tenantId){
	                return !$scope.newDeployments[environmentId] ||
	                !$scope.newDeployments[environmentId][tenantId] ||
	                $scope.newDeployments[environmentId][tenantId].state !== "success";
	            }).map(function (tenantId) {
	                return createDeployment(environmentId, tenantId);
	            });
	        });
	
	        function getTenants() {
	            if ($scope.view.selectedTenantTags.length !== 0) {
	                return $scope.view.loadMatchingTenants();
	            } else {
	                return $q.resolve($scope.view.selectedTenants);
	            }
	        }
	    }
	
	    init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectEditController', function ($scope, $stateParams, busy, pageTitle, projectState, octopusRepository, $location, unsavedChanges, octoDialog, octopusAuthenticator, octopusPermissionSet){
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.project = null;
	    $scope.projectGroups = null;
	    $scope.otherProjects = null;
	    $scope.createOptions = {};
	    $scope.createOptions.clone = null;
	
	    isLoading.promise(octopusRepository.ProjectGroups.all().then(function (groups) {
	        isLoading.promise(octopusRepository.Lifecycles.all().then(function (lifecycles) {
	            var projectId = $stateParams.projectId;
	            var groupId = $stateParams.grpid || $location.search().grpid;
	            var cloneFromId = $location.search().clone;
	
	            $scope.lifecycles = lifecycles;
	            $scope.lifecyclesById = _.object(_.pluck(lifecycles, "Id"), lifecycles);
	            $scope.projectGroups = groups;
	
	            if (projectId) {
	                isLoading.promise(projectState.load().then(function (project) {
	                    isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {
	                        if (project.ProjectConnectivityPolicy == null) {
	                            project.ProjectConnectivityPolicy = {
	                                OfflineDeploymentBehavior: "Fail"
	                            };
	                        }
	                        $scope.project = project;
	                        $scope.deploymentProcess = deploymentProcess;
	                        $scope.view = { versionFromPackage: !!project.VersioningStrategy.DonorPackageStepId };
	                        $scope.packageActions = _.filter(
	                            _.flatten(
	                                _.map(deploymentProcess.Steps,
	                                    function(s) { return s.Actions; })),
	                            function(a) { return !!a.Properties["Octopus.Action.Package.PackageId"]; });
	                    }));
	                    pageTitle(project.Name + " settings");
	                }));
	            } else {
	                isLoading.promise(octopusRepository.Alerts.list().then(function(alerts) {
	                    $scope.alerts = alerts;
	                }));
	                isLoading.promise(octopusRepository.Projects.all().then(function(otherProjects){
	                    if (cloneFromId) {
	                        $scope.createOptions.clone = cloneFromId;
	                    }
	                    $scope.otherProjects = otherProjects;
	
	                    if (!groupId && groups.length) {
	                        groupId = groups[0].Id;
	                    }
	
	                    $scope.project = { ProjectGroupId: groupId, LifecycleId: $scope.lifecycles[0].Id, DefaultToSkipIfAlreadyInstalled: false, VersioningStrategy: { Template: '#{Octopus.Version.LastMajor}.#{Octopus.Version.LastMinor}.#{Octopus.Version.NextPatch}' } };
	                    $scope.view = { versionFromPackage: false };
	                    pageTitle("Create project");
	                }));
	            }
	        }));
	    }));
	
	    $scope.save = function() {
	        if ($scope.view.versionFromPackage) {
	            $scope.project.VersioningStrategy.Template = null;
	        } else {
	            $scope.project.VersioningStrategy.DonorPackageStepId = null;
	        }
	
	        var doSave = $scope.project.Id ?
	            octopusRepository.Projects.modify($scope.project) :
	            octopusRepository.Projects.create($scope.project, $scope.createOptions);
	
	        isSaving.promise(doSave.then(function (saved) {
	            unsavedChanges.saved();
	
	            if (!$scope.project.Id)
	            {
	                octopusRepository.Users.getPermissions(Octopus.App.currentUser).then(function(permissions) {
	                    octopusAuthenticator.setCurrentPrincipal(Octopus.App.currentUser, permissions.Permissions);
	                    octopusPermissionSet.refresh();
	                    $location.path("/projects/" + saved.Slug);
	                });
	            }
	            else
	      {
	          $location.path("/projects/" + saved.Slug);
	      }
	        }));
	    };
	
	    $scope.resetVersionTemplate = function() {
	        $scope.project.VersioningStrategy.Template =
	          '#{Octopus.Version.LastMajor}.#{Octopus.Version.LastMinor}.#{Octopus.Version.NextPatch}';
	    };
	
	    $scope.$watch('project.TenantedDeploymentMode', function (nv, ov) {
	        if (nv === 'Untenanted') {
	            octopusRepository.Tenants.list({projectId: $scope.project.Id}).then(function (results) {
	                if (results.TotalResults > 0) {
	                    octoDialog.alertMessageBox({
	              title: 'Tenants are connected to this project',
	              message: 'You can not disable tenanted deployments because some tenants are connected to this project. Please disconnect all tenants from this project, and then disable tenanted deployments.',
	          }).finally(function () {
	              $scope.project.TenantedDeploymentMode = ov;
	          });
	                }
	            });
	        }
	    });
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectIndexController', function ($scope, $location, $timeout, busy, octopusRepository){
	    var isLoading = $scope.isLoading = busy.create();
	
	    $scope.projectGroups = null;
	    $scope.projects = {};
	    $scope.pulses = {};
	    $scope.view = { showEmptyGroups: false };
	    $scope.projectCount = 0;
	    $scope.projectsLoading = {};
	    $scope.projectGroupsWaitingForProjectsToLoad = 0;
	    var newProjectGroupId = $location.search().newProjectGroupId;
	
	    isLoading.promise(octopusRepository.ProjectGroups.all().then(function (results) {
	        $scope.projectGroups = results;
	        _.each(results, function(pg) {
	            $scope.projectGroupsWaitingForProjectsToLoad++;
	            var groupLoading = $scope.projectsLoading[pg.Id] = busy.create();
	            groupLoading.promise(octopusRepository.Projects.listByGroup(pg).then(function(projects) {
	                $scope.projects[pg.Id] = projects;
	                $scope.projectCount = $scope.projectCount + projects.TotalResults;
	                $scope.projectGroupsWaitingForProjectsToLoad--;
	            }));
	        });
	    }));
	
	    var hasProjects = function(projectGroup) {
	        var projects = $scope.projects[projectGroup.Id];
	        return projects && projects.Items.length > 0;
	    };
	
	    $scope.isGroupVisible = function(projectGroup) {
	        return $scope.view.showEmptyGroups || hasProjects(projectGroup) || (newProjectGroupId && projectGroup.Id === newProjectGroupId);
	    };
	
	    $scope.anyShowing = function() {
	        return _.find($scope.projectGroups, $scope.isGroupVisible);
	    };
	
	    $scope.anyHiding = function() {
	        return _.find($scope.projectGroups, function(g) { return !$scope.isGroupVisible(g); });
	    };
	
	    $scope.anyLoading = function () {
	        return $scope.isLoading.busy ||
	          _.find(_.values($scope.projectsLoading), function(gl) { return gl.busy; });
	    };
	});
	
	
	
	
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 516 */
/***/ function(module, exports) {

	angular.module('octopusApp.projects')
	    .controller('ProjectLayoutController', function($scope, projectState) {
	        var self = $scope;
	        self.project = null;
	        self.projectId = projectState.projectId;
	        self.isLoading = projectState.isLoading;
	        self.isSaving = projectState.isSaving;
	        self.suppressCreateRelease = false;
	
	        $scope.$watch(function () {
	            return projectState.deploymentProcess;
	        }, function(deploymentProcess) {
	            self.suppressCreateRelease = !deploymentProcess || deploymentProcess.Steps.length < 1;
	        });
	
	        $scope.$watch(function () {
	            return projectState.project;
	        }, function (project) {
	            self.project = project;
	        });
	    }).provider('projectState', function() {
	        this.$get = function($stateParams, $timeout, busy, octopusRepository) {
	            var state = {
	                isLoading: busy.create(),
	                isSaving: busy.create(),
	                projectId: $stateParams.projectId,
	                project: null,
	                projectAsync: null,
	                deploymentProcessAsync: null,
	                deploymentProcess: null
	            };
	
	            function load() {
	                state.projectAsync = octopusRepository.Projects.get(state.projectId).then(function (project) {
	                    state.deploymentProcessAsync = octopusRepository.DeploymentProcesses.get(project.DeploymentProcessId).then(function(deploymentProcess) {
	                        return (state.deploymentProcess = deploymentProcess);
	                    });
	                    state.isLoading.promise(state.deploymentProcessAsync);
	                    return (state.project = project);
	                });
	                state.isLoading.promise(state.projectAsync);
	
	                return state.projectAsync;
	            }
	
	            $timeout(function() {
	                if (!state.projectAsync) {
	                    console.warn("Project State was not populated by content controller.");
	                    load();
	                }
	            }, 5000);
	
	            state.load = load;
	            return state;
	        };
	    });

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller("ProjectLifecycleSelectorDialogController", function($scope, $injector, pluginRegistry, projectId, $uibModalInstance, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isPreviewing = $scope.isPreviewing = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  isLoading.promise(octopusRepository.Projects.get(projectId).then(function (project) {
	    isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
	      isLoading.promise(octopusRepository.Lifecycles.all().then(function (lifecycles) {
	        $scope.lifecycles = lifecycles;
	        $scope.environments = environments;
	        $scope.project = project;
	        $scope.lifecyclesById = _.object(_.pluck(lifecycles, "Id"), lifecycles);
	
	        $scope.preview();
	      }));
	    }));
	  }));
	
	  $scope.preview = function() {
	    var selected = $scope.lifecyclesById[$scope.project.LifecycleId];
	
	    isPreviewing.promise(octopusRepository.Lifecycles.preview(selected).then(function (previewLifecycle) {
	      $scope.previewLifecycle = previewLifecycle;
	    }));
	  };
	
	  $scope.accept = function() {
	    isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function (p) {
	      $uibModalInstance.close(true);
	    }));
	  };
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectLogoController', function ($scope, $location, $stateParams, projectState, busy, octopusRepository, octoUploader, octopusClient) {
	    var octoUpload = octoUploader.create($scope);
	
	    var projectId = $stateParams.projectId;
	    $scope.isLoading = busy.create();
	    $scope.isUploading = busy.create();
	    $scope.octoUpload = octoUpload;
	    $scope.beginReset = beginReset;
	    $scope.beginUpload = beginUpload;
	
	
	    $scope.cancel = function () {
	        octoUpload.cancel();
	
	        var form = $("#logoUpload")[0];
	        if (form) {
	            form.reset();
	        }
	    };
	
	
	    function init() {
	        $scope.isLoading.promise(projectState.load().then(onProjectLoaded));
	    }
	
	    function beginUpload() {
	        var url = octopusClient.resolve($scope.project.Links['Logo']);
	        $scope.isUploading.promise(octoUpload.begin(url).then(function () {
	            $location.path('/projects/' + $scope.project.Id + '/settings');
	        }));
	    }
	
	    function beginReset() {
	        $scope.isUploading.promise(octopusClient.put($scope.project.Links['Logo'], null).then(function () {
	            $location.path('/projects/' + $scope.project.Id + '/settings');
	        }));
	    }
	
	    function onProjectLoaded(project) {
	        $scope.project = project;
	    }
	
	    init();
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, jQuery) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectOverviewController', function ($scope, $location, busy, $stateParams, $state, projectState, pageTitle, octopusRepository, pollLoop, $q, $uibModal, octopusTagSets) {
	    var vm = this;
	    var isLoading = vm.isLoading = busy.create();
	
	
	    vm.showFastboard = false;
	    vm.dashboardType = 'project';
	    vm.showPrevious = false;
	    vm.hasDeploymentSteps = false;
	    vm.togglePrevious = togglePrevious;
	    vm.openTenantFilterDialog = openTenantFilterDialog;
	
	    vm.availableTenants = [];
	    vm.tenantPromotions = {};
	    vm.dashboardFilter = {showAll: true};
	    vm.isFiltered = false;
	
	    vm.clearFilters = false;
	    var clearAllFilters = function () {
	        vm.dashboardFilter.selectedTags = [];
	        vm.dashboardFilter.selectedTenants = [];
	        vm.isFiltered = false;
	        $location.search("tenants", null);
	        $location.search("tags", null);
	        refreshActiveComponents();
	        return false;
	    };
	
	    function extractTenantFilterParams(){
	        if ($location.search().tenants){
	            var tenantVal = $location.search().tenants;
	            if (typeof tenantVal === "string") {
	                tenantVal = [tenantVal];
	            }
	            vm.dashboardFilter.selectedTenants = tenantVal;
	            vm.isFiltered = true;
	        }
	        if ($location.search().tags){
	            var tagVal = $location.search().tags;
	            if (typeof tagVal === "string") {
	                tagVal = [tagVal];
	            }
	            vm.dashboardFilter.selectedTags = tagVal;
	            vm.isFiltered = true;
	        }
	    }
	
	    function extractReleaseFilterParams() {
	        if ($location.search().release) {
	            var foundRelease = _.find(vm.releases, function (item) {
	                return item.Version === $location.search().release;
	            });
	            if (foundRelease) {
	                vm.selectedRelease = foundRelease;
	                vm.dashboardFilter.releaseId = foundRelease.Id;
	            }
	        }
	    }
	
	    function extractGroupByParams() {
	        if ($location.search().groupBy) {
	            var foundGroupBy = _.find(vm.tagSets, function (item) {
	                return item.Name === $location.search().groupBy;
	            });
	
	            if (foundGroupBy) {
	                vm.groupBy = foundGroupBy;
	            }
	        }
	    }
	
	    function openTenantFilterDialog() {
	        if (vm.clearFilters) {
	            clearAllFilters();
	            vm.clearFilters = false;
	            return;
	        }
	
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/tenants/advanced_tenant_selector/design_selected_tags_dialog.html',
	            controller: 'DesignSelectedTagsController',
	            controllerAs: 'vm',
	            bindToController: true,
	            resolve: {
	                selectedValues: function () {
	                    return {
	                        selectedTenants: vm.dashboardFilter.selectedTenants,
	                        selectedTags: vm.dashboardFilter.selectedTags
	                    };
	                },
	                visibleTenantFilter: function () {
	                    return function (tenant) {
	                        return false;
	                    };
	                },
	                hideTenants: function () {
	                    return vm.hideTenants;
	                }
	            }
	        }).result.then(function (result) {
	            if (!result) {
	                return;
	            }
	            vm.dashboardFilter.selectedTenants = result.selectedTenants;
	            vm.dashboardFilter.selectedTags = result.selectedTags;
	            vm.isFiltered = result.selectedTenants.length > 0 || result.selectedTags.length > 0;
	
	            if (vm.dashboardFilter.selectedTenants && vm.dashboardFilter.selectedTenants.length > 0) {
	                $location.search('tenants', vm.dashboardFilter.selectedTenants);
	            } else {
	                $location.search('tenants', undefined);
	            }
	
	            if (vm.dashboardFilter.selectedTags && vm.dashboardFilter.selectedTags.length > 0) {
	                $location.search('tags', vm.dashboardFilter.selectedTags);
	            } else {
	                $location.search('tags', undefined);
	            }
	
	            refreshActiveComponents();
	        });
	    }
	
	    function togglePrevious() {
	        vm.showPrevious = !vm.showPrevious;
	    }
	
	    function getDashboardGroups(tagSet) {
	        var groups = [{
	            Name: '',
	            IsGrouped: true
	        }];
	
	        _.each(tagSet.Tags, function (tag) {
	            groups.push({
	                Name: tagSet.Name + ': ' + tag.Name,
	                CanonicalTagName: tag.CanonicalTagName,
	                IsGrouped: true
	            });
	        });
	        return groups;
	    }
	
	    function getGroupByOptions(tenants) {
	        var tagSetsInUse = _.uniq(_.flatten(_.map(tenants, function (tenant) { return tenant.TenantTags; })));
	        var groupedTagSets = octopusTagSets.groupByTagSet(tagSetsInUse);
	        return _.filter(vm.tagSets, function (tagSet) { return groupedTagSets[tagSet.Name]; });
	    }
	
	    var refreshActiveComponents = function () {
	        var project = vm.project;
	        if (!vm.showFastboard) {
	            return isLoading.promise(octopusRepository.Progression.getProgression(project).then(function (progression) {
	                if (vm.progressionSnapshot !== undefined && _.isEqual(vm.progressionSnapshot, progression)) {
	                    // Nothing has changed, don't update the view (or this can cause scrollbars to reset their position unnecessarily).
	                    return;
	                }
	                vm.progressionSnapshot = jQuery.extend(true, {}, progression); // deep copy (we can't use vm.progression because it gets tampered with elsewhere, screwing with our equality checks)
	                vm.progression = progression;
	
	                if (vm.triggers.Items.length === 0) {
	                    vm.unsuccessfulDashboardItemExists = false;
	                    return;
	                }
	
	                vm.unsuccessfulDashboardItemExists = _.some(vm.progression.Releases, function (release) {
	                    return _.some(release.Deployments, function (deployments) {
	                         return _.some(deployments, function (deployment) {
	                            return isFailedDeploymentForAutoDeployEnvironment(deployment);
	                        });
	                    });
	                });
	            }));
	        } else {
	            return isLoading.promise(octopusRepository.Dashboards.getDashboard(vm.dashboardFilter).then(function (dashboardData) {
	                if (vm.dashboardDataSnapshot !== undefined && _.isEqual(vm.dashboardDataSnapshot, dashboardData)) {
	                    // Nothing has changed, don't update the view (or this can cause scrollbars to reset their position unnecessarily).
	                    return;
	                }
	                vm.dashboardDataSnapshot = jQuery.extend(true, {}, dashboardData); // deep copy (we can't use vm.dashboardData because it gets tampered with elsewhere, screwing with our equality checks)
	
	                vm.groupByOptions = getGroupByOptions(dashboardData.Tenants);
	
	                _.each(dashboardData.Tenants, function (tenant) {
	                    tenant.isMissingVariable = function () {
	                        if (!vm.missingVariables) {
	                            return null;
	                        }
	                        return vm.missingVariables.indexOf(tenant.Id) !== -1;
	                    };
	                });
	
	                if (vm.groupBy) {
	                    dashboardData.Groups = getDashboardGroups(vm.groupBy);
	                }
	
	                if (vm.dashboardFilter.selectedTags && vm.dashboardFilter.selectedTags.length > 0) {
	                    dashboardData.SelectedTags = vm.dashboardFilter.selectedTags;
	                }
	
	                if (vm.dashboardFilter.selectedTenants && vm.dashboardFilter.selectedTenants.length > 0) {
	                    dashboardData.SelectedTenants = vm.dashboardFilter.selectedTenants;
	                }
	
	                vm.unsuccessfulDashboardItemExists = false;
	                if (vm.triggers.Items.length > 0) {
	                    vm.unsuccessfulDashboardItemExists = _.some(dashboardData.Items, function (dashboardItem) {
	                        return isFailedDeploymentForAutoDeployEnvironment(dashboardItem);
	                    });
	                }
	
	                if (vm.selectedRelease) {
	                    return isLoading.promise(octopusRepository.Releases.getDeploymentTemplate(vm.selectedRelease).then(function (template) {
	                        var tenantPromotions = {};
	                        template.TenantPromotions.forEach(function (tenantPromotion) {
	                            tenantPromotion.PromoteTo.forEach(function (environmentPromotion) {
	                                var key = environmentPromotion.Id + '__' + tenantPromotion.Id;
	                                if (!tenantPromotions[key]) {
	                                    tenantPromotions[key] = {
	                                        tenantId: tenantPromotion.Id,
	                                        environment: environmentPromotion
	                                    };
	                                }
	                            });
	                        });
	                        dashboardData.TenantPromotions = tenantPromotions;
	                        dashboardData.PromoteTo = template.PromoteTo;
	                        vm.dashboardData = dashboardData;
	                    }));
	                } else {
	                    vm.dashboardData = dashboardData;
	                }
	            }));
	        }
	    };
	
	    function isFailedDeploymentForAutoDeployEnvironment(deployment) {
	        if (!isFailedDeployment(deployment)) {
	            return false;
	        }
	
	        return _.some(vm.triggers.Items, function(trigger) {
	            if (trigger.Type !== "DeploymentTarget") {
	                return false;
	            }
	
	            var triggerEnvironments = trigger.Properties["Octopus.ProjectTriggerCondition.Environments"];
	
	            if (!triggerEnvironments || triggerEnvironments.length === 0) { // any environment
	                return true;
	            }
	
	            return _.contains(triggerEnvironments.split(','), deployment.EnvironmentId);
	        });
	    }
	
	    function isFailedDeployment(deployment) {
	        return (deployment !== undefined
	          && deployment.IsCompleted === true
	          && deployment.IsCurrent === true
	          && deployment.State !== undefined
	          && deployment.State !== 'Success'
	          && deployment.State !== 'Queued'
	          && deployment.State !== 'Executing');
	    }
	
	    function init() {
	        var loop = pollLoop.create($scope, function () {
	            return refreshActiveComponents();
	        });
	
	        extractTenantFilterParams();
	        isLoading.promise(projectState.load().then(function (project) {
	            vm.project = project;
	            vm.dashboardFilter.projectId = project.Id;
	            pageTitle(project.Name);
	
	            isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {
	                vm.deploymentProcess = deploymentProcess;
	                vm.hasDeploymentSteps = vm.deploymentProcess.Steps.length > 0;
	
	                var promises = [];
	                promises.push(octopusRepository.Projects.getTriggers(vm.project).then(function (triggers) {
	                    vm.triggers = triggers;
	                }));
	
	                if (!octopusRepository.Tenants) {
	                    isLoading.promises(promises).then(function() {
	                        loop.startImmediately();
	                    });
	                    return;
	                }
	
	                promises.push(octopusRepository.Tenants.all({projectId: vm.project.Id}).then(function (tenants) {
	                    vm.availableTenants = tenants;
	                    vm.showFastboard = tenants.length > 0;
	                }));
	                promises.push(octopusRepository.Tenants.missingVariables({projectId: vm.project.Id}, false).then(function (missingVariables) {
	                    vm.missingVariables = _.pluck(missingVariables, 'TenantId');
	                }));
	                promises.push(octopusRepository.Projects.getReleases(vm.project).then(function (releases) {
	                    vm.releases = releases.Items;
	                }));
	                promises.push(octopusTagSets.getAll().then(function (tagSets) {
	                    vm.tagSets = tagSets;
	                }));
	
	                isLoading.promises(promises).then(function() {
	                    extractReleaseFilterParams();
	                    extractGroupByParams();
	
	                    $scope.$watch('vm.selectedRelease', function (nv, ov) {
	                        if (!nv) {
	                            vm.dashboardFilter.releaseId = undefined;
	                            $location.search('release', undefined);
	                        } else {
	                            vm.dashboardFilter.releaseId = nv.Id;
	                            $location.search('release', nv.Version);
	                        }
	                        if (ov || nv) {
	                            refreshActiveComponents();
	                        }
	                    });
	
	                    $scope.$watch('vm.groupBy', function (nv, ov) {
	                        if (!nv) {
	                            $location.search('groupBy', undefined);
	                        } else {
	                            $location.search('groupBy', nv.Name);
	                        }
	                        if (ov || nv) {
	                            refreshActiveComponents();
	                        }
	                    });
	
	                    loop.startImmediately();
	                });
	
	            }));
	        }));
	    }
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectProcessController', function ($scope, $stateParams, projectState, $q, busy, pageTitle, octopusRepository, $state, pluginRegistry, octoDialog, $uibModal, $location, unsavedChanges){
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var projectId = $stateParams.projectId;
	    $scope.project = null;
	
	    $scope.actionClass = function(action) {
	        return action.ActionType.replace(".", "").toLowerCase();
	    };
	
	    $scope.canHaveChildren = function(step) {
	        return _.some(step.Actions, function (a) { 
	            var actionDefinition = pluginRegistry.getDeploymentAction(a.ActionType);
	            return actionDefinition.canHaveChildren(step);
	        });
	    };
	
	    var getTags = function(allOptions, selectedOptions) {
	        if (allOptions.length === 0) {
	            return "";
	        }
	
	        var result = [];
	
	        _.each(selectedOptions, function (e) {
	            if (allOptions.indexOf(e.Id) >= 0) {
	                result.push(e.Name);
	            }
	        });
	
	        return result.join(",");
	    };
	
	    function init() {
	
	        var environmentPromise = octopusRepository.Environments.all().then(function (environments) {
	            $scope.environments = environments;
	        });
	
	        isLoading.promise(projectState.load().then(function (project) {
	            $scope.project = project;
	            pageTitle(project.Name + " deployment process");
	
	            var lifeCyclesPromise = octopusRepository.Lifecycles.get(project.LifecycleId)
	                .then(octopusRepository.Lifecycles.preview)
	                .then(function (lifecycle) {
	                    $scope.lifecycle = lifecycle;
	                });
	            var channelsPromise = octopusRepository.Projects.getChannels(project).then(function (channels) {
	                $scope.channels = channels;
	            });
	
	            var deploymentProcesPromise = projectState.deploymentProcessAsync.then(function (deploymentProcess) {
	                $scope.deploymentProcess = deploymentProcess;
	                $scope.builtInFeedPackageActions = _.filter(
	                    _.flatten(
	                        _.map(deploymentProcess.Steps,
	                            function (s) {
	                                return s.Actions;
	                            })),
	                    function (a) {
	                        return a.Properties["Octopus.Action.Package.FeedId"] === 'feeds-builtin';
	                    });
	            });
	
	            return $q.all([environmentPromise, lifeCyclesPromise, channelsPromise, deploymentProcesPromise]);
	        }).then(function(){
	            _.each($scope.deploymentProcess.Steps, function (s) {
	                _.each(s.Actions, function (a) {
	                    a.environments = getTags(a.Environments || [], $scope.environments);
	                    a.excludedEnvironments = getTags(a.ExcludedEnvironments || [], $scope.environments);
	                    a.channels = getTags(a.Channels, $scope.channels.Items);
	                });
	            });
	        }).then(updateIncludedSets)
	        .then(function() {
	            unsavedChanges.saved();
	        }));
	    }
	
	    var updateIncludedSets = function() {
	        return isLoading.promise(octopusRepository.LibraryVariableSets.all({contentType: 'ScriptModule'}).then(function(libraryVariableSets){
	            $scope.includedScriptModules = _.filter(libraryVariableSets, function(set){
	                var included = _.find($scope.project.IncludedLibraryVariableSetIds, function(id){
	                    return id === set.Id;
	                });
	                return included;
	            });
	        }));
	    };
	
	    $scope.configureLibraryScriptModules = function() {
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/views/include_variables_dialog.html',
	            controller: 'ProjectVariablesIncludeController',
	            resolve: {
	                current: function () { return _.toArray($scope.project.IncludedLibraryVariableSetIds); },
	                contentType: function() { return 'ScriptModule'; },
	                contentTypeDesc: function() { return 'Script Module'; }
	            }
	        }).result.then(function(result) {
	            if (result) {
	                if (!_.isEqual(result, $scope.project.IncludedLibraryVariableSetIds)) {
	                    $scope.project.IncludedLibraryVariableSetIds = _.toArray(result);
	                    return isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function(project){
	                        $scope.project = project;
	                        return updateIncludedSets();
	                    }));
	                }
	            }
	        });
	    };
	
	    $scope.addStep = function (stepId) {
	        if (!stepId) {
	            $location.path("/projects/" + $scope.project.Slug + "/steptemplates");
	        }
	        else {
	            $location.path("/projects/" + $scope.project.Slug + "/childsteptemplates/" + stepId);
	        }
	    };
	
	    var modifyProcess = function(stepId, actionId, callback) {
	        isLoading.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id)
	            .then(function (deploymentProcess) {
	                var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });
	                if (!step) { return; }
	                                
	                var action = _.find(step.Actions, function (a) { return a.Id === actionId; });
	
	                var result = callback(deploymentProcess, step, action);
	
	                if (result) {
	                    isSaving.promise(isLoading.promise(octopusRepository.DeploymentProcesses.save(deploymentProcess).then(function () {
	                        $state.reload();
	                    })));
	                }
	            }));
	    };
	
	    $scope.disableAction = function(stepId, actionId) {
	        modifyProcess(stepId, actionId, function (process, step, action) {
	            action.IsDisabled = true;
	            return true;
	        });
	    };
	    
	    $scope.enableAction = function(stepId, actionId) {
	        modifyProcess(stepId, actionId, function (process, step, action) {
	            action.IsDisabled = false;
	            return true;
	        });
	    };
	    
	    $scope.disableAllActions = function(stepId) {
	        modifyProcess(stepId, null, function (process, step, action) {
	            _.each(step.Actions, function (a) {
	                a.IsDisabled = true;
	            });
	            return true;
	        });
	    };
	    
	    $scope.enableAllActions = function(stepId) {
	        modifyProcess(stepId, null, function (process, step, action) {
	            _.each(step.Actions, function (a) {
	                a.IsDisabled = false;
	            });
	            return true;
	        });
	    };
	
	    $scope.cloneStep = function(stepId, actionId) {
	        modifyProcess(stepId, actionId, function (process, step, action) {
	            var nameOfActionExists = function (steps, actionName) {
	                return _.filter(steps, function (s) {
	                    return (s.Name === actionName) || (_.filter(s.Actions, function (a) { return a.Name === actionName; }).length > 0);
	                }).length > 0;
	            };
	
	            var getNewActionName = function (steps, clonedAction) {
	                var suffix = "";
	                var counter = 1;
	                while (nameOfActionExists(steps, clonedAction.Name + suffix)) {
	                    suffix = " - clone (" + counter + ")";
	                    counter++;
	                }
	
	                return clonedAction.Name + suffix;
	            };
	
	            var stepNameExists = function (steps, stepName) {
	                return _.filter(steps, function (s) {
	                    return s.Name === stepName;
	                }).length > 0;
	            };
	
	            var getNewStepName = function (steps, clonedStep) {
	                var suffix = "";
	                var counter = 1;
	                while (stepNameExists(steps, clonedStep.Name + suffix)) {
	                    suffix = " - clone (" + counter + ")";
	                    counter++;
	                }
	
	                return clonedStep.Name + suffix;
	            };
	
	            if (action && step.Actions.length > 1) {
	                var clonedAction = JSON.parse(JSON.stringify(action));
	                clonedAction.Id = "";
	                clonedAction.Name = getNewActionName(process.Steps, clonedAction);
	
	                var actionIndex = _.indexOf(step.Actions, action);
	                step.Actions.splice(actionIndex + 1, 0, clonedAction);
	            } else {
	                var clonedStep = JSON.parse(JSON.stringify(step));
	                clonedStep.Id = "";
	                clonedStep.Name = getNewStepName(process.Steps, clonedStep);
	                for (var i = 0;i < clonedStep.Actions.length;i++) {
	                    clonedStep.Actions[i].Id = "";
	                    clonedStep.Actions[i].Name = getNewActionName(process.Steps, clonedStep.Actions[i]);
	                }
	                var stepIndex = _.indexOf(process.Steps, step);
	                process.Steps.splice(stepIndex + 1, 0, clonedStep);
	            }
	
	            return true;
	        });
	    };
	    
	    $scope.moveOut = function(stepId, actionId) {
	        modifyProcess(stepId, actionId, function (process, step, action) {
	            var newStep = {
	                Name: action.Name,
	                RequiresPackagesToBeAcquired: step.RequiresPackagesToBeAcquired,
	                Properties: step.Properties,
	                Condition : step.Condition,
	                StartTrigger: step.StartTrigger,
	                Actions: [
	                    action
	                ]
	            };
	
	            var name = newStep.Name;
	            var i = 1;
	            var isStep = function(s) {
	                return s.Name === newStep.Name;
	            };
	            while (true) {
	                if (!_.some(process.Steps, isStep)){
	                    break;
	                }
	                newStep.Name = name + " " + i;
	                i++;
	            }
	
	            var actionIndex = _.indexOf(step.Actions, action);
	            step.Actions.splice(actionIndex, 1);
	
	            var stepIndex = _.indexOf(process.Steps, step);
	            process.Steps.splice(stepIndex + 1, 0, newStep);
	
	            return true;
	        });
	    };
	
	    $scope.moveIn = function(stepId, actionId) {
	        var steps = _.filter($scope.deploymentProcess.Steps, function (s) { 
	            return s.Id !== stepId && $scope.canHaveChildren(s);
	        });
	
	        var step = _.find($scope.deploymentProcess.Steps, function (s) { return s.Id === stepId; });
	        var action = _.find(step.Actions, function (a) { return a.Id === actionId; });
	
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/views/step_list_dialog.html',
	            controller: 'StepListController',
	            resolve: {
	                action: function () { return action; },
	                steps: function () { return steps; }
	            }
	        }).result.then(function(result) {
	            var moveIt = function() {
	                modifyProcess(stepId, actionId, function (process, step, action) {
	                    // Copy the action to the new step
	                    var newParent = _.find(process.Steps, function (s) { return s.Id === result.Id; });
	                    newParent.Actions.splice(newParent.Actions.length, 0, action);
	
	                    // Remove action from the old step
	                    var actionIndex = _.indexOf(step.Actions, action);
	                    step.Actions.splice(actionIndex, 1);
	
	                    // Remove parent step if no actions left
	                    if (step.Actions.length === 0) {
	                        var stepIndex = _.indexOf(process.Steps, step);
	                        process.Steps.splice(stepIndex, 1);
	                    }
	                    return true;
	                });
	            };
	
	            if (result) {
	                if (step.Properties["Octopus.Action.TargetRoles"] !== result.Properties["Octopus.Action.TargetRoles"]) {
	                    octoDialog.messageBox(
	                        "Confirm target role change",
	                        "This step previously targeted a different set of roles than the step you are moving it to. This means the step is now likely to run on a different set of machines. Are you sure you wish to move the step?",
	                        [{
	                        result: 'yes',
	                        label: 'Move',
	                        cssClass: 'btn-success'
	                        }, {
	                        result: 'cancel',
	                        label: 'Cancel'
	                        }]).then(function (result) {
	                        if (result === 'yes') {
	                            moveIt();
	                        }
	                        });
	                } else {
	                    moveIt();
	                }
	
	
	                
	            }
	        });
	    };
	
	    $scope.deleteStep = function(stepId, actionId) {
	        octoDialog.asyncConfirm({
	            title: "Delete step",
	            message: "Are you sure you wish to delete this step? This action cannot be undone.",
	            executeButtonClass: "btn-warning",
	            executeButtonText: "Delete",
	            execute: function (dialog) {
	                dialog.busy.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id).then(function (deploymentProcess) {
	                    var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });
	                    if (step) {
	                        var deleteStep = false;
	
	                        if (actionId) {
	                            var action = _.find(step.Actions, function (a) { return a.Id === actionId; });
	                            if (action) {
	                                var actionIndex = _.indexOf(step.Actions, action);
	                                step.Actions.splice(actionIndex, 1);
	
	                                if (step.Actions.length === 0) {
	                                    deleteStep = true;
	                                }
	                            }
	                        } else {
	                            deleteStep = true;
	                        }
	
	                        if (deleteStep) {
	                            var stepIndex = _.indexOf(deploymentProcess.Steps, step);
	                            deploymentProcess.Steps.splice(stepIndex, 1);
	                        } else if (step.Actions.length === 1) {
	                            step.Name = step.Actions[0].Name;
	                        }
	                    }
	
	                    dialog.busy.promise(octopusRepository.DeploymentProcesses.save(deploymentProcess).then(function() {
	                        dialog.dismiss();
	                        $state.reload();
	                    }));
	                }));
	            }
	        });
	    };
	
	    $scope.reorderSteps = function(stepId) {
	        octoDialog.sort({
	            title: "Reorder Steps",
	            saveButtonText: "Save",
	            load: function(dialog) {
	                dialog.busy.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id).then(function (deploymentProcess) {
	                    var items = [];
	
	                    if (stepId) {
	                        var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });
	                        dialog.render(_.map(step.Actions, function (action) {
	                            return {
	                                id: action.Id,
	                                name: action.Name
	                            };
	                        }));
	                    } else {
	                        dialog.render(_.map(deploymentProcess.Steps, function (action) {
	                            return {
	                                id: action.Id,
	                                name: action.Name
	                            };
	                        }));
	                    }
	                }));
	            },
	            save: function (items, dialog) {
	                dialog.busy.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id).then(function (deploymentProcess) {
	                    if (stepId) {
	                        var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });
	
	                        var oldActions = step.Actions;
	                        step.Actions = _.map(items, function (id) {
	                            return _.find(oldActions, function (s) { return s.Id === id; });
	                        });
	                    } else {
	                        var oldSteps = deploymentProcess.Steps;
	                        deploymentProcess.Steps = _.map(items, function (id) {
	                            return _.find(oldSteps, function (s) { return s.Id === id; });
	                        });
	                    }
	
	                    dialog.busy.promise(octopusRepository.DeploymentProcesses.save(deploymentProcess).then(function() {
	                        dialog.dismiss();
	                        $state.reload();
	                    }));
	                }));
	            }
	        });
	    };
	
	    $scope.changeLifecycle = function (){
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/views/lifecycle_selector_dialog.html',
	            controller: 'ProjectLifecycleSelectorDialogController',
	            resolve: {
	                projectId: function () { return $scope.project.Id; }
	            }
	        }).result.then(function(result) {
	            if (result) {
	                $state.reload();
	            }
	        });
	    };
	
	    $scope.changeProjectConnectivityPolicy = function () {
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/views/target_settings_dialog.html',
	            controller: 'TargetSettingsDialogController',
	            resolve: {
	                projectId: function () { return $scope.project.Id; }
	            }
	        }).result.then(function(result) {
	            if (result) {
	                $state.reload();
	            }
	        });
	    };
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectProcessFeaturesController', function ($scope, octopusRepository, pluginRegistry, currentStep, currentAction, $uibModalInstance) {
	    $scope.features = [];
	    $scope.close = closeModal;
	    $scope.save = save;
	    $scope.featureToggled = featureToggled;
	    $scope.removedFeatures = [];
	
	    var actionType = pluginRegistry.getDeploymentAction(currentAction.ActionType);
	    var allFeatures = pluginRegistry.getAllFeatures();
	    var enabledFeatures = [];
	
	    function init(){
	        if (currentAction.Properties["Octopus.Action.EnabledFeatures"]) {
	            enabledFeatures = currentAction.Properties["Octopus.Action.EnabledFeatures"].split(',');
	        }
	
	        if (actionType.features && actionType.features.optional) {
	            allFeatures.forEach(function (feature) {
	                if (!_.contains(actionType.features.optional, feature.featureName)) {
	                    return;
	                }
	
	                $scope.features.push({
	                    featureName: feature.featureName,
	                    title: feature.title,
	                    description: feature.description,
	                    instance: feature,
	                    isEnabled: _.contains(enabledFeatures, feature.featureName),
	                    wasEnabled: _.contains(enabledFeatures, feature.featureName)
	                });
	            });
	        }
	    }
	
	    function featureToggled() {
	        $scope.removedFeatures = $scope.features.filter(function(feature){
	            return feature.wasEnabled && !feature.isEnabled;
	        }).map(function(feature){
	            return feature.title;
	        });
	    }
	
	    function closeModal() {
	        $uibModalInstance.close();
	    }
	
	    function save() {
	        var currentlyEnabled;
	        // permanent actions are always enabled
	        if (actionType.features && actionType.features.permanent) {
	            currentlyEnabled = actionType.features.permanent;
	        } else {
	            currentlyEnabled = [];
	        }
	
	        $scope.features.forEach(function (feature) {
	            if (feature.isEnabled) {
	                currentlyEnabled.push(feature.featureName);
	            }
	
	            if (!feature.wasEnabled && feature.isEnabled) {
	                if (feature.instance.enable) {
	                    feature.instance.enable(currentAction, currentStep);
	                }
	            }
	        });
	        currentAction.Properties["Octopus.Action.EnabledFeatures"] = currentlyEnabled.join(',');
	        $uibModalInstance.close(true);
	    }
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectProcessStepEditController',
	    function ($scope, $state, $uibModal, octoDialog, $stateParams, projectState, busy, pageTitle, octopusRepository, pluginRegistry,
	              octopusLog, $location, unsavedChanges, $q, actionExecutionLocations) {
	        $scope.isLoading = projectState.isLoading;
	        var isSaving = $scope.isSaving = busy.create();
	        var projectId = $stateParams.projectId;
	        $scope.project = null;
	        $scope.step = null;
	        $scope.environments = null;
	        $scope.deploymentProcess = null;
	        $scope.roles = [];
	        $scope.hasFeatures = false;
	        $scope.canChooseRoles = false;
	        $scope.unavailableEnvironments = [];
	        $scope.unavailableExcludedEnvironments = [];
	        $scope.channels = null;
	        $scope.executionLocations = actionExecutionLocations;
	        $scope.condition = {
	            environmentOption: 'all',
	            inclusiveEnvironments: [],
	            exclusiveEnvironments: [],
	            hasHiddenEnvironments: false
	        };
	
	        $scope.actionClass = function (action) {
	            return action.ActionType.replace(".", "").toLowerCase();
	        };
	
	        $scope.runsOnServer = function (action, executionLocation) {
	            return action && executionLocation &&
	                (executionLocation === $scope.executionLocations.alwaysOnServer ||
	                (executionLocation === $scope.executionLocations.targetOrServer && action.Properties['Octopus.Action.RunOnServer'] === 'true'));
	        };
	
	        $scope.$on('actionTemplateEditor:dirty', function () {
	            unsavedChanges.unsaved();
	        });
	
	        var stepId = $stateParams["stepId"];
	        var actionType = $stateParams["actionType"];
	        var template = $stateParams["template"];
	
	        var findAction = function (deploymentProcess, id) {
	            for (var i = 0; i < deploymentProcess.Steps.length; i++) {
	                var step = deploymentProcess.Steps[i];
	                for (var j = 0; j < step.Actions.length; j++) {
	                    var action = step.Actions[j];
	                    if (action.Id === id) {
	                        return {action: action, step: step, actionIndex: j, stepIndex: i};
	                    }
	                }
	            }
	            return null;
	        };
	
	        var onLoaded = function () {
	
	            if ($scope.action) {
	                $scope.isNew = (!$scope.action.Name);
	                var plugin = pluginRegistry.getDeploymentAction($scope.action.ActionType);
	                if ($scope.isNew && plugin.hasPackages($scope.action) && $scope.feeds.length === 0) {
	                    return $q.reject({ErrorMessage: "A NuGet package feed is required before this step can be configured. Please add a feed in the Configuration area and try again."});
	                }
	
	                // If the execution location is optional, default it to run on the target
	                if ($scope.isNew && plugin.executionLocation === actionExecutionLocations.targetOrServer) {
	                    $scope.action.Properties["Octopus.Action.RunOnServer"] = "false";
	                }
	
	                // If the execution location is locked, clean up the mess we've made by accidentally setting "Octopus.Action.RunOnServer" for all actions
	                if (plugin.executionLocation !== actionExecutionLocations.targetOrServer) {
	                    delete $scope.action.Properties["Octopus.Action.RunOnServer"];
	                }
	
	                $scope.hasFeatures = pluginRegistry.hasFeaturesForAction($scope.action.ActionType);
	                $scope.executionLocation = plugin.executionLocation;
	                $scope.canChooseRoles = plugin.canChooseRoles;
	                $scope.isMultiAction = ($scope.step.Actions.length > 1 || $scope.step.Actions[0] !== $scope.action);
	                $scope.rolesAreEditable = ($scope.step.Actions.length === 1 && $scope.step.Actions[0] === $scope.action) || $scope.step.Actions.length === 0;
	                $scope.conditionIsEditable = $scope.step.Actions.length === 1 && $scope.step.Actions[0] === $scope.action || $scope.step.Actions.length === 0;
	                $scope.originalActionName = $scope.action.Name || "New step";
	            } else {
	                $scope.canChooseRoles = true;
	                $scope.hasFeatures = false;
	                $scope.rolesAreEditable = true;
	                $scope.conditionIsEditable = true;
	            }
	
	            var stepIndex = _.indexOf($scope.deploymentProcess.Steps, $scope.step);
	            var isNotFirstStep = (stepIndex > 0 || (stepIndex < 0 && $scope.deploymentProcess.Steps.length > 0));
	            $scope.conditionIsEditable = $scope.conditionIsEditable && isNotFirstStep;
	            $scope.originalStepName = $scope.step.Name;
	
	            // If we DON'T have an action, or the action does NOT have packages, we canRunBeforeAcquisition
	            // Wrapping this in an object for future additions (plus this solved some weird issues with scope and directives).
	            $scope.viewOptions = {
	                canRunBeforeAcquisition: !$scope.action || !pluginRegistry.getDeploymentAction($scope.action.ActionType).hasPackages($scope.action),
	            };
	
	            _.each($scope.deploymentProcess.Steps, function (step, i) {
	                if (!$scope.viewOptions.canRunBeforeAcquisition) {
	                    return;
	                }
	
	                if (i <= stepIndex || stepIndex < 0) {
	                    var hasPackages = _.any(step.Actions, function (action) {
	                        var actionDefinition = pluginRegistry.getDeploymentAction(action.ActionType);
	                        return actionDefinition && actionDefinition.hasPackages(action);
	                    });
	
	                    if (hasPackages) {
	                        $scope.viewOptions.canRunBeforeAcquisition = false;
	                    }
	                }
	            });
	
	            if ($scope.action) {
	                var knownEnvironments = _.map($scope.environments, function (e) {
	                    return e.Id;
	                });
	                $scope.unavailableEnvironments = _.difference($scope.action.Environments || [], knownEnvironments);
	                $scope.unavailableExcludedEnvironments = _.difference($scope.action.ExcludedEnvironments || [], knownEnvironments);
	
	                $scope.condition.inclusiveEnvironments = _.intersection($scope.action.Environments || [], knownEnvironments);
	                $scope.condition.exclusiveEnvironments = _.intersection($scope.action.ExcludedEnvironments || [], knownEnvironments);
	                $scope.condition.hasHiddenEnvironments = $scope.unavailableEnvironments.length + $scope.unavailableExcludedEnvironments.length > 0;
	            }
	
	            $scope.runConditions = [
	                {value: "Success", description: "Success: only run when previous steps are successful"},
	                {value: "Failure", description: "Failure: only run when a previous step failed"},
	                {value: "Variable", description: "Variable: only run when the variable expression is true"},
	                {value: "Always", description: "Always run"}
	            ];
	
	            $scope.startTriggers = [
	                {value: "StartAfterPrevious", description: "Wait for the previous step to complete, then start"},
	                {value: "StartWithPrevious", description: "Run in parallel with the previous step"}
	            ];
	        };
	
	        var find;
	        var promises = [
	            octopusRepository.Environments.all().then(function (environments) {
	                $scope.environments = environments;
	            }),
	            octopusRepository.MachineRoles.all().then(function (machineRoles) {
	                $scope.availableRoles = machineRoles;
	            }),
	            octopusRepository.Feeds.all().then(function (feeds) {
	                $scope.feeds = feeds;
	            }),
	            projectState.load().then(function (project) {
	                $scope.project = project;
	
	                return $q.all(
	                    [
	                        projectState.deploymentProcessAsync
	                            .then(function (deploymentProcess) {
	                                $scope.deploymentProcess = deploymentProcess;
	
	                                if (!actionType) {
	                                    find = findAction(deploymentProcess, stepId);
	                                }
	
	                                var getTemplate;
	                                if (template) {
	                                    getTemplate = octopusRepository.ActionTemplates.get(template);
	                                } else if (find && find.action.Properties["Octopus.Action.Template.Id"]) {
	                                    getTemplate = octopusRepository.ActionTemplates.get(find.action.Properties["Octopus.Action.Template.Id"]);
	                                } else {
	                                    var qq = $q.defer();
	                                    getTemplate = qq.promise;
	                                    qq.resolve(null);
	                                }
	
	                                return getTemplate.then(function (actionTemplate) {
	                                    $scope.actionTemplate = actionTemplate;
	                                });
	
	                            }),
	
	                        octopusRepository.Projects.getChannels(project)
	                            .then(function (channels) {
	                                $scope.channels = channels.Items;
	                            })
	                    ]);
	            })
	        ];
	
	        $scope.isLoading.promise($q.all(promises)).then(function () {
	            if (!actionType) {
	                if (find) {
	                    $scope.step = find.step;
	                    $scope.action = find.action;
	                    pageTitle($scope.step.Name);
	                } else {
	                    $scope.step = _.find($scope.deploymentProcess.Steps, function (s) {
	                        return s.Id === stepId;
	                    });
	                    $scope.action = null;
	                    pageTitle($scope.step.Name);
	                }
	            } else {
	                if (stepId) {
	                    var step = _.find($scope.deploymentProcess.Steps, function (s) {
	                        return s.Id === stepId;
	                    });
	                    if (step) {
	                        $scope.step = step;
	                        $scope.action = {
	                            ActionType: actionType,
	                            Name: "",
	                            Environments: [],
	                            ExcludedEnvironments: [],
	                            Channels: [],
	                            TenantTags: [],
	                            Properties: {}
	                        };
	
	                        pageTitle("New step for: " + step.Name);
	                    }
	                }
	                if (!$scope.step) {
	                    $scope.step = {
	                        Name: "",
	                        Environments: [],
	                        Channels: [],
	                        TenantTags: [],
	                        Properties: {},
	                        Condition: "Success",
	                        StartTrigger: "StartAfterPrevious",
	                        Actions: [
	                            {
	                                ActionType: actionType,
	                                Name: "",
	                                Environments: [],
	                                ExcludedEnvironments: [],
	                                Channels: [],
	                                TenantTags: [],
	                                Properties: {}
	                            }
	                        ]
	                    };
	                    $scope.action = $scope.step.Actions[0];
	                    pageTitle("New step");
	                }
	
	                if ($scope.actionTemplate) {
	                    $scope.action.Name = $scope.step.Name = $scope.actionTemplate.Name;
	                    $scope.action.Properties = _.clone($scope.actionTemplate.Properties);
	                    $scope.action.Properties["Octopus.Action.Template.Id"] = $scope.actionTemplate.Id;
	                    $scope.action.Properties["Octopus.Action.Template.Version"] = $scope.actionTemplate.Version;
	                    _.each($scope.actionTemplate.Parameters, function (parameter) {
	                        if (typeof parameter.DefaultValue !== 'undefined' && parameter.DefaultValue !== null && parameter.DefaultValue !== '') {
	
	                            if (parameter.DisplaySettings['Octopus.ControlType'] === 'Sensitive') {
	                                $scope.action.Properties[parameter.Name] = {
	                                    HasValue: true,
	                                    NewValue: parameter.DefaultValue
	                                };
	                                return;
	                            }
	
	                            $scope.action.Properties[parameter.Name] = parameter.DefaultValue;
	                        }
	                    });
	                }
	            }
	
	            if (!!$scope.action) {
	                if (($scope.action.Environments || []).length > 0) {
	                    $scope.condition.environmentOption = 'include';
	                } else if (($scope.action.ExcludedEnvironments || []).length > 0) {
	                    $scope.condition.environmentOption = 'exclude';
	                } else {
	                    $scope.condition.environmentOption = 'all';
	                }
	            }
	
	            // Provide default fallback for script templates.
	            if ($scope.action && $scope.action.ActionType === 'Octopus.Script' && $scope.action.Properties && $scope.action.Properties['Octopus.Action.RunOnServer'] == null) {
	                $scope.action.Properties['Octopus.Action.RunOnServer'] = 'false';
	            }
	
	            $scope.view = {editingBatchSize: $scope.step.Properties["Octopus.Action.MaxParallelism"]};
	            $scope.beginEditBatchSize = function (fixed) {
	                if (typeof fixed !== 'undefined') {
	                    $scope.step.Properties["Octopus.Action.MaxParallelism"] = fixed;
	                }
	            };
	            $scope.endEditBatchSize = function () {
	                $scope.step.Properties["Octopus.Action.MaxParallelism"] = $scope.view.editingBatchSize;
	            };
	            return onLoaded();
	        });
	
	        $scope.showAddFeaturesDialog = function (action) {
	            $uibModal.open({
	                backdrop: true,
	                keyboard: true,
	                templateUrl: 'areas/projects/views/process_features_dialog.html',
	                controller: 'ProjectProcessFeaturesController',
	                dialogClass: 'modal modal-big',
	                resolve: {
	                    currentAction: function () {
	                        return action;
	                    },
	                    currentStep: function () {
	                        return $scope.step;
	                    }
	                }
	            }).result.then(function (result) {
	            });
	        };
	
	        function updateFeatures() {
	            var enabledFeatureNames = ($scope.action.Properties["Octopus.Action.EnabledFeatures"] || "")
	                .split(',')
	                .filter(function(name){
	                    return name !== "";
	                });
	            
	            var enabledFeatures = enabledFeatureNames.map(function (f) {
	                return pluginRegistry.getFeature(f);
	            });
	
	            var errors = [];
	
	            enabledFeatures.forEach(function (feature) {
	                if (feature.validate) {
	                    feature.validate($scope.action, $scope.step, errors);
	                }
	            });
	            if (errors.length > 0) {
	                isSaving.showErrors("There was a problem with your request.", errors);
	                return false;
	            }
	
	            pluginRegistry.getAllFeatures().forEach(function (feature) {
	                if(enabledFeatureNames.indexOf(feature.featureName) === -1){
	                    feature.disable($scope.action, $scope.step);
	                }
	            });
	
	            enabledFeatures.forEach(function (feature) {
	                if (feature.preSave) {
	                    feature.preSave($scope.action, $scope.step);
	                }
	            });
	            return true;
	        }
	
	        function updateEnvironments() {
	            $scope.action.Environments = _.uniq(($scope.condition.inclusiveEnvironments || []).concat($scope.unavailableEnvironments));
	            $scope.action.ExcludedEnvironments = _.uniq(($scope.condition.exclusiveEnvironments || []).concat($scope.unavailableExcludedEnvironments));
	
	            if ($scope.condition.environmentOption !== 'include'){
	                $scope.action.Environments.splice(0);
	            }
	            if ($scope.condition.environmentOption !== 'exclude'){
	                $scope.action.ExcludedEnvironments.splice(0);
	            }
	        }
	
	        $scope.save = function () {
	
	            if ($scope.action) {
	                if (!$scope.action.Name || $scope.action.Name.length === 0) {
	                    if ($scope.action.Properties["Octopus.Action.Package.PackageId"]) {
	                        $scope.action.Name = $scope.action.Properties["Octopus.Action.Package.PackageId"];
	                    }
	                }
	
	                if(!updateFeatures()){
	                    return;
	                }
	                updateEnvironments();
	            }
	
	            if ($scope.step.Actions.length === 1) {
	                // Step name should always match action name if there is only one action
	                $scope.step.Name = $scope.step.Actions[0].Name;
	            }
	
	            var applyChange = function (deploymentProcess) {
	                isSaving.promise(octopusRepository.DeploymentProcesses.modify(deploymentProcess).then(function () {
	                    unsavedChanges.saved();
	                    $state.go('app.project.process', {projectId: $scope.project.Slug});
	                }));
	            };
	
	            isSaving.promise(octopusRepository.DeploymentProcesses.get($scope.project.DeploymentProcessId).then(function (deploymentProcess) {
	                if (actionType) {
	                    if (stepId) {
	                        var step = _.find(deploymentProcess.Steps, function (s) {
	                            return s.Id === stepId;
	                        });
	                        step.Actions.push($scope.action);
	                    } else {
	                        deploymentProcess.Steps.push($scope.step);
	                    }
	                    applyChange(deploymentProcess);
	                    return;
	                }
	
	                if ($scope.action) {
	                    var find = findAction(deploymentProcess, stepId);
	                    if (!find) {
	                        octoDialog.messageBox("Conflict", "Someone else has deleted this step from the deployment process. Would you like to add the step back?", [{
	                            result: 'yes',
	                            label: 'Restore the step',
	                            cssClass: 'btn-success'
	                        }, {result: 'cancel', label: 'Cancel'}])
	                            .then(function (result) {
	                                if (result === 'yes') {
	                                    var index = _.indexOf($scope.deploymentProcess.Steps, $scope.step);
	                                    octopusLog.info("Inserting the step back at position: ", index);
	                                    deploymentProcess.Steps.splice(index, 0, $scope.step);
	                                    applyChange(deploymentProcess);
	                                }
	                            });
	                    } else {
	                        find.step.Actions[find.actionIndex] = $scope.action;
	                        find.step.Name = $scope.step.Name;
	                        find.step.RequiresPackagesToBeAcquired = $scope.step.RequiresPackagesToBeAcquired;
	                        find.step.Condition = $scope.step.Condition;
	                        find.step.StartTrigger = $scope.step.StartTrigger;
	                        _.each($scope.step.Properties, function (val, key) {
	                            find.step.Properties[key] = val;
	                        });
	                        applyChange(deploymentProcess);
	                    }
	                } else {
	                    var originalStep = _.find(deploymentProcess.Steps, function (s) {
	                        return s.Id === stepId;
	                    });
	                    originalStep.Name = $scope.step.Name;
	                    originalStep.RequiresPackagesToBeAcquired = $scope.step.RequiresPackagesToBeAcquired;
	                    originalStep.Condition = $scope.step.Condition;
	                    originalStep.StartTrigger = $scope.step.StartTrigger;
	                    _.each($scope.step.Properties, function (val, key) {
	                        originalStep.Properties[key] = val;
	                    });
	                    applyChange(deploymentProcess);
	                }
	            }));
	        };
	    });
	
	
	
	
	
	
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectReleaseController', function ($scope, busy, $state, $stateParams, projectState, $q, pageTitle, octopusRepository, octoDialog, pollLoop) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isRefreshing = $scope.isRefreshing = busy.create();
	    var projectId = $stateParams.projectId;
	    var releaseVersion = $stateParams.version;
	
	    var loop = pollLoop.create($scope, function () { return refreshActiveComponents(); });
	    $scope.isEventsLoading = busy.create();
	    $scope.snapshotVariables = snapshotVariables;
	    $scope.$on('progress-updates', function(event) {
	        getReleaseProgression($scope.release);
	    });
	
	    function init() {
	        isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
	            $scope.environments = environments;
	        }));
	
	        isLoading.promise(projectState.load().then(function (project) {
	
	            isLoading.promise(octopusRepository.Projects.getChannels(project).then(function(channels) {
	                $scope.channels = channels.Items; 
	            }));
	
	            isLoading.promise(projectState.deploymentProcessAsync.then(function (currentDeploymentProcess) {
	                $scope.currentDeploymentProcess = currentDeploymentProcess;
	            }));
	
	            isLoading.promise(octopusRepository.Projects.getReleaseByVersion(project, releaseVersion).then(function (release) {
	                getLifecycle(project, release);
	
	                isLoading.promise(octopusRepository.DeploymentProcesses.get(release.ProjectDeploymentProcessSnapshotId).then(function (deploymentProcess) {
	                    isLoading.promise(octopusRepository.DeploymentProcesses.getTemplate(deploymentProcess, release.ChannelId, release.Id).then(function (template) {
	                        load(project, release);
	                        $scope.deploymentProcess = deploymentProcess;
	                        $scope.template = template;
	
	
	                        _.each(template.Packages, function (packageTemplate) {
	                            var selectionForStep = _.find(release.SelectedPackages, function (selected) {
	                                return selected.StepName === packageTemplate.StepName;
	                            });
	
	                            if (selectionForStep) {
	                                var pkg = {
	                                    StepName: packageTemplate.StepName,
	                                    PackageId: packageTemplate.PackageId,
	                                    FeedName: packageTemplate.FeedName,
	                                    FeedId: packageTemplate.FeedId,
	                                    Version: selectionForStep.Version,
	                                    Notes: 'Loading...',
	                                    State: 'loading'
	                                };
	
	                                $scope.packages.push(pkg);
	
	                            }
	                        });
	                    }));
	                }, function () {
	                    load(project, release);
	                }));
	            }));
	        }));
	    }
	
	    function getLifecycle(project, release) {
	        if (release.ChannelId) {
	            isLoading.promise(octopusRepository.Channels.get(release.ChannelId).then(function(channel) {
	                $scope.channel = channel;
	                var lifecycleId = (channel.LifecycleId) ? channel.LifecycleId : project.LifecycleId;
	                isLoading.promise(octopusRepository.Lifecycles.get(lifecycleId).then(function (lifecycle) {
	                    $scope.lifecycle = lifecycle;
	                }));
	            }));
	        }
	        else
	    {
	        isLoading.promise(octopusRepository.Lifecycles.get(project.LifecycleId).then(function (lifecycle) {
	            $scope.lifecycle = lifecycle;
	        }));
	    }
	    }
	
	    function getReleaseProgression(release) {
	        isRefreshing.promise(octopusRepository.Releases.progression(release).then(function (progression) {
	            $scope.progression = progression;
	        }));
	    }
	
	    function mergeListData(scopeList, newList, initializeCallback) {
	        if (scopeList) {
	            scopeList.Items = newList.Items;
	            scopeList.Links = newList.Links;
	            scopeList.IsStale = newList.IsStale;
	            scopeList.ItemsPerPage = newList.ItemsPerPage;
	            scopeList.TotalResults = newList.TotalResults;
	        }
	        else {
	            initializeCallback();
	        }
	    }
	
	    function refreshActiveComponents() {
	        var release = $scope.release;
	        return isLoading.promise(octopusRepository.Releases.getDeployments(release, ($scope.deployments && $scope.deployments.Page > 0) ? $scope.deployments.Page * $scope.deployments.ItemsPerPage : 0)).then(function (deployments) {
	            mergeListData($scope.deployments, deployments, function (){ $scope.deployments = deployments; });
	            loadEvents(release.Id);
	            return $q.all([loadArtifacts(release.Id), loadProgression(release)]);
	        });
	
	        function loadArtifacts(releaseId) {
	            return isLoading.promise(octopusRepository.Artifacts.list({regarding: releaseId, skip: ($scope.artifacts && $scope.artifacts.Page > 0) ? $scope.artifacts.Page * $scope.artifacts.ItemsPerPage : 0}).then(function (artifacts) {
	                mergeListData($scope.artifacts, artifacts, function (){ $scope.artifacts = artifacts; });
	            }));
	        }
	
	        function loadEvents(releaseId) {
	            return $scope.isEventsLoading.promise(octopusRepository.Events.list({regarding: releaseId, skip: ($scope.events && $scope.events.Page > 0) ? $scope.events.Page * $scope.events.ItemsPerPage : 0}).then(function (events) {
	                mergeListData($scope.events, events, function (){ $scope.events = events; });
	            }));
	        }
	
	        function loadProgression(release){
	            isLoading.promise(octopusRepository.Releases.progression(release).then(function (progression) {
	                $scope.progression = progression;
	            }));
	        }
	    }
	
	    function load(project, release) {
	        pageTitle(project.Name + " release " + release.Version);
	        $scope.project = project;
	        $scope.release = release;
	        $scope.packages = [];
	        loop.startImmediately();
	    }
	
	    function snapshotVariables() {
	        var message = "Octopus takes a snapshot of the variables each time a release is created. By updating the variables, the current snapshot will be discarded, and the latest variables (as seen on the Variables tab) will be imported.";
	
	        if ($scope.currentDeploymentProcess.LastSnapshotId !== $scope.release.ProjectDeploymentProcessSnapshotId) {
	            message += " As your deployment process has changed since the release was created, if you removed any deployment steps, keep in mind that variables might also have been deleted that you still rely on for this release.";
	        }
	
	        octoDialog.asyncConfirm({
	            title: "Confirm variable update",
	            message: message,
	            executeButtonClass: "btn-danger",
	            executeButtonText: "Update variables",
	            execute: function (dialog) {
	                dialog.busy.promise(octopusRepository.Releases.snapshotVariables($scope.release).then(function(release) {
	                    dialog.dismiss();
	                    $state.reload();
	                }));
	            }
	        });
	    }
	
	    init();
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectReleaseEditController', function ($scope, busy, $timeout, $location, $stateParams, pageTitle, octopusLog, octopusRepository, $uibModal, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var projectId = $stateParams.projectId;
	    var channelId = $stateParams.channelId;
	    var releaseVersion = $stateParams.version;
	
	    $scope.deploymentProcess = null;
	    $scope.packageSelections = [];
	    $scope.hasBeenModified = false;
	    $scope.violatedPackages = [];
	    $scope.versionModified = function () {
	        $scope.hasBeenModified = true;
	    };
	    $scope.setVersionSatisfaction = setVersionSatisfaction;
	    $scope.options = {
	        ignoreChannelRules: false
	    };
	
	    $scope.channels = [];
	
	    $scope.showSearchDialog = function (pkg) {
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/views/package_list_dialog.html',
	            controller: 'ProjectReleasePackageListController',
	            resolve: {
	                currentPackage: function () {
	                    return pkg;
	                },
	                channelFilters: function () {
	                    return getChannelFilters(pkg.StepName);
	                }
	            }
	        }).result.then(function (result) {
	            if (result) {
	                pkg.SpecificVersion = result;
	                pkg.VersionType = 'specific';
	                $scope.packageVersionChanged(pkg, result);
	            }
	        });
	    };
	
	    $scope.specificVersionSelected = function(pkg){
	        pkg.VersionType = "specific";
	        setVersionSatisfaction(pkg, pkg.SpecificVersion);
	    };
	
	    $scope.packageVersionChanged = function (pkg, version) {
	        if ($scope.template.VersioningPackageStepName && $scope.template.VersioningPackageStepName === pkg.StepName) {
	            $scope.release.Version = version;
	        }
	        setVersionSatisfaction(pkg, version);
	    };
	
	    $scope.save = function () {
	        var release = $scope.release;
	        release.SelectedPackages = [];
	        for (var i = 0; i < $scope.packageSelections.length; i++) {
	            var selection = $scope.packageSelections[i];
	            var selectedVersion = '';
	            if (selection.VersionType === 'latest') {
	                selectedVersion = selection.LatestVersion;
	            } else if (selection.VersionType === 'last') {
	                selectedVersion = selection.LastReleaseVersion;
	            } else if (selection.VersionType === 'specific') {
	                selectedVersion = selection.SpecificVersion;
	            }
	
	            release.SelectedPackages.push({
	                'StepName': selection.StepName,
	                'Version': selectedVersion
	            });
	        }
	
	        if ($scope.channels.Items === 1) {
	            release.ChannelId = $scope.channels.Items[0].Id;
	        }
	
	        isSaving.promise(octopusRepository.Releases.save(release, {ignoreChannelRules: $scope.options.ignoreChannelRules}).then(function (newRelease) {
	            unsavedChanges.saved();
	            $location.path("/projects/" + $scope.project.Slug + "/releases/" + newRelease.Version);
	        }));
	    };
	
	    $scope.channelSelected = function () {
	        loadTemplate();
	    };
	
	    function init() {
	        isLoading.promise(octopusRepository.Projects.get(projectId).then(function (project) {
	            $scope.project = project;
	            isLoading.promise(octopusRepository.Projects.getChannels(project))
	              .then(function (channels) {
	                  $scope.channels = channels;
	
	                  if (angular.isDefined(releaseVersion) && releaseVersion !== null) {
	                      isLoading.promise(octopusRepository.Projects.getReleaseByVersion(project, releaseVersion).then(function (release) {
	                          $scope.release = release;
	                          $scope.originalVersion = release.Version;
	                          $scope.originalChannelId = $scope.release.ChannelId;
	                          pageTitle("Edit release " + release.Version);
	                          loadDeploymentProcess(release.ProjectDeploymentProcessSnapshotId);
	                      }));
	                  } else {
	                      var defaultChannel = _.find($scope.channels.Items, function (channel) {
	                          return channel.IsDefault;
	                      });
	                      $scope.release = {
	                          ProjectId: project.Id,
	                          ChannelId: channelId ? channelId : defaultChannel ? defaultChannel.Id : $scope.channels.Items[0].Id
	                      };
	                      pageTitle("Create release for " + project.Name);
	                      loadDeploymentProcess(project.DeploymentProcessId);
	                  }
	              });
	        }));
	    }
	
	    function getChannelFilters(deploymentActionName) {
	        var filters = {};
	
	        if (!$scope.release.ChannelId) {
	            return filters;
	        }
	
	        var applicableRules = $scope.channels.Items
	            .filter(function (x) {
	                return x.Id === $scope.release.ChannelId;
	            })[0]
	            .Rules
	            .filter(function (rule) {
	                return rule.Actions.length === 0 || _.contains(rule.Actions, deploymentActionName);
	            })[0];
	
	        if (applicableRules && applicableRules.VersionRange) {
	            filters.versionRange = applicableRules.VersionRange;
	        }
	
	        if (applicableRules && applicableRules.Tag) {
	            filters.preReleaseTag = applicableRules.Tag;
	        }
	
	        return filters;
	    }
	
	    function setVersionSatisfaction(pkg, version) {
	        var filters = getChannelFilters(pkg.StepName);
	
	        octopusRepository.Channels.ruleTest(version, {
	            versionRange: filters.versionRange,
	            preReleaseTag: filters.preReleaseTag
	        }).then(function (result) {
	            pkg.isSelectedVersionValid = result.Errors.indexOf("Invalid Version Number") !== -1 || (result.SatisfiesVersionRange && result.SatisfiesPreReleaseTag);
	
	            var position = $scope.violatedPackages.indexOf(pkg.StepName);
	            if (pkg.isSelectedVersionValid && position !== -1) {
	                $scope.violatedPackages.splice(position, 1);
	            } else if (!pkg.isSelectedVersionValid && position === -1) {
	                $scope.violatedPackages.push(pkg.StepName);
	            }
	        });
	    }
	
	    function loadVersions(selectionsByFeed) {
	        octopusLog.log("Loading packages by feed", selectionsByFeed);
	        $scope.feedLoadingError = null;
	
	        _.each(selectionsByFeed, function (selections, feedId) {
	
	            isLoading.promise(octopusRepository.Feeds.get(feedId).then(function (feed) {
	                _.each(selections, function (selection) {
	
	                    var filters = getChannelFilters(selection.StepName);
	                    checkForRuleSatisfaction(selection, filters);
	
	                    var searchOptions = _.extend({
	                        packageId: selection.PackageId,
	                        partialMatch: false,
	                        includeMultipleVersions: false,
	                        includePreRelease: true,
	                        includeNotes: false,
	                        take: 1
	                    }, filters);
	
	                    octopusRepository.Feeds.search(feed, searchOptions).then(function (packages) {
	                        if (packages.length > 0) {
	                            var pkg = packages[0];
	                            selection.LatestVersion = pkg.Version;
	
	                            if (!$scope.release.Id) {
	                                $scope.packageVersionChanged(selection, pkg.Version);
	                            } else {
	                                setVersionSatisfaction(selection, selection.SpecificVersion);
	                            }
	                        }
	                        else { // no latest version found
	                            selection.IsResolvable = false;
	                            selection.VersionType = "specific";
	                            selection.ErrorLoadingLatest = "Could not find the latest version of package " + selection.PackageId + " in this feed.";
	                            setVersionSatisfaction(selection, selection.SpecificVersion);
	                        }
	                    },
	            function (err) {
	                if (!$scope.feedLoadingError) {
	                    $scope.feedLoadingError = err;
	                }
	            }
	          );
	                });
	            }));
	        });
	
	        function checkForRuleSatisfaction(selection, filters) {
	            if (selection.LastReleaseVersion) {
	                octopusRepository.Channels.ruleTest(selection.LastReleaseVersion, {
	                    versionRange: filters.versionRange,
	                    preReleaseTag: filters.preReleaseTag
	                }).then(function (result) {
	                    selection.isLastReleaseVersionValid = result.SatisfiesVersionRange && result.SatisfiesPreReleaseTag;
	                });
	            } else {
	                selection.isLastReleaseVersionValid = false;
	            }
	        }
	    }
	
	    function loadDeploymentProcess(processId) {
	        isLoading.promise(octopusRepository.DeploymentProcesses.get(processId).then(function (deploymentProcess) {
	            $scope.deploymentProcess = deploymentProcess;
	            loadTemplate();
	        }));
	    }
	
	    function loadTemplate() {
	        var deploymentProcess = $scope.deploymentProcess;
	        isLoading.promise(octopusRepository.DeploymentProcesses.getTemplate(deploymentProcess, $scope.release.ChannelId).then(function (template) {
	            $scope.template = template;
	            $scope.deploymentProcess = deploymentProcess;
	            if (!$scope.release.Id) {
	                if (template.NextVersionIncrement) {
	                    $scope.release.Version = template.NextVersionIncrement;
	                }
	            }
	
	            var existingSelections = {};
	            if ($scope.release.SelectedPackages) {
	                for (var k = 0; k < $scope.release.SelectedPackages.length; k++) {
	                    existingSelections[$scope.release.SelectedPackages[k].StepName] = $scope.release.SelectedPackages[k].Version;
	                }
	            }
	
	            var selectionByFeed = {};
	            $scope.packageSelections = [];
	            for (var i = 0; i < template.Packages.length; i++) {
	                var selection = {};
	                selection.StepName = template.Packages[i].StepName;
	                selection.PackageId = template.Packages[i].PackageId;
	                selection.FeedId = template.Packages[i].FeedId;
	                selection.FeedName = template.Packages[i].FeedName;
	                selection.LatestVersion = '';
	                selection.SpecificVersion = angular.isDefined(existingSelections[selection.StepName]) ? existingSelections[selection.StepName] : '';
	                selection.IsResolvable = template.Packages[i].IsResolvable;
	                selection.LastReleaseVersion = template.Packages[i].VersionSelectedLastRelease;
	                selection.VersionType = selection.SpecificVersion ? 'specific' : (selection.IsResolvable ? 'latest' : (selection.LastReleaseVersion ? 'last' : 'specific'));
	                selection.isLastReleaseVersionValid = false;
	
	                $scope.packageSelections.push(selection);
	
	                if (selection.IsResolvable) {
	                    if (!selectionByFeed[selection.FeedId]) {
	                        selectionByFeed[selection.FeedId] = [];
	                    }
	
	                    selectionByFeed[selection.FeedId].push(selection);
	                }
	            }
	
	            loadVersions(selectionByFeed);
	        }));
	    }
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectReleasePackageListController', function ($scope, $uibModalInstance, $q, busy, octopusRepository, currentPackage, channelFilters) {
	  var isLoading = $scope.isLoading = busy.create();
	  var feed;
	  $scope.packageResults = [];
	  $scope.package = currentPackage;
	  $scope.preRelease = true;
	  $scope.channelRules = true;
	  $scope.notes = false;
	
	  $scope.refresh = function () {
	    var displayPackages = [];
	    var displayPromise = getDisplayPackages();
	
	    isLoading.promise(displayPromise);
	
	    loadChannelMatchPackages();
	
	    function getDisplayPackages() {
	      return getPackages($scope.channelRules ? channelFilters : {}).then(function(result) {
	        displayPackages = result;
	        $scope.packageResults = displayPackages;
	      });
	    }
	
	    function loadChannelMatchPackages() {
	      if($scope.channelRules) {
	        return;
	      }
	      $q.all([getPackages(channelFilters), displayPromise])
	        .then(function(result) {
	          var channelFilteredPackages = result[0];
	          var matchIndex = channelFilteredPackages ? _.indexBy(channelFilteredPackages, 'Id') : {};
	          displayPackages.forEach(function(pack) {
	            pack.IsNonChannelRule = !$scope.channelRules && !matchIndex[pack.Id];
	          });
	        });
	    }
	  };
	
	  function getPackages(filter) {
	    var searchOptions = _.extend({
	      packageId: currentPackage.PackageId,
	      partialMatch: false,
	      includeMultipleVersions: true,
	      includePreRelease: $scope.preRelease,
	      includeNotes: $scope.notes,
	      take: 1000
	    }, filter || {});
	    return octopusRepository.Feeds.search(feed, searchOptions);
	  }
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.selectVersion = function (version) {
	    $uibModalInstance.close(version);
	  };
	
	  isLoading.promise(octopusRepository.Feeds.get(currentPackage.FeedId).then(function (f) {
	    feed = f;
	    $scope.refresh();
	  }));
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 526 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectReleasesController', function ($scope, busy, $stateParams, projectState, pageTitle, octopusRepository) {
	    var isLoading = $scope.isLoading = busy.create();
	    var projectId = $stateParams.projectId;
	    $scope.filter = {};
	    $scope.refresh = refresh;
	    $scope.channels = [];
	
	    isLoading.promise(projectState.load().then(function (project) {
	        pageTitle(project.Name + " releases");
	        $scope.project = project;
	
	        isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {
	
	            refresh();
	            $scope.deploymentProcess = deploymentProcess;
	        }, function () {
	            $scope.project = project;
	        }));
	
	        isLoading.promise(octopusRepository.Projects.getChannels(project).then(function (channels) {
	            $scope.channels = channels;
	        }));
	    }));
	
	    function refresh() {
	        loadReleases();
	    }
	
	    function loadReleases() {
	        var channelId = $scope.filter.channelId;
	
	        if (channelId) {
	            isLoading.promise(octopusRepository.Channels.get(channelId).then(function (channel) {
	                isLoading.promise(octopusRepository.Channels.getReleases(channel, {skip: $scope.skip}).then(function (releases) {
	                    $scope.releases = releases;
	                }));
	            }));
	        }
	        else {
	            isLoading.promise(octopusRepository.Projects.getReleases($scope.project, {skip: $scope.skip}).then(function (releases) {
	                $scope.releases = releases;
	            }));
	        }
	    }
	});


/***/ },
/* 527 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('StepListController', function ($scope, busy, $uibModalInstance, steps, action) {
	  $scope.steps = steps;
	  $scope.action = action;
	  $scope.selectedStep = null;
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function (selected) {
	    $uibModalInstance.close($scope.selectedStep);
	  };
	});
	


/***/ },
/* 528 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller("TargetSettingsDialogController", function($scope, $injector, pluginRegistry, projectId, $uibModalInstance, $q, busy, octopusRepository) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isPreviewing = $scope.isPreviewing = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	
	  var promises = [
	    octopusRepository.MachineRoles.all().then(function (machineRoles) { $scope.availableRoles = machineRoles; }),
	    octopusRepository.Projects.get(projectId).then(function (project) {
	      $scope.project = project;
	    })
	  ];
	
	  isLoading.promise($q.all(promises));
	
	  $scope.accept = function() {
	    isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function (p) {
	      $uibModalInstance.close(true);
	    }));
	  };
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	});


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectVariablesIncludeController', function ($scope, busy, octopusRepository, current, $uibModalInstance, contentType, contentTypeDesc) {
	  var isLoading = $scope.isLoading = busy.create();
	  $scope.contentTypeDesc = contentTypeDesc;
	
	  isLoading.promise(octopusRepository.LibraryVariableSets.all({contentType: contentType}).then(function(all){
	    $scope.libraryVariableSets = [];
	    _.each(all, function(lvs){
	      $scope.libraryVariableSets.push({
	        id: lvs.Id,
	        title: lvs.Name,
	        description: lvs.Description,
	        isIncluded: _.contains(current, lvs.Id)
	      });
	    });
	  }));
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    var thisType = _.filter($scope.libraryVariableSets, function(lvs) {
	      return lvs.isIncluded;
	    });
	
	    var thisTypeIds = _.pluck(thisType, 'id');
	
	    var otherIds = _.filter(current, function(c){
	      return !_.find($scope.libraryVariableSets, function(lvs) { return lvs.id === c; });
	    });
	
	    var ids = _.union(thisTypeIds, otherIds);
	
	    $uibModalInstance.close(ids);
	  };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('deploymentCreateEnvironmentSelector', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            edit: '=',
	            availableEnvironments: '=',
	            selectedEnvironments: '=',
	            project: '=',
	            newDeployments: '='
	        },
	        templateUrl: 'areas/projects/deployment-create/deployment-create-environment-selector.html',
	        controllerAs: 'vm',
	        bindToController: true,
	        controller: function ($scope, busy, pollLoop, octopusRepository) {
	            var vm = this;
	
	            vm.latest = {};
	            vm.getEnvironmentName = getEnvironmentName;
	
	            function getEnvironmentName(environmentId) {
	                return vm.availableEnvironments.filter(function(env) { return env.Id === environmentId; })[0].Name;
	            }
	
	            function getLatestEnvironmentReleases() {
	                return octopusRepository.Dashboards.getProjectDashboard(vm.project).then(function(dash){
	                    _.each(dash.Items, function (item) {
	                        vm.latest[item.EnvironmentId] =  item;
	                    });
	                });
	            }
	
	            function init(){
	                var loop = pollLoop.create($scope, function () { return getLatestEnvironmentReleases(); });
	                loop.startImmediately();
	            }
	
	            init();
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.projects');
	
	module.directive('deploymentCreateSchedule', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            scheduledAt: '=',
	            expiresAt: '='
	        },
	        templateUrl: 'areas/projects/deployment-create/deployment-create-schedule.html',
	        controller: function($scope) {
	            var vm = this;
	            vm.isScheduled =false;
	            vm.scheduledDate = new Date();
	            vm.scheduledTime= new Date();
	            vm.expiryDate = new Date();
	            vm.expiryTime = new Date();
	            vm.minDate = new Date();
	            vm.maxDate = moment().add(14, 'days');
	            vm.userTimezone = moment().format("[GMT] Z");
	            vm.updateScheduled = updateScheduled;
	            vm.updateExpiry = updateExpiry;
	            vm.moment = moment;
	
	            function init() {
	                $scope.$watch(function() { return vm.scheduledDate; }, function(){ updateScheduled(); });
	                $scope.$watch(function() { return vm.expiryDate; }, function(){ updateExpiry(); });
	
	                vm.scheduledTime = rollForward(moment(), 10);
	                vm.expiryTime = rollForward(moment(vm.scheduledTime), 30);
	            }
	
	            function rollForward(date, minutes)
	            {
	                var mins = 0;
	                var now = date.add(minutes, 'minutes');
	                var hour = now.hour();
	                if (now.minute() > 45) {
	                    mins = 0;
	                    hour++;
	                } else if (now.minute() > 30) {
	                    mins = 45;
	                } else if (now.minute() > 15) {
	                    mins = 30;
	                } else if (now.minute() > 0) {
	                    mins = 15;
	                }
	                return new Date(2000, 1, 1, hour, mins);
	            }
	
	            function updateScheduled() {
	                updateScheduleDates();
	                ensureExpiryDateIsInTheFuture();
	            }
	
	            function updateScheduleDates()
	            {
	                if(!vm.isScheduled || !vm.scheduledDate) {
	                    vm.scheduledAt = null;
	                    vm.expiresAt = null;
	                    return;
	                }
	
	                vm.scheduledAt = combineDateTime(vm.scheduledDate, vm.scheduledTime);
	                vm.expiresAt = combineDateTime(vm.expiryDate, vm.expiryTime);
	            }
	
	            function ensureExpiryDateIsInTheFuture()
	            {
	                if (!vm.expiresAt || !vm.scheduledAt)
	                {
	                    return;
	                }
	
	                if (vm.expiresAt > vm.scheduledAt)
	                {
	                    return;
	                }
	
	                vm.expiryDate = vm.scheduledDate;
	                vm.expiryTime = rollForward(moment(vm.scheduledTime), 30);
	                vm.expiresAt = combineDateTime(vm.expiryDate, vm.expiryTime);
	            }
	
	            function updateExpiry() {
	                updateScheduleDates();
	            }
	
	            function combineDateTime(date, time)
	            {
	                var combine = moment(date).utcOffset(moment().utcOffset());
	                if (time) {
	                    var t = moment(time);
	                    combine.hour(t.hour());
	                    combine.minute(t.minute());
	                }
	                return combine;
	            }
	
	            init();
	        },
	        bindToController: true,
	        controllerAs: 'vm'
	    };
	});


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('deploymentCreateTenantSelector', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            edit: '=',
	            allTenants: '=',
	            selectedEnvironments: '=',
	            selectedTenants: '=',
	            selectedTags: '=',
	            resultantTenants: '=',
	            resultantTenantCount: '=',
	            project: "=",
	            template: "=",
	            channel: "=",
	            newDeployments: '=',
	            loadMatches: '='
	        },
	        templateUrl: 'areas/projects/deployment-create/deployment-create-tenant-selector.html',
	        controllerAs: 'vm',
	        bindToController: true,
	        controller: function ($scope, $q, busy, pollLoop, octopusTagSets, octopusRepository) {
	            var vm = this;
	
	            vm.customTenantFilter = customTenantFilter;
	            vm.setSelectedEnvironment = setSelectedEnvironment;
	            vm.getMissingTenantVariables = getMissingTenantVariables;
	            vm.hasSelectedTenantsWithMissingVariables = hasSelectedTenantsWithMissingVariables;
	            vm.loadMatches = loadMatches;
	            vm.applySelection = applySelection;
	
	            vm.selectedEnvironment = null;
	            vm.tenantsById = {};
	            vm.warning = null;
	            vm.availableEnvironments = [];
	            vm.tagMatchedTenants = [];
	
	            var tenantPromotionsIndex = {};
	            var tenantMissingVariables = {};
	            var tenantsForProject = [];
	            var tenantsForProjectChannel = [];
	            var tenantsWhoCanDeploy = [];
	            var tagMatchedLoader;
	
	            function loadMatches() {
	                return tagMatchedLoader.then(function () {
	                    vm.showMatched = true;
	                    var resultantTenants = vm.tagMatchedTenants.map(function (tenant) {
	                        return tenant.Id;
	                    }).concat(vm.selectedTenants || []);
	
	                    vm.resultantTenants = resultantTenants;
	                    vm.resultantTenantCount = resultantTenants.length;
	                    return resultantTenants;
	                });
	            }
	
	            function applySelection() {
	                if ((vm.selectedTenants || []).length <= 0 && (vm.selectedTags|| []).length <= 0) {
	                    return;
	                }
	                
	                vm.edit = false;
	                loadTagMatched(false);
	            }
	
	            function loadTagMatched(force) {
	                vm.isTagMatchedTenantMissingVariable = false;
	                if (!force && (!vm.selectedTags || vm.selectedTags.length === 0)) {
	                    return tagMatchedLoader = $q.resolve([]);
	                }
	
	                return tagMatchedLoader = octopusRepository.Tenants.tagTest(vm.selectedTenants || [], vm.selectedTags)
	                    .then(filterTagMatches)
	                    .then(function (matched) {
	                        return vm.allTenants.filter(function (tenant) {
	                            return matched.indexOf(tenant.Id) !== -1 && !vm.customTenantFilter(tenant);
	                        });
	                    })
	                    .then(function (matched) {
	                        vm.tagMatchedTenants = matched.filter(function (tenant) {
	                            return vm.selectedTenants.indexOf(tenant.Id) === -1;
	                        });
	
	                        vm.isTagMatchedTenantMissingVariable = _.any(vm.tagMatchedTenants, function (tenant) {
	                            return tenantMissingVariables[tenant.Id];
	                        });
	                    });
	            }
	
	            function filterTagMatches(result) {
	                return Object.keys(result).filter(function (tenantId) {
	                    return result[tenantId].IsMatched;
	                });
	            }
	
	            function init() {
	                $scope.$watch(function () {
	                    return vm.selectedEnvironments[0];
	                }, function () {
	                    vm.selectedEnvironment = vm.selectedEnvironments.filter(isEnvironmentAvailable)[0];
	                    setSelectedEnvironmentName();
	                    setAvailableTenants();
	                });
	
	                tenantsForProject = vm.allTenants.filter(function (tenant) {
	                    return Object.keys(tenant.ProjectEnvironments).indexOf(vm.project.Id) !== -1;
	                });
	
	                tenantPromotionsIndex = vm.template.TenantPromotions.reduce(function(idx, tenantPromo) {
	                    idx[tenantPromo.Id] = _.indexBy(tenantPromo.PromoteTo, function(environmentPromo) { return environmentPromo.Id; });
	                    return idx;
	                }, {});
	
	                tenantsWhoCanDeploy = vm.template.TenantPromotions.filter(function (tenantPromotion) {
	                    return tenantPromotion.PromoteTo.length > 0;
	                });
	                vm.tenantsById = _.object(_.pluck(vm.allTenants, "Id"), vm.allTenants);
	
	                // When the environment changes, check if any tenants are available for environment
	                $scope.$watch(function () { return vm.selectedEnvironment; },
	                    function () {
	                        vm.anyTenantsInThisEnvironment = _.any(vm.allTenants, function (tenant) {
	                            return (tenant.ProjectEnvironments[vm.project.Id] || []).indexOf(vm.selectedEnvironment) !== -1;
	                        });
	                        loadTagMatched(false);
	                        loadMatches();
	                    });
	
	                $scope.$watch(function () { return vm.selectedTenants; },
	                    function () {
	                        loadTagMatched(true);
	                        loadMatches();
	                    });
	
	                $scope.$watch(function () { return vm.selectedTags; },
	                    function () {
	                        loadTagMatched(true);
	                        loadMatches();
	                    });
	
	                vm.availableEnvironments =  _.uniq(_.flatten(
	                    vm.template.TenantPromotions.map(
	                        function(tenantPromotion) { return tenantPromotion.PromoteTo; })),
	                    function(promoteTo) { return promoteTo.Id; });
	                
	                if (!vm.selectedTenants || vm.selectedTenants.length === 0) {
	                    if (vm.selectedTags && vm.selectedTags.length > 0) {
	                        octopusRepository.Tenants.tagTest([], vm.selectedTags)
	                            .then(filterTagMatches)
	                            .then(function (result) {
	                                tenantsForProjectChannel = result.filter(function (tenantId) {
	                                    return _.any(tenantsForProject, function (tenant) {
	                                        return tenant.Id === tenantId;
	                                    });
	                                });
	                                setWarningMessage();
	                                setAvailableTenants();
	                            });
	                    } else if (vm.channel.TenantTags.length > 0) {
	                        vm.selectedTags = JSON.parse(JSON.stringify(vm.channel.TenantTags));
	                        octopusRepository.Tenants.tagTest(vm.selectedTenants || [], vm.channel.TenantTags)
	                            .then(filterTagMatches)
	                            .then(function (result) {
	                                tenantsForProjectChannel = result.filter(function (tenantId) {
	                                    return _.any(tenantsForProject, function (tenant) {
	                                        return tenant.Id === tenantId;
	                                    });
	                                });
	                                setWarningMessage();
	                                setAvailableTenants();
	                            });
	                    } else {
	                        tenantsForProjectChannel = tenantsForProject.map(function (tenant) {
	                            return tenant.Id;
	                        });
	                        setWarningMessage();
	                    }
	                }
	
	                loadMissingTenantVariables();
	                loadTagMatched(false);
	
	                if ((!vm.selectedTenants || vm.selectedTenants.length === 0) &&
	                    (!vm.selectedTags || vm.selectedTags.length === 0)
	                ) {
	                    vm.edit = true;
	                }
	            }
	
	            function loadMissingTenantVariables() {
	                return octopusRepository.Tenants.missingVariables({projectId: vm.project.Id}, true).then(function (result) {
	                    tenantMissingVariables = result.reduce(function (tenantIndex, b) {
	                        tenantIndex[b.TenantId] = b.MissingVariables.reduce(function (tenantDetails, template) {
	                            if (template.EnvironmentId) {
	                                tenantDetails.envDetails[template.EnvironmentId] = (tenantDetails.envDetails[template.EnvironmentId] || []);
	                                tenantDetails.envDetails[template.EnvironmentId].push(template.VariableTemplateName);
	                            } else {
	                                tenantDetails.allDetails.push(template.VariableTemplateName);
	                            }
	                            return tenantDetails;
	                        }, {envDetails: {}, allDetails: []});
	                        return tenantIndex;
	                    }, {});
	                });
	            }
	
	            function isEnvironmentAvailable(envId) {
	                return _.any(vm.availableEnvironments, function (env) {
	                    return env.Id === envId;
	                });
	            }
	
	            function setSelectedEnvironment() {
	                vm.selectedEnvironments.length = 0;
	                vm.selectedEnvironments.push(vm.selectedEnvironment);
	
	                setSelectedEnvironmentName();
	                setAvailableTenants();
	            }
	
	            function setAvailableTenants() {
	                vm.availableTenants = vm.allTenants.filter(function (tenant) {
	                    var isAvailable = !customTenantFilter(tenant);
	                    if (!isAvailable) {
	                        var currentIndex = vm.selectedTenants.indexOf(tenant.Id);
	                        if (currentIndex !== -1) {
	                            vm.selectedTenants.splice(currentIndex, 1);
	                        }
	                    }
	                    return isAvailable;
	                });
	
	                vm.anyTenantsInThisEnvironment = vm.availableTenants.length > 0;
	            }
	
	            function setSelectedEnvironmentName() {
	                if (!vm.selectedEnvironment) {
	                    vm.selectedEnvironmentName = null;
	                    vm.edit = true;
	                } else {
	                    var selectedEnvironment = vm.availableEnvironments.filter(function (env) {
	                        return env.Id === vm.selectedEnvironment;
	                    })[0];
	                    vm.selectedEnvironmentName = selectedEnvironment.Name;
	                }
	            }
	
	            function setWarningMessage() {
	                vm.warning = null;
	
	                if (tenantsForProject.length === 0) {
	                    return vm.warning = {
	                        title: "There are no tenants connected to this project.",
	                        message: "Connect at least one tenant to this project to start performing tenanted deployments of this project. To do this, find the tenant, and connect it to this project targeting the desired environments."
	                    };
	                }
	
	                if (tenantsForProjectChannel.length === 0) {
	                    return vm.warning = {
	                        title: "There are no matching tenants for the " + vm.channel.Name + " channel.",
	                        message: "Releases in the " + vm.channel.Name + " channel can only be deployed to matching tenants. Either change the tenant filter on the channel, tag an existing tenant so they match the channel filter, or create a new tenant tagged to match the channel filter."
	                    };
	                }
	
	                if (tenantsWhoCanDeploy.length === 0) {
	                    if (vm.project.RequireTenantedDeployment) {
	                        return vm.warning = {
	                            title: "Cannot deploy to any of the connected tenants in this phase of the lifecycle.",
	                            message: "Releases of this project can only be deployed to tenants, but there are no tenants connected to any environments in the current lifecycle phase. " +
	                            (vm.availableEnvironments.length > 0 ? "Available environments are: " + vm.availableEnvironments : '') +
	                            "Either connect an existing tenant to one of the environments in this lifecycle phase, or create a new tenant and connect them to one of the environments in this lifecycle phase, or modify the lifecycle, or configure the project to allow un-tenanted deployments."
	                        };
	                    } else {
	                        return vm.warning = {
	                            title: "Cannot deploy to any of the connected tenants in this phase of the lifecycle.",
	                            message: "Either perform an un-tenanted deployment of this release to an environment in this lifecycle phase, or connect an existing tenant to one of the environments in this lifecycle phase, or create a new tenant and connect them to one of the environments in this lifecycle phase, or modify the lifecycle."
	                        };
	                    }
	                }
	            }
	
	            function customTenantFilter(tenant) {
	                var environments = tenant.ProjectEnvironments[vm.project.Id];
	                if (!environments) {
	                    return "Tenant is not connected to this project.";
	                }
	
	                if (tenantsForProjectChannel.length !== 0 && tenantsForProjectChannel.indexOf(tenant.Id) === -1) {
	                    return "Tenant is not connected to this channel.";
	                }
	
	                if (environments.indexOf(vm.selectedEnvironment) === -1) {
	                    return "Tenant is not connected to this environment.";
	                }
	
	                if (!tenantPromotionsIndex[tenant.Id]) {
	                   return "Tenant is not available for deployment. This may be because you do not have permission to deploy for this tenant.";
	                }
	
	                if (!tenantPromotionsIndex[tenant.Id][vm.selectedEnvironment]) {
	                    return "Tenant has not reached this lifecycle phase.";
	                }
	
	                return null;
	            }
	
	            function getMissingTenantVariables(tenantId) {
	                if (!tenantMissingVariables[tenantId]) {
	                    return [];
	                }
	
	                var projectVariables = tenantMissingVariables[tenantId].envDetails[vm.selectedEnvironment] || [];
	                var libraryVariables = tenantMissingVariables[tenantId].allDetails;
	
	                return [].concat(libraryVariables).concat(projectVariables);
	            }
	
	            function hasSelectedTenantsWithMissingVariables() {
	                return _.any(vm.selectedTenants, function (tenantId) {
	                    return getMissingTenantVariables(tenantId).length > 0;
	                });
	            }
	
	            octopusTagSets.getAll().then(function (tagSets) {
	                vm.tagSets = tagSets;
	                init();
	            });
	
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var module = angular.module('octopusApp.projects');
	
	module.directive('actionEditor', function($templateCache, $compile, $injector, octopusLog, pluginRegistry) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      action: '=',
	      step: '=',
	      project: '=',
	      feeds: '=',
	      viewOptions: '=',
	      localNames: '='
	    },
	    templateUrl: 'areas/projects/views/action_editor.html',
	    link: function(scope, element) {
	      var reload = function() {
	        
	        var action = scope.action;
	        var step = scope.step;
	        if (!action || !step) {
	          return;
	        }
	
	        var plugin = pluginRegistry.getDeploymentAction(action.ActionType);
	        if (!plugin) {
	          octopusLog.error("Unknown action type: ", action.ActionType);
	          return;
	        }
	
	        var viewTemplateUrl = plugin.editTemplateUrl;
	        var template = $templateCache.get(viewTemplateUrl);
	        if (!template) {
	          octopusLog.info("Could not find view template in the template cache: ", viewTemplateUrl);
	          return;
	        }
	
	        if (plugin.preLink) {
	          plugin.preLink(scope);
	        }
	
	        var child = $compile(template)(scope);
	
	        // If it is a new action
	        if (!action.Id) {
	          
	          // Enable any permanent or initial features
	          if (plugin.features) {
	            
	            var enabledFeatures = [];
	            
	            if (plugin.features.permanent) {
	              _.each(plugin.features.permanent, function(feature){
	                var featurePlugin = pluginRegistry.getFeature(feature);
	                featurePlugin.enable(action);
	                enabledFeatures.push(feature);
	              });
	            }
	            
	            if (plugin.features.initial) {
	             _.each(plugin.features.initial, function(feature){
	                var featurePlugin = pluginRegistry.getFeature(feature);
	                featurePlugin.enable(action);
	                enabledFeatures.push(feature);
	             });
	            }
	            
	            action.Properties["Octopus.Action.EnabledFeatures"] = enabledFeatures.join(","); 
	          }
	        }
	        
	        if (plugin.editLink) {
	          plugin.editLink(scope, child, action);
	        }
	
	        var actionBody = $('.action-details', element);
	        actionBody.html('');
	        actionBody.html(child);
	      };
	
	      scope.$watch("action", function() {
	        reload();
	      });
	
	    }
	  };
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.projects');
	
	module.directive('actionSummary', function($templateCache, $compile, $injector, octopusLog, pluginRegistry, octopusClient) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      action: '=',
	      step: '=',
	      number: '=',
	      editLink: '='
	    },
	    templateUrl: 'areas/projects/views/action_summary.html',
	    link: function(scope, element) {
	      var action = scope.action;
	      var step = scope.step;
	      if (!action || !step) {
	        return;
	      }
	
	      scope.isSingleStep = step.Actions.length === 1;
	      scope.properties = $.extend({}, action.Properties, step.Properties);
	
	      octopusLog.info("Finding registered deployment action for action type: " + action.ActionType);
	
	      var plugin = pluginRegistry.getDeploymentAction(action.ActionType);
	      if (!plugin) {
	        octopusLog.error("Unknown action type: ", action.ActionType);
	        return;
	      }
	
	      var actionId = action.Properties['Octopus.Action.Template.Id'];
	      var typeOrId =  actionId ? actionId : action.ActionType;
	      scope.logoUrl = octopusClient.resolveLinkTemplate("ActionTemplateLogo", {typeOrId : typeOrId});
	      var viewTemplateUrl = plugin.summaryTemplateUrl;
	      octopusLog.info("Resolving view template: ", viewTemplateUrl);
	
	      var template = $templateCache.get(viewTemplateUrl);
	      if (!template) {
	        octopusLog.info("Could not find view template in the template cache: ", viewTemplateUrl);
	        return;
	      }
	
	      var child = $compile(template)(scope);
	      if (plugin.summaryLink) {
	        plugin.summaryLink(scope, child);
	      }
	
	      var actionBody = $('.action-details', element);
	      actionBody.html('');
	      actionBody.html(child);
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('actionTemplateEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/projects/views/action_template_editor.html',
	    scope: {
	      actionTemplate: '=',
	      action: '=',
	      process: '=',
	      project: '='
	    },
	    controller: function($scope, sensitiveValue, actionUpdater){
	
	      $scope.createResetValues = function() {
	        $scope.resetValues = {};
	        if ($scope.action == null) {
	            return;
	        }
	
	        _.each($scope.actionTemplate.Parameters, function(parameter){
	
	          if (parameter.DisplaySettings['Octopus.ControlType'] === 'Sensitive') {
	            $scope.resetValues[parameter.Name] = sensitiveValue.getResetValue($scope.action.Properties[parameter.Name]);
	            return;
	          }
	
	          if (parameter.Name in $scope.action.Properties) {
	            $scope.resetValues[parameter.Name] = $scope.action.Properties[parameter.Name];
	            return;
	          }
	        });
	      };
	
	      if ($scope.process) {
	        $scope.allSteps = _.flatten($scope.process.Steps.map(function(a) { return a.Actions.map(function(action) { return action.Name; }); }));
	      }
	      
	      $scope.mergeLatest = function() {
	
	        actionUpdater.update($scope.action, $scope.actionTemplate);
	        $scope.actionUpdated = true;
	        $scope.$emit("actionTemplateEditor:dirty");
	        $scope.createResetValues();
	      };
	
	      $scope.createResetValues();
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 536 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('actionTemplateField', function($compile, $templateCache, octoUtil) {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        require: 'ngModel',
	        scope: {
	            parameter: '=',
	            placeholder: '=',
	            selectOptions: '='
	        },
	        controllerAs: 'vm',
	        bindToController: true,
	        controller: function(){},
	        link: function($scope, $element, attr, ngModel) {
	            var vm = $scope.vm;
	
	            ngModel.$render = function onRender() { // Update internal selected if outer model changes
	                $scope.vm.value = ngModel.$viewValue;
	            };
	            $scope.$watch(function(){return $scope.vm.value;}, function(){
	                ngModel.$setViewValue($scope.vm.value);
	            });
	
	            $scope.$watch(function(){ return vm.parameter;}, function() {
	                if (!vm.parameter) {
	                    return;
	                }
	                var template = getFieldTemplate(vm.parameter);
	                $element.html('');
	                $element.html($compile(template)($scope));
	            });
	
	            var selectOptions = null;
	
	            vm.getSelectOptions = function getSelectOptions(){
	                if(selectOptions) {
	                    return selectOptions;
	                }
	
	                if(vm.parameter && vm.parameter.DisplaySettings['Octopus.SelectOptions']) {
	                    selectOptions = octoUtil.selectOptionsTextToList(vm.parameter.DisplaySettings['Octopus.SelectOptions']);
	                    return selectOptions;
	                }
	
	                if(!vm.selectOptions || !vm.parameter) {
	                    return null;
	                }
	
	                selectOptions = vm.selectOptions[vm.parameter.DisplaySettings["Octopus.ControlType"]];
	                return selectOptions;
	            };
	        }
	    };
	
	    function getFieldTemplate(parameter) {
	        if (parameter.DisplaySettings && parameter.DisplaySettings["Octopus.ControlType"]) {
	            var templateName = parameter.DisplaySettings["Octopus.ControlType"];
	            return $templateCache.get('areas/projects/action-template-fields/field-' + templateName + '.html');
	        }
	        return $templateCache.get('areas/projects/action-template-fields/field-SingleLineText.html');
	    }
	});


/***/ },
/* 537 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('applicationPoolEditor', function(octopusRepository, sensitiveValue) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      action: '=',
	      project: '=',
	      localNames: '=',
	      pathToRootProperty: '@'
	    },
	    templateUrl: 'areas/projects/views/application_pool_editor.html',
	    link: function(scope, element) {
	        scope.fullPath = function(propertyName){
	            return scope.pathToRootProperty + "." + propertyName;
	        };
	
	        scope.identity = {
	            identityTypeBound: {},
	            applicationPoolPasswordResetValue: sensitiveValue.getResetValue(scope.action.Properties[scope.fullPath("ApplicationPoolPassword")])
	        };
	     }
	 };
	});


/***/ },
/* 538 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('azurePowershellScriptInfo', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl:'areas/projects/views/azure_powershell_script_info.html'
	    };
	});


/***/ },
/* 539 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('channelLabel', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      project: '=project',
	      channels: '=channels',
	      channelId: '=channelId'
	    },
	    template: '<span class="label label-primary">{{name}}</span>',
	    controller: function($scope, octopusRepository) {
	      $scope.name = null;
	      if($scope.channels){
	        setChannelName($scope.channels);
	      } else {
	        octopusRepository.Projects.getChannels($scope.project).then(setChannelName);
	      }
	
	      function setChannelName(channels){
	        if(channels.Id){
	          $scope.Name = channels.Name;
	        } else if (channels.Items !== undefined && channels.Items.length > 1) {
	          $scope.name = channels.Items.filter(function (channel) {
	            return channel.Id === $scope.channelId;
	          })[0].Name;
	        }
	      }
	    }
	  };
	});


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('deployButtons', function(busy, octopusRepository, octopusPermissionSet, $q) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    templateUrl: 'areas/projects/views/deploy_buttons.html',
	    scope: {
	      project: '=',
	      release: '=',
	      lifecycle: '=',
	      environments: '=',
	      progression: '='
	    },
	    link: function(scope, element, attrs) {
	      scope.filterEnvironments = function () {
	        var allowedEnvironments = {};
	
	        var checks = _.map(scope.environments, function(environment){
	          return octopusPermissionSet.isAuthorized({
	            permission: "DeploymentCreate",
	            projectId: scope.project && scope.project.Id,
	            environmentId: environment.Id
	          }).then(function(allowed){
	            if(allowed){
	              allowedEnvironments[environment.Id] = environment;
	            }
	          });
	        });
	
	        $q.all(checks).then(function(){
	          scope.environmentsById = allowedEnvironments;
	        });
	      };
	
	      scope.environmentsById = {};
	      scope.$watch("environments", scope.filterEnvironments);
	      scope.$watch("project", scope.filterEnvironments);
	
	      scope.customClasses = attrs.class;
	      scope.deployOrPromote = "Deploy";
	
	      scope.$watch("progression", function() {
	        scope.deployed = {};
	        scope.tasks = {};
	        scope.warning = {};
	        scope.progress = {};
	
	        if (!scope.progression) {
	          return;
	        }
	
	        var deploymentCount = 0;
	
	        scope.nextDeployments= _.filter(scope.progression.NextDeployments, function(en){ return scope.environmentsById[en]; } );
	        scope.nextDeploymentsCombined = scope.nextDeployments.join(',');
	
	        _.each(scope.progression.Phases, function (phase) {
	          scope.progress[phase.Name] = phase.Progress;
	          _.each(phase.Deployments, function (deployment) {
	            deploymentCount++;
	            scope.deployed[deployment.Deployment.EnvironmentId] = true;
	            scope.tasks[deployment.Deployment.EnvironmentId] = deployment.Task.Id;
	            scope.warning[deployment.Deployment.EnvironmentId] = deployment.Task.HasWarningsOrErrors;
	          });
	        });
	
	        scope.deployOrPromote = (deploymentCount > 0) ? "Promote" : "Deploy";
	      });
	
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var module = angular.module('octopusApp.projects');
	
	module.directive('featureEditor', function ($templateCache, $compile, $injector, octopusLog, pluginRegistry) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      action: '=',
	      step: '=',
	      project: '=',
	      enabledFeatures: '=',
	      localNames: '='
	    },
	    templateUrl: 'areas/projects/views/feature_editor.html',
	    link: function (scope, element) {
	      scope.$watch('enabledFeatures', function() {
	        var action = scope.action;
	        var step = scope.step;
	        if (!action || !step) {
	          return;
	        }
	
	        var actionBody = $('.feature-list', element);
	        actionBody.html('');
	
	        if (!scope.enabledFeatures) {
	          return;
	        }
	        var featureNames = scope.enabledFeatures.split(',');
	
	        var allFeatures = pluginRegistry.getAllFeatures();
	
	        _.each(allFeatures, function (feature) {
	          var isEnabled = _.contains(featureNames, feature.featureName);
	          if (!isEnabled) {
	            return;
	          }
	
	          var viewTemplateUrl = feature.editTemplateUrl;
	
	          var template = $templateCache.get(viewTemplateUrl);
	          if (!template) {
	            octopusLog.info("Could not find view template in the template cache: ", viewTemplateUrl);
	            return;
	          }
	
	          if (feature.preLink) {
	            feature.preLink(scope);
	          }
	
	          var child = $compile(template)(scope);
	          if (feature.editLink) {
	            feature.editLink(scope, child, action, step, scope.project);
	          }
	
	          actionBody.append(child);
	        });
	
	      });
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('lifecycleMap', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    templateUrl: 'areas/projects/views/lifecycle_map.html',
	    scope: {
	      lifecycle: '=',
	      environments: '=',
	      progression: '='
	    },
	    link: function(scope, element) {
	      scope.$watch("environments", function() {
	        scope.environmentsById = _.object(_.pluck(scope.environments, "Id"), scope.environments);
	      });
	
	      var empty = [];
	
	      scope.getPhaseCollection = function () {
	        if (scope.progression) {
	          return scope.progression.Phases;
	        } else if (scope.lifecycle) {
	          return scope.lifecycle.Phases;
	        }
	        return empty;
	      };
	
	      scope.getSingleDeploymentTarget = function(phase) {
	        if (phase.AutomaticDeploymentTargets.length > 0) {
	          return phase.AutomaticDeploymentTargets[0];
	        } else {
	          return phase.OptionalDeploymentTargets[0];
	        }
	      };
	
	      scope.$watch("progression", function() {
	        scope.deployed = {};
	        scope.tasks = {};
	        scope.warning = {};
	        scope.executing = {};
	        scope.queued = {};
	        scope.progress = {};
	
	        if (!scope.progression) {
	          return;
	        }
	
	        _.each(scope.progression.Phases, function (phase) {
	          var phaseStatus = phase.Progress;
	          if (phase.Blocked) {
	            phaseStatus = "Blocked";
	          }
	          scope.progress[phase.Name] = phaseStatus;
	
	          _.each(phase.Deployments, function (deployment) {
	            scope.deployed[deployment.Deployment.EnvironmentId] = true;
	            scope.tasks[deployment.Deployment.EnvironmentId] = deployment.Task.Id;
	            scope.warning[deployment.Deployment.EnvironmentId] = deployment.Task.HasWarningsOrErrors;
	            scope.executing[deployment.Deployment.EnvironmentId] = deployment.Task.State !== "Success";
	            scope.queued[deployment.Deployment.EnvironmentId] = deployment.Task.State === "Queued";
	          });
	        });
	      });
	
	      scope.envCount = function(phase) {
	        return _.union(phase.OptionalDeploymentTargets, phase.AutomaticDeploymentTargets).length;
	      };
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 543 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	
	module.directive('octoDisableLink', function() {
	  return function(scope, element, attr) {
	    var isLoaded = false;
	
	    element.click(function (e) {
	      if (!isLoaded) {
	        e.preventDefault();
	        return false;
	      }
	    });
	    scope.$watch(attr.octoDisableLink, function octoDisableLinkWatch(value) {
	      isLoaded = value;
	    });
	  };
	});
	


/***/ },
/* 544 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('packageDownloadOptions', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            action: '=',
	            localNames: '='
	        },
	        templateUrl: 'areas/projects/views/package_download_options.html',
	        link: function(scope, element) {
	            
	            if (!scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"]) {
	                scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"] = "False";
	            }
	        }
	    };
	});


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('packageList', function($timeout, octopusRepository) {
	    return {
	        restrict: 'E',
	        transclude: false,
	        templateUrl: 'areas/projects/views/package_list.html',
	        scope: {
	            packages: '='
	        },
	        link: function(scope, element) {
	
	            function loadPackagesForFeed(packages, feedId) {
	
	                function LoadPackages(feed) {
	                    return packages.map(function (pkg) {
	                        return octopusRepository.Feeds.getNotes(feed, pkg.PackageId, pkg.Version).then(function (notes) {
	                            pkg.ErrorNotes = null;
	                            pkg.Notes = notes;
	                            pkg.State = "ok";
	                        }, function (err) {
	                            pkg.ErrorNotes = err.ErrorMessage;
	                            pkg.Notes = null;
	                            pkg.State = "error";
	                        });
	                    });
	                }
	                octopusRepository.Feeds.get(feedId).then(LoadPackages);
	            }
	
	            function init() {
	                if (!scope.packages) {
	                    return;
	                }
	
	                _.each(_.groupBy(scope.packages, function(pkg) { return pkg.FeedId; }), loadPackagesForFeed);
	            }
	
	            $timeout(init, 200);
	        }
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.directive('packageSelector', function(octopusRepository) {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            action: '=',
	            project: '=',
	            feeds: '=',
	            localNames: '=',
	            feedType: '=',
	            onChange: '&'
	        },
	        templateUrl: 'areas/projects/views/package_selector.html',
	        link: function(scope, element) {
	
	            if (!scope.feedType){
	                scope.feedType = 'NuGet';
	            }
	        
	            scope.reset = {
	                feed: ""
	            };
	
	            if (scope.feeds.length > 0) {
	                scope.reset.feed = "feeds-builtin";
	            }
	
	            scope.feedChanged = feedChanged;
	
	            function feedChanged() {
	                if (scope.onChange) {
	                    scope.onChange();
	                }
	            }
	
	            scope.looksLikeVersion = false;
	            scope.checkIfLooksLikeVersion = function() {
	            scope.looksLikeVersion = false;
	            var packageId = scope.action.Properties["Octopus.Action.Package.PackageId"];
	            if (packageId) {
	                if (packageId.match(/\.[0-9]+\.?$/)) {
	                    scope.looksLikeVersion = true;
	                }
	            }
	            feedChanged();
	        };
	
	            scope.getPackages = function(searchText) {
	                var selectedFeedId = scope.action.Properties["Octopus.Action.Package.FeedId"];
	                var selectedFeed = scope.feedsById[selectedFeedId];
	                var searchOptions = {
	                    packageId: searchText,
	                    partialMatch: true,
	                    includeMultipleVersions: false,
	                    includePreRelease: true,
	                    includeNotes: false
	                };
	                return octopusRepository.Feeds.search(selectedFeed, searchOptions);
	            };
	
	            scope.feedsById = {};
	            _.each(scope.feeds, function (f) { scope.feedsById[f.Id] = f; });
	
	            if (!scope.action.Properties["Octopus.Action.Package.FeedId"] && scope.feeds.length > 0) {
	                scope.action.Properties["Octopus.Action.Package.FeedId"] = "feeds-builtin";
	            }
	        }
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var module = angular.module('octopusApp.projects');
	
	module.directive('progressionMatrix', function(octoUtil, taskStatusRenderer, octopusPermissionSet, octopusRepository, $q) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      progression: '=',
	      project: '='
	    },
	    link: function(scope, element) {
	      var previousHeadings = "";
	      var channels;
	
	      function fullRenderRequired(slice) {
	        var headings = angular.toJson({ a: slice.environments, b: slice.releases });
	        var required = headings !== previousHeadings;
	        previousHeadings = headings;
	        return required;
	      }
	
	      function nodeKey(envId, releaseId) { return [envId, "__", releaseId].join(''); }
	
	      function sliceProgression(data) {
	        var slice = {
	          releases: [],
	          environments: data.Environments,
	          channelEnvironments: data.ChannelEnvironments,
	          environmentsById: _.object(_.pluck(data.Environments, 'Id'), data.Environments),
	          items: {},
	          progressions: {}
	        };
	
	        var permissions = [];
	        _.each(data.Releases, function (row) {
	          row.Release.isBlocked = row.HasUnresolvedDefect;
	          slice.releases.push(row.Release);
	
	          _.each(row.Deployments, function(deployments, iter) {
	            _.each(deployments, function(deployment) {
	              var key = nodeKey(iter, deployment.ReleaseId);
	              if (!slice.items[key]) {
	                slice.items[key] = deployment;
	              }
	            });
	          });
	
	          _.each(row.NextDeployments, function(next) {
	            var key = nodeKey(next, row.Release.Id);
	            permissions.push(
	                octopusPermissionSet.isAuthorized(
	                    {permission: "DeploymentCreate", projectId: scope.project.Id, environmentId: next}
	                ).then(function (allowed) {
	                  if (allowed) {
	                    slice.progressions[key] = {release: row.Release.Version, envId: next};
	                  }
	                })
	            );
	          });
	        });
	
	        return $q.all(permissions).then(function() {
	          return slice;
	        });
	      }
	
	      function sliceByChannel(data) {
	        var slices = {};
	        _.each(channels, function (channel) {
	          slices[channel.Id] = {
	            channelId: channel.Id,
	            releases: [],
	            environments: data.channelEnvironments[channel.Id] || data.environments,
	            items: {},
	            progressions: data.progressions
	          };
	          var environments = slices[channel.Id].environments;
	          slices[channel.Id].environmentsById = _.object(_.pluck(environments, 'Id'), environments);
	        });
	
	        _.each(data.releases, function (release) {
	          slices[release.ChannelId].releases.push(release);
	        });
	
	        return slices;
	      }
	
	      function getItemsForChannel(releases, items, channelId) {
	        var itemDictionary = {};
	
	        _.each(releases, function(release) {
	          if (release.ChannelId === channelId) {
	            var releaseId = release.Id;
	            _.each(items, function (item) {
	              if (item.ReleaseId === releaseId) {
	                var itemKey = nodeKey(item.EnvironmentId, item.ReleaseId);
	                if (!itemDictionary[itemKey]) {
	                    itemDictionary[itemKey] = [];
	                }
	                itemDictionary[itemKey].push(item);
	              }
	            });
	          }
	        });
	
	        return itemDictionary;
	      }
	
	      function sortChannelsByDefaultThenByName() {
	        return channels.sort(function(channelA, channelB) {
	          return (
	            // Sort by default channel first
	            channelA.IsDefault === channelB.IsDefault ? 0 
	            : channelA.IsDefault ? -1 
	            : 1) || (
	            // Then sort by name alphabetically
	            channelA.Name === channelB.Name ? 0 
	            : channelA.Name < channelB.Name ? -1 
	            : 1);
	        });
	      }
	
	      var matrices = [];
	
	      function renderDashboard(slice, heading) {
	        var matrixElement = $("<div></div>");
	        element.append(matrixElement);
	        var matrix = new Octopus.ReleaseMatrix(matrixElement, taskStatusRenderer, octoUtil);
	
	        matrix.environments = slice.environments;
	        matrix.environmentsById = slice.environmentsById;
	        matrix.rows = slice.releases;
	        matrix.heading = heading;
	        matrix.items = slice.items;
	        matrix.progressions = slice.progressions;
	        if (channels.length > 1) {
	          matrix.slice = slice;
	        }
	        matrix.keyFromPair = function (env, release) { return nodeKey(env.Id, release.Id); };
	        matrix.renderEmptyRow = function (html) {
	          html.push('<tr>');
	          html.push('<td class="no-bottom-border" colspan="' + (matrix.environments.length + 1) + '">');
	          html.push('<p class="empty-row-state">There are no releases for this channel yet. ');
	          html.push('<a href="#/projects/' + scope.project.Slug + '/releases/create');
	          if (slice.channelId) {
	            html.push('?channelId=' + slice.channelId);
	          }
	          html.push('">Create a release</a>.');
	          html.push('</p>');
	          html.push('</td>');
	          html.push('</tr>');
	        };
	        matrix.renderRowHeading = function (release, html) {
	          if (release.isBlocked) {
	            html.push('<div class="unresolved-defect" title="This release has been blocked from future deployments. View the release details for more information."><i class="fa fa-exclamation-triangle"></i></div>');
	          }
	          html.push('<a class="project-name" href="#/projects/');
	          html.push(scope.project.Slug);
	          html.push('/releases/');
	          html.push(release.Version);
	          html.push('">');
	          html.push(octoUtil.escapeHtml(release.Version));
	          html.push('</a>');
	        };
	        matrix.renderEmptyCell = function(key, html) {
	          var progression = matrix.progressions[key];
	          if (progression) {
	            html.push('<div class="deploy-buttons">');
	            html.push('<a class="btn" href="#/projects/');
	            html.push(scope.project.Slug);
	            html.push('/releases/');
	            html.push(progression.release);
	            html.push('/deployments/create/to/');
	            html.push(progression.envId);
	            html.push('">Deploy</a>');
	            html.push('</div>');
	          }
	        };
	
	        matrix.render();
	        matrices.push(matrix);
	      }
	
	      function fullRender(data) {
	        sliceProgression(data).then(function(slice) {
	          if (channels.length < 2) {
	            renderDashboard(slice, "Release");
	          } else {
	            var channelSlices = sliceByChannel(slice);
	            var items = slice.items;
	
	            var sortedChannels = sortChannelsByDefaultThenByName();
	
	            _.each(sortedChannels, function (channel) {
	              var channelSlice = channelSlices[channel.Id];
	
	              channelSlice.items = getItemsForChannel(channelSlice.releases, items, channel.Id);
	              renderDashboard(channelSlice, "Channel: " + channel.Name);
	            });
	          }
	        });
	      }
	
	      function partialRender(data) {
	        sliceProgression(data).then(function(slice) {
	          _.each(matrices, function (matrix) {
	            if (matrix.slice) {
	              matrix.environments = slice.channelEnvironments[matrix.slice.channelId] || slice.environments;
	              matrix.items = getItemsForChannel(slice.releases, slice.items, matrix.slice.channelId);
	              matrix.rows = _.filter(slice.releases, function (release) { return release.ChannelId === matrix.slice.channelId; });
	              matrix.progressions = slice.progressions;
	            } else {
	              matrix.environments = slice.environments;
	              matrix.items = slice.items;
	              matrix.rows = slice.releases;
	              matrix.progressions = slice.progressions;
	            }
	            matrix.render();
	          });
	        });
	      }
	
	      scope.$watch('progression', updateDisplay, true);
	      scope.$watch('project', updateDisplay, true);
	
	      function updateDisplay() {
	        if (!scope.project || !scope.progression) {
	          return;
	        }
	
	        if(channels) {
	          if (fullRenderRequired(scope.progression)) {
	            fullRender(scope.progression);
	          } else {
	            partialRender(scope.progression);
	          }
	        } else {
	          octopusRepository.Projects.getChannels(scope.project).then(function (c) {
	            channels = c.Items;
	            updateDisplay();
	          });
	        }
	      }
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 548 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('projectEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    templateUrl: 'areas/projects/views/editor.html',
	    link: function(scope, element) {
	    }
	  };
	});


/***/ },
/* 549 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('projectGroupEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/projects/views/group_editor.html'
	  };
	});
	
	


/***/ },
/* 550 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('projectLogo', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            project: '=',
	            maxSize: "@"
	        },
	        template: '<img class="project-logo" ng-src="{{ project.Links.Logo | resolveLink }}?cb={{random}}" style="max-width: {{maxSize}}; max-height: {{maxSize}}" ng-show="project.Links.Logo"/>',
	        link: function ($scope, element, attr) {
	            $scope.random = Math.round(new Date().getTime() / 1000);
	        }
	    };
	});
	


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.projects');
	
	module.directive('projectPulse', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      pulse: '=pulse'
	    },
	    templateUrl: 'areas/projects/views/pulse.html',
	    controller: function($scope) {
	      // Could be better off as a filter
	      $scope.pulseFreshnessClass = function() {
	        var none = 'none';
	        var freshnessClasses = [[1, 'super'], [7, 'fresh'], [30, 'stale'], [120, 'old'], [null, 'ancient']];
	        var freshness = none;
	
	        if ($scope.anyPulse()) {
	          var deployed = moment($scope.pulse.Deployed);
	          var days = moment().diff(deployed, 'days');
	          for (var i = 0; i < freshnessClasses.length; ++i) {
	            var f = freshnessClasses[i];
	            var bracket = f[0];
	            if (!bracket || (days < bracket)) {
	              freshness = f[1];
	              break;
	            }
	          }
	        }
	
	        return 'pulse-freshness-' + freshness;
	      };
	
	      $scope.anyPulse = function() {
	        return $scope.pulse && $scope.pulse.MostSignificantDeploymentId;
	      };
	    }
	  };
	});
	


/***/ },
/* 552 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('releaseDefects', function(busy, octopusRepository, octoDialog) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    templateUrl: 'areas/projects/views/release_defects.html',
	    scope: {
	      release: '=',
	      progression: '='
	    },
	    link: function(scope, element) {
	
	      var isLoading = scope.isDefectLoading = busy.create();
	      var isSaving = scope.isDefectSaving = busy.create();
	
	      var defects = scope.defects = {
	        releaseHasDefect: false,
	        showReportArea: false,
	        defectDescription: null,
	        newDefectDescription: null,
	        toggleReportArea: function(){
	          this.showReportArea = !this.showReportArea;
	        },
	        reportDefect: function() {
	          var me = this;
	          isSaving.promise(octopusRepository.Defects.report(scope.release, me.newDefectDescription).then(function () {
	            me.releaseHasDefect = true;
	            me.defectDescription = me.newDefectDescription;
	
	            me.showReportArea = false;
	            me.newDefectDescription = null;
	            scope.$emit('progress-updates', null);
	          }));
	        },
	        resolveDefect: function() {
	          var me = this;
	          octoDialog.asyncConfirm({
	            title: "Unblock deployment",
	            message: "If it is now safe to proceed with deployments of this release, you can unblock it.",
	            executeButtonClass: "btn-success",
	            executeButtonText: "Unblock",
	            windowClass: "modal-alert modal-info fade",
	
	            execute: function (dialog) {
	              isSaving.promise(octopusRepository.Defects.resolve(scope.release).then(function () {
	                me.releaseHasDefect = false;
	                scope.$emit('progress-updates', null);
	                dialog.dismiss();
	              }));
	            }
	          });
	        }
	      };
	
	      scope.$watch("release", function() {
	        if (!scope.release) {
	          return;
	        }
	
	        isLoading.promise(octopusRepository.Defects.all(scope.release).then(function (defectList) {
	
	          var defect = null;
	          var hasItems = defectList.Items.length > 0;
	          if (hasItems) {
	            var lastIndex = defectList.Items.length - 1;
	            var potentialDefect = defectList.Items[lastIndex];
	            if (potentialDefect.Status === 'Unresolved') {
	              defect = potentialDefect;
	            }
	          }
	
	          defects.releaseHasDefect = (defect !== null);
	
	          if(defect) {
	            defects.defectDescription = defect.Description;
	          }
	        }));
	
	      });
	      //
	
	    }
	  };
	});


/***/ },
/* 553 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('releaseEditor', function($templateCache, $compile, $injector, octopusLog, pluginRegistry) {
	  return {
	    restrict: 'E',
	    transclude: false,
	    templateUrl: 'areas/projects/views/release_editor.html'
	  };
	});


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var module = angular.module('octopusApp.projects');
	
	var defineSlickGrid = function(variableSettings, viewScope, octoDropdownMenu, rootScope, canEdit, showSourceColumn, octopusRepository, octoDialog, $q, disableContextMenu) {
	  function requiredFieldValidator(value) {
	    if (value == null || typeof value === 'undefined' || !value.length) {
	      return {valid: false, msg: "This is a required field"};
	    } else {
	      return {valid: true, msg: null};
	    }
	  }
	
	  var grid;
	  var data = [];
	  var dataView;
	  var columns = [
	    {id: "state", name: "<i class='variable-filter-icon'></i>", field: "state", width: 20, variableSettings: variableSettings, cssClass: "cell-nopadding", formatter: Slick.Formatters.OctopusVariableState, focusable: false, resizable: false, selectable: false },
	    {id: "name", name: "Name", field: "name", width: 300, variableSettings: variableSettings,cssClass: "cell-title", editor: Slick.Editors.Text, validator: requiredFieldValidator, sortable: true},
	    {id: "value", name: "Value", width: 500, variableSettings: variableSettings,editor: Slick.Editors.OctopusVariableValue, formatter: Slick.Formatters.OctopusVariableValue, sortable: true},
	    {id: "scope", name: "Scope", field: "scope", width: 400, variableSettings: variableSettings, editor: Slick.Editors.OctopusVariableScope, formatter: Slick.Formatters.OctopusVariableScope, sortable: true}
	  ];
	  var resetSelectionOnFilter = true;
	  
	  if(showSourceColumn)
	  {
	    columns.push({id: "source", name: "Source", field: "source", width: 400, variableSettings: variableSettings, formatter: Slick.Formatters.OctopusVariableSource, sortable: true});
	  }
	  
	  var options = {
	    editable: canEdit,
	    enableAddRow: canEdit,
	    enableCellNavigation: true,
	    asyncEditorLoading: false,
	    autoEdit: canEdit,
	    rowHeight: 28,
	    explicitInitialization: true,
	    enableColumnReorder: false,
	    forceFitColumns: true,
	    headerRowHeight: 30,
	    showHeaderRow: true,
	    autoHeight:true
	  };
	
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000)
	      .toString(16)
	      .substring(1);
	  }
	
	  function guid() {
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
	      s4() + '-' + s4() + s4() + s4();
	  }
	
	  function publicGrid() {
	    return grid;
	  }
	
	  var init = function () {
	    dataView = new Slick.Data.DataView();
	    var columnFilters = { scope: { } };
	
	    grid = new Slick.Grid("#myGrid", dataView, columns, options);
	
	    grid.setSelectionModel(new Slick.CellSelectionModel());
	
	    dataView.onRowCountChanged.subscribe(function (e, args) {
	      grid.updateRowCount();
	      grid.render();
	    });
	
	    var resetGridSelection = function() {
	      grid.resetActiveCell();
	      grid.setSelectedRows([]);
	    };
	
	    grid.onHeaderClick.subscribe(function(e, args) {
	      if (args.column.id === "state") {
	        if (grid.getOptions().showHeaderRow) {
	          grid.setHeaderRowVisibility(false);
	          columnFilters['scope'] = columnFilters['name'] = columnFilters['value'] = undefined;
	          $('div.slick-headerrow-column input.editor-text').val('');
	          $('button.variable-scope-editor.filter').text('Show all').removeClass('restricted');
	          dataView.refresh();
	        } else {
	          resetGridSelection();
	          grid.setHeaderRowVisibility(true);
	        }
	      }
	    });
	
	    var stringContains = function (recv, searchString) {
	      return recv.toLowerCase().indexOf(searchString.toLowerCase()) >= 0;
	    };
	
	    var filter = function(gridRow) {
	      if(resetSelectionOnFilter) {
	        resetGridSelection();
	      }
	
	      for (var columnId in columnFilters) {
	        /*jshint loopfunc: true */
	        if (columnId !== undefined) {
	          var filterVal = columnFilters[columnId];
	          if (filterVal !== undefined) {
	
	            var column = grid.getColumns()[grid.getColumnIndex(columnId)];
	            if (columnId === "scope"){
	              var missing =_.find(_.pairs(filterVal), function(nv) {
	                var required = nv[1];
	                if (!required || required.length === 0) {
	                  return null;
	                }
	                var name = nv[0];
	                var variableScope = gridRow[column.field];
	                if (variableScope === undefined) {
	                  return false;
	                }
	                var scopeValue = variableScope[name];
	                  if (!scopeValue) {
	                    //This is an unscoped variable, so we want to show it
	                    return false;
	                  }
	                  return _.find(required, function(r){
	                  return !_.find(scopeValue, function(s) { return r === s; });
	                });
	              });
	
	              if (missing) {
	                return false;
	              }
	            } else if (columnId === "value") {
	              if (!stringContains(gridRow['value'] || '', filterVal)) {
	                return false;
	              }
	            } else if (columnId === "source") {
	              if (!stringContains(gridRow['source'].name || '', filterVal)) {
	                return false;
	              }
	            } else {
	              if (filterVal !== "") {
	                if (!stringContains(gridRow[column.field] || '', filterVal)) {
	                  return false;
	                }
	              }
	            }
	          }
	        }
	      }
	      return true;
	    };
	
	    grid.onHeaderRowCellRendered.subscribe(function(e, args) {
	      var columnId = args.column.id;
	      if (columnId === "state") {
	        return;
	      }
	
	      $(args.node).empty();
	
	      if (columnId === 'scope'){
	        var edd = new Slick.Editors.OctopusVariableScope({
	          container: args.node,
	          column: args.column,
	          grid: grid,
	          commitChanges: function() {
	            var newScopeFilter = edd.serializeValue();
	            columnFilters['scope'] = newScopeFilter;
	            var filterToString = Slick.Helpers.OctopusVariableScopeToString(newScopeFilter, args.column.variableSettings);
	            if (!filterToString) {
	              $('button.variable-scope-editor.filter').text('Show all').removeClass('restricted');
	            } else {
	              $('button.variable-scope-editor.filter').text(filterToString).addClass('restricted');
	            }
	            dataView.refresh();
	          },
	          cancelChanges: function() {},
	          isFilter: true
	        });
	        edd.loadValue({ scope: _.extend(columnFilters['scope']) });
	      } else {
	        $("<input class='editor-text' type='text' placeholder='Show all'>")
	          .val(columnFilters[columnId])
	          .on('keyup', function() {
	            columnFilters[columnId] = $.trim($(this).val());
	            dataView.refresh();
	          })
	          .on('change', function() {
	            columnFilters[columnId] = $.trim($(this).val());
	            dataView.refresh();
	          })
	          .appendTo(args.node);
	      }
	    });
	
	    var scopeGreater = function(field, a, b) {
	      var va = a[field] || [];
	      var vb = b[field] || [];
	
	      if (va.length === 0 && vb.length === 0) {
	        return 0;
	      }
	
	      if (va.length === 0) {
	        return 1;
	      }
	
	      if (vb.length === 0) {
	        return -1;
	      }
	
	      if (va.length !== vb.length) {
	        // No/less scope is broader ('greater') than any scope/more
	        return va.length > vb.length ? 1 : -1;
	      }
	
	      var ca = va.slice(0).sort();
	      var sa = _.reduce(ca, function(m, s) { return m + s + '; '; }, '');
	      var cb = vb.slice(0).sort();
	      var sb = _.reduce(cb, function(m, s) { return m + s + '; '; }, '');
	      if (sa === sb) {
	        return 0;
	      }
	      return (sa > sb) ? 1 : -1;
	    };
	
	    grid.onSort.subscribe(function(e, args) {
	
	      var comparer = function(a, b) {
	        var sortA = a[args.sortCol.id];
	        var sortB = b[args.sortCol.id];
	
	        if (args.sortCol.id === 'scope') {
	          var scopeSort = 0;
	          scopeSort = scopeGreater('steps', sortA, sortB);
	          if (scopeSort !== 0) {
	            return scopeSort;
	          }
	          scopeSort = scopeGreater('machines', sortA, sortB);
	          if (scopeSort !== 0) {
	            return scopeSort;
	          }
	          scopeSort = scopeGreater('roles', sortA, sortB);
	          if (scopeSort !== 0) {
	            return scopeSort;
	          }
	          scopeSort = scopeGreater('environments', sortA, sortB);
	          return scopeSort;
	        }
	
	        if(sortA && sortA.name)
	        {
	          return (sortA.name > sortB.name) ? 1 : -1;
	        }
	
	        return (sortA > sortB) ? 1 : -1;
	      };
	
	      dataView.sort(comparer, args.sortAsc);
	    });
	
	    dataView.onRowsChanged.subscribe(function (e, args) {
	      grid.invalidateRows(args.rows);
	      grid.render();
	    });
	
	    var getRowMetadata = function(original) {
	      return function(row) {
	        var item = this.getItem(row),
	          ret = original(row);
	
	        if (item && item.state === "Deleted") {
	          ret = ret || {};
	          ret.cssClasses = (ret.cssClasses || '') + ' deleted';
	        }
	
	        return ret;
	      };
	    };
	
	    dataView.getItemMetadata = getRowMetadata(dataView.getItemMetadata);
	
	    dataView.beginUpdate();
	    dataView.endUpdate();
	
	    grid.setSelectionModel(new Slick.CellSelectionModel());
	
	    grid.onBeforeEditCell.subscribe(function(e,args) {
	      if (typeof args.item === "undefined") {
	        if (args.column.id !== "name") {
	          return false;
	        }
	        return true;
	      }
	      return args.item.isEditable;
	    });
	
	    grid.onAddNewRow.subscribe(function (e, args) {
	      var item = args.item;
	
	      item.isEditable = true;
	
	      if (item.name) {
	        item.value = "";
	        item.scope = {};
	      } else if (item.value) {
	        item.name = "";
	        item.scope = {};
	      } else if (item.scope) {
	        item.name = "";
	        item.value = "";
	      }
	
	      if (item.name || item.value || item.scope) {
	        item["state"] = "New";
	        item.id = guid();
	        item.reset = function() {
	          dataView.deleteItem(item.id);
	          checkDirty();
	        };
	        resetSelectionOnFilter = false;
	        dataView.addItem(item);
	        resetSelectionOnFilter = true;
	      }
	      checkDirty();
	    });
	
	    grid.onCellChange.subscribe(function (e, args) {
	      var selected = args.grid.getSelectedRows();
	      if (selected && selected.length > 1) {
	        var column = grid.getColumns()[args.cell];
	
	        var sourceItem = dataView.getItem(args.row);
	
	        dataView.beginUpdate();
	
	        var copyScope = function(source) {
	          var result = {};
	          _.each(source, function (val, key) {
	            result[key] = [];
	            _.each(val, function (v) {
	              result[key].push(v);
	            });
	          });
	          return result;
	        };
	
	        for (var i = selected[0]; i <= selected.slice(-1)[0]; i++) {
	          if (i === args.row) {
	            continue;
	          }
	          var item = dataView.getItem(i);
	          if (column.id === "name") {
	            item.name = sourceItem.name;
	          } else if (column.id === "value") {
	            item.value = sourceItem.value;
	            item.isSensitive = sourceItem.isSensitive;
	          } else if (column.id === "scope") {
	            item.scope = copyScope(sourceItem.scope);
	          }
	
	          if (item.state === "") {
	            item.state = "Changed";
	          }
	          grid.invalidateRow(i);
	        }
	
	        dataView.endUpdate();
	        grid.render();
	      }
	      if (args.item.state === "") {
	        args.item.state = "Changed";
	      }
	      args.grid.updateCell(args.row, 0);
	
	      checkDirty();
	    });
	
	    grid.onContextMenu.subscribe(function (e) {
	      e.preventDefault();
	      if (disableContextMenu) { return; }
	
	      var cell = grid.getCellFromEvent(e);
	
	      grid.setActiveCell(cell.row, cell.cell);
	
	      var node = grid.getCellNode(cell.row, cell.cell);
	
	      var variable = dataView.getItem(cell.row);
	
	      octoDropdownMenu.show(viewScope, $(node), 'variableDropdown', { variable: variable, row: cell.row, hasChanges: variable.state !== "" }, { x: e.pageX, y: e.pageY });
	    });
	
	    grid.onValidationError.subscribe(function (e, args) {
	    });
	
	    grid.init();
	    dataView.setFilter(filter);
	    grid.setHeaderRowVisibility(false);
	
	    $(window).resize(function() {
	      grid.resizeCanvas();
	    });
	    $(window).focus(function() {
	      setTimeout(function() {
	        grid.resizeCanvas();
	      }, 100);
	    });
	    setTimeout(function() {
	      grid.resizeCanvas();
	    }, 100);
	    setTimeout(function() {
	      grid.resizeCanvas();
	    }, 1000);
	  };
	
	  var checkDirty = function() {
	    var dirty = false;
	    var items = dataView.getItems();
	
	    for (var i = 0; i < items.length; i++) {
	      if (items[i].state !== "") {
	        dirty = true;
	        break;
	      }
	    }
	
	    var raise = function() {
	      if (dirty) {
	        viewScope.$emit("variableEditor:dirty");
	      } else  {
	        viewScope.$emit("variableEditor:clean");
	      }
	    };
	
	    if(!viewScope.$$phase && !rootScope.$$phase) {
	      viewScope.$apply(raise);
	    } else {
	      raise();
	    }
	  };
	
	  var dataViewHasVariable = function(variable) {
	    var hasVariable = _.some(dataView.getItems(), function(item) { return item.id === variable.Id; });
	    return hasVariable;
	  };
	
	  var updateVariableResourceFromDataViewItem = function(resource, item) {
	    resource["Id"] = item.id;
	    resource["Name"] = item.name;
	    resource["Value"] = item.value !== null ? item.value.trim() : null;
	    resource["IsSensitive"] = item.isSensitive;
	    if (item.prompt) {
	      resource["Prompt"] = {
	        "Label": item.prompt.label,
	        "Description": item.prompt.description,
	        "Required": item.prompt.required
	      };
	    } else {
	      resource["Prompt"] = null;
	    }
	    if (item.scope) {
	      resource["Scope"] = {
	        "Environment": item.scope.environments,
	        "Machine": item.scope.machines,
	        "Action": item.scope.steps,
	        "Role": item.scope.roles,
	        "Channel": item.scope.channels,
	        "TenantTag": item.scope.tenantTags,
	        "Tenants": item.scope.tenants
	      };
	    }
	  };
	
	  var refreshAndCheckDirty = function() {
	    dataView.refresh();
	    grid.invalidateAllRows();
	    grid.render();
	    checkDirty();
	  };
	
	  return {
	    init: init,
	
	    publicGrid: publicGrid,
	
	    update: function(variableSet) {
	      if (!variableSet || !variableSet.Variables) {
	        return;
	      }
	
	      var mapVariable = function(v) {
	        var d = {};
	
	        d.reset = function() {
	          d["id"] = v.Id;
	          d["state"] = v.State || "";
	          d["name"] = v.Name;
	          d["value"] = v.Value;
	          d["isSensitive"] = v.IsSensitive;
	          d["isEditable"] = v.IsEditable;
	          d["prompt"] = null;
	          if (v.Prompt) {
	            d["prompt"] = { };
	            d["prompt"]["label"] = v.Prompt.Label;
	            d["prompt"]["description"] = v.Prompt.Description;
	            d["prompt"]["required"] = v.Prompt.Required;
	          }
	          d["scope"] = {};
	          if (v.Scope) {
	            d["scope"]["environments"] = v.Scope["Environment"];
	            d["scope"]["machines"] = v.Scope["Machine"];
	            d["scope"]["steps"] = v.Scope["Action"];
	            d["scope"]["roles"] = v.Scope["Role"];
	            d["scope"]["channels"] = v.Scope["Channel"];
	            d["scope"]["tenantTags"] = v.Scope["TenantTag"];
	            d["scope"]["tenants"] = v.Scope["Tenant"];
	          }
	          d["source"] = v.Source;
	        };
	
	        d.reset();
	        return d;
	      };
	
	      var data = _.chain(variableSet.Variables).sortBy(function(v) {
	        return v.Name.toLowerCase() + " " + v.Id;
	      }).map(mapVariable).value();
	
	      dataView.beginUpdate();
	      dataView.setItems(data);
	      dataView.endUpdate();
	
	      refreshAndCheckDirty();
	    },
	
	    notifyChanged: function() {
	      refreshAndCheckDirty();
	    },
	
	    destroy: function() {
	      grid.destroy();
	    },
	
	    markForDeletion: function(variable) {
	      var selected = grid.getSelectedRows();
	
	      var toDeleteImmediately = [];
	
	      if (!selected || selected.length === 0) {
	        if (grid.getActiveCell() != null) {
	          selected = [grid.getActiveCell().row];
	        }
	      }
	
	      for (var i = selected[0]; i <= selected.slice(-1)[0]; i++) {
	        var item = dataView.getItem(i);
	
	        if (item.state === "New") {
	          toDeleteImmediately.push(item.id);
	        } else {
	          item.state = "Deleted";
	        }
	      }
	
	      for (var k = 0; k < toDeleteImmediately.length; k++) {
	        dataView.deleteItem(toDeleteImmediately[k]);
	      }
	
	      refreshAndCheckDirty();
	    },
	
	    duplicate: function(variable, row) {
	      var copy = {};
	      copy.id = guid();
	      copy.name = variable.name;
	      if (!variable.isSensitive) {
	        copy.value = variable.value;
	      } else {
	        copy.value = "";
	      }
	      copy.scope = variable.scope;
	      copy.state = "New";
	      copy.reset = function() {
	        dataView.deleteItem(copy.id);
	        refreshAndCheckDirty();
	      };
	      dataView.insertItem(row, copy);
	      refreshAndCheckDirty();
	    },
	
	    confirmNonPrintableChars: function(success) {
	      var warnings = [];
	      var promises = []; 
	
	      var displayNonPrintableChar = function(str, i) {
	        return "(Position: " + i + ", Unicode value: U+" + ("0000" + str.charCodeAt(i).toString(16)).slice(-4) + ")";
	      };
	
	      var checkForNonPrintableChars = function(variableName, str, msgPrefix) {
	        return octopusRepository.Variables.nonPrintableChars(str)
	          .then(function(nonPrintableCharIndexes){
	            if (!_.isEmpty(nonPrintableCharIndexes)){
	             warnings.push(
	                nonPrintableCharIndexes.length > 1 
	                  ? msgPrefix + " variable '" + variableName + "' contains characters which may not be visible:<br/>" 
	                    + _.map(nonPrintableCharIndexes, function(x){ return displayNonPrintableChar(str, x);}).join("<br/>")
	                  : msgPrefix + " variable '" + variableName + "' contains characters which may not be visible:<br/>" 
	                    + displayNonPrintableChar(str, nonPrintableCharIndexes[0])
	             );
	            }
	          });
	      };
	
	      for (var j = 0; j < dataView.getLength(); j++) {
	        var item = dataView.getItem(j);
	
	        if (item.state !== "New" && item.state !== "Changed") {
	          continue;
	        }
	
	        promises.push(checkForNonPrintableChars(item.name, item.name, "Name of"));
	        promises.push(checkForNonPrintableChars(item.name, item.value, "Value of"));
	      }
	
	      $q.all(promises).then(function(){ 
	        if (_.isEmpty(warnings)){
	          success();
	          return;
	        }
	
	        octoDialog.asyncConfirm({
	         title: "Non-printable characters",
	         message: _.reduce(warnings, function(memo, line) { return "<p>" + line + "</p>";}, ""),
	         executeButtonClass: "btn-warning",
	         executeButtonText: "Save anyway",
	         execute: function(dialog){ 
	          dialog.dismiss();
	          success(); 
	          }
	        } );
	      });
	    },
	
	    applyChanges: function(variableSet) {
	      var variablesById = {};
	      for (var i = 0; i < variableSet.Variables.length; i++) {
	        var v = variableSet.Variables[i];
	        variablesById[v.Id] = v;
	
	        var hasVariable = dataViewHasVariable(v);
	        if (hasVariable) {
	          variablesById[v.Id] = v;
	        }
	        else {
	          variableSet.Variables.splice(i, 1); // Remove variable that was deleted from the dataView immediately but still in the parent variableSet
	        }
	      }
	
	      var dataViewItems = dataView.getItems();
	      var dataViewItemCount = 0; // Using dataView.getItems.length because dataView.getLength is affected by filtering
	      if (dataViewItems) {
	        dataViewItemCount = dataViewItems.length;
	      }
	
	      for (var j = 0; j < dataViewItemCount; j++) {
	        var item = dataViewItems[j];
	        if (item.state === "") {
	          continue; // no changes
	        }
	
	        if (item.state === "Deleted") {
	          var index = variableSet.Variables.indexOf(variablesById[item.id]);
	          if(index >= 0) { // If saving failed once (due to network error) and user saves again the variable won't be found and we'll get -1 here
	            variableSet.Variables.splice(index, 1);
	          }
	          continue;
	        }
	
	        var resource = variablesById[item.id];
	        if (!resource) {
	          resource = {};
	        }
	        updateVariableResourceFromDataViewItem(resource, item);
	
	        if (item.state === "New" && !variablesById[resource.Id]) {
	          variableSet.Variables.push(resource);
	        }
	      }
	
	      return true;
	    }
	  };
	};
	
	module.directive('variableEditor', function(octoDropdownMenu, $rootScope, $timeout, octopusRepository, octoDialog, $q, $uibModal) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      data: '=',
	      tab: '='
	    },
	    templateUrl: 'areas/projects/views/variables_editor.html',
	    link: function(scope, element) {
	
	      var settings = {};
	
	      var editor = $("#myGrid", element);
	      editor.css("height", "auto");
	      editor.css("margin-bottom", "5px");
	
	      var grid = null;
	
	      scope.showScopePicker = function(selectedScopeValues, isFilter, callback) {
	        $uibModal.open({
	          backdrop: true,
	          keyboard: true,
	          templateUrl: 'areas/projects/views/variables_editor_scope.html',
	          controller: 'VariableEditorScopeController',
	          controllerAs: 'vm',
	          bindToController: true,
	          resolve: {
	            selectedScopeValues: function(){
	              return selectedScopeValues;
	            },
	            availableScopeValues: function(){
	              return scope.data.variableSet.ScopeValues;
	            },
	            isFilter: function(){
	              return isFilter;
	            },
	            canScopeToTenantTags: function () {
	              return scope.data.canScopeToTenantTags;
	            }
	          }
	        }).result.then(function (result) {
	          if (!result) {
	            callback();
	          } else {
	            callback(result.selectedScopeValues);
	          }
	        });
	      };
	
	      scope.$watch("data", function(v) {
	        if (scope.data != null) {
	          settings.scopeOptions = scope.data.scopeOptions;
	
	          $timeout(function() {
	            grid = defineSlickGrid(settings, scope, octoDropdownMenu, $rootScope, scope.data.canEdit, scope.data.showSourceColumn,
	              octopusRepository, octoDialog, $q, !!scope.data.disableContextMenu);
	            grid.init();
	            grid.update(scope.data.variableSet);
	          }, 200);
	        }
	      });
	
	      // Resize on tab changes (helps avoid weird timing issues in Angular).
	      scope.$watch("tab", function(v) {
	        if (grid && grid.publicGrid() && scope.tab != null) {
	          setTimeout(function() {
	            grid.publicGrid().resizeCanvas();
	          }, 100);
	        }
	      });
	
	      scope.$on("destroy", function() {
	        if (grid) {
	          grid.destroy();
	        }
	      });
	
	      scope.duplicateVariable = function(variable, row) {
	        grid.duplicate(variable, row);
	        grid.notifyChanged();
	      };
	
	      scope.deleteVariable = function(variable) {
	        grid.markForDeletion(variable);
	        grid.notifyChanged();
	      };
	
	      scope.resetChanges = function(variable) {
	        variable.reset();
	        grid.notifyChanged();
	      };
	
	      element.keyup(function(e) {
	        if (e.keyCode === 46) {
	          e.preventDefault();
	
	          grid.markForDeletion(null);
	
	          return false;
	        }
	      });
	
	      scope.$on("variableEditor:applyChanges", function(e, vs) {
	        grid.confirmNonPrintableChars(function(){
	          var valid = grid.applyChanges(vs);
	          if (valid) {
	            scope.$emit("variableEditor:changesApplied", vs);
	          }
	        });
	      });
	
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {angular.module('octopusApp.projects')
	    .controller('VariableEditorScopeController', function ($scope, $q, $uibModalInstance, $location, busy, octopusRepository, selectedScopeValues, availableScopeValues, isFilter, canScopeToTenantTags) {
	    var vm = this;
	    var isLoading = vm.isLoading = busy.create();
	
	    vm.close = $uibModalInstance.close;
	    vm.save = save;
	
	    vm.isFilter = isFilter;
	    vm.availableScopeValues =  availableScopeValues;
	    vm.selectedScopeValues = cloneScope(selectedScopeValues);
	    vm.canScopeToTenantTags = canScopeToTenantTags;
	
	    function save() {
	        $uibModalInstance.close({
	            selectedScopeValues: vm.selectedScopeValues
	        });
	    }
	
	    function cloneScope(originalScopeValues){
	        var copyScopes = _.clone(originalScopeValues);
	        _.map(copyScopes, function(a) { return _.clone(a); });
	        return copyScopes;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 556 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.ConfigurationTransforms", function(busy, octopusRepository) {
	    return {
	      title: "Configuration transforms",
	      description: "Runs configuration file transforms, such as _Web.Release.config_",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.ConfigurationTransforms_edit.html",
	      priority: 21,
	      editLink: function($scope, element) {
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] = "True";
	      },
	      disable: function(action, step) {
	        delete action.Properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"];
	        delete action.Properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"];
	      }
	    };
	  });
	
	});
	


/***/ },
/* 557 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.ConfigurationVariables", function(busy, octopusRepository) {
	    return {
	      title: "Configuration variables",
	      description: "Replace settings in any _.config_ files with variables defined in Octopus.",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.ConfigurationVariables_edit.html",
	      priority: 20,
	      editLink: function($scope, element) {
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] = "True";
	      },
	      disable: function(action, step) {
	        delete action.Properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"];
	      }
	    };
	  });
	
	});
	


/***/ },
/* 558 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.CustomDirectory", function(busy, octopusRepository) {
	    return {
	      title: "Custom installation directory",
	      description: "Change where Tentacle extracts your package",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.CustomDirectory_edit.html",
	      priority: 5,
	      editLink: function($scope, element) {
	      },
	      enable: function(action, step) {
	      },
	      disable: function(action, step) {
	        delete action.Properties["Octopus.Action.Package.CustomInstallationDirectory"];
	      }
	    };
	  });
	
	});
	


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.CustomScripts", function(busy, octopusRepository, $timeout) {
	    return {
	      title: "Custom deployment scripts",
	      description: "Execute scripts during the deployment, without embedding them in your package",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.CustomScripts_edit.html",
	      priority: 10,
	      enable: function(action, step) {
	      },
	      disable: function(action, step) {
	          Object.keys(action.Properties).filter(function(name) {
	              return name.indexOf("Octopus.Action.CustomScripts.") === 0;
	          }).forEach(function(name){
	              delete action.Properties[name];
	          });
	      },
	      preLink: function(scope) {
	        var createScriptModel = function () {
	          return { syntax: 'PowerShell', scriptBody: '' };
	        };
	
	        scope.scripts = {
	          preDeploy: createScriptModel(),
	          deploy: createScriptModel(),
	          postDeploy: createScriptModel()
	        };
	      },
	      editLink: function(scope, element) {
	        // Maintains a mapping between simple properties of the
	        // editor objects, and properties like action.Properties["Octopus.Action.CustomScripts.PreDeploy.ps1"]
	
	        var syntaxExtensions = { PowerShell: 'ps1', CSharp: 'csx', Bash: 'sh', FSharp: 'fsx' };
	        var extensionSyntaxes = _.invert(syntaxExtensions);
	        var scriptToVar = { preDeploy: 'PreDeploy', deploy: 'Deploy', postDeploy: 'PostDeploy'};
	        var varToScript = { PreDeploy: scope.scripts.preDeploy, Deploy: scope.scripts.deploy, PostDeploy: scope.scripts.postDeploy };
	        var customScriptPrefix = "Octopus.Action.CustomScripts.";
	
	        _.each(_.pairs(scope.action.Properties), function(prop){
	          if (prop[0].indexOf(customScriptPrefix) === 0) {
	            var scrext = prop[0].slice(customScriptPrefix.length).split('.');
	            var script = varToScript[scrext[0]];
	            script.syntax = extensionSyntaxes[scrext[1]];
	            script.scriptBody = prop[1];
	          }
	        });
	
	        _.each(['preDeploy', 'deploy', 'postDeploy'], function(editor){
	          var varName = scriptToVar[editor];
	          var script = varToScript[varName];
	
	          scope.$watch('scripts.' + editor + '.syntax', function() {
	            var pname = customScriptPrefix + varName + '.' + syntaxExtensions[script.syntax];
	            _.each(syntaxExtensions, function(ext){
	              var oldname = customScriptPrefix + varName + '.' + ext;
	              if (ext !== syntaxExtensions[script.syntax] && scope.action.Properties.hasOwnProperty(oldname)) {
	                delete scope.action.Properties[oldname];
	              }
	            });
	            scope.action.Properties[pname] = script.scriptBody;
	          });
	
	          scope.$watch('scripts.' + editor + '.scriptBody', function() {
	            var pname = customScriptPrefix + varName + '.' + syntaxExtensions[script.syntax];
	            scope.action.Properties[pname] = script.scriptBody;
	          });
	        });
	      }
	    };
	  });
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  var bindingsFromString = function(bindingString) {
	    try {
	      var result = parseV2Format();
	      if(typeof result === 'object'){
	        return result;
	      }
	      return parseV1Format();
	    }
	    catch (ex) {
	      return parseV1Format();
	    }
	
	    function parseV1Format() {
	      return bindingString.split("|").map(function(b){
	        var bindingParts = b.split("/");
	        var bindingInfo = bindingParts[1].split(":");
	        var enabled = bindingParts.length >= 4 ? (bindingParts[3] === "True") : true;
	        var requireSni = bindingParts.length >= 5 ? (bindingParts[4] === "True"): false;
	        return {
	          protocol: bindingParts[0],
	          enabled: enabled,
	          thumbprint: bindingParts[2],
	          ipAddress: bindingInfo[0],
	          port: bindingInfo[1],
	          host: bindingInfo[2],
	          requireSni: requireSni
	        };
	      });
	    }
	
	    function parseV2Format() {
	      return JSON.parse(bindingString);
	    }
	  };
	
	  var bindingsToString = function(bindings) {
	    var result = bindings.map(function(b) {
	      var isHttp = (b.protocol === "http");
	      //strip http etc except inside #{...} variable declarations
	      b.host = b.host
	        .split(/(#{.*?})/g)
	        .map(function(h){
	           return /^#{.*}$/.test(h)
	            ? h
	            : h.replace("//", "").replace("/", "").replace("https:", "").replace("http:", "");
	        })
	        .join("");
	
	      return {
	        protocol: b.protocol,
	        ipAddress:  b.ipAddress,
	        port: b.port,
	        host: b.host,
	        thumbprint: isHttp ? "" : b.thumbprint,
	        requireSni: isHttp ? false : b.requireSni,
	        enabled: b.enabled
	      };
	    });
	
	    return JSON.stringify(result);
	  };
	
	  pluginRegistry.registerFeature("Octopus.Features.IISWebSite", function(busy, octopusRepository, $uibModal, $rootScope, sensitiveValue) {
	    return {
	      title: "IIS web site and application pool",
	      description: "Creates or reconfigures an IIS website and application pool (requires IIS7+)",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.IISWebSite_edit.html",
	      priority: 8,
	      editLink: function($scope, element, action, step, project) {
	
	        if (!action.Properties["Octopus.Action.IISWebSite.DeploymentType"]) {
	          action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = 'webSite';
	        }
	
	        $scope.isIISStep = action.ActionType === "Octopus.IIS";
	
	        $scope.$watch("action.Properties.Octopus.Action.IISWebSite.Bindings", function() {
	          $scope.iisBindings = bindingsFromString(action.Properties["Octopus.Action.IISWebSite.Bindings"]);
	        });
	
	        $scope.removeBinding = function(b) {
	          $scope.iisBindings.splice($scope.iisBindings.indexOf(b), 1);
	          action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
	        };
	
	        $scope.editBinding = function(binding) {
	          $uibModal.open({
	            size: "lg",
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/features/Octopus.Features.IISWebSite_binding_dialog.html',
	            controller: "IISWebSiteDialogController",
	            resolve: {
	              "projectId" : function() {
	                return project.Id;
	              },
	              "binding": function () {
	                return _.clone(binding);
	              }
	            }
	          }).result.then(function(result) {
	            if (result) {
	              var ix = $scope.iisBindings.indexOf(binding);
	              $scope.iisBindings[ix] = result;
	              action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
	            }
	          });
	        };
	
	        $scope.addBinding = function() {
	          $uibModal.open({
	            size: "lg",
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/features/Octopus.Features.IISWebSite_binding_dialog.html',
	            controller: "IISWebSiteDialogController",
	            resolve: {
	              "projectId" : function() {
	                return project.Id;
	              },
	              "binding": function() {
	                return {
	                  protocol: "http",
	                  port: "80",
	                  ipAddress: "*",
	                  host: "",
	                  thumbprint: "",
	                  enabled: true,
	                  requireSni: false
	                };
	              }
	            }
	          }).result.then(function(result) {
	            if (result) {
	              $scope.iisBindings.push(result);
	              action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
	            }
	          });
	        };
	
	        $scope.selectVirtualDirectory = function () {
	          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'True';
	          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'False';
	          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'False';
	        };
	
	        $scope.selectWebSite = function () {
	          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'False';
	          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'False';
	          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'True';
	        };
	
	        $scope.selectWebApplication = function () {
	          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'False';
	          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'True';
	          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'False';
	        };
	
	        $scope.checkWebSiteName = function() {
	          var name = action.Properties["Octopus.Action.IISWebSite.WebSiteName"];
	          $scope.looksLikeVDir = name && (name.indexOf('/') !== -1 || name.indexOf('\\') !== -1);
	        };
	
	        $scope.checkWebRoot = function() {
	          var path = action.Properties["Octopus.Action.IISWebSite.WebRoot"];
	          $scope.looksLikeFullPath = path && path.indexOf(':') !== -1;
	        };
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = 'webSite';
	        action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "True";
	
	        action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString([{ protocol: "http", port: 80, host: "", enabled: true }]);
	        setupApplicationPoolDefaults(action, "Octopus.Action.IISWebSite");
	
	        action.Properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] = "False";
	        action.Properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] = "False";
	        action.Properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] = "True";
	
	        setupApplicationPoolDefaults(action, "Octopus.Action.IISWebSite.WebApplication");
	
	        function setupApplicationPoolDefaults(action, pathToRootProperty) {
	          action.Properties[pathToRootProperty + ".ApplicationPoolFrameworkVersion"] = "v4.0";
	          action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"] = "ApplicationPoolIdentity";
	        }
	      },
	      preSave: function(action, step) {
	        normalizeApplicationPoolData(action, "Octopus.Action.IISWebSite");
	        normalizeApplicationPoolData(action, "Octopus.Action.IISWebSite.WebApplication");
	
	        function normalizeApplicationPoolData(action, pathToRootProperty) {
	          if(action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"] !== "SpecificUser" && !$rootScope.isBound(action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"])) {
	            action.Properties[pathToRootProperty + ".ApplicationPoolUsername"] = null;
	            action.Properties[pathToRootProperty + ".ApplicationPoolPassword"]  = null;
	          }
	        }
	      },
	      validate: function(action, step, errors) {
	        var deploymentType = action.Properties["Octopus.Action.IISWebSite.DeploymentType"];
	        if(!deploymentType) {
	            deploymentType = (action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = "webSite");
	        }
	        switch(deploymentType) {
	          case "webSite" :
	            if (!action.Properties["Octopus.Action.IISWebSite.Bindings"]) {
	              errors.push("Please add at least one IIS binding.");
	            }
	            if (!action.Properties["Octopus.Action.IISWebSite.WebSiteName"]) {
	              errors.push("Please enter an IIS web site name");
	            }
	            if (!action.Properties["Octopus.Action.IISWebSite.ApplicationPoolName"]) {
	              errors.push("Please enter an IIS application pool name");
	            }
	            if (action.Properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] + action.Properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] + action.Properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] === "FalseFalseFalse") {
	              errors.push("Please enable at least one of the IIS authentication options");
	            }
	            break;
	          case "webApplication":
	            if (!action.Properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"]) {
	              errors.push("Please enter an IIS web site name");
	            }
	            if (!action.Properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"]) {
	              errors.push("Please enter an IIS virtual path");
	            }
	            if (!action.Properties["Octopus.Action.IISWebSite.WebApplication.ApplicationPoolName"]) {
	              errors.push("Please enter an IIS application pool name");
	            }
	            break;
	          case "virtualDirectory":
	            if (!action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"]) {
	              errors.push("Please enter an IIS web site name");
	            }
	            if (!action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"]) {
	              errors.push("Please enter an IIS virtual path");
	            }
	            break;
	          default:
	            throw  "Unknown deployment type: " + deploymentType;
	        }
	      },
	      disable: function(action, step) {
	        Object.keys(action.Properties).filter(function(name) {
	          return name.indexOf("Octopus.Action.IISWebSite.") === 0;
	        }).forEach(function(name){
	          delete action.Properties[name];
	        });
	      }
	    };
	  });
	});
	
	module.controller('IISWebSiteDialogController', function ($scope, busy, octopusRepository, pluginRegistry, $uibModalInstance, projectId, binding) {
	  $scope.isSaving = busy.create();
	
	  $scope.binding = binding;
	  binding.projectId = projectId;
	
	  $scope.protocolChanged = function() {
	    if ($scope.binding.protocol === "https") {
	      $scope.binding.port = "443";
	    }
	  };
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    if ($scope.binding.protocol === 'https') {
	      if ($scope.binding.thumbprint.trim() === '') {
	        $scope.isSaving.showError('An SSL certificate thumbprint must be provided for HTTPS bindings.');
	        return;
	      }
	
	      if (!$scope.isBound($scope.binding.thumbprint)) {
	        $scope.binding.thumbprint = $scope.binding.thumbprint.replace(/[^0-9A-z]/g, '');
	      }
	    }
	
	    $uibModalInstance.close($scope.binding);
	  };
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 561 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.IisHome", function(busy, octopusRepository) {
	    return {
	      title: "IIS6+ home directory",
	      description: "Points an existing IIS website or virtual directory's 'Home' directory to the path the package was extracted to (**not** compatible with the _IIS web site_ feature)",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.IisHome_edit.html",
	      priority: 30,
	      editLink: function($scope, element) {
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.Package.UpdateIisWebsite"] = "True";
	      },
	      disable: function(action, step) {
	        delete action.Properties["Octopus.Action.Package.UpdateIisWebsite"];
	        delete action.Properties["Octopus.Action.Package.UpdateIisWebsiteName"];
	      }
	    };
	  });
	
	});
	


/***/ },
/* 562 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.JsonConfigurationVariables", function(busy, octopusRepository) {
	    return {
	      title: "JSON configuration variables",
	      description: "Replace settings in selected JSON files with variables defined in Octopus.",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.JsonConfigurationVariables_edit.html",
	      priority: 15,
	      editLink: function($scope, element) {
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"] = "True";
	      },
	      disable: function(action, step) {
	        delete action.Properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"];
	        delete action.Properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"];
	      }
	    };
	  });
	
	});
	


/***/ },
/* 563 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	  pluginRegistry.registerFeature("Octopus.Features.RedGateDatabase", function(busy, octopusRepository) {
	    return {
	      title: "Red Gate Database Deployment",
	      description: "Deploy a database using SQLCI.exe from Red Gate",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.RedGateDatabase_edit.html",
	      priority: 100,
	      editLink: function($scope, element, action, step, project) {
	
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.RedGateDatabase.Enabled"] = "True";
	        action.Properties["Octopus.Action.RedGateDatabase.CompareOptions"] = "IgnoreUsers,IgnoreCertificatesAndCryptoKeys,ForceColumnOrder,ThrowOnFileParseFailed";
	        action.Properties["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"] = "True";
	        action.Properties["Octopus.Action.RedGateDatabase.SqlCiPath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\sqlCI.exe";
	        action.Properties["Octopus.Action.RedGateDatabase.SqlComparePath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\SC\\SQLCompare.exe";
	      },
	      validate: function(action, step, errors) {
	        if (!action.Properties["Octopus.Action.RedGateDatabase.SqlCiPath"]) {
	          errors.push("Please specify a path to SQLCI.exe.");
	        }
	        if (!action.Properties["Octopus.Action.RedGateDatabase.SqlComparePath"]) {
	          errors.push("Please specify a path to SQLCompare.exe.");
	        }
	        if (!action.Properties["Octopus.Action.RedGateDatabase.ConnectionStrings"]) {
	          errors.push("Please specify the connection strings to the databases that you wish to deploy.");
	        }
	      },
	      disable: function(action, step) {
	          Object.keys(action.Properties).filter(function(name) {
	              return name.indexOf("Octopus.Action.RedGateDatabase.") === 0;
	          }).forEach(function(name){
	              delete action.Properties[name];
	          });
	      }
	    };
	  });
	});


/***/ },
/* 564 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.SubstituteInFiles", function() {
	    return {
	      title: "Substitute variables in files",
	      description: "Transforms files using the Octopus <code>#{Variable}</code> substitution syntax",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.SubstituteInFiles_edit.html",
	      priority: 22,
	      editLink: function($scope, element) {
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.SubstituteInFiles.Enabled"] = "True";
	      },
	      disable: function(action, step) {
	        delete action.Properties["Octopus.Action.SubstituteInFiles.TargetFiles"];
	        delete action.Properties["Octopus.Action.SubstituteInFiles.OutputEncoding"];
	      }
	    };
	  });
	
	});
	
	


/***/ },
/* 565 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.run(function(pluginRegistry) {
	
	  pluginRegistry.registerFeature("Octopus.Features.WindowsService", function(busy, octopusRepository, $rootScope, sensitiveValue) {
	    return {
	      title: "Windows Service",
	      description: "Creates or reconfigures a Windows Service using _sc.exe_",
	      editTemplateUrl: "areas/projects/features/Octopus.Features.WindowsService_edit.html",
	      priority: 8,
	      editLink: function($scope, element, action) {
	        $scope.isWindowsServiceStep = action.ActionType === "Octopus.WindowsService";
	
	        $scope.account = {
	          bound: {},
	          passwordReset: sensitiveValue.getResetValue($scope.action.Properties["Octopus.Action.WindowsService.CustomAccountPassword"])
	        };
	      },
	      enable: function(action, step) {
	        action.Properties["Octopus.Action.WindowsService.CreateOrUpdateService"] = "True";
	        action.Properties["Octopus.Action.WindowsService.ServiceAccount"] = "LocalSystem";
	        action.Properties["Octopus.Action.WindowsService.StartMode"] = "auto";
	      },
	      preSave: function(action, step) {
	        if(action.Properties["Octopus.Action.WindowsService.ServiceAccount"] !== "_CUSTOM" && !$rootScope.isBound(action.Properties["Octopus.Action.WindowsService.ServiceAccount"])) {
	          action.Properties["Octopus.Action.WindowsService.CustomAccountName"] = null;
	          action.Properties["Octopus.Action.WindowsService.CustomAccountPassword"]  = null;
	        }
	      },
	      validate: function(action, step, errors) {
	        if (!action.Properties["Octopus.Action.WindowsService.ServiceName"]) {
	          errors.push("Please enter a service name for the Windows Service.");
	        }
	        if (!action.Properties["Octopus.Action.WindowsService.ExecutablePath"]) {
	          errors.push("Please enter an executable path for this Windows Service.");
	        }
	      },
	      disable: function(action, step) {
	          Object.keys(action.Properties).filter(function(name) {
	              return name.indexOf("Octopus.Action.WindowsService.") === 0;
	          }).forEach(function(name){
	              delete action.Properties[name];
	          });
	      }
	    };
	  });
	});
	


/***/ },
/* 566 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectGroupEditController', function ($scope, $stateParams, busy, pageTitle, octopusRepository, $location) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.projectGroup = null;
	    $scope.environments = null;
	
	    var projectGroupId = $stateParams["id"];
	    isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
	
	        if (projectGroupId) {
	            isLoading.promise(octopusRepository.ProjectGroups.get(projectGroupId).then(function (group) {
	                $scope.environments = environments;
	                $scope.projectGroup = group;
	                pageTitle(group.Name + " settings");
	            }));
	        } else {
	            $scope.environments = environments;
	            $scope.projectGroup = {};
	            pageTitle("Create project group");
	        }
	    }));
	
	    $scope.save = function () {
	        isSaving.promise(octopusRepository.ProjectGroups.save($scope.projectGroup).then(function (saved) {
	            $location.url("/projects" + (!projectGroupId ? "?newProjectGroupId=" + saved.Id : ""));
	        }));
	    };
	});
	
	
	


/***/ },
/* 567 */
/***/ function(module, exports) {

	angular.module('octopusApp.projects')
	    .config(function($stateProvider,$urlRouterProvider) {
	
	        $stateProvider.state('app.projects.groups', {
	            abstract: true,
	            url: '^/projectgroups',
	            template: '<script octo-section="breadcrumbs" type="text/ng-template"><li>Project Groups</li></script><ui-view></ui-view>'
	        });
	
	        $stateProvider.state('app.projects.groups.new', {
	            url: '/new',
	            templateUrl: 'areas/projects/groups/ProjectGroupCreate.html',
	            controller: 'ProjectGroupEditController',
	            layout: {
	                title: 'New Project Group'
	            }
	        });
	
	
	        $stateProvider.state('app.projects.groups.edit', {
	            url: '/:id',
	            templateUrl: 'areas/projects/groups/ProjectGroupEdit.html',
	            controller: 'ProjectGroupEditController',
	            layout: {
	                title: 'Edit Project Group'
	            }
	        });
	    });

/***/ },
/* 568 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.service('actionExecutionLocations', function () {
	
	    this.alwaysOnTarget = 'AlwaysOnTarget';
	    this.alwaysOnServer = 'AlwaysOnServer';
	    this.targetOrServer = 'TargetOrServer';
	});


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1);
	
	var angularModule = angular.module('octopusApp.projects');
	
	var ActionUpdater = function () {
	    var that = this;
	
	    this.isParameterSensitive = function(parameter){
	        return !!parameter.DisplaySettings["Octopus.ControlType"] && parameter.DisplaySettings["Octopus.ControlType"] === "Sensitive";
	    };
	
	    this.hasParameterDefaultValue = function(parameter){
	        return typeof parameter.DefaultValue !== 'undefined' && parameter.DefaultValue !== null && parameter.DefaultValue !== '';
	    };
	
	    this.isPropertySensitive = function(property){
	        return Object.prototype.toString.call(property) === "[object Object]";
	    };
	
	
	    this.update = function(action, actionTemplate, defaultPropertyValues){
	        var previous = _.clone(action.Properties);
	        defaultPropertyValues = defaultPropertyValues || {};
	
	        // In this way we get rid of properties that don't match parameters of the template
	        action.Properties = _.clone(actionTemplate.Properties);
	
	        _.each(previous, function(v, k){
	            if (_.contains(["Octopus.Action.TargetRoles",
	                    "Octopus.Action.MaxParallelism",
	                    "Octopus.Action.RunOnServer"], k)){
	                action.Properties[k] = v;
	            }
	        });
	
	        _.each(actionTemplate.Parameters, function(parameter){
	
	            var isParameterSensitive = that.isParameterSensitive(parameter);
	            var isPropertySensitive = that.isPropertySensitive(previous[parameter.Name]);
	
	            if (parameter.Name in previous) {
	                if (isParameterSensitive === isPropertySensitive) {
	                    action.Properties[parameter.Name] = previous[parameter.Name];
	                }
	
	                if (isParameterSensitive && !isPropertySensitive) {
	                    action.Properties[parameter.Name] = { HasValue: true, NewValue: previous[parameter.Name] };
	                }
	
	                // We don't want to expose sensitive information.
	                if (!isParameterSensitive && isPropertySensitive) {
	                    if (defaultPropertyValues[parameter.Name] !== undefined) {
	                        action.Properties[parameter.Name] = defaultPropertyValues[parameter.Name];
	                    } else {
	                        action.Properties[parameter.Name] = parameter.DefaultValue;
	                    }
	                }
	            }
	            else {
	                if (defaultPropertyValues[parameter.Name] !== undefined) {
	                    action.Properties[parameter.Name] = defaultPropertyValues[parameter.Name];
	                }
	                 else {
	                    if (that.hasParameterDefaultValue(parameter)) {
	                        action.Properties[parameter.Name] = parameter.DefaultValue;
	                    }
	                }
	            }
	        });
	
	        action.Properties["Octopus.Action.Template.Id"] = actionTemplate.Id;
	        action.Properties["Octopus.Action.Template.Version"] = actionTemplate.Version;
	    };
	};
	
	angularModule.service('actionUpdater', ActionUpdater);
	
	module.exports = ActionUpdater;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	
	module.controller('StepTemplatesController', function ($scope, busy, $stateParams, $location, pageTitle, projectState,
	                                                       octopusRepository, octopusPermissionSet, pluginRegistry, $filter, actionTemplateProcessor) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isInstalling = $scope.isInstalling = busy.create();
	    var projectId = $stateParams.projectId;
	
	    var parentStepId = $stateParams["parentStepId"];
	    var isNormalStep = !parentStepId;
	
	    var getNewStepUrl = function(actionTemplate) {
	        var url = "";
	
	        if (isNormalStep) {
	            url = "/projects/" + $scope.project.Slug + "/process/step/new/" + actionTemplate.ActionType;
	        }
	        else {
	            // Add 'child' step
	            url = "/projects/" + $scope.project.Slug + "/process/step/" + parentStepId + "/new/" + actionTemplate.ActionType;
	        }
	
	        if (actionTemplate.Id) {
	            url = url + "/" + actionTemplate.Id;
	        }
	
	        return url;
	    };
	
	    $scope.resolveLink = $filter('resolveLink');
	    $scope.add = function (type, id) {
	        var tmpActionTemplate = {Id: id, ActionType: type};
	        var url = getNewStepUrl(tmpActionTemplate);
	        $location.path(url);
	    };
	
	    $scope.redirectToLibraryStepDetails = function (id) {
	        $location.path("/library/steptemplates/community/" + id + "/details").search("from", projectId);
	    };
	
	    $scope.install = function (id) {
	        return isLoading.promise(octopusRepository.CommunityActionTemplates.get(id).then(function (template) {
	            return actionTemplateProcessor.installCommunityActionTemplate(template, getNewStepUrl, false, isInstalling);
	        }));
	    };
	
	    $scope.update = function (id) {
	        $scope.redirectToLibraryStepDetails(id);
	    };
	
	    $scope.details = function (id) {
	        $scope.redirectToLibraryStepDetails(id);
	    };
	
	    $scope.allTemplates = [];
	    $scope.filteredInstalledTemplates = [];
	    $scope.filteredLibraryTemplates = [];
	
	    $scope.enableGrouping = true;
	
	    $scope.actionsToShow = _.chain(pluginRegistry.getAllActions())
	                                .filter(function(action) {
	                                   return !action.canShow || action.canShow();
	                                });
	
	    $scope.actionTypesToShow = $scope.actionsToShow.map(function(action){return action.actionType;}).value();
	    $scope.childActionTypesToShow = $scope.actionsToShow.filter(function (action) { return action.canBeChild; }).map(function(action){return action.actionType;}).value();
	
	    $scope.filterTemplates = function () {
	        $scope.enableGrouping = !(!!this.inputText);
	
	        if (isNormalStep) {
	            $scope.filteredInstalledTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
	                return template.IsInstalled && _.contains($scope.actionTypesToShow, template.Type);
	            });
	        } else {
	            $scope.filteredInstalledTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
	                return template.IsInstalled && _.contains($scope.childActionTypesToShow , template.Type);
	            });
	        }
	
	        $scope.filteredLibraryTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) { return !template.IsInstalled; });
	    };
	
	    isLoading.promise(projectState.load().then(function (project) {
	        pageTitle(project.Name + " step templates");
	        $scope.project = project;
	
	        isLoading.promise(actionTemplateProcessor.getActionTemplates().then(function( templates ) {
	            $scope.allTemplates = templates;
	            $scope.filterTemplates();
	
	            isLoading.promise(actionTemplateProcessor.getActionTemplatesAuthorizationAndFeatureConfig().then(function (results) {
	                $scope.showActionTemplateTeaser = !results.isAuthorized;
	                $scope.showLibraryTemplateTeaser = !results.configuration.IsCommunityActionTemplatesEnabled;
	            }));
	        }));
	    }));
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectTriggerEditController', function ($scope, busy, $stateParams, projectState, $location, $q, pageTitle, octopusRepository, unsavedChanges){
	
	    var triggerId = $stateParams.triggerId;
	    var projectId = $stateParams.projectId;
	    var isLoading = $scope.isLoading = projectState.isLoading;
	    var isSaving = $scope.isSaving = projectState.isSaving;
	
	    if (!triggerId) {
	        $scope.projectTrigger = {
	            ProjectId: projectId,
	            Name: "",
	            Filter: {
	                FilterType:"MachineFilter",
	                EnvironmentIds:[],
	                Roles:[],
	                EventGroups:[],
	                EventCategories:[]
	            },
	            Action: {
	                ActionType:"AutoDeploy",
	                ShouldRedeployWhenMachineHasBeenDeployedTo:false
	            }
	        };
	    }
	    $scope.actions = [];
	    $scope.isMultiTenancyEnabled = false;
	    $scope.teamSensitiveValues = { EnvironmentIds: [] };
	    $scope.selectedFilters = {
	        eventGroups: [],
	        eventCategories: [],
	        selectedEventGroupCategories: [],
	        roles: [],
	        environments: []
	    };
	    var unavailableEnvironments = [];
	
	    function init() {
	        var promises = [];
	
	        promises.push(projectState.load().then(function (project) {
	            $scope.project = project;
	        }));
	
	        promises.push(octopusRepository.MachineRoles.all().then(function (machineRoles) {
	            $scope.roles = [];
	            _.each(machineRoles, function (role) {
	                $scope.roles.push({"Id":role, "Name":role});
	            });
	        }));
	
	        promises.push(octopusRepository.Environments.all().then(function (environments) {
	            $scope.environments = environments;
	        }));
	
	        promises.push(octopusRepository.Events.categories({appliesTo: "Machine"}).then(function (eventCategories) {
	            $scope.eventCategories = eventCategories;
	        }));
	
	        promises.push(octopusRepository.Events.groups({appliesTo: "Machine"}).then(function (eventGroups) {
	            $scope.eventGroups = eventGroups;
	        }));
	
	        isLoading.promises(promises).then(function(){
	            if (triggerId) {
	                isLoading.promise(octopusRepository.ProjectTriggers.get(triggerId)).then(function(projectTrigger) {
	                    $scope.projectTrigger = projectTrigger;
	
	                    $scope.selectedFilters.eventGroups = projectTrigger.Filter.EventGroups;
	                    $scope.selectedFilters.eventCategories = projectTrigger.Filter.EventCategories;
	                    $scope.selectedFilters.roles = projectTrigger.Filter.Roles;
	
	                    var projectTriggerEnvironmentIds = projectTrigger.Filter.EnvironmentIds;
	
	                    $scope.selectedFilters.environments = $scope.environments.filter(function(m){ return projectTriggerEnvironmentIds.indexOf(m.Id) !== -1; }).map(function(e){return e.Id;});
	                    unavailableEnvironments = projectTriggerEnvironmentIds.filter(function(tid) { return $scope.selectedFilters.environments.indexOf(tid) === -1; });
	                });
	            }
	        });
	    }
	
	    $scope.save = function() {
	        $scope.projectTrigger.ProjectId = $scope.project.Id;
	        $scope.projectTrigger.Filter.EnvironmentIds = ([].concat(unavailableEnvironments).concat($scope.selectedFilters.environments));
	        $scope.projectTrigger.Filter.EventGroups = $scope.selectedFilters.eventGroups;
	        $scope.projectTrigger.Filter.EventCategories = $scope.selectedFilters.eventCategories;
	        $scope.projectTrigger.Filter.Roles = $scope.selectedFilters.roles;
	
	        isSaving.promise(octopusRepository.ProjectTriggers.save($scope.projectTrigger).then(function() {
	            unsavedChanges.saved();
	            $location.path('/projects/' + $scope.project.Slug + '/triggers');
	        }));
	    };
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 572 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.directive('projectTriggerEditor', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/projects/triggers/trigger_editor.html'
	  };
	});

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectTriggersController', function ($scope, $stateParams, busy, pageTitle, projectState, octopusRepository, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var projectId = $stateParams.projectId;
	
	    var loadTriggers = function(){
	        var promises = [];
	
	        promises.push(octopusRepository.Projects.getTriggers($scope.project));
	
	        promises.push(octopusRepository.Events.categories({appliesTo: "Machine"}));
	
	        promises.push(octopusRepository.Environments.all());
	
	        promises.push(octopusRepository.Events.groups({appliesTo: "Machine"}));
	
	        isLoading.promises(promises).then(function(results){
	
	            var triggers = results[0];
	            var eventCategories = results[1];
	            var environments = results[2];
	            var eventGroups = results[3];
	
	            _.each(triggers.Items, function (trigger) {
	                trigger.environment = getTags(trigger.Filter.EnvironmentIds, environments);
	
	                var selectedEventGroups = trigger.Filter.EventGroups || [];
	
	                var selectedEventGroupCategories = getEventCategoriesForEventGroups(selectedEventGroups, eventGroups, eventCategories);
	                var selectedEventCategories = trigger.Filter.EventCategories || [];
	
	
	                var allSelectedEventCategories = _.union(selectedEventGroupCategories, selectedEventCategories);
	
	                trigger.events = getTags(allSelectedEventCategories, eventCategories);
	                trigger.roles = trigger.Filter.Roles ? trigger.Filter.Roles.join(',') : [];
	            });
	            $scope.triggers = triggers;
	        });
	    };
	
	    function getEventCategoriesForEventGroups(selectedEventGroups, allEventGroups, allEventCategories) {
	        if (selectedEventGroups.length > 0) {
	            var selectedGroups = _.filter(allEventGroups, function (eventGroup) {
	                return selectedEventGroups.indexOf(eventGroup.Id) > -1;
	            });
	            var selectedEventCategoryIds = _.flatten(_.map(selectedGroups, function (selectedGroup) {
	                return selectedGroup.EventCategories;
	            }));
	            return selectedEventCategoryIds;
	        } else {
	            return [];
	        }
	    }
	
	    isLoading.promise(projectState.load().then(function (project) {
	        isLoading.promise(octopusRepository.Projects.getChannels(project).then(function (channels) {
	            isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {
	                pageTitle(project.Name + " triggers");
	
	                $scope.project = project;
	                $scope.actionsByName = {};
	                $scope.deploymentProcess = deploymentProcess;
	
	                var actions = _.chain(deploymentProcess.Steps).map(function(step){ return step.Actions; }).flatten().value();
	                $scope.actionsByName = _.object(_.pluck(actions, "Name"), actions);
	
	                // ARC-related scope variables.
	                $scope.channels = channels;
	                $scope.builtInFeedPackageActions = _.filter(
	                _.flatten(
	                    _.map(deploymentProcess.Steps,
	                    function (s) {
	                        return s.Actions;
	                    })
	                ),
	                function (a) {
	                    return a.Properties["Octopus.Action.Package.FeedId"] === 'feeds-builtin';
	                });
	
	                // Initialise this here so people can disable ARC and save
	                $scope.showAutomaticReleaseCreation = $scope.builtInFeedPackageActions.length > 0 || project.AutoCreateRelease === true;
	
	                loadTriggers();
	            }));
	        }));
	    }));
	
	    // ARC
	    $scope.changeReleaseCreation = function () {
	        if(!$scope.builtInFeedPackageActions) {
	            $scope.project.AutoCreateRelease = false;
	        }
	        if(!$scope.builtInFeedPackageActions || !$scope.project.AutoCreateRelease) {
	            $scope.project.ReleaseCreationStrategy.ReleaseCreationPackageStepId = null;
	            $scope.project.ReleaseCreationStrategy.ChannelId = null;
	        }
	        if ($scope.project.AutoCreateRelease && $scope.channels.Items.length === 1) {
	            $scope.project.ReleaseCreationStrategy.ChannelId = $scope.channels.Items[0].Id;
	        }
	        isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function (p) {
	            unsavedChanges.saved();
	        }));
	    };
	
	    var getTags = function(selectedOptions, allOptions) {
	        if (!selectedOptions || selectedOptions.length === 0 || allOptions.length === 0) {
	            return "";
	        }
	
	        var result = [];
	        _.each(allOptions, function (e) {
	            if (_.contains(selectedOptions, e.Id)) {
	                result.push(e.Name);
	            }
	        });
	        return result.join(",");
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 574 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	
	module.controller('ProjectVariablesController', function($scope, $timeout, busy, projectState, pageTitle, octopusRepository,
	                                                         $location, unsavedChanges, octopusPermissionSet, scopeValuesToScopeOptionsConverter) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var projectId = projectState.projectId;
	
	    $scope.canSave = false;
	    $scope.canSaveProject = false;
	
	    $scope.save = function() {
	        if ($scope.canSaveProject) {
	            octopusRepository.Projects.modify($scope.project).then(function(modified) {
	                $scope.canSaveProject = false;
	                if ($scope.canSave) {
	                    $scope.$broadcast("variableEditor:applyChanges", $scope.variableSet);
	                } else {
	                    unsavedChanges.saved();
	                }
	            });
	        } else {
	            $scope.$broadcast("variableEditor:applyChanges", $scope.variableSet);
	        }
	    };
	    $scope.$on("variableEditor:changesApplied", function(e, vs) {
	        isSaving.promise(octopusRepository.Variables.modify(vs).then(function() {
	            unsavedChanges.saved();
	            load();
	        }));
	    });
	
	    $scope.$on("variableEditor:dirty", function(e, vs) {
	        $scope.canSave = true;
	        unsavedChanges.unsaved();
	    });
	
	    $scope.$on("variableEditor:clean", function(e, vs) {
	        $scope.canSave = false;
	        unsavedChanges.saved();
	    });
	
	    var load = function() {
	        isLoading.promise(projectState.load().then(function(project) {
	            pageTitle(project.Name + " variables");
	
	            octopusRepository.LibraryVariableSets.all({ids: project.IncludedLibraryVariableSetIds, contentType: 'Variables'}).then(function (libraryVariableSets) {
	            $scope.libraryVariableSetCount = libraryVariableSets.length;
	        });
	
	            $scope.project = project;
	
	            isLoading.promise(octopusPermissionSet.isAuthorized({
	                permission: 'VariableEdit',
	                projectId: project.Id,
	                environmentId: '*'
	            }).then(function(yn) {
	                isLoading.promise(octopusRepository.Variables.get(project.VariableSetId).then(function(variableSet) {
	                    $scope.variableSet = variableSet;
	
	                    $scope.variableEditorOptions = {
	                        variableSet: variableSet,
	                        scopeOptions: scopeValuesToScopeOptionsConverter(variableSet.ScopeValues),
	                        canEdit: yn,
	                        canScopeToTenantTags: project.TenantedDeploymentMode !== 'Untenanted'
	                    };
	
	                    delayVariableEditor();
	                }));
	            }));
	        }));
	    };
	
	    function delayVariableEditor() {
	        $timeout(function() {
	            $scope.showVariableEditor = true;
	        }, 100);
	    }
	
	    load();
	});


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	
	module.controller('ProjectVariablesAllController', function ($scope, $timeout, pageTitle, busy, projectState, octopusRepository,
	                                                             $q, $uibModal, scopeValuesToScopeOptionsConverter) {
	    var isLoading = $scope.isLoading = busy.create();
	    var projectId = projectState.projectId;
	    $scope.isSaving = busy.create();
	
	    var stateOk = {icon: "check", class: "text-success", title: "A value is set for this variable"};
	
	    function init() {
	        isLoading.promise(
	            loadProject()
	                .then(getAndTransformVariablesAndTemplates)
	            .then(function (result) {
	
	                $scope.variableEditorOptions = {
	                    variableSet: result,
	                    scopeOptions: scopeValuesToScopeOptionsConverter(result.ScopeValues),
	                    canEdit: false,
	                    showSourceColumn: true,
	                    disableContextMenu: true
	                };
	
	                $timeout(function () {
	                    $scope.showVariableEditor = true;
	                }, 100);
	
	            })
	    );
	    }
	
	    function loadProject() {
	        return projectState.load()
	        .then(function (project) {
	            pageTitle("All " + project.Name + " variables");
	            $scope.project = project;
	            return project;
	        });
	    }
	
	    function getAndTransformVariablesAndTemplates(project) {
	
	        var projectVariablesSetP = octopusRepository.Variables.get(project.VariableSetId);
	        var libraryP = getLibrarySetVariablesAndTemplates(project);
	        var tenantsP = octopusRepository.Tenants ? octopusRepository.Tenants.all({projectId: project.Id}) : $q.resolve([]);
	        var tenantVariablesP = octopusRepository.TenantVariables ? octopusRepository.TenantVariables.all({projectId: project.Id}) : $q.resolve([]);
	        return $q.all([projectVariablesSetP, libraryP, tenantsP, tenantVariablesP])
	        .then(function (results) {
	            var projectVariableSet = results[0];
	            var library = results[1];
	            var tenants = results[2];
	            var tenantVariables = toHash(results[3], "TenantId");
	
	            var tenantProjectTemplateVariables = mapProjectTemplateVariables(project, tenants, tenantVariables);
	            var tenantLibrarySetTemplateVariables = mapLibraryTemplateVariables(library.templates, tenants, tenantVariables);
	
	            var projectVariables = mapVariableSets(projectVariableSet, "/projects/" + project.Slug + "/variables", project.Name);
	            var scopeValues = _.extend(
	                {Tenants: tenants},
	                library.scopeValues,
	                projectVariableSet.ScopeValues
	            );
	
	            return {
	                ScopeValues: scopeValues,
	                Variables: projectVariables
	                    .concat(library.variables)
	                    .concat(tenantProjectTemplateVariables)
	                    .concat(tenantLibrarySetTemplateVariables)
	            };
	        });
	    }
	
	    function mapVariableSets(variableSet, sourceLink, sourceName) {
	        return variableSet.Variables.map(function (variable) {
	            return _.extend({
	                State: stateOk,
	                Source: {link: sourceLink, name: sourceName}
	            }, variable);
	        });
	    }
	
	    var getLibrarySetVariablesAndTemplates = function (project) {
	        var mapLibrarySets = function (libraryVariableSets) {
	            $scope.libraryVariableSetCount = 0;
	            var variablePromises = libraryVariableSets.map(function (libraryVariableSet) {
	
	                if(libraryVariableSet.ContentType === 'Variables') {
	                    $scope.libraryVariableSetCount++;
	                }
	
	                return octopusRepository.Variables.get(libraryVariableSet.VariableSetId)
	                    .then(function (variableSet) {
	                        return {
	                            scopeValues: variableSet.scopeValues,
	                            variables: mapVariableSets(variableSet, "/library/variables/" + libraryVariableSet.Id, libraryVariableSet.Name)
	                        };
	                    });
	            });
	
	
	
	            var templates = _.pluck(libraryVariableSets, "Templates");
	
	            return $q.all(variablePromises)
	                .then(function (results) {
	                    return {
	                        templates: _.flatten(templates),
	                        variables: _.flatten(_.pluck(results, "variables")),
	                        scopeValues: results.reduce(function (a, b) {
	                            return _.extend(a, b);
	                        }, {})
	                    };
	                });
	        };
	        var loadingPromise = octopusRepository.LibraryVariableSets.all({ids: project.IncludedLibraryVariableSetIds});
	        return loadingPromise.then(mapLibrarySets);
	    };
	
	    function mapProjectTemplateVariables(project, tenants, tenantVariables) {
	        var getTenantsValue = function (tenant, template, environmentId) {
	            var variablesForTenant = tenantVariables[tenant.Id];
	            if (!variablesForTenant ||
	                !variablesForTenant.ProjectVariables[project.Id] ||
	                !variablesForTenant.ProjectVariables[project.Id].Variables[environmentId]) {
	                return;
	            }
	            return variablesForTenant.ProjectVariables[project.Id].Variables[environmentId][template.Id];
	        };
	
	        var results = project.Templates.map(function (template) {
	            return tenants.map(function (tenant) {
	                var projectEnvironments = tenant.ProjectEnvironments[project.Id] || [];
	
	                return projectEnvironments.map(function (environmentId) {
	                    var value = getTenantsValue(tenant, template, environmentId)
	                        || template.DefaultValue;
	
	                    return {
	                        State: value ? stateOk : {
	                            icon: "warning",
	                            class: "text-warning",
	                            title: "This variable is missing for this tenant and environment"
	                        },
	                        Name: template.Name,
	                        Id: template.Id + tenant.Id + environmentId,
	                        Value: value,
	                        IsSensitive: isSensitive(template, value),
	                        Scope: {Tenant: [tenant.Id], Environment: [environmentId]},
	                        Source: {link: "/tenants/" + tenant.Id + "/variables/projects", name: tenant.Name}
	                    };
	                });
	            });
	        });
	        return _.flatten(results);
	    }
	
	    function mapLibraryTemplateVariables(libraryTemplates, tenants, tenantVariables) {
	        if (!libraryTemplates) {
	            return [];
	        }
	
	        var getTenantsValue = function (tenant, template) {
	            var variablesForTenant = tenantVariables[tenant.Id];
	            if (!variablesForTenant){
	                return null;
	            }
	
	            for (var libVsId in variablesForTenant.LibraryVariables) {
	                if (Object.keys(variablesForTenant.LibraryVariables[libVsId].Variables).indexOf(template.Id) !== -1) {
	                    return variablesForTenant.LibraryVariables[libVsId].Variables[template.Id];
	                }
	            }
	
	            return null;
	        };
	
	        var results = libraryTemplates.map(function (template) {
	            return tenants.map(function (tenant) {
	                var value = getTenantsValue(tenant, template) || template.DefaultValue;
	                return {
	                    State: value ? stateOk : {
	                        icon: "warning",
	                        class: "text-warning",
	                        title: "This variable is missing for this tenant"
	                    },
	                    Name: template.Name,
	                    Id: template.Id + tenant.Id,
	                    Value: value,
	                    Scope: {Tenant: [tenant.Id]},
	                    IsSensitive: isSensitive(template, value),
	                    Source: {link: "/tenants/" + tenant.Id + "/variables", name: tenant.Name}
	                };
	            });
	        });
	        return _.flatten(results);
	    }
	
	    function isSensitive(template, value) {
	        return template.DisplaySettings["Octopus.ControlType"] === "Sensitive" && !!value && value.HasValue ;
	    }
	
	    function toHash(array, keyName, valueName) {
	        var values = valueName ? _.pluck(array, valueName) : array;
	        return _.object(_.pluck(array, keyName), values);
	    }
	
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectVariableCommonTemplatesController', function($scope, busy, pageTitle, projectState, octopusRepository) {
	    var isLoading = $scope.isLoading = busy.create();
	
	    isLoading.promise(projectState.load().then(function(project) {
	        $scope.project = project;
	        pageTitle(project.Name + ' Common Variable Templates');
	
	        isLoading.promise(octopusRepository.LibraryVariableSets.all({ids: project.IncludedLibraryVariableSetIds}).then(function(lvs) {
	            $scope.libraryVariableSets = _.filter(lvs, function (x) {
	                return x.Templates.length > 0;
	            });
	        }));
	    }));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectVariablesLibraryController', function ($scope, $timeout, busy, projectState, pageTitle, octopusRepository, $location, unsavedChanges, $uibModal) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.configureLibraryVariableSets = configureLibraryVariableSets;
	    $scope.save = save;
	
	    function init() {
	        $scope.showRemovedVariableSetWarning = false;
	        isLoading.promise(projectState.load().then(function (project) {
	            pageTitle(project.Name + " variables");
	            $scope.project = project;
	            updateIncludedSets();
	        }));
	    }
	
	    function save() {
	        isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function () {
	            unsavedChanges.saved();
	            init();
	        }));
	    }
	
	    function updateIncludedSets() {
	        isLoading.promise(octopusRepository.LibraryVariableSets.all({ids: $scope.project.IncludedLibraryVariableSetIds, contentType: 'Variables'}).then(function (libraryVariableSets) {
	            $scope.includedSets = libraryVariableSets;
	            $scope.libraryVariableSetCount = libraryVariableSets.length;
	        }));
	    }
	
	    function configureLibraryVariableSets() {
	
	        var originalVariableSetIds = $scope.project.IncludedLibraryVariableSetIds;
	
	        $uibModal.open({
	            backdrop: true,
	            keyboard: true,
	            templateUrl: 'areas/projects/views/include_variables_dialog.html',
	            controller: 'ProjectVariablesIncludeController',
	            resolve: {
	                current: function () {
	                    return _.toArray($scope.project.IncludedLibraryVariableSetIds);
	                },
	                contentType: function () {
	                    return 'Variables';
	                },
	                contentTypeDesc: function () {
	                    return 'Variable Set';
	                }
	            }
	        }).result.then(function (result) {
	            if (result) {
	                if (!_.isEqual(result, $scope.project.IncludedLibraryVariableSetIds)) {
	
	                    var variableSetsIdsRemoved = _.difference(originalVariableSetIds, result);
	                    $scope.showRemovedVariableSetWarning = variableSetsIdsRemoved.length > 0;
	
	                    $scope.project.IncludedLibraryVariableSetIds = _.toArray(result);
	                    unsavedChanges.unsaved();
	                    return updateIncludedSets();
	                }
	            }
	        });
	    }
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 578 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.config(function($stateProvider) {
	
	    $stateProvider.state('app.project.variables', {
	        url: '/variables',
	        templateUrl: 'areas/projects/variables/layout.html',
	        layout: {
	            projectTab: 'variables'
	        },
	        defaultSubRoute: 'app.project.variables.project'
	    });
	
	
	    $stateProvider.state('app.project.variables.project', {
	        url: '/project',
	        templateUrl: 'areas/projects/variables/project_variables.html',
	        controller: 'ProjectVariablesController',
	        layout: {
	            variableTab: 'variables'
	        }
	    });
	
	
	    $stateProvider.state('app.project.variables.projectvariabletemplates', {
	        url: '/projectvariabletemplates',
	        templateUrl: 'areas/projects/variables/project_variables_templates.html',
	        controller: 'ProjectVariableTemplatesController',
	        layout: {
	            variableTab: 'projectvariabletemplates'
	        }
	    });
	
	
	    $stateProvider.state('app.project.variables.commonvariabletemplates', {
	        url: '/commonvariabletemplates',
	        templateUrl: 'areas/projects/variables/project_variables_common_templates.html',
	        controller: 'ProjectVariableCommonTemplatesController',
	        layout: {
	            variableTab: 'commonvariabletemplates'
	        }
	    });
	
	
	    $stateProvider.state('app.project.variables.libraryvariabletemplates', {
	        url: '/library',
	        templateUrl: 'areas/projects/variables/project_variables_library.html',
	        controller: 'ProjectVariablesLibraryController',
	        layout: {
	            variableTab: 'library'
	        }
	    });
	
	
	    $stateProvider.state('app.project.variables.all', {
	        url: '/all',
	        templateUrl: 'areas/projects/variables/project_variables_all.html',
	        controller: 'ProjectVariablesAllController',
	        layout: {
	            variableTab: 'all'
	        }
	    });
	});

/***/ },
/* 579 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.projects');
	
	module.controller('ProjectVariableTemplatesController', function($scope, busy, pageTitle, projectState, octopusRepository, octopusPermissionSet, templateParameterModal, unsavedChanges) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	    var projectId = projectState.projectId;
	    $scope.unsavedChanges = unsavedChanges;
	    $scope.templateEditor = null;
	
	    var load = function()
	    {
	        isLoading.promise(projectState.load().then(function(project) {
	            pageTitle(project.Name + ' Variable Templates');
	            $scope.templateEditor = templateParameterModal.create(project.Templates, { name: 'Project Variable Template', isTemplate: true, requiredPermission: 'VariableEdit', projectId: project.Id });
	
	            isLoading.promise(octopusPermissionSet.isAuthorized({ permission: 'VariableEdit', projectId: project.Id, environmentId: '*' }).then(function(yn){
	                $scope.project = project;
	
	                $scope.save = function() {
	                    isSaving.promise(octopusRepository.Projects.get(projectId).then(function(project) {
	                        project.Templates = $scope.project.Templates;
	                        return octopusRepository.Variables.modify($scope.project).then(function() {
	                            unsavedChanges.saved();
	                            load();
	                        });
	                    }));
	                };
	            }));
	        }));
	    };
	
	    load();
	});

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.controller('ExportEntityDialogController', function($scope, $uibModalInstance, entity, entityType, $rootScope){
	
	  // _Shallow_ clone.
	  var cloned = _.clone(entity);
	
	  cloned = _.omit(cloned, 'Links');
	
	  cloned.$Meta = { ExportedAt: new Date(), OctopusVersion: $rootScope.octopusVersion, Type: entityType };
	
	  $scope.entityJson = JSON.stringify(cloned, null, 2);
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.controller('ImportEntityDialogController', function($scope, $uibModalInstance, busy, $q, entityType, doImport){
	  var isSaving = $scope.isSaving = busy.create();
	
	  $scope.entityJson = '';
	
	  $scope.save = function() {
	    var entity;
	
	    try {
	      entity = JSON.parse($scope.entityJson);
	      if (!entity || !entity.$Meta || entity.$Meta.Type !== entityType) {
	        throw new Error("The data is not a valid " + entityType + ".");
	      }
	      entity = _.omit(entity, ['Id', '$Meta']);
	    } catch (e) {
	      isSaving.showError(e.message || e);
	      return;
	    }
	
	    isSaving.promise(doImport(entity).then(function(){
	      $uibModalInstance.close();
	    }));
	  };
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.controller('TemplateParameterEditController', function ($scope, busy, $uibModalInstance, title, parameter, invalidStepTypes, names, requiredPermission, projectId) {
	    var isSaving = $scope.isSaving = busy.create();
	    $scope.title = title;
	    $scope.parameter = parameter;
	    $scope.invalidStepTypes = invalidStepTypes;
	    $scope.requiredPermission = requiredPermission;
	    $scope.projectId = projectId;
	
	    $scope.controlTypes = {
	        "SingleLineText": "Single-line text box",
	        "MultiLineText": "Multi-line text box",
	        "Select": "Drop down",
	        "Checkbox": "Checkbox",
	        "Sensitive": "Sensitive/password box",
	        "StepName": "A previous deployment step name",
	        "AzureAccount": "Azure Account"
	    };
	    
	    if (!$scope.parameter.DisplaySettings) {
	        $scope.parameter.DisplaySettings = {};
	        $scope.parameter.DisplaySettings['Octopus.ControlType'] = 'SingleLineText';
	    }
	
	    $scope.close = function () {
	        if (!parameter.Name || parameter.Name === '') {
	            isSaving.showError('Please provide a variable name for the parameter.');
	            return;
	        }
	        if (_.contains(names, parameter.Name)) {
	            isSaving.showError('This parameter variable name is already in use. Please provide a unique name.');
	            return;
	        }
	        $uibModalInstance.close(parameter);
	    };
	
	    $scope.cancel = function () {
	        $uibModalInstance.close();
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 583 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('alerts', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      list: '='
	    },
	    templateUrl: 'areas/shared/views/alerts.html',
	    link: function (scope, element, attrs) {
	    },
	    controller: function($scope, octopusRepository) {
	
	    }
	  };
	});


/***/ },
/* 584 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('artifactListing', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      artifacts: '='
	    },
	    templateUrl: 'areas/shared/views/artifact-listing.html',
	    link: function (scope, element, attrs) {
	    },
	    controller: function($scope, octopusRepository) {
	      $scope.formatDownload = function(artifact) {
	        return octopusRepository.resolve(artifact.Links["Content"]);
	      };
	    }
	  };
	});


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var module = angular.module('octopusApp.shared');
	var avatarPlaceHolder = __webpack_require__(1275);
	
	module.directive('avatar', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      model: '=',
	      size: '@'
	    },
	    template: '<div style="background-image: url(\'' + avatarPlaceHolder + '\'); background-size: 100%; width: 100%; height: 100%;">' +
	                '<div ng-style="avatarStyle"></div>' +
	              '</div>',
	    link: function(scope, element, attrs) {
	      scope.avatarStyle = { };
	
	      var getStyle = function(addr, size) {
	        if (!addr) {
	          return { };
	        }
	
	        var suf = '';
	        if (size) {
	          suf = '&s=' + size;
	        }
	
	        var url = addr + suf;
	        return {
	          'background-image': 'url(\'' + url + '\')',
	          'background-size': '100%',
	          'width': '100%',
	          'height': '100%'
	        };
	      };
	
	      var update = function () {
	        if (scope.model) {
	          if (scope.model.IsService) {
	            scope.avatarStyle = getStyle('img/users/octopus-service-440.png', scope.size);
	          } else if (scope.model.Links && scope.model.Links.Avatar) {
	            scope.avatarStyle = getStyle(scope.model.Links.Avatar, scope.size);
	          }
	        }
	      };
	
	      scope.$watch("model.Links.Avatar", update);
	      scope.$watch("model.IsService", update);
	
	      update();
	    }
	  };
	});
	
	
	
	


/***/ },
/* 586 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('csvSplitFormatter', function() {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, element, attr, ngModel) {
	            var fromCsv = function(text) {
	                if(text && text !== ''){
	                    return text.split(',');
	                }
	                return [];
	            };
	            var toCsv = function(data) {
	                return (data || []).join(',');
	            };
	            ngModel.$parsers.push(toCsv);
	            ngModel.$formatters.push(fromCsv);
	        }
	    };
	});

/***/ },
/* 587 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('deleteButton', function (octoDialog, octopusClient, unsavedChanges, $location) {
	  return {
	    restrict: 'E',
	    replace: false,
	    scope: {
	      model: '=',
	      what: '@',
	      redirect: "@"
	    },
	    template: '<a class="delete-button btn" href="" title="Delete" ng-show="canDelete" ng-click="deleteItem()">Delete</a>',
	    link: function(scope, element, attr) {
	      scope.$watch("model", function () {
	        scope.canDelete = (scope.model && scope.model.Links && scope.model.Links.Self);
	      });
	
	      scope.deleteItem = function () {
	        var dlg = octoDialog.confirmDelete(scope.what, function() {
	          return octopusClient.del(scope.model.Links.Self);
	        });
	        dlg.then(function(result) {
	          if (result) {
	            unsavedChanges.saved();
	            $location.path(scope.redirect);
	          }
	        });
	      };
	    }
	  };
	});
	


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.directive('deploymentListing', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      deployments: '=',
	      prefix: '@'
	    },
	    templateUrl: 'areas/shared/views/deployment-listing.html',
	    controller: function($scope, octopusRepository, $q) {
	
	      $scope.tasks = { };
	      $scope.projects = { };
	      $scope.releases = { };
	
	      var completedTasks = {};
	
	      var update = function() {
	        if (!$scope.deployments) {
	          return;
	        }
	
	        // We always want to refresh running tasks, but completed tasks can be cached
	        var tasks = { };
	        _.each(completedTasks, function (a,k) {
	          tasks[k] = a;
	        });
	
	        var promises = [];
	
	        _.each($scope.deployments.Items, function(dep) {
	          if (!tasks[dep.TaskId]) {
	            promises.push(octopusRepository.Tasks.get(dep.TaskId).then(function(task) {
	              tasks[dep.TaskId] = task;
	              if (task.IsCompleted) {
	                // Cache the completed task for later
	                completedTasks[dep.TaskId] = task;
	              }
	            }));
	          }
	          if (!$scope.projects[dep.ProjectId]) {
	            promises.push(octopusRepository.Projects.get(dep.ProjectId).then(function(project) {
	              $scope.projects[dep.ProjectId] = project;
	            }));
	          }
	          if (!$scope.releases[dep.ReleaseId]) {
	            promises.push(octopusRepository.Releases.get(dep.ReleaseId).then(function(release) {
	              $scope.releases[dep.ReleaseId] = release;
	            }));
	          }
	        });
	
	        $q.all(promises).then(function () {
	          $scope.tasks = tasks;
	        });
	      };
	
	      $scope.$watch('deployments.Items', update);
	
	      update();
	    }
	  };
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 589 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('emailAddressesInput', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      model: '='
	    },
	    template: '<input type="text" class="form-control" ng-model="model" placeholder="Separate multiple email addresses with semicolons or commas" />'
	  };
	});
	


/***/ },
/* 590 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('eventListing', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      events: '='
	    },
	    templateUrl: 'areas/shared/views/event-listing.html',
	    link: function (scope, element, attrs) {
	    },
	    controller: function($scope, eventFormatter) {
	      $scope.skip = 0;
	      $scope.formatMessageHtml = eventFormatter.format;
	    }
	  };
	});
	


/***/ },
/* 591 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('helpBlock', function (helpManager) {
	  return {
	    restrict: 'C',
	    link: function(scope, element, attrs) {
	
	    }
	  };
	});
	
	
	


/***/ },
/* 592 */
/***/ function(module, exports) {

	/**
	 * Fix for IE select menus getting stuck when their underlying list changes.
	 * Original code: http://kkurni.blogspot.com.au/2013/10/angularjs-ng-option-with-ie8.html
	 *
	 * Set the `ie-select-fix` attribute to the model expression that should trigger the list to re-render.
	 *
	 * @example <select ng-model="modelValue" ie-select-fix="itemList" ng-options="item.label for item in itemList">
	 */
	var module = angular.module('octopusApp.shared');
	
	module.directive('ieSelectFix', ['$document',
	  function($document) {
	
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function(scope, element, attributes) {
	        var ua = window.navigator.userAgent;
	        var isIE = ua.indexOf('Trident') !== -1 || ua.indexOf('Edge') !== -1;
	        if (!isIE) {
	          return;
	        }
	
	        var control = element[0];
	        scope.$watch(attributes.ieSelectFix, function() {
	
	          setTimeout(function() {
	            //this will add and remove an option to trigger the rendering in IE8
	            var option = document.createElement("option");
	            control.add(option, null);
	            control.remove(control.options.length - 1);
	          }, 0);
	
	        });
	      }
	    };
	  }
	]);

/***/ },
/* 593 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('interruptionField', function($compile, $templateCache) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      element: '=',
	      submit: '=',
	      isDisabled: '='
	    },
	    link: function(scope, element) {
	
	      scope.changed = function() {
	        scope.$emit("interruptionField:changed", scope.element);
	      };
	
	      scope.$watch('element', function() {
	        if (!scope.element) {
	          return;
	        }
	
	        var templateName = scope.element.type;
	        var template = $templateCache.get('areas/shared/views/interrupt-fields/interrupt_' + templateName + '.html');
	        if (!template) {
	          template = $templateCache.get('areas/shared/views/interrupt-fields/interrupt_Unknown.html');
	        }
	
	        element.html('');
	        element.html($compile(template)(scope));
	      });
	    }
	  };
	});


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.directive('interruptionForm', function (octoDialog) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      interruptions: '=',
	      submitted: '=',
	      takeResponsibility: '=',
	      isSubmitting: '=',
	      correlateLog: '='
	    },
	    templateUrl: 'areas/shared/views/interruption-form.html',
	    link: function ($scope, element, attrs) {
	      $scope.interruptionsModel = new Octopus.Model.SynchronizedList({
	        sourceToTargetTransformer: function (a) {
	          var instance = {};
	          instance.title = a.Title;
	          instance.elements = [];
	          instance.value = null;
	          instance.isPending = a.IsPending;
	          instance.isMine = a.HasResponsibility;
	          instance.isUnassigned = !instance.isMine && !a.ResponsibleUserId;
	          instance.isAssignedToSomeoneElse = !instance.isMine && a.ResponsibleUserId;
	          instance.couldBeMine = a.CanTakeResponsibility;
	          instance.original = a;
	          instance.responsibleUserId = a.ResponsibleUserId;
	          instance.correlationId = a.CorrelationId;
	          instance.isOpen = instance.isMine;
	          instance.toggleOpen = function() {
	            instance.isOpen = !instance.isOpen;
	          };
	
	          _.each(a.Form.Elements, function(element) {
	            instance.elements.push({
	              label: element.Name,
	              name: element.Name,
	              type: element.Control.Type,
	              interrupt: instance,
	              required: element.IsValueRequired,
	              properties: element.Control
	            });
	          });
	
	          return instance;
	        },
	        refresh: function(instance, a) {
	          instance.isPending = a.IsPending;
	          instance.isMine = a.HasResponsibility;
	          instance.isUnassigned = !instance.isMine && !a.ResponsibleUserId;
	          instance.isAssignedToSomeoneElse = !instance.isMine && a.ResponsibleUserId;
	          instance.couldBeMine = a.CanTakeResponsibility;
	          instance.responsibleUserId = a.ResponsibleUserId;
	          instance.original = a;
	          if (instance.isMine) {
	            instance.isOpen = true;
	          }
	        },
	        sourceKey: function (a) {
	          return a.Id;
	        },
	        onAdded: function(a) { },
	        onRemoved: function(a) { }
	      });
	
	      $scope.$watch('interruptions', function () {
	        $scope.interruptionsModel.sync($scope.interruptions);
	      });
	
	      $scope.submit = function(submittingElement, value) {
	        var result = {};
	        _.each(submittingElement.interrupt.elements, function (element) {
	          result[element.name] = element.value;
	          if (!result[element.name]) {
	            result[element.name] = '';
	          }
	        });
	
	        result[submittingElement.name] = value;
	
	        $scope.submitted(submittingElement.interrupt.original, result);
	      };
	
	      $scope.confirmTakeResponsibility = function(interrupt) {
	
	        octoDialog.messageBox(
	            "Confirm re-assignment",
	            "Someone else is already assigned to this interruption. Are you sure you wish to assign it to yourself?",
	            [{
	              result: 'yes',
	              label: 'Yes',
	              cssClass: 'btn-success'
	            }, {
	              result: 'cancel',
	              label: 'Cancel'
	            }]).then(function (result) {
	              if (result === 'yes') {
	                $scope.takeResponsibility(interrupt);
	              }
	            });
	      };
	    }
	  };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 595 */
/***/ function(module, exports) {

	angular.module('octopusApp.shared')
	    .directive("noDirtyCheck", function noDirtyCheck() {
	        return {
	            restrict: 'A',
	            require: 'ngModel',
	            link: function (scope, elem, attrs, ctrl) {
	                var alwaysFalse = {
	                    get: function () {
	                        return false;
	                    },
	                    set: function () {
	                    }
	                };
	                Object.defineProperty(ctrl, '$pristine', alwaysFalse);
	                Object.defineProperty(ctrl, '$dirty', alwaysFalse);
	            }
	        };
	    });


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.directive('octoForm', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      form: '=',
	      submitted: '=',
	      isSubmitting: '=',
	      isFormDisabled: '='
	    },
	    templateUrl: 'areas/shared/views/octo-form.html',
	    link: function (scope, element, attrs) {
	      scope.formElements = [];
	
	      scope.$watch('form', function () {
	        scope.formElements = [];
	
	        if (!scope.form || !scope.form.Elements) {
	          return;
	        }
	
	        _.each(scope.form.Elements, function(element) {
	          scope.formElements.push({
	            label: element.Name,
	            name: element.Name,
	            type: element.Control.Type,
	            required: element.IsValueRequired,
	            properties: element.Control,
	            value: scope.form.Values[element.Name]
	          });
	        });
	      });
	
	      scope.$on("interruptionField:changed", function () {
	        var result = {};
	        _.each(scope.formElements, function (el) {
	          result[el.name] = el.value;
	          if (!result[el.name]) {
	            result[el.name] = '';
	          }
	        });
	
	        scope.form.Values = result;
	      });
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.directive('scriptEditor', function($timeout) {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      id: '@',
	      body: '=',
	      syntax: '=',
	      syntaxFilter: '=',
	      syntaxSelectionDisabled: '=',
	      projectId: '=',
	      machinePolicyId: '=',
	      localNames: '=',
	      noVariables: '='
	    },
	    templateUrl: 'areas/shared/views/script_editor.html',
	    link: {
	      pre: function($scope) {
	        $scope.editor = null;
	
	        $scope.allSyntaxes = [ 
	          { id: 'PowerShell', display:'PowerShell', aceMode:'powershell'},
	          { id: 'CSharp', display: 'C#', aceMode:'csharp'},
	          { id: 'Bash', display: 'Bash', aceMode:'sh'},
	          //FSharp mode is still work in progress: https://github.com/ajaxorg/ace/issues/2871 but because F# is based on Ocaml so we can use it instead for now.
	          { id: 'FSharp', display: 'F#', aceMode:'ocaml'}
	        ];
	        $scope.syntaxes = $scope.allSyntaxes;
	
	        if ($scope.syntaxFilter) {
	          $scope.syntaxes = _.filter($scope.allSyntaxes, function(syntax) {
	            return $scope.syntaxFilter.indexOf(syntax.id) >= 0;
	          });
	        }
	
	        var syntaxMode = _.find($scope.syntaxes, function(syntax){ return $scope.syntax && $scope.syntax === syntax.id;});
	
	        if (syntaxMode === undefined) {
	          syntaxMode = $scope.syntaxes[0];
	        }
	
	        $scope.aceMode = syntaxMode.aceMode;
	
	        $scope.editorLoaded = function(editor) {
	          $scope.editor = editor;
	          editor.$blockScrolling = Infinity;
	          window.rend = $scope.editor.renderer;
	        };
	
	        $scope.insertVariable = function(variableReference) {
	          if ($scope.editor) {
	            $scope.editor.insert(variableReference);
	            $scope.body = $scope.editor.getValue();
	            return $scope.editor.getValue();
	          }
	          return null;
	        };
	
	        $scope.$on('octo-fullscreen-toggle', function() {
	          $timeout(function() {
	            if ($scope.editor) {
	              $scope.editor.renderer.updateFull();
	            }
	          }, 200);
	        });
	      },
	      post: function($scope) {
	        $scope.$watch('syntax', function(newSyntax){
	            if (newSyntax == null) {
	                return;
	            }
	            $scope.aceMode = _.find($scope.syntaxes, function(syntax){ return newSyntax && newSyntax === syntax.id;}).aceMode;
	            if($scope.aceMode && $scope.editor) {
	                $scope.editor.getSession().setMode('ace/mode/' + $scope.aceMode);
	            }
	        });
	        
	        $scope.$watch('syntaxFilter', function(nv){
	          if (nv != null) {
	            $scope.syntaxes = _.filter($scope.allSyntaxes, function(syntax) {
	              return nv.indexOf(syntax.id) >= 0;
	            });
	          }
	        });
	      }
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 598 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('selectMachines', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            placeholder: "@",
	            available: "=",
	            selected: "="
	        },
	        templateUrl: 'areas/shared/views/select-machines.html',
	        controller: function(targetStateMapper) {
	            var vm = this;
	            vm.updateModelsWithProvided = updateModelsWithProvided;
	            vm.onRemoved = onRemoved;
	            vm.onSelected = onSelected;
	            vm.calculateTargetIcon  = targetStateMapper.calculateTargetIcon;
	
	            function onRemoved(item) {
	                var itemIndex = vm.selected.indexOf(item.Id);
	                vm.selected.splice(itemIndex, 1);
	            }
	
	            function onSelected(item){
	                vm.selected.push(item.Id);
	            }
	
	            function updateModelsWithProvided() {
	                vm.selectedModels = (vm.available || []).filter(function(machine) {
	                    return (vm.selected || []).indexOf(machine.Id) !== -1;
	                });
	            }
	        },
	        controllerAs: 'vm',
	        bindToController: true,
	        link: function($scope) {
	            $scope.$watch(function(){ return $scope.vm.selected; }, $scope.vm.updateModelsWithProvided);
	            $scope.$watch(function(){ return $scope.vm.available; }, $scope.vm.updateModelsWithProvided);
	        }
	    };
	});


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {angular
	    .module('octopusApp.shared')
	    .service('selectorDirective', function() {
	        function isMultipleSelector(attrs) {
	            return attrs["multiple"] === "" || (!!attrs["multiple"] && attrs["multiple"] !== "false");
	        }
	
	        function isAllowedToClear(attrs) {
	            return attrs["allowClear"] === "" || (!!attrs["allowClear"] && attrs["allowClear"] !== "false");
	        }
	
	        this.build = function(defaultPlaceholder, options) {
	            options = options || {};
	            return {
	                restrict: 'E',
	                replace: true,
	                require: 'ngModel',
	                scope: {
	                    placeholder: "=",
	                    available: "="
	                },
	                templateUrl: 'areas/shared/views/selector/select-projects.html',
	                controller: function($scope) {
	                    var vm = this;
	
	                    if (vm.isMultiple && !vm.selected){
	                        vm.selected = [];
	                    }
	                    // Set Default Placeholder
	                    if (!vm.placeholder || vm.placeholder === ''){
	                        vm.placeholder = defaultPlaceholder;
	                    }
	
	                    vm.showControl = function showControl() {
	                        return !!vm.available && (!vm.isMultiple || !!vm.selected);
	                    };
	                },
	                compile: function($element, attrs) {
	                    var isMultiple = isMultipleSelector(attrs);
	                    var canClear = isAllowedToClear(attrs);
	                    var $uiSelect = $("ui-select", $element);
	                    var $uiSelectChoices =  $("ui-select-choices", $element);
	                    var $uiSelectMatch = $("ui-select-match", $element);
	
	                    // Needs to be explicitly reapplied due to remapping of model
	                    if (attrs.hasOwnProperty('noDirtyCheck')) {
	                        $uiSelect.attr('no-dirty-check', '');
	                    }
	
	                    if (isMultiple) {
	                        $uiSelect.attr("multiple", "true");
	                    }
	
	                    if (!canClear) {
	                        $uiSelectMatch.attr("allow-clear", "false");
	                    }
	
	                    if (options.choiceTemplate) {
	                        $uiSelectChoices.html(options.choiceTemplate);
	                    }
	
	                    if (options.selectedTemplate) {
	                        var template = options.selectedTemplate;
	                        if (!isMultiple) {
	                            template = options.selectedTemplate.replace(/\$item/g, '$select.selected');
	                        }
	                        $uiSelectMatch.html(template);
	                    }
	
	                    if (options.isSimple) {
	                        $uiSelectChoices.attr('repeat', $uiSelectChoices.attr('repeat').replace('item.Id as ', ''));
	                        $uiSelectMatch.html($uiSelectMatch.html().replace('.Name', ''));
	                        $uiSelectChoices.html($uiSelectChoices.html().replace('.Name', ''));
	                    }
	
	                    if (options.boundIdentity){
	                        $uiSelectChoices.attr('repeat', $uiSelectChoices.attr('repeat').replace('item.Id as ', 'item.'+ options.boundIdentity +' as '));
	                    }
	
	                    return {
	                        post: function ($scope, $element, attrs, ngModel) {
	                            var vm = $scope.vm;
	                            vm.isMultiple = isMultiple;
	                            ngModel.$render = function onRender() { // Update internal selected if outer model changes
	                                vm.selected = ngModel.$viewValue || (isMultiple ? [] : null);
	                            };
	                            vm.onChange = function onChange() { // Update outer model if internal model changes
	                                ngModel.$setViewValue(vm.selected);
	                            };
	                        }
	                    };
	                },
	                controllerAs: 'vm',
	                bindToController: true
	            };
	        };
	    })
	    .directive('selectCustom', function(selectorDirective) {
	        return selectorDirective.build('Select');
	    }).directive('selectProjects', function(selectorDirective) {
	        return selectorDirective.build('Any Project');
	    }).directive('selectEnvironments', function(selectorDirective) {
	        return selectorDirective.build('Any Environment');
	    }).directive('selectTenants', function(selectorDirective) {
	        return selectorDirective.build('Select Tenants');
	    }).directive('selectChannels', function(selectorDirective) {
	        return selectorDirective.build('Any Channel');
	    }).directive('selectProjectGroups', function(selectorDirective) {
	        return selectorDirective.build('Any Project Group');
	    }) .directive('selectRoles', function(selectorDirective) {
	        return selectorDirective.build('Any Role', {
	            isSimple: true
	        });
	    }) .directive('selectTags', function(selectorDirective) {
	        return selectorDirective.build('Select Tags', {
	            choiceTemplate: '<span class="label label-info" ng-style="{ \'background-color\' : item.Color }" ng-bind-html="item.Name | highlight: $select.search" ></span>',
	            selectedTemplate: '<span set-select-match-color uib-tooltip="{{$item.Description}}">{{$item.Name}}</span>',
	            boundIdentity: 'CanonicalTagName'
	        });
	    }).directive('selectUsers', function(selectorDirective) {
	        return selectorDirective.build('Any User',
	            {
	                choiceTemplate: '<span ng-bind-html="item.Username | highlight: $select.search"></span> (<span ng-bind-html="item.DisplayName | highlight: $select.search"></span>)',
	                selectedTemplate:  '{{$item.DisplayName}} ({{$item.Username}})'
	            });
	    }).directive('selectRelease', function (selectorDirective) {
	        return selectorDirective.build('Show current releases',
	            {
	                choiceTemplate: '<span ng-bind-html="item.Version | highlight: $select.search"></span>',
	                selectedTemplate:  '{{$item.Version}}'
	            });
	    });
	
	angular
	    .module('octopusApp.shared').directive('setSelectMatchColor', function() {
	    return {
	        restrict: 'EA',
	        link: function ($scope, $element) {
	            var item = $element.scope().$item;
	
	            if (item) {
	                $element.parents(".ui-select-match-item")
	                    .css("background-color", item.Color);
	            }
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.shared');
	
	module.directive("onNewContent", function ($timeout) {
	
	    function setNewContent($scope, name, data){
	        $timeout(function () {
	            setIsProcessing($scope, false);
	            $scope.onNewContent({
	                data: data,
	                name: name
	            });
	        });
	    }
	    function setIsProcessing($scope, state) {
	        $timeout(function () {
	            $scope.isProcessing = state;
	        });
	    }
	    function attachModernBrowserHandler($scope, element) {
	        $(element).bind("change", function (changed) {
	            setIsProcessing($scope, true);
	            if (!changed.target.files || changed.target.files.length === 0 || !changed.target.files[0]) {
	                setNewContent($scope);
	                return;
	            }
	
	            var file = changed.target.files[0];
	            if ($scope.encodeContent) {
	                var reader = new FileReader();
	                reader.onload = function (loaded) {
	                    var b6 = loaded.target.result.indexOf('base64,') + 7;
	                    setNewContent($scope, file.name, loaded.target.result.slice(b6));
	                };
	
	                reader.readAsDataURL(file);
	            } else {
	                setNewContent($scope, file.name);
	            }
	        });
	    }
	
	    function attachAncientBrowserHandler($scope, element) {
	        window.FileAPI.event.on(element, 'change', function (ch) {
	            setIsProcessing($scope, true);
	            var files = window.FileAPI.getFiles(ch);
	            if (files.length !== 1) {
	                return setNewContent($scope);
	            }
	            var file = files[0];
	            if ($scope.encodeContent) {
	                window.FileAPI.readAsDataURL(file, function (rd) {
	                    if (rd.type === 'load') {
	                        var b6 = rd.result.indexOf('base64,') + 7;
	                        setNewContent($scope, file.name, rd.result.slice(b6));
	                    }
	                });
	            } else {
	                setNewContent($scope, file.name);
	            }
	        });
	    }
	
	    return {
	        scope: {
	            onNewContent: "=",
	            isProcessing: "=",
	            encodeContent: "="
	        },
	        link: function ($scope, element, attr) {
	
	            $scope.fileReaderAvailable = !!window.FileReader;
	            if ($scope.fileReaderAvailable) {
	                attachModernBrowserHandler($scope, element[0]);
	            } else {
	                attachAncientBrowserHandler($scope, element[0]);
	            }
	        }
	    };
	});
	
	module.directive('sensitiveFileInput', function($compile) {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl: 'areas/shared/views/sensitive_file_input.html',
	        scope: {
	            model: '=',
	            display: '=',
	            displayClass: '@'
	        },
	        link: function ($scope, $element) {
	            var model;
	            $scope.hasOriginalContent = false;
	            $scope.hasNewContent = false;
	            $scope.fileReaderAvailable = !!window.FileReader;
	            $scope.onNewContent = changed;
	            $scope.remove = remove;
	            $scope.cancel = cancel;
	            $scope.canCancel = false;
	            setDisplay();
	
	            function remove() {
	                model.HasValue = false;
	                model.NewValue = null;
	                $scope.displayName = null;
	                $scope.canCancel = $scope.hasOriginalContent;
	                resetFileElements();
	            }
	
	            function changed(content) {
	                if (!model) {
	                    $scope.model = {};
	                    link($scope.model);
	                }
	                if (content && content.data && content.data.length > 0) {
	                    model.HasValue = true;
	                    model.NewValue = content.data;
	                    $scope.displayName = content.name;
	                    $scope.hasNewContent = true;
	                    $scope.canCancel = $scope.hasOriginalContent;
	                } else {
	                    remove();
	                }
	            }
	
	            function resetFileElements() {
	                $element.find('.uploader').each(function(index, uploader){
	                    var $newUploader = $(uploader.outerHTML);
	                    $compile($newUploader)($scope);
	                    $(uploader).replaceWith($newUploader);
	                });
	            }
	
	            function setDisplay(){
	                $scope.displayName = $scope.display || 'A file exists.';
	            }
	
	
	            function cancel() {
	                model.HasValue = true;
	                model.NewValue = null;
	                $scope.hasNewContent = false;
	                $scope.canCancel = false;
	                setDisplay();
	            }
	
	
	            function link(originalModel) {
	                model = originalModel;
	                $scope.hasOriginalContent = model.HasValue;
	                $scope.canCancel = false;
	            }
	
	            if ($scope.model) {
	                link($scope.model);
	            } else {
	                $scope.$watch('model', function(nv) {
	                    if (nv && !$scope.view) {
	                        link(nv);
	                    }
	                });
	            }
	        }
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 601 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	// Allows editing of sensitive-values
	module.directive('sensitiveInput', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      model: '='
	    },
	    templateUrl: 'areas/shared/views/sensitive-input.html',
	    link: function($scope, element, attr) {
	      $scope.setOrChange = "Set";
	
	      $scope.$watch(function () {
	        if (!$scope.model) {
	          return;
	        }
	
	        if ($scope.model.HasValue) {
	          $scope.setOrChange = "Change";
	          $scope.hasPassword = true;
	        } else {
	          $scope.setOrChange = "Set";
	          $scope.hasPassword = false;
	        }
	      });
	
	      $scope.isEditingPassword = false;
	      $scope.set = function() {
	        $scope.model = $scope.model || {};
	        $scope.isEditingPassword = true;
	        $scope.hadValue = $scope.model.HasValue;
	        $scope.model.NewValue = '';
	      };
	      $scope.clear = function() {
	        $scope.isEditingPassword = false;
	        $scope.hadValue = $scope.model.HasValue;
	        $scope.model.NewValue = null;
	        $scope.model.HasValue = false;
	      };
	      $scope.undo = function() {
	        $scope.isEditingPassword = false;
	        $scope.model.NewValue = null;
	        $scope.model.HasValue = $scope.hadValue || false;
	      };
	    }
	  };
	});


/***/ },
/* 602 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('tagList', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      tags: '='
	    },
	    template: '<span class="label label-info" ng-class="label" ng-repeat="tag in tags | csvToArray">{{ tag }}</span> ',
	    link: function (scope, element, attrs) {
	      scope.label = "label-info";
	    }
	  };
	});
	
	module.directive('environmentList', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      tags: '='
	    },
	    template: '<span class="label" ng-class="label" ng-repeat="tag in tags | csvToArray">{{ tag }}</span> ',
	    link: function (scope, element, attrs) {
	    }
	  };
	});

/***/ },
/* 603 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.directive('userName', function (busy, octopusRepository) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      userId: '=',
	      nullText: '='
	    },
	    templateUrl: 'areas/shared/views/user-name.html',
	    link: function (scope) {
	      var isLoading = scope.isLoading = busy.create();
	      var usersById = {};
	
	      scope.$watch('userId', function() {
	        if (!scope.userId) {
	          scope.username = "";
	          scope.displayName = "";
	        } else {
	          if (!usersById[scope.userId]) {
	            isLoading.promise(octopusRepository.Users.get(scope.userId).then(function (user) {
	              usersById[scope.userId] = user;
	              scope.username = user.Username;
	              scope.displayName = user.DisplayName;
	            }));
	          } else {
	            scope.username = usersById[scope.userId].Username;
	            scope.displayName = usersById[scope.userId].DisplayName;
	          }
	        }
	      });
	    }
	  };
	});

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.directive('variableSetSnapshot', function() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      snapshotId: '=id',
	      limitWidth: '='
	    },
	    templateUrl: 'areas/shared/views/variable-set-snapshot.html',
	    controller: function($scope, octopusRepository, busy) {
	      var isLoading = $scope.isLoading = busy.create();
	
	      var formatted = {};
	
	      $scope.$watch('snapshotId', function(){
	        if (!$scope.snapshotId) {
	          return;
	        }
	        isLoading.promise(octopusRepository.Variables.get($scope.snapshotId).then(function(variables) {
	          $scope.snapshot = variables;
	          $scope.scopeValues = variables.ScopeValues;
	        }));
	      });
	      $scope.formatScope = function(variableId, varscope, scopeValues) {
	        if (!varscope || !scopeValues) {
	          return '';
	        }
	        if (formatted[variableId]) {
	          return formatted[variableId];
	        }
	
	        var values = [];
	        _.each(_.sortBy(_.pairs(varscope), function(pr) { return pr[0]; }), function(pr){
	          var refs = scopeValues[pr[0] + 's'];
	          _.each(pr[1], function(id) {
	            var item = _.find(refs, function(ref) { return ref.Id === id; });
	            if (item) {
	              values.push(item.Name);
	            }
	          });
	        });
	        var result = values.join('; ');
	        formatted[variableId] = result;
	        return result;
	      };
	    }
	  };
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 605 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.provider('stateHelper', function(){
	
	    this.withBreadcrumb = function(text, href) {
	        if (href) {
	            return '<script octo-section="breadcrumbs" type="text/ng-template"><li><a href="' + href + '">' + text + '</a></li></script><ui-view></ui-view>';
	        } else {
	            return '<script octo-section="breadcrumbs" type="text/ng-template"><li>' + text + '</li></script><ui-view></ui-view>';
	        }
	    };
	
	    this.redirectRoute = function(url, newUrl) {
	        var urlGetter = newUrl;
	        if (typeof newUrl === 'string') {
	            urlGetter = function () {
	                return newUrl;
	            };
	        } else if (typeof newUrl !== 'function') {
	            throw "Unable to build redirection based on " + typeof(newUrl);
	        }
	
	        return {
	            url: url,
	            views: {
	                "@app": {
	                    templateUrl: 'areas/shared/views/redirect.html',
	                    controller: function ($scope, $injector, $q, $location, busy) {
	                        $scope.isLoading = busy.create();
	
	                        var result = $injector.invoke(urlGetter);
	                        $scope.isLoading.promise($q.when(result)).then(function (path) {
	                            $location.path(path);
	                            $location.replace();
	                        });
	                    }
	                }
	            },
	            layout: {
	                title: 'Loading...',
	                tab: null
	            }
	        };
	    };
	
	    this.$get = function(){};
	});

/***/ },
/* 606 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.shared');
	
	module.service('actionTemplateProcessor', function ($location, octopusRepository, octopusPermissionSet, $q) {
	
	    this.installCommunityActionTemplate = function(communityActionTemplate, getRedirectUrl, includeInstallStepIdInUrl, busy) {
	
	        var promise = octopusRepository.CommunityActionTemplates.install(communityActionTemplate)
	            .then(function(actionTemplate) {
	                var url = getRedirectUrl(actionTemplate);
	
	                if (includeInstallStepIdInUrl) {
	                    $location.path(url).search('installedStep', actionTemplate.Id);
	                }
	                else {
	                    $location.path(url);
	                }
	            });
	
	        return busy.promise(promise);
	    };
	
	    this.cloneActionTemplate = function(actionTemplate, actionTemplateNameOverride, getRedirectUrl, busy, afterRedirect) {
	
	        var newTemplate = {
	            Name: actionTemplateNameOverride ? actionTemplateNameOverride : actionTemplate.Name,
	            Description: actionTemplate.Description,
	            ActionType: actionTemplate.ActionType,
	            Properties: actionTemplate.Properties,
	            Parameters: actionTemplate.Parameters,
	            Version : actionTemplate.Version
	        };
	
	        var promise = octopusRepository.ActionTemplates.create(newTemplate)
	            .then(function(actionTemplate) {
	                var url = getRedirectUrl(actionTemplate);
	                $location.path(url);
	                afterRedirect();
	            });
	
	        return busy.promise(promise);
	    };
	
	    this.updateCommunityActionTemplateInstallation = function(communityActionTemplate, getRedirectUrl, busy) {
	
	        var promise = octopusRepository.CommunityActionTemplates.updateInstallation(communityActionTemplate)
	            .then(function(actionTemplate) {
	                if (getRedirectUrl) {
	                    var url = getRedirectUrl(actionTemplate);
	                    $location.path(url);
	                }
	            });
	        return busy.promise(promise);
	    };
	
	    this.getActionTemplates = function() {
	
	        // Strictly speaking not required but the React warning was annoying enough :)
	        // https://facebook.github.io/react/docs/multiple-components.html
	        function provideRenderKey(templates) {
	            for (var i = 0; i < templates.length; i++) {
	                templates[i].key = i;
	            }
	        }
	
	        var stepTemplateLoader = octopusRepository.ActionTemplates.search();
	
	        return stepTemplateLoader.then(function (templates) {
	            provideRenderKey(templates);
	            return templates;
	        });
	
	    };
	
	    this.getActionTemplatesAuthorizationAndFeatureConfig = function() {
	
	        var permissionLoader = octopusPermissionSet.isAuthorized({permission: 'ActionTemplateView'});
	        var featureConfigLoader = octopusRepository.FeaturesConfiguration.get();
	        var loaders = [permissionLoader, featureConfigLoader];
	
	        return $q.all(loaders).then(function (results) {
	
	            var isAuthorized = results[0];
	            var configuration = results[1];
	
	            return {
	                isAuthorized: isAuthorized,
	                configuration: configuration
	            };
	        });
	
	    };
	
	    this.filterActionTemplates = function (templates, filterText, sectionScope) {
	
	        var sectionTemplates = templates.filter(sectionScope);
	
	        if (!filterText) {
	            return sectionTemplates;
	        }
	
	        function contains(content, value) {
	            return content && content.toLowerCase().indexOf(value) !== -1;
	        }
	
	        filterText = filterText.toLowerCase();
	
	        return sectionTemplates.filter(function (template) {
	            return contains(template.Name, filterText) ||
	                contains(template.Category, filterText) ||
	                contains(template.Description, filterText);
	        });
	    };
	});


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.factory('eventFormatter', function(octoUtil, octoDirectory) {
	  return {
	    format: function(e) {
	      var message = e.Message;
	      var isDelete = message.indexOf(' was deleted', message.length - ' was deleted'.length) !== -1;
	
	      function htmlEncode(html) {
	        return document.createElement('div')
	          .appendChild(document.createTextNode(html))
	          .parentNode
	          .innerHTML;
	      }
	
	      var indexes = [];
	      var references = e.MessageReferences;
	      if (references && references.length > 0) {
	
	        var refStart = references[0];
	        if (refStart.StartIndex !== 0) {
	          indexes.push({ ref: null, idx: 0 });
	        }
	
	        var lastRef = null;
	        var referencesLength = references.length;
	        for (var i = 0; i < referencesLength; i++) {
	          var reference = references[i];
	
	          if (!lastRef || lastRef.idx !== reference.StartIndex) {
	            indexes.push({ ref: reference, idx: reference.StartIndex });
	          }
	          indexes.push({ ref: null, idx: reference.StartIndex + reference.Length });
	          lastRef = reference;
	        }
	
	        var refEnd = references[references.length - 1];
	        var endIndex = (refEnd.StartIndex + refEnd.Length);
	        if (endIndex !== message.length) {
	          indexes.push({ ref: null, idx: message.length });
	        }
	
	      } else {
	        indexes.push({ ref: null, idx: 0 });
	        indexes.push({ ref: null, idx: message.length });
	      }
	
	      var last = null;
	      var parts = [];
	      var indexesLen = indexes.length;
	      for (var j = 0; j < indexesLen; j++) {
	        var item = indexes[j];
	
	        if (last) {
	          parts.push({ ref: last.ref, msg: message.substring(last.idx, item.idx) });
	        }
	
	        last = item;
	      }
	
	      var encodedParts = _.map(parts, function(x) {
	
	        var encMsg = htmlEncode(x.msg);
	        if (x.ref) {
	          var docId = x.ref.ReferencedDocumentId;
	          var href = octoDirectory.linkTo(docId);
	
	          if (docId.toLowerCase().indexOf("interruption")) {
	            return "<a class='reference'  title='" + docId + "' href='" + href +  "'>" + encMsg + "</a>";
	          } else {
	            return encMsg;
	          }
	
	        } else {
	          return encMsg;
	        }
	      });
	
	      var result = _.reduce(encodedParts, function(aggregate, part) {
	        return aggregate + part;
	      }, "");
	
	      return result;
	    }
	  };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.factory('helpManager', function($rootScope) {
	  var manager = {};
	
	  manager.helpBlocks = [];
	  manager.isHelpVisible = false;
	
	  manager.toggleHelp = function() {
	    manager.isHelpVisible = !manager.isHelpVisible;
	
	    _.each(manager.helpBlocks, function (block) {
	      block(manager.isHelpVisible);
	    });
	  };
	
	  manager.registerHelpElement = function(callback) {
	    manager.helpBlocks.push(callback);
	  };
	
	  $rootScope.$on('$routeChangeStart', function() {
	    manager.helpBlocks = [];
	  });
	
	  manager.hasHelp = function() {
	    return manager.helpBlocks.length > 0;
	  };
	
	  return manager;
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.factory('scopeValuesToScopeOptionsConverter', function() {
	    return function(scopeValues){
	        var optionConverter = function (r) {
	            return {id: r.Id, name: r.Name};
	        };
	        var scopeOptions = [];
	        scopeOptions.push({
	            title: "Environments",
	            name: "environments",
	            values: _.map(scopeValues.Environments, optionConverter)
	        });
	        scopeOptions.push({
	            title: "Roles",
	            name: "roles",
	            values: _.map(scopeValues.Roles, optionConverter)
	        });
	        scopeOptions.push({
	            title: "Deployment Targets",
	            name: "machines",
	            values: _.map(scopeValues.Machines, optionConverter)
	        });
	        scopeOptions.push({
	            title: "Steps",
	            name: "steps",
	            values: _.map(scopeValues.Actions, optionConverter)
	        });
	        if (scopeValues.Channels && scopeValues.Channels.length > 1) {
	            scopeOptions.push({
	                title: "Channels",
	                name: "channels",
	                values: _.map(scopeValues.Channels, optionConverter)
	            });
	        }
	        scopeOptions.push({
	            title: "TenantTags",
	            name: "tenantTags",
	            values: _.map(scopeValues.TenantTags, optionConverter)
	        });
	
	        return scopeOptions;
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var machineImages = __webpack_require__(114);
	
	angular.module('octopusApp.shared').service('targetStateMapper', function(octoUtil){
	    function calculateTargetIcon(machine){
	        var state = machine.HealthStatus;
	        if (machine.IsDisabled) {
	            state = "Disabled";
	        } else if (state !== "Unknown" && state !== "Unavailable" && state !== "Unhealthy") { // Upgrade status shouldn't override these states
	            if (machine.Endpoint.TentacleVersionDetails &&
	                machine.Endpoint.TentacleVersionDetails.UpgradeSuggested && !machine.Endpoint.TentacleVersionDetails.UpgradeLocked) {
	                state = "NeedsUpgrade";
	            } else if (!machine.HasLatestCalamari) {
	                state = "CalamariNeedsUpgrade";
	            }
	        }
	
	        var commsStyle = octoUtil.escapeHtml(machine.Endpoint.CommunicationStyle);
	        var name = "./Server-" + octoUtil.escapeHtml(state) + "." + commsStyle + ".png";
	        return machineImages(name, true);
	    }
	
	    return {
	        calculateTargetIcon: calculateTargetIcon
	    };
	});

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.shared');
	
	module.factory('templateParameterModal', function ($uibModal, unsavedChanges) {
	    function create(templates, options) {
	        var name = options.name || 'Variable Template';
	        var invalidStepTypes = options.isTemplate ?
	            ["StepName"] :["AzureAccount"];
	        var requiredPermission = options.requiredPermission || 'ActionTemplateEdit';
	        var projectId = options.projectId || '*';
	
	        function addTemplate() {
	            return $uibModal.open({
	                backdrop: true,
	                keyboard: true,
	                templateUrl: 'areas/shared/views/edit_parameter_dialog.html',
	                controller: 'TemplateParameterEditController',
	                dialogClass: 'modal modal-big',
	                resolve: {
	                    title: function () {
	                        return name;
	                    },
	                    parameter: function () {
	                        return {};
	                    },
	                    names: function () {
	                        return _.pluck(templates, 'Name');
	                    },
	                    invalidStepTypes: function () {
	                        return invalidStepTypes;
	                    },
	                    requiredPermission: function () {
	                        return requiredPermission;
	                    },
	                    projectId: function () {
	                        return projectId;
	                    }
	                }
	            }).result.then(function (result) {
	                if (result) {
	                    templates.push(result);
	                    unsavedChanges.unsaved();
	                    if (options.onChange) {
	                        options.onChange();
	                    }
	                }
	            });
	        }
	
	        function editTemplate(variableTemplate) {
	            return $uibModal.open({
	                backdrop: true,
	                keyboard: true,
	                templateUrl: 'areas/shared/views/edit_parameter_dialog.html',
	                controller: 'TemplateParameterEditController',
	                dialogClass: 'modal modal-big',
	                resolve: {
	                    title: function () {
	                        return name;
	                    },
	                    parameter: function () {
	                        return _.clone(variableTemplate);
	                    },
	                    names: function () {
	                        return _.pluck(_.without(templates, variableTemplate), 'Name');
	                    },
	                    invalidStepTypes: function () {
	                        return invalidStepTypes;
	                    },
	                    requiredPermission: function () {
	                        return requiredPermission;
	                    },
	                    projectId: function () {
	                        return projectId;
	                    }
	                }
	            }).result.then(function (result) {
	                if (result) {
	                    templates[_.indexOf(templates, variableTemplate)] = result;
	                    unsavedChanges.unsaved();
	                    if (options.onChange) {
	                        options.onChange();
	                    }
	                }
	            });
	        }
	
	        function removeTemplate(variableTemplate) {
	            templates.splice(templates.indexOf(variableTemplate), 1);
	            unsavedChanges.unsaved();
	        }
	
	        return {
	            addTemplate: addTemplate,
	            editTemplate: editTemplate,
	            removeTemplate: removeTemplate
	        };
	    }
	
	    return {
	        create: create
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.tasks');
	
	module.controller('TaskController', function ($scope, $timeout, $state, $stateParams, $location, $q, octopusLog, busy, octopusRepository, pageTitle, pollLoop, octopusPermissionSet) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isLoadingEvents = $scope.isLoadingEvents = busy.create();
	    var isLoadingInterrupts = $scope.isLoadingInterrupts = busy.create();
	    var isLoadingArtifacts = $scope.isLoadingArtifacts = busy.create();
	    var isLoadingQueue = $scope.isLoadingQueue = busy.create();
	    var isSubmitting = $scope.isSubmitting = busy.create();
	    var isSubmittingInterruption = $scope.isSubmittingInterruption = busy.create();
	    var isLoadingPrevious = $scope.isLoadingPrevious = busy.create();
	    var isLoadingProgression = $scope.isLoadingProgression = busy.create();
	
	    var id = $stateParams["id"];
	    var taskId = $stateParams["taskId"];
	    var depid = $stateParams["depid"];
	
	    $scope.task = null;
	    $scope.moment = moment;
	    $scope.appContext = null;
	    $scope.permScope = null;
	
	    $scope.rootNodes = [];
	    $scope.tab = "summary";
	    $scope.isLastRefresh = false;
	    $scope.isVerbose = false;
	    $scope.isTail = true;
	
	    $scope.skipBehind = 0;
	    $scope.pageQueuedTasks = pageQueuedTasks;
	
	    $scope.changeTab = function (v) {
	        $scope.tab = v;
	    };
	
	
	    $scope.canViewLog = false;
	
	    $scope.toggleGap = function () {
	        $scope.isTail = false;
	        reload();
	    };
	
	    var loop = pollLoop.create($scope, function () {
	        return reload();
	    }, 1000);
	
	    $scope.rerun = function () {
	        octopusLog.log("Re-running: " + $scope.task.Id);
	        isSubmitting.promise(octopusRepository.Tasks.rerun($scope.task).then(function (newTask) {
	            $location.path("/tasks/" + newTask.Id);
	        }));
	    };
	
	    $scope.cancel = function () {
	        octopusLog.log("Canceling: " + $scope.task.Id);
	        isSubmitting.promise(octopusRepository.Tasks.cancel($scope.task).then(function () {
	            reload();
	        }));
	    };
	
	    $scope.goToLog = function (e) {
	        if (!$scope.canViewLog) {
	            return;
	        }
	        $scope.changeTab("log");
	        $scope.setExpanderMode('Custom');
	        $scope.nodeExpandTo(e);
	        //$scope.rootNode.expander.setMode('Custom');
	        //$scope.rootNode.expandTo(e);
	    };
	
	    $scope.goToLogById = function (id) {
	        if (!$scope.canViewLog) {
	            return;
	        }
	        $scope.changeTab("log");
	        $scope.setExpanderMode('Custom');
	        $scope.nodeExpandToId(id);
	        //$scope.rootNode.expander.setMode('Custom');
	        //$scope.rootNode.expandToId(id);
	    };
	
	    $scope.expanderMode = null;
	    $scope.setExpanderMode = function (mode) {
	        $scope.expanderMode = mode;
	
	        _.each($scope.rootNodes, function (rootNode) {
	            rootNode.expander.setMode(mode);
	        });
	    };
	    $scope.nodeExpandTo = function (node) {
	        _.each($scope.rootNodes, function (rootNode) {
	            rootNode.expandTo(node);
	        });
	    };
	    $scope.nodeExpandToId = function (nodeId) {
	        _.each($scope.rootNodes, function (rootNode) {
	            rootNode.expandToId(nodeId);
	        });
	    };
	
	    $scope.showVerbose = function () {
	        if (!$scope.canViewLog) {
	            return;
	        }
	        $scope.isVerbose = true;
	        reload();
	    };
	
	    $scope.submitInterruption = function (interrupt, result) {
	        isSubmittingInterruption.promise(octopusRepository.Interruptions.submit(interrupt, result).then(function () {
	            reload();
	        }));
	    };
	
	    $scope.takeResponsibility = function (interrupt) {
	        isSubmittingInterruption.promise(octopusRepository.Interruptions.takeResponsibility(interrupt).then(function () {
	            reload();
	        }));
	    };
	
	    $scope.showMachine = function (machine) {
	        $location.path('/machines/' + machine.Id);
	    };
	
	
	    function init() {
	        if (taskId) {
	            var taskAsync = !!$stateParams.task ? $q.resolve($stateParams.task) : octopusRepository.Tasks.get(taskId);
	            isLoading.promise(taskAsync.then(function (task) {
	                if (task.Name === 'Deploy' && task.Arguments.DeploymentId) {
	                    $location.path('/deployments/' + task.Arguments.DeploymentId);
	                    $location.replace();
	                } else {
	                    $scope.task = task;
	                    if (task.Arguments && task.Arguments.EnvironmentId) {
	                        $scope.permScope = {environmentId: task.Arguments.EnvironmentId};
	                    }
	                    loop.startImmediately();
	                }
	            }));
	        } else if (depid) {
	            $scope.appContext = {};
	            $scope.packages = [];
	
	            isLoading.promise(octopusRepository.Deployments.get(depid).then(function (deployment) {
	                $scope.appContext.deployment = deployment;
	                $scope.permScope = {
	                    projectId: deployment.ProjectId,
	                    environmentId: deployment.EnvironmentId
	                };
	
	                var deploymentQueries = [
	                    octopusRepository.Releases.get(deployment.ReleaseId),
	                    octopusRepository.Projects.get(deployment.ProjectId),
	                    octopusRepository.Channels.get(deployment.ChannelId),
	                    octopusRepository.Tasks.get(deployment.TaskId),
	                    octopusRepository.Environments.all()
	                ];
	
	                return $q.all(deploymentQueries).then(function (result) {
	                    $scope.appContext.release = result[0];
	                    $scope.appContext.project = result[1];
	                    $scope.channel = result[2];
	                    $scope.task = result[3];
	                    $scope.appContext.environments = result[4];
	                    loop.startImmediately();
	                });
	            }));
	        }
	    }
	
	    function checkLoadingLoopComplete(details) {
	        if (details.Task && (details.Task.State === "Success" || details.Task.State === "Failed" || details.Task.State === "TimedOut" || details.Task.State === "Canceled")) {
	            if ($scope.isLastRefresh) {
	                octopusLog.log("Task has finished; no more refreshing");
	                loop.stop();
	            } else {
	                if ($scope.appContext && $scope.appContext.release) {
	                    isLoadingProgression.promise(octopusRepository.Releases.progression($scope.appContext.release)).then(function (progression) {
	                        $scope.appContext.progression = progression;
	                    });
	                }
	
	                octopusLog.log("Task has finished; there will be one more refresh");
	                $scope.isLastRefresh = true;
	            }
	        }
	    }
	
	    function reload() {
	        var environmentId = $scope.permScope ? $scope.permScope.environmentId : null;
	        var projectId = $scope.permScope ? $scope.permScope.projectId : null;
	
	        octopusPermissionSet.isAuthorized({
	            permission: 'TaskViewLog',
	            projectId: projectId,
	            environmentId: environmentId
	        }).then(function (yn) {
	            $scope.canViewLog = yn;
	        });
	
	        var taskDetailOptions = {
	            verbose: $scope.isVerbose
	        };
	        if ($scope.isTail) {
	            taskDetailOptions.tail = 20;
	        }
	
	        var all = [
	            isLoading.promise(octopusRepository.Tasks.getDetails($scope.task, taskDetailOptions)),
	
	            isLoadingArtifacts.promise(octopusPermissionSet.isAuthorized({
	                permission: 'ArtifactView',
	                projectId: projectId,
	                environmentId: environmentId
	            }).then(function (yn) {
	                return yn ? octopusRepository.Artifacts.list({
	                    regarding: $scope.task.Id,
	                    skip: ($scope.artifacts && $scope.artifacts.Page > 0) ? $scope.artifacts.Page * $scope.artifacts.ItemsPerPage : 0
	                }) : null;
	            })),
	
	            isLoadingInterrupts.promise(octopusPermissionSet.isAuthorized({
	                permission: 'InterruptionViewSubmitResponsible',
	                projectId: projectId,
	                environmentId: environmentId
	            }).then(function (yn) {
	                return yn ? octopusRepository.Interruptions.list({regarding: $scope.task.Id}) : null;
	            })),
	
	            isLoadingEvents.promise(octopusPermissionSet.isAuthorized({
	                permission: 'EventView',
	                projectId: projectId,
	                environmentId: environmentId
	            }).then(function (yn) {
	                return yn ? octopusRepository.Events.list({
	                    regardingAny: (depid ? [$scope.task.Id, depid] : [$scope.task.Id]),
	                    skip: ($scope.events && $scope.events.Page > 0) ? $scope.events.Page * $scope.events.ItemsPerPage : 0
	                }) : null;
	            }))
	        ];
	
	        if (depid) {
	            all.push(isLoadingPrevious.promise(octopusRepository.Deployments.list({
	                projects: projectId,
	                environments: environmentId,
	                taskState: 'Success',
	                skip: ($scope.previous && $scope.previous.Page > 0) ? $scope.previous.Page * $scope.previous.ItemsPerPage : 0,
	                take: 4
	            }).then(function (previous) {
	                previous.Items = _.filter(previous.Items, function (pd) {
	                    return pd.Id !== depid;
	                });
	                if (previous.Items.Length === 4) {
	                    previous.Items.Length = 3;
	                }
	                return previous;
	            })));
	        }
	
	        return $q.all(all).then(function (result) {
	            var details = result[0],
	                artifacts = result[1],
	                interruptions = result[2],
	                events = result[3],
	                previous = result[4];
	
	            $scope.task = details.Task;
	            $scope.details = details;
	            $scope.progress = details.Progress;
	            $scope.interruptions = interruptions;
	
	            mergeListData($scope.artifacts, artifacts, function () {
	                $scope.artifacts = artifacts;
	            });
	
	            mergeListData($scope.events, events, function () {
	                $scope.events = events;
	            });
	
	            mergeListData($scope.previous, previous, function () {
	                $scope.previous = previous;
	            });
	
	            if (!$scope.task.HasBeenPickedUpByProcessor) {
	                loadQueuedTasks();
	            } else {
	                $scope.behind = [];
	            }
	
	            pageTitle(details.Task.Description);
	            rebuildTree(details.ActivityLogs);
	            checkLoadingLoopComplete(details);
	        });
	    }
	
	    function mergeListData(scopeList, newList, initializeCallback) {
	        if (scopeList) {
	            scopeList.Items = newList.Items;
	            scopeList.Links = newList.Links;
	            scopeList.IsStale = newList.IsStale;
	            scopeList.ItemsPerPage = newList.ItemsPerPage;
	            scopeList.TotalResults = newList.TotalResults;
	        }
	        else {
	            initializeCallback();
	        }
	    }
	
	    function pageQueuedTasks(skipBehind) {
	        $scope.skipBehind = skipBehind;
	        loadQueuedTasks();
	    }
	
	    function loadQueuedTasks() {
	        isLoadingQueue.promise(octopusRepository.Tasks.getQueuedBehind($scope.task, {skip: $scope.skipBehind}).then(function (behind) {
	            $scope.behind = behind;
	        }));
	    }
	
	    function rebuildTree(activityLogs) {
	        if (!activityLogs || activityLogs.length === 0) {
	            return;
	        }
	
	        _.each(activityLogs, function (activityLog) {
	            var existing = _.find($scope.rootNodes, function (node) {
	                return node.id === activityLog.Id &&
	                    node.started === activityLog.Started &&
	                    node.name === activityLog.Name;
	            });
	            if (!existing) {
	                existing = new Octopus.Model.LogTreeNode();
	                $scope.rootNodes.push(existing);
	            }
	            existing.refresh(activityLog);
	        });
	    }
	
	    init();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 613 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tasks');
	
	module.controller('TaskRawController', function ($scope, $stateParams, octopusRepository, busy) {
	  var isLoading = $scope.isLoading = busy.create();
	  var id = $stateParams["taskId"];
	  $scope.task = null;
	
	  $scope.refresh = function() {
	    isLoading.promise(octopusRepository.Tasks.get(id).then(function (task) {
	      isLoading.promise(octopusRepository.Tasks.getRaw(task).then(function (raw) {
	        $scope.task = task;
	        $scope.rawLog = raw;
	        $scope.rawDownloadLink = octopusRepository.resolve(task.Links["Raw"]);
	      }));
	    }));
	  };
	
	  $scope.refresh();
	});


/***/ },
/* 614 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tasks');
	
	module.controller('TasksIndexController', function ($scope, $timeout, $location, busy, pollLoop, octopusRepository, octopusPermissionSet) {
	    var isLoading = $scope.isLoading = busy.create();
	
	    $scope.tasks = null;
	    $scope.skip = 0;
	    $scope.skipActive = 0;
	    $scope.filter = {
	        name: "",
	        nodeId: $location.search().serverNode
	    };
	
	    $scope.taskTypes = ["Deploy", "Health", "AdHocScript", "AutoDeploy", "Backup", "Upgrade", "TestEmail", "TestAzureAccount", "Retention", "Delete", "SystemIntegrityCheck", "SyncCommunityActionTemplates", "SynchronizeBuiltInPackageRepositoryIndex", "UpdateCalamari"];
	    $scope.loadRecentPage = loadRecentPage;
	    $scope.loadActivePage = loadActivePage;
	    $scope.refresh = refresh;
	
	    function loadRecentPage(skip) {
	        $scope.skip = skip;
	        loadTasks();
	    }
	
	    function loadActivePage(skipActive) {
	        $scope.skipActive = skipActive;
	        loadTasks();
	    }
	
	    function refresh() {
	        $scope.skip = 0;
	        $scope.skipActive = 0;
	        loadTasks();
	    }
	
	    isLoading.promise(octopusPermissionSet.isAuthorized({
	        permission: 'ProjectView',
	        projectId: '*'
	    }).then(function (yn) {
	        return yn ? octopusRepository.Projects.all().then(function (projects) {
	            $scope.projects = projects;
	        }) : null;
	    }));
	
	    isLoading.promise(octopusPermissionSet.isAuthorized({
	        permission: 'EnvironmentView',
	        environmentId: '*'
	    }).then(function (yn) {
	        return yn ? octopusRepository.Environments.all().then(function (environments) {
	            $scope.environments = environments;
	        }) : null;
	    }));
	
	    isLoading.promise(octopusRepository.OctopusServerNodes.all().then(function (nodes) {
	        $scope.nodes = nodes;
	    }));
	
	    function loadTasks() {
	        var options = {
	            environment: $scope.filter.environmentId,
	            name: $scope.filter.name || null,
	            project: $scope.filter.projectId,
	            node: $scope.filter.nodeId
	        };
	
	        return isLoading.promise(octopusRepository.Tasks.filter(angular.extend({}, options, {
	            skip: $scope.skip,
	            active: false
	        })).then(function (tasks) {
	            return isLoading.promise(octopusRepository.Tasks.filter(angular.extend({}, options, {
	                skip: $scope.skipActive,
	                active: true
	            })).then(function (activeTasks) {
	                $scope.tasks = tasks;
	                $scope.activeTasks = activeTasks;
	            }));
	        }));
	    }
	
	    pollLoop.create($scope, function () {
	        return loadTasks();
	    }).startImmediately();
	
	});
	


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.tasks');
	
	module.directive('activityElementSummary', function (octoUtil) {
	  var summaryTemplate = '<div class="log-entry">' +
	          '<div class="log-progress"></div>' +
	          ' <span class="log-title title" title="view log"></span>' +
	          ' <div class="log-content">' +
	          '   <p class="log-additional"><span>84</span> additional lines have been hidden. <a href="">Show all</a></p>' +
	          '   <div class="log-output fixed"></div>' +
	          '   <div class="log-entry-children"></div>' +
	          ' </div>' +
	          '</div>';
	
	  var detailsTemplate = '<div class="log-entry">' +
	          '<div class="log-entry-heading">' +
	          ' <div class="log-progress pull-right"></div>' +
	          ' <a href="" class="log-entry-title">' +
	          '   <i class="fa fa-fw"></i>' +
	          '   <span class="log-title title" title="view log"></span>' +
	          ' </a>' +
	          '</div>' +
	          '<div class="log-content padding-xs-vr">' +
	          ' <p class="log-additional"><span>84</span> additional lines have been hidden. <a href="">Show all</a></p>' +
	          ' <div class="log-output fixed"></div>' +
	          ' <div class="log-entry-children"></div>' +
	          ' </div>' +
	          '</div>';
	
	  var summaryMode = (function () {
	    return {
	      className: 'log-entry-summary',
	      template: summaryTemplate,
	      expandable: false,
	      nodeFilter: function (element) {
	        return element.showAtSummaryLevel;
	      },
	      logEntryFilter: function (logEntry) {
	        return logEntry.Category === "Warn" ||
	            logEntry.Category === "Warning" ||
	            logEntry.Category === "Fatal" ||
	            logEntry.Category === "Alert" ||
	            logEntry.Category === "Error" ||
	            logEntry.MessageText.indexOf("Submitted by: ") === 0;
	      }
	    };
	  })();
	
	  var detailsMode = (function () {
	    return {
	      className: 'log-entry-details',
	      template: detailsTemplate,
	      expandable: true,
	      nodeFilter: function (element) {
	        return element.status !== 'Skipped' && element.status !== 'Pending';
	      },
	      logEntryFilter: function (logEntry) {
	        return true;
	      }
	    };
	  })();
	
	  var modes = { 'summary': summaryMode, 'details': detailsMode };
	
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      element: '=',
	      goToLog: '=',
	      toggleGap: '=',
	      mode: '@'
	    },
	    terminal: true,
	    link: function (scope, element) {
	      var elementNodes = {};
	
	      var mode = modes[scope.mode];
	
	      var ensureViewNode = function (node, parentDomElement) {
	        if (!node.id) {
	          return { update: function() {} };
	        }
	        if (elementNodes[node.id]) {
	          return elementNodes[node.id];
	        }
	
	        if (!mode.nodeFilter(node)) {
	          return { update: function() {} };
	        }
	
	        var self = {};
	        self.node = node;
	        self.domElement = angular.element(mode.template);
	
	        self.childrenElement = $(".log-entry-children", self.domElement);
	        self.expandElement = $(".fa-fw", self.domElement);
	        self.logOutputElement = $(".log-output", self.domElement);
	        self.logAdditionalElement = $(".log-additional", self.domElement);
	        self.logAdditionalCountElement = $(".log-additional span", self.domElement);
	        self.titleElement = $(".title", self.domElement);
	        self.contentElement = $(".log-content", self.domElement);
	        self.progressElement = $(".log-progress", self.domElement);
	        self.rendered = false;
	        self.lastVersion = -1;
	        if (mode.expandable) {
	          self.titleElement.addClass("expandable");
	        }
	        self.renderLog = function() {
	          if (self.lastVersion === node.counter && self.rendered) {
	            return;
	          }
	          self.lastVersion = node.counter;
	
	          if (node.isExpanded || !mode.expandable) {
	            var html = [];
	            var logElements = node.logElements;
	            for (var i = 0; i < logElements.length; i++) {
	              var logEntry = logElements[i];
	              if (!mode.logEntryFilter(logEntry)) {
	                continue;
	              }
	              var occurred = moment(logEntry.OccurredAt);
	
	              html.push('<div class="log-line ');
	              html.push(logEntry.Category);
	              html.push('">');
	
	              if(logEntry.Category === "Gap") {
	                html.push('<a href="" class="toggleGap">');
	                html.push(octoUtil.escapeHtml(logEntry.DetailedMessageText));
	                html.push('</a>');
	              } else {
	                html.push('<div class="log-time" title="');
	                html.push(occurred.format("LLLL"));
	                html.push('">');
	                html.push(occurred.format("MMMM Do YYYY HH:mm:ss"));
	                html.push('</div>');
	
	                html.push('<div class="log-category">');
	                html.push(logEntry.Category);
	                html.push('</div>');
	
	                html.push('<div class="log-message">');
	                html.push(octoUtil.escapeHtml(logEntry.DetailedMessageText));
	                html.push('</div>');
	              }
	              html.push('</div>');
	            }
	            self.rendered = true;
	            self.logOutputElement.html(html.join(''));
	
	            $(".toggleGap", self.logOutputElement).click(function (e) {
	              e.preventDefault();
	              scope.$apply(function () {
	                scope.toggleGap(node);
	              });
	              return false;
	            });
	          } else {
	            self.rendered = false;
	          }
	        };
	
	        $(".title", self.domElement).parent().click(function (e) {
	          e.preventDefault();
	          scope.$apply(function () {
	            if (mode.expandable) {
	              node.toggleExpanded();
	              self.update();
	            } else {
	              scope.goToLog(node);
	            }
	          });
	          return false;
	        });
	
	        parentDomElement.append(self.domElement);
	
	        self.update = function () {
	          if (!mode.nodeFilter(node)) {
	            self.domElement.hide();
	          } else {
	            self.domElement.show();
	          }
	
	          self.titleElement.text(node.name);
	          self.domElement.attr("class", "log-entry " + node.status +" "+ mode.className);
	
	          if (mode.expandable) {
	            if (node.isExpanded) {
	              self.expandElement.removeClass("fa-plus-square").addClass("fa-minus-square");
	            } else {
	              self.expandElement.removeClass("fa-minus-square").addClass("fa-plus-square");
	            }
	          }
	
	          self.renderLog();
	
	          if (node.progressPercentage > 0) {
	            self.progressElement.show();
	            self.progressElement.html("<div class='progress progress-striped active'><div class='progress-bar' style='width: " + node.progressPercentage + "%'></div></div> <span class='log-progress-text'>" + octoUtil.escapeHtml(node.progressMessage) +  " (" + node.progressPercentage + "%)</span>");
	          } else {
	            self.progressElement.html('');
	            self.progressElement.hide();
	          }
	
	          if (node.additionalEntries > 0) {
	            self.logAdditionalElement.show();
	            self.logAdditionalCountElement.html(node.additionalEntries.toFixed(0).replace(/(\d)(?=(\d{3})+\b)/g,'$1,'));
	          } else {
	            self.logAdditionalElement.hide();
	          }
	
	          if (mode.expandable) {
	            if (node.isExpanded) {
	              self.contentElement.show();
	            } else {
	              self.contentElement.hide();
	            }
	          }
	
	          for (var i = 0; i < self.node.children.length; i++) {
	            ensureViewNode(self.node.children[i], self.childrenElement).update();
	          }
	        };
	
	        elementNodes[node.id] = self;
	        return self;
	      };
	
	      var render = function() {
	        if (!scope.element) {
	          return;
	        }
	
	        ensureViewNode(scope.element, element).update();
	      };
	
	      scope.$watch("element.updateCount", function () {
	        render();
	      });
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 616 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tasks');
	
	module.directive('logLine', function ($compile) {
	  return {
	    restrict: 'E',
	    replace: true,
	    templateUrl: 'areas/tasks/views/log_line.html',
	    scope: {
	      event: '=',
	      detail: '@',
	      fullDate: '@'
	    },
	    controller: function($scope) {
	      var update = function() {
	        if (!$scope.event) {
	          $scope.detailedMessage = $scope.summaryMessage = null;
	          return;
	        }
	
	        $scope.dateFormat = $scope.fullDate ? "YYYY-MM-DD HH:mm:ss" : "HH:mm:ss";
	
	        var detail = $scope.event.Detail || '';
	        var message = $scope.event.MessageText || '';
	
	        var firstDetail = '';
	        if (detail.length > 0) {
	          firstDetail = detail.split('\n')[0];
	        }
	
	        $scope.detailedMessage = (message.length > 0 ? message + '\n' : '') + detail;
	        $scope.summaryMessage = message.length > 0 ? message : firstDetail;
	      };
	
	      update();
	      $scope.$watch('event', update);
	    }
	  };
	});
	
	
	


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(3);
	angular.module('octopusApp.tasks').directive('taskStatus', taskStatus);
	
	function taskStatus() {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      task: "=",
	      popDirection: "@",
	      previousReleaseNumber: "=",
	      previous: "=",
	      archive: "="
	    },
	    templateUrl: 'areas/tasks/views/task-status.html',
	    terminal: true,
	    bindToController: true,
	    controllerAs: 'vm',
	    controller: function myController($scope, momentFromFilter) {
	      var vm = this;
	      vm.isAlert = false;
	      vm.isSpinning = false;
	      vm.icon = '';
	      vm.tip = '';
	      vm.title = '';
	      vm.stateClass = '';
	
	
	      $scope.$watch(function () {
	        return $scope.vm.task;
	      }, update);
	
	      function update(task) {
	        if (!task) {
	          return;
	        }
	        vm.isAlert = isAlert(task);
	        vm.isSpinning = isSpinning(task);
	        vm.icon = getIcon(task);
	        vm.tip = getTip(task);
	        vm.title = getTitle(task);
	        vm.stateClass = getStateClass(task);
	      }
	
	      function getStateClass(task) {
	        if (task.HasPendingInterruptions && !task.IsCompleted) {
	          return "Paused";
	        }
	        if (task.State === "Success" && task.HasWarningsOrErrors) {
	          return "SuccessWithWarnings";
	        }
	
	        return task.State;
	      }
	
	      function getTitle(task) {
	        if (vm.previousReleaseNumber) {
	          return vm.previousReleaseNumber;
	        }
	        if (task.HasPendingInterruptions && !task.IsCompleted) {
	          return "Waiting...";
	        }
	
	        if (task.State === "Queued") {
	          return "Queued...";
	        }
	
	        if (task.State === "TimedOut") {
	          return "Timed out";
	        }
	        return task.State;
	      }
	
	      function getTip(task) {
	        var duration = task.Duration;
	        var errorMessage = task.ErrorMessage;
	
	        if (task.HasPendingInterruptions && !task.IsCompleted) {
	          return "This task is waiting for manual intervention. Duration: " + duration;
	        }
	        if (task.State === "Cancelling") {
	          return "Cancellation has been requested, attempting to stop the task.";
	        }
	        if (task.State === "Queued") {
	          var timeToExecution = moment(task.QueueTime).fromNow();
	          return "The Octopus Server will process this task in " + timeToExecution + ".";
	        }
	        if (task.State === "Executing") {
	          return "This task is being executed by the Octopus Server. Duration: " + duration;
	        }
	        if (task.State === "Failed") {
	          var tip = "An error occurred whilst processing this task";
	          if (errorMessage && errorMessage.length > 0) {
	            tip = tip + ": " + errorMessage;
	          } else {
	            tip = tip + ". See the task details for more information.";
	          }
	          return tip;
	        }
	        if (task.State === "Canceled") {
	          return "This task was canceled by a user.";
	        }
	        if (task.State === "TimedOut") {
	          var queueTime = moment(task.QueueTime).calendar();
	          var expiryTime =  momentFromFilter(task.QueueTimeExpiry, task.QueueTime);
	          var lastUpdated = moment(task.LastUpdatedTime).calendar();
	          return "The task was scheduled to run " + queueTime + " within " + expiryTime + " but the Octopus Server attempted to run the task at " + lastUpdated + ". This can happen when the Octopus server is too busy to process the task.";
	        }
	
	        if (task.State === "Success") {
	          if (task.HasWarningsOrErrors) {
	            return "This task completed successfully, but warnings or errors were reported in the log. Duration: " + duration;
	          } else {
	            return "This task completed without any problems. Duration: " + duration;
	          }
	        }
	
	        return '';
	      }
	
	      function isSpinning(task) {
	        return task.State === "Executing" && !task.HasPendingInterruptions;
	      }
	
	      function isAlert(task) {
	        return task.State === "Success" && task.HasWarningsOrErrors;
	      }
	
	      function getIcon(task) {
	        if (task.HasPendingInterruptions && !task.IsCompleted) {
	          return "fa-eye";
	        }
	        return iconStateMap[task.State];
	      }
	
	      var iconStateMap = {
	        "Cancelling": "fa-user-times",
	        "Canceled": "fa-user-times",
	        "Queued": "fa-clock-o",
	        "TimedOut": "fa-clock-o",
	        "Executing": "fa-spinner",
	        "Failed": "fa-exclamation-triangle",
	        "Success": "fa-check"
	      };
	    }
	  };
	}
	
	
	
	
	
	


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.tasks');
	
	module.factory('taskStatusRenderer', taskStatusRenderer);
	
	function taskStatusRenderer(octoUtil, momentFromFilter) {
	    function inspector(task) {
	        var pendingInterruptions = task.HasPendingInterruptions;
	        var warningsOrErrors = task.HasWarningsOrErrors;
	        var duration = task.Duration;
	        var errorMessage = task.ErrorMessage;
	        var stateClass = task.State;
	        var description = task.State;
	        var previous = task.IsPrevious;
	        var archive = !task.IsCurrent && !task.IsPrevious;
	        var tip = "";
	        var html = "";
	
	        if (pendingInterruptions && !task.IsCompleted) {
	            html = "<i class='fa fa-eye'></i>";
	            description = "Waiting...";
	            stateClass = "Paused";
	            tip = "This task is waiting for manual intervention. Duration: " + duration;
	        } else if (task.State === "Cancelling") {
	            html = "<i class='fa fa-user-times'></i>";
	            description = "Cancelling";
	            tip = "Cancellation has been requested, attempting to stop the task.";
	        } else if (task.State === "Queued") {
	            html = "<i class='fa fa-clock-o'></i>";
	            description = "Queued...";
	            var timeToExecution = moment(task.QueueTime).fromNow();
	            tip = "The Octopus Server will process this task in " + timeToExecution + ".";
	        } else if (task.State === "Executing") {
	            html = "<i class='fa fa-spinner fa-spin'></i>";
	            tip = "This task is being executed by the Octopus Server. Duration: " + duration;
	        } else if (task.State === "Failed") {
	            html = "<i class='fa fa-exclamation-triangle'></i>";
	            tip = "An error occurred whilst processing this task";
	            if (errorMessage && errorMessage.length > 0) {
	                tip = tip + ": " + errorMessage;
	            } else {
	                tip = tip + ". See the task details for more information.";
	            }
	        } else if (task.State === "Canceled") {
	            html = "<i class='fa fa-user-times'></i>";
	            tip = "This task was canceled by a user.";
	        } else if (task.State === "TimedOut") {
	            html = "<i class='fa fa-clock-o'></i>";
	            description = "Timed out";
	            var queueTime = moment(task.QueueTime).calendar();
	            var expiryTime =  momentFromFilter(task.QueueTimeExpiry, task.QueueTime);
	            var lastUpdated = moment(task.LastUpdatedTime).calendar();
	            tip = "The task was scheduled to run " + queueTime + " within " + expiryTime + " but the Octopus Server attempted to run the task at " + lastUpdated + ". This can happen when the Octopus server is too busy to process the task.";
	        } else if (task.State === "Success") {
	            if (warningsOrErrors) {
	                html = "<i class='fa fa-check'></i><span class='status-overlay'><i class='fa fa-exclamation-triangle'></i></span>";
	                stateClass = "SuccessWithWarnings";
	                tip = "This task completed successfully, but warnings or errors were reported in the log. Duration: " + duration;
	            } else {
	                html = "<i class='fa fa-check'></i>";
	                tip = "This task completed without any problems. Duration: " + duration;
	            }
	        }
	
	        return {
	            tip: tip,
	            html: html,
	            stateClass: stateClass,
	            description: description,
	            previous: previous,
	            archive: archive
	        };
	    }
	
	    function renderer(html, task) {
	        var info = inspector(task);
	        html.push("<span class='status ");
	        html.push(octoUtil.escapeHtml(info.stateClass));
	        if (info.previous) {
	          html.push(" status-previous");
	        }
	        else if (info.archive) {
	          html.push(" status-archive");
	        }
	        html.push("' data-tip='");
	        html.push(octoUtil.escapeHtml(info.tip));
	        html.push("'>");
	        html.push(info.html);
	        html.push("</span>");
	    }
	
	    function updater(task, domElement, previous, archive) {
	        var info = inspector(task);
	
	        domElement.removeClass();
	        domElement.addClass("status");
	        domElement.addClass(info.stateClass);
	        if (previous) {
	            domElement.addClass("status-previous");
	        }
	        if (archive) {
	            domElement.addClass("status-archive");
	        }
	        domElement.attr("data-tip", info.tip);
	
	        domElement.html(info.html);
	
	        domElement.popover("destroy");
	        domElement.popover({
	            title: info.description,
	            content: info.tip,
	            trigger: 'hover',
	            placement: "bottom",
	            container: '#dynamicallyGeneratedContent'
	        });
	    }
	
	    function bindPopovers(domElements) {
	        domElements.each(function () {
	            var domElement = $(this);
	            domElement.popover({
	                title: domElement.text(),
	                content: domElement.data("tip"),
	                trigger: 'hover',
	                placement: "bottom",
	                container: '#dynamicallyGeneratedContent'
	            });
	        });
	    }
	
	    return {
	        inspect: inspector,
	        render: renderer,
	        update: updater,
	        bindPopovers: bindPopovers
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 619 */
/***/ function(module, exports) {

	angular.module('octopusApp.tenants')
	    .directive('advancedTenantSelector', function () {
	        return {
	            restrict: 'E',
	            replace: true,
	            scope: {
	                availableTenants: '=',
	                selectedTenants: '=',
	                selectedTags: '=',
	                selectedEnvironment: '=',
	                hideTenants: '@',
	                applyBorder: '@',
	                tenantFilter: '&?',
	                filterByProjectId: '='
	            },
	            templateUrl: 'areas/tenants/advanced_tenant_selector/advanced_tenant_selector.html',
	            compile: function (element, attrs) {
	                if (!attrs.tenantFilter) {
	                    attrs.tenantFilter = function () {
	                        return null;
	                    };
	                }
	            },
	            controller: function ($scope, $uibModal, octopusTagSets, octopusRepository) {
	                var vm = this;
	                var allTenants = [];
	                vm.availableTagSets = {};
	                vm.applyBorder = (vm.applyBorder || '').toLowerCase() === "false" ? false : true;
	                vm.openTagDesigner = openTagDesigner;
	                vm.getAvailableTenants = getAvailableTenants;
	                vm.showEmptyMessage = showEmptyMessage;
	                vm.matchingTenantText = null;
	
	                function init() {
	                    if (!vm.availableTenants && octopusRepository.Tenants) {
	                        octopusRepository.Tenants.all().then(function (tenants) {
	                            allTenants = tenants;
	                        });
	                    }
	
	                    octopusTagSets.getAll().then(function (tagSets) {
	                        vm.availableTagSets = tagSets.filter(function (ts) {
	                            return ts.Tags.length > 0;
	                        });
	                    });
	
	                    $scope.$watchCollection(function() { return vm.selectedTenants; }, calcMatches);
	                    $scope.$watchCollection(function() { return vm.selectedTags; }, calcMatches);
	                    $scope.$watchCollection(function() { return vm.selectedEnvironment; }, calcMatches);
	                }
	
	                function showEmptyMessage(){
	                    return vm.availableTagSets.length === 0 && vm.hideTenants;
	                }
	
	                function getAvailableTenants() {
	                    return vm.availableTenants || allTenants;
	                }
	
	                function openTagDesigner() {
	                    $uibModal.open({
	                        backdrop: true,
	                        keyboard: true,
	                        templateUrl: 'areas/tenants/advanced_tenant_selector/design_selected_tags_dialog.html',
	                        controller: 'DesignSelectedTagsController',
	                        controllerAs: 'vm',
	                        bindToController: true,
	                        resolve: {
	                            selectedValues: function () {
	                                return {
	                                    selectedTenants: vm.selectedTenants,
	                                    selectedTags: vm.selectedTags
	                                };
	                            },
	                            visibleTenantFilter: function () {
	                                return function (tenant) {
	                                    return checkProjectFilter(tenant) || vm.tenantFilter({tenant: tenant});
	                                };
	                            },
	                            hideTenants: function () {
	                                return vm.hideTenants;
	                            }
	                        }
	                    }).result.then(function (result) {
	                            if (!result) {
	                                return;
	                            }
	                            vm.selectedTenants = result.selectedTenants;
	                            vm.selectedTags = result.selectedTags;
	                        });
	                }
	
	                function checkProjectFilter(tenant) {
	                    if (!vm.filterByProjectId) {
	                        return null;
	                    }
	
	                    var environments = tenant.ProjectEnvironments[vm.filterByProjectId];
	                    if (!environments) {
	                        return "Tenant is not connected to this project.";
	                    }
	
	                    return null;
	                }
	
	                function calcMatches(){
	                    if ((!vm.selectedTenants || vm.selectedTenants.length === 0) && (!vm.selectedTags || vm.selectedTags.length === 0)) {
	                        vm.matchingTenantText = null;
	                        vm.matchingTenantDescription = null;
	                    } else {
	
	                        var validTenantIds = getAvailableTenants().filter(function(tenant) {
	                            return !(checkProjectFilter(tenant) || vm.tenantFilter({tenant: tenant}));
	                        }).map(function(tenant){
	                            return tenant.Id;
	                        });
	
	                        octopusRepository.Tenants.tagTest(vm.selectedTenants, vm.selectedTags).then(function (result) {
	                            var matchCount = vm.getAvailableTenants().reduce(function(sum, tenant) {
	                                if (validTenantIds.indexOf(tenant.Id) === -1) {
	                                    return sum;
	                                }
	
	                                return sum + (result[tenant.Id].IsMatched ? 1 : 0);
	                            }, 0);
	
	                            vm.matchingTenantText = matchCount === 1 ?
	                                "1 matching tenant" :
	                            matchCount + " matching tenants";
	
	                            vm.matchingTenantDescription = "This filter currently results in " + vm.matchingTenantText + ".";
	                        });
	                    }
	                }
	
	                init();
	            },
	            controllerAs: 'vm',
	            bindToController: true
	        };
	    });


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {angular.module('octopusApp.tenants')
	    .directive('appliedTagsList', function() {
	        return {
	            restrict: 'E',
	            replace: true,
	            transclude: false,
	            require: 'ngModel',
	            scope: true,
	            link: function($scope, $element, attr, ngModel) {
	                ngModel.$render = function onRender() {
	                    if(ngModel.$viewValue) {
	                       $scope.vm.reloadTags(ngModel.$viewValue);
	                    }
	                };
	            },
	            controller: function(octopusTagSets) {
	                var vm = this;
	                vm.tags = [];
	                vm.reloadTags = reloadTags;
	
	                function reloadTags(model) {
	                    if(_.all(model, function(a) { return a.hasOwnProperty("Color") && a.hasOwnProperty("Name"); })){
	                        vm.tags = model;
	                    } else {
	                        octopusTagSets.getTag(model).then(function (tags) {
	                            vm.tags = tags;
	                        });
	                    }
	                }
	            },
	            controllerAs: 'vm',
	            bindToController: true,
	            template: '<div class="applied-tags-list">' +
	            '   <div ng-repeat="tag in vm.tags">' +
	            '       <i class="fa fa-square tag-swatch"  ng-style="{ \'color\' : tag.Color}" uib-tooltip="{{tag.Name}}" tooltip-placement="auto top"></i>' +
	            '   </div>' +
	            '</div>'
	        };
	    });
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {angular.module('octopusApp.tenants')
	    .controller('DesignSelectedTagsController', function ($scope, $q, $uibModalInstance, $location, busy, octopusRepository, selectedValues, visibleTenantFilter, octopusTagSets, hideTenants) {
	        var vm = this;
	        vm.isLoading = busy.create();
	        vm.selectedTenants = selectedValues.selectedTenants || [];
	        vm.matchedTenantText = "0 tenants matched";
	        vm.matchedTenants = [];
	        vm.onlyShowMatching = true;
	        vm.hideTenants = hideTenants;
	        vm.close = $uibModalInstance.close;
	        vm.save = save;
	        vm.tenantFilter = tenantFilter;
	        vm.tagsUpdated = tagsUpdated;
	        var allTenants = [];
	
	
	        function tagsUpdated() {
	            var selectedTagList = vm.selectedTags;
	            var allTagList = _.flatten(_.pluck(vm.tagSets, 'Tags'));
	
	            return octopusRepository.Tenants.tagTest(vm.selectedTenants, selectedTagList).then(function (result) {
	
	                var matchCount = 0;
	                vm.matchedTenants = _.map(result, function (tenantTestResult, tenantId) {
	
	
	                    var tenant = allTenants.filter(function (t) {
	                        return t.Id === tenantId;
	                    })[0];
	
	                    var filterOverride = visibleTenantFilter(tenant);
	
	                    if (!tenant) {
	                        return null;
	                    }
	
	                    if (tenantTestResult.IsMatched && !filterOverride) {
	                        matchCount++;
	                    }
	
	                    var matchedTags = _.intersection(selectedTagList, tenant.TenantTags);
	
	                    return {
	                        id: tenantId,
	                        name: tenant.Name,
	                        reason: filterOverride || tenantTestResult.Reason,
	                        isMatched: tenantTestResult.IsMatched && !filterOverride,
	                        isMatchedByName: vm.selectedTenants.indexOf(tenantId) !== -1 && !filterOverride,
	                        missingTags: tenantTestResult.MissingTags,
	                        matchedTags: allTagList.filter(function (tag) {
	                            return matchedTags.indexOf(tag.CanonicalTagName) !== -1;
	                        })
	                    };
	                })
	                    .filter(function (tenant) {
	                        return !!tenant;
	                    })
	                    .sort(function (resultA, resultB) {
	                        if (resultA.isMatched && !resultB.isMatched) {
	                            return -1;
	                        } else if (!resultA.isMatched && resultB.isMatched) {
	                            return 1;
	                        }
	
	                        if (resultA.name < resultB.name) {
	                            return -1;
	                        } else if (resultA.name > resultB.name) {
	                            return 1;
	                        } else {
	                            return 0;
	                        }
	                    });
	
	                vm.matchedTenantText = matchCount + ' matching tenant' + (matchCount === 1 ? '' : 's');
	            });
	        }
	
	        function tenantFilter(value) {
	            return !vm.onlyShowMatching || (vm.onlyShowMatching && value.isMatched);
	        }
	
	        function save() {
	            $uibModalInstance.close({
	                selectedTenants: vm.selectedTenants,
	                selectedTags: vm.selectedTags
	            });
	        }
	
	        function init() {
	            var loadingTagSets = vm.isLoading.promise(octopusTagSets.getAll().then(function (tagSets) {
	                vm.tagSets = tagSets.filter(function (ts) {
	                    return ts.Tags.length > 0;
	                });
	                vm.selectedTags = _.clone(selectedValues.selectedTags);
	            }));
	
	            var loadingTenants = vm.isLoading.promise(octopusRepository.Tenants.all().then(function (tenants) {
	                allTenants = tenants;
	                vm.availableTenants = allTenants.filter(function (tenant) {
	                    return !visibleTenantFilter(tenant);
	                });
	            }));
	
	            $q.all([loadingTagSets, loadingTenants]).then(function () {
	                vm.tagsUpdated();
	            });
	        }
	
	        init();
	    });
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {angular.module('octopusApp.tenants')
	    .directive('filterTagsByTagset', function() {
	    return{
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, element, attr, ngModel){
	            var rootValue = [];
	            var tagSetName = attr["filterTagsByTagset"];
	            var tagsInThisTagSet = scope.vm[attr["filterTagsByTagsetAll"]]
	                .filter(function(a){ return a.Name === tagSetName; })[0]
	                .Tags.map(function(a){ return a.CanonicalTagName; });
	
	            ngModel.$formatters.push(function(value) {
	                rootValue = value || [];
	                return tagsInThisTagSet
	                    .filter(function(a) { return rootValue.indexOf(a) !== -1; });
	            });
	
	            ngModel.$parsers.push(function(value){
	                return _.difference(rootValue, tagsInThisTagSet).concat(value);
	            });
	        }
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.tenants');
	
	module.directive('missingTagList', function($compile, octopusTagSets) {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            tagList: '=',
	            tagsAll: "="
	        },
	        link: function ($scope, $element, attrs) {
	            $scope.$watchCollection('tagList', function() {
	                if (!$scope.tagList || !$scope.tagsAll) {
	                    return;
	                }
	
	                var groupedTags = octopusTagSets.groupByTagSet($scope.tagList);
	                
	                var allTagDetails = _.flatten($scope.tagsAll.map(function(ts) { return ts.Tags; }));
	                var str = "";
	                for (var tagSetName in (groupedTags || {})) {
	                    var tagSet = groupedTags[tagSetName];
	
	                    if (tagSet.length === 0 ){
	                        continue;
	                    }
	
	                    if (str !== "") {
	                        str += " and ";
	                    }
	
	                    if (tagSet.length === 1) {
	                        str += buildTag(allTagDetails, tagSet[0]);
	                    } else {
	                        str += '(';
	                        for(var index = 0; index < tagSet.length; index++) {
	                            var tag = tagSet[index];
	                            if (index === tagSet.length -1){
	                                str += " or ";
	                            } else if (index !== 0) {
	                                str += ", ";
	                            }
	                            var tagHtml = buildTag(allTagDetails, tag);
	                            str += tagHtml;
	                        }
	                        str += ')';
	                    }
	                }
	
	                $element.html(str);
	                $compile($element.contents())($scope);
	            });
	        }
	    };
	
	    function buildTag(allTagDetails, tagName) {
	
	        var thisTagDetails = allTagDetails.filter(function(a) { return a.CanonicalTagName === tagName ; })[0];
	        if (!thisTagDetails) {
	            return '';
	        }
	
	        return '<span class="label label-info" style="background-color:'+ thisTagDetails.Color +'">'+ thisTagDetails.Name +'</span>';
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.tenants');
	
	module.controller('TenantAddProjectDialogController', function ($scope, busy, $uibModalInstance, octopusRepository, existingProjects) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSavingProject = $scope.isSavingProject = busy.create();
	    $scope.adding = { ProjectId: null, Environments: [] };
	    $scope.availableEnvironments = [];
	
	    function init() {
	        isLoading.promise(octopusRepository.Projects.all().then(function (allProjects) {
	            $scope.availableProjects = _.reject(allProjects, function (p) {
	                return _.find(existingProjects, function (existing) {
	                    return existing.Id === p.Id;
	                });
	            });
	        }));
	
	        $scope.$watch('adding.ProjectId', function(newProjectId) {
	            if (!newProjectId) {
	                $scope.selectedProject = null;
	            }
	
	            $scope.selectedProject = _.find($scope.availableProjects, function(p) {
	                return p.Id === newProjectId;
	            });
	        });
	    }
	
	    $scope.getAvailableEnvironments = function () {
	        if ($scope.adding.ProjectId) {
	            isLoading.promise(octopusRepository.Projects.get($scope.adding.ProjectId).then(function (project) {
	                octopusRepository.Progression.getProgression(project).then(function(progression) {
	                    $scope.adding.Environments = [];
	                    $scope.availableEnvironments = progression.Environments;
	                });
	            }));
	        } else {
	            $scope.availableEnvironments = [];
	        }
	    };
	
	    $scope.enableTenantedDeployments = function () {
	        if ($scope.selectedProject) {
	
	            $scope.selectedProject.TenantedDeploymentMode = 'TenantedOrUntenanted';
	            isSavingProject.promise(octopusRepository.Projects.modify($scope.selectedProject));
	        }
	    };
	
	    $scope.close = function () {
	        $uibModalInstance.close();
	    };
	
	    $scope.save = function () {
	        $uibModalInstance.close($scope.adding);
	    };
	
	    init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.tenants');
	
	module.controller('TenantEditProjectDialogController', function ($scope, busy, $uibModalInstance, octopusRepository, project, environments) {
	    var isLoading = $scope.isLoading = busy.create();
	    $scope.projectName = project.Name;
	    $scope.selected = {
	        environmentIds: _.pluck(environments, 'Id')
	    };
	
	    isLoading.promise(octopusRepository.Progression.getProgression(project).then(function(progression) {
	        $scope.availableEnvironments = progression.Environments;
	    }));
	
	    $scope.close = function () {
	        $uibModalInstance.close();
	    };
	
	    $scope.save = function () {
	        $uibModalInstance.close({
	            environmentIds: $scope.selected.environmentIds
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.tenants');
	
	module.controller('TenantIndexController', function ($scope, $q, busy, octopusRepository, octopusTagSets, octopusPermissionSet, $location, octoUtil) {
	    var vm = this;
	    vm.isLoading = busy.create();
	    vm.tenants = [];
	    vm.searchText = null;
	    vm.searchApplied = null;
	    vm.searchTenantsByName = searchTenantsByName;
	    vm.clearSearch = clearSearch;
	    vm.tenantTagSetDetails = [];
	    vm.toggleTagSetDisplay = toggleTagSetDisplay;
	    vm.tagFilters = [];
	    vm.selectedTags = [];
	    vm.isFiltered = false;
	    vm.addTagToFilter = addTagToFilter;
	    vm.removeTagFromFilter = removeTagFromFilter;
	    vm.loadMoreTenants = loadMoreTenants;
	    vm.loadAllTenants = loadAllTenants;
	    vm.allTenantsLoaded = false;
	    var tenantFilter = {};
	
	    function loadAllTenants() {
	        vm.isLoading.promise(octopusRepository.Tenants.all().then(function (results) {
	            vm.tenantsList = results;
	            vm.tenants = {};
	
	            var environmentsById = _.object(_.pluck(vm.environments, "Id"), vm.environments);
	            var projectsById = _.object(_.pluck(vm.projects, "Id"), vm.projects);
	
	            vm.tenantsList.forEach(function (tenant) {
	                tenant.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);
	
	                tenant.isMissingVariable = function () {
	                    if (!vm.tenantsMissingVariables) {
	                        return null;
	                    }
	                    return vm.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
	                };
	
	                tenant.projectEnvironmentMap = buildProjectEnvironmentMap(tenant, projectsById, environmentsById);
	            });
	            vm.allTenantsLoaded = true;
	        }));
	    }
	
	    function loadMoreTenants(skip) {
	        extractSearchAndFilterParams();
	
	        var allArgs = {};
	        if (skip) {
	            allArgs = _.extend(skip > 0 ? {skip: skip} : {}, tenantFilter || {});
	        }
	        octopusRepository.Tenants.list(allArgs).then(function (tenants) {
	            vm.tenantsList = vm.tenantsList.concat(tenants.Items);
	            vm.tenants = tenants;
	        });
	    }
	
	    function buildProjectEnvironmentMap(tenant, projectsById, environmentsById) {
	        var projectEnvironmentMap = _.chain(tenant.ProjectEnvironments).map(function (environmentIds, projectId) {
	            return {
	                project: projectsById[projectId],
	                environments: _.chain(environmentIds).map(function (id) {
	                    return environmentsById[id];
	                }).filter(function (environment) {
	                    return !!environment;
	                }).sortBy(function (environment) {
	                    return environment.SortOrder;
	                }).value()
	            };
	        }).filter(function (x) {
	            return !!x.project;
	        }).sortBy(function (x) {
	            return x.project.Name;
	        }).value();
	
	        return projectEnvironmentMap;
	    }
	
	    function searchTenantsByName() {
	        if (!vm.searchText || vm.searchText.length === 0) {
	            return;
	        }
	
	        if (vm.searchText !== vm.searchApplied) {
	            $location.search("name", vm.searchText);
	            vm.isFiltered = true;
	            refreshTenants();
	        }
	    }
	
	    function clearSearch() {
	        vm.searchText = vm.searchApplied = null;
	        $location.search("name", null);
	
	        refreshTenants();
	
	        vm.isFiltered = vm.selectedTags.length > 0;
	    }
	
	    function toggleTagSetDisplay(tenantTagSetDetail) {
	        tenantTagSetDetail.showTags = !tenantTagSetDetail.showTags;
	    }
	
	    function addTagToFilter(tag) {
	        var tagsVal = $location.search().tags;
	
	        if (!tagsVal) {
	            tagsVal = [];
	        }
	        if (typeof tagsVal === "string") {
	            tagsVal = [tagsVal];
	        }
	
	        var index = tagsVal.indexOf(tag.CanonicalTagName);
	        if (index < 0) {
	            tagsVal.push(tag.CanonicalTagName);
	            vm.selectedTags.push(tag);
	            $location.search('tags', tagsVal);
	            vm.isFiltered = true;
	            refreshTenants();
	        }
	    }
	
	    function removeTagFromFilter(tag) {
	
	        var tagsVal = $location.search().tags;
	        if (!tagsVal) {
	            tagsVal = [];
	        }
	        if (typeof tagsVal === "string") {
	            tagsVal = [tagsVal];
	        }
	
	        var indexForControllerCache = vm.selectedTags.indexOf(tag);
	        if (indexForControllerCache >= 0) {
	            vm.selectedTags.splice(indexForControllerCache, 1);
	        }
	
	        var indexForQueryString = tagsVal.indexOf(tag.CanonicalTagName);
	        if (indexForQueryString >= 0) {
	            tagsVal.splice(indexForQueryString, 1);
	            $location.search('tags', tagsVal);
	        }
	
	        if (indexForControllerCache >= 0 || indexForQueryString >= 0) {
	            vm.isFiltered = (vm.searchApplied != null && vm.searchApplied.length > 0) || vm.selectedTags.length > 0;
	            refreshTenants();
	        }
	    }
	
	    function extractSearchAndFilterParams() {
	
	        if ($location.search().name) {
	            vm.searchApplied = $location.search().name;
	        }
	        if ($location.search().tags) {
	            var tagsVal = $location.search().tags;
	            if (typeof tagsVal === "string") {
	                vm.tagFilters = [tagsVal];
	            }
	            if (tagsVal.length > 0) {
	                vm.tagFilters = tagsVal;
	            }
	        }
	
	        _.extend(tenantFilter, { name : vm.searchApplied });
	        _.extend(tenantFilter, { tags : vm.tagFilters });
	    }
	
	    function refreshTenants(skip) {
	
	        extractSearchAndFilterParams();
	
	        var tenantLoader = vm.allTenantsLoaded 
	            ? octopusRepository.Tenants.all(tenantFilter) 
	            : octopusRepository.Tenants.list(tenantFilter);
	
	        vm.isLoading.promise(tenantLoader.then(function (results) {
	            vm.tenantsList = results.Items || results;
	            vm.tenants = results.Items ? results : {};
	
	            var environmentsById = _.object(_.pluck(vm.environments, "Id"), vm.environments);
	            var projectsById = _.object(_.pluck(vm.projects, "Id"), vm.projects);
	
	            vm.tenantsList.forEach(function (tenant) {
	                tenant.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);
	
	                tenant.isMissingVariable = function () {
	                    if (!vm.tenantsMissingVariables) {
	                        return null;
	                    }
	                    return vm.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
	                };
	
	                tenant.projectEnvironmentMap = buildProjectEnvironmentMap(tenant, projectsById, environmentsById);
	            });
	        }));
	    }
	
	    function init() {
	        var projectsLoader = octopusPermissionSet.isAuthorized({
	            permission: 'ProjectView',
	            projectId: '*'
	        }).then(function (isAuthorized) {
	            return isAuthorized ? octopusRepository.Projects.all() : [];
	        });
	
	        var environmentsLoader = octopusPermissionSet.isAuthorized({
	            permission: 'EnvironmentView',
	            environmentId: '*'
	        }).then(function (isAuthorized) {
	            return isAuthorized ? octopusRepository.Environments.all() : [];
	        });
	
	        extractSearchAndFilterParams();
	
	        var tenantLoader = octopusRepository.Tenants.list(tenantFilter);
	        var tenantTagSetLoader = octopusTagSets.getAll();
	
	        var loaders = [tenantLoader, projectsLoader, environmentsLoader, tenantTagSetLoader];
	        vm.isLoading.promise($q.all(loaders).then(function (results) {
	            vm.tenantsList = results[0].Items;
	            vm.tenants = results[0];
	            vm.projects = results[1];
	            vm.environments = results[2];
	            var tagSets = _.sortBy(results[3], function (tagSet) {
	                return tagSet.SortOrder;
	            });
	            vm.tenantTagSetDetails = _.map(tagSets, function (tagSet) {
	                tagSet.Tags = _.sortBy(tagSet.Tags, function (tag) {
	                    return tag.SortOrder;
	                });
	                return {
	                    showTags: true,
	                    tagSet: tagSet
	                };
	            });
	
	            if ((vm.tagFilters.length > 0) && vm.selectedTags.length === 0) {
	                var allTags = [];
	                _.map(tagSets, function (tagSet) {
	                    _.map(tagSet.Tags, function (tag) {
	                        allTags[tag.CanonicalTagName] = tag;
	                    });
	                });
	                _.forEach(tenantFilter.tags, function (canonicalTagName) {
	                    var tag = allTags[canonicalTagName];
	                    vm.selectedTags.push(tag);
	                });
	
	                vm.isFiltered = vm.selectedTags.length > 0;
	            }
	
	            var environmentsById = _.object(_.pluck(vm.environments, "Id"), vm.environments);
	            var projectsById = _.object(_.pluck(vm.projects, "Id"), vm.projects);
	
	            vm.tenantsList.forEach(function (tenant) {
	                tenant.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);
	
	                tenant.isMissingVariable = function () {
	                    if (!vm.tenantsMissingVariables) {
	                        return null;
	                    }
	                    return vm.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
	                };
	
	                tenant.projectEnvironmentMap = buildProjectEnvironmentMap(tenant, projectsById, environmentsById);
	            });
	        }));
	
	        octopusRepository.Tenants.missingVariables(false).then(function (result) {
	            vm.tenantsMissingVariables = _.pluck(result, 'TenantId');
	        });
	    }
	
	    init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 627 */
/***/ function(module, exports) {

	angular.module('octopusApp.tenants')
	    .controller('TenantLayoutController', function ($scope, tenantState) {
	        var self = this;
	        self.tenant = null;
	        self.tenantId = tenantState.tenantId;
	        self.isLoading = tenantState.isLoading;
	        self.isSaving = tenantState.isSaving;
	        self.tenantState = tenantState;
	        $scope.$watch(function () {
	            return tenantState.tenant;
	        }, function (tenant) {
	            self.tenant = tenant;
	        });
	    }).provider('tenantState', function() {
	        this.$get = function($stateParams, busy, octopusRepository) {
	            var state = {
	                isLoading: busy.create(),
	                isSaving: busy.create(),
	                tenantId: $stateParams.tenantId,
	                tenantIdAsync: null
	            };
	
	            function load() {
	                state.tenantIdAsync = octopusRepository.Tenants.get(state.tenantId);
	                state.isLoading.promise(state.tenantIdAsync.then(function (tenant) {
	                    state.tenant = tenant;
	                }));
	                return state.tenantIdAsync;
	            }
	
	            state.load = load;
	            return state;
	        };
	    });

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.tenants');
	
	module.controller('TenantLogoController', function($scope, $location, $stateParams, $state, tenantState, busy, octopusRepository, octoUploader, octopusClient) {
	    var vm = this;
	    var tenantId = tenantState.tenantId;
	    var octoUpload = octoUploader.create($scope);
	
	    vm.isUploading = busy.create();
	    vm.octoUpload = octoUpload;
	    vm.beginReset = beginReset;
	    vm.beginUpload = beginUpload;
	    vm.cancel = cancel;
	
	    function cancel() {
	        octoUpload.cancel();
	
	        var form = $("#logoUpload")[0];
	        if (form) {
	            form.reset();
	        }
	    }
	
	    function init() {
	        tenantState.isLoading.promise(tenantState.load().then(onTenantLoaded));
	    }
	
	    function beginUpload() {
	        var url = octopusClient.resolve(vm.tenant.Links['Logo']);
	        vm.isUploading.promise(octoUpload.begin(url).then(function () {
	            $state.reload();
	            //$location.path('/tenants/' + vm.tenant.Id);
	        }));
	    }
	
	    function beginReset() {
	        vm.isUploading.promise(octopusClient.put(vm.tenant.Links['Logo'], null).then(function () {
	            $state.reload();
	            //$location.path('/tenants/' + vm.tenant.Id);
	        }));
	    }
	
	    function onTenantLoaded(tenant) {
	        vm.tenant = tenant;
	    }
	
	    init();
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.tenants');
	
	module.controller('TenantOverviewController', function($scope, $q, $location,tenantState, $state,  busy, unsavedChanges, octopusRepository, octopusTagSets, missingTenantVariablesLoader) {
	    var vm = this;
	    var tenantId = tenantState.tenantId;
	    vm.isSaving = tenantState.isSaving;
	    vm.isLoading = tenantState.isLoading;
	    vm.save = save;
	
	    function init() {
	        tenantState.isLoading.promise(tenantState.load().then(function (tenant) {
	            tenantState.tenant = tenant;
	            vm.tenant = tenant;
	            return octopusTagSets.getAll().then(function (tagSets) {
	                vm.tagSets = tagSets;
	                vm.hasTagSets = vm.tagSets.length > 0;
	                vm.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);
	            });
	        }));
	
	        tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);
	    }
	    
	    function save() {
	        vm.tenant.TenantTags = _.flatten(_.values(vm.selectedTagSets));
	        vm.isSaving.promise(octopusRepository.Tenants.modify(vm.tenant).then(function () {
	            unsavedChanges.saved();
	            $state.reload();
	        }));
	    }
	
	    init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 630 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tenants');
	
	module.controller('TenantSettingsController', function($scope, $q, $location, $state, $stateParams, tenantState, busy, octopusRepository, unsavedChanges, octoDialog, missingTenantVariablesLoader) {
	    var vm = this;
	    var tenantId = tenantState.tenantId;
	    vm.isLoading = busy.create();
	    vm.isSaving = busy.create();
	
	    vm.save = save;
	    vm.deleteTenant = deleteTenant;
	  
	
	    function init() {
	        if (tenantId) {
	            tenantState.load().then(function(tenant){ vm.tenant = tenant; });
	            tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);
	        } else {
	            vm.tenant = { Id: null, Name: '', ProjectIds: [], ProjectEnvironments: {} };
	        }
	    }
	    
	    function save() {
	        var doSave = vm.tenant.Id ?
	            octopusRepository.Tenants.modify(vm.tenant).then(function() {
	                unsavedChanges.saved();
	                //$location.path('/tenants/'+ vm.tenant.Id);
	                $state.reload();
	            }):
	            octopusRepository.Tenants.create(vm.tenant).then(function(tenant){
	                unsavedChanges.saved();
	                $location.path('/tenants/'+ tenant.Id);
	            });
	
	        vm.isSaving.promise(doSave);
	    }
	
	    function deleteTenant() {
	        var dlg = octoDialog.confirmDelete('tenant', function () {
	            return octopusRepository.Tenants.delete(vm.tenant);
	        });
	        dlg.then(function (result) {
	            if (result) {
	                $location.path('/tenants');
	            }
	        });
	    }
	
	    init();
	});

/***/ },
/* 631 */
/***/ function(module, exports) {

	angular.module('octopusApp.tenants')
	    .directive('tenantLogo', function() {
	        return {
	            restrict: 'E',
	            replace: true,
	            scope: {
	                tenant: '=',
	                maxSize: "@"
	            },
	            template: '<img ng-src="{{ tenant.Links.Logo | resolveLink }}?cb={{random}}" style="max-width: {{maxSize}}; max-height: {{maxSize}}" ng-show="tenant.Links.Logo"/>',
	            link: function ($scope, element, attr) {
	                $scope.random = Math.round(new Date().getTime() / 1000);
	            }
	        };
	    });

/***/ },
/* 632 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tenants');
	
	module.directive('tenantStatusPopover', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            tenant: '=',
	            projectsById: '=',
	            environmentsById: '='
	        },
	        templateUrl: 'areas/tenants/views/tenant_status_popover.html',
	        link: function ($scope) {
	            $scope.getIconStyle = function () {
	                var isMissingVariable = $scope.tenant.isMissingVariable();
	                if (isMissingVariable == null) {
	                    return 'fa-spinner fa-pulse';
	                }
	                return isMissingVariable ? 'fa-warning text-warning' : 'fa-info-circle';
	            };
	        }
	    };
	});

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.tenants');
	
	module.directive('tenantSummary', function() {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            tenant: '=',
	            projects: '=',
	            environments: '='
	        },
	        templateUrl: 'areas/tenants/views/tenant_summary.html',
	        link: function (scope, element) {
	        },
	        controller: function ($scope) {
	            $scope.projectsById = _.object(_.pluck($scope.projects, "Id"), $scope.projects);
	            $scope.environmentsById = _.object(_.pluck($scope.environments, "Id"), $scope.environments);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 634 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.tenants');
	
	module.directive('tenantTag', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        require: 'ngModel',
	        scope: true,
	        link: function($scope, $element, attr, ngModel) {
	            $scope.vm.isSwatch = (attr["mode"] === 'swatch');
	            ngModel.$render = function onRender() {
	                if (ngModel.$viewValue) {
	                    $scope.vm.reloadTag(ngModel.$viewValue);
	                }
	            };
	        },
	        controller: function(octopusTagSets) {
	            var vm = this;
	            vm.tag = null;
	            vm.reloadTag = reloadTag;
	
	            function reloadTag(model) {
	                if (typeof model === 'string'){
	                    octopusTagSets.getTag(model).then(function (tag) {
	                        vm.tag = tag;
	                    });
	                } else {
	                    vm.tag = model;
	                }
	            }
	        },
	        controllerAs: 'vm',
	        bindToController: true,
	        template: '<span>' +
	        '   <span ng-if="vm.tag">' +
	            '   <i class="fa fa-square tag-swatch" ng-style="{\'color\': vm.tag.Color}" uib-tooltip="{{::vm.tag.Name}}" ng-if="::vm.isSwatch" tooltip-placement="auto top"></i>' +
	            '   <span class="label label-info"   ng-style="{ \'background-color\': vm.tag.Color}"  ng-if="::!vm.isSwatch" uib-tooltip="{{::vm.tag.Description}}" tooltip-placement="auto top">' +
	            '       {{vm.tag.Name}}' +
	            '   </span>' +
	        '   </span>' +
	        '</span>'
	    };
	});


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.tenants');
	
	module.directive('tenantsProjectSelector', function () {
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: false,
	        scope: {
	            tenant: '='
	        },
	        templateUrl: 'areas/tenants/views/tenants-project-selector.html',
	        controllerAs: 'vm',
	        bindToController: true,
	        link: function ($scope) {
	
	        },
	        controller: function ($q, $uibModal, busy, unsavedChanges, octopusPermissionSet, octopusRepository) {
	            var vm = this;
	            vm.isLoading = busy.create();
	            vm.editProjectEnvironmentMapping = editProjectEnvironmentMapping;
	            vm.addProjectEnvironmentMapping = addProjectEnvironmentMapping;
	            vm.removeProjectEnvironmentMapping = removeProjectEnvironmentMapping;
	            vm.environmentsById = {};
	            vm.projectsById = {};
	
	            function init() {
	
	                vm.isLoading.promise(permissionCheck()
	                    .then(function (isAuthorized) {
	                        if (!isAuthorized) {
	                            return;
	                        }
	
	                        buildProjectEnvironmentMap();
	                    }));
	            }
	
	
	            function loadEnvironments() {
	                var environmentIds = _.unique(_.flatten(_.values(vm.tenant.ProjectEnvironments)));
	                if (_.any(environmentIds, function (envId) { return !vm.environmentsById[envId]; })) {
	                    return octopusRepository.Environments.all({ids: environmentIds}).then(function (environments) {
	                        vm.environmentsById = _.object(_.pluck(environments, "Id"), environments);
	                    });
	                }
	                return $q.resolve();
	            }
	
	            function loadProjects() {
	                var projectIds = Object.keys(vm.tenant.ProjectEnvironments);
	                if (_.any(projectIds, function (pid) { return !vm.projectsById[pid]; })) {
	                    return octopusRepository.Projects.all({ids: projectIds}).then(function (projects) {
	                        vm.projectsById = _.object(_.pluck(projects, "Id"), projects);
	                    });
	                }
	                return $q.resolve();
	            }
	
	            function permissionCheck() {
	                return octopusPermissionSet.isAuthorized({
	                    permission: 'ProjectView',
	                    projectId: '*'
	                }).then(function (isAuthorized) {
	                    if (!isAuthorized) {
	                        return false;
	                    }
	                    return octopusPermissionSet.isAuthorized({permission: 'EnvironmentView', environmentId: '*'});
	                });
	            }
	
	            function buildProjectEnvironmentMap() {
	                vm.isLoading.promise($q.all([loadProjects(), loadEnvironments()]).then(function () {
	                    if (vm.tenant && vm.projectsById && vm.environmentsById) {
	                        vm.projectEnvironmentMap = _.chain(vm.tenant.ProjectEnvironments).map(function (environmentIds, projectId) {
	                            return {
	                                project: vm.projectsById[projectId],
	                                environments: _.chain(environmentIds).map(function (id) {
	                                    return vm.environmentsById[id];
	                                }).filter(function (environment) {
	                                    return !!environment;
	                                }).sortBy(function (environment) {
	                                    return environment.SortOrder;
	                                }).value()
	                            };
	                        }).filter(function (x) {
	                            return !!x.project;
	                        }).sortBy(function (x) {
	                            return x.project.Name;
	                        }).value();
	                    }
	                }));
	            }
	
	            function editProjectEnvironmentMapping(projectId) {
	                var mapping = _.find(vm.projectEnvironmentMap, function (map) {
	                    return map.project.Id === projectId;
	                });
	                $uibModal.open({
	                    backdrop: true,
	                    keyboard: true,
	                    templateUrl: 'areas/tenants/views/tenant_edit_project_dialog.html',
	                    controller: 'TenantEditProjectDialogController',
	                    resolve: {
	                        project: function () {
	                            return mapping.project;
	                        },
	                        environments: function () {
	                            return mapping.environments;
	                        }
	                    }
	                }).result.then(function (result) {
	                    if (result) {
	                        var unavailableEnvironments = vm.tenant.ProjectEnvironments[projectId].filter(function(envId) {
	                            return !_.any(mapping.environments, function(e) { return e.Id === envId; });
	                        });
	                        vm.tenant.ProjectEnvironments[projectId] = unavailableEnvironments.concat(result.environmentIds);
	                        buildProjectEnvironmentMap();
	                        unsavedChanges.unsaved();
	                    }
	                });
	            }
	
	            function addProjectEnvironmentMapping() {
	                var existingProjects = _.pluck(vm.projectEnvironmentMap, 'project');
	
	                $uibModal.open({
	                    backdrop: true,
	                    keyboard: true,
	                    templateUrl: 'areas/tenants/views/tenant_add_project_dialog.html',
	                    controller: 'TenantAddProjectDialogController',
	                    resolve: {
	                        existingProjects: function () {
	                            return existingProjects;
	                        }
	                    }
	                }).result.then(function (result) {
	                    if (result) {
	                        if (_.contains(vm.tenant.ProjectIds, result.ProjectId)) {
	                            return;
	                        }
	                        unsavedChanges.unsaved();
	                        vm.tenant.ProjectEnvironments[result.ProjectId] = result.Environments;
	                        buildProjectEnvironmentMap();
	                    }
	                });
	            }
	
	            function removeProjectEnvironmentMapping(projectId) {
	                delete vm.tenant.ProjectEnvironments[projectId];
	                buildProjectEnvironmentMap();
	                unsavedChanges.unsaved();
	            }
	
	            init();
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.factory('missingTenantVariablesLoader', function($q, octopusRepository) {
	
	    return {
	        missingVariables: function(tenantId){
	            var missingByTemplate = [];
	            var loadingPromise = $q.defer();
	            var vm  = {
	                isLoading: true,
	                loadingAsync: loadingPromise.promise,
	                isMissingVariable: false,
	                isMissingProjectVariable: false,
	                isMissingLibraryVariable: false,
	                isMissing: isMissing
	            };
	
	            function isMissing(templateId, environmentId) {
	                if (!missingByTemplate[templateId]) {
	                    return false;
	                }
	
	                return _.any(missingByTemplate[templateId], function(missing){
	                    return missing.EnvironmentId === environmentId;
	                });
	            }
	
	            octopusRepository.Tenants.missingVariables({
	                tenantId: tenantId
	            }, true).then(function (result) {
	                vm.isLoading = false;
	                vm.isMissingVariable = result.length > 0;
	                if (vm.isMissingVariable) {
	                    missingByTemplate = _.groupBy(result[0].MissingVariables, function(item) { return item.VariableTemplateId; });
	                    var missingProjectVariables = result[0].MissingVariables.filter(function(a) { return !!a.ProjectId; });
	                    vm.isMissingProjectVariable = missingProjectVariables.length > 0;
	                    vm.isMissingLibraryVariable = ( result[0].MissingVariables.length - missingProjectVariables.length) > 0;
	                }
	                loadingPromise.resolve(vm);
	            }, function(err) {
	                loadingPromise.reject(err);
	            });
	            return vm;
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 637 */
/***/ function(module, exports) {

	angular.module('octopusApp.tenants')
	        .controller('TenantVariablesLayoutController', function($rootScope, tenantState, tabState) {
	        this.tenantState = tenantState;
	        this.tenantId = tenantState.tenantId;
	        this.isLoading = tabState.isLoading;
	        this.isSaving = tenantState.isSaving;
	        this.showMissingVariablesMessage = function showMissingVariablesMessage() {
	            if (!tenantState.missingVariables) {
	                return false;
	            }
	
	            return (tenantState.missingVariables.isMissingLibraryVariable && $rootScope.layout.variableTab === 'library') ||
	                (tenantState.missingVariables.isMissingProjectVariable && $rootScope.layout.variableTab === 'projects');
	        };
	    }).provider('tenantVariablesState', function() {
	        this.$get = function($stateParams, busy, octopusRepository) {
	            var state = {
	                isLoading: busy.create(),
	                isSaving: busy.create(),
	                tenantId: $stateParams.tenantId,
	                tenantIdAsync: null
	            };
	
	            function load() {
	                state.tenantIdAsync = octopusRepository.Tenants.get(state.tenantId);
	                state.isLoading.promise(state.tenantIdAsync.then(function (tenant) {
	                    state.tenant = tenant;
	                }));
	                return state.tenantIdAsync;
	            }
	
	            state.load = load;
	            return state;
	        };
	    });

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('TenantVariablesLibraryController', function ($scope, $q, $location, $state, tenantState, tabState, octopusPermissionSet, octopusRepository, unsavedChanges, missingTenantVariablesLoader) {
	    var vm = this;
	    var tenantId = tenantState.tenantId;
	    vm.libraryTemplateDetails = [];
	    vm.hasLibraryTemplates = false;
	    vm.save = save;
	    vm.isLibraryFiltered = isLibraryFiltered;
	
	    vm.allAccounts = [];
	    var variables;
	
	    function isLibraryFiltered(libraryVariableSet) {
	        return libraryVariableSet.templates.length > 0;
	    }
	
	    function init() {
	        tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);
	
	        octopusPermissionSet.isAuthorized({permission: 'LibraryVariableSetView'}).then(function (isAuthorized) {
	            if (!isAuthorized) {
	                return $location.path("/tenants/" + tenantId + "/variables/projects");
	            }
	
	            tabState.isLoading.promise(tenantState.load()
	                .then(function (tenant) {
	                    vm.tenant = tenant;
	                    return octopusRepository.Tenants.getVariables(tenant);
	                }).then(function (tenantVariables) {
	                    variables = tenantVariables;
	                }).then(loadAccountsIfAzurePresent)
	                .then(refreshLibraryTemplates)
	            );
	
	            tabState.isLoading.promise(tenantState.missingVariables.loadingAsync);
	        });
	    }
	
	    function loadAccountsIfAzurePresent(){
	        var areAnyTemplateTypesAzure = _.any(variables.LibraryVariables, function (lvs) {
	            return _.any(lvs.Templates, isAzureAccountTemplate);
	        });
	
	        if (areAnyTemplateTypesAzure) {
	            return octopusRepository.Accounts.all().then(function (acc) {
	                vm.allAccounts = acc;
	            });
	        }
	
	        function isAzureAccountTemplate(template) {
	            return template.DisplaySettings['Octopus.ControlType'] === 'AzureAccount';
	        }
	    }
	
	    function refreshLibraryTemplates() {
	        vm.hasLibraryTemplates = false;
	        vm.libraryTemplateDetails = _.map(variables.LibraryVariables, function(libraryVariableDetails, id) {
	            vm.hasLibraryTemplates = vm.hasLibraryTemplates || libraryVariableDetails.Templates.length > 0;
	
	            _.each(libraryVariableDetails.Templates, function (template) {
	                if (!libraryVariableDetails.Variables[template.Id] && typeof template.DefaultValue !== 'undefined' && template.DefaultValue !== null && template.DefaultValue !== '') {
	                    libraryVariableDetails.Variables[template.Id] = template.DefaultValue;
	                }
	                template.isMissingValue = tenantState.missingVariables.isMissing(template.Id);
	            });
	
	            return {
	                id: libraryVariableDetails.LibraryVariableSetId,
	                name: libraryVariableDetails.LibraryVariableSetName,
	                templates: libraryVariableDetails.Templates,
	                localNames: _.pluck(libraryVariableDetails.Templates, "Name"),
	                Properties: libraryVariableDetails.Variables
	            };
	        });
	    }
	
	    function save() {
	        variables.LibraryVariableSetVariableTemplates = modelToResource();
	
	        tenantState.isSaving.promise(octopusRepository.Tenants.setVariables(vm.tenant, variables).then(function (a) {
	            unsavedChanges.saved();
	            init();
	        }));
	
	        function modelToResource() {
	            return vm.libraryTemplateDetails.reduce(function (idx, a) {
	                idx[a.id] = {
	                    LibraryVariableSetId: a.id,
	                    LibraryVariableSetName: a.name,
	                    Templates: a.templates,
	                    Variables: a.Properties
	                };
	                return idx;
	            }, {});
	        }
	    }
	
	    init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.projects');
	
	module.controller('TenantVariablesProjectsController', function ($scope, $q, $state, tenantState, tabState,  busy, octopusRepository, unsavedChanges, missingTenantVariablesLoader) {
	    var vm = this;
	    var tenantId = tenantState.tenantId;
	    vm.projectTemplateDetails = [];
	    vm.hasProjectTemplates = false;
	    vm.filteredProjectId = null;
	    vm.tenantProjects = [];
	    vm.save = save;
	    vm.refreshTenantVariables = refreshTenantVariables;
	    vm.isProjectFiltered = isProjectFiltered;
	
	    var projectsById = {};
	    var environmentsById = {};
	    var variables;
	    var accounts = [];
	    var projects = [];
	
	    function isProjectFiltered(projectVariables){
	        return projectVariables.project.Templates.length > 0 && (!vm.filteredProjectId || projectVariables.project.Id === vm.filteredProjectId);
	    }
	
	    function isAzureAccountTemplate(template) {
	        return template.DisplaySettings['Octopus.ControlType'] === 'AzureAccount';
	    }
	
	    function init() {
	        tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);
	
	        tabState.isLoading.promise(tenantState.load().then(function (tenant) {
	            vm.tenant = tenant;
	            return $q.all([loadEnvironments(tenant), loadProjects(tenant), loadVariables(tenant)]);
	        }).then(function () {
	            setApplicableProjects();
	            refreshTenantVariables();
	        }));
	
	        tabState.isLoading.promise(tenantState.missingVariables.loadingAsync);
	    }
	
	
	
	    function loadVariables(tenant) {
	        return octopusRepository.Tenants.getVariables(tenant).then(function (tenantVariables) {
	            variables = tenantVariables;
	        });
	    }
	
	    function loadEnvironments(tenant) {
	        var environmentIds = _.unique(_.flatten(_.values(tenant.ProjectEnvironments)));
	        return octopusRepository.Environments.all({ids: environmentIds}).then(function (environments) {
	            environmentsById = _.object(_.pluck(environments, "Id"), environments);
	        });
	    }
	
	    function loadProjects(tenant) {
	        var projectIds = Object.keys(tenant.ProjectEnvironments);
	        return octopusRepository.Projects.all({ids: projectIds}).then(function (proj) {
	            projects = proj;
	            projectsById = _.object(_.pluck(projects, "Id"), projects);
	
	            if (_.any(projects, function (project) {
	                    return _.any(project.Templates, isAzureAccountTemplate);
	                })) {
	                return octopusRepository.Accounts.all().then(function (acc) {
	                    accounts = acc;
	                });
	            }
	        });
	    }
	
	    function setApplicableProjects() {
	        vm.tenantProjects = projects.filter(function (project) {
	            return Object.keys(variables.ProjectVariables).indexOf(project.Id) !== -1;
	        });
	    }
	
	    function cloneTemplatesWithValues(project, envId, variables) {
	        return project.Templates.map(function (template) {
	            var templateCopy = _.clone(template);
	            if (isAzureAccountTemplate(template)) {
	                templateCopy.selectOptions = {
	                    'AzureAccount': accounts.filter(function (acc) {
	                        return !acc.EnvironmentIds || acc.EnvironmentIds.length === 0 || acc.EnvironmentIds.indexOf(envId) !== -1;
	                    })
	                };
	            }
	            templateCopy.DisplaySettings = _.clone(template.DisplaySettings);
	            templateCopy.value = variables[template.Id] || template.DefaultValue;
	            templateCopy.isMissingValue = tenantState.missingVariables.isMissing(template.Id, envId);
	            return templateCopy;
	        });
	    }
	
	    function refreshTenantVariables() {
	        vm.hasProjectTemplates = false;
	        vm.projectTemplateDetails = _.map(variables.ProjectVariables, function(projectVariable) {
	            var project = projectsById[projectVariable.ProjectId];
	            var templates = _.map(projectVariable.Variables, function (variables, envId) {
	                return {
	                    environmentId: envId,
	                    environment: environmentsById[envId],
	                    templates: cloneTemplatesWithValues(project, envId, variables)
	                };
	            });
	
	            vm.hasProjectTemplates = vm.hasProjectTemplates || projectVariable.Templates.length > 0;
	            return {
	                project: project,
	                environmentIds: Object.keys(projectVariable.Variables),
	                templatesByEnvironment: templates
	            };
	        });
	    }
	
	    function save() {
	        variables.ProjectVariables = modelToResource();
	        tenantState.isSaving.promise(octopusRepository.Tenants.setVariables(vm.tenant, variables).then(function (a) {
	            unsavedChanges.saved();
	            init();
	
	        }));
	
	        function modelToResource() {
	            return vm.projectTemplateDetails.reduce(function(idx, val) {
	                idx[val.project.Id] = {
	                    ProjectId: val.project.Id,
	                    ProjectName: val.project.Name,
	                    Templates: val.project.Templates,
	                    Variables: mapEnvironmentsToResource(val.templatesByEnvironment)
	                };
	                return idx;
	            }, {});
	
	            function mapEnvironmentsToResource(templatesByEnvironment){
	                return templatesByEnvironment.reduce(function(idx, val){
	                    idx[val.environmentId] =  mapTemplatesToResource(val.templates);
	                    return idx;
	                }, {});
	            }
	
	            function mapTemplatesToResource(templates){
	                return templates.reduce(function(a, b) { a[b.Id] = b.value; return a;}, {});
	            }
	        }
	    }
	
	    init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 640 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.users');
	
	module.controller('AuthProviderController', function ($scope) {
	
	    $scope.name = $scope.provider.Name;
	
	    $scope.linkHtml = $scope.provider.LinkHtml;
	});
	


/***/ },
/* 641 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.users');
	
	module.controller('ProfileController', function($scope, $window, $location, octoDialog, busy, octopusRepository, octopusPermissionSet) {
	    var isLoading = $scope.isLoading = busy.create();
	    var isSaving = $scope.isSaving = busy.create();
	
	    $scope.tab = "profile";
	    $scope.changeTab = function (v) { $scope.tab = v; };
	
	    isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
	        isLoading.promise(octopusRepository.Users.getCurrent().then(function(me) {
	            $scope.user = me;
	            $scope.status = status;
	            $scope.view = { showPasswordChange: false, confirmNewPassword: '' };
	
	            return octopusPermissionSet.isAuthorized({ permission: 'EventView', projectId: '*', environmentId: '*' }).then(function(yn) {
	                if (yn) {
	                    return octopusRepository.Events.list({ user: me.Id }).then(function(events) {
	                        $scope.activity = events;
	                    });
	                }
	            });
	        }));
	    }));
	
	    $scope.save = function() {
	        if ($scope.user.IsActive && $scope.view.showPasswordChange) {
	            if ($scope.user.Password !== $scope.view.confirmNewPassword) {
	                isSaving.showError('The passwords do not match');
	                return;
	            }
	        } else {
	            $scope.user.Password = null;
	        }
	        isSaving.promise(octopusRepository.Users.save($scope.user).then(function() {
	            $window.location.reload();
	        }));
	    };
	});
	
	
	
	
	
	


/***/ },
/* 642 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.users');
	
	module.controller('RegisterController', function($scope, $location, $stateParams, busy, octopusAuthenticator, octopusRepository, octopusPermissionSet, octopusFeatures) {
	    var isSubmitting = $scope.isSubmitting = busy.create();
	
	    if (octopusAuthenticator.currentUser()) {
	        $location.path('/');
	        return;
	    }
	
	    var invitation = $stateParams['invitation'];
	
	    var fields = $scope.fields = {
	        username: '',
	        displayName: '',
	        emailAddress: '',
	        password: '',
	        confirmPassword: '',
	        invitation: invitation
	    };
	
	    $scope.invitationRequired = !(invitation) || invitation.length !== 33;
	
	    $scope.register = function() {
	        if (fields.password !== fields.confirmPassword) {
	            isSubmitting.showError('The passwords you entered do not match');
	            return;
	        }
	
	        var go = octopusRepository.Users.register({
	            Username: fields.username,
	            DisplayName: fields.displayName,
	            EmailAddress: fields.emailAddress,
	            Password: fields.password,
	            InvitationCode: fields.invitation,
	            IsActive: true
	        });
	
	        var redirect = go.then(function(user) {
	            octopusAuthenticator.currentUser(user);
	            octopusPermissionSet.refresh();
	            octopusFeatures.refresh();
	            $location.path('/');
	        });
	
	        isSubmitting.promise(redirect);
	    };
	
	
	});
	
	
	
	


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.users');
	
	module.controller('SignInController', function ($scope, $q, $rootScope, $state, octopusLog, octopusRepository, octopusClient, octopusAuthenticator, $location, $window, busy, octopusPermissionSet, octopusFeatures) {
	    $scope.fields = {
	        username: '',
	        password: '',
	        rememberMe: false
	    };
	
	    var root = $scope.rootDocument = octopusClient.rootDocument();
	
	    var isSubmitting = $scope.isSubmitting = busy.create();
	    var isRedirecting = $scope.isRedirecting = busy.create();
	
	    var error = $location.search()['error'];
	    if (error) {
	        isSubmitting.error = {Errors: [error]};
	    }
	
	    $scope.nonFormsAuthenticationProviders = _.filter(root.AuthenticationProviders, function (p) {
	        return !p.FormsLoginEnabled && p.Name !== 'Active Directory' && !p.IsGuestProvider;
	    });
	    $scope.formsAuthenticationProviders = _.filter(root.AuthenticationProviders, function (p) {
	        return p.FormsLoginEnabled && !p.IsGuestProvider;
	    });
	
	    $scope.anyFormsAuthenticationProviders = _.any($scope.formsAuthenticationProviders);
	    $scope.anyNonFormsAuthenticationProviders = _.any($scope.nonFormsAuthenticationProviders);
	
	    $scope.formsProvidersWithLinks = _.filter(root.AuthenticationProviders, function (p) {
	        return p.Name === 'Active Directory';
	    });
	
	    $scope.anyAuthenticationProviders = $scope.anyFormsAuthenticationProviders || $scope.anyNonFormsAuthenticationProviders || $scope.formsProvidersWithLinks.length > 0;
	
	    $scope.isGuestProviderEnabled = _.any(root.AuthenticationProviders, function (p) {
	        return p.IsGuestProvider;
	    });
	    if ($scope.isGuestProviderEnabled) {
	        $scope.guestProvider = _.filter(root.AuthenticationProviders, function (p) {
	            return p.IsGuestProvider;
	        })[0];
	    }
	    $scope.guestPanelVisible = $scope.isGuestProviderEnabled && !error;
	    $scope.hideGuestPanel = function () {
	        $scope.guestPanelVisible = false;
	    };
	
	    if (root.AutoLoginEnabled && !error && !$scope.anyFormsAuthenticationProviders &&
	        ($scope.nonFormsAuthenticationProviders.length === 1 || $scope.formsProvidersWithLinks.length === 1) && !$scope.guestPanelVisible) {
	
	        $scope.shouldAutoLogin = true;
	        // create a promise here so the loading spinner becomes visible until the redirect actually happens.
	        isRedirecting.promise($q(function (resolve, reject) {}));
	    }
	
	    var redirectAfterLogin = function (success) {
	
	        return octopusRepository.Users.getPermissions(success).then(function(permissions){
	            octopusAuthenticator.setCurrentPrincipal(success, permissions.Permissions);
	            octopusPermissionSet.refresh();
	            octopusFeatures.refresh();
	            octopusLog.log("Sign in successful, redirecting");
	            $location.search('error', null);
	            if ($rootScope.redirectAfterFormsLoginTo) {
	                octopusLog.log("Redirecting to " + $rootScope.redirectAfterFormsLoginTo);
	                if ($rootScope.redirectAfterFormsLoginTo.startsWith('http')) {
	                    $window.location.href = $rootScope.redirectAfterFormsLoginTo;
	                } else {
	                    $location.path($rootScope.redirectAfterFormsLoginTo);
	                }
	            } else {
	                octopusLog.log("Redirecting to /");
	                $state.go('app');
	            }
	        }, function(error) {
	            octopusLog.log(error);
	            var message = "The sign in succeeded but we failed to get the resultant permissions for this user account. ";
	
	            var reason = (error.StatusCode === 401)
	                ? "This can happen if the authentication cookie is not saved to the browser properly."
	                : "There was a problem communicating with the Octopus Server: " + error.ErrorMessage;
	
	            throw { Errors: [message + reason] };
	        });
	    };
	
	    $scope.handleSignInError = function(error) {
	        if (error.Errors && error.Errors.length > 0) {
	            throw { Errors: error.Errors };
	        } else if (error.ErrorMessage) {
	            throw {Errors: [error.ErrorMessage] };
	        } else {
	            throw { Errors: [error] };
	        }
	    };
	
	    $scope.signIn = function() {
	        if (isSubmitting.busy) {
	            return;
	        }
	
	        var user = { Username: $scope.fields.username, Password: $scope.fields.password, RememberMe: $scope.fields.rememberMe };
	
	        octopusLog.log("Attempting to sign in: " + user.Username);
	
	        isSubmitting.promise(octopusRepository.Users.signIn(user).then(redirectAfterLogin, $scope.handleSignInError));
	    };
	
	    $scope.signInAsGuest = function() {
	        if (!$scope.guestProvider) {
	            return;
	        }
	
	        if (isSubmitting.busy) {
	            return;
	        }
	        var user = { Username: "guest", Password: "guest", RememberMe: true };
	
	        octopusLog.log("Attempting to sign in: " + user.Username);
	
	        isSubmitting.promise(octopusRepository.Users.signIn(user).then(redirectAfterLogin, $scope.handleSignInError));
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 644 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.users');
	
	module.controller('SignOutController', function ($scope, $rootScope, $location,$state, octopusLog, octopusRepository, octopusAuthenticator, octopusFeatures,  busy, $window) {
	    var isSubmitting = $scope.isSubmitting = busy.create();
	
	    $scope.signOut = function() {
	        octopusLog.log("Attempting to sign out");
	        isSubmitting.promise(octopusRepository.Users.signOut()
	      .then(function () {
	          octopusAuthenticator.setCurrentPrincipal(null, null);
	          $rootScope.redirectAfterFormsLoginTo = null;
	          $rootScope.redirectAfterExternalLoginTo = null;
	          octopusFeatures.refresh();
	          octopusLog.log("Sign out successful, redirecting");
	          //$location.path("/");
	          $state.go('app');
	      }));
	    };
	
	    $scope.cancel = function () {
	        $window.history.back();
	    };
	});
	
	


/***/ },
/* 645 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.users');
	
	module.directive("authProvider", function () {
	    return {
	        restrict: 'E',
	        templateUrl: 'areas/users/views/auth_provider.html',
	        replace: true,
	        transclude: true,
	        controller: 'AuthProviderController',
	        scope: {
	            provider: '=',
	            isSubmitting: '=',
	            handleSignInError: '=',
	            shouldAutoLogin: '='
	        }
	    };
	});


/***/ },
/* 646 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.controller('AlertDialogController', function ($scope, options, $uibModalInstance) {
	    $scope.options = options;
	
	    $scope.close = function() {
	        $uibModalInstance.close();
	    };
	});
	


/***/ },
/* 647 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.controller('AsyncConfirmDialogController', function ($scope, busy, options, $uibModalInstance, $timeout) {
	  var isWorking = $scope.isWorking = busy.create();
	  $scope.options = options;
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.execute = function () {
	    $scope.options.execute({
	      busy: isWorking,
	      dismiss: function () {
	        $uibModalInstance.close(true);
	      }
	    });
	  };
	
	  if ($scope.options.error) {
	    $timeout(function () {
	      isWorking.error = $scope.options.error;
	    });
	  }
	});
	


/***/ },
/* 648 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.controller('MessageBoxController', function ($scope, busy, options, $uibModalInstance) {
	  var isWorking = $scope.isWorking = busy.create();
	  $scope.options = options;
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.submit = function (result) {
	    $uibModalInstance.close(result);
	  };
	});
	


/***/ },
/* 649 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.controller('PromptDialogController', function ($scope, busy, options, $uibModalInstance) {
	  var isWorking = $scope.isWorking = busy.create();
	  $scope.options = options;
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.execute = function () {
	    $scope.options.execute({
	      answer: $scope.options.answer,
	      busy: isWorking,
	      dismiss: function () {
	        $uibModalInstance.close(true);
	      }
	    });
	  };
	});
	


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.infrastructure');
	
	module.controller('SortDialogController', function ($scope, busy, options, $uibModalInstance) {
	  var isLoading = $scope.isLoading = busy.create();
	  var isSaving = $scope.isSaving = busy.create();
	  $scope.options = options;
	  $scope.items = [];
	
	  if ($scope.options.load) {
	    $scope.options.load({
	      busy: isLoading,
	      render: function (items) {
	        $scope.items = items;
	      }
	    });
	  }
	
	  $scope.close = function() {
	    $uibModalInstance.close();
	  };
	
	  $scope.save = function () {
	    $scope.options.save(_.map($scope.items, function(item) { return item.id; }), {
	      busy: isSaving,
	      dismiss: function () {
	        $uibModalInstance.close();
	      }
	    });
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 651 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	// Courtesy of https://github.com/chesleybrown/autofill-directive (MIT)
	
	module.directive('autofill', function() {
	  return {
	    require: 'ngModel',
	    link: function (scope, element, attrs, ngModel) {
	      scope.$on('autofill-submit', function(e) {
	        ngModel.$setViewValue(element.val());
	      });
	    }
	  };
	});
	
	module.directive('autofillSubmit', ['$parse', function($parse) {
	  return {
	    link: function (scope, element) {
	      var fn = $parse(element.attr('autofill-submit'));
	      element.on('submit', function(event) {
	        scope.$broadcast('autofill-submit');
	        scope.$apply(function() {
	          fn(scope, {$event:event});
	        });
	      });
	    }
	  };
	}]);
	


/***/ },
/* 652 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('bindFiles', function(){
	  return {
	    scope: {
	      files: '=bindFiles'
	    },
	    link: function (scope, element) {
	      element.bind('change', function(){
	        // Currently a bit of a hack while the uploader is shaken out
	        scope.$apply(function() { scope.files = element[0].files; });
	      });
	    }
	  };
	});


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.infrastructure');
	
	module.directive("boundField", function () {
	  return {
	    restrict: 'E',
	    transclude: true,
	    replace: true,
	    templateUrl: 'infrastructure/directives/views/bound-field.html',
	    require:  '?^form',
	    scope: {
	      projectId: '=',
	      projectEnvironmentsFilter: '=',
	      localNames: '=',
	      model: '=',
	      resetValue: '=',
	      parameter: '=',
	      label: '@',
	      bound: '=',
	      isLocked: '='
	    },
	    link: function ($scope, element, attrs, $form) {
	      $scope.boundText = boundText;
	      $scope.bind = bind;
	      $scope.unbind = unbind;
	      $scope.bound = $scope.bound || {};
	      $scope.isLocked = $scope.isLocked || function(){ return false; };
	
	      var parameterUnboundValueRanges = {
	        "Checkbox": function(param, value) {
	          //console.log("eval checkbox", param, value);
	          if (!value) {
	            return false;
	          }
	          var lower = value.toLowerCase();
	          return lower === "true" || lower === "false";
	        },
	        "Select": function (param, value) {
	         // console.log("eval select", param, value);
	          var options = param["Octopus.SelectOptions"].split("\n");
	          return options.map(function(option) { return option.split('|')[0]; }).indexOf(value) >= 0;
	        },
	        "Sensitive": function (param, value) {
	         // console.log("eval select", param, value);
	          return typeof value === 'undefined' || typeof value === 'object';
	        }
	      };
	
	      var refreshTextBoxness = function () {
	        if($('.select2', element).length !== 0) {
	          $scope.needsSpecialTextBox = true;
	        } else {
	          var x = $(".transcluded.input-boxes input[type='text'], .transcluded.input-boxes textarea", element);
	          $scope.needsSpecialTextBox = x.length === 0;
	        }
	      };
	
	      var refreshIsBound = function(){
	        if ($scope.isLocked()) {
	          bind();
	          return;
	        }
	
	        if ($scope.model && typeof($scope.model) === 'string') {
	          if ($scope.model.indexOf("#{") >= 0) {
	            bind();
	          }
	
	          if ($scope.parameter) {
	            var displaySettings = $scope.parameter.DisplaySettings;
	            var controlType = displaySettings["Octopus.ControlType"];
	            var isInRange = parameterUnboundValueRanges[controlType];
	            if (isInRange) {
	              if (!isInRange(displaySettings, $scope.model)) {
	                bind();
	              }
	            }
	          }
	        }
	      };
	
	      function init() {
	        refreshTextBoxness();
	        refreshIsBound();
	
	        $scope.$watch("model", function(newVal, oldVal) {
	          if (newVal !== oldVal && $form) {
	            $form.$setDirty();
	          }
	
	          refreshIsBound();
	        });
	
	        $scope.$watch($scope.isLocked, 
	          function (newVal, oldVal) {
	            if (newVal !== oldVal) {
	              refreshIsBound();
	            }
	        });
	      }
	
	      function boundText() {
	        if ($scope.isBound) {
	          return "This field is bound";
	        }
	        return "This field supports custom bindings";
	      }
	
	      function bind() {
	        if (typeof($scope.model) !== 'string') {
	         $scope.model = '';
	        }
	        $scope.isBound = true;
	        $scope.bound.isBound = true;
	      }
	
	      function unbind() {
	        $scope.isBound = false;
	        $scope.bound.isBound = false;
	
	        if (typeof($scope.resetValue) === 'function') {
	         $scope.model = $scope.resetValue();
	        } else {
	          $scope.model = $scope.resetValue;
	        }
	      }
	
	      init();
	    }
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 654 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive("controlGroup", function ($timeout) {
	  return {
	    restrict: 'E',
	    templateUrl: 'infrastructure/directives/views/control-group.html',
	    replace: true,
	    transclude: true,
	    scope: {
	      label: "@" // Gets the string contents of the `label` attribute.
	    },
	    link: function (scope, element) {
	
	      scope.$watch('', function() {
	        // The <label> should have a `for` attribute that links it to the input.
	        // Get the `id` attribute from the input element
	        // and add it to the scope so our template can access it.
	        $timeout(function() {
	          scope['for'] = element.find(":input, .form-control").attr("id");
	        }, 100);
	      });
	    }
	  };
	
	
	});


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('inputDatePicker', function () {
	    return {
	        restrict: 'E',
	        require: ['ngModel'],
	        scope: {
	            date: '=ngModel',
	            minDate: '=',
	            maxDate: '=',
	            ngRequired: '=',
	            dateOptions: '='
	        },
	        template: '<div class="input-group" style="width:175px">' +
	        '<input type="text" ' +
	        'class="form-control" ' +
	        'placeholder="yyyy-MM-dd" ' +
	        'ng-model="date" ' +
	        'ng-required="ngRequired" ' +
	        'datepicker-append-to-body="true" ' +
	        'uib-datepicker-popup="yyyy-MM-dd" ' +
	        'datepicker-options="datepickeroptions"' +
	        'is-open="isOpen" ' +
	        'on-open-focus="true"' +
	        'close-text="Close" />' +
	        ' <span class="input-group-btn">' +
	        '<button type="button" class="btn btn-default popper" ng-click="open($event)"><i class="fa fa-calendar"></i></button></span>' +
	        '</p>',
	        replace: true,
	        link: function ($scope, $element, $attributes) {
	            $scope.isOpen = false;
	            $scope.datepickeroptions = {
	                dateDisabled: disabled,
	                minDate: resolvedMinDate(),
	                maxDate: resolvedMaxDate(),
	                startingDay: 0
	            };
	
	            function resolveDate(date) {
	                if ($scope.minDate === "today") {
	                    return new Date();
	                }
	                return date;
	            }
	
	            function getDayStart(date) {
	                if (date) {
	                    return moment(resolveDate(date)).startOf("day");
	                }
	                return null;
	            }
	
	            function resolvedMinDate() {
	                return getDayStart($scope.minDate).toDate();
	            }
	
	            function resolvedMaxDate() {
	                return getDayStart($scope.maxDate).toDate();
	            }
	
	            function disabled(date, mode) {
	                return (mode === 'day'
	                    && ((date < resolvedMinDate())
	                    || (date > resolvedMaxDate()))
	                );
	            }
	
	            $scope.open = function ($event) {
	                $event.preventDefault();
	                $event.stopPropagation();
	
	                $scope.isOpen = true;
	            };
	        }
	    };
	});

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('dateRangePicker', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    template: '<div class="date-range-picker-display"><a href="" class="picker">{{ start | moment:"D MMMM YYYY" }}<span> to </span>{{ end | moment:"D MMMM YYYY" }}<span class="pull-right"><i class="fa fa-calendar"></i></span></a></div>',
	    scope: {
	      start: '=',
	      end: '=',
	      change: '&'
	    },
	    link: function ($scope, $element, $attributes) {
	      $(".picker", $element).click(function () {
	        var options = {};
	        options.opens = "left";
	        options.startDate = $scope.start;
	        options.endDate = $scope.end;
	        options.ranges = {
	          'Today': [moment(), moment()],
	          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
	          'Last 7 days': [moment().subtract(7, 'days'), moment()],
	          'Last 30 days': [moment().subtract(30, 'days'), moment()],
	          'Last 90 days': [moment().subtract(90, 'days'), moment()]
	        };
	
	        $element.daterangepicker(options, function(start, end) {
	          $scope.$apply(function () {
	            start = start.startOf('day');
	            end = end.add(1, 'day').startOf('day').subtract(1, 'seconds');
	            $scope.start = start;
	            $scope.end = end;
	          });
	          $scope.$apply(function() {
	            $scope.change();
	          });
	        });
	      });
	    }
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 657 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('detailedHelpToggle', function () {
	    return {
	        restrict: 'AC',
	        replace: false,
	        link: function (scope, element) {
	            element.click(function () {
	               element.hide();
	                element.closest("p").siblings(".detailed-help").fadeIn(200);
	            });
	        }
	    };
	});


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.infrastructure');
	
	module.directive('errorBox', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      error: '=',
	      onDismiss: '&'
	    },
	    templateUrl: 'infrastructure/directives/views/error-box.html',
	    link: function ($scope, element) {
	      $scope.dismiss = dismiss;
	      $scope.hasError = false;
	      $scope.isOpen = false;
	
	      function dismiss () {
	        $scope.isOpen = false;
	        $scope.onDismiss();
	      }
	
	      $scope.$watch('error', function () {
	        $scope.hasError = $scope.error !== null && typeof ($scope.error) !== "undefined";
	        $scope.isOpen = true;
	
	        if ($scope.hasError) {
	          element.fadeTo(100, 0.5, function () {
	            element.fadeTo(100, 1);
	
	            $('html, body').animate({
	              scrollTop: element.offset().top + 'px'
	            }, 'fast');
	          });
	        } else {
	          element.fadeTo(100, 0);
	        }
	      });
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 659 */
/***/ function(module, exports) {

	// Fixes this issue http://stackoverflow.com/questions/17702401/ie-8-selecting-n1-index when applied to <select>
	
	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('fixIeSelect', function($timeout, sniffer){
	  return {
	    require:'select',
	    link: function (scope, element) {
	      if(sniffer.isIE){
	        $timeout(function(){
	          var dummy = angular.element('<option disabled></option>');
	          element.append(dummy);
	        });
	      }
	    }
	  };
	});
	
	


/***/ },
/* 660 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('focusMe', function ($timeout) {
	  return {
	    restrict: 'AC',
	    link: function (scope, element, attr) {
	      var focus = scope.$eval(attr.focusMe);
	
	      if (focus === false) {
	        return;
	      }
	
	      setTimeout(function(){ element[0].focus(); },500);
	    }
	  };
	});
	
	module.directive('focusOn', function($timeout) {
	  return function(scope, element, attr) {
	    scope.$on('focusOn', function(e, name) {
	      if(name === attr.focusOn) {
	        $timeout(function () {
	          element[0].focus();
	        });
	      }
	    });
	  };
	});
	
	module.factory('focus', function ($rootScope, $timeout) {
	  return function(name) {
	    $timeout(function (){
	      $rootScope.$broadcast('focusOn', name);
	    });
	  };
	});


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {angular.module('octopusApp.infrastructure')
	    .directive('heightMagic', function () {
	    return {
	        restrict: 'A',
	        link: function (scope, element) {
	            var windowHeight = $(window).innerHeight()  - 210;
	            element.css('min-height', windowHeight);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 662 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('helpButton', function (helpManager) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	    },
	    templateUrl: 'infrastructure/directives/views/help-button.html',
	    link: function (scope, element) {
	      scope.helpManager = helpManager;
	    }
	  };
	});


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.infrastructure');
	
	module.directive('inOrOut', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      options: "=",
	      selectedItems: "="
	    },
	    template: '<div class="in-or-out row margin-top-bottom-20">\n' +
	    '    <div class="in-or-out-list col-md-12">\n' +
	    '        <label for="excluded-list">Excluded</label>\n' +
	    '        <select id="excluded-list" multiple="multiple" ng-dblclick="include()" class="form-control list-excluded" ng-model="excludeSelection" ng-options="item.label group by item.group for item in excludeList | orderBy:[\'sort\',\'group\']"></select>\n' +
	    '    </div>\n' +
	    '    <div class="col-md-6">\n' +
	    '        <div class="in-or-out-buttons"><button type="button" class="btn btn-default" ng-click="include()">Include <span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button></div>\n' +
	    '    </div>\n' +
	    '    <div class="col-md-6">\n' +
	    '        <div class="in-or-out-buttons"><button type="button" class="btn btn-default" ng-click="exclude()">Exclude <span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button></div>\n' +
	    '    </div>\n' +
	    '    <div class="in-or-out-list col-md-12">\n' +
	    '        <label for="included-list">Included</label>\n' +
	    '        <select id="included-list" multiple="multiple" ng-dblclick="exclude()" class="form-control list-included" ng-model="includeSelection" ng-options="item.label group by item.group for item in includeList | orderBy:[\'sort\',\'group\']"></select>\n' +
	    '    </div>\n' +
	    '</div>',
	    link: function (scope, element) {
	      scope.excludeList = [];
	      scope.includeList = [];
	
	      scope.excludeSelection = [];
	      scope.includeSelection = [];
	
	      // options will be a list of JSON objects with the following properties:
	      //   { Id: 'foo', Group: 'bar', Name: 'Foo' }
	      scope.$watch("options", function() {
	        scope.reload();
	      });
	      scope.$watch("selectedItems", function() {
	        scope.reload();
	      });
	
	      scope.include = function () {
	        _.each(scope.excludeSelection, function (item) {
	          scope.selectedItems.push(item.value);
	        });
	
	        scope.reload();
	      };
	
	      scope.exclude = function () {
	        _.each(scope.includeSelection, function (item) {
	          var itemIndex = scope.selectedItems.indexOf(item.value);
	          if (itemIndex >= 0) {
	            scope.selectedItems.splice(itemIndex, 1);
	          }
	        });
	
	        scope.reload();
	      };
	
	      var renderItemsInList = function(boundList, items) {
	
	        _.each(items, function (item) {
	          boundList.push({ group: item.Group, value: item.Id, label: item.Name });
	        });
	
	      };
	
	      scope.reload = function () {
	        scope.includeList.length = 0;
	        scope.excludeList.length = 0;
	
	        if (!scope.options) {
	          return;
	        }
	
	        var selectedItemsDictionary = {};
	        _.each(scope.selectedItems, function(i) {
	          selectedItemsDictionary[i] = "true";
	        });
	
	        var excludedItems = _.filter(scope.options, function(item) { return !selectedItemsDictionary[item.Id];});
	        var includedItems = _.filter(scope.options, function(item) { return selectedItemsDictionary[item.Id] === "true"; });
	
	        renderItemsInList(scope.excludeList, excludedItems);
	        renderItemsInList(scope.includeList, includedItems);
	      };
	
	      scope.reload();
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var Spinner = __webpack_require__(1226);
	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('inlineSpin', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      active: '=active'
	    },
	    template: '<span></span>',
	    link: function (scope, element) {
	      var opts = {
	        lines: 12,                  // The number of lines to draw
	        length: 2,                  // The length of each line
	        width: 3,                   // The line thickness
	        radius: 6,                 // The radius of the inner circle
	        corners: 1,                 // Corner roundness (0..1)
	        rotate: 0,                  // The rotation offset
	        direction: -1,              // 1: clockwise, -1: counterclockwise
	        color: '#889',              // #rgb or #rrggbb
	        speed: 1,                   // Rounds per second
	        trail: 60,                  // Afterglow percentage
	        shadow: false,              // Whether to render a shadow
	        hwaccel: false,             // Whether to use hardware acceleration
	        className: 'spinner-inline',       // The CSS class to assign to the spinner
	        zIndex: 2e9,                // The z-index (defaults to 2000000000)
	        top: '0',                   // Top position relative to parent in px
	        left: '0'                   // Left position relative to parent in px
	      };
	
	      var spinJsSpinner = new Spinner(opts);
	
	      var container = element;
	
	      var spinning = false;
	      var update = function () {
	        if (scope.active && !spinning) {
	          spinning = true;
	          spinJsSpinner.spin(container[0]);
	        } else if (!scope.active && spinning) {
	          spinning = false;
	          spinJsSpinner.stop(container[0]);
	        }
	      };
	
	      scope.$watch('active', function () {
	        update();
	      });
	
	      update();
	    }
	  };
	});


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var module = angular.module('octopusApp.infrastructure');
	
	$(function() {
	  var clearVariableListings = function() {
	    $(".variable-listing").remove();
	  };
	
	  $(document).on("click", clearVariableListings);
	});
	
	module.directive("insertVariableButton", function ($compile, octopusRepository, busy) {
	  var template = [];
	  template.push("<button class='btn btn-link no-margin no-padding no-border' type='button' title='Insert a variable'><em class='insert-variable-button-img'></em></button>");
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    replace: true,
	    template: template.join(""),
	    scope: {
	      projectId: '=',
	      projectEnvironmentsFilter: '=',
	      localNames: '=',   // Optional list of additional variable names to show
	      syntax: '@',       // octopus, powershell, bash or csharp
	      ngSyntax: '=',     // (binding-friendly version of the above)
	      insert: '=',       // insert(text) or null to use sibling textarea
	      rebind: '@'        // unsatisfactory, but required to cause ngModel to update
	    },
	    link: function (scope, element, attrs) {
	
	      var insert = function(text) {
	
	        var textBox = scope.rebind ? angular.element(scope.rebind) : $("input[type='text'], textarea", element.parents(".bound-field")).not(".ui-select-focusser, .select2-input").first();
	
	        var newValue;
	        if (scope.insert) {
	          newValue = scope.insert(text);
	        } else {
	          newValue = textBox.val() + text;
	          textBox.val(newValue);
	        }
	
	        var ctrl = textBox.controller('ngModel');
	        if (ctrl) {
	          ctrl.$setViewValue(newValue);
	        }
	        textBox.focus();
	      };
	
	      var getSyntax = function() {
	        return (scope.ngSyntax || scope.syntax || 'octopus').toLowerCase();
	      };
	
	      var delimit = function(varname) {
	        var syntax = getSyntax();
	
	        if (syntax === 'octopus') {
	          return "#{" + varname + "}";
	        }
	
	        // Some escaping is probably required here.
	
	        if (syntax === 'powershell') {
	          if (varname.match(/^[A-z0-9]+$/)) {
	            return "$" + varname;
	          } else {
	            return "$OctopusParameters['" + varname + "']";
	          }
	        }
	
	        if (syntax === 'csharp') {
	          return 'Octopus.Parameters["' + varname + '"]';
	        }
	
	        if (syntax === 'bash') {
	          return '`get_octopusvariable "' + varname + '"`';
	        }
	
	        return varname;
	      };
	
	      element.click(function (e) {
	        e.preventDefault();
	
	        var childScope = scope.$new();
	
	        childScope.searchText = "";
	        childScope.names = [];
	        childScope.functions = [];
	
	        var isLoading = childScope.isLoading = busy.create();
	
	        var text = [];
	        text.push("<div class='variable-listing dynamic-popups'>");
	        text.push("<div><spin active='isLoading.busy'></spin></div>");
	        text.push("<div><error-box error='isLoading.error'></error-box></div>");
	        text.push("<div ng-hide='isLoading.busy' class='variable-listing-toolbar form-search'><input class='search search-query' type='text' placeholder='Find...' ng-model='searchText' /></div>");
	        text.push("<div ng-hide='isLoading.busy' class='variable-listing-items'>");
	        text.push("<div ng-repeat='name in names | filter:searchText'><a class='fixed' href='' ng-click='select(name)'>{{ name }}</a></div>");
	        text.push("<hr ng-show='functions.length > 0' />");
	        text.push("<div ng-repeat='func in functions | filter:searchText'><a class='fixed function' href='' ng-click='selectFunction(func)'>{{ func }}</a></div>");
	        text.push("</div>");
	        text.push("</div>");
	
	        var html = $compile(text.join(""))(childScope);
	
	        childScope.select = function(name) {
	          if (name) {
	            html.remove();
	            insert(delimit(name));
	          }
	        };
	
	        childScope.selectFunction = function(func) {
	          if (func) {
	            html.remove();
	            insert(func);
	          }
	        };
	
	        $(".search", html).keyup(function(e){
	          if(e.keyCode === 13) {
	            var val = _.find(childScope.names, function (n) { return n.toLocaleLowerCase().indexOf(childScope.searchText.toLocaleLowerCase()) >= 0; });
	            if (val) {
	              childScope.select(val);
	            }
	          }
	        });
	
	        html.click(function (e) {
	          e.preventDefault();
	          return false;
	        });
	
	        childScope.$digest();
	
	        var parent = $("body");
	        var refPos = element.offset();
	        var refHeight = element.outerHeight();
	        var refWidth = element.outerWidth();
	        var leftOffset = (parent.outerWidth() - refPos.left) < 240 ? 480 : 240;
	
	        html.css({
	          "position": "absolute",
	          "left": (refPos.left - leftOffset) + "px",
	          "top": (refPos.top + refHeight) + "px"
	        });
	
	        $(".dynamic-popups").remove();
	
	        parent.append(html);
	
	        isLoading.promise(octopusRepository.Variables.names(scope.projectId, scope.projectEnvironmentsFilter).then(function (values) {
	          if (scope.localNames) {
	            childScope.names = _.clone(scope.localNames);
	          }
	
	          for (var i = 0; i < values.length; i++) {
	            childScope.names.push(values[i]);
	          }
	
	          if (getSyntax() === 'powershell') {
	            childScope.functions.push('New-OctopusArtifact');
	            childScope.functions.push('Set-OctopusVariable');
	          }
	
	          $(".search", html).focus();
	        }));
	
	        return false;
	      });
	
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 666 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('lastModified', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      model: '=model'
	    },
	    template: "<div ng-show='model.LastModifiedBy' class='control-group'><div class='controls'><div class='last-modified'>Last modified by {{ model.LastModifiedBy }} {{ model.LastModifiedOn | moment:'ago' }}</div></div></div>"
	  };
	});


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.infrastructure');
	
	module.directive('loadingWrapper', function (focus, $timeout) {
	    return {
	        restrict: 'E',
	        replace: false,
	        transclude: true,
	        scope: {
	            busy: '='
	        },
	        templateUrl: 'infrastructure/directives/views/loading-wrapper.html',
	        link: function ($scope, element) {
	            $scope.hasLoaded = false;
	            $scope.once = (element.attr('once') || 'false').toLocaleLowerCase() === 'true';
	
	            $scope.$watch("busy.busy", function() {
	                if ($scope.hasLoaded && $scope.once){
	                    return;
	                }
	
	
	                focus("page-loaded");
	
	                $scope.hasLoaded = !$scope.busy.busy;
	                if ($scope.hasLoaded && $scope.once) {
	                    $timeout(function () {
	                        $(".fade-in-when-loaded", element).removeClass("fade-in-when-loaded");
	                    }, 200);
	                }
	            });
	        }
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var module = angular.module('octopusApp.infrastructure');
	var showdown = __webpack_require__(110);
	
	module.directive('markdown', function ($sanitize) {
	    var converter = new showdown.Converter({
	        tables: true,
	        strikethrough: true
	    });
	    return {
	        restrict: 'E',
	        scope: {
	            text: '='
	        },
	        link: function (scope, element) {
	
	            var refresh = function () {
	                if (scope.text) {
	                    var html = $sanitize(converter.makeHtml(scope.text))
	                        .replace(/&#10;/g, "\n")
	                        // Ensure the bootstrap styling is applied - could use a showdown converter, but seems like overkill
	                        .replace(/<table/g, '<table class="table table-bordered table-striped"');
	                    element.html(html);
	                } else {
	                    element.html('');
	                }
	            };
	            scope.$watch('text', function () {
	                refresh();
	            });
	
	            refresh();
	        }
	    };
	});


/***/ },
/* 669 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('markitup', function () {
	  // -------------------------------------------------------------------
	  // markItUp!
	  // -------------------------------------------------------------------
	  // Copyright (C) 2008 Jay Salvat
	  // http://markitup.jaysalvat.com/
	  // -------------------------------------------------------------------
	  // Modified for Octopus
	  // -------------------------------------------------------------------
	
	  var mySettings = function(element) {
	    return {
	      previewParserPath: '',
	      onShiftEnter: {keepDefault: false, openWith: '\n\n'},
	      markupSet: [
	        {name: 'Bold', className: 'bold', key: 'B', openWith: '**', closeWith: '**'},
	        {name: 'Italic', className: 'italic', key: 'I', openWith: '_', closeWith: '_'},
	        {separator: '---------------' },
	        {name: 'Bulleted List', className: 'bullet', openWith: '- ' },
	        {name: 'Numeric List', className: 'numeric', openWith: function (markItUp) {
	          return markItUp.line + '. ';
	        }},
	        {separator: '---------------' },
	        {name: 'Picture', className: 'picture', key: 'P', replaceWith: '![[![Alternative text]!]]([![URL to image file:!:http://]!])'},
	        {name: 'Link', className: 'link', key: 'L', openWith: '[', closeWith: ']([![URL:!:http://]!])', placeHolder: 'Your text to link here...' },
	        {separator: '---------------'},
	        {name: 'Code Block / Code', className: 'code', openWith: '(!(    |!|`)!)', closeWith: '(!(`)!)'},
	        {name: 'Quotes', className: 'quotes', openWith: '> '}
	      ],
	      afterInsert: function () {
	        var scope = element.scope();
	        // Force the markup change to be written to the bound scope
	        element.controller('ngModel').$setViewValue(element.val());
	      }
	    };
	  };
	
	  // -------------------------------------------------------------------
	
	  return {
	    restrict: 'A',
	    link: function (scope, element) {
	      element.markItUp(mySettings(element));
	    }
	  };
	});


/***/ },
/* 670 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('ngBindHtmlTemplate', function($compile, octopusClient) {
	  return {
	    link: function($scope, $element, $attrs) {
	      var html = $scope.$eval($attrs.ngBindHtmlTemplate);
	      $element.html(html);
	      $compile($element.contents())($scope);
	    }
	  };
	});


/***/ },
/* 671 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('ngBindHtmlUnsafe', function() {
	  return function(scope, element, attr) {
	    element.addClass('ng-binding').data('$binding', attr.ngBindHtmlUnsafe);
	    scope.$watch(attr.ngBindHtmlUnsafe, function ngBindHtmlUnsafeWatchAction(value) {
	      element.html(value || '');
	    });
	  };
	});


/***/ },
/* 672 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive("octoClippy", function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'infrastructure/directives/views/octo-clippy.html',
	    replace: false,
	    transclude: true
	  };
	});


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var module = angular.module('octopusApp.infrastructure');
	
	module.directive("octoFullScreen", function ($rootScope) {
	  return {
	    restrict: 'A',
	    link: function (scope, element, attr) {
	      element.html("<i class='fa fa-expand'></i>");
	
	      element.click(function (e) {
	        e.preventDefault();
	        var target = $(attr.octoFullScreen);
	        var exitFullScreen = function() {
	          $(".fullscreen-controls", target).remove();
	          target.removeClass("fullscreen-content");
	          $('body').removeClass("fullscreen-body");
	          $rootScope.$broadcast("octo-fullscreen-toggle");
	          $(document).unbind("keyup", escapeKeyHandler);
	        };
	
	        var escapeKeyHandler = function(e) {
	          if (e.keyCode === 27) {
	            exitFullScreen();
	          }
	        };
	
	        $('body').addClass("fullscreen-body");
	        $(document).bind("keyup", escapeKeyHandler);
	
	        target.addClass("fullscreen-content");
	        target.prepend($("<div class='fullscreen-controls'><a href='' class='exit-full-screen'>Exit full screen</div>"));
	
	        $(".exit-full-screen", target).click(function (e) {
	          e.preventDefault();
	          exitFullScreen();
	          return false;
	        });
	
	        $rootScope.$broadcast("octo-fullscreen-toggle");
	        return false;
	      });
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 674 */
/***/ function(module, exports) {

	angular.module('octopusApp.infrastructure').directive('octoBarChart', function () {
	    return {
	        restrict: 'E',
	        scope: {
	            reportData: "="
	        },
	        template: '<div class="chart project-deployments" style="width: 200px;height: 90px"></div>',
	        replace: true,
	        transclude: true,
	
	        link: function ($scope, element) {
	            $scope.$watch('reportData', function (reportData) {
	                if (!reportData) {
	                    return;
	                }
	                var dataSeries = reportData.Series[0].Data;
	                var barPadding = 1;
	                var units = element.height() / Math.max.apply(Math, dataSeries);
	                d3.select(element[0])
	                    .append("svg")
	                    .selectAll("rect")
	                    .data(dataSeries)
	                    .enter()
	                    .append("rect")
	                    .attr("class", "bar")
	                    .attr("x", function (d, i) {
	                        return i * (element.width() / dataSeries.length);
	                    })
	                    .attr("y", function (d) {
	                        return element.height() - units * d;
	                    })
	                    .attr("width", element.width() / dataSeries.length - barPadding)
	                    .attr("height", function (d) {
	                        return units * d;
	                    });
	            });
	        }
	    };
	});


/***/ },
/* 675 */
/***/ function(module, exports) {

	angular
	    .module('octopusApp.infrastructure')
	    .directive("octoFeature", function(octopusFeatures) {
	        return {
	            restrict: 'A',
	            replace: false,
	            link: function ($scope, $element, attr) {
	                if (!attr.octoFeature) {
	                    return;
	                }
	
	                $scope.$watch(function () {
	                    return octopusFeatures.isEnabled(attr.octoFeature);
	                }, function (isEnabled) {
	                    if (isEnabled) {
	                        $element.removeClass('octo-feature-denied');
	                    } else {
	                        $element.addClass('octo-feature-denied');
	                    }
	                });
	            }
	        };
	    });

/***/ },
/* 676 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('octoPaginator', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      collection: '=',
	      contentType: '=',
	      pageSelected: '=',
	      isLoading: '=',
	      showAsLoadMore: '=',
	      loadMore: '=',
	      loadAll: '='
	    },
	    templateUrl: 'infrastructure/directives/views/octo-paginator.html',
	    link: function (scope, element, attrs) {
	      scope.pages = [];
	      scope.show = false;
	      scope.skip = 0;
	
	      var pagesToShow = 16;
	      var halfPagesToShow = 8;
	
	      scope.$watch('collection.Items', function (val, oldVal) {
	
	        var coll = scope.collection;
	
	        if (coll && coll.Links && coll.ItemsPerPage) {
	          var totalPages = Math.ceil(coll.TotalResults / coll.ItemsPerPage);
	          if (!scope.showAsLoadMore) {
	            var pages = [];
	
	            var currentPageIndex = 0;
	            for (var j = 0; j < totalPages; j++) {
	              if (coll.Links["Page." + j] === coll.Links["Page.Current"]) {
	                currentPageIndex = j;
	              }
	            }
	            var addPage = function (i, text) {
	              pages.push({
	                index: i,
	                isActive: currentPageIndex === i,
	                skip: i * coll.ItemsPerPage,
	                number: text
	              });
	            };
	
	            if (totalPages > 0) {
	              addPage(0, "«");
	            }
	
	            var isStartCollapsed = false;
	            var isEndCollapsed = false;
	            for (var i = 0; i < totalPages; i++) {
	              var skip = !(totalPages < pagesToShow || ((i - currentPageIndex) < halfPagesToShow && (i - currentPageIndex) > -halfPagesToShow));
	
	              if (skip && i < currentPageIndex && !isStartCollapsed) {
	                addPage(Math.max(currentPageIndex - pagesToShow, 0), "...");
	                isStartCollapsed = true;
	              }
	              if (!skip) {
	                addPage(i, (i + 1));
	              }
	              if (skip && i > currentPageIndex && !isEndCollapsed) {
	                addPage(Math.min(currentPageIndex + pagesToShow, totalPages -1), "...");
	                isEndCollapsed = true;
	              }
	            }
	
	            if (totalPages > 0) {
	              addPage(totalPages - 1, "»");
	            }
	
	            scope.show = totalPages > 1;
	            scope.pages = pages;
	          } else {
	            if (coll.Links["Page.Next"] === undefined) {
	              scope.show = false;
	              scope.skip = 0;
	            } else {
	              scope.show = totalPages > 1;
	              scope.skip = scope.skip + coll.ItemsPerPage;
	            }
	          }
	        } else {
	          scope.show = false;
	          scope.pages = [];
	        }
	      });
	    },
	    controller: function($scope, octopusClient) {
	      $scope.onPageSelected = function(skip, p) {
	        if ($scope.pageSelected) {
	          $scope.pageSelected(skip, p + 1);
	        } else {
	          if ($scope.collection && $scope.collection.Links){
	            $scope.collection.Page = p;
	            var pageLink = $scope.collection.Links["Page." + p];
	            if($scope.contentType) {
	              pageLink = pageLink + "&contentType=" + encodeURIComponent($scope.contentType);
	            }
	            var getPage = octopusClient.get(pageLink).then(function(newColl){
	              $scope.collection.Items = newColl.Items;
	              $scope.collection.Links = newColl.Links;
	              $scope.collection.IsStale = newColl.IsStale;
	              $scope.collection.ItemType = newColl.ItemType;
	              $scope.collection.ItemsPerPage = newColl.ItemsPerPage;
	            });
	            if ($scope.isLoading) {
	              $scope.isLoading.promise(getPage);
	            }
	          }
	        }
	      };
	
	      $scope.onLoadMore = function (skip) {
	        if ($scope.loadMore) {
	          $scope.loadMore(skip);
	        }
	      };
	
	      $scope.onLoadAll = function () {
	        if ($scope.loadAll) {
	          $scope.loadAll();
	        }
	      };
	    }
	  };
	});
	
	
	
	


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {angular
	    .module('octopusApp.infrastructure')
	    .directive("octoPermission", function($rootScope, octopusPermissionSet, $timeout, $q) {
	
	      var update = function (element, permission, project, environment, projectGroup, wildcard) {
	        element.addClass('octo-permission-unknown');
	        element.removeClass('octo-permission-denied');
	
	        var pid = project || (wildcard ? '*' : null);
	        var eid = environment || (wildcard ? '*' : null);
	        var gid = projectGroup || (wildcard ? '*' : null);
	
	        var permissions = permission.split(',');
	
	        var checks = [];
	        _.each(permissions, function (p) {
	          checks.push(octopusPermissionSet.isAuthorized({
	            permission: p,
	            projectId: pid,
	            environmentId: eid,
	            projectGroupId: gid
	          }));
	        });
	
	        $q.all(checks).then(function (yn) {
	          var allowed = _.any(yn, function (y) {
	            return y === true;
	          });
	
	          element.removeClass('octo-permission-unknown');
	          if (!allowed) {
	            element.addClass('octo-permission-denied');
	            element.attr('octo-denied-project', pid);
	            element.attr('octo-denied-environment', eid);
	          }
	        });
	      };
	
	      return {
	        restrict: 'A',
	        replace: false,
	        link: function (scope, element, attr) {
	          var permission = attr.octoPermission;
	          var project = attr.octoProject;
	          var environment = attr.octoEnvironment;
	          var group = attr.octoProjectGroup;
	
	          var wildcard = 'wildcard' in attr;
	
	          var p = project ? scope.$eval(project) : null;
	          var e = environment ? scope.$eval(environment) : null;
	          var g = group ? scope.$eval(group) : null;
	
	          var doUpdate = function () {
	            update(element, permission, p, e, g, wildcard);
	          };
	          doUpdate();
	
	          var unwatchStatus = $rootScope.$watch('isAuthenticated', function (newVal) {
	            doUpdate();
	          });
	
	          if (project && environment) {
	
	            scope.$watchCollection('[' + project + ',' + environment + ']', function (newPE) {
	              p = newPE[0];
	              e = newPE[1];
	              doUpdate();
	            });
	
	          } else {
	
	            if (project) {
	              scope.$watch(project, function (newP) {
	                p = newP;
	                doUpdate();
	              });
	            }
	
	            if (environment) {
	              scope.$watch(environment, function (newE) {
	                e = newE;
	                doUpdate();
	              });
	            }
	
	            if (group) {
	              scope.$watch(group, function (newG) {
	                g = newG;
	                doUpdate();
	              });
	            }
	          }
	
	          scope.$on('$destroy', unwatchStatus);
	        }
	      };
	    });
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 678 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive("octoPlaceholder", function(octoUtil, $compile, $rootScope) {
	    return {
	        restrict: 'AC',
	        link: function(scope, element, attr) {
	            var sectionName = "section" + attr.octoPlaceholder;
	            var placeholder = element[0];
	
	
	            $rootScope[sectionName] = placeholder;
	
	            var watchEvent = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
	                element.html('');
	            });
	
	            scope.$on('$destroy', function() {
	                delete $rootScope[sectionName];
	                watchEvent();
	            });
	
	
	
	
	
	            /* $rootScope["section" + attr.octoPlaceholder] = element[0];
	             console.log("Placeholder: Adding - "  + attr.octoPlaceholder);
	
	
	             var watchEvent = $rootScope.$on('$stateChangeStart',function(e, a, b) {
	                  // Clear on navigate
	                 console.log("Placeholder: Clearing- "  + attr.octoPlaceholder);
	                  element.html('');
	              });
	
	             scope.$on('$destroy', function() {
	                 //stop watching when scope is destroyed
	                 console.log("Placeholder: Detatching- "+ attr.octoPlaceholder);
	                 delete $rootScope["section" + attr.octoPlaceholder];
	                 watchEvent();
	             });*/
	        }
	    };
	});
	


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.infrastructure');
	
	module.directive("octoSection", function(octoUtil, $compile, $rootScope) {
	    return {
	        restrict: 'AC',
	        link: function(scope, element, attr) {
	            var sectionName = "section" + attr.octoSection;
	            var scopedDomInstances = [];
	
	            function update(){
	                var placeholder = $rootScope[sectionName];
	                if (placeholder) {
	                    scopedDomInstances = $compile(element.html())(scope);
	                    _.forEach(scopedDomInstances, function(a) { placeholder.appendChild(a); });
	                }
	            }
	
	            var stateChangeDetach = $rootScope.$on('$stateChangeSuccess', function() {
	                update();
	            });
	
	            scope.$on('$destroy', function() {
	                var placeholder = $rootScope[sectionName];
	                if (placeholder) {
	                    _.forEach(scopedDomInstances, function(a) { placeholder.removeChild(a); });
	                }
	                stateChangeDetach();
	            });
	
	            update();
	
	
	            /*
	            var sectionName = "section" + attr.octoSection;
	            function update(){
	                var placeholder = $rootScope[sectionName];
	                if (placeholder) {
	                    var templateHtml = element.html();
	                    var scopedDomInstance = $compile(templateHtml)(scope);
	                    $(placeholder).html(scopedDomInstance);
	                }
	                //  console.log('Updaging '+ attr.octoSection);
	            }
	            var stateChangeDetach = $rootScope.$on('$stateChangeSuccess', function(e, a, b) {
	                console.log("Section State: "+ attr.octoSection);
	                update();
	            });
	
	            var sectionWatchDetach = $rootScope.$watch(sectionName, function(){
	                console.log("Section Watch: "+ attr.octoSection);
	                update();
	            });
	
	            scope.$on('$destroy', function() {
	                console.log("Section Destroy: "+ attr.octoSection);
	                stateChangeDetach();
	                sectionWatchDetach();
	            });
	*/
	            /*
	
	
	            var changer1 = $rootScope.$watch("section" + attr.octoSection, update);
	
	
	            function update(){
	                var placeholder = $rootScope["section" + attr.octoSection];
	                if (placeholder) {
	                    var templateHtml = element.html();
	                    var scopedDomInstance = $compile(templateHtml)(scope);
	                    $(placeholder).html(scopedDomInstance);
	                }
	              //  console.log('Updaging '+ attr.octoSection);
	            }
	
	            var changer2 = $rootScope.$on('$stateChangeSuccess', function(e, a, b) {
	                update();
	            });
	
	            scope.$on('$destroy', function() {
	                //stop watching when scope is destroyed
	                //console.log("Detatching Section"+ attr.octoSection);
	                changer2();
	                changer1();
	            });*/
	        }
	    };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 680 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('searchBox', function($timeout) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      inputText: '=',
	      placeholder: '@',
	      onTextChanged: '=',
	      onSearchClicked: '=',
	      autoFocus: '='
	    },
	    templateUrl: 'infrastructure/directives/views/search-box.html'
	 };
	});


/***/ },
/* 681 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('spin', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: false,
	    scope: {
	      active: '=active'
	    },
	    templateUrl: 'infrastructure/directives/views/spin.html',
	    link: function (scope, element) {
	
	    }
	  };
	});


/***/ },
/* 682 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive("trackUnsavedChanges", function ($rootScope, unsavedChanges) {
	  return {
	    restrict: 'AC',
	    require: "^form",
	    link: function (scope, element, attr, ctrl) {
	        scope.$watch(function () {
	            return ctrl.$dirty;
	        }, function () {
	            if (ctrl.$dirty) {
	                unsavedChanges.unsaved();
	            }
	        });
	
	        var watchEvent = $rootScope.$on('changesSaved', function () {
	            ctrl.$setPristine();
	        });
	
	        scope.$on('$destroy', function () {
	            watchEvent();
	        });
	    }
	  };
	});
	
	module.directive("trackAfter", function ($rootScope, unsavedChanges, octopusLog, $timeout) {
	  return {
	    restrict: 'AC',
	    require: "^form",
	    link: function (scope, element, attr, ctrl) {
	
	      $timeout(function() {
	        ctrl.$setPristine();
	        unsavedChanges.saved();
	      }, parseInt(attr.trackAfter, 10));
	    }
	  };
	});
	
	module.directive("unsavedChangesIndicator", function ($rootScope, unsavedChanges) {
	  return {
	    restrict: 'E',
	    template: '<span class="tools-info" ng-show="unsavedChanges.hasUnsavedChanges()">You have unsaved changes</span>',
	    link: function (scope, element, attr, ctrl) {
	      scope.unsavedChanges = unsavedChanges;
	    }
	  };
	});
	


/***/ },
/* 683 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.directive('updateWrapper', function () {
	  return {
	    restrict: 'E',
	    replace: false,
	    transclude: true,
	    scope: {
	      busy: '='
	    },
	    templateUrl: 'infrastructure/directives/views/update-wrapper.html',
	    link: function (scope, element) {
	    }
	  };
	});


/***/ },
/* 684 */
/***/ function(module, exports) {

	// Based on http://stackoverflow.com/questions/15900485/correctly-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
	var module = angular.module('octopusApp.infrastructure');
	
	module.filter('bytesToSize', function () {
	  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
	
	  return function (input, format) {
	    var bytes = parseInt(input, 10);
	    if (isNaN(bytes)) {
	      return '';
	    }
	    if (bytes === 0){
	      return '0 bytes';
	    }
	    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
	    return +(bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
	  };
	});
	
	
	


/***/ },
/* 685 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.filter('csvToArray', function () {
	  return function (input) {
	    if (!input) {
	      input = "";
	    }
	
	    return input.split(',');
	  };
	});


/***/ },
/* 686 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.filter('ellipsis', function () {
	  return function (input, format) {
	    var count = parseInt(format || "30", 10);
	    return input.length > count ? input.slice(0, count - 2) + '…' : input;
	  };
	});
	


/***/ },
/* 687 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.filter('extension', function () {
	  return function (input) {
	    return input.split('.').pop().toLowerCase();
	  };
	});


/***/ },
/* 688 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.filter('filterUsers', function() {
	  return function (collection, search) {
	    if (!search || search === "" || !collection) {
	      return collection;
	    }
	
	    return collection.filter(function (item) {
	
	      var searchText = latinize(search).toLowerCase();
	      return latinize((item.Username || "").toLowerCase()).indexOf(searchText) !== -1 ||
	              latinize((item.DisplayName || "").toLowerCase()).indexOf(searchText) !== -1;
	    });
	  };
	});


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(3);
	var module = angular.module('octopusApp.infrastructure');
	
	module.filter('moment', function () {
	  return function (input, format) {
	    var when = new Date(Date.parse(input));
	    var m = moment(when);
	    format = format || "LLLL";
	    var display = format === "ago" ? m.fromNow() : m.format(format);
	    return display;
	  };
	}).filter('momentAgo', function () {
	  var fn = function (input) {
	    var when = new Date(Date.parse(input));
	    return  moment(when).fromNow();
	  };
	  fn.$stateful = true;
	  return fn;
	}).filter('momentFrom', function () {
	  return function(fromDate, toDate) {
	    if (!fromDate) {
	      return null;
	    }
	
	    var fromMoment = moment(fromDate);
	    var toMoment = toDate ? moment(toDate) : moment();
	
	    var diff = fromMoment.diff(toMoment);
	    var duration = moment.duration(diff);
	    var mins = duration.minutes();
	    var hours = duration.hours();
	    var days = Math.floor(duration.asDays());
	    var result = (mins === 1 ? "1 minute" : mins + " minutes");
	    result = (hours !== 0 ? (hours === 1 ? "1 hour" : hours + " hours") + " and " : "") + result;
	    result = (days !== 0 ? (days === 1 ? "1 day" : days + " days") + ", " : "") + result;
	    return result;
	  };
	});


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.infrastructure');
	
	module.filter('pluralize', function () {
	  var vowels = ['a', 'e', 'i', 'o', 'u'];
	
	  var plural = function(singular) {
	    if (singular.slice(-1) === 'y' && !_.contains(vowels, singular.slice(-2, -1))) {
	      return singular.slice(0, -1) + 'ies';
	    }
	    return singular + 's';
	  };
	
	  return function (input, format) {
	    var singular = format || 'item';
	    var count = parseInt((input || 0).toString(), 10);
	    var countDesc = count.toString();
	    if (count === 0 || isNaN(count)) {
	      countDesc = 'no';
	    }
	    var pluralized = singular;
	    if (count === 0 || count > 1) {
	      pluralized = plural(singular);
	    }
	
	    return countDesc + ' ' + pluralized;
	  };
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 691 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.filter('resolveLink', function (octopusClient) {
	
	  return function (input, format) {
	    if (!input || input === '') {
	      return '';
	    }
	    return octopusClient.resolve(input);
	  };
	
	});
	
	


/***/ },
/* 692 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure')
	
	    .run(ConfigureRedirectOn401)
	
	    .run(ConfigureRedirectWhenNoUser);
	
	function ConfigureRedirectWhenNoUser($rootScope, $location, $state, octopusAuthenticator, octopusLog, octopusClient) {
	        // Some global properties for the current page
	        $rootScope.isAuthenticated = octopusAuthenticator.currentUser() || false;
	        $rootScope.currentUser = octopusAuthenticator.currentUser();
	        $rootScope.redirectAfterFormsLoginTo = null;
	        $rootScope.redirectAfterExternalLoginTo = octopusClient.uiRelativeRootPath($location);
	
	        function stateRedirect(toState, toParams) {
	            var redirect = toState.redirectTo;
	            if (redirect) {
	                if (angular.isFunction(redirect)) {
	                    redirect.call($state, toState, toParams);
	                } else {
	                    $state.go(redirect);
	                }
	                return true;
	            }
	        }
	
	        function subRouteRedirect(toState, toParams) {
	            var redirect = toState.defaultSubRoute;
	            if (redirect) {
	                $state.go(redirect, toParams, { location: false });
	                return true;
	            }
	        }
	
	        $rootScope.$on('$stateChangeSuccess', function(){
	            $rootScope.isAuthenticated = octopusAuthenticator.currentUser()  || false;
	            $rootScope.currentUser = octopusAuthenticator.currentUser();
	        });
	
	        // When the user changes navigation, make sure they are logged in
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	            if (subRouteRedirect(toState, toParams)){
	                event.preventDefault();
	                return;
	            }
	
	            if (stateRedirect(toState, toParams)) {
	                event.preventDefault();
	                return;
	            }
	
	            if (toState.name === 'app.not-found') {
	                return;
	            }
	
	            if (octopusAuthenticator.currentUser() !== null) {
	                $rootScope.redirectAfterFormsLoginTo = null;
	                $rootScope.redirectAfterExternalLoginTo = octopusClient.uiRelativeRootPath($location);
	                return;
	            }
	
	
	            var isDevelopmentMode = !octopusClient.urlIndicatesNonDevelopmentMode($location.absUrl(), octopusClient.resolve('~/'));
	            octopusLog.log('There is no current user.');
	            if (isAnonymous(toState)) {
	                // Preserve any pre-existing redirection so we follow deep links after signin or registration
	                if ($rootScope.redirectAfterFormsLoginTo === null) {
	                    // The user refreshed on the signin or register page and we want to redirect to the dashboard afterwards
	                    if (isDevelopmentMode) {
	                        $rootScope.redirectAfterFormsLoginTo = $location.absUrl().replace($location.path(), '');
	                        if ($rootScope.redirectAfterFormsLoginTo.endsWith('#')) {
	                            $rootScope.redirectAfterFormsLoginTo += '/';
	                        }
	                        $rootScope.redirectAfterExternalLoginTo = $rootScope.redirectAfterFormsLoginTo;
	
	                    } else {
	                        $rootScope.redirectAfterFormsLoginTo = '/';
	                        $rootScope.redirectAfterExternalLoginTo = octopusClient.uiRelativeRootPath($location);
	                    }
	                }
	                octopusLog.log('Sign-in or registration page is allowed, will return to ' + $rootScope.redirectAfterFormsLoginTo);
	            } else {
	                // This looks like the user has navigated to a deep link but isn't authenticated
	                // We need to preserve the original intended route, and redirect to the signin page
	                if (isDevelopmentMode) {
	                    //$rootScope.redirectAfterFormsLoginTo = $state.href(fromState.name, fromParams, {absolute: true});
	                    $rootScope.redirectAfterFormsLoginTo = $location.absUrl().replace($location.path(), '') + $state.href(toState.name, toParams).replace('#', '');
	                    $rootScope.redirectAfterExternalLoginTo = $rootScope.redirectAfterFormsLoginTo;
	                } else {
	                    $rootScope.redirectAfterFormsLoginTo = $state.href(toState.name, toParams).replace('#', ''); //$location.path(); // e.g: /users/sign-out"
	                    $rootScope.redirectAfterExternalLoginTo = octopusClient.urlStripHostAndPort($location);
	                }
	                octopusLog.log('Redirecting to the sign-in page, will return to ' + $rootScope.redirectAfterFormsLoginTo);
	
	                event.preventDefault();
	                $state.go('app.signin');
	            }
	        });
	    }
	
	function ConfigureRedirectOn401($rootScope, $location, octopusLog, octopusAuthenticator, octopusClient, $state) {
	    Octopus.Client.Util.ajax.error = function (error) {
	        if (error.StatusCode === 401 && !isAnonymous($state.current)) {
	            var apiUrl = octopusClient.resolve('~/');
	            if (octopusClient.urlIndicatesNonDevelopmentMode($location.absUrl(), apiUrl)) {
	                $rootScope.redirectAfterFormsLoginTo = $location.path();
	                $rootScope.redirectAfterExternalLoginTo = octopusClient.urlStripHostAndPort($location);
	            } else {
	                $rootScope.redirectAfterFormsLoginTo = $location.absUrl();
	                $rootScope.redirectAfterExternalLoginTo = $rootScope.redirectAfterFormsLoginTo;
	            }
	            octopusLog.log("Cookie has expired. Redirecting to login page, but will return to " + $rootScope.redirectAfterFormsLoginTo);
	            octopusAuthenticator.setCurrentPrincipal(null, null);
	            $state.go("app.signin");
	        }
	    };
	}
	
	function isAnonymous(stateName) {
	        return (stateName.name.indexOf('app.register') === 0 || stateName.name === 'app.signin');
	    }

/***/ },
/* 693 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	// A service that helps to show a spinner/busy indicator when a background action is happening, using promises.
	// When the busy service is injected into your controller, you can create a busy state:
	//
	//   var isLoading = scope.isLoading = busy.create();
	//
	// You can then use it to track promises:
	//
	//   isLoading.promise(somePromise);
	//
	// For example, a REST API request:
	//
	//   isLoading.promise(octopusRepository.Users.getCurrent().then(function (user) {
	//     console.log('Got a user', user);
	//   }));
	//
	// It exposes a property which you can use to show/hide a busy indicator when the promises are active:
	//
	//   <spin active='isLoading.busy'></spin>
	//
	// You can also show any errors which are returned from the promise:
	//
	//   <error-box error='isLoading.error'></error-box>
	//
	module.factory('busy', function ($rootScope, $q) {
	
	  var BusyState = function () {
	    var promises = [];
	    var self = this;
	    self.error = null;
	    self.busy = false;
	
	    self.showError = function(message) {
	      self.error = { ErrorMessage: message };
	    };
	
	    self.clearError = function(){
	      self.error = null;
	    };
	
	    self.showErrors = function(message, errors) {
	      self.error = { ErrorMessage: message, Errors: errors };
	    };
	
	    self.refresh = function () {
	      self.busy = promises.length > 0;
	      if (!($rootScope.$$phase)) {
	        $rootScope.$digest();
	      }
	    };
	
	    self.promises = function (proms) {
	      return self.promise($q.all(proms));
	    };
	
	    self.promise = function (prom) {
	      promises.push(prom);
	      self.refresh();
	
	      var onComplete = function () {
	        var ix = promises.indexOf(prom);
	        if (ix >= 0) {
	          promises.splice(ix, 1);
	        }
	
	        self.refresh();
	      };
	
	      var def = $q.defer();
	      prom.then(function (r) {
	        self.error = null;
	        onComplete();
	        def.resolve(r);
	      }, function (err) {
	        self.error = err;
	        onComplete();
	        def.reject(err);
	      });
	
	      return def.promise;
	    };
	
	    return self;
	  };
	
	  return {
	    create: function () {
	      return new BusyState();
	    }
	  };
	});
	


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var module = angular.module('octopusApp.infrastructure');
	
	module.directive("externalDropdown", function ($compile) {
	  return {
	    link: function (scope, element, attrs) {
	      var dropdownElement = null;
	      scope.$on('$destroy', function () {
	        if (dropdownElement) {
	          dropdownElement.remove();
	        }
	      });
	
	      element.click(function (e) {
	        e.preventDefault();
	
	        var data = scope.$eval(attrs.externalDropdown);
	        var childScope = scope.$new();
	        var template = $("#" + data.id);
	
	        var text = [];
	        text.push("<div class='dropdown dynamic-popups'>");
	        text.push(" <a class='hidden' id='_externaldropdown_toggler' data-toggle='dropdown'></a>");
	        text.push(template.html());
	        text.push("</div>");
	
	        var html = $compile(text.join(""))(childScope);
	
	        _.each(data.scope, function (val, key) {
	          childScope[key] = val;
	        });
	        childScope.$digest();
	
	        var refPos = element.offset();
	        var refHeight = element.outerHeight();
	        var containerPos = $("#body").offset();
	
	        dropdownElement = html;
	
	        html.css({
	          "position": "absolute",
	          "z-index": "100000",
	          "left": (refPos.left - 140) + "px",
	          "top": (refPos.top + refHeight) + "px"
	        });
	
	        $(".dynamic-popups").remove();
	
	        var parent = $("body");
	        parent.append(html);
	
	        var toggler = $("a#_externaldropdown_toggler", html).first();
	        toggler.dropdown("toggle");
	
	        return false;
	      });
	    }
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var module = angular.module('octopusApp.infrastructure');
	
	module.factory('octoDropdownMenu', function($compile) {
	  return {
	    show: function(scope, relativeToElement, templateId, data, position) {
	      var dropdownElement = null;
	      scope.$on('$destroy', function () {
	        if (dropdownElement) {
	          dropdownElement.remove();
	        }
	      });
	
	      var containerPos = $("#main-wrapper").offset();
	
	      var element = relativeToElement;
	      if (!position) {
	        var refPos = element.offset();
	        var refHeight = element.outerHeight();
	
	        position = { x: refPos.left, y: refPos.top + refHeight };
	      }
	
	      position.y = position.y - containerPos.top;
	
	      var childScope = scope.$new();
	      var template = $("#" + templateId);
	
	      var text = [];
	      text.push("<div class='dropdown'>");
	      text.push(" <a class='hidden' id='_externaldropdown_toggler' data-toggle='dropdown'></a>");
	      text.push(template.html());
	      text.push("</div>");
	
	      var html = $compile(text.join(""))(childScope);
	
	      _.each(data, function (val, key) {
	        childScope[key] = val;
	      });
	      childScope.$digest();
	
	
	      dropdownElement = html;
	
	      html.css({
	        "position": "absolute",
	        "z-index": "100000",
	        "left": (position.x) + "px",
	        "top": (position.y) + "px"
	      });
	
	      var parent = $("#dynamicallyGeneratedContent");
	      parent.empty();
	      parent.append(html);
	
	      var toggler = $("a#_externaldropdown_toggler", html).first();
	      toggler.dropdown("toggle");
	    }
	  };
	});
	
	module.factory('octoDialog', function ($uibModal) {
	  return {
	    asyncConfirm: function (options) {
	      options = options || {};
	
	      if (!options.windowClass) {
	        options.windowClass = "modal-alert modal-warning fade";
	      }
	
	      $uibModal.open({
	        templateUrl: 'infrastructure/controllers/views/async-confirm-dialog.html',
	        controller: 'AsyncConfirmDialogController',
	        windowClass: options.windowClass,
	        resolve: {
	          options: function() { return options; }
	        }
	      });
	    },
	
	    alertMessageBox: function (options) {
	      options = options || {};
	
	      if (!options.windowClass) {
	        options.windowClass = "modal-alert modal-warning fade";
	      }
	
	      return $uibModal.open({
	        templateUrl: 'infrastructure/controllers/views/alert-dialog.html',
	        controller: 'AlertDialogController',
	        windowClass: options.windowClass,
	        resolve: {
	          options: function () { return options; }
	        }
	      }).result;
	    },
	
	    messageBox: function(caption, message, buttons) {
	      return $uibModal.open({
	        templateUrl: 'infrastructure/controllers/views/message-box-dialog.html',
	        controller: 'MessageBoxController',
	        resolve: {
	          options: function() {
	            return {
	              caption: caption, message: message, buttons: buttons
	            };
	          }
	        }
	      }).result;
	    },
	
	    sort: function (options) {
	      $uibModal.open({
	        templateUrl: 'infrastructure/controllers/views/sort-dialog.html',
	        controller: 'SortDialogController',
	
	        resolve: {
	          options: function() { return options; }
	        }
	      });
	    },
	
	    prompt: function(options) {
	      return $uibModal.open({
	        templateUrl: 'infrastructure/controllers/views/prompt-dialog.html',
	        controller: 'PromptDialogController',
	        windowClass: "modal-alert modal-info fade",
	        resolve: {
	          options: function() { return options; }
	        }
	      }).result;
	    },
	
	    confirmDelete: function(what, onContinue) {
	      var options = {
	        title: "Delete " + what,
	        message: "Deleting this " + what + " is permanent, there is no going back. Do you wish to continue?",
	        executeButtonClass: "btn-warning",
	        executeButtonText: "Delete " + what,
	        execute: function (dialog) {
	          dialog.busy.promise(onContinue().then(function() {
	            dialog.dismiss();
	          }));
	        }
	      };
	
	      return $uibModal.open({
	        templateUrl: 'infrastructure/controllers/views/async-confirm-dialog.html',
	        controller: 'AsyncConfirmDialogController',
	        windowClass: "modal-alert modal-warning fade",
	        resolve: {
	          options: function() { return options; }
	        }
	      }).result;
	    },
	
	    confirmChangesWillBeLost: function(onContinue) {
	      var w = 'If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?';
	
	      var options = {
	        title: "Unsaved changes",
	        message: w,
	        executeButtonClass: "btn-warning",
	        executeButtonText: "Discard changes",
	        execute: function (dialog) {
	          onContinue();
	          dialog.dismiss();
	        }
	      };
	
	      return $uibModal.open({
	        templateUrl: 'infrastructure/controllers/views/async-confirm-dialog.html',
	        windowClass: "modal-alert modal-warning fade",
	        controller: 'AsyncConfirmDialogController',
	
	        resolve: {
	          options: function() { return options; }
	        }
	      }).result;
	    }
	  };
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 696 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.factory('octoDirectory', function () {
	  var map = [];
	  map.push({ prefix: "actiontemplates-", redirect: function (id) { return "#/library/steptemplates/" + id; }});
	  map.push({ prefix: "deployments-", redirect: function (id) { return "#/deployments/" + id; } });
	  map.push({ prefix: "environments-", redirect: function (id) { return "#/environments/" + id; } });
	  map.push({ prefix: "feeds-", redirect: function (id) { return "#/library/feeds/" + id; } });
	  map.push({ prefix: "libraryvariablesets-", redirect: function (id) { return "#/library/variables/" + id; }});
	  map.push({ prefix: "lifecycles-", redirect: function (id) { return "#/library/lifecycles/" + id; }});
	  map.push({ prefix: "machinepolicies-", redirect: function (id) { return "#/environments/machinepolicies/" + id; }});
	  map.push({ prefix: "machines-", redirect: function (id) { return "#/machines/" + id; } });
	  map.push({ prefix: "projects-", redirect: function (id) { return "#/projects/" + id; } });
	  map.push({ prefix: "projectgroups-", redirect: function (id) { return "#/projectgroups/" + id; } });
	  map.push({ prefix: "proxies-", redirect: function (id) { return "#/environments/proxies/" + id; } });
	  map.push({ prefix: "releases-", redirect: function (id) { return "#/releases/" + id; } });
	  map.push({ prefix: "servertasks-", redirect: function (id) { return "#/tasks/" + id; } });
	  map.push({ prefix: "tagsets-", redirect: function (id) { return "#/library/tagsets/" + id; }});
	  map.push({ prefix: "teams-", redirect: function (id) { return "#/configuration/teams/" + id; } });
	  map.push({ prefix: "tenants-", redirect: function (id) { return "#/tenants/" + id; } });
	  map.push({ prefix: "users-", redirect: function (id) { return "#/configuration/users/" + id; } });
	  map.push({ prefix: "subscriptions-", redirect: function (id) { return "#/configuration/audit/subscriptions/" + id; } });
	
	  return {
	    linkTo: function(id) {
	      if (!id) {
	        return '';
	      }
	
	      var lower = id.toLowerCase();
	
	      for (var i = 0; i < map.length; i++) {
	        var mapEntry = map[i];
	        if (lower.indexOf(mapEntry.prefix) === 0) {
	          return mapEntry.redirect(id);
	        }
	      }
	
	      return '#/not-found';
	    }
	  };
	});


/***/ },
/* 697 */
/***/ function(module, exports) {

	/*
	var module = angular.module('octopusApp.infrastructure');
	
	module.provider('octoRoute', function OctoRoute() {
	  this.redirect = function(getUrl) {
	    return {
	      templateUrl: 'areas/shared/views/redirect.html',
	      title: 'Loading...',
	      tab: '',
	      controller: function($scope, $routeParams, $location, busy, octopusRepository) {
	        $scope.isLoading = busy.create();
	        $scope.isLoading.promise(getUrl($routeParams, octopusRepository)).then(function(path) {
	          $location.path(path);
	          $location.replace();
	        });
	      }
	    };
	  };
	
	  this.$get = function() { };
	});
	
	
	*/


/***/ },
/* 698 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.factory('octoUploader', function($q, $filter, FileUploader, sniffer) {
	
	  function create($scope) {
	    var uploader = new FileUploader({
	        scope: $scope,
	        withCredentials: true,
	        headers: {'Accept': '*/*'}
	    });
	    var octoUpload = {
	      uploader: uploader,
	      begin: begin,
	      selectedFile: '',
	      cancel: cancel
	    };
	
	   uploader.onSuccessItem = function (item, response, status, headers) {
	      if (sniffer.isIE9) {
	        response = JSON.parse(response.replace('<pre>', '').replace('</pre>', ''));
	      }
	      if (response.ErrorMessage) {
	        item.uploadPromise.reject(response);
	        return;
	      }
	      item.uploadPromise.resolve(response);
	    };
	
	    uploader.onErrorItem = function (item, response, status, headers) {
	      item.uploadPromise.reject(response);
	    };
	
	    uploader.onAfterAddingFile = function(a){
	      octoUpload.selectedFile = a.file.name + ' ('+ $filter('bytesToSize')(a.file.size) +')';
	    };
	
	    function cancel(){
	      uploader.clearQueue();
	      octoUpload.selectedFile = '';
	    }
	
	    function begin(uploadUrl) {
	        if(uploader.queue === 0){
	            return;
	        }
	
	      var uploadPromise = $q.defer();
	
	      uploader.onBeforeUploadItem = function (item) {
	        delete uploader.onBeforeUploadItem;
	        item.uploadPromise = uploadPromise;
	
	        if (item._xhr) {
	          item._xhr.withCredentials = true;
	        }
	          item.withCredentials = true;
	          item.url = uploadUrl;
	      };
	
	      uploader.uploadItem(uploader.queue[uploader.queue.length-1]);
	      return uploadPromise.promise;
	    }
	
	    return octoUpload;
	  }
	
	  return {
	    create: create
	  };
	});
	


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.infrastructure');
	
	module.run(function ($rootScope) {
	  $rootScope.isBound = function(value) {
	    if (value) {
	      return value.indexOf("#{") >= 0;
	    }
	    return true;
	  };
	});
	
	module.factory('octoUtil', function() {
	  var entityMap = {
	    "&": "&amp;",
	    "<": "&lt;",
	    ">": "&gt;",
	    '"': '&quot;',
	    "'": '&#39;',
	    "/": '&#x2F;'
	  };
	
	  return {
	    escapeHtml: function (string) {
	      return String(string).replace(/[&<>"'\/]/g, function (s) {
	        return entityMap[s];
	      });
	    },
	    toBoolean: function toBoolean(value) {
	      if (value && value.length !== 0) {
	        var v = angular.lowercase("" + value);
	        value = !(v === 'f' || v === '0' || v === 'false' || v === 'no' || v === 'n' || v === '[]');
	      } else {
	        value = false;
	      }
	      return value;
	    },
	
	    insertString: function (source, index, string) {
	      if (index > 0) {
	        return source.substring(0, index) + string + source.substring(index, this.length);
	      }
	      else {
	        return string + source;
	      }
	    },
	
	    selectOptionsTextToList: function (input) {
	      input = input || "";
	
	      var lines = input.split("\n");
	      var results = [];
	
	      _.each(lines, function (l) {
	        l = l.trim();
	        if (l.length === 0) {
	          return;
	        }
	
	        var parts = l.split('|');
	        if (parts.length > 1) {
	          results.push({
	            Value: parts[0].trim(),
	            DisplayText: parts[1].trim()
	          });
	        } else {
	          results.push({
	            Value: l,
	            DisplayText: l
	          });
	        }
	      });
	
	      return results;
	    }
	  };
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 700 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	// Manages who the current user is
	module.factory('octopusAuthenticator', function () {
	  return {
	    currentUser: function (newValue) {
	      if (typeof (newValue) !== "undefined") {
	        Octopus.App.currentUser = newValue;
	        Octopus.App.currentPermissionSet = null;
	      }
	
	      if (typeof (Octopus.App.currentUser) === "undefined") {
	        return null;
	      }
	
	      return Octopus.App.currentUser;
	    },
	    setCurrentPrincipal: function(user, permissionSet) {
	      Octopus.App.currentUser = user;
	      Octopus.App.currentPermissionSet = permissionSet;
	    }
	  };
	});


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, jQuery) {var module = angular.module('octopusApp.infrastructure');
	
	// Make these Octopus.Client services available as Angular services
	
	module.factory('octopusClient', function ($q, $rootScope) {
	    Octopus.Client.PromiseWrapper = function(callback) {
	        var deferred = $q.defer();
	
	        callback(function ResolvePromise(value) {
	            if ($rootScope.$$phase) {
	                deferred.resolve(value);
	            } else {
	                $rootScope.$apply(function () {
	                    deferred.resolve(value);
	                });
	            }
	        }, function RejectPromise(value) {
	            if ($rootScope.$$phase) {
	                deferred.reject(value);
	            } else {
	                $rootScope.$apply(function () {
	                    deferred.reject(value);
	                });
	            }
	        });
	
	        return deferred.promise;
	    };
	    return Octopus.App.Client;
	});
	
	module.factory('octopusRepository', function (octopusClient) {
	    return new Octopus.Client.Repository(octopusClient);
	});
	
	module.factory('octopusPermissionSet', function(octopusRepository, $q) {
	
	    var ps = {};
	
	    var refresh = function() {
	        ps = {};
	        _.each(Octopus.App.currentPermissionSet, function(v, k) {
	            ps[k.toLowerCase()] = jQuery.map(v, function(e) {
	                return { 
	                    projectIds: jQuery.map(e.RestrictedToProjectIds || [], function(id) { return id.toLowerCase(); }),
	                    environmentIds: jQuery.map(e.RestrictedToEnvironmentIds || [], function(id) { return id.toLowerCase(); }),
	                    projectGroupIds: jQuery.map(e.RestrictedToProjectGroupIds || [], function(id) { return id.toLowerCase(); }) 
	                };
	            });
	        });
	    };
	
	    refresh();
	
	    return {
	        refresh: refresh,
	
	        firstAuthorized: function (permissions) {
	            var result = $q.defer();
	
	            var evaluate = function() {
	                var match = null;
	
	                _.each(permissions, function (p) {
	                    var restrictions = ps[p.toLowerCase()];
	
	                    if (!restrictions) {
	                        return;
	                    }
	
	                    if (!match) {
	                        match = p;
	                    }
	                });
	
	                return match;
	            };
	
	            result.resolve(evaluate());
	
	            return result.promise;
	        },
	
	        isAuthorized: function(authorization) {
	
	            var result = $q.defer();
	
	            var isWildcard = function(s) {
	                return s === '*';
	            };
	
	            var evaluate = function() {
	                var restrictions = ps[authorization.permission.toLowerCase()];
	
	                if (!restrictions) {
	                    // User doesn't have the permission in any scope
	                    return false;
	                }
	
	                if (restrictions.length === 0) {
	                    // No restrictions
	                    return true;
	                }
	
	                for (var i = 0; i < restrictions.length; i++) {
	                    var restriction = restrictions[i];
	                    var allowed = true;
	
	                    if (restriction.projectIds.length !== 0) {
	                        if (authorization.projectId == null ||
	                            (!isWildcard(authorization.projectId) &&
	                             jQuery.inArray(authorization.projectId.toLowerCase(), restriction.projectIds) === -1)) {
	                            allowed = false;
	                        }
	                    }
	
	                    if (restriction.environmentIds.length !== 0) {
	                        if (authorization.environmentId == null ||
	                            (!isWildcard(authorization.environmentId) &&
	                             jQuery.inArray(authorization.environmentId.toLowerCase(), restriction.environmentIds) === -1)) {
	                            allowed = false;
	                        }
	                    }
	
	                    if (restriction.projectGroupIds.length !== 0) {
	                        if (authorization.projectGroupId == null ||
	                            (!isWildcard(authorization.projectGroupId) &&
	                             jQuery.inArray(authorization.projectGroupId.toLowerCase(), restriction.projectGroupIds) === -1)) {
	                            allowed = false;
	                        }
	                    }
	
	                    if (allowed) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	            result.resolve(evaluate());
	
	            return result.promise;
	        }
	    };
	});
	
	
	module.factory('octopusFeatures', function($q, octopusRepository) {
	    var currentFeatures = {};
	
	    var refresh = function refresh() {
	        return octopusRepository.FeaturesConfiguration.get().then(function (features) {
	            currentFeatures = features;
	        });
	    };
	
	    var isEnabled = function isEnabled(feature){
	        return !!currentFeatures[feature];
	    };
	
	    refresh();
	    return {
	        refresh: refresh,
	        isEnabled: isEnabled
	    };
	});
	
	module.factory('octopusTagSets', function ($q, octopusRepository) {
	    var tagSeperator = "/";
	    var tagLoader = null;
	
	    function getAll() {
	        return tagLoader = octopusRepository.TagSets ?
	            octopusRepository.TagSets.all() :
	            $q.resolve([]);
	    }
	
	    function getTag(canonicalTagName) {
	        if (typeof canonicalTagName === 'string') {
	            return getTagSingle(canonicalTagName);
	        } else if (_.isArray(canonicalTagName)) {
	            return getTagArray(canonicalTagName);
	        }
	    }
	
	    function getTagSingle(canonicalTagName) {
	        return tagLoader.then(function (tagSets) {
	            var tag = findSingleTag(canonicalTagName, tagSets);
	            if (!!tag) {
	                return tag;
	            }
	
	            //Tag didn't match any in collection... lets try load and find again.
	            return getAll().then(function (tagSets) {
	                return findSingleTag(canonicalTagName, tagSets);
	            });
	        });
	    }
	
	    function getTagArray(canonicalTagNames) {
	        return tagLoader.then(function(tagSets) {
	            var mapped = canonicalTagNames.map(function(t){ return findSingleTag(t, tagSets); });
	            if (mapped.indexOf(null) === -1){
	                return mapped;
	            }
	
	            //There was a tag missing in the collection... lets try load and find again.
	            return getAll().then(function(tagSets){
	                return canonicalTagNames.map(function(t){ return findSingleTag(t, tagSets); });
	            });
	        });
	    }
	
	    function findSingleTag(canonicalTagName, tagSets) {
	        var tagSetName = canonicalTagName.split(tagSeperator)[0];
	        for (var i in tagSets) {
	            var tagSet = tagSets[i];
	            if (tagSet.Name !== tagSetName) {
	                continue;
	            }
	
	            for (var j in tagSet.Tags) {
	                var tag = tagSet.Tags[j];
	                if (canonicalTagName === tag.CanonicalTagName) {
	                    return tag;
	                }
	            }
	        }
	        return null;
	    }
	
	    function groupByTagSet(canonicalTagNames) {
	        return _.groupBy(canonicalTagNames, function(ctn) { return ctn.split(tagSeperator)[0]; } );
	    }
	
	    getAll();
	    return {
	        getAll: getAll,
	        getTag: getTag,
	        groupByTagSet: groupByTagSet
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 702 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	// Simple logger
	module.factory('octopusLog', function () {
	  var instance = {};
	  instance.isEnabled = true;
	
	  var consoleWrapper = function (name) {
	    var console = window.console;
	    if (console && console[name]) {
	      if (console[name].apply) {
	        return function () {
	          if (instance.isEnabled) {
	            console[name].apply(console, arguments);
	          }
	        };
	      } else {
	        return function () {
	          if (instance.isEnabled) {
	            var message = Array.prototype.join.call(arguments, ', ');
	            console[name](message);
	          }
	        };
	      }
	    }
	
	    return function () {
	      return this;
	    };
	  };
	
	  instance.log = consoleWrapper('log');
	  instance.info = consoleWrapper('info');
	  instance.warn = consoleWrapper('warn');
	  instance.error = consoleWrapper('error');
	  instance.error = consoleWrapper('error');
	  instance.enabled = function (b) {
	    if (typeof (b) !== "undefined") {
	      instance.isEnabled = b;
	    }
	    return instance.isEnabled;
	  };
	  return instance;
	});


/***/ },
/* 703 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.factory('pageTitle', function($rootScope) {
	  return function(title) {
	    $rootScope.pageTitle = title;
	  };
	});


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.infrastructure');
	
	// Allows other parties to register 'plugins' that provide the view and edit experience for
	// custom deployment actions and conventions.
	//
	//   var module = angular.module('myPlugin', [], function(pluginRegistry) {
	//      pluginRegistry.registerDeploymentAction("Octopus.TentaclePackage", {
	//        title: "Deploy a NuGet package",               // Display text for users adding the step
	//        summary: "Deploys a NuGet package...",         // Help text to show
	//        summaryTemplateUrl: "area/foo/bar.html",       // Template for a short summary on the process overview page
	//        summaryLink: function (scope, element) {       // Angular directive-style link function
	//          var action = scope.action;                   // Get the action we are rendering
	//          var step = scope.step;                       // Get the step we are rendering
	//          var jQueryElement = element;                 // The HTML element for the bar.html we just inserted
	//        },
	//        editTemplate: "area/bar/baz.html"              // Template for editing
	//      });
	//
	//      pluginRegistry.registerFeature("Octopus.Features.CustomPackageDirectory", {
	//        isEnabled: function(action, step) {  },
	//        enable: function(action, step) {  },
	//        disable: function(action, step) {  },
	//        editTemplateUrl: "area/foo/bar.html",
	//        editLink: function(scope, element) { }
	//      });
	//   });
	
	module.factory('pluginRegistry', function ($injector) {
	  var data = {};
	  data.registeredActions = {};
	  data.registeredFeatures = {};
	
	  var resolve = function (container, key, callback) {
	    var result = $injector.invoke(container[key]);
	    callback(result, key);
	    return result;
	  };
	
	  var resolveAll = function (container, callback) {
	    return _.chain(container).map(function (registration, key) {
	      return resolve(container, key, callback);
	    }).sortBy(function (item) { return item.priority; }).value();
	  };
	
	  var registry = {};
	  registry.registerDeploymentAction = function(actionType, registration) {
	    data.registeredActions[actionType] = registration;
	  };
	  registry.getDeploymentAction = function(actionType) {
	    return resolve(data.registeredActions, actionType, function (feature, name) { feature.actionType = name; });
	  };
	  registry.getAllActions = function() {
	    return resolveAll(data.registeredActions, function (feature, name) { feature.actionType = name; });
	  };
	  registry.registerFeature = function(featureName, registration) {
	    data.registeredFeatures[featureName] = registration;
	  };
	  registry.getFeature = function(featureName) {
	    return resolve(data.registeredFeatures, featureName, function (feature, name) { feature.featureName = name; });
	  };
	  registry.getAllFeatures = function() {
	    return resolveAll(data.registeredFeatures, function (feature, name) { feature.featureName = name; });
	  };
	  registry.hasFeaturesForAction = function(actionType) {
	    var actionPlugin = registry.getDeploymentAction(actionType);
	    return _.chain(registry.getAllFeatures()).filter(function (f) { return actionPlugin.features && actionPlugin.features.optional && _.contains(actionPlugin.features.optional, f.featureName); }).value().length > 0;
	  };
	
	  return registry;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 705 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	// A service that helps for building screens that auto-refresh from a service.
	// You create a loop by attaching it to your scope (it will automatically stop looping
	// when your scope is destroyed by Angular) and giving it a callback.
	//
	//   var loop = pollLoop.create($scope, function () {
	//     return doSomethingThatReturnsAPromise();
	//   });
	//
	// Start the loop using:
	//
	//   loop.start();                or
	//   loop.startImmediately();
	//
	// The callback must return a promise. The loop will set a timeout to run again once
	// the promise completes (success or fail) - that way if you have a 3 second poll loop,
	// the 3 seconds starts from when your service call finishes, not from when it started.
	//
	// When you're finished polling, you can use:
	//
	//   loop.stop();
	//
	module.factory('pollLoop', function ($timeout, octopusLog) {
	  return {
	    create: function ($scope, callbackThatReturnsAPromise, timeout) {
	      if (!timeout) {
	        timeout = 4000;
	      }
	
	      var instance = {};
	      instance.activeId = 0;
	      instance.isRunning = false;
	
	      $scope.$on('$destroy', function () {
	        instance.isRunning = false;
	        //octopusLog.info("Poll loop destroyed");
	      });
	
	      instance.stop = function() {
	        instance.isRunning = false;
	      };
	
	      var startInternal = function (immediate) {
	        instance.activeId++;
	        var id = instance.activeId;
	        if (instance.isRunning) {
	          return;
	        }
	
	        instance.isRunning = true;
	
	        var firstTime = true;
	
	        var doTimeout = function () {
	          $timeout(function () {
	            loop();
	          }, timeout);
	        };
	
	        var loop = function() {
	          if (!instance.isRunning || id !== instance.activeId) {
	            return;
	          }
	
	          if (!firstTime || immediate) {
	            var prom = callbackThatReturnsAPromise();
	            if (!prom) {
	              octopusLog.error("The poll loop callback should return a promise");
	            } else {
	              prom.then(function () {
	                doTimeout();
	              }, function () {
	                doTimeout();
	              });
	            }
	          } else if (firstTime && !immediate) {
	            doTimeout();
	          }
	
	          firstTime = false;
	        };
	
	        loop();
	      };
	
	      instance.startImmediately = function () {
	        startInternal(true);
	      };
	
	      instance.start = function () {
	        startInternal(false);
	      };
	
	      return instance;
	    }
	  };
	});

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var module = angular.module('octopusApp.infrastructure');
	
	module.factory('sensitiveValue', function () {
	
	    return {
	        // Returns a reset-value function for use with bound-field directive
	        getResetValue: function (model) {
	
	            // If not an object, then it wasn't a sensitive-value
	            if (typeof(model) !== 'object') {
	                return function () {
	                    return {HasValue: false};
	                };
	            }
	
	            var initial = _.clone(model);
	            return function () {
	                return _.clone(initial);
	            };
	        }
	    };
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 707 */
/***/ function(module, exports) {

	// Trying to keep all the ugliness in one place.
	
	var module = angular.module('octopusApp.infrastructure');
	
	module.factory('sniffer', function(){
	  var ie = navigator.appName === 'Microsoft Internet Explorer';
	  var re  = new RegExp("MSIE 9\\.0");
	  var ie9 = ie && re.exec(navigator.userAgent);
	  return {
	    isIE: ie,
	    isIE9: ie9
	  };
	});
	


/***/ },
/* 708 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	
	module.factory('timeSpan', function($rootScope) {
	
	  var create = function(ms) {
	    var totalMilliseconds = ms;
	
	    var rem = totalMilliseconds;
	
	    var days = Math.floor(rem / (1000 * 60 * 60 * 24));
	    rem -=  days * (1000 * 60 * 60 * 24);
	
	    var hours = Math.floor(rem / (1000 * 60 * 60));
	    rem -= hours * (1000 * 60 * 60);
	
	    var minutes = Math.floor(rem / (1000 * 60));
	    rem -= minutes * (1000 * 60);
	
	    var seconds = Math.floor(rem / (1000));
	    rem -= seconds * (1000);
	
	    var milliseconds = Math.round(rem);
	
	    var totalSeconds = function() {
	      return totalMilliseconds / 1000;
	    };
	
	    var totalMinutes = function() {
	      return totalSeconds() / 60;
	    };
	
	    var totalHours = function() {
	      return totalMinutes() / 60;
	    };
	
	    var totalDays = function() {
	      return totalHours() / 24;
	    };
	
	    var pad2 = function(str) {
	      return '00'.concat(str).slice(-2);
	    };
	
	    var pad3 = function(str) {
	      return '000'.concat(str).slice(-3);
	    };
	
	    var toString = function() {
	      var result = '';
	      if (days > 0) {
	        result = result.concat(days.toString(), '.');
	      }
	      result = result.concat(pad2(hours), ':', pad2(minutes), ':', pad2(seconds));
	      if (milliseconds !== 0) {
	        result = result.concat('.', pad3(milliseconds));
	      }
	      return result;
	    };
	
	    return {
	      totalDays: totalDays,
	      totalHours: totalHours,
	      totalMinutes: totalMinutes,
	      totalSeconds: totalSeconds,
	      totalMilliseconds: function() { return totalMilliseconds; },
	
	      days: function() { return days; },
	      hours: function() { return hours; },
	      minutes: function() { return minutes; },
	      seconds: function() { return seconds; },
	      milliseconds: function() { return milliseconds; },
	
	      toString: toString
	    };
	  };
	
	  var parse = function(str) {
	    var parts = str.split(':');
	
	    var ms = parseFloat(parts[parts.length - 1] * 1000);
	
	    if (parts.length === 2) {         // 00:00.000
	      ms += parseInt(parts[0], 10) * 60 * 1000;
	    } else if (parts.length === 3) { // 0.00:00:00.000
	      var dh = parts[0].split('.');
	      if (dh.length === 1) {
	        ms += parseInt(parts[0], 10) * 60 * 60 * 1000;
	      } else {
	        ms += parseInt(dh[0], 10) * 24 * 60 * 60 * 1000;
	        ms += parseInt(dh[1], 10) * 60 * 60 * 1000;
	      }
	      ms += parseInt(parts[1], 10) * 60 * 1000;
	    } else {
	      throw "Invalid TimeSpan string " + str;
	    }
	
	    return create(ms);
	  };
	
	  var fromMilliseconds = function(ms) {
	    return create(ms);
	  };
	
	  var fromSeconds = function(s) {
	    return create(s * 1000);
	  };
	
	  var fromMinutes = function(m) {
	    return create(m * 60 * 1000);
	  };
	
	  return {
	    fromMilliseconds: fromMilliseconds,
	    fromSeconds: fromSeconds,
	    fromMinutes: fromMinutes,
	
	    parse: parse
	  };
	});
	


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var module = angular.module('octopusApp.infrastructure');
	var _ = __webpack_require__(1);
	
	// A service that helps to prompt for unsaved changes
	//
	//
	module.factory('unsavedChanges', function ($rootScope, $location, octoDialog) {
	
	    $rootScope.octopusUnsavedChanges = false;
	
	    var instance = {};
	
	    instance.hasUnsavedChanges = function () {
	        return $rootScope.octopusUnsavedChanges;
	    };
	
	    instance.saved = function () {
	        $rootScope.octopusUnsavedChanges = false;
	        $rootScope.$broadcast('changesSaved', {});
	    };
	
	    instance.ignoreNextLocationChange = function () {
	        // Ignore next location change.  Then reset.
	        $rootScope.ignoreNextLocationChange = true;
	    };
	
	    instance.unsaved = function () {
	        $rootScope.octopusUnsavedChanges = true;
	    };
	
	    $rootScope.$on("$stateChangeSuccess", function () {
	        instance.saved();
	    });
	
	    var leave = false;
	    $rootScope.$on('$locationChangeStart', function (event, next) {
	        if (leave) {
	            leave = false;
	            return;
	        }
	
	        if ($rootScope.octopusUnsavedChanges && !$rootScope.ignoreNextLocationChange) {
	            event.preventDefault();
	
	            octoDialog.confirmChangesWillBeLost(function () {
	                leave = true;
	
	                $location.url($location.url(next).hash());
	            });
	        }
	
	        if ($rootScope.ignoreNextLocationChange) {
	            $rootScope.ignoreNextLocationChange = false; // Reset
	        }
	    });
	
	    window.onbeforeunload = function (e) {
	        if ($rootScope.octopusUnsavedChanges) {
	            var message = "Unsaved changes will be lost.";
	            var evt = e || window.event;
	            if (evt) {
	                evt.returnValue = message;
	            }
	            return message;
	        }
	    };
	
	    return instance;
	});
	
	


/***/ },
/* 710 */
/***/ function(module, exports) {

	var module = angular.module('octopusApp.infrastructure');
	module.controller('StyleGuideController', function ($scope, pageTitle, $filter) {
	    pageTitle("Live Style Guide");
	    $scope.resolveLink = $filter('resolveLink');
	    $scope.availableEnvironments = [{Id:'1', Name:'Envioronment1'}, {Id:'2', Name:'Envioronment2'}, {Id:'3', Name:'Envioronment3'}, {Id:'4', Name:'Envioronment4'}];
	    $scope.selectedEnvironmentIds = [];
	
	    $scope.cards = [];
	    for(var i = 0; i < 12; i++)
	    {
	        $scope.cards.push({
	                        title : "Concept title" + i,
	                        content: "Concept content" + i,
	                        logoUrl: "http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo"
	                    });
	    }
	});
	


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, _) {// Contains Octopus-specific SlickGrid editors
	var promptedImage = __webpack_require__(1277);
	
	(function ($) {
	
	  function OctopusVariableStateFormatter(row, cell, value, columnDef, dataContext) {
	    if(value && value.icon)
	    {
	      return "<i class='fa fa-lg fa-"+value.icon+" "+ value.class + "' title='"+value.title+"'></i>";
	    }
	    
	    if (value === "New") {
	      return "<i class='fa fa-lg fa-asterisk text-warning' title='This variable has been added'></i>";
	    } else if (value === "Changed") {
	      return "<i class='fa fa-lg fa-pencil text-primary' title='This variable has been modified'></i>";
	    } else if (value === "Deleted") {
	      return "<i class='fa fa-lg fa-remove text-danger' title='When you save, this variable will be deleted'></i>";
	    } else {
	      return "<i class='fa fa-lg fa-check text-success' title='This variable has not been modified'></i>";
	    }
	  }
	
	  function escapeVariableValue(string) {
	    if (string === null) {
	      return "";
	    }
	    var subs = {
	      "&": "&amp;",
	      "<": "&lt;",
	      ">": "&gt;",
	      '"': '&quot;',
	      "'": '&apos;',
	      "/": '&#x2F;'
	    };
	
	    var esc = String(string).replace(/[&<>"'\/]/g, function (s) {
	      return subs[s];
	    });
	
	    return esc.replace(/\n/g, '<strong style="color: #CCC">&para;</strong>');
	  }
	
	  function OctopusVariableValueFormatter(row, cell, value, columnDef, dataContext) {
	    var result;
	    if (dataContext.isSensitive) {
	      result = "●●●●●●●●●●";
	    } else {
	      result = escapeVariableValue(dataContext.value);
	    }
	
	    if (dataContext.prompt && dataContext.prompt.label) {
	      return "<img src='" + promptedImage + "' alt='This value will be entered at deployment time' width='16' height='16' /> " + result;
	    } else {
	      return result;
	    }
	  }
	
	  // Used for a variable value. Shows the variable value with a textarea, and a checkbox for whether it is secure
	  var variableValueTemplate = [];
	  variableValueTemplate.push("<div style='z-index:1030;position:absolute;' class='slick-edit-dialog slick-cell-editor variable-value-editor'>");
	  variableValueTemplate.push("  <textarea hidefocus class='var-edit'></textarea>");
	  variableValueTemplate.push("  <div style='text-align: right'>");
	  variableValueTemplate.push("    <div class='checkbox' style='float: left; margin-top: 6px;'><label>");
	  variableValueTemplate.push("      <input type='checkbox' class='var-sens' style='position: static' /> <span style='vertical-align: top'>Sensitive</span>");
	  variableValueTemplate.push("    </label></div>");
	  variableValueTemplate.push("    <button style='float: left;' class='btn btn-link var-prompt'>Prompt...</button>");
	  variableValueTemplate.push("    <button class='btn btn-success var-save'>Apply</button> ");
	  variableValueTemplate.push("    <button class='btn btn-link var-cancel'>Cancel</button>");
	  variableValueTemplate.push("  </div>");
	  variableValueTemplate.push("</div>");
	  var variableValueTemplateString = variableValueTemplate.join("\n");
	
	  function OctopusVariableValueEditor(args) {
	    var $val, $isSensitive;
	    var scope = this;
	    var defaultValue;
	    var defaultPrompt;
	    var defaultSensitive;
	    var prompt;
	    var promptLink;
	
	    this.init = function () {
	      var editor = $(variableValueTemplateString).appendTo($("#dynamicallyGeneratedContent"));
	      var position = $(args.container).offset();
	      editor.css("top", (position.top) + "px");
	      editor.css("left", position.left + "px");
	
	      $val = $(".var-edit", editor);
	      $isSensitive = $(".var-sens", editor);
	      $val.resizable({
	        handles: "se",
	        minHeight: 50,
	        minWidth: 450
	      });
	      $val.bind("keydown", scope.handleKeyDown);
	
	      editor.find(".var-save").bind("click", this.save);
	      editor.find(".var-cancel").bind("click", this.cancel);
	      editor.find(".var-prompt").bind("click", this.promptDialog);
	
	      promptLink = editor.find(".var-prompt");
	      scope.focus();
	    };
	
	    this.refreshPromptStatus = function() {
	      if (!prompt) {
	        promptLink.text("Prompt");
	      } else {
	        promptLink.text("Change prompt");
	      }
	    };
	
	    this.promptDialog = function (e) {
	      var editorTemplate = [];
	      editorTemplate.push("<div class='modal' style='z-index: 10000'><div class='modal-dialog'><div class='modal-content'>");
	      editorTemplate.push("  <div class='modal-header'>");
	      editorTemplate.push("    <button type='button' class='close' data-dismiss='modal'' aria-hidden='true'>&times;</button>");
	      editorTemplate.push("    <h3>Prompt settings</h3>");
	      editorTemplate.push("  </div>");
	      editorTemplate.push("  <div class='modal-body'>");
	      editorTemplate.push("  <div class='form-horizontal'>");
	      editorTemplate.push('   <div class="form-group">');
	      editorTemplate.push('    <label class="col-sm-3 control-label" for="prompt-label">Label:</label>');
	      editorTemplate.push('    <div class="col-sm-9">');
	      editorTemplate.push('     <input type="text" id="prompt-label" class="form-control" />');
	      editorTemplate.push("    </div>");
	      editorTemplate.push("   </div>");
	      editorTemplate.push('   <div class="form-group">');
	      editorTemplate.push('    <label class="col-sm-3 control-label" for="prompt-description">Description:</label>');
	      editorTemplate.push('    <div class="col-sm-9">');
	      editorTemplate.push('     <input type="text" id="prompt-description" class="form-control" />');
	      editorTemplate.push("    </div>");
	      editorTemplate.push("   </div>");
	      editorTemplate.push('   <div class="form-group">');
	      editorTemplate.push('    <div class="col-md-3"></div>');
	      editorTemplate.push('    <div class="checkbox col-md-9">');
	      editorTemplate.push("     <label>");
	      editorTemplate.push("       <input type='checkbox' id='prompt-required' /> Required");
	      editorTemplate.push("     </label>");
	      editorTemplate.push("    </div>");
	      editorTemplate.push("   </div>");
	      editorTemplate.push("  </div>");
	      editorTemplate.push("  </div>");
	      editorTemplate.push("  <div class='modal-footer'>");
	      editorTemplate.push("    <button class='btn btn-success prompt-save'>Apply</button> ");
	      editorTemplate.push("    <button class='btn btn-warning prompt-delete'>Delete prompt</button>");
	      editorTemplate.push("    <button class='btn btn-link prompt-cancel'>Cancel</button>");
	      editorTemplate.push("  </div>");
	      editorTemplate.push("</div></div></div>");
	
	      var editor = $(editorTemplate.join('\n'))
	        .appendTo("#dynamicallyGeneratedContent");
	
	      var $promptLabel = $("#prompt-label", editor);
	      var $promptDescription = $("#prompt-description", editor);
	      var $promptRequired = $("#prompt-required", editor);
	
	      if (prompt) {
	        $promptLabel.val(prompt.label);
	        $promptDescription.val(prompt.description);
	        if (prompt.required) {
	          $promptRequired.attr("checked", "checked");
	        } else {
	          $promptRequired.attr("checked", null);
	        }
	      } else {
	        $(".prompt-delete", editor).hide();
	      }
	
	      editor.modal({
	        backdrop: true
	      });
	
	      $promptLabel.focus();
	
	      $("button.prompt-cancel", editor).click(function () {
	        editor.modal("hide");
	      });
	
	      $("button.prompt-save", editor).click(function () {
	        prompt = {
	          label: $promptLabel.val(),
	          description: $promptDescription.val(),
	          required: $promptRequired.is(":checked")
	        };
	        scope.refreshPromptStatus();
	        editor.modal("hide");
	      });
	
	      $("button.prompt-delete", editor).click(function () {
	        prompt = null;
	        scope.refreshPromptStatus();
	        editor.modal("hide");
	      });
	    };
	
	    this.handleKeyDown = function (e) {
	      if (e.which === $.ui.keyCode.ENTER && e.ctrlKey) {
	        scope.save();
	      } else if (e.which === $.ui.keyCode.ESCAPE) {
	        e.preventDefault();
	        scope.cancel();
	      } else if (e.which === $.ui.keyCode.TAB && e.shiftKey) {
	        e.preventDefault();
	        args.grid.navigatePrev();
	        return false;
	      } else if (e.keyCode === $.ui.keyCode.LEFT || e.keyCode === $.ui.keyCode.RIGHT || (e.keyCode === $.ui.keyCode.ENTER && e.shiftKey)) {
	        e.stopImmediatePropagation();
	      } else if (e.keyCode === $.ui.keyCode.TAB) {
	        e.preventDefault();
	        args.grid.navigateNext();
	        return false;
	      }
	    };
	
	    this.save = function () {
	      args.commitChanges();
	    };
	
	    this.cancel = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      scope.refreshPromptStatus();
	      $val.val(defaultValue);
	      if (defaultSensitive) {
	        $isSensitive.attr("checked", "checked");
	      } else {
	        $isSensitive.attr("checked", null);
	      }
	      args.cancelChanges();
	      return false;
	    };
	
	    this.destroy = function () {
	      $("#dynamicallyGeneratedContent").empty();
	    };
	
	    this.focus = function () {
	      $val.focus();
	    };
	
	    this.serializeValue = function () {
	      return {
	        value: ($val.val() || '').trim(),
	        prompt: prompt,
	        isSensitive: $isSensitive.is(":checked")
	      };
	    };
	
	    this.applyValue = function (item, state) {
	      item.value = state.value;
	      item.isSensitive = state.isSensitive;
	      item.prompt = state.prompt;
	    };
	
	    this.loadValue = function (item) {
	      prompt = defaultPrompt = item.prompt;
	      scope.refreshPromptStatus();
	      $val.val(defaultValue = item.value);
	      $val.select();
	      defaultSensitive = item.isSensitive;
	      if (item.isSensitive) {
	        $isSensitive.attr("checked", "checked");
	      } else {
	        $isSensitive.attr("checked", null);
	      }
	    };
	
	    this.isValueChanged = function () {
	      return (!($val.val() === "" && defaultValue === null)) && ($val.val() !== defaultValue) || $isSensitive.is(":checked") !== defaultSensitive || angular.toJson(prompt) !== angular.toJson(defaultPrompt);
	    };
	
	    this.validate = function () {
	      return {
	        valid: true
	      };
	    };
	
	    this.init();
	  }
	
	  function OctopusVariableScopeToString(scope, variableSettings) {
	    if (!scope) {
	      return "";
	    }
	
	    var fields = [];
	
	    _.chain(variableSettings.scopeOptions).map(function (a) { return a; }).reverse().each(function(option) {
	      var valueDictionary = {};
	
	      _.each(option.values, function(v) {
	        valueDictionary[v.id] = v.name;
	      });
	
	      if (scope[option.name] && scope[option.name].length > 0) {
	        var selected = [];
	        _.each(scope[option.name], function(selection) {
	          selected.push(valueDictionary[selection]);
	        });
	        fields.push(selected.join(", "));
	      }
	    });
	    
	    return fields.join("; ");
	  }
	
	  function OctopusVariableScopeFormatter(row, cell, value, columnDef, dataContext) {
	    return OctopusVariableScopeToString(value, columnDef.variableSettings);
	  }
	
	  function OctopusVariableScopeEditor(args) {
	    var columnDef = args.column;
	    //var variableSettings = columnDef.variableSettings;
	
	    var self = this;
	
	    var inlineEditor;
	    var modifiedScope = {};
	    var originalScope;
	
	    this.init = function () {
	      var editorTemplate = args.isFilter ?
	          '<button class="variable-scope-editor filter">Show all</button>' :
	          '<button class="variable-scope-editor" style="color: #555555; margin: 0; padding: 0; font-style: italic; background: transparent; border: none; box-shadow: none">Press enter to edit scope</button>';
	
	      inlineEditor = $(editorTemplate)
	        .appendTo(args.container)
	        .keydown(self.handleKeyDown)
	        .click(function () {
	          var controller = angular.element(args.container).scope();
	          controller.showScopePicker(modifiedScope, args.isFilter, function(result){
	            if(result) {
	              modifiedScope = result;
	              self.save();
	            }
	            inlineEditor.focus();
	          });
	        });
	
	      self.focus();
	    };
	
	    this.handleKeyDown = function (e) {
	      if (e.which === $.ui.keyCode.ENTER) {
	        e.stopImmediatePropagation();
	        return true;
	      } else if (e.which === $.ui.keyCode.TAB && e.shiftKey) {
	        e.preventDefault();
	        args.grid.navigatePrev();
	        return false;
	      } else if (e.keyCode === $.ui.keyCode.TAB) {
	        e.preventDefault();
	        args.grid.navigateNext();
	        return false;
	      }
	    };
	
	    this.save = function () {
	      args.commitChanges();
	    };
	
	    this.cancel = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      args.cancelChanges();
	      return false;
	    };
	
	    this.destroy = function () {
	      $(args.container).empty();
	    };
	
	    this.focus = function () {
	      inlineEditor.focus();
	    };
	
	    this.serializeValue = function () {
	      return modifiedScope;
	    };
	
	    this.applyValue = function (item, state) {
	      item.scope = state;
	    };
	
	    this.loadValue = function (item) {
	      modifiedScope = item.scope;
	      originalScope = item.scope;
	    };
	
	    this.isValueChanged = function () {
	      if (_.difference(Object.keys(modifiedScope), Object.keys(originalScope)).length !== 0
	      || _.difference(Object.keys(originalScope), Object.keys(modifiedScope)).length !== 0) {
	        return true;
	      }
	
	      for(var prop in modifiedScope) {
	        if(_.difference(modifiedScope[prop], originalScope[prop]).length !== 0
	        || _.difference(originalScope[prop], modifiedScope[prop]).length !== 0) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    this.validate = function () {
	      return {
	        valid: true
	      };
	    };
	
	    this.init();
	  }
	
	  function OctopusVariableSourceFormatter(row, cell, value, columnDef, dataContext) {
	    return value ? "<a href='#"+value.link + "'>" + value.name + "</a>" : "";
	  }
	
	  $.extend(true, window, {
	    "Slick": {
	      "Editors": {
	        "OctopusVariableValue": OctopusVariableValueEditor,
	        "OctopusVariableScope": OctopusVariableScopeEditor
	      },
	      "Formatters": {
	        "OctopusVariableValue": OctopusVariableValueFormatter,
	        "OctopusVariableState": OctopusVariableStateFormatter,
	        "OctopusVariableScope": OctopusVariableScopeFormatter,
	        "OctopusVariableSource": OctopusVariableSourceFormatter
	      },
	      "Helpers": {
	        "OctopusVariableScopeToString": OctopusVariableScopeToString
	      }
	    }
	  });
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 712 */
/***/ function(module, exports) {

	// Ensure calls to console.log don't break IE
	if (typeof console === "undefined" || typeof console.log === "undefined") {
	  console = {};
	  console.log = function() {};
	}
	
	var Octopus = window.Octopus = window.Octopus || {};


/***/ },
/* 713 */
/***/ function(module, exports) {

	Octopus.Model = Octopus.Model || {};
	
	Octopus.Model.AutomaticExpander = function (rootNode) {
	    var self = this;
	
	    // Modes:
	    //  All
	    //  Errors
	    //  None
	    //  Interesting (errors and currently running)
	    //  Custom
	    self.mode = "Interesting";
	
	    self.setMode = function (mode) {
	        self.mode = mode;
	        self.refresh();
	        self.changed();
	    };
	
	    self.isExpanded = function (node) {
	        if (self.mode === "Custom") {
	            return node.isExpanded;
	        } else if (self.mode === "All") {
	            return true;
	        } else if (self.mode === "Errors") {
	            return node.hasErrors;
	        } else if (self.mode === "Interesting") {
	            return node.id === rootNode.id || node.hasErrors || node.showAtSummaryLevel || node.status === "Pending" || node.status === "Running" || node.status === "SuccessWithWarning" || node.status === "Canceled";
	        } else if (self.mode === "None") {
	            return false;
	        }
	    };
	
	    var expand = function (node) {
	        var childExpanded = false;
	        for (var i = 0; i < node.children.length; i++) {
	            if (expand(node.children[i])) {
	                childExpanded = true;
	            }
	        }
	
	        if (childExpanded) {
	            node.isExpanded = true;
	            return true;
	        }
	
	        if (self.isExpanded(node)) {
	            node.isExpanded = true;
	            return true;
	        } else {
	            node.isExpanded = false;
	            return false;
	        }
	    };
	
	    self.refresh = function () {
	        if (self.mode === "Custom") {
	            return;
	        }
	        expand(rootNode);
	    };
	
	    self.changed = function () {
	        rootNode.updateCount++;
	    };
	
	    return self;
	};
	
	Octopus.Model.LogTreeNode = function () {
	    var self = this;
	    self.id = null;
	    self.status = null;
	    self.children = [];
	    self.name = null;
	    self.started = null;
	    self.logElements = [];
	    self.childrenById = {};
	    self.updateCount = 0;
	    self.progressMessage = "";
	    self.progressPercentage = 0;
	    self.showAtSummaryLevel = false;
	    self.counter = 0;
	    self.isExpanded = false;
	    self.expander = new Octopus.Model.AutomaticExpander(self);
	    self.additionalEntries = 0;
	
	    self.toggleExpanded = function () {
	        if (!self.isExpanded) {
	            self.expandSingleNodes();
	        }
	        else {
	            self.isExpanded = false;
	        }
	        if (self.expander) {
	            self.expander.mode = "Custom";
	        }
	    };
	
	    self.expandSingleNodes = function () {
	        self.isExpanded = true;
	        if (self.children.length === 1) {
	            self.children[0].expandSingleNodes();
	        }
	    };
	
	    self.expandTo = function (e) {
	        return self.expandToId(e.id);
	    };
	
	    self.expandToId = function (id) {
	        if (id === self.id) {
	            self.isExpanded = true;
	            return true;
	        } else {
	            for (var q = 0; q < self.children.length; q++) {
	                if (self.children[q].expandToId(id)) {
	                    self.isExpanded = true;
	                    if (self.expander) {
	                        self.expander.mode = "Custom";
	                    }
	                    return true;
	                }
	            }
	
	            self.isExpanded = false;
	        }
	
	        return false;
	    };
	
	    self.update = function (element) {
	        self.id = element.Id;
	        self.name = element.Name;
	        self.status = element.Status;
	        self.started = element.Started;
	        self.updateCount++;
	        self.progressPercentage = element.ProgressPercentage;
	        self.progressMessage = element.ProgressMessage;
	        self.showAtSummaryLevel = element.ShowAtSummaryLevel;
	        self.hasErrors = false;
	        self.additionalEntries = element.AdditionalEntries;
	
	        if (element.Children) {
	            for (var i = 0; i < element.Children.length; i++) {
	                var child = element.Children[i];
	                if (!self.childrenById[child.Id]) {
	                    self.childrenById[child.Id] = new Octopus.Model.LogTreeNode();
	                    self.childrenById[child.Id].expander = self.expander;
	                    self.children.push(self.childrenById[child.Id]);
	                }
	
	                self.childrenById[child.Id].update(child);
	                self.hasErrors = self.hasErrors || self.childrenById[child.Id].hasErrors;
	            }
	        }
	
	        if (element.LogElements) {
	            var shuffling = false;
	            for (var j = 0; j < element.LogElements.length; j++) {
	                var source = element.LogElements[j];
	                var target;
	                if (j < self.logElements.length) {
	                    target = self.logElements[j];
	
	                    if (shuffling ||
	                        target.Category !== source.Category ||
	                        target.OccurredAt !== source.OccurredAt ||
	                        target.MessageText !== source.MessageText) {
	                        target.MessageText = source.MessageText;
	                        target.Category = source.Category;
	                        target.OccurredAt = source.OccurredAt;
	                        shuffling = true;
	                        self.counter = self.counter + 1;
	                    }
	                } else {
	                    self.logElements.push(source);
	                    target = source;
	                    self.counter = self.counter + 1;
	                }
	
	                if (target.Category === "Error" || target.Category === "Fatal") {
	                    self.hasErrors = true;
	                }
	
	                target.DetailedMessageText = source.MessageText;
	
	                if (source.Detail) {
	                    target.DetailedMessageText = target.DetailedMessageText + '\n' + source.Detail;
	                }
	            }
	        }
	    };
	
	    self.refresh = function (element) {
	        self.update(element);
	        self.expander.refresh();
	    };
	};
	
	


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {Octopus.Model = Octopus.Model || {};
	
	Octopus.Model.SynchronizedList = function (options) {
	    var defaults = {
	        sourceToTargetTransformer: function (a) {
	            return a;
	        },
	        refresh: function(b, a) {
	    },
	        sourceKey: function (a) {
	            return a.Id;
	        },
	        onAdded: function(a) { },
	        onRemoved: function(a) { }
	    };
	
	    options = jQuery.extend(defaults, options);
	
	    var self = this;
	    self.items = [];
	    self.itemsMap = { };
	
	    self.sync = function(source) {
	
	        var seenSourceItems = {};
	
	        if (!source) {
	            return;
	        }
	
	        jQuery.each(source, function (ignore, src) {
	            if (!src) {
	                return;
	            }
	
	            var srcKey = options.sourceKey(src);
	            if (!srcKey) {
	                return;
	            }
	
	            if (!self.itemsMap[srcKey]) {
	                var newTarget = options.sourceToTargetTransformer(src);
	                self.itemsMap[srcKey] = newTarget;
	                self.items.push(newTarget);
	
	                options.onAdded(newTarget);
	            } else {
	                var target = self.itemsMap[srcKey];
	                options.refresh(target, src);
	            }
	
	            seenSourceItems[srcKey] = true;
	        });
	
	        var removedKeys = [];
	        var removedValues = [];
	
	        jQuery.each (self.itemsMap, function (srcKey, val) {
	            if (!seenSourceItems[srcKey]) {
	                removedKeys.push(srcKey);
	                removedValues.push(val);
	            }
	        });
	
	        jQuery.each (removedKeys, function (ignore, k) {
	            delete self.itemsMap[k];
	        });
	
	        jQuery.each (removedValues, function (ignore, k) {
	            var ix = self.items.indexOf(k);
	            if (ix >= 0) {
	                self.items.splice(ix, 1);
	                options.onRemoved(k);
	            }
	        });
	
	        if (options.sortTargetBy) {
	            self.items.sort(function(first, second) {
	                var f = options.sortTargetBy(first);
	                var s = options.sortTargetBy(second);
	                if (f === s) { return 0; }
	                if (f < s) { return -1; }
	                return 1;
	            });
	        }
	    };
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, _) {var RSVP = __webpack_require__(1216);
	var URI = __webpack_require__(71);
	var URITemplate = __webpack_require__(300);
	
	(function () {
	    if (typeof String.prototype.endsWith !== 'function') {
	        String.prototype.endsWith = function (suffix) {
	            return this.indexOf(suffix, this.length - suffix.length) !== -1;
	        };
	    }
	
	    if (typeof String.prototype.startsWith !== 'function') {
	        String.prototype.startsWith = function (str) {
	            return this.slice(0, str.length) === str;
	        };
	    }
	})();
	
	(function (window) {
	    if (!window.JSON) {
	        throw new Error("Octopus.Client: No JSON parser found. Please ensure json2.js is referenced before the Octopus.Client.js file if you need to support clients without native JSON parsing support, e.g. IE<8.");
	    }
	
	    if (!RSVP) {
	        throw new Error("Octopus.Client: RSVP.js not found. Please ensure RSVP.js is referenced before the Octopus.Client.js file.");
	    }
	
	    if (!__webpack_provided_window_dot_jQuery) {
	        throw new Error("Octopus.Client: jQuery was not found. Please ensure jQuery is referenced before the Octopus.Client.js file.");
	    }
	
	    var Octopus = window.Octopus = window.Octopus || {};
	    var noOp = function () {
	        return this;
	    };
	
	    var jQuery = __webpack_provided_window_dot_jQuery;
	
	    Octopus.Client = {};
	
	    Octopus.Client.PromiseWrapper = function (callback) {
	        return new RSVP.Promise(callback);
	    };
	
	    Octopus.Client.Logger = (function () {
	        var instance = {};
	        instance.isEnabled = true;
	
	        var consoleWrapper = function (name) {
	            var console = window.console;
	            if (console && console[name]) {
	                if (console[name].apply) {
	                    return function () {
	                        if (instance.isEnabled) {
	                            console[name].apply(console, arguments);
	                        }
	                    };
	                } else {
	                    return function () {
	                        if (instance.isEnabled) {
	                            var message = Array.prototype.join.call(arguments, ', ');
	                            console[name](message);
	                        }
	                    };
	                }
	            }
	        };
	
	        instance.log = consoleWrapper('log') || noOp();
	        instance.info = consoleWrapper('info') || noOp();
	        instance.warn = consoleWrapper('warn') || noOp();
	        instance.error = consoleWrapper('error') || noOp();
	        instance.error = consoleWrapper('error') || noOp();
	        instance.enabled = function (b) {
	            if (typeof (b) !== "undefined") {
	                instance.isEnabled = b;
	            }
	            return instance.isEnabled;
	        };
	        return instance;
	    })();
	
	    Octopus.Client.Util = {};
	    Octopus.Client.Util.extend = function () {
	        return jQuery.extend(arguments[0], arguments[1]);
	    };
	
	    // We use our own AJAX function so that we're not too coupled to jQuery
	    Octopus.Client.Util.ajax = (function () {
	        var XMLHttpFactories = [
	            function () {
	                return new XMLHttpRequest();
	            },
	            function () {
	                return new ActiveXObject("Msxml2.XMLHTTP");
	            },
	            function () {
	                return new ActiveXObject("Msxml3.XMLHTTP");
	            },
	            function () {
	                return new ActiveXObject("MSXML2.XMLHTTP.3.0");
	            },
	            function () {
	                return new ActiveXObject("Microsoft.XMLHTTP");
	            }
	        ];
	
	        return function (options2) {
	            var createXMLHTTPObject = function () {
	                var xmlhttp = false;
	                for (var i = 0; i < XMLHttpFactories.length; i++) {
	                    try {
	                        xmlhttp = XMLHttpFactories[i]();
	                    }
	                    catch (e) {
	                        continue;
	                    }
	                    break;
	                }
	                return xmlhttp;
	            };
	
	            var defaults = {
	                method: "GET",
	                uri: null,
	                nonStale: true,
	                requestBody: null,
	                requestBodyContentType: null,
	                raw: false,
	                success: function (data) {
	                },
	                error: function (xhr) {
	                }
	            };
	
	            var options = Octopus.Client.Util.extend(defaults, options2);
	
	            var request = createXMLHTTPObject();
	            if (!request) {
	                return;
	            }
	
	            var methodOverride = null;
	            var method = options.method;
	            if (method === 'PUT') {
	                methodOverride = 'PUT';
	                method = 'POST';
	            }
	            if (method === 'DELETE') {
	                methodOverride = 'DELETE';
	                method = 'POST';
	            }
	
	            request.open(method, options.url, true);
	
	            request.withCredentials = true;
	
	            //request.setRequestHeader('Cache-Control', 'no-cache');
	            request.setRequestHeader('Accept', 'application/json');
	            if (options.requestBody) {
	                request.setRequestHeader('Content-type', 'application/json');
	            }
	
	            if (methodOverride) {
	                request.setRequestHeader('X-HTTP-Method-Override', methodOverride);
	            }
	
	            request.onreadystatechange = function () {
	                if (request.readyState !== 4) {
	                    return;
	                }
	
	                var deserialize = function (forceJson) {
	                    if (options.raw && ((typeof forceJson === 'undefined') || !forceJson)) {
	                        return request.responseText;
	                    }
	
	                    if (request.responseText && request.responseText.length) {
	                        return JSON.parse(request.responseText);
	                    }
	
	                    return null;
	                };
	
	                if (request.status < 100 || request.status >= 400) {
	                    var error = null;
	
	                    try {
	                        if (request.status === 0) {
	                            error = {
	                                ErrorMessage: "There was a problem with your request.",
	                                FullException: null,
	                                Errors: ["Unable to establish a connection to the Octopus Deploy server. The server may be offline. Please check your network connection."]
	                            };
	                        } else {
	                            error = deserialize(true);
	
	                            if (!error.ErrorMessage) {
	                                error = {
	                                    ErrorMessage: "There was a problem with your request.",
	                                    FullException: request.response,
	                                    Errors: ["The Octopus Deploy server returned a status of: " + request.status]
	                                };
	                            }
	                        }
	                    }
	                    catch (err) {
	                        error = {
	                            ErrorMessage: "There was a problem with your request.",
	                            FullException: err.toString(),
	                            Errors: ["Unhandled error when communicating with the Octopus Deploy server. The server returned a status of: " + request.status]
	                        };
	                    }
	
	                    error.StatusCode = request.status;
	
	                    if (typeof Octopus.Client.Util.ajax.error === 'function') {
	                        Octopus.Client.Util.ajax.error(error);
	                    }
	
	                    options.error(error);
	                    return;
	                }
	
	                options.success(deserialize());
	            };
	
	            if (request.readyState === 4) {
	                return;
	            }
	
	            var body = options.requestBody;
	            if (typeof (body) === "undefined") {
	                request.send();
	            } else if (typeof (body) === "string") {
	                request.send(body);
	            } else {
	                var bodyJson = JSON.stringify(body);
	                request.send(bodyJson);
	            }
	        };
	    })();
	
	    // This function can be overriden to allow intercepting and handling of ajax errors
	    Octopus.Client.Util.ajax.error = function (error) {
	
	    };
	
	    // The Resolver is used to take URI's like "/api/foo/bar" and turn them into fully qualified URI's depending on the Octopus
	    // server we are talking to (e.g., http://your-octopus/api/foo/bar or perhaps even, http://your-octopus/vdir1/vdir2/api/foo/bar).
	    Octopus.Client.Resolver = function (baseUri) {
	        baseUri = baseUri.endsWith('/') ? baseUri : baseUri + "/";
	
	        var lastIndexOfMandatorySegment = baseUri.lastIndexOf('/api/');
	        if (lastIndexOfMandatorySegment >= 1) {
	            baseUri = baseUri.substring(0, lastIndexOfMandatorySegment);
	        } else if (baseUri.endsWith('/api')) {
	            baseUri = baseUri.substring(0, -4);
	        }
	
	        baseUri = baseUri.endsWith('/') ? baseUri.substring(0, baseUri.length - 1) : baseUri;
	
	        var parsed = URI(baseUri);
	        var rootUri = parsed.scheme() + "://" + parsed.authority();
	        rootUri = rootUri.endsWith('/') ? rootUri.substring(0, rootUri.length - 1) : rootUri;
	
	        this.resolve = function (path, uriTemplateParameters) {
	            if (!path) {
	                throw 'The link does not exist';
	            }
	
	            if (path.startsWith("~/")) {
	                path = path.substring(1, path.length);
	                path = baseUri + path;
	            } else {
	                path = rootUri + path;
	            }
	
	            var template = new URITemplate(path);
	            var result = template.expand(uriTemplateParameters || {});
	
	            return result;
	        };
	    };
	
	    // The Octopus Client implements the low-level semantics of the Octopus Deploy REST API
	    Octopus.Client.OctopusClient = function (configuration) {
	        var defaultConfiguration = {
	            serverEndpoint: null
	        };
	
	        configuration = Octopus.Client.Util.extend(defaultConfiguration, configuration);
	
	        var endpoint = configuration.serverEndpoint;
	        if (endpoint == null || endpoint.length === 0) {
	            endpoint = "" + window.location.protocol;
	            if (!endpoint.endsWith("//")) {
	                endpoint = endpoint + "//";
	            }
	
	            endpoint = endpoint + window.location.host;
	
	            var path = window.location.pathname;
	            if (!path.startsWith("/")) {
	                path = "/" + path;
	            }
	
	            if (path.length >= 1) {
	                var lastSegmentIndex = path.lastIndexOf("/");
	                if (lastSegmentIndex >= 0) {
	                    path = path.substring(0, lastSegmentIndex + 1);
	                }
	            }
	
	            endpoint = endpoint + path;
	        }
	
	        Octopus.Client.Logger.log("Creating Octopus client for endpoint: " + endpoint);
	
	        var currentResolver = new Octopus.Client.Resolver(endpoint);
	
	        var dispatchRequest = function (method, url, requestBody) {
	            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
	                Octopus.Client.Util.ajax({
	                    method: method,
	                    url: url,
	                    requestBody: requestBody,
	                    success: function (result) {
	                        resolve(result);
	                    },
	                    error: function (error) {
	                        reject(error);
	                    }
	                });
	            });
	        };
	
	        this.urlStripHostAndPort = function(location) {
	            var url = location.absUrl();
	            url = url.replace(location.protocol() + '://' + location.host(), '');
	            if (url[0] !== ':') {
	                return url;
	            }
	            return url.replace(':' + location.port(), '');
	        };
	
	        this.uiRelativeRootPath = function(location) {
	            return this.urlStripHostAndPort(location).replace(location.path(), '');
	        };
	
	        this.urlIndicatesNonDevelopmentMode = function(absUrl, apiUrl) {
	            // In our Nancy localhost:9005 dev world, the absolute url on :9005 won't start with the api url on :8065.
	            return absUrl.startsWith(apiUrl);
	        };
	
	        this.resolve = currentResolver.resolve;
	        this.resolveLinkTemplate = function(link, args) {
	            return this.resolve(this.rootDocument().Links[link], args);
	        };
	
	        this.get = function (path, args) {
	            var url = currentResolver.resolve(path, args);
	            return dispatchRequest("GET", url);
	        };
	
	        this.getRaw = function (path, args) {
	            var url = currentResolver.resolve(path, args);
	
	            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
	                Octopus.Client.Util.ajax({
	                    method: 'GET',
	                    url: url,
	                    raw: true,
	                    success: function (result) {
	                        resolve(result);
	                    },
	                    error: function (error) {
	                        reject(error);
	                    }
	                });
	            });
	        };
	
	        this.post = function (path, resource) {
	            var url = currentResolver.resolve(path);
	            return dispatchRequest("POST", url, resource);
	        };
	
	        this.create = function (path, resource, args) {
	            var url = currentResolver.resolve(path, args);
	
	            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
	                dispatchRequest("POST", url, resource)
	                    .then(function (result) {
	                        dispatchRequest("GET", currentResolver.resolve(result.Links["Self"]))
	                            .then(function (result2) {
	                                resolve(result2);
	                            }, reject);
	                    }, reject);
	            });
	        };
	
	        this.update = function (path, resource, args) {
	            var url = currentResolver.resolve(path, args);
	
	            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
	                dispatchRequest("PUT", url, resource)
	                    .then(function () {
	                        dispatchRequest("GET", url)
	                            .then(function (result2) {
	                                resolve(result2);
	                            }, reject);
	                    }, reject);
	            });
	        };
	
	        this.del = function (path, resource, args) {
	            var url = currentResolver.resolve(path, args);
	            return dispatchRequest("DELETE", url, resource);
	        };
	
	        this.put = function (path, resource) {
	            var url = currentResolver.resolve(path);
	            return dispatchRequest("PUT", url, resource);
	        };
	
	        this._rootDocument = null;
	
	        this.rootDocument = function () {
	            if (!this.isConnected()) {
	                throw new Error('The Octopus Client has not connected.');
	            }
	
	            return this._rootDocument;
	        };
	
	        this.isConnected = function () {
	            return this._rootDocument !== null;
	        };
	
	        this.connect = function (progressCallback) {
	            var that = this;
	
	            progressCallback("Checking your credentials. Please wait...", '');
	
	            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
	                if (that._rootDocument !== null) {
	                    resolve(that._rootDocument);
	                }
	
	                var attempt = function (success, fail) {
	                    that.get("~/api")
	                        .then(success, fail);
	                };
	
	                var onSuccess = function (root) {
	                    that._rootDocument = root;
	                    resolve(that._rootDocument);
	                };
	
	                var fails = 0;
	                var onFail = function (err) {
	                    if (err.StatusCode !== 503) {
	                        fails++;
	                    }
	
	                    if ((err.StatusCode === 0 || err.StatusCode === 503) && fails < 20) {
	                        Octopus.Client.Logger.warn("Unable to connect, trying again in 1 second...", err);
	
	                        if (err.StatusCode === 503) {
	                            progressCallback(err.ErrorMessage, 'success');
	                        } else if (err.StatusCode === 0) {
	                            progressCallback("The Octopus server does not appear to have started, trying again...", 'warning');
	                        }
	
	                        setTimeout(function () {
	                            Octopus.Client.Logger.warn("Trying again", err);
	                            attempt(onSuccess, onFail);
	                        }, 1000);
	                    } else {
	                        Octopus.Client.Logger.error("Unable to connect, unexpected error, or timeout exceeded", err);
	                        reject(err);
	                    }
	                };
	
	                attempt(onSuccess, onFail);
	            });
	        };
	    };
	
	    // Repositories provide a helpful abstraction around the Octopus Deploy API
	    Octopus.Client.Repository = function (client) {
	
	        this.resolve = client.resolve;
	        this.resolveLinkTemplate = client.resolveLinkTemplate;
	
	        var BasicRepository = function (collectionLinkName) {
	            var self = this;
	
	            self.create = function (resource, args) {
	                return client.create(client.rootDocument().Links[collectionLinkName], resource, args);
	            };
	
	            self.modify = function (resource, args) {
	                return client.update(resource.Links["Self"], resource, args);
	            };
	
	            self.del = function (resource) {
	                return client.del(resource.Links["Self"]);
	            };
	
	            self.list = function (args) {
	                return client.get(client.rootDocument().Links[collectionLinkName], args);
	            };
	
	            self.get = function (id, args) {
	                var allArgs = Octopus.Client.Util.extend(args || {}, {id: id});
	                return client.get(client.rootDocument().Links[collectionLinkName], allArgs);
	            };
	
	            self.all = function (args) {
	                if (args !== undefined && args.ids instanceof Array && args.ids.length === 0) {
	                    return Octopus.Client.PromiseWrapper(function(res) { res([]); });
	                }
	
	                var allArgs = Octopus.Client.Util.extend(args || {}, {id: 'all'});
	                return client.get(client.rootDocument().Links[collectionLinkName], allArgs);
	            };
	
	            self.save = function (resource, args) {
	                if (resource.Links && resource.Id) {
	                    return self.modify(resource, args);
	                } else {
	                    return self.create(resource, args);
	                }
	            };
	        };
	
	        var hasRootLink = function (rootLink, repository) {
	            return !!client.rootDocument().Links[rootLink];
	        };
	
	        this.Users = Octopus.Client.Util.extend(new BasicRepository("Users"), {
	            signIn: function (loginCommand) {
	                return client.post(client.rootDocument().Links["SignIn"], loginCommand);
	            },
	
	            signOut: function () {
	                return client.post(client.rootDocument().Links["SignOut"], {});
	            },
	
	            getCurrent: function () {
	                return client.get(client.rootDocument().Links["CurrentUser"]);
	            },
	
	            getPermissions: function (user) {
	                return client.get(user.Links["Permissions"]);
	            },
	
	            createApiKey: function (user, purpose) {
	                return client.post(user.Links["ApiKeys"], {Purpose: purpose});
	            },
	
	            listApiKeys: function (user) {
	                return client.get(user.Links["ApiKeys"]);
	            },
	
	            revokeApiKey: function (apiKey) {
	                return client.del(apiKey.Links["Self"]);
	            },
	
	            invite: function (teamIds) {
	                return client.post(client.rootDocument().Links["Invitations"], {AddToTeamIds: teamIds});
	            },
	
	            register: function (registerCommand) {
	                return client.post(client.rootDocument().Links["Register"], registerCommand);
	            },
	
	            getTriggers: function (user) {
	                return client.get(user.Links["Triggers"]);
	            },
	        });
	
	        this.Licenses = Octopus.Client.Util.extend(new BasicRepository("Licenses"), {
	            getCurrent: function () {
	                return client.get(client.rootDocument().Links["CurrentLicense"]);
	            }
	        });
	
	        this.Dashboards = {
	            getDashboard: function (dashboardFilter) {
	                return client.get(client.rootDocument().Links["Dashboard"], dashboardFilter);
	            },
	
	            getProjectDashboard: function (project) {
	                return client.get(client.rootDocument().Links["DashboardDynamic"], {
	                    projects: project.Id,
	                    includePrevious: true
	                });
	            },
	
	            getMiniboard: function (project, environment) {
	                return client.get(client.rootDocument().Links["DashboardDynamic"], {
	                    projects: project,
	                    environments: environment,
	                    includePrevious: false
	                });
	            }
	        };
	
	        this.DashboardConfiguration = {
	            get: function () {
	                return client.get(client.rootDocument().Links["DashboardConfiguration"]);
	            },
	            modify: function (resource) {
	                return client.update(resource.Links["Self"], resource);
	            }
	        };
	
	        this.SmtpConfiguration = {
	            get: function () {
	                return client.get(client.rootDocument().Links["SmtpConfiguration"]);
	            },
	            modify: function (resource) {
	                return client.update(resource.Links["Self"], resource);
	            }
	        };
	
	        this.MaintenanceConfiguration = {
	            get: function () {
	                return client.get(client.rootDocument().Links["MaintenanceConfiguration"]);
	            },
	            modify: function (resource) {
	                return client.update(resource.Links["Self"], resource);
	            }
	        };
	
	        this.FeaturesConfiguration = {
	            get: function () {
	                return client.get(client.rootDocument().Links["FeaturesConfiguration"]);
	            },
	            modify: function (resource) {
	                return client.update(resource.Links["Self"], resource);
	            }
	        };
	
	        this.ServerConfiguration = {
	            get: function () {
	                return client.get(client.rootDocument().Links["ServerConfiguration"]);
	            },
	            modify: function (resource) {
	                return client.update(resource.Links["Self"], resource);
	            },
	            settings: function () {
	                return client.get(client.rootDocument().Links["ServerConfigurationSettings"]);
	            }
	        };
	
	        this.ServerStatus = {
	            getServerStatus: function () {
	                return client.get(client.rootDocument().Links["ServerStatus"]);
	            },
	            getLogs: function (status) {
	                return client.get(status.Links["RecentLogs"]);
	            },
	            getSystemInfo: function (status) {
	                return client.get(status.Links["SystemInfo"]);
	            },
	            getBuiltInFeedStats: function (status) {
	                return client.get(status.Links["BuiltInFeedStats"]);
	            },
	            gcCollect: function (status) {
	                return client.post(status.Links["GCCollect"], status);
	            },
	            getExtensionStats: function () {
	                return client.get(client.rootDocument().Links["ExtensionStats"]);
	            },
	            getTimezones: function () {
	                return client.get(client.rootDocument().Links["Timezones"]);
	            }
	        };
	
	        this.Accounts = Octopus.Client.Util.extend(new BasicRepository("Accounts"), {
	            getWebSites: function (account) {
	                return client.get(account.Links["WebSites"]);
	            },
	            getCloudServices: function (account) {
	                return client.get(account.Links["CloudServices"]);
	            },
	            getStorageAccounts: function (account) {
	                return client.get(account.Links["StorageAccounts"]);
	            },
	            getResourceGroups: function (account) {
	                return client.get(account.Links["ResourceGroups"]);
	            }
	        });
	
	        this.Progression = {
	            getProgression: function (project, options) {
	                return client.get(project.Links["Progression"], options);
	            }
	        };
	
	        this.Backups = {
	            getConfiguration: function () {
	                return client.get(client.rootDocument().Links["BackupConfiguration"]);
	            },
	            updateConfiguration: function (configuration) {
	                return client.update(configuration.Links["Self"], configuration);
	            }
	        };
	
	        this.PermissionDescriptions = {
	            all: function () {
	                return client.get(client.rootDocument().Links["PermissionDescriptions"], null);
	            }
	        };
	
	        this.ActionTemplates = Octopus.Client.Util.extend(new BasicRepository("ActionTemplates"), {
	            getUsage: function (template) {
	                return client.get(template.Links["Usage"]);
	            },
	            getByCommunityTemplate : function (communityTemplate) {
	                var allArgs = Octopus.Client.Util.extend({}, {id: communityTemplate.id});
	                return client.get(communityTemplate.Links["InstalledTemplate"], allArgs);
	            },
	            search: function () {
	                return client.get(client.rootDocument().Links["ActionTemplatesSearch"]);
	            }
	        });
	
	        this.Alerts = Octopus.Client.Util.extend(new BasicRepository("Alerts"), {});
	
	        this.Tasks = Octopus.Client.Util.extend(new BasicRepository("Tasks"), {
	            getDetails: function (task, options) {
	                return client.get(task.Links["Details"], options);
	            },
	            getQueuedBehind: function (task, options) {
	                return client.get(task.Links["QueuedBehind"], options);
	            },
	            getRaw: function (task) {
	                return client.getRaw(task.Links["Raw"]);
	            },
	
	            filter: function (options) {
	                return client.get(client.rootDocument().Links["Tasks"], options);
	            },
	
	            rerun: function (task) {
	                return client.post(task.Links["Rerun"]);
	            },
	
	            cancel: function (task) {
	                return client.post(task.Links["Cancel"]);
	            }
	        });
	
	        this.Packages = Octopus.Client.Util.extend(new BasicRepository("Packages"), {
	            deleteMany: function (packageIds) {
	                return client.del(client.rootDocument().Links["PackagesBulk"], null, {ids: packageIds});
	            },
	            getUploadUrl: function (uploadOptions) {
	                return client.resolve(client.rootDocument().Links["PackageUpload"], uploadOptions);
	            }
	        });
	
	        this.ExternalSecurityGroupProviders = {
	            all: function () {
	                return client.get(client.rootDocument().Links["ExternalSecurityGroupProviders"]);
	            }
	        };
	
	        this.ExternalSecurityGroups = {
	            search: function (url, name) {
	                return client.get(url, {name: name});
	            }
	        };
	
	        this.PackageRepository = {
	            getConfiguration: function () {
	                return client.get(client.rootDocument().Links["RepositoryConfiguration"]);
	            },
	            updateConfiguration: function (configuration) {
	                return client.update(configuration.Links["Self"], configuration);
	            }
	        };
	
	        this.Projects = Octopus.Client.Util.extend(new BasicRepository("Projects"), {
	            getDeployments: function (project) {
	                return client.get(client.rootDocument().Links["Deployments"], {projects: project.Id});
	            },
	
	            getReleases: function (project) {
	                return client.get(project.Links["Releases"]);
	            },
	
	            getReleaseByVersion: function (project, version) {
	                return client.get(project.Links["Releases"], {version: version});
	            },
	
	            listByGroup: function (projectGroup) {
	                return client.get(projectGroup.Links["Projects"]);
	            },
	
	            getChannels: function (project) {
	                return client.get(project.Links["Channels"]);
	            },
	
	            getTriggers: function (project) {
	                return client.get(project.Links["Triggers"]);
	            },
	
	            orderChannels: function (project, channelIds) {
	                return client.post(project.Links["OrderChannels"], channelIds);
	            },
	
	            getPulse: function (projects) {
	                var projectIds = _.map(projects, function (p) {
	                    return p.Id;
	                }).join(',');
	                return client.get(client.rootDocument().Links["ProjectPulse"], {projectIds: projectIds});
	            }
	        });
	
	        this.ProjectGroups = Octopus.Client.Util.extend(new BasicRepository("ProjectGroups"), {});
	
	        this.Lifecycles = Octopus.Client.Util.extend(new BasicRepository("Lifecycles"), {
	            preview: function (lifecycle) {
	                return client.get(lifecycle.Links["Preview"]);
	            },
	            projects: function (lifecycle) {
	                return client.get(lifecycle.Links["Projects"]);
	            }
	        });
	
	        this.MachinePolicies = Octopus.Client.Util.extend(new BasicRepository("MachinePolicies"), {
	            getMachines: function (machinePolicy) {
	                return client.get(machinePolicy.Links["Machines"]);
	            }
	        });
	
	        this.RetentionPolicies = Octopus.Client.Util.extend(new BasicRepository("RetentionPolicies"), {});
	
	        this.Environments = Octopus.Client.Util.extend(new BasicRepository("Environments"), {
	            sort: function (order) {
	                return client.put(client.rootDocument().Links["EnvironmentSortOrder"], order);
	            },
	            variablesScopedOnlyToThisEnvironment: function (environment) {
	                return client.get(environment.Links["SinglyScopedVariableDetails"]);
	            }
	        });
	
	        this.Machines = Octopus.Client.Util.extend(new BasicRepository("Machines"), {
	            listByEnvironment: function (environment) {
	                return client.get(environment.Links["Machines"]);
	            },
	            discover: function (host, port, type, proxyId) {
	                return client.get(client.rootDocument().Links["DiscoverMachine"], {host: host, port: port, type: type, proxyId: proxyId});
	            },
	            getConnectionStatus: function (machine) {
	                return client.get(machine.Links["Connection"]);
	            },
	            getTasks: function (machine, options) {
	                return client.get(machine.Links["TasksTemplate"], options);
	            },
	            hosted: function () {
	                var allArgs = {id: 'hosted'};
	                return client.get(client.rootDocument().Links["Machines"], allArgs);
	            },
	            listByDeployment: function (deployment) {
	                return client.get(client.rootDocument().Links["Machines"], {id: 'all', deploymentId: deployment.Id});
	            }
	        });
	
	        this.UserRoles = Octopus.Client.Util.extend(new BasicRepository("UserRoles"), {});
	
	        this.MachineRoles = {
	            all: function () {
	                return client.get(client.rootDocument().Links["MachineRoles"]);
	            }
	        };
	
	        this.Defects = {
	            all: function (release) {
	                return client.get(release.Links["Defects"]);
	            },
	            report: function (release, description) {
	                return client.post(release.Links["ReportDefect"], {Description: description});
	            },
	            resolve: function (release) {
	                return client.post(release.Links["ResolveDefect"]);
	            }
	        };
	
	        this.Releases = Octopus.Client.Util.extend(new BasicRepository("Releases"), {
	            getDeployments: function(release, skip) {
	                return client.get(release.Links["Deployments"], {skip: skip || 0});
	            },
	            getDeploymentTemplate: function (release) {
	                return client.get(release.Links["DeploymentTemplate"]);
	            },
	            getDeploymentPreview: function (promotionTarget) {
	                return client.get(promotionTarget.Links["Preview"]);
	            },
	            progression: function (release) {
	                return client.get(release.Links["Progression"]);
	            },
	            snapshotVariables: function (release) {
	                return client.post(release.Links["SnapshotVariables"]);
	            }
	        });
	
	        this.Deployments = Octopus.Client.Util.extend(new BasicRepository("Deployments"), {});
	
	        this.Feeds = Octopus.Client.Util.extend(new BasicRepository("Feeds"), {
	            getVersions: function (feed, packageIds) {
	                return client.get(feed.Links["VersionsTemplate"], {packageIds: packageIds});
	            },
	            search: function (feed, searchOptions) {
	                return client.get(feed.Links["SearchTemplate"], searchOptions);
	            },
	            getNotes: function (feed, packageId, version) {
	                return client.getRaw(feed.Links["NotesTemplate"], {packageId: packageId, version: version});
	            }
	        });
	
	        this.Artifacts = Octopus.Client.Util.extend(new BasicRepository("Artifacts"), {
	            list: function (options) {
	                return client.get(client.rootDocument().Links["Artifacts"], options);
	            }
	        });
	
	        this.Events = Octopus.Client.Util.extend(new BasicRepository("Events"), {
	            list: function (options) {
	                return client.get(client.rootDocument().Links["Events"], options);
	            },
	            categories: function (options) {
	                return client.get(client.rootDocument().Links["EventCategories"], options);
	            },
	            groups: function (options) {
	                return client.get(client.rootDocument().Links["EventGroups"], options);
	            }
	        });
	
	        this.Interruptions = Octopus.Client.Util.extend(new BasicRepository("Interruptions"), {
	            list: function (options) {
	                return client.get(client.rootDocument().Links["Interruptions"], options);
	            },
	            submit: function (interruption, result) {
	                return client.post(interruption.Links["Submit"], result);
	            },
	            takeResponsibility: function (interruption) {
	                return client.put(interruption.Links["Responsible"]);
	            }
	        });
	
	        this.Variables = Octopus.Client.Util.extend(new BasicRepository("Variables"), {
	            names: function (projectId, projectEnvironmentsFilter) {
	                return client.get(client.rootDocument().Links["VariableNames"], {
	                    project: projectId,
	                    projectEnvironmentsFilter: projectEnvironmentsFilter ? projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
	                });
	            },
	            nonPrintableChars: function (variableSet) {
	                return client.post(client.rootDocument().Links["VariablesNonPrintableChars"], variableSet);
	            }
	        });
	
	        this.DeploymentProcesses = Octopus.Client.Util.extend(new BasicRepository("DeploymentProcesses"), {
	            getTemplate: function (deploymentProcess, channelId, releaseId) {
	                return client.get(deploymentProcess.Links["Template"], {channel: channelId, releaseId: releaseId});
	            }
	        });
	
	        this.Reporting = {
	            getDeploymentsCountedByWeek: function (projectIds) {
	                return client.get(client.rootDocument().Links["Reporting/DeploymentsCountedByWeek"], {projectIds: projectIds.join(",")});
	            }
	        };
	
	        this.Teams = Octopus.Client.Util.extend(new BasicRepository("Teams"), {});
	
	        this.Certificates = Octopus.Client.Util.extend(new BasicRepository("Certificates"), {
	            getOctopusCertificate: function () {
	                return this.get('certificate-global');
	            },
	            getAzureCertificate: function () {
	                return this.get('certificate-azure');
	            }
	        });
	
	        this.Proxies = Octopus.Client.Util.extend(new BasicRepository("Proxies"), {});
	
	        this.LibraryVariableSets = Octopus.Client.Util.extend(new BasicRepository("LibraryVariables"), {});
	
	        this.OctopusServerNodes = Octopus.Client.Util.extend(new BasicRepository("OctopusServerNodes"), {});
	
	        this.Channels = Octopus.Client.Util.extend(new BasicRepository("Channels"), {
	            ruleTest: function (version, searchOptions) {
	                return client.post(client.rootDocument().Links["VersionRuleTest"], {
	                    version: version,
	                    versionRange: searchOptions.versionRange,
	                    preReleaseTag: searchOptions.preReleaseTag
	                });
	            },
	            getReleases: function (channel, options) {
	                return client.get(channel.Links["Releases"], options);
	            }
	        });
	
	        this.UpgradeConfiguration = {
	            get: function () {
	                return client.get(client.rootDocument().Links["UpgradeConfiguration"]);
	            },
	            modify: function (resource) {
	                return client.update(resource.Links["Self"], resource);
	            }
	        };
	
	        if (hasRootLink("Tenants")) {
	            this.Tenants = Octopus.Client.Util.extend(new BasicRepository("Tenants"), {
	                tagTest: function (tenantIds, tags) {
	                    return client.get(client.rootDocument().Links["TenantTagTest"], {tenantIds: tenantIds, tags: tags});
	                },
	                getVariables: function (tenant) {
	                    return client.get(tenant.Links["Variables"]);
	                },
	                setVariables: function (tenant, variables) {
	                    return client.put(tenant.Links["Variables"], variables);
	                },
	                missingVariables: function (filterOptions, includeDetails) {
	                    if (filterOptions === false || filterOptions === true) {
	                        includeDetails = filterOptions;
	                    }
	                    filterOptions = filterOptions || {};
	                    var payload = {
	                        tenantId: filterOptions.tenantId,
	                        projectId: filterOptions.projectId,
	                        environmentId: filterOptions.environmentId,
	                        includeDetails: !!includeDetails
	                    };
	                    return client.get(client.rootDocument().Links["TenantsMissingVariables"], payload);
	                }
	            });
	        }
	
	        if (hasRootLink("TenantVariables")) {
	            this.TenantVariables = Octopus.Client.Util.extend(new BasicRepository("TenantVariables"), {});
	        }
	
	        if (hasRootLink("TagSets")) {
	            this.TagSets = Octopus.Client.Util.extend(new BasicRepository("TagSets"), {
	                sort: function (tagSet) {
	                    return client.put(client.rootDocument().Links["TagSetSortOrder"], tagSet);
	                }
	            });
	        }
	
	        this.ProjectTriggers = Octopus.Client.Util.extend(new BasicRepository("ProjectTriggers"), {});
	
	        this.Subscriptions = Octopus.Client.Util.extend(new BasicRepository("Subscriptions"), {});
	
	        this.Scheduler = Octopus.Client.Util.extend(new BasicRepository("Scheduler"), {
	            getDetails: function (name, options) {
	                return client.get(client.rootDocument().Links["Scheduler"], {
	                    name: name,
	                    verbose: options.verbose,
	                    tail: options.tail
	                });
	            }
	        });
	
	        this.CommunityActionTemplates = {
	            get : function (id) {
	                var allArgs = Octopus.Client.Util.extend({}, {id: id});
	                return client.get(client.rootDocument().Links["CommunityActionTemplates"], allArgs);
	            },
	            install : function (communityActionTemplate) {
	                return client.post(communityActionTemplate.Links["Installation"]);
	            },
	            updateInstallation : function (communityActionTemplate) {
	                return client.put(communityActionTemplate.Links["Installation"]);
	            }
	        };
	    };
	
	    module.exports = Octopus.Client;
	
	})(window);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ },
/* 716 */,
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 141,
		"./af.js": 141,
		"./ar": 145,
		"./ar-ma": 142,
		"./ar-ma.js": 142,
		"./ar-sa": 143,
		"./ar-sa.js": 143,
		"./ar-tn": 144,
		"./ar-tn.js": 144,
		"./ar.js": 145,
		"./az": 146,
		"./az.js": 146,
		"./be": 147,
		"./be.js": 147,
		"./bg": 148,
		"./bg.js": 148,
		"./bn": 149,
		"./bn.js": 149,
		"./bo": 150,
		"./bo.js": 150,
		"./br": 151,
		"./br.js": 151,
		"./bs": 152,
		"./bs.js": 152,
		"./ca": 153,
		"./ca.js": 153,
		"./cs": 154,
		"./cs.js": 154,
		"./cv": 155,
		"./cv.js": 155,
		"./cy": 156,
		"./cy.js": 156,
		"./da": 157,
		"./da.js": 157,
		"./de": 159,
		"./de-at": 158,
		"./de-at.js": 158,
		"./de.js": 159,
		"./el": 160,
		"./el.js": 160,
		"./en-au": 161,
		"./en-au.js": 161,
		"./en-ca": 162,
		"./en-ca.js": 162,
		"./en-gb": 163,
		"./en-gb.js": 163,
		"./eo": 164,
		"./eo.js": 164,
		"./es": 165,
		"./es.js": 165,
		"./et": 166,
		"./et.js": 166,
		"./eu": 167,
		"./eu.js": 167,
		"./fa": 168,
		"./fa.js": 168,
		"./fi": 169,
		"./fi.js": 169,
		"./fo": 170,
		"./fo.js": 170,
		"./fr": 172,
		"./fr-ca": 171,
		"./fr-ca.js": 171,
		"./fr.js": 172,
		"./fy": 173,
		"./fy.js": 173,
		"./gl": 174,
		"./gl.js": 174,
		"./he": 175,
		"./he.js": 175,
		"./hi": 176,
		"./hi.js": 176,
		"./hr": 177,
		"./hr.js": 177,
		"./hu": 178,
		"./hu.js": 178,
		"./hy-am": 179,
		"./hy-am.js": 179,
		"./id": 180,
		"./id.js": 180,
		"./is": 181,
		"./is.js": 181,
		"./it": 182,
		"./it.js": 182,
		"./ja": 183,
		"./ja.js": 183,
		"./jv": 184,
		"./jv.js": 184,
		"./ka": 185,
		"./ka.js": 185,
		"./km": 186,
		"./km.js": 186,
		"./ko": 187,
		"./ko.js": 187,
		"./lb": 188,
		"./lb.js": 188,
		"./lt": 189,
		"./lt.js": 189,
		"./lv": 190,
		"./lv.js": 190,
		"./me": 191,
		"./me.js": 191,
		"./mk": 192,
		"./mk.js": 192,
		"./ml": 193,
		"./ml.js": 193,
		"./mr": 194,
		"./mr.js": 194,
		"./ms-my": 195,
		"./ms-my.js": 195,
		"./my": 196,
		"./my.js": 196,
		"./nb": 197,
		"./nb.js": 197,
		"./ne": 198,
		"./ne.js": 198,
		"./nl": 199,
		"./nl.js": 199,
		"./nn": 200,
		"./nn.js": 200,
		"./pl": 201,
		"./pl.js": 201,
		"./pt": 203,
		"./pt-br": 202,
		"./pt-br.js": 202,
		"./pt.js": 203,
		"./ro": 204,
		"./ro.js": 204,
		"./ru": 205,
		"./ru.js": 205,
		"./si": 206,
		"./si.js": 206,
		"./sk": 207,
		"./sk.js": 207,
		"./sl": 208,
		"./sl.js": 208,
		"./sq": 209,
		"./sq.js": 209,
		"./sr": 211,
		"./sr-cyrl": 210,
		"./sr-cyrl.js": 210,
		"./sr.js": 211,
		"./sv": 212,
		"./sv.js": 212,
		"./ta": 213,
		"./ta.js": 213,
		"./th": 214,
		"./th.js": 214,
		"./tl-ph": 215,
		"./tl-ph.js": 215,
		"./tr": 216,
		"./tr.js": 216,
		"./tzm": 218,
		"./tzm-latn": 217,
		"./tzm-latn.js": 217,
		"./tzm.js": 218,
		"./uk": 219,
		"./uk.js": 219,
		"./uz": 220,
		"./uz.js": 220,
		"./vi": 221,
		"./vi.js": 221,
		"./zh-cn": 222,
		"./zh-cn.js": 222,
		"./zh-tw": 223,
		"./zh-tw.js": 223
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 717;


/***/ },
/* 718 */,
/* 719 */,
/* 720 */
/***/ function(module, exports) {

	var path = 'areas/accounts/views/account_selector.html';
	var html = "<div> <span class=pull-right> <button type=button class=\"btn btn-link btn-default no-padding-hr\" ng-click=refresh()> <i class=\"fa fa-refresh\"></i> </button> <a class=\"btn btn-link btn-default\" href=#/accounts target=_blank>Add new...</a> </span> <div style=margin-right:8em> <loading-wrapper busy=isLoadingAccounts> <ui-select ng-model=something.Account append-to-body=true> <ui-select-match placeholder=\"Select account\" allow-clear=true><i class=\"fa account-icon-{{$select.selected.AccountType}}\"></i>{{$select.selected.Name}}</ui-select-match> <ui-select-choices repeat=\"item in accounts | filter:{Name: $select.search} track by item.Id\"> <i class=\"fa account-icon-{{item.AccountType}}\"></i><span ng-bind-html=\"item.Name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </loading-wrapper> </div> <p class=help-block>Select the <a href=#/accounts>account</a> to use for the connection.</p> <p class=help-block ng-if=warning>{{warning}}</p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 721 */
/***/ function(module, exports) {

	var path = 'areas/accounts/views/account_summary.html';
	var html = "<div> <h4><a href=#/accounts/{{account.Id}}>{{ account.Name }}</a></h4> <div class=smaller-fonts ng-show=account.environments>Only in: <environment-list tags=account.environments></environment-list></div> <applied-tags-list octo-feature=IsMultiTenancyEnabled ng-model=account.TenantTags style=margin:0></applied-tags-list> <markdown class=subtle text=\"account.Description || '_No description provided_'\"></markdown> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 722 */
/***/ function(module, exports) {

	var path = 'areas/accounts/views/azure_account.html';
	var html = "<div> <control-group label=Subscription> <input type=text class=form-control ng-model=account.SubscriptionNumber id=SubscriptionNumber placeholder=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx /> <p class=help-block>Your Azure subscription ID. This is a <em>GUID</em> in the format <code>xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</code>.</p> </control-group> <control-group label=\"Authentication method\" ng-hide=account.Id> <label class=radio><input type=radio ng-model=account.AccountType ng-value=\"'AzureSubscription'\"> Use a Management Certificate</label> <label class=radio><input type=radio ng-model=account.AccountType ng-value=\"'AzureServicePrincipal'\"> Use a Service Principal</label> </control-group> <div ng-show=\"account.AccountType === 'AzureServicePrincipal'\"> <control-group label=\"Client\\Application ID\"> <input type=text class=form-control ng-model=account.ClientId placeholder=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx /> <p class=help-block>Your Azure Active Directory Client ID. This is a <em>GUID</em> in the format <code>xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</code>. This value is known as <em>Client ID</em> in the Azure Portal, and <em>Application ID</em> in the API.</p> </control-group> <control-group label=\"Tenant ID\"> <input type=text class=form-control ng-model=account.TenantId placeholder=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx /> <p class=help-block>Your Azure Active Directory Tenant ID. This is a <em>GUID</em> in the format <code>xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</code>.</p> </control-group> <control-group label=Password\\Key> <sensitive-input model=account.Password></sensitive-input> <p class=help-block>The password for the Azure Active Directory application. This value is known as <em>Key</em> in the Azure Portal, and <em>Password</em> in the API.</p> </control-group> </div> <control-group ng-show=\"account.AccountType === 'AzureSubscription'\" label=\"Management certificate (.pfx)\"> <sensitive-file-input model=account.CertificateBytes display=account.CertificateThumbprint display-class=\"input-thumbprint thumbprint\"></sensitive-file-input> <p class=help-block>Leave blank to let Octopus generate a new certificate or provide a password free .pfx file.</p> <div ng-show=account.Id class=\"alert alert-info\"> <p>To give permission for Octopus to deploy to your Azure subscription, upload the public key portion (.cer) of the certificate to the Azure portal:</p> <ol class=\"subtle ng-scope\"> <li>Download the certificate public key: <a target=_blank href=\"{{ account.Links.PublicKey | resolveLink }}\" class=alert-link>{{account.CertificateThumbprint}}</a></li> <li>Log in to the <a href=http://g.octopushq.com/ManageAzure target=_blank class=\"external alert-link\">Azure management portal</a></li> <li>In the <strong>Settings</strong> tab, click <strong>Management Certificates</strong></li> <li>Click the <strong>Upload</strong> toolbar button</li> <li>Click <strong>Save</strong></li> <li>Select the public key file that you downloaded, and your subscription</li> </ol> </div> </control-group> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 723 */
/***/ function(module, exports) {

	var path = 'areas/accounts/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/environments\">Environments</a></li>\r\n    <li><a href=\"#/accounts\">Accounts</a></li>\r\n    <li ng-show=\"vm.account.Id\"><a href=\"#/accounts/{{ vm.account.Id }}\">\r\n        <i class=\"fa account-icon-{{vm.account.AccountType}} valign-middle\"></i>{{ vm.account.Name }}\r\n    </a></li>\r\n    <li ng-hide=\"vm.account.Id\"><a href=\"#/accounts/new?accountType={{ vm.account.AccountType }}\">Create New</a>\r\n    </li> </script> <div class=row> <div class=col-sm-12> <form class=\"form-box form-horizontal\"> <help-button></help-button> <h3 class=no-margin-top>{{ vm.account.Id ? \"Account settings\" : \"Create an Account\" }}</h3> <loading-wrapper busy=vm.isLoading> <div class=form-body> <error-box error=vm.isSaving.error></error-box> <control-group label=Name> <input type=text class=form-control id=Name placeholder=\"Account Name\" ng-model=vm.account.Name maxlength=200 /> <p class=help-block>A short, memorable, unique name for this account group.</p> </control-group> <control-group label=Description> <textarea class=input-xxlarge id=Description ng-model=vm.account.Description markitup rows=7></textarea> <p class=help-block>A summary explaining the use of the account to other users.</p> </control-group> <control-group label=Environments> <select-environments available=vm.environments ng-model=vm.teamSensitiveValues.EnvironmentIds multiple=true></select-environments> <p class=help-block>If this field is left blank, the account can be used for deployments to any environment. If environments are specified, then the account will be limited to use in those environments.</p> </control-group> <div ng-switch=vm.account.AccountType> <azure-account model=vm.account ng-switch-default></azure-account> <username-password-account model=vm.account ng-switch-when=UsernamePassword></username-password-account> <ssh-key-pair-account model=vm.account ng-switch-when=SshKeyPair></ssh-key-pair-account> </div> <last-modified model=vm.account></last-modified> </div> <div ng-show=accountTestTask> <control-group label=\"Verifying account\"> <task-status task=accountTestTask pop-direction=right style=margin-top:-12px></task-status> </control-group> <control-group ng-show=accountTestTask.ErrorMessage> <p class=\"alert alert-danger\">{{accountTestTask.ErrorMessage}}</p> </control-group> </div> <div octo-feature=IsMultiTenancyEnabled> <h4 class=separator>Tenants</h4> <advanced-tenant-selector apply-border=false available-tenants=vm.availableTenants selected-tenants=vm.teamSensitiveValues.TenantIds selected-tags=vm.account.TenantTags> </advanced-tenant-selector> <div class=help-block>Tenants matching this filter will be authorized to use this account. For more information on designing a multi-tenant hosting model refer to our <a href=http://g.octopushq.com/MultiTenantHostingModel target=_blank>documentation</a>. </div> </div> <div class=form-actions ng-hide=vm.signInAsGuest> <div class=\"\"> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy ng-click=vm.save(true) ng-show=\"vm.account.AccountType == 'AzureSubscription' || vm.account.AccountType == 'AzureServicePrincipal'\"> Save and test </button> <button class=\"btn btn-success\" type=submit ng-disabled=vm.isSaving.busy ng-click=vm.save(false)>Save </button> <delete-button model=vm.account what=account redirect=/accounts ng-show=vm.account.Id octo-environment=\"'*'\" octo-permission=AccountDelete></delete-button> <spin active=vm.isSaving.busy class=spin-static></spin> </div> </div> </loading-wrapper> </form> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 724 */
/***/ function(module, exports) {

	var path = 'areas/accounts/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/environments\">Environments</a></li>\r\n    <li><a href=\"#/accounts\">Accounts</a></li> </script> <div class=\"panel panel-transparent\" ng-repeat=\"accountType in accountTypes\"> <div class=panel-heading> <span class=panel-title> <i class=\"fa account-icon-{{accountType.Id}} fa-2x valign-middle\"></i> {{ accountType.Plural || (accountType.Name + 's') }} </span> <div class=panel-heading-controls> <a class=\"btn btn-success\" octo-permission=AccountCreate href=\"#/accounts/new?accountType={{ accountType.Id }}\" wildcard> Add account </a> </div> </div> <div class=panel-body> <div class=row> <div class=col-xs-8> <loading-wrapper busy=isLoading> <div ng-if=!accountType.SubTypes> <div ng-repeat=\"account in accountType.Accounts track by account.Id\"> <account-summary account=account></account-summary> </div> </div> <div ng-if=accountType.SubTypes> <div ng-repeat=\"(subType, accounts) in accountType.Accounts\"> <h5 class=\"separator account-subtype-heading\">{{subType}}</h5> <div ng-repeat=\"account in accounts track by account.Id\"> <account-summary account=account></account-summary> </div> </div> </div> <p class=\"tutorial tutorial-center\" ng-hide=accounts[accountType.Id]>Use the button above to add a new {{ accountType.Name }}.</p> </loading-wrapper> </div> <div class=col-xs-4> <markdown class=subtle text=accountType.Description></markdown> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 725 */
/***/ function(module, exports) {

	var path = 'areas/accounts/views/ssh_key_pair_account.html';
	var html = "<div> <control-group label=Username> <input class=form-control id=Username type=text ng-model=account.Username> <p class=help-block>The username to use when authenticating against the remote host.</p> </control-group> <control-group label=\"Private key\"> <sensitive-file-input id=Privatekey model=account.PrivateKeyFile></sensitive-file-input> <p class=help-block>Upload the private key file portion of the key pair.</p> </control-group> <control-group label=Passphrase> <sensitive-input id=Passphrase model=account.PrivateKeyPassphrase></sensitive-input> <p class=help-block>The passphrase for the private key, if required.</p> </control-group> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 726 */
/***/ function(module, exports) {

	var path = 'areas/accounts/views/username_password_account.html';
	var html = "<div> <control-group label=Username> <input class=form-control id=Username type=text placeholder=Username ng-model=account.Username> <p class=help-block>The username to use when authenticating against the remote host.</p> </control-group> <control-group label=Password> <sensitive-input model=account.Password id=Password></sensitive-input> <p class=help-block>The password to use to when authenticating against the remote host.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 727 */
/***/ function(module, exports) {

	var path = 'areas/configuration/audit/subscriptions/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/audit/subscriptions/new\">Create new</a></li> </script> <div class=\"form-box form-horizontal\"> <subscription-editor></subscription-editor> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 728 */
/***/ function(module, exports) {

	var path = 'areas/configuration/audit/subscriptions/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/audit/subscriptions/{{ vm.subscription.Id }}\">{{ vm.subscription.Name }}</a></li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <subscription-editor></subscription-editor> </div> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <div octo-permission=SubscriptionDelete> <h3>Delete</h3> <div> <p>Once you delete this subscription, there is no going back.</p> <delete-button model=vm.subscription what=Subscription redirect=/configuration/audit/subscriptions></delete-button> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 729 */
/***/ function(module, exports) {

	var path = 'areas/configuration/audit/subscriptions/views/editor.html';
	var html = "<form ng-submit=vm.save() name=subscriptionForm track-unsaved-changes> <div class=form-body> <h3>Subscription</h3> <p>This type of subscription allows your teams to be notified when certain events occur within Octopus. Learn more about subscriptions in our <a class=alert-link href=http://g.octopushq.com/Subscriptions target=_blank>documentation</a></p> <error-box error=vm.isSaving.error on-dismiss=\"vm.isSaving.error = null\"></error-box> <control-group label=Name> <input class=form-control type=text ng-model=vm.subscription.Name /> <p class=help-block>A short, memorable, unique name for this subscription.</p> </control-group> <div ng-show=vm.subscription.Id> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=vm.subscription.IsDisabled>Disable this subscription</label></div> <p class=help-block>Disable a subscription to prevent any notifications from being sent.</p> </control-group> </div> <h4 class=separator>Event Filter</h4> <event-filter users=vm.users projects=vm.projects environments=vm.environments event-groups=vm.eventGroups event-categories=vm.eventCategories tenants=vm.availableTenants tag-sets=vm.tagSets selected-filters=vm.selectedValues></event-filter> <p class=help-block>Any events matching these filters will be included in the e-mail digest or sent to the webhook destination configured below.</p> <h4 class=separator>Email Notifications</h4> <p class=\"alert alert-warning\" ng-hide=vm.smtpConfigured> You will need to <a class=alert-link href=#/configuration/smtp>configure SMTP</a> before emails can be sent. </p> <control-group label=\"Email Teams\"> <select-custom ng-model=vm.subscription.EventNotificationSubscription.EmailTeams available=vm.teams placeholder=\"'Select team(s)'\" multiple=true allow-clear=true></select-custom> <p class=help-block>Each member of these teams will receive an email.</p> </control-group> <control-group label=\"Email Frequency\" class=form-group-inline> <div> <input class=\"form-control input-small\" type=number ng-model=vm.emailFrequencyPeriod.Days min=0 max=23 /> <span>day{{ vm.emailFrequencyPeriod == null || vm.emailFrequencyPeriod.Days == 0 || vm.emailFrequencyPeriod.Days > 1 ? \"s\" : \"\"}}</span> <input class=\"form-control input-small\" type=number ng-model=vm.emailFrequencyPeriod.Hours min=0 max=23 /> <span>hour{{ vm.emailFrequencyPeriod == null || vm.emailFrequencyPeriod.Hours == 0 || vm.emailFrequencyPeriod.Hours > 1 ? \"s\" : \"\"}}</span> <input class=\"form-control input-small\" type=number ng-model=vm.emailFrequencyPeriod.Minutes min=0 max=59 /> <span>minute{{ vm.emailFrequencyPeriod == null || vm.emailFrequencyPeriod.Minutes == 0 || vm.emailFrequencyPeriod.Minutes > 1 ? \"s\" : \"\"}}</span> </div> <p class=help-block>Emails will be sent periodically, including a digest of events that have occurred.</p> </control-group> <control-group label=\"Email Timezone\"> <select class=form-control ng-model=vm.subscription.EventNotificationSubscription.EmailShowDatesInTimeZoneId ng-options=\"timezone.Id as timezone.Name for timezone in vm.timezones\"></select> <p class=help-block>Any date/times in emails will be shown using this timezone.</p> </control-group> <p class=help-block ng-show=vm.serverUriExists> Emails will include a deep-link to your Octopus audit screen (with filters matching the selected events). The base URL that will be used is: <a href={{vm.serverUri}} target=_blank>{{vm.serverUri}}</a>. </p> <p class=help-block ng-hide=vm.serverUriExists> This email can include a deep-link to your Octopus audit screen (with filters matching the selected events). To enable this feature, simply set a URL in your <a href=#/configuration/nodes/config>Octopus Server's configuration settings</a>. </p> <h4 class=separator>Webhook Notifications</h4> <control-group label=\"Payload URL\"> <input class=form-control ng-model=vm.subscription.EventNotificationSubscription.WebhookURI type=text /> <p class=help-block>The server endpoint that will receive the webhook payload.</p> <p class=help-block>The payload will be delivered in the body of a POST request using an <code>application/json</code> content type, contained in a parameter called \"Payload\". Each payload will contain a single event.</p> </control-group> <control-group label=\"Limited Team Scope\"> <select-custom ng-model=vm.subscription.EventNotificationSubscription.WebhookTeams available=vm.teams placeholder=\"'Select team(s)'\" multiple=true allow-clear=true></select-custom> <p class=help-block>By default, webhook requests will be sent with a global scope (all events will be sent). You may narrow the security scope to one or more teams. The subscription will then be limited to the events that the given team(s) can view. The team(s) must have at least EventView permissions.</p> </control-group> <last-modified model=vm.subscription></last-modified> </div> <div class=form-actions> <spin active=vm.isSaving.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=vm.isSaving.busy>Save</button> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 730 */
/***/ function(module, exports) {

	var path = 'areas/configuration/audit/subscriptions/views/index.html';
	var html = "<div> <script octo-section=configuration_tools type=text/ng-template> <a octo-permission=\"SubscriptionCreate\" wildcard class='btn btn-success'\r\n           href=\"#/configuration/audit/subscriptions/new\">Add subscription</a> </script> <h3>Subscriptions</h3> <p>Subscriptions allow your teams to be notified when certain events occur within Octopus. Read our <a class=alert-link href=http://g.octopushq.com/Subscriptions target=_blank>documentation</a> to learn more about working with subscriptions.</p> <div ng-show=\"subscriptions.length > 0\"> <div class=\"octo-list-group narrow-left narrow650\"> <a class=\"octo-list-group-item clickable\" href=#/configuration/audit/subscriptions/{{subscription.Id}} ng-repeat=\"subscription in subscriptions track by subscription.Id\"> <h4 class=octo-list-group-item-heading>{{ subscription.Name }}</h4> <p ng-show=\"subscription.IsDisabled === true\"><span class=\"label label-danger\">Disabled</span></p> <p class=subtle>{{ subscription.emailFrequencyPeriodText }}</p> <p class=subtle ng-show=subscription.emailTeams>Email teams: <tag-list tags=subscription.emailTeams></tag-list> </p> <p class=subtle ng-show=subscription.EventNotificationSubscription.WebhookURI>Webhook: <code>{{subscription.EventNotificationSubscription.WebhookURI}}</code> <span class=subtle ng-show=\"subscription.EventNotificationSubscription.WebhookURI && subscription.webhookTeams\"> with events scoped to teams: <tag-list tags=subscription.webhookTeams></tag-list></span> </p> </a> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 731 */
/***/ function(module, exports) {

	var path = 'areas/configuration/audit/views/audit_filter_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=vm.close()>×</button> <h3>Audit filter</h3> </div> <div class=\"modal-body tenant-tags-designer\"> <div> <event-filter users=vm.users projects=vm.projects environments=vm.environments event-groups=vm.eventGroups event-categories=vm.eventCategories tenants=vm.availableTenants tag-sets=vm.tagSets selected-filters=vm.selectedFilters></event-filter> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" type=submit ng-click=vm.save()>OK</button> <button class=\"btn btn-default\" type=button ng-click=vm.close()>Cancel</button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 732 */
/***/ function(module, exports) {

	var path = 'areas/configuration/audit/views/event_filter.html';
	var html = "<div> <control-group label=\"Event groups\" ng-if=\"vm.eventGroups && vm.eventGroups.length > 0\"> <select-custom placeholder=\"'Any Event Group'\" available=vm.eventGroups ng-model=vm.selectedFilters.eventGroups multiple=true allow-clear=true></select-custom> <control-group ng-if=vm.selectedFilters.selectedEventGroupCategories.length label=\"Events included\" class=margin-top-10 style=width:100%> <tag-list tags=vm.selectedFilters.selectedEventGroupCategories></tag-list> </control-group> </control-group> <control-group label=Events ng-if=\"vm.eventCategories && vm.eventCategories.length > 0\"> <select-custom placeholder=\"'Any Event'\" available=vm.eventCategories ng-model=vm.selectedFilters.eventCategories multiple=true allow-clear=true></select-custom> </control-group> <control-group label=Users ng-if=\"vm.users && vm.users.length > 0\"> <select-users available=vm.users ng-model=vm.selectedFilters.users allow-clear=true multiple=multiple></select-users> </control-group> <control-group label=Projects ng-if=\"vm.projects && vm.projects.length > 0\"> <select-projects available=vm.projects ng-model=vm.selectedFilters.projects allow-clear=true multiple=multiple></select-projects> </control-group> <control-group label=Environments ng-if=\"vm.environments && vm.environments.length > 0\"> <select-custom ng-model=vm.selectedFilters.environments available=vm.environments placeholder=\"'Any environment'\" multiple=true allow-clear=true></select-custom> </control-group> <control-group label=Roles ng-if=\"vm.roles && vm.roles.length > 0\"> <select-custom ng-model=vm.selectedFilters.roles available=vm.roles placeholder=\"'Any role'\" multiple=true allow-clear=true></select-custom> </control-group> <control-group label=\"Tenants (by name)\" octo-feature=IsMultiTenancyEnabled ng-if=\"vm.tenants && vm.tenants.length > 0\"> <select-tenants available=vm.tenants ng-model=vm.selectedFilters.tenants multiple=true allow-clear=true></select-tenants> </control-group> <control-group label=\"Tenants (by tag)\" octo-feature=IsMultiTenancyEnabled ng-if=\"vm.tagSets && vm.tagSets.length > 0\"> <div ng-repeat=\"tagSet in vm.tagSets\"> <control-group label={{tagSet.Name}}> <select-tags multiple=true available=tagSet.Tags ng-model=vm.selectedFilters.tagSets filter-tags-by-tagset={{tagSet.Name}} filter-tags-by-tagset-all=tagSets allow-clear=true></select-tags> </control-group> </div> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 733 */
/***/ function(module, exports) {

	var path = 'areas/configuration/audit/views/index.html';
	var html = "<div> <script octo-section=configuration_tools type=text/ng-template> <spin active=\"vm.isLoading.busy\"></spin>\r\n        <button type=\"button\" class='btn btn-link' ng-click=\"vm.openSubscriptions()\" octo-permission=\"SubscriptionView\">\r\n            Subscriptions\r\n        </button> </script> <div class=row> <div class=col-sm-12> <div class=dashboard-filter> <button type=button class=\"btn btn-link\" ng-click=vm.openNewSubscription() ng-show=vm.isFiltered octo-permission=SubscriptionEdit>Create subscription from this filter </button> <date-range-picker start=vm.dashboardFilter.dates.startDate end=vm.dashboardFilter.dates.endDate change=vm.refreshDates() style=width:300px></date-range-picker> <button type=button class=\"btn btn-default\" ng-click=vm.refresh() octo-permission=AuditView> Refresh </button> <button type=button ng-click=vm.openFilterDialog() class=\"btn btn-dashboard-filter\" ng-class=\"{'btn-success': vm.isFiltered}\"> <i class=\"fa fa-fw fa-filter\"></i> {{ vm.isFiltered ? 'Filtering is on' : 'Add filters' }} <span ng-if=vm.isFiltered ng-click=\"vm.clearFilters = true\" class=clear-filter><i class=\"fa fa-fw fa-times\"></i></span> </button> </div> </div> </div> <loading-wrapper busy=isLoading> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th style=width:150px>When</th> <th style=width:150px>Who</th> <th>What</th> </tr> </thead> <tbody> <tr ng-repeat=\"e in vm.events.Items\"> <td><span title=\"{{ e.Occurred | moment }}\">{{ e.Occurred | momentAgo }}</span></td> <td title=\"{{ e.IdentityEstablishedWith }}\"> <div class=user-image> <avatar model=vm.usersByUsername[e.Username]></avatar> </div> {{ e.Username }} </td> <td> <span ng-bind-html-unsafe=vm.formatMessageHtml(e)></span> <a href=\"\" ng-show=\"e.Details && !e.detailsVisible\" ng-click=vm.showDetails(e)>(show details)</a> <a href=\"\" ng-show=\"e.Details && e.detailsVisible\" ng-click=vm.showDetails(e)>(hide details)</a> <div ng-show=\"e.Details && e.detailsVisible\"> <pre class=diff ng-bind-html-unsafe=vm.formatDiff(e.Details)>\r\n          </pre> </div> </td> </tr> </tbody> </table> <octo-paginator collection=vm.events is-loading=vm.isLoading page-selected=vm.selectPage></octo-paginator> <div class=\"tutorial tutorial-center\" ng-hide=\"vm.events.Items.length > 0\"> No audit events found </div> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 734 */
/***/ function(module, exports) {

	var path = 'areas/configuration/backup/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/backup\">Backup</a></li> </script> <div class=form-body> <h3>Octopus database backups</h3> <p> Your Octopus database can be backed up by configuring backups for SQL Server and the file system. For more information, please see the <a href=http://g.octopushq.com/BackupRestore target=_blank>documentation on backups and restores</a>. </p> <div class=\"note note-warning\"> <p>Certain data in your Octopus Deploy database, such as sensitive variables and passwords for NuGet feeds, is encrypted. You won't be able to restore this data without a <a href=http://g.octopushq.com/SaveMyMasterKey target=_blank>copy of your Octopus master key</a>.</p> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 735 */
/***/ function(module, exports) {

	var path = 'areas/configuration/certificates/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/certificates\">Certificates</a></li> </script> <div class=form-horizontal> <h3>Octopus → Tentacle</h3> <p class=subtle>The certificate below is used to identify this Octopus server to any Tentacles when executing a deployment. You'll need the thumbprint when manually adding new Tentacle deployment targets to an environment.</p> <pre class=thumbprint>{{ octopusCertificate.Thumbprint }}</pre> <p class=help-block>Copy this value into the Tentacle set up screen.</p> <h3 class=margin-top-20>Octopus → Windows Azure</h3> <p class=subtle>Octopus authenticates with Windows Azure using Management Certificates. Grant this Octopus server rights to your Azure Subscriptions by creating an <a octo-permission=AccountEdit wildcard href=#/accounts>Account</a> for each one.</p> <a octo-permission=AccountEdit wildcard href=#/accounts>Manage Accounts</a> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 736 */
/***/ function(module, exports) {

	var path = 'areas/configuration/diagnostics/views/layout.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/diagnostics\">Diagnostics</a></li> </script> <div> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: $root.layout.diagnosticTab == 'serverLogs'}\"> <a href=#/configuration/diagnostics/ > Server Logs </a> </li> <li ng-class=\"{active: $root.layout.diagnosticTab == 'autoDeploymentLogs'}\"> <a href=#/configuration/diagnostics/auto_deployment_activity>Auto deploy logs</a> </li> <li ng-class=\"{active: $root.layout.diagnosticTab == 'environmentCleanupLogs'}\"> <a href=#/configuration/diagnostics/environment_cleanup>Machine clean up logs</a> </li> <li ng-class=\"{active: $root.layout.diagnosticTab == 'subscriptionLogs'}\"> <a href=#/configuration/diagnostics/subscription_activity>Subscription logs</a> </li> </ul> <ui-view></ui-view> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 737 */
/***/ function(module, exports) {

	var path = 'areas/configuration/diagnostics/views/logs.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/diagnostics\">Diagnostics</a></li> </script> <script octo-section=configuration_tools type=text/ng-template> <spin active='isLoading.busy'></spin>\r\n    <button type=\"button\" class='btn btn-success' ng-click=\"refresh()\" octo-permission=\"AdministerSystem\">Refresh\r\n    </button> </script> <h3>Detailed Server Logs</h3> <div class=\"tutorial tutorial-center\" ng-show=\"logs.length == 0\"> <p class=subtle>No warning- or error-level events have been collected in this session.</p> </div> <div ng-show=logs> <p>The entries below are the most recent warning- and error-level events recorded on the Octopus Server in this session.</p> <div> <log-line detail=true event=log full-date=true ng-repeat=\"log in logs\"></log-line> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 738 */
/***/ function(module, exports) {

	var path = 'areas/configuration/diagnostics/views/scheduled_task.html';
	var html = "<div class=container-fluid> <div class=row> <div> <span class=\"pull-right text-right\"> <span class=expand-mode-selector> Expand: <a href ng-click=\"rootNode.expander.setMode('All')\" ng-class=\"{ current: rootNode.expander.mode == 'All' }\">All</a> | <a href ng-click=\"rootNode.expander.setMode('Interesting')\" ng-class=\"{ current: rootNode.expander.mode == 'Interesting' }\">Interesting</a> | <a href ng-click=\"rootNode.expander.setMode('Errors')\" ng-class=\"{ current: rootNode.expander.mode == 'Errors' }\">Errors</a> | <a href ng-click=\"rootNode.expander.setMode('None')\" ng-class=\"{ current: rootNode.expander.mode == 'None' }\">None</a> </span> <a class=\"btn btn-link btn-default\" href ng-hide=isVerbose ng-click=showVerbose()>Verbose</a> </span> </div> </div> <div class=row> <div class=activity-log ng-show=\"rootNode.children.length || rootNode.name\"> <activity-element-summary element=rootNode go-to-log=goToLog mode=details toggle-gap=toggleGap></activity-element-summary> </div> <p ng-hide=\"rootNode.children.length || rootNode.name\">The task has not written any information to the log yet.</p> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 739 */
/***/ function(module, exports) {

	var path = 'areas/configuration/diagnostics/views/server_activity.html';
	var html = "<div class=server-activity ng-class=\"{'active': activity.CurrentlyReceiving}\"> <div class=server-activity-description> <h4>{{ activity.Description }} <span ng-show=\"activity.InputQueueCount > 0\" class=\"badge badge-warning\" title=\"Queued messages incoming\">{{ activity.InputQueueCount }}</span></h4> <p ng-show=\"!activity.Location && activity.ActorName\"><a href=\"{{ activity.Links['Raw'] | resolveLink }}\" target=_blank>{{ activity.ActorName }}</a></p> <p ng-show=activity.Location class=subtle>{{ activity.ActorName }}@{{ activity.Location }}</p> <p ng-show=activity.CurrentOperation class=subtle>{{ activity.CurrentOperation }}</p> <p ng-show=activity.CurrentlyReceiving class=subtle>Processing <strong>{{ activity.CurrentlyReceiving }}</strong> since {{ activity.CurrentlyReceivingSinceUtc | moment }}</p> </div> <ul> <li ng-repeat=\"supervisee in activity.SupervisedActivities | orderBy:'Description'\"> <server-activity activity=supervisee></server-activity> </li> </ul> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 740 */
/***/ function(module, exports) {

	var path = 'areas/configuration/diagnostics/views/server_logs.html';
	var html = " <script octo-section=configuration_tools type=text/ng-template> <spin active='isLoading.busy'></spin>\r\n  <a class=\"btn btn-info\" href=\"{{ systemReportLink }}\" ng-click=\"showSystemReportWarning = true\" octo-permission=\"AdministerSystem\"><i class=\"fa fa-download\"></i> System Report</a>\r\n  <a class=\"btn btn-info\" href=\"\" ng-click=\"checkSystemIntegrity()\" octo-permission=\"AdministerSystem\"><i class=\"fa fa-database\"></i> Check System Integrity</a> </script> <div> <div class=row ng-show=showSystemReportWarning> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div class=\"note note-warning\"> <p>The generated <strong>system report</strong> may contain information specific to this Octopus Deploy installation, such as file paths, deployment target, project, user, or environment details. Every effort is made to mask sensitive data such as passwords.</p> <p> If you are concerned about sharing any of this information with the Octopus Deploy Support Team we recommend opening the file and sending only extracts relevant to your specific problem.</p> </div> </div> </div> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <error-box error=isChecking.error on-dismiss=\"isChecking.error = null\"></error-box> </div> </div> <div class=row> <div class=\"col-sm-8 col-md-8 col-lg-8\"> <h3>Server Logs</h3> <div class=\"tutorial tutorial-center\" ng-show=\"logs.length == 0\"> <p class=subtle>No warning- or error-level events have been collected in this session.</p> </div> <div ng-show=logs> <p>The entries below are the most recent warning- and error-level events recorded on the Octopus Server in this session.</p> <div> <log-line event=log full-date=true ng-repeat=\"log in logs\"></log-line> </div> <p><a href=#/configuration/diagnostics/logs>View detailed log<span ng-show=\"more > 0\"> ({{ more }} more)</span> »</a></p><p> </p></div> </div> <div class=\"col-sm-4 col-md-4 col-lg-4\"> <h3>System Information</h3> <table class=\"table table-bordered\"> <tbody> <tr><th>OS Version</th><td>{{ info.OSVersion }}</td></tr> <tr><th>CLR Version</th><td>{{ info.ClrVersion }}</td></tr> <tr><th>Working Set</th><td>{{ info.WorkingSetBytes | bytesToSize }}<br/><a href ng-click=gcCollect()>Collect</a></td></tr> <tr><th>Threads</th><td>{{ info.ThreadCount }}</td></tr> <tr><th>Uptime</th><td>{{ info.Uptime }}</td></tr> </tbody> </table> <div class=row></div> <h3>Server Extensions</h3> <table class=\"table table-bordered\"> <thead> <th>Name</th> <th>Author</th> <th>Version</th> </thead> <tbody> <tr ng-repeat=\"extensionInfo in extensions\"> <td>{{extensionInfo.Name}}</td> <td ng-if=!extensionInfo.IsCustom>{{ extensionInfo.Author }}</td> <td ng-if=extensionInfo.IsCustom><strong>{{ extensionInfo.Author }}</strong></td> <td>{{extensionInfo.Version}}</td> </tr> </tbody> </table> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 741 */
/***/ function(module, exports) {

	var path = 'areas/configuration/features/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/features\">Features</a></li> </script> <div class=\"form-box form-horizontal\"> <form name=featuresForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <div class=features-multi-tenancy> <h3>Multi-tenant deployments</h3> <p class=text-muted>By enabling this feature you will be able to create tenants, connect them to projects/environments, capture tenant-specific configuration settings, and deploy your projects to tenants. For more information refer to our comprehensive <a href=http://g.octopushq.com/MultiTenantDeployments target=_blank>documentation</a>. </p> <control-group label=Enabled> <input id=multiTenancySwitch type=checkbox bs-switch ng-model=config.IsMultiTenancyEnabled switch-on-color=success switch-on-label=On switch-off-label=Off switch-size=small> </control-group> <div class=\"alert alert-info margin-top-10\" ng-if=\"config.IsMultiTenancyEnabled && hasTenants === false\">Now go and <a class=alert-link href=#tenants>create your first tenant</a>! </div> <last-modified model=config></last-modified> </div> <hr> <div> <h3>Docker</h3> <p class=text-muted>By enabling this feature you will be able to create Docker feeds and run Docker steps as part of your deployment process. Learn about <a href=http://g.octopushq.com/DockerGuide target=_blank>Docker and Octopus Deploy</a>.</p> <control-group label=Enabled> <input type=checkbox bs-switch ng-model=config.IsDockerEnabled switch-on-color=success switch-on-label=On switch-off-label=Off switch-size=small> </control-group> <p ng-if=config.IsDockerEnabled class=help-block> <a href=http://g.octopushq.com/WhatIsEAP target=_blank><span class=\"label label-warning\">EAP</span></a> We are providing early access to the Docker features in this release of Octopus Deploy, and it is likely we will make changes based on your feedback! </p> </div> <hr> <div> <h3>Octopus community step templates</h3> <p class=text-muted> This feature enables access to all <a target=_blank href=http://g.octopushq.com/CommunityLibrary>community contributed steps</a> when editing project deployment processes. Octopus will fetch and store the templates locally, and they will be available alongside the built-in Octopus step templates. <br> <strong>Note: The Octopus server requires internet access for this to work.</strong> For more information refer to our community step <a href=http://g.octopushq.com/CommunityContributedStepTemplates target=_blank>documentation</a>. </p> <control-group label=Enabled> <input id=communityStepTemplatesSwitch type=checkbox bs-switch ng-model=config.IsCommunityActionTemplatesEnabled switch-on-color=success switch-on-label=On switch-off-label=Off switch-size=small> </control-group> <div class=margin-top-10 ng-if=\"config.IsCommunityActionTemplatesEnabled && (IsCommunityActionTemplatesEnabledOnLoad || !unsavedChanges.hasUnsavedChanges())\"> <div class=margin-bottom-10> <span ng-class=lastSyncTextClass>Last sync {{lastSyncFailed ? 'failed' : 'succeeded'}}: <a ng-if=lastSyncTaskUrl href={{lastSyncTaskUrl}}><span title=\"{{ lastSync | moment }}\">{{lastSync | momentAgo }}</span></a> <span ng-if=!lastSyncTaskUrl>{{lastSync}}</span></span> </div> <control-group label=\"\"> <button class=\"btn btn-default\" type=submit ng-disabled=isLoading.busy ng-click=synchronizeLibrarySteps()>Sync now </button> </control-group> </div> <last-modified model=config></last-modified> </div> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-show=unsavedChanges.hasUnsavedChanges() ng-disabled=isSaving.busy ng-click=save()>Save </button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 742 */
/***/ function(module, exports) {

	var path = 'areas/configuration/license/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/license\">License</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>License</h3> <div class=\"narrow-left narrow650\"> <p class=tutorial-left> Octopus comes with a free Community edition license, which allows you to have up to five active projects and ten deployment targets for free. To increase these limits, you will need a license. Please refer to <a class=external href=http://g.octopushq.com/HowDoIGetALicense target=_blank>the Octopus licensing page</a> for details on how licensing works. </p> <loading-wrapper busy=isLoading> <div class=\"alert alert-danger\" ng-hide=license.IsCompliant> <h4>License limits exceeded</h4> <div ng-bind-html=license.NoncomplianceReason></div> <p>Get more information or upgrade your license at <a class=alert-link target=_blank href=http://g.octopushq.com/Purchase>octopusdeploy.com</a>.</p> </div> <error-box error=isSaving.error></error-box> <form ng-submit=save() track-unsaved-changes name=licenseForm> <div class=form-body> <control-group label=License> <div class=radio><label><input type=radio ng-model=license.UseFreeVersion ng-value=true> I want to use the free Community Edition</label></div> <div class=radio><label><input type=radio ng-model=license.UseFreeVersion ng-value=false> I have a license key</label></div> <div ng-hide=license.UseFreeVersion> <p class=help-block>Please paste the license XML below:</p> <div id=scriptEditorContainer> <div id=scriptEditor ui-ace=\"{ mode: 'xml' }\" ng-model=license.LicenseText></div> </div> </div> </control-group> <hr/> <h3>Upgrades</h3> <p>This setting only affects the visibility of the bullhorn/update notification that is shown in the top menu when Octopus updates are available.</p> <control-group label=\"Upgrade Notifications\"> <div class=radio><label><input type=radio ng-model=config.NotificationMode ng-value=\"'AlwaysShow'\"> Always show updates</label></div> <div class=radio><label><input type=radio ng-model=config.NotificationMode ng-value=\"'ShowOnlyMajorMinor'\"> Only show major or minor version updates</label></div> <div class=radio><label><input type=radio ng-model=config.NotificationMode ng-value=\"'NeverShow'\"> Never show updates</label></div> </control-group> </div> <div class=form-actions> <button class=\"btn btn-success\" type=button ng-click=save()>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </loading-wrapper> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 743 */
/***/ function(module, exports) {

	var path = 'areas/configuration/maintenance/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/maintenance\">Maintenance</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>Maintenance</h3> <p> In maintenance mode, the Octopus server will be read-only. Only members of the <strong>Octopus Administrators</strong> team will be able to make changes or initiate deployments. </p> <form name=maintenanceForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=\"Maintenance mode\"> <div class=\"pull-left-100 labeled-switch\"> <input type=checkbox bs-switch ng-model=config.IsInMaintenanceMode switch-on-color=danger switch-on-label=On switch-off-label=Off switch-size=small> </div> </control-group> <last-modified model=config></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy ng-click=save()>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 744 */
/***/ function(module, exports) {

	var path = 'areas/configuration/nodes/config/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/nodes\">Octopus Server Nodes</a></li>\r\n        <li><a href=\"#/configuration/nodes/config\">Configuration Settings</a></li> </script> <loading-wrapper busy=isLoading once=true> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div class=\"form-box form-horizontal\"> <form name=serverForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <div> <h3>Server Configuration</h3> <control-group label=\"Server URL\"> <input class=form-control type=text ng-model=config.ServerUri> <p class=help-block>The publicly-accessible URL of this server.</p> </control-group> <last-modified model=config></last-modified> </div> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy ng-click=saveServerConfiguration()>Save </button> </div> </form> </div> </div> </div> <div ng-repeat=\"configSet in configSettings\"> <h4 class=separator>{{configSet.ConfigurationSet}}</h4> <div ng-repeat=\"configValue in configSet.ConfigurationValues\"> <control-group label={{configValue.Description}}> <div>{{configValue.Value}}</div> </control-group> </div> </div> </loading-wrapper> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 745 */
/***/ function(module, exports) {

	var path = 'areas/configuration/nodes/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/nodes\">Octopus Server Nodes</a></li> </script> <script octo-section=configuration_tools type=text/ng-template> <spin active='isLoading.busy'></spin>\r\n    <a href=\"#/configuration/nodes/config\" class='btn btn-link' octo-permission=\"AdministerSystem\">Configuration\r\n        Settings</a> </script> <loading-wrapper busy=isLoading once=true> <div class=\"form-box form-horizontal\"> <h3>Octopus Server Nodes</h3> <ul class=octo-tiles> <li ng-repeat=\"node in nodes.Items\"> <div class=octo-list-group> <div class=\"octo-list-group-item node-tile\"> <form name=nodeForm track-unsaved-changes> <div class=node-title> <div> <h4 class=octo-list-group-item-heading>{{ node.Name | ellipsis:40 }}</h4> </div> <span class=\"status Failed\" ng-if=node.IsOffline style=position:absolute;right:10px;top:5px uib-tooltip=\"This Octopus Server node is offline.\"> <i class=\"fa fa-exclamation-triangle\"> </i> </span> </div> <control-group label=Rank> <p class=node-information>{{ node.Rank }}</p> </control-group> <control-group label=\"Last seen\"> <p class=node-information ng-class=\"{Offline: node.IsOffline}\">{{ node.LastSeen }}</p> </control-group> <control-group label=Tasks> <p class=node-information> <a href=\"#/tasks?serverNode={{ node.Id }}\">{{ nodeTaskCount[node.Id] ? nodeTaskCount[node.Id] : \"No\" }} running task{{ nodeTaskCount[node.Id] == null || nodeTaskCount[node.Id] == 0 || nodeTaskCount[node.Id] > 1 ? \"s\" : \"\"}}</a> </p> </control-group> <control-group label=\"Task cap\"> <input class=form-control type=number ng-model=node.MaxConcurrentTasks min=0> <p class=help-block>Number of tasks this node can execute at once.</p> </control-group> <control-group label=Drain> <div class=\"pull-left-100 labeled-switch\"> <input type=checkbox bs-switch ng-model=node.IsInMaintenanceMode switch-on-color=danger switch-on-label=On switch-off-label=Off switch-size=small> </div> <p class=help-block>Prevent new tasks from executing on this node.</p> </control-group> <error-box error=isSaving.error></error-box> <div class=text-right> <delete-button model=node what=node redirect=/configuration/nodes ng-if=\"nodes.Items.length > 1\"></delete-button> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy ng-click=save(node)>Save </button> </div> </form> </div> </div> </li> </ul> <octo-paginator collection=nodes></octo-paginator> </div> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 746 */
/***/ function(module, exports) {

	var path = 'areas/configuration/overview/index.html';
	var html = "<div> <h3>About this Octopus Deploy server</h3> <p>Welcome to Octopus Deploy! Just getting started? The checklist below will help you get up and running.</p> <ul class=\"checklist fa-ul\"> <li ng-repeat=\"item in checklist\"><i class=\"fa-li fa\" ng-class=\"{'fa-check-square': item.completed, 'fa-square': !item.completed, 'text-success': item.completed, 'text-primary': !item.completed}\"></i><span ng-bind-html-unsafe=item.html></span></li> </ul> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 747 */
/***/ function(module, exports) {

	var path = 'areas/configuration/roles/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-hide=\"role.Id\"><a href=\"#/configuration/roles/new\">New Role</a></li>\r\n    <li ng-show=\"role.Id\"><a href=\"#/configuration/roles/{{ role.Id }}\">{{ role.Name }}</a></li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <h3>{{ title }}</h3> <form ng-submit=save() name=teamForm> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Name> <input class=form-control type=text ng-model=role.Name ng-show=\"role.CanBeRenamed || role.CanBeDeleted\"> <span class=uneditable-input ng-hide=\"role.CanBeRenamed || role.CanBeDeleted\">{{role.Name}}</span> <p class=help-block>A short, memorable, unique name for this role. Example: Project Support.</p> </control-group> <control-group label=Description> <input class=form-control type=text ng-model=role.Description> <p class=help-block>Briefly describe what this role grants.</p> </control-group> <h4 class=separator>Roles</h4> <table class=\"table table-bordered\"> <tbody> <tr ng-repeat=\"perm in availablePermissions\"> <td> <div class=checkbox><label> <input type=checkbox ng-model=perm.selected> {{ perm.id }} </label></div> </td> <td> {{ perm.description }} </td> </tr> </tbody> </table> <last-modified model=role></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <div ng-show=role.CanBeDeleted octo-permission=UserRoleEdit> <h3>Delete</h3> <p>Deleting this role will not delete the members of the role.</p> <delete-button model=role what=role redirect=/configuration/roles></delete-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 748 */
/***/ function(module, exports) {

	var path = 'areas/configuration/roles/views/index.html';
	var html = "<script octo-section=configuration_tools type=text/ng-template> <a class='btn btn-success' href=\"#/configuration/roles/new\" octo-permission=\"UserRoleEdit\">Add custom role</a> </script> <div> <h3>User Roles</h3> <p>Octopus comes with a common set of built-in roles, and you can create custom user roles to suit your needs.</p> <div class=\"octo-list-group narrow-left narrow650\"> <a class=octo-list-group-item href=#/configuration/roles/{{role.Id}} ng-repeat=\"role in roles.Items\"> <h4 class=octo-list-group-item-heading>{{ role.Name }}</h4> <p class=subtle>{{ role.Description}}</p> </a> </div> <octo-paginator collection=roles></octo-paginator> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 749 */
/***/ function(module, exports) {

	var path = 'areas/configuration/smtp/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/smtp\">SMTP</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>SMTP Configuration</h3> <form name=smtpForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=\"SMTP Host\"> <input class=\"input-xlarge form-control\" type=text ng-model=smtp.SmtpHost> <p class=help-block>DNS hostname of the SMTP server.</p> </control-group> <control-group label=\"SMTP Port\"> <input class=\"input-small form-control\" type=text ng-model=smtp.SmtpPort> <p class=help-block>The TCP port of the SMTP server.</p> </control-group> <control-group label=\"Use SSL/TLS\"> <div class=checkbox><label><input type=checkbox ng-model=smtp.EnableSsl></label></div> <p class=help-block>Whether SSL/TLS should be used; check with your email provider.</p> </control-group> <control-group label=\"From Address\"> <input class=\"input-xlarge form-control\" type=text ng-model=smtp.SendEmailFrom> <p class=help-block>All emails will be sent 'From' the address above.</p> </control-group> <div ng-show=view.hasExistingPassword> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=view.showPasswordChange ng-disabled=view.showPasswordChange> Change credentials</label></div> </control-group> </div> <div id=credentials ng-show=view.showPasswordChange> <h4 class=separator>Credentials</h4> <p class=subtle>Leave the following blank if your SMTP server does not require authentication.</p> <control-group label=\"SMTP Login\"> <input class=form-control type=text ng-model=smtp.SmtpLogin> </control-group> <control-group label=\"SMTP Password\"> <input class=form-control type=password ng-model=smtp.NewSmtpPassword> </control-group> </div> <last-modified model=feed></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy ng-click=save(true)>Save and test </button> <button class=\"btn btn-default\" type=submit ng-disabled=isSaving.busy ng-click=save(false)>Save </button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 750 */
/***/ function(module, exports) {

	var path = 'areas/configuration/teams/views/add_domain_group_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add Active Directory group</h3> </div> <div class=modal-body> <error-box error=isLoading.error></error-box> <div class=input-append> <form ng-submit=search.perform()> <input class=\"input-xlarge form-control\" type=text id=domainGroupName ng-model=search.groupName> <button class=\"btn btn-default\">Search</button> <div style=float:right> <spin active=isLoading.busy></spin> </div> </form> </div> <div class=\"tutorial-center tutorial\" ng-show=\"hasSearched && results.length == 0\"> No results were found. Enter the start of a group name. For example, to find \"Domain Users\", type \"Domain\". </div> <table class=\"table table-bordered margin-top-bottom-20\" ng-show=\"results && results.length > 0 && !isLoading.busy\"> <tbody> <tr ng-repeat=\"r in results\"> <td> <div class=checkbox><label><input type=checkbox ng-model=r.Selected> {{ r.DisplayName }}</label></div> </td> </tr> </tbody> </table> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save() ng-show=!isLoading.busy>Add</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 751 */
/***/ function(module, exports) {

	var path = 'areas/configuration/teams/views/add_external_role_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add External Role</h3> </div> <div class=modal-body> <error-box error=isLoading.error></error-box> <control-group label=\"Role Id\"> <input class=\"input-xlarge form-control\" type=text id=openIdRoleId ng-model=role.id> </control-group> <control-group label=\"Display Name\"> <input class=\"input-xlarge form-control\" type=text id=openIdRoleDisplayName ng-model=role.displayName> </control-group> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save()>Add</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 752 */
/***/ function(module, exports) {

	var path = 'areas/configuration/teams/views/add_members_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add team members</h3> </div> <div class=modal-body> <loading-wrapper busy=isLoading> <control-group label=Users> <select-users ng-model=adding.members available=users placeholder=\"'Any User'\" multiple=true></select-users> </control-group> </loading-wrapper> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save() ng-show=!isLoading.busy>Add</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'areas/configuration/teams/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-hide=\"team.Id\"><a href=\"#/configuration/teams/new\">Create New</a></li>\r\n    <li ng-show=\"team.Id\"><a href=\"#/configuration/teams/{{ team.Id }}\">{{ team.Name }}</a></li> </script> <div class=row> <div class=col-sm-9> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <form ng-submit=save() name=teamForm ng-if=team> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Name> <input class=form-control type=text ng-model=team.Name ng-show=team.CanBeRenamed> <span class=uneditable-input ng-show=!team.CanBeRenamed>{{team.Name}}</span> <p class=help-block>A short, memorable, unique name for this team. Example: ACME Project Contributors.</p> </control-group> <control-group label=Roles> <ul class=\"octo-list-group can-add\"> <li class=octo-list-group-item ng-repeat=\"userRoleId in team.UserRoleIds\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=removeRole(userRoleId) ng-show=team.CanChangeRoles>×</button> <h4 class=octo-list-group-item-heading>{{ getRole(userRoleId).Name }}</h4> <p>{{ getRole(userRoleId).Description }}</p> </li> </ul> <button class=\"btn btn-default\" type=button ng-class=\"{ 'octo-list-group-add': team.UserRoleIds.length }\" ng-click=addRole() ng-show=team.CanChangeRoles><i class=icon-plus></i> Add role</button> <p class=help-block>Roles grant the team permission to perform actions on the Octopus Deploy Server.</p> </control-group> <control-group label=\"Project Groups\"> <select-custom placeholder=\"'Any Project Group'\" available=projectGroups ng-model=team.ProjectGroupIds multiple=true allow-clear=true> </select-custom> <p class=help-block>Team participation can be restricted to one or more project groups, including all projects in the group.</p> </control-group> <control-group label=Projects> <select-projects available=projects ng-model=team.ProjectIds multiple=true></select-projects> <p class=help-block>Team participation can be restricted to one or more projects. Leaving this option empty will grant the permissions associated with the team across all projects.</p> </control-group> <control-group label=Environments> <select-environments available=environments ng-model=team.EnvironmentIds multiple=true></select-environments> <p class=help-block>Team participation can be restricted to one or more environments. Leaving this option empty will grant the permissions associated with the team across all environments.</p> </control-group> <control-group label=Tenants octo-feature=IsMultiTenancyEnabled> <select-tenants available=allTenants ng-model=team.TenantIds multiple=multiple></select-tenants> <p class=help-block>Team participation can be restricted to one or more tenants. Leaving this option empty will grant the permissions associated with the team across all tenants.</p> </control-group> <control-group label=Members> <ul class=\"octo-list-group can-add\"> <li class=octo-list-group-item ng-repeat=\"member in team.ExternalSecurityGroups\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=removeExternalGroup(member) ng-show=team.CanChangeMembers>×</button> <div ng-show=\"member.DisplayIdAndName == true\"><div class=user-image><img src=" + __webpack_require__(294) + " width=16 height=16 alt=Role></div> {{ member.DisplayName }} ({{ member.Id }})</div> <div ng-hide=\"member.DisplayIdAndName == true\"><div class=user-image><img src=" + __webpack_require__(294) + " width=16 height=16 alt=\"Security group\"></div> {{ member.DisplayName }}</div> </li> <li class=octo-list-group-item ng-repeat=\"member in team.MemberUserIds\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=removeMember(member) ng-show=team.CanChangeMembers>×</button> <div><div class=user-image><avatar model=getUser(member)></avatar></div> {{ getUser(member).DisplayName }}</div> </li> </ul> <button class=\"btn btn-default\" type=button ng-class=\"{ 'octo-list-group-add': team.MemberUserIds.length + team.ExternalSecurityGroups.length }\" ng-click=addMembers() ng-show=team.CanChangeMembers><i class=icon-plus></i> Add members</button> <button ng-repeat=\"groupProvider in externalGroupProviders\" class=\"btn btn-default\" type=button ng-class=\"{ 'octo-list-group-add': team.MemberUserIds.length + team.ExternalSecurityGroups.length }\" ng-click=addExternalGroup(groupProvider.LookupUri) ng-show=team.CanChangeMembers><i class=icon-plus></i> Add {{ groupProvider.Name }} group</button> <button class=\"btn btn-default\" type=button ng-class=\"{ 'octo-list-group-add': team.MemberUserIds.length + team.ExternalSecurityGroups.length }\" ng-click=addExternalRole() ng-show=\"team.CanChangeMembers && hasRoleBasedGroupProviders\"><i class=icon-plus></i> Add External Role</button> <p class=help-block>The users and groups belonging to the team; a user can belong to more than one team.</p> </control-group> <last-modified model=team></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </div> <div class=\"other-actions col-sm-3\"> <div ng-show=team.CanBeDeleted octo-permission=TeamDelete> <h3>Delete</h3> <p>Deleting this team will not delete the members or roles of the team.</p> <delete-button model=team what=team redirect=/configuration/teams></delete-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 754 */
/***/ function(module, exports) {

	var path = 'areas/configuration/teams/views/edit_role_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add role</h3> </div> <div class=\"modal-body help-scope\"> <loading-wrapper busy=isLoading> <control-group label=Role> <select-custom class=ng-hide ng-show=!isLoading.busy placeholder=\"'Select Role'\" available=userRoles ng-model=roleParticipation.userRoleId> </select-custom> <p class=\"pad-left-30 subtle\">{{ getRole().Description }} Permissions granted with the role:</p> <ul class=\"pad-left-30 subtle\"> <li ng-repeat=\"permission in getRole().PermissionDescriptions\">{{ permission }}</li> </ul> <p class=help-block>A role specifies what actions users in this team will be able to perform.</p> </control-group> </loading-wrapper> </div> <div class=modal-footer> <button class=\"btn btn-success ng-hide\" ng-click=save() ng-show=roleParticipation.userRoleId>Add</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 755 */
/***/ function(module, exports) {

	var path = 'areas/configuration/teams/views/index.html';
	var html = "<script octo-section=configuration_tools type=text/ng-template> <a class='btn btn-link' href=\"#/configuration/teams/test\" octo-permission=\"TeamView\">Test Permissions</a>\r\n    <a class='btn btn-link' href=\"#/configuration/roles\" octo-permission=\"UserRoleView\">Roles</a>\r\n    <a class='btn btn-success' href=\"#/configuration/teams/new\" octo-permission=\"TeamCreate\">Add team</a> </script> <div> <h3>Teams</h3> <p>Octopus manages permissions by assigning users to teams. A team is associated with a set of roles along with the projects and environments those roles can be exercised in.</p> <div class=\"octo-list-group narrow-left narrow650\"> <a class=octo-list-group-item href=#/configuration/teams/{{team.Id}} ng-repeat=\"team in teams.Items\"> <h4 class=octo-list-group-item-heading>{{ team.Name }}</h4> <applied-tags-list octo-feature=IsMultiTenancyEnabled ng-model=team.TenantTags></applied-tags-list> <p class=subtle>{{ team.MemberUserIds.length }} member<span ng-show=\"team.MemberUserIds.length != 1\">s</span></p> <p class=subtle ng-show=\"team.ExternalSecurityGroups.length > 0\">{{ team.ExternalSecurityGroups.length }} external group<span ng-show=\"team.ExternalSecurityGroups.length != 1\">s</span></p> </a> </div> <octo-paginator collection=teams></octo-paginator> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 756 */
/***/ function(module, exports) {

	var path = 'areas/configuration/teams/views/test.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/teams/test\">Test Permissions</a></li> </script> <div> <h3>Test Permissions</h3> <div class=filter-bar> <ui-select ng-model=filter.selectedUser ng-change=test() append-to-body=true> <ui-select-match placeholder=\"Any user\" allow-clear=true>{{$select.selected.DisplayName}} ({{$select.selected.Username}}) </ui-select-match> <ui-select-choices repeat=\"item in users | filterUsers:$select.search track by item.Id\"> <span ng-bind-html=\"item.Username | highlight: $select.search\"></span> (<span ng-bind-html=\"item.DisplayName | highlight: $select.search\"></span>) </ui-select-choices> </ui-select> </div> <div ng-show=user> <h3>Teams</h3> <p>The user <a href=\"#/configuration/users/{{ user.Id }}\">{{ user.Username }}</a> is a member of the following teams:</p> <ul> <li ng-repeat=\"t in teams\"><a href=\"#/configuration/teams/{{ t.Id }}\">{{ t.Name }}</a></li> </ul> <div class=\"panel panel-transparent\"> <div class=panel-heading> <h3 class=\"panel-title permissions\">Permissions</h3> <div class=panel-heading-controls> <a class=\"btn btn-success\" href=\"{{ exportUrl }}\" ng-show=permissions> Export </a> </div> </div> </div> <p>The user has the following permissions:</p> <div class=\"tutorial tutorial-center\" ng-hide=permissions> <p>No permissions</p> </div> <div ng-show=permissions> <table class=\"table table-bordered\"> <thead> <tr> <th>Permission</th> <th>Project Groups</th> <th>Projects</th> <th>Environments</th> <th>Tenants</th> </tr> </thead> <tbody> <tr ng-repeat=\"p in permissions\"> <td><strong ng-hide=p.sameAsPrevious title=\"{{ p.info.Description }}\">{{p.name}}</strong></td> <td> <span ng-show=\"p.perms && p.info.SupportedRestrictions.indexOf('projectgroups') >= 0\"> <span ng-show=p.perms.RestrictedToProjectGroupIds> <span ng-repeat=\"id in p.perms.RestrictedToProjectGroupIds\"><a class=\"btn btn-link btn-default\" href=\"#/projectgroups/{{ id }}\">{{ projectGroups[id].Name }}</a></span> </span> <span ng-hide=p.perms.RestrictedToProjectGroupIds><em class=gray>All project groups</em></span> </span> </td> <td> <span ng-show=\"p.perms && p.info.SupportedRestrictions.indexOf('projects') >= 0\"> <span ng-show=p.perms.RestrictedToProjectIds> <span ng-repeat=\"id in p.perms.RestrictedToProjectIds\"><a class=\"btn btn-link btn-default\" href=\"#/projects/{{ projects[id].Slug }}\">{{ projects[id].Name }}</a></span> </span> <span ng-hide=p.perms.RestrictedToProjectIds><em class=gray>All projects</em></span> </span> </td> <td> <span ng-show=\"p.perms && p.info.SupportedRestrictions.indexOf('environments') >= 0\"> <span ng-show=p.perms.RestrictedToEnvironmentIds> <span ng-repeat=\"id in p.perms.RestrictedToEnvironmentIds\"><a class=\"btn btn-link btn-default\" href=#/environments>{{ environments[id].Name }}</a></span> </span> <span ng-hide=p.perms.RestrictedToEnvironmentIds><em class=gray>All environments</em></span> </span> </td> <td> <span ng-show=\"p.perms && p.info.SupportedRestrictions.indexOf('tenants') >= 0\"> <span ng-show=p.perms.RestrictedToTenantIds> <span ng-repeat=\"id in p.perms.RestrictedToTenantIds\"><a class=\"btn btn-link btn-default\" href=#/tenants/{{id}}>{{ tenants[id].Name }}</a></span> </span> <span ng-hide=p.perms.RestrictedToTenantIds><em class=gray>All tenants</em></span> </span> </td> </tr> </tbody> </table> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 757 */
/***/ function(module, exports) {

	var path = 'areas/configuration/users/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/users/new\">Create New</a></li> </script> <div class=\"narrow650 narrow-left\"> <div class=\"form-box form-horizontal help-scope\"> <h3>New user</h3> <form ng-submit=save()> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Username> <input class=\"input form-control\" type=text ng-model=user.Username /> <p class=help-block>The username that the user authenticates with.</p> </control-group> <control-group label=\"Display name\"> <input class=form-control type=text ng-model=user.DisplayName /> <p class=help-block>The user's name. This does not need to be unique.</p> </control-group> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=user.IsService /> The user is a service account</label></div> <p class=help-block>A service account can log in using API keys only. After creating the user you'll need to add some API keys before the account can be used.</p> </control-group> <div ng-hide=user.IsService> <control-group label=\"Email address\"> <input class=form-control type=text ng-model=user.EmailAddress /> <p class=help-block>The user's email address. This will be used to show the user's <a class=external target=_blank href=http://g.octopushq.com/Gravatar>Gravatar</a>.</p> </control-group> <control-group label=Password> <input class=form-control type=password ng-model=user.Password autocomplete=off /> </control-group> <control-group label=\"Confirm password\"> <input class=form-control type=password ng-model=view.confirmNewPassword autocomplete=off /> </control-group> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Create user</button> <spin active=isSaving.busy class=spin-static></spin> </div> </div> </form> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 758 */
/***/ function(module, exports) {

	var path = 'areas/configuration/users/views/create_api_key.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-hide=isWorking.busy ng-click=close()>×</button> <h3>Generate new API key</h3> </div> <div class=modal-body> <error-box error=isWorking.error></error-box> <p ng-hide=apiKey>API keys can be used to authenticate with the Octopus Deploy REST API in place of a username and password. Using API keys lets you keep your username and password secret, but the API key itself is still sensitive information that needs to be protected.</p> <div ng-hide=apiKey> <control-group label=Purpose> <input class=\"input input-xlarge form-control\" type=text ng-model=createParams.purpose> <p class=subtle>Record the purpose of this key so that you can revoke it when no longer required.</p> </control-group> </div> <div ng-show=apiKey> <p>Your new API key is:</p> <div class=\"pre thumbprint\" style=cursor:text>{{ apiKey.ApiKey }}</div> <p class=subtle>API keys cannot be retrieved once they are created. Make sure you save this key in a safe place like a password management tool.</p> </div> </div> <div class=modal-footer> <spin active=isWorking.busy></spin> <div ng-hide=apiKey> <button class=\"btn btn-success\" ng-disabled=isWorking.busy ng-click=execute()>Generate new</button> <button class=\"btn btn-default\" ng-disabled=isWorking.busy ng-click=cancel()>Cancel</button> </div> <div ng-show=apiKey> <button class=\"btn btn-default\" ng-click=close()>Close</button> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 759 */
/***/ function(module, exports) {

	var path = 'areas/configuration/users/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/users/{{ user.Id }}\">\r\n        <div class=\"user-image\">\r\n            <avatar model=\"user\"></avatar>\r\n        </div>\r\n        {{ user.DisplayName }}</a></li> </script> <div class=row> <div class=col-sm-9> <div> <div class=\"form-box form-horizontal help-scope\"> <h3>{{ user.DisplayName }}</h3> <div class=\"alert alert-info\" ng-show=user.IsService> <p>For this <strong>service account</strong> to be useful it must belong to one or more <a href=#/configuration/teams>teams</a>, and have one or more API keys associated with it. </p></div> <form ng-submit=save()> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Username> <p class=thumbprint>{{ user.Username }}</p> <p class=help-block>The username that the user authenticates with.</p> </control-group> <control-group label=\"Display name\"> <input class=form-control type=text ng-model=user.DisplayName /> <p class=help-block>The user's name. This does not need to be unique.</p> </control-group> <div ng-hide=user.IsService> <control-group label=\"Email address\"> <input class=form-control type=text ng-model=user.EmailAddress /> <p class=help-block>The user's email address.</p> </control-group> </div> <h4 class=separator>Authentication</h4> <div ng-hide=user.IsRequestor> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=user.IsActive /> This user is active and can log in</label></div> <p class=help-block>Inactive users remain in the database but cannot use the Octopus server.</p> <p class=help-block ng-show=user.IsService>This user is a service account without username/password login rights - only API key login is allowed.</p> </control-group> </div> <div ng-show=user.IsActive> <control-group label=\"API keys\"> <user-api-keys user=user></user-api-keys> </control-group> <div ng-show=user.CanPasswordBeEdited> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=view.showPasswordChange> Change password</label></div> </control-group> <div ng-show=view.showPasswordChange> <control-group label=\"New password\"> <input class=form-control type=password ng-model=user.Password /> </control-group> <control-group label=\"Confirm new password\"> <input class=form-control type=password ng-model=view.confirmNewPassword /> </control-group> </div> </div> </div> <last-modified model=user></last-modified> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </div> </form> </div> </div> </div> <div class=col-sm-3> <div class=other-actions> <div ng-show=\"user.Id && !user.IsRequestor\"> <h3>Delete</h3> <p>Once you delete this user, there is no going back.</p> <delete-button model=user what=user redirect=/configuration/users></delete-button> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 760 */
/***/ function(module, exports) {

	var path = 'areas/configuration/users/views/index.html';
	var html = " <script octo-section=configuration_tools type=text/ng-template> <a class='btn' href=\"#/configuration/users/new\" octo-permission=\"AdministerSystem\">Create user</a>\r\n  <a class='btn btn-success' ng-show=\"canInviteUsers\" href=\"#/configuration/users/invite\" octo-permission=\"UserInvite\">Invite users</a> </script> <div class=\"form-box form-horizontal\"> <h3>Users</h3> <ul class=octo-tiles> <li ng-repeat=\"user in users.Items\"> <div class=octo-list-group> <a href=#/configuration/users/{{user.Id}} class=\"octo-list-group-item user-tile\"> <div class=octo-list-group-item-icon> <avatar model=user></avatar> </div> <div> <h4 class=octo-list-group-item-heading>{{ user.DisplayName | ellipsis:40 }}</h4> <p class=subtle>{{ user.Username | ellipsis:20 }}</p> </div> </a> </div> </li> </ul> <octo-paginator collection=users></octo-paginator> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 761 */
/***/ function(module, exports) {

	var path = 'areas/configuration/users/views/invite.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/users/invite\">Invite</a></li> </script> <script octo-section=configuration_tools type=text/ng-template> <button type=\"button\" ng-show=\"invitations.length\" class='btn' ng-click=\"more()\" octo-permission=\"UserInvite\">Invite more users</button> </script> <div class=\"narrow650 narrow-left\"> <div class=\"form-box form-horizontal help-scope\" ng-hide=invitations.length> <h3>Invite users</h3> <p>Create invitation codes to allow users to register their own accounts on the Octopus Deploy server.</p> <p>Each code can be used at most once, and all codes will expire 48 hours after creation.</p> <div class=form-body> <error-box error=isGenerating.error></error-box> <control-group label=Teams> <ui-select multiple=multiple ng-model=invitation.teams> <ui-select-match placeholder=\"Select Teams\" allow-clear=true>{{$item.Name}}</ui-select-match> <ui-select-choices repeat=\"item in teams | filter:{Name: $select.search} track by item.Id\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> <p class=help-block>Select the teams that the invited users will belong to. At least one team is required.</p> </control-group> <control-group label=Quantity> <input class=\"input form-control\" type=number ng-model=invitation.quantity> <p class=help-block>The number of invitation codes to create.</p> </control-group> <div class=form-actions> <spin active=isGenerating.busy></spin> <button class=\"btn btn-success\" type=button ng-click=generateInvitations() ng-disabled=isGenerating.busy>Create</button> </div> </div> </div> <div ng-show=invitations.length> <h3>Invitations</h3> <p>Please provide the links below to the invited users.</p> <table class=table> <tbody> <tr ng-repeat=\"inv in invitations\"> <td> <a href=\"{{ resolveLink(inv.Links.Register) }}\">{{ resolveLink(inv.Links.Register) }}</a> </td> </tr> </tbody> </table> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 762 */
/***/ function(module, exports) {

	var path = 'areas/configuration/users/views/user_api_keys.html';
	var html = "<div> <octo-paginator collection=userApiKeys page-selected=loadPage></octo-paginator> <p class=\"tutorial tutorial-left\" ng-show=\"userApiKeys && !userApiKeys.Items.length\">There aren't currently any API keys to show.</p> <ul class=\"octo-list-group can-add\"> <li class=octo-list-group-item ng-repeat=\"apiKey in userApiKeys.Items\"> <button class=\"close remove-button\" type=button ng-click=revoke(apiKey)>×</button> <h4 class=octo-list-group-item-heading>{{ apiKey.Purpose || 'General-purpose API key' }}</h4> <p>Created {{ apiKey.Created | momentAgo }}</p> </li> </ul> <button class=\"btn btn-default\" type=button ng-class=\"{ 'octo-list-group-add': userApiKeys.Items.length }\" ng-click=newApiKey()><i class=icon-plus></i> New API key</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 763 */
/***/ function(module, exports) {

	var path = 'areas/configuration/views/configuration_layout.html';
	var html = " <script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration\">Configuration</a></li> </script> <script octo-section=tools type=text/ng-template> <spin active='isSaving.busy'></spin>\r\n    <unsaved-changes-indicator></unsaved-changes-indicator>\r\n    <div octo-placeholder=\"configuration_tools\" style=\"display: inline;\">\r\n    </div> </script> <div> <div class=\"page-body layout-sidebar\"> <div id=sidebar style=display:inherit ng-cloak> <div class=list-group> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'overview'}\" href=#/configuration octo-permission=AdministerSystem>Overview</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'audit'}\" href=#/configuration/audit octo-permission=AdministerSystem,AuditView>Audit</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'backup'}\" href=#/configuration/backup octo-permission=AdministerSystem>Backup</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'certificates'}\" href=#/configuration/certificates octo-permission=AdministerSystem>Certificates</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'diagnostics'}\" href=#/configuration/diagnostics octo-permission=AdministerSystem>Diagnostics</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'features'}\" href=#/configuration/features octo-permission=AdministerSystem>Features</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'license'}\" href=#/configuration/license octo-permission=AdministerSystem>License</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'maintenance'}\" href=#/configuration/maintenance octo-permission=AdministerSystem>Maintenance</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'nodes'}\" href=#/configuration/nodes octo-permission=AdministerSystem>Nodes</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'smtp'}\" href=#/configuration/smtp octo-permission=AdministerSystem>SMTP</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'teams'}\" href=#/configuration/teams octo-permission=AdministerSystem,TeamView>Teams</a> <a class=list-group-item ng-class=\"{active: $root.layout.configTab == 'users'}\" href=#/configuration/users octo-permission=AdministerSystem>Users</a> </div> </div> <div id=content-wrapper ng-cloak> <div id=view-container height-magic> <ui-view></ui-view> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 764 */
/***/ function(module, exports) {

	var path = 'areas/configuration/views/master_key_clippy.html';
	var html = "<div ng-show=\"backup && !backup.IsMasterKeyBackedUp\"> <div class=\"alert alert-warning\"> <octo-clippy> <p class=strong> Hey there! Without a safe copy of your <strong>Octopus Master Key</strong>, it will be impossible to restore backups of your Octopus Deploy database on any other machine. Please <a href=http://g.octopushq.com/SaveMyMasterKey target=_blank>take a copy of your master key</a> and put it in a safe place. </p> <p> <button class=\"btn btn-success\" type=button ng-click=okayIveDoneThis()>OK, I've backed it up, stop reminding me</button> </p> </octo-clippy> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 765 */
/***/ function(module, exports) {

	var path = 'areas/dashboard/views/dashboard.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/\">Dashboard</a></li> </script> <script octo-section=tools type=text/ng-template> <spin active='isLoading.busy'></spin>\r\n  <a ng-if=\"dashboardLoaded\" href=\"#/dashboard/configure\" class=\"btn\" ng-class=\"{'btn-success': dashboardData.IsFiltered, 'btn-link': !dashboardData.IsFiltered}\">\r\n    <span ng-show=\"!dashboardData.IsFiltered\">Configure dashboard</span>\r\n    <span ng-show=\"dashboardData.IsFiltered\"><i class=\"fa fa-filter\"></i> Filtering is on...</span>\r\n  </a> </script> <div ng-show=\"dashboardData.ProjectGroups.length == 0 && !useFilter\"> <div class=\"tutorial tutorial-center\"> <p>Welcome! Your dashboard is empty. <span octo-permission=EnvironmentCreate> <span octo-permission=ProjectCreate>Get started by adding some <a href=#/projects>projects</a> to deploy and <a href=#/environments>environments</a> to deploy them to.</span></span> </p> </div> </div> <div ng-show=useFilter class=form-inline> <select class=form-control ng-model=groupFilter ng-options=\"group.Id as group.Name for group in projectGroups\"> <option value=\"\">All Groups</option> </select> <input class=\"input input-xlarge form-control\" type=text placeholder=\"Project Name\" ng-model=projectFilter>&nbsp; <span ng-show=\"matchCount > projectLimit\" class=\"help-inline text-warning\">{{matchCount}} projects match, only the first {{projectLimit}} are shown, plus any with failing deployments</span> <span ng-show=\"matchCount <= projectLimit && matchCount != 1\" class=\"help-inline text-info\">{{matchCount}} projects match</span> <span ng-show=\"matchCount == 1\" class=\"help-inline text-info\">1 project matches</span> </div> <div ng-show=\"dashboardData.ProjectGroups.length == 0 && useFilter\" class=\"tutorial tutorial-center\"> <p>No projects found </p> </div> <loading-wrapper busy=isLoading once=true> <fastboard dashboard-data=dashboardData></fastboard> </loading-wrapper> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 766 */
/***/ function(module, exports) {

	var path = 'areas/dashboard/views/dashboard_configure.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/\">Dashboard</a></li>\r\n  <li><a href='#/dashboard/configure'>Configure</a></li> </script> <div class=row> <div class=\"narrow750 box-shadow col-sm-12 col-md-12 col-lg-12\"> <help-button></help-button> <h3>Configure your dashboard</h3> <loading-wrapper busy=isLoading> <div class=\"form-box form-horizontal\"> <form ng-submit=save()> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Projects> <div class=radio><label><input type=radio ng-model=radios.isAllProjects value=true> All projects</label></div> <div class=radio><label><input type=radio ng-model=radios.isAllProjects value=false> Only selected projects</label></div> <div class=clearfix ng-show=\"radios.isAllProjects == 'false'\"> <in-or-out options=projects selected-items=configuration.IncludedProjectIds></in-or-out> </div> </control-group> <control-group label=Environments> <div class=radio><label><input type=radio ng-model=radios.isAllEnvironments value=true> All environments</label></div> <div class=radio><label><input type=radio ng-model=radios.isAllEnvironments value=false> Only selected environments</label></div> <div class=clearfix ng-show=\"radios.isAllEnvironments == 'false'\"> <in-or-out options=environments selected-items=configuration.IncludedEnvironmentIds></in-or-out> </div> </control-group> <control-group label=\"Maximum Projects\"> <input class=form-control type=number ng-model=configuration.ProjectLimit min=0 placeholder=50> <p class=help-block> The maximum number of projects to display on the dashboard. Setting this to greater than the default value of 50 may adversely effect performance. Prefer filtered views if you have a large number of projects. </p> </control-group> <control-group label=Tenants octo-feature=IsMultiTenancyEnabled> <div class=clearfix> <advanced-tenant-selector selected-tenants=configuration.IncludedTenantIds selected-tags=configuration.IncludedTenantTags tenant-filter=\"\"> </advanced-tenant-selector> </div> </control-group> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </loading-wrapper> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 767 */
/***/ function(module, exports) {

	var path = 'areas/environments/machinepolicies/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/environments/machinepolicies/new\">Create new</a></li> </script> <loading-wrapper busy=isLoading> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <machine-policy-editor></machine-policy-editor> </div> </div> </div> </div> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 768 */
/***/ function(module, exports) {

	var path = 'areas/environments/machinepolicies/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/environments/machinepolicies/{{ machinePolicy.Id }}\">{{ machinePolicy.Name }}</a></li> </script> <script octo-section=library_tools type=text/ng-template> </script> <loading-wrapper busy=isLoading> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <h3>Machine policy</h3> <machine-policy-editor></machine-policy-editor> </div> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <div octo-permission=MachinePolicyDelete> <h3>Delete</h3> <div ng-if=machinePolicy.IsDefault> <p>You cannot delete the default machine policy.</p> </div> <div ng-if=!machinePolicy.IsDefault> <p>Any machines that belong to this policy will be reassigned to the default machine policy.</p> <p>Once you delete this machine policy, there is no going back.</p> <delete-button model=machinePolicy what=MachinePolicy redirect=/environments/machinepolicies></delete-button> </div> </div> <div ng-if=\"numberOfMachines > 0\" octo-permission=MachinePolicyView> <h3>Currently in use</h3> <div> <p>This policy is being used by {{numberOfMachines}} {{numberOfMachines == 1 ? 'machine' : 'machines'}}.</p> <div class=\"octo-list-group narrow-left narrow650 margin-bottom-20\"> <a class=\"octo-list-group-item clickable\" href=#/machines/{{machine.Id}} ng-repeat=\"machine in machinesUsingPolicy.Items\"> <h4 class=octo-list-group-item-heading>{{ machine.Name }}</h4> </a> </div> <octo-paginator collection=machinesUsingPolicy></octo-paginator> </div> </div> <div ng-if=\"numberOfMachines == 0\" octo-permission=MachinePolicyView> <h3>Not currently in use</h3> <div>This policy is not currently used by any machines.</div> </div> </div> </div> </loading-wrapper> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 769 */
/***/ function(module, exports) {

	var path = 'areas/environments/machinepolicies/views/editor.html';
	var html = "<form ng-submit=save() name=machinePolicyForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <control-group label=Name> <input class=form-control type=text ng-model=machinePolicy.Name /> <p class=help-block>A short, memorable, unique name for this machine policy.</p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=machinePolicy.Description markitup rows=7></textarea> <p class=help-block>This summary will appear on the machine policy overview page.</p> </control-group> <h4 class=separator>Health check</h4> <control-group label=\"Time between checks\" class=form-group-inline> <input class=\"form-control input-small\" type=number ng-model=healthCheckInterval.Days min=0 max=99 /> <span>day{{ healthCheckInterval == null || healthCheckInterval.Days == 0 || healthCheckInterval.Days > 1 ? \"s\" : \"\"}}</span> <input class=\"form-control input-small\" type=number ng-model=healthCheckInterval.Hours min=0 max=23 /> <span>hour{{ healthCheckInterval == null || healthCheckInterval.Hours == 0 || healthCheckInterval.Hours > 1 ? \"s\" : \"\"}}</span> <input class=\"form-control input-small\" type=number ng-model=healthCheckInterval.Minutes min=0 max=59 /> <span>minute{{ healthCheckInterval == null || healthCheckInterval.Minutes == 0 || healthCheckInterval.Minutes > 1 ? \"s\" : \"\"}}</span> </control-group> <h4 class=separator>Health check for Tentacle endpoints</h4> <div ng-if=!machinePolicy.IsDefault> <control-group label=\"\"> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.RunType ng-value=\"'InheritFromDefault'\"/> Inherit from default machine policy <strong>(default)</strong></label></div> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.RunType ng-value=\"'Inline'\"/> Use custom script</label></div> </control-group> </div> <div ng-show=\"machinePolicy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.RunType === 'Inline'\"> <h4>Powershell script</h4> <p>Please see the <a href=http://docs.octopusdeploy.com/display/OD/Machine+Policies target=_blank>documentation on machine policy scripting</a></p> <script-editor id=scriptEditor syntax=\"'PowerShell'\" syntax-filter=\"'PowerShell'\" syntax-selection-disabled=true no-variables=true body=machinePolicy.MachineHealthCheckPolicy.TentacleEndpointHealthCheckPolicy.ScriptBody machine-policy-id=machinePolicy.Id local-names=localNames></script-editor> </div> <h4 class=separator>Health check for SSH endpoints</h4> <div ng-if=!machinePolicy.IsDefault> <control-group label=\"\"> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType ng-value=\"'InheritFromDefault'\"/> Inherit from default machine policy <strong>(default)</strong></label></div> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType ng-value=\"'Inline'\"/> Use custom script</label></div> </control-group> </div> <div ng-show=\"machinePolicy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.RunType === 'Inline'\"> <h4>Bash script</h4> <p>Please see the <a href=http://docs.octopusdeploy.com/display/OD/Machine+Policies target=_blank>documentation on machine policy scripting</a></p> <script-editor id=scriptEditor syntax=\"'Bash'\" syntax-filter=\"'Bash'\" syntax-selection-disabled=true no-variables=true body=machinePolicy.MachineHealthCheckPolicy.SshEndpointHealthCheckPolicy.ScriptBody machine-policy-id=machinePolicy.Id local-names=localNames></script-editor> </div> <h4 class=separator>Machine connectivity</h4> <control-group label=\"During health checks\"> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineConnectivityPolicy.MachineConnectivityBehavior ng-value=\"'ExpectedToBeOnline'\"/> Unavailable machines cause health checks to fail <strong>(default)</strong></label></div> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineConnectivityPolicy.MachineConnectivityBehavior ng-value=\"'MayBeOfflineAndCanBeSkipped'\"/> Unavailable machines will not cause health checks to fail</label></div> </control-group> <p class=\"alert alert-info\" ng-show=\"machinePolicy.MachineConnectivityPolicy.MachineConnectivityBehavior === 'MayBeOfflineAndCanBeSkipped'\">Health checks will succeed without warning if a machine in this policy is unavailable.</p> <h4 class=separator>Machine updates</h4> <control-group label=\"Calamari updates\"> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineUpdatePolicy.CalamariUpdateBehavior ng-value=\"'UpdateOnDeployment'\"/> Automatically update Calamari when a machine is involved in a deployment <strong>(default)</strong></label></div> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineUpdatePolicy.CalamariUpdateBehavior ng-value=\"'UpdateOnNewMachine'\"/> Automatically update Calamari the first time a machine comes online and then when it is involved in a deployment</label></div> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineUpdatePolicy.CalamariUpdateBehavior ng-value=\"'UpdateAlways'\"> Always keep Calamari up to date</label></div> </control-group> <control-group label=\"Tentacle updates\"> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineUpdatePolicy.TentacleUpdateBehavior ng-value=\"'NeverUpdate'\"/> Do not update Tentacle <strong>(default)</strong></label></div> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineUpdatePolicy.TentacleUpdateBehavior ng-value=\"'Update'\"/> Automatically update Tentacle</label></div> </control-group> <h4 class=separator>Cleaning up unavailable machines</h4> <control-group label=\"\"> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineCleanupPolicy.DeleteMachinesBehavior ng-value=\"'DoNotDelete'\"/> Do not delete machines automatically <strong>(default)</strong></label></div> <div class=radio><label><input type=radio ng-model=machinePolicy.MachineCleanupPolicy.DeleteMachinesBehavior ng-value=\"'DeleteUnavailableMachines'\"/> Automatically delete unavailable machines</label></div> </control-group> <control-group label=\"Time unavailable\" class=form-group-inline ng-show=\"machinePolicy.MachineCleanupPolicy.DeleteMachinesBehavior === 'DeleteUnavailableMachines'\"> <input class=\"form-control input-small\" type=number ng-model=deleteMachinesElapsedTimeSpan.Days min=0 max=99 /> <span>day{{ deleteMachinesElapsedTimeSpan == null || deleteMachinesElapsedTimeSpan.Days == 0 || deleteMachinesElapsedTimeSpan.Days > 1 ? \"s\" : \"\"}}</span> <input class=\"form-control input-small\" type=number ng-model=deleteMachinesElapsedTimeSpan.Hours min=0 max=23 /> <span>hour{{ deleteMachinesElapsedTimeSpan == null || deleteMachinesElapsedTimeSpan.Hours == 0 || deleteMachinesElapsedTimeSpan.Hours > 1 ? \"s\" : \"\"}}</span> <input class=\"form-control input-small\" type=number ng-model=deleteMachinesElapsedTimeSpan.Minutes min=0 max=59 /> <span>minute{{ deleteMachinesElapsedTimeSpan == null || deleteMachinesElapsedTimeSpan.Minutes == 0 || deleteMachinesElapsedTimeSpan.Minutes > 1 ? \"s\" : \"\"}}</span> </control-group> <p class=\"alert alert-warning\" ng-show=\"machinePolicy.MachineCleanupPolicy.DeleteMachinesBehavior === 'DeleteUnavailableMachines'\">Please be aware this will cause unavailable machines to be deleted during health checks if they do not become available within this time.</p> <last-modified model=machinePolicy></last-modified> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 770 */
/***/ function(module, exports) {

	var path = 'areas/environments/machinepolicies/views/index.html';
	var html = "<script octo-section=tools type=text/ng-template> <a octo-permission=\"MachinePolicyCreate\" wildcard class='btn btn-success' href=\"#/environments/machinepolicies/new\">Add machine policy</a> </script> <loading-wrapper busy=isLoading> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <h3>Machine policies</h3> <p>Machine policies allow you to define behaviors that apply to Tentacle and SSH endpoints.</p> <div ng-show=\"machinePolicies.length > 0\"> <div class=\"octo-list-group narrow-left narrow650\"> <a class=\"octo-list-group-item clickable\" href=#/environments/machinepolicies/{{machinePolicy.Id}} ng-repeat=\"machinePolicy in machinePolicies track by machinePolicy.Id\"> <h4 class=octo-list-group-item-heading>{{ machinePolicy.Name }}&nbsp;&nbsp;<span ng-if=machinePolicy.IsDefault class=\"label label-info\" ng-class=label>default</span></h4> <machine-policy-summary machine-policy=machinePolicy></machine-policy-summary> </a> </div> </div> </div> </div> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 771 */
/***/ function(module, exports) {

	var path = 'areas/environments/machinepolicies/views/preview.html';
	var html = "<div> <div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Machine Policy Preview</h3> </div> <div class=modal-body> <control-group label=Environment> <select class=\"input-xlarge form-control\" fix-ie-select ng-model=viewOptions.environment ng-options=\"e as e.Name for e in environments\" ng-change=refreshPreview()></select> </control-group> </div> <table ng-if=machinePolicyPreviews class=\"table table-striped table-bordered\"> <thead> <tr> <th>Machine</th> <th>Roles</th> <th>Auto-deploy</th> <th>Skip</th> </tr> </thead> <tbody> <tr ng-repeat=\"machinePolicyPreview in machinePolicyPreviews\"> <td>{{ machinePolicyPreview.machine.Name }}</td> <td><span ng-repeat=\"role in machinePolicyPreview.machine.Roles\" class=\"label truncate label-default\">{{role}}</span></td> <td ng-class=\"machinePolicyPreview.autoDeployPreview.canAutoDeploy ? 'success' : 'danger'\">{{ machinePolicyPreview.autoDeployPreview.why }}</td> <td ng-class=\"machinePolicyPreview.skipPreview.canSkip ? 'success' : 'danger'\">{{ machinePolicyPreview.skipPreview.why }}</td> </tr> </tbody> </table> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 772 */
/***/ function(module, exports) {

	var path = 'areas/environments/machines/discover.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/machines/new\">Create New</a></li> </script> <div class=page-machine-discover> <form ng-submit=discover() class=\"form-box form-horizontal\"> <h3 class=no-margin-top>New deployment target</h3> <loading-wrapper busy=isLoading> <error-box error=isDiscovering.error></error-box> <alerts list=alerts></alerts> <octo-clippy ng-show=isDiscovering.error> <p>It looks like you're having trouble connecting to this deployment target. If you're using a Tentacle, make sure all firewalls between the Octopus server and the Tentacle agent allow TCP traffic on the specified port below. Our <a href=http://g.octopushq.com/TentacleTroubleshooting>Tentacle troubleshooting guide</a> has more information on resolving connectivity issues.</p> </octo-clippy> <div class=form-body> <div class=\"form-group form-group-narrow\"> <label class=\"col-sm-3 control-label padding-sm-vr\">Target type</label> <div class=\"col-sm-9 padding-sm-hr\"> <label ng-repeat=\"cs in communicationStyles\" class=\"target-type radio padding-xs-vr\"> <div> <input type=radio ng-model=endpoint.communicationStyle value={{cs.value}}> <img alt={{machine.StatusSummary}} title={{machine.StatusSummary}} ng-src=\"{{machineImages('./Server-Healthy.' + cs.value + '.png')}}\"> </div> <div> <strong>{{ cs.label }}</strong> <br/> <span class=help-block style=font-weight:400 ng-bind-html=cs.helpHtml></span> </div> </label> <p class=help-block>Learn more about <a href=http://g.octopushq.com/DeploymentTargets target=_blank>deployment targets</a>.</p> </div> </div> <div ng-if=endpoint.isListeningTentacle()> <hr/> <div> <div class=\"margin-top-bottom-20 pad-left-30\"> <p> The Tentacle agent will need to be installed on the target server: </p> <ul> <li> <a href=http://download.octopusdeploy.com/octopus/Octopus.Tentacle.{{$root.octopusVersion}}.msi> 32-bit/x86 installer </a> </li> <li> <a href=http://download.octopusdeploy.com/octopus/Octopus.Tentacle.{{$root.octopusVersion}}-x64.msi> 64-bit/x64 installer </a> </li> </ul> <p> During setup, configure the Tentacle in <strong>listening</strong> mode, and ensure the Tentacle is configured to trust an Octopus Server with the thumbprint: <span class=thumbprint>{{ serverThumbprint }}</span> </p> <p>Learn more about <a href=http://g.octopushq.com/ListeningTentacle>configuring listening Tentacles</a>.</p> </div> </div> </div> <div ng-if=endpoint.isPollingTentacle()> <hr/> <div> <div class=\"margin-top-bottom-20 pad-left-30\"> <p> The Tentacle agent will need to be installed on the target server: </p> <ul> <li> <a href=http://download.octopusdeploy.com/octopus/Octopus.Tentacle.{{$root.octopusVersion}}.msi>32-bit/x86 installer</a></li> <li> <a href=http://download.octopusdeploy.com/octopus/Octopus.Tentacle.{{$root.octopusVersion}}-x64.msi>64-bit/x64 installer</a></li> </ul> <p> During setup, configure the Tentacle in <strong>polling</strong> mode. The wizard will then ask for your credentials to connect to the Octopus server and establish the connection. </p> <p>Learn more about <a href=http://g.octopushq.com/PollingTentacle>configuring polling Tentacles</a>.</p> </div> </div> </div> <div ng-if=endpoint.canDiscover()> <hr/> <control-group label=Hostname> <input class=form-control id=hostname type=text ng-model=endpoint.host focus-me/> <div class=help-block>The DNS name of the machine to discover. Examples: <br/> <ul> <li><code>10.0.0.1</code></li> <li><code>web01.local</code></li> <li><code>web01.mynetwork.com</code></li> </ul></div> </control-group> <control-group label=Port> <input id=port class=form-control type=number ng-model=endpoint.port placeholder={{endpoint.defaultPort()}}> <p class=help-block>The port on which the endpoint is listening.</p> </control-group> <div ng-if=endpoint.isListeningTentacle()> <control-group label=Proxy> <div class=checkbox><label><input type=checkbox ng-model=view.machineUseProxy ng-change=useProxyChanged()> Use a proxy</label></div> <p class=help-block>Connect to this deployment target through a proxy server.</p> </control-group> <control-group ng-show=view.machineUseProxy> <select class=form-control ng-model=endpoint.ProxyId ng-options=\"proxy.Id as proxy.Name for proxy in proxies\"> </select> <p class=help-block>The proxy to use to communicate with this deployment target.</p> </control-group> </div> </div> </div> </loading-wrapper> <div class=form-actions> <div class=\"\" ng-show=\"endpoint.canDiscover() || (endpoint.communicationStyle && !endpoint.isPollingTentacle())\"> <button class=\"btn btn-success\" type=submit ng-hide=\"endpoint.isPollingTentacle() || !endpoint.communicationStyle\"> {{endpoint.canDiscover() ? \"Discover\" : \"Next\"}} </button> <a class=\"btn btn-link btn-default\" ng-if=endpoint.canDiscover() href=\"#/machines/new/manual?environment={{environmentId}}&type={{endpoint.communicationStyle}}\">Enter details manually</a> <spin active=isDiscovering.busy class=spin-static></spin> </div> </div> </form> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 773 */
/***/ function(module, exports) {

	var path = 'areas/environments/machines/edit_machine.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-hide=\"machine.Id || isLoading.busy\"><a href=\"#/machines/new\">Create New</a></li> </script> <div class=row> <div class=col-xs-9> <form ng-submit=save() class=form-horizontal> <h3>Deployment Target settings</h3> <loading-wrapper busy=isLoading> <div ng-if=!machine.IsHosted> <error-box error=isSaving.error></error-box> <div class=\"alert alert-warning\" ng-show=\"machine.Endpoint.CommunicationStyle == 'AzureWebApp' || machine.Endpoint.CommunicationStyle == 'AzureCloudService'\"> <p>Azure targets are in the process of being deprecated. Please consider <a class=alert-link href=http://g.octopushq.com/MigrateAzureTargets target=_blank>migrating to the equivalent Azure Steps</a>.</p> <p>The ability to create new Azure Targets was removed in Octopus Deploy 3.4. The ability to deploy to existing Targets will be removed in the future.</p> <p>Read our blog post for the <a class=alert-link href=https://octopus.com/blog/azure-changes target=_blank>reasoning.</a></p> </div> <control-group label=\"Display name\"> <input id=name class=form-control type=text ng-model=machine.Name> <p class=help-block>A unique, informational name for the deployment target.</p> </control-group> <div ng-show=machine.Id> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=machine.IsDisabled> Disable this deployment target</label></div> <p class=help-block>Disable a deployment target to prevent releases or deployments being made to it.</p> </control-group> </div> <h4 class=separator>Deployment</h4> <control-group label=Environments> <select-environments ng-model=teamSensitiveValues.EnvironmentIds available=environments multiple=true placeholder=\"'Select Environments'\"></select-environments> <p class=help-block>Specify at least one environment for the deployment target.</p> </control-group> <control-group label=Roles> <ui-select ng-model=machine.Roles multiple=multiple tagging tagging-label=\"(custom 'new' role)\" class=form-control> <ui-select-match placeholder=\"Select roles\" allow-clear=true>{{$item}} </ui-select-match> <ui-select-choices repeat=\"item in availableRoles | filter:$select.search\"> <span ng-bind-html=\"item | highlight: $select.search\"></span> </ui-select-choices> </ui-select> <p class=help-block>Specify at least one role that this deployment target will provide.</p> </control-group> <div ng-hide=\"machine.Endpoint.CommunicationStyle === 'None'\"> <control-group label=Policy ng-show=\"machine.Id !== undefined || machinePolicies.length > 1\" ng-if=\"machine.Endpoint.CommunicationStyle === 'TentaclePassive' || machine.Endpoint.CommunicationStyle === 'TentacleActive' || machine.Endpoint.CommunicationStyle === 'Ssh'\"> <select class=form-control ng-model=machine.MachinePolicyId ng-options=\"machinePolicy.Id as machinePolicy.Name for machinePolicy in machinePolicies\" ng-change=changed()></select> <machine-policy-summary machine-policy=machinePolicy hide-description=true></machine-policy-summary> </control-group> <h4 class=separator>Communication</h4> <control-group label=Style> <select id=style class=form-control ng-disabled=machine.Endpoint.CommunicationStyle title=\"{{machine.Endpoint.CommunicationStyle ? 'This value cannot be modified once the machine has been added. To change communication styles, delete this machine and then create a new one with the desired communication style.' : ''}}\" ng-model=machine.Endpoint.CommunicationStyle ng-change=resetEndpoint() ng-options=\"cs.value as cs.label for cs in communicationStyles\"></select> <p class=help-block>Choose alternative styles when the Tentacle agent can't be installed on the remote machine.</p> </control-group> <div ng-switch=machine.Endpoint.CommunicationStyle> <tentacle-active-endpoint endpoint=machine.Endpoint ng-switch-when=TentacleActive></tentacle-active-endpoint> <tentacle-passive-endpoint endpoint=machine.Endpoint ng-switch-when=TentaclePassive></tentacle-passive-endpoint> <ssh-endpoint endpoint=machine.Endpoint ng-switch-when=Ssh></ssh-endpoint> <offline-drop-endpoint endpoint=machine.Endpoint ng-switch-when=OfflineDrop></offline-drop-endpoint> <azure-web-app-endpoint endpoint=machine.Endpoint ng-switch-when=AzureWebApp></azure-web-app-endpoint> <ftp-endpoint endpoint=machine.Endpoint ng-switch-when=Ftp></ftp-endpoint> <azure-cloud-service-endpoint endpoint=machine.Endpoint ng-switch-when=AzureCloudService></azure-cloud-service-endpoint> </div> </div> <div octo-feature=IsMultiTenancyEnabled> <h4 class=separator>Tenants</h4> <advanced-tenant-selector apply-border=false available-tenants=availableTenants selected-tenants=teamSensitiveValues.TenantIds selected-tags=machine.TenantTags> </advanced-tenant-selector> <div class=help-block> The tenant filter defines which deployments should use this deployment target. <ul> <li> By defining a filter this will be considered as a <strong>tenanted deployment target</strong>, and only included in tenanted deployments for tenants that match the filter. </li> <li> By leaving the filter empty this will be considered as an <strong>un-tenanted deployment target</strong>, and only included in un-tenanted deployments. </li> </ul> For more information on designing a multi-tenant hosting model refer to our <a href=http://g.octopushq.com/MultiTenantHostingModel target=_blank>documentation</a>. </div> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </div> <div ng-if=machine.IsHosted> <control-group label=\"Display name\"> <input class=form-control readonly=readonly type=text ng-model=machine.Name> <p class=help-block>A unique, informational name for the deployment target.</p> </control-group> <h4 class=separator>About</h4> <p>This deployment target represents the Octopus Server itself and is used to facilitate communication to non-Tentacle endpoints.</p> </div> </loading-wrapper> </form> </div> <div class=col-xs-3> <div class=other-actions ng-show=\"machine.Id && !machine.IsHosted\" octo-permission=MachineDelete octo-environment=\"'*'\"> <div> <h3>Delete</h3> <p>Once you delete this deployment target, there is no going back. The target will be permanently deleted.</p> <delete-button model=machine what=machine redirect=/environments></delete-button> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 774 */
/***/ function(module, exports) {

	var path = 'areas/environments/machines/machine_connection.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-show=\"machine\"><a href=\"#/machines/{{ machine.Id }}/connection\">Connectivity</a></li> </script> <script octo-section=machine_tools type=text/ng-template> <spin active=\"isLoading.busy\"></spin>\r\n    <button type=\"button\" class=\"btn\" ng-click=\"checkHealth()\">Check health</button> </script> <div class=container-fluid> <h3>Connectivity</h3> <loading-wrapper busy=isLoading once=true> <div ng-show=\"machine.Endpoint.CommunicationStyle === 'None'\" class=\"alert alert-success\"> <strong>Healthy</strong> <p>Cloud Regions are always healthy. Hooray!</p> </div> <div ng-show=\"status && machine.Endpoint.CommunicationStyle !== 'None'\" ng-switch=status.Status> <div class=\"alert alert-success\" ng-switch-when=Healthy> <strong>Healthy</strong> <p>The last health check completed successfully</p> <p class=small>Last health check {{ status.LastChecked | momentAgo }}</p> </div> <div class=\"alert alert-danger\" ng-switch-when=Unhealthy> <strong>Unhealthy</strong> <p>The last health check encountered errors</p> <p class=small>Last health check {{ status.LastChecked | momentAgo }}</p> </div> <div class=\"alert alert-warning\" ng-switch-when=HasWarnings> <strong>Healthy with warnings</strong> <p>The last health check encountered warnings</p> <p class=small>Last health check {{ status.LastChecked | momentAgo }}</p> </div> <div class=\"alert alert-danger\" ng-switch-when=Unavailable> <strong>Unavailable</strong> <p class=small>Last health check {{ status.LastChecked | momentAgo }}</p> </div> <div class=\"alert alert-warning\" ng-switch-when=Unknown> <strong>Unknown</strong> <p>This deployment target was just added, and a health check has not been performed.</p> </div> </div> <form class=form-horizontal> <div ng-if=\"tentacleDetails && tentacleDetails.Version\"> <h4 class=separator>Tentacle</h4> <control-group label=\"Current Version\"> <div style=padding-top:7px class=text-bold ng-class=\"{'text-warning': tentacleDetails.UpgradeSuggested && !tentacleDetails.UpgradeRequired, 'text-danger': tentacleDetails.UpgradeRequired }\"> {{ tentacleDetails.Version }} <span ng-if=\"tentacleDetails.UpgradeSuggested && !tentacleDetails.UpgradeRequired\">(upgrade available)</span> <span ng-if=tentacleDetails.UpgradeRequired>(upgrade required)</span> </div> </control-group> <loading-wrapper busy=isSaving> <control-group ng-if=tentacleDetails.UpgradeSuggested> <button class=\"btn btn-med btn-labeled btn\" ng-disabled=tentacleDetails.UpgradeLocked ng-click=upgradeTentacle()> <span class=\"btn-label icon fa fa-upload\"></span>Upgrade To Latest </button> </control-group> <control-group> <button class=\"btn btn-med btn-labeled btn-warning\" ng-click=lockVersion(false) ng-if=tentacleDetails.UpgradeLocked> <span class=\"btn-label icon fa fa-unlock\"></span>Unlock Current Version </button> <button class=\"btn btn-med btn-labeled\" ng-click=lockVersion(true) ng-if=!tentacleDetails.UpgradeLocked> <span class=\"btn-label icon fa fa-lock\"></span>Lock Current Version </button> <p class=help-block>Ensures this Tentacle does not get updated past currently installed version or get prompted when newer versions are available.</p> </control-group> </loading-wrapper> </div> <div ng-show=\"status.Logs.length > 0\"> <h4 class=separator>Last Health Check Logs</h4> <log-line detail=true event=log full-date=true ng-repeat=\"log in status.Logs\"></log-line> </div> </form> </loading-wrapper> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 775 */
/***/ function(module, exports) {

	var path = 'areas/environments/machines/machine_deployments.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-show=\"machine\"><a href=\"#/machines/{{ machine.Id }}/deployments\">Deployments</a></li> </script> <script octo-section=machine_tools type=text/ng-template> <spin active=\"isLoading.busy\"></spin> </script> <div class=container-fluid> <h3>Deployment History</h3> <loading-wrapper busy=isLoading once=true> <div ng-show=\"tasks.Items.length == 0\">This deployment target has not been involved in any deployments.</div> <div ng-if=\"tasks.Items.length > 0\" class=task-list> <a class=task href=\"#/tasks/{{ task.Id }}\" ng-repeat=\"task in tasks.Items\"> <task-status task=task pop-direction=right></task-status> <div class=details> <span class=title>{{task.Description}}</span> <span class=date>{{ task.QueueTime | moment }}</span> </div> </a> <octo-paginator collection=tasks page-selected=loadPage></octo-paginator> </div> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 776 */
/***/ function(module, exports) {

	var path = 'areas/environments/machines/machine_events.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-show=\"machine\"><a href=\"#/machines/{{ machine.Id }}/deployments\">Events</a></li> </script> <script octo-section=machine_tools type=text/ng-template> <spin active=\"isLoading.busy\"></spin> </script> <div class=container-fluid> <h3>Event History</h3> <loading-wrapper busy=isLoading once=true> <div ng-show=\"events.Items.length == 0\">This deployment has no events.</div> <div ng-if=\"events.Items.length > 0\"> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th style=width:150px>Occurred</th> <th>Description</th> </tr> </thead> <tbody> <tr ng-repeat=\"event in events.Items\"> <td class=date><span title=\"{{ event.Occurred | moment }}\">{{ event.Occurred | momentAgo }}</span> </td> <td>{{event.Message}}</td> </tr> </tbody> </table> <octo-paginator collection=events page-selected=loadPage></octo-paginator> </div> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 777 */
/***/ function(module, exports) {

	var path = 'areas/environments/machines/machine_layout.html';
	var html = " <script octo-section=breadcrumbs type=text/ng-template> <li ng-show=\"machine\">\r\n            <a href=\"#/machines/{{ machine.Id }}\">\r\n                <machine-status machine=\"machine\" height=\"24px\" ng-if=\"machine\"></machine-status>\r\n                {{ machine.Name }}\r\n            </a>\r\n        </li> </script> <script octo-section=tools type=text/ng-template> <div octo-placeholder=\"machine_tools\" style=\"display: inline;\">\r\n        </div> </script> <div> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li class=active ng-hide=machineId> <a>Settings</a> </li> <li ng-show=machineId ng-class=\"{active: $root.layout.machineTab == 'settings'}\"> <a href=#/machines/{{machineId}}>Settings</a> </li> <li ng-show=machineId ng-class=\"{active: $root.layout.machineTab == 'connection'}\"> <a href=#/machines/{{machineId}}/connection>Connectivity</a> </li> <li ng-show=machineId ng-class=\"{active: $root.layout.machineTab == 'deployments'}\"> <a href=#/machines/{{machineId}}/deployments>Deployments</a> </li> <li octo-permission=EventView ng-show=machineId ng-class=\"{active: $root.layout.machineTab == 'events'}\"> <a href=#/machines/{{machineId}}/events>Events</a> </li> </ul> <ui-view></ui-view> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 778 */
/***/ function(module, exports) {

	var path = 'areas/environments/machines/machine_policy_summary.html';
	var html = "<div class=machine-policy-summary> <markdown ng-hide=hideDescription text=machinePolicy.Description></markdown> <div class=row> <div class=\"col-md-5 machine-policy-summary-label\"><i>Health check interval</i></div> <div class=col-md-7><span ng-bind-html=healthCheckIntervalHtml></span></div> </div> <div class=row> <div class=\"col-md-5 machine-policy-summary-label\"><i>Health check (Tentacle endpoints)</i></div> <div class=col-md-7><span ng-bind-html=tentacleEndpointHealthCheckHtml></span></div> </div> <div class=row> <div class=\"col-md-5 machine-policy-summary-label\"><i>Health check (SSH endpoints)</i></div> <div class=col-md-7><span ng-bind-html=sshEndpointHealthCheckHtml></span></div> </div> <div class=row> <div class=\"col-md-5 machine-policy-summary-label\"><i>Machine connectivity</i></div> <div class=col-md-7><span ng-bind-html=machineConnectivityHtml></span></div> </div> <div class=row> <div class=\"col-md-5 machine-policy-summary-label\"><i>Calamari Machine updates</i></div> <div class=col-md-7><span ng-bind-html=machineCalamariUpdatesHtml></span></div> </div> <div class=row> <div class=\"col-md-5 machine-policy-summary-label\"><i>Tentacle Machine updates</i></div> <div class=col-md-7><span ng-bind-html=machineTentacleUpdatesHtml></span></div> </div> <div class=row> <div class=\"col-md-5 machine-policy-summary-label\"><i>Clean up</i></div> <div class=col-md-7><span ng-bind-html=cleaningUpOfflineHtml></span></div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 779 */
/***/ function(module, exports) {

	var path = 'areas/environments/proxies/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-hide=\"proxy.Id\"><a href=\"#/environments/proxies/new\">Create New</a></li>\r\n    <li ng-show=\"proxy.Id\"><a href=\"#/environments/proxies/{{ proxy.Id }}\">{{ proxy.Name }}</a></li> </script> <script octo-section=tools type=text/ng-template> </script> <div class=row> <div class=col-sm-9> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <form name=smtpForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Name> <input class=form-control type=text ng-model=proxy.Name> <p class=help-block>A short, memorable, unique name for this Proxy. Example: DMZ Proxy.</p> </control-group> <control-group label=\"Proxy Host\"> <input class=\"input-xlarge form-control\" type=text ng-model=proxy.Host> <div class=help-block>DNS hostname of the Proxy server. Examples: <br/> <ul> <li><code>10.0.0.1</code></li> <li><code>web01.local</code></li> <li><code>web01.mynetwork.com</code></li> </ul></div> <div class=\"alert alert-info\"> Octopus only supports the use of HTTP proxies, there is currently no support for SOCKS proxies. </div> </control-group> <control-group label=\"Proxy Port\"> <input class=\"input-small form-control\" type=text ng-model=proxy.Port> <p class=help-block>The TCP port of the Proxy server.</p> </control-group> <div ng-show=view.hasExistingPassword> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=view.showPasswordChange ng-disabled=view.showPasswordChange> Change credentials</label></div> </control-group> </div> <div id=credentials ng-show=view.showPasswordChange> <h4 class=separator>Credentials</h4> <p class=subtle>Leave the following blank if your Proxy server does not require authentication.</p> <control-group label=\"Proxy Login\"> <input class=form-control type=text ng-model=proxy.Username> </control-group> <control-group label=\"Proxy Password\"> <sensitive-input model=proxy.Password id=Password></sensitive-input> </control-group> </div> <last-modified model=feed></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy ng-click=save()>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </div> <div class=\"other-actions col-sm-3\"> <div octo-permission=ProxyDelete ng-show=proxy.Id> <h3>Delete</h3> <p>Deleting this proxy will remove it from all machines that are using it.</p> <delete-button model=proxy what=proxy redirect=/environments/proxies></delete-button> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 780 */
/***/ function(module, exports) {

	var path = 'areas/environments/proxies/views/index.html';
	var html = "<script octo-section=tools type=text/ng-template> <a class='btn btn-success' href=\"#/environments/proxies/new\">Add proxy</a> </script> <div> <h3>Proxies</h3> <p>Octopus can talk to deployment targets through a proxy. Create proxies here and then configure each deployment target that needs a proxy.</p> <div class=\"octo-list-group narrow-left narrow650\"> <a class=octo-list-group-item href=#/environments/proxies/{{proxy.Id}} ng-repeat=\"proxy in proxies.Items\"> <h4 class=octo-list-group-item-heading>{{ proxy.Name }}</h4> </a> </div> <octo-paginator collection=proxies></octo-paginator> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 781 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-if=\"!environment.Id\"><a href='#/environments/new'>Create New</a></li>\r\n    <li ng-if=\"environment.Id\"><a href=\"#/environments/{{ environment.Id }}\">{{ environment.Name }}</a></li> </script> <div class=row> <div class=col-sm-12> <form ng-submit=save() class=\"form-box form-horizontal\"> <help-button></help-button> <h3 class=no-margin-top ng-if=!environment.Id ng-cloak>Create an environment</h3> <h3 class=no-margin-top ng-if=environment.Id>Environment settings</h3> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Name> <input type=text class=form-control id=Name placeholder=\"Environment Name\" ng-model=environment.Name /> </control-group> <control-group label=Description> <textarea class=form-control id=Description ng-model=environment.Description markitup rows=7></textarea> </control-group> <control-group label=\"\"> <div class=checkbox> <label class=\"\"> <input type=checkbox id=ckGuidedFailure ng-model=environment.UseGuidedFailure /> Use guided failure mode by default</label> </div> <p class=help-block>If guided failure is enabled for an environment, Octopus Deploy will prompt for user intervention if a deployment fails in the environment.</p> </control-group> <last-modified model=environment></last-modified> </div> <div class=form-actions ng-hide=signInAsGuest> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> <a href class=\"btn delete-button pull-right\" title=Delete octo-permission=EnvironmentDelete ng-show=environment ng-click=deleteEnvironment()>Delete</a> </div> </form> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 782 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/azure_cloud_service_endpoint.html';
	var html = "<div> <control-group label=Account> <account-selector endpoint=endpoint type=AzureSubscription></account-selector> </control-group> <azure-cloud-service-selector-deprecated endpoint=endpoint></azure-cloud-service-selector-deprecated> <h4 class=separator>Deployment</h4> <control-group label=Slot> <select ng-model=endpoint.Slot class=form-control required id=slot> <option>Staging</option> <option>Production</option> </select> <p class=help-block>Usually <em>Production</em> or <em>Staging</em>.</p> </control-group> <control-group label=Swap> <label class=radio><input type=radio ng-model=endpoint.SwapIfPossible ng-value=false> Always deploy</label> <label class=radio><input type=radio ng-model=endpoint.SwapIfPossible ng-value=true> Swap staging to production if possible</label> <p class=help-block> Azure allows staging and production deployments to be swapped, by switching virtual IP addresses. When deploying to production, Octopus can detect whether the current staging deployment can be swapped, and if so, it can do a swap rather than a new deployment. </p> </control-group> <control-group label=\"Instance count\"> <label class=radio><input type=radio ng-model=endpoint.UseCurrentInstanceCount ng-value=true> Use the instance count from the current Azure deployment</label> <label class=radio><input type=radio ng-model=endpoint.UseCurrentInstanceCount ng-value=false> Use the instance count defined in the service configuration XML file</label> <p class=help-block> If you have previously scaled your service by changing the number of instances using the Azure management portal, Octopus can retrieve these values and use them in the deployment, so that the instance count remains unchanged. </p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 783 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/azure_cloud_service_selector.html';
	var html = "<div> <control-group label=\"Cloud service\"> <loading-wrapper busy=vm.isLoading> <ui-select ng-model=vm.selectedCloudService ng-change=vm.changed() append-to-body=true> <ui-select-match placeholder=\"Select Cloud Service\" allow-clear=true>{{$select.selected.Name}} <i>- {{$select.selected.Location}}</i></ui-select-match> <ui-select-choices repeat=\"item in vm.cloudServices | filter:{Name: $select.search} track by item.Name\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> <i>- {{item.Location}}</i> </ui-select-choices> </ui-select> </loading-wrapper> <p class=help-block>The name of the cloud service to which files will be deployed.</p> </control-group> <control-group label=\"Storage account\"> <loading-wrapper busy=vm.isLoading> <ui-select ng-model=vm.selectedStorageAccount ng-change=vm.changed() append-to-body=true> <ui-select-match placeholder=\"Select Storage Account\" allow-clear=true>{{$select.selected.Name}} - {{$select.selected.Location}}</ui-select-match> <ui-select-choices repeat=\"item in vm.storageAccounts |  filter:{Name: $select.search} track by item.Name\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> <i>- {{item.Location}}</i> </ui-select-choices> </ui-select> </loading-wrapper> <p class=help-block>The name of a storage account that <em>CSPKG</em> files will be uploaded to before deployment.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 784 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/azure_web_app_endpoint.html';
	var html = "<div> <control-group label=Account> <account-selector endpoint=endpoint type=AzureSubscription></account-selector> </control-group> <azure-web-site-selector-deprecated endpoint=endpoint></azure-web-site-selector-deprecated> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 785 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/azure_web_site_selector.html';
	var html = "<div> <control-group label=\"Web App\"> <loading-wrapper busy=vm.isLoading> <ui-select ng-model=vm.selectedWebApp ng-change=vm.changed() append-to-body=true> <ui-select-match allow-clear=true placeholder=\"Select Web App\">{{$select.selected.Name}}<i ng-if=$select.selected.ResourceGroup> - {{$select.selected.ResourceGroup}}</i><i> - {{$select.selected.Region}}</i></ui-select-match> <ui-select-choices repeat=\"item in vm.webSites | filter:{Name: $select.search}\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> <br/> <i ng-if=item.ResourceGroup>{{item.ResourceGroup}} ({{item.Region}})</i> <i ng-if=!item.ResourceGroup>{{item.Region}}</i> </ui-select-choices> </ui-select> <p class=help-block>The name of your Azure Web App.</p> </loading-wrapper> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 786 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/generic_endpoint.html';
	var html = "<div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 787 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/offline_drop_endpoint.html';
	var html = "<div> <control-group label=\"Drop folder path\"> <input id=folder-path class=form-control type=text ng-model=endpoint.DropFolderPath placeholder=\\\\> <p class=help-block>A filesystem path to which drop packages will be published. Using a full UNC path is recommended.</p> <p class=help-block>Packages may contain sensitive data.</p> </control-group> <control-group label=\"Sensitive-variables encryption password\"> <sensitive-input model=endpoint.SensitiveVariablesEncryptionPassword></sensitive-input> <p class=help-block>If your project contains sensitive-variables, they will be encrypted in the drop location. The installation script will prompt for this password, and use it for decryption.</p> <p class=help-block>If your project will not contain sensitive-variables you may leave this value un-set.</p> </control-group> <control-group label=\"Applications directory\"> <input id=applications-directory type=text class=form-control ng-model=endpoint.ApplicationsDirectory placeholder=C:\\Applications /> <p class=help-block>The directory that packages will be extracted to when run on the deployment machine.</p> <p class=help-block>The final application installation path can be set by using the 'Custom Installation Directory' project setting.</p> </control-group> <control-group label=\"Octopus working directory\"> <input id=working-directory class=form-control type=text ng-model=endpoint.OctopusWorkingDirectory placeholder=C:\\Octopus> <p class=help-block>A working directory for Octopus to store reusable needed information such as the deployment journal.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 788 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/ssh_endpoint.html';
	var html = "<div> <control-group label=Account> <account-selector endpoint=endpoint type=UsernamePassword,SshKeyPair></account-selector> </control-group> <control-group label=Host> <input id=host class=form-control type=text ng-model=endpoint.Host placeholder=\"hostname.com or 10.0.0.1\"> <p class=help-block>The hostname or IP address of the machine to connect to.</p> </control-group> <control-group label=Port> <input id=port class=form-control type=text ng-model=endpoint.Port> <p class=help-block>The port to use when connecting to the remote host.</p> </control-group> <control-group label=Fingerprint> <input id=fingerprint class=\"input input-xxlarge form-control\" type=text ng-model=endpoint.Fingerprint placeholder=xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx> <p class=help-block>Enter the host fingerprint to be verified.</p> </control-group> <control-group label=Proxy> <div class=checkbox><label><input type=checkbox ng-model=view.sshUseProxy ng-change=useProxyChanged()> Use a proxy</label></div> <p class=help-block>Connect to this SSH endpoint through a proxy server.</p> </control-group> <control-group ng-show=view.sshUseProxy> <select class=form-control ng-model=endpoint.ProxyId ng-options=\"proxy.Id as proxy.Name for proxy in proxies\"> </select> <p class=help-block>The proxy to use to communicate with this SSH endpoint.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 789 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/tentacle_active_endpoint.html';
	var html = "<div> <control-group label=Thumbprint> <input id=thumbprint class=\"thumbprint form-control\" type=text ng-model=endpoint.Thumbprint> <p class=help-block> The X509 certificate thumbprint that securely identifies the machine. You can confirm the validity of the thumbprint by opening the Tentacle administration tool on the discovered machine. </p> <p class=padding-sm-vr> Please ensure the Tentacle is configured to trust an Octopus Server with the thumbprint: <span class=thumbprint>{{ serverThumbprint }}</span> </p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 790 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/endpoints/tentacle_passive_endpoint.html';
	var html = "<div> <tentacle-active-endpoint endpoint=endpoint></tentacle-active-endpoint> <control-group label=\"Tentacle URL\"> <input id=url class=form-control type=text ng-model=endpoint.Uri placeholder=https://example:10933> <p class=help-block> The network address at which the Tentacle can be reached.</p> </control-group> <control-group label=Proxy> <div class=checkbox><label><input type=checkbox ng-model=view.tentacleUseProxy ng-change=useProxyChanged()> Use a proxy</label></div> <p class=help-block>Connect to this Tentacle through a proxy server.</p> </control-group> <control-group ng-show=view.tentacleUseProxy> <select class=form-control ng-model=endpoint.ProxyId ng-options=\"proxy.Id as proxy.Name for proxy in proxies\"> </select> <p class=help-block>The proxy to use to communicate with this Tentacle.</p> </control-group> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 791 */
/***/ function(module, exports) {

	var path = 'areas/environments/views/index.html';
	var html = "<script octo-section=tools type=text/ng-template> <a octo-permission=\"MachinePolicyEdit\" wildcard class='btn btn-link' href=\"#/environments/machinepolicies\">Machine policies</a>\r\n    <a octo-permission=\"ProxyEdit\" wildcard class='btn btn-link' href=\"#/environments/proxies\">Proxies</a>\r\n    <a octo-permission=\"AccountEdit\" wildcard class='btn btn-link' href=\"#/accounts\">Accounts</a>\r\n    <button type=\"button\" octo-permission=\"EnvironmentEdit\" class='btn btn-link' ng-click=\"reorder()\"\r\n            ng-show=\"environments.length > 1\">Reorder\r\n    </button>\r\n    <a octo-permission=\"EnvironmentCreate\" class='btn' ng-show=\"environments.length >= 0\"\r\n       ng-class=\"{'btn-success': environments.length == 0, 'btn-link': environments.length > 0}\"\r\n       href=\"#/environments/new\">Add environment</a> </script> <loading-wrapper busy=isLoading> <div ng-if=hasLoaded> <div ng-show=\"upgradesRequired && environments.length > 0 && showUpgrade\"> <div class=\"alert alert-warning margin-bottom-20\"> <h4>Tentacle upgrade required</h4> <p> One or more machines are running old versions of the Tentacle deployment agent and can be upgraded. </p> <button class=\"btn btn-success\" type=button ng-click=upgradeTentacles()>Upgrade all Tentacles</button> <button class=btn type=button ng-click=dismissTentacleUpgrade()>Dismiss this Update</button> </div> </div> <div ng-show=showAzureTargetsWarning class=\"alert alert-warning margin-bottom-20\"> <p>Azure targets are in the process of being deprecated. Please consider <a class=alert-link href=http://g.octopushq.com/MigrateAzureTargets target=_blank>migrating to the equivalent Azure Steps</a>.</p> <p>The ability to create new Azure Targets was removed in Octopus Deploy 3.4. The ability to deploy to existing Targets will be removed in the future.</p> <p>Read our blog post for the <a class=alert-link href=https://octopus.com/blog/azure-changes target=_blank>reasoning.</a></p> <button class=btn type=button ng-click=dismissAzureTargetsWarning()>Dismiss this Warning</button> </div> <div ng-show=\"environments.length == 0\"> <div class=container-fluid> <div class=\"tutorial tutorial-center\"> <p>You don't have any environments to deploy to. <span octo-permission=EnvironmentCreate>You can create an environment using the <strong>Add environment</strong> button above.</span></p> </div> </div> </div> <div class=\"panel panel-transparent\" ng-repeat=\"environment in environments\" ng-show=environment.visible(environment)> <div class=panel-heading> <span class=panel-title> {{ environment.Name }} <i class=\"fa fa-random\" ng-show=environment.UseGuidedFailure></i> </span> <div class=panel-heading-controls> <a class=btn ng-if=\"environment.showFor != 'hosted'\" octo-permission=EnvironmentEdit octo-environment=environment.Id href=\"#/environments/{{ environment.Id }}\"> Edit </a> <button class=btn octo-permission=MachineEdit octo-environment=environment.Id ng-click=checkHealth(environment)> Check health </button> <a class=\"btn btn-success\" ng-if=\"environment.showFor != 'hosted'\" octo-permission=MachineCreate octo-environment=environment.Id href=\"#/machines/new?environment={{ environment.Id }}\"> Add deployment target </a> </div> </div> <div class=panel-body> <markdown class=subtle text=environment.Description></markdown> <p class=\"tutorial tutorial-center\" ng-show=\"machines[environment.Id].TotalResults == 0\"> You don't have any deployment targets in this environment yet. </p> <div ng-show=\"machines[environment.Id]['NeedsUpgrade']\"> <h5 class=separator>Upgrade suggested</h5> <machine-list machines=\"machines[environment.Id]['NeedsUpgrade']\" show=show></machine-list> <div class=margin-bottom-20> <button class=\"btn btn-success\" ng-click=upgradeTentaclesInEnvironment(environment) ng-if=showUpgrade> Upgrade <span>{{ machines[environment.Id]['NeedsUpgrade'].length === 1 ? \"this machine\" : \"these \" + machines[environment.Id]['NeedsUpgrade'].length + \" machines\" }}</span> </button> </div> </div> <div ng-show=\"machines[environment.Id]['CalamariNeedsUpgrade']\"> <h5 class=separator>Calamari update suggested</h5> <machine-list machines=\"machines[environment.Id]['CalamariNeedsUpgrade']\" show=show></machine-list> <div class=margin-bottom-20> <button class=\"btn btn-success\" ng-click=upgradeCalamariOnDeploymentTargets(environment)> Update Calamari on <span>{{ machines[environment.Id]['CalamariNeedsUpgrade'].length === 1 ? \"this machine\" : \"these \" + machines[environment.Id]['CalamariNeedsUpgrade'].length + \" machines\" }}</span> </button> </div> </div> <div ng-show=\"machines[environment.Id]['HasWarnings']\"> <h5 class=separator>Healthy with warnings</h5> <machine-list machines=\"machines[environment.Id]['HasWarnings']\" show=show></machine-list> </div> <div ng-show=\"machines[environment.Id]['Unhealthy']\"> <h5 class=separator>Unhealthy</h5> <machine-list machines=\"machines[environment.Id]['Unhealthy']\" show=show></machine-list> </div> <div ng-show=\"machines[environment.Id]['Unavailable']\"> <h5 class=separator>Unavailable</h5> <machine-list machines=\"machines[environment.Id]['Unavailable']\" show=show></machine-list> </div> <div ng-show=\"machines[environment.Id]['Unknown']\"> <h5 class=separator>New</h5> <machine-list machines=\"machines[environment.Id]['Unknown']\" show=show></machine-list> </div> <div ng-show=\"machines[environment.Id]['Healthy']\"> <h5 class=separator ng-show=\"machines[environment.Id]['Disabled'] || machines[environment.Id]['Unknown'] || machines[environment.Id]['Unavailable'] || machines[environment.Id]['NeedsUpgrade'] || machines[environment.Id]['CalamariNeedsUpgrade'] || machines[environment.Id]['Unhealthy'] || machines[environment.Id]['HasWarnings']\"> Healthy </h5> <machine-list machines=\"machines[environment.Id]['Healthy']\" show=show></machine-list> </div> <div ng-show=\"machines[environment.Id]['Disabled']\"> <h5 class=separator>Disabled</h5> <machine-list machines=\"machines[environment.Id]['Disabled']\" show=show></machine-list> </div> </div> </div> </div> </loading-wrapper> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 792 */
/***/ function(module, exports) {

	var path = 'areas/library/feeds/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/feeds\">External Feeds</a></li>\r\n    <li><a href=\"#/library/feeds/new\">Create New</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <feed-editor></feed-editor> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 793 */
/***/ function(module, exports) {

	var path = 'areas/library/feeds/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/feeds\">External Feeds</a></li>\r\n    <li><a href=\"#/library/feeds/{{ feed.Id }}\">{{ feed.Name }}</a></li> </script> <script octo-section=library_tools type=text/ng-template> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <feed-editor></feed-editor> </div> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <div> <h3>Delete</h3> <p>If any projects depend on packages in this feed, they will not be able to be deployed should you delete this feed.</p> <delete-button model=feed what=Feed redirect=/library/feeds></delete-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 794 */
/***/ function(module, exports) {

	var path = 'areas/library/feeds/views/editor.html';
	var html = "<form ng-submit=save() name=feedForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <div ng-show=feed.Id> <control-group label=ID> <p class=form-control-static>{{ feed.Id }}</p> <p class=help-block>This is the identity of the feed which can be used in variable bindings. It will never change, even if you rename the feed.</p> </control-group> </div> <control-group label=\"Feed Type\" octo-feature=IsDockerEnabled> <p ng-if=feed.Id class=form-control-static> {{feeds[feed.FeedType]}} </p> <div ng-if=!feed.Id> <select class=form-control ng-model=feed.FeedType ng-options=\"code as desc for (code, desc) in feeds\" ng-change=updateOptions()></select>  <p class=help-block>This defines what types of deployment steps your build artifacts can be used in.</p> </div> </control-group> <control-group label=Name> <input class=form-control type=text ng-model=feed.Name> <p class=help-block>A short, memorable, unique name for this feed. Example: ACME Builds.</p> </control-group> <control-group label=URL> <input class=form-control type=text ng-model=feed.FeedUri> <p class=help-block>The location of the feed. <span ng-if=\"feed.FeedType === 'NuGet'\">Both URLs and folder paths are accepted.</span></p> </control-group> <control-group label=\"API Version\" ng-if=\"feed.FeedType === 'Docker'\"> <label class=radio><input type=radio ng-model=feed.ApiVersion ng-value=\"'v1'\"> V1</label> <label class=radio><input type=radio ng-model=feed.ApiVersion ng-value=\"'v2'\"> V2</label> </control-group> <control-group label=\"Registry Path\" ng-if=\"feed.FeedType === 'Docker'\"> <input class=form-control type=text ng-model=feed.RegistryPath> <p class=help-block>The path of the <a href=https://docs.docker.com/engine/reference/commandline/pull/#/pulling-from-a-different-registry target=_blank>registry</a> for the docker host to pull from as accessible from the target. Example: <code>localhost:5000</code>. <br/>Leave empty if the same as the URL host provided above.</p> </control-group> <h4 class=separator>Credentials</h4> <p class=subtle>Leave the following blank if your feed does not require authentication.</p> <control-group label=Username> <input class=form-control type=text ng-model=feed.Username> </control-group> <control-group label=Password> <sensitive-input model=feed.Password></sensitive-input> </control-group> <div ng-if=\"feed.FeedType === 'NuGet'\"> <div><a href ng-click=\"showAdvanced = !showAdvanced\"><span ng-if=showAdvanced>Hide</span><span ng-if=!showAdvanced>Show</span> advanced settings</a></div> <div ng-if=showAdvanced> <h4 class=separator>Advanced</h4> <control-group label=\"Download attempts\"> <div class=\"input-group col-xs-6\"> <input class=form-control type=number ng-model=feed.DownloadAttempts placeholder={{defaultDownloadAttempts}}> <span class=input-group-addon id=basic-addon2>attempts</span> </div> <p class=help-block>The number of times a deployment should attempt to download a package from this feed before failing.</p> </control-group> <control-group label=\"Download retry backoff\"> <div class=\"input-group col-xs-6\"> <input class=form-control type=number ng-model=feed.DownloadRetryBackoffSeconds placeholder={{defaultDownloadRetryBackoffSeconds}}> <span class=input-group-addon id=basic-addon2>seconds</span> </div> <p class=help-block>The number of seconds to apply as a linear back off between download attempts.</p> </control-group> </div> </div> <last-modified model=feed></last-modified> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" type=button ng-click=save(true) ng-disabled=isSaving.busy>Save and test</button> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 795 */
/***/ function(module, exports) {

	var path = 'areas/library/feeds/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/feeds\">External Feeds</a></li> </script> <script octo-section=tools type=text/ng-template> <a class='btn btn-success' href=\"#/library/feeds/new\">Add feed</a> </script> <div> <h3>External feeds</h3> <p> Octopus can deploy packages from external NuGet package repositories. You can <a class=external target=_blank href=http://g.octopushq.com/DocumentationPackaging>set up your own repository</a> and add it using the <strong>Add feed</strong> button. </p> <loading-wrapper busy=isLoading> <table class=\"table table-bordered table-striped\" ng-show=\"feeds.Items.length > 1\"> <thead> <tr> <th>Name</th> <th>URL</th> <th style=width:120px>Actions</th> </tr> </thead> <tbody> <tr ng-hide=\"feed.Id == builtIn.feedId\" ng-repeat=\"feed in feeds.Items\"> <th>{{feed.Name}}</th> <td class=tight><a class=external target=_blank href=\"{{ feed.FeedUri }}\">{{ feed.FeedUri | ellipsis:50 }}</a></td> <td> <a octo-permission=AdministerSystem href=\"#/library/feeds/{{ feed.Id }}\">Edit</a> &nbsp; &nbsp; <a href=\"#/library/feeds/{{ feed.Id }}/test\">Test</a> </td> </tr> </tbody> </table> <octo-paginator collection=feeds></octo-paginator> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 796 */
/***/ function(module, exports) {

	var path = 'areas/library/feeds/views/test.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/feeds\">External Feeds</a></li>\r\n    <li><a href=\"#/library/feeds/{{ feed.Id }}\">{{ feed.Name }}</a></li>\r\n    <li><a href=\"#/library/feeds/{{ feed.Id }}/test\">Test</a></li> </script> <div> <div class=\"help-scope form-box form-horizontal\"> <h3>Test {{ feed.Name }}</h3> <p>Test the <dfn title=\"{{ feed.FeedUri }}\">{{ feed.Name }}</dfn> repository using the search below. Up to ten results will be shown.</p> <form ng-submit=testFeed()> <control-group label=\"Package name\"> <div class=form-group-margin> <input class=form-control type=text ng-model=test.searchTerm> </div> <button class=\"btn btn-success\" type=submit ng-disabled=isTesting.busy>Search</button> <p class=help-block>A package name to search for. Note that names on local folders and file shares are case-sensitive.</p> </control-group> </form> </div> <spin active=isTesting.busy class=spin-static></spin> <h4 ng-show=test.started>Matching packages</h4> <error-box error=isTesting.error></error-box> <table class=\"table table-bordered\" ng-show=test.started> <thead> <tr> <th>Id</th> <th ng-if=hasVersion()>Version</th> <th>Description</th> </tr> </thead> <tbody> <tr ng-repeat=\"package in packages\"> <th>{{ package.PackageId }}</th> <td ng-if=hasVersion()>{{ package.Version }}</td> <td>{{ (package.Description || package.Summary || package.Title) | ellipsis:140 }}</td> </tr> </tbody> </table> <p class=subtle ng-show=\"test.started && packages.length == 0\">If you don't see any results and you are using a file-based NuGet package repository, it might be because your NuGet folder is unavailable. Check that the Octopus service is running under an account that has permissions to access the directory.</p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 797 */
/***/ function(module, exports) {

	var path = 'areas/library/lifecycles/views/add_environment_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add environment</h3> </div> <form ng-submit=save()> <div class=modal-body> <div class=\"alert alert-warning\" ng-show=\"environments.length == 0\"> <p>All possible environments have already been defined in this lifecycle.</p> </div> <div class=form-horizontal> <select class=form-control ng-model=adding.environmentId> <option ng-repeat=\"e in environments\" value={{e.Id}}>{{e.Name}}</option> </select> <div class=radio> <label> <input type=radio ng-model=adding.trigger ng-value=\"'Automatic'\"> Deploy <strong>automatically</strong> to this environment as soon as the release enters this phase. </label> </div> <div class=radio> <label> <input type=radio ng-model=adding.trigger ng-value=\"'Manual'\"> Users will need to <strong>manually</strong> queue the deployment to this environment. </label> </div> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" type=submit ng-click=save() ng-show=!isLoading.busy ng-disabled=!adding.environmentId>Add</button> <button class=\"btn btn-default\" type=button ng-click=close()>Cancel</button> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 798 */
/***/ function(module, exports) {

	var path = 'areas/library/lifecycles/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/lifecycles\">Lifecycles</a></li>\r\n    <li><a href=\"#/library/lifecycles/new\">Create New</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <lifecycle-editor></lifecycle-editor> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 799 */
/***/ function(module, exports) {

	var path = 'areas/library/lifecycles/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/lifecycles\">Lifecycles</a></li>\r\n    <li><a href=\"#/library/lifecycles/{{ lifecycle.Id }}\">{{ lifecycle.Name }}</a></li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <h3>Lifecycle</h3> <lifecycle-editor></lifecycle-editor> </div> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <h3>Projects</h3> <div ng-show=!projects> <p class=tutorial>No projects are currently using this lifecycle. Go to a project, then go to the <em>Process</em> tab to assign this lifecycle.</p> </div> <div ng-show=projects> <p class=tutorial>The following projects use this lifecycle.</p> </div> <ul ng-repeat=\"project in projects\"> <li><a href=#/projects/{{project.Slug}}/process>{{project.Name}}</a></li> </ul> <div octo-permission=LifecycleDelete> <h3>Delete</h3> <p>Once you delete this lifecycle, there is no going back.</p> <delete-button model=lifecycle what=Lifecycle redirect=/library/lifecycles></delete-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 800 */
/***/ function(module, exports) {

	var path = 'areas/library/lifecycles/views/editor.html';
	var html = "<form ng-submit=save() name=lifecycleForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <control-group label=Name> <input class=form-control type=text ng-model=lifecycle.Name> <p class=help-block>A short, memorable, unique name for this lifecycle. Example: Dev/Test/Prod.</p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=lifecycle.Description markitup rows=7></textarea> <p class=help-block>This summary will appear on the lifecycle overview page.</p> </control-group> <control-group label=\"Default retention policy\"> <div class=pad-text> <div>Releases: <retention-summary policy=lifecycle.ReleaseRetentionPolicy></retention-summary></div> <div>Files on Tentacles: <retention-summary policy=lifecycle.TentacleRetentionPolicy></retention-summary></div> <div> <a href ng-click=changeRetentionPolicy(lifecycle)>Change</a> </div> </div> <p class=help-block>Retention policies dictate how long releases and deployments are kept for.</p> </control-group> <h3>Phases</h3> <div class=phase-editor> <div class=tutorial-center ng-show=\"lifecycle.Phases.length == 0\"> <p>This lifecycle will use the default conventions. They allow deployment to any environment, so long as environments are deployed to in the order that they are defined on the <a href=#/environments>environments</a> page. Use the <em>Add phase</em> button to explicitly define your own phases or to restrict the lifecycle to specific environments.</p> </div> <div class=tutorial-center ng-show=\"lifecycle.Phases.length > 0\"> <p>Projects that use this lifecycle can only be deployed according to the phases below.</p> </div> <div ng-repeat=\"phase in lifecycle.Phases\"> <div class=phase> <div class=phase-heading> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=removePhase(phase)>×</button> <control-group label=\"Phase {{ ($index + 1) }}\" style=margin-right:20px> <input class=form-control type=text ng-model=phase.Name required> </control-group> </div> <div class=phase-body> <control-group label=Environments> <div ng-show=\"(envCount(phase)) == 0\"> <strong class=pad-text>Any environment</strong> <p class=\"\"> When the release is in this phase, any environment <span ng-show=\"lifecycle.Phases.length > 1\">that is not explicitly named in another phase</span> can be deployed to. Use the <em>Add environment</em> button to limit the phase to a specific list of environments. </p> <button class=\"btn btn-default\" type=button ng-click=addEnvironment(phase)><i class=icon-plus></i> Add environment</button> </div> <div> <ul class=octo-list-group> <li class=octo-list-group-item ng-repeat=\"target in phase.AutomaticDeploymentTargets\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=\"removeEnvironment(phase.AutomaticDeploymentTargets, target)\">×</button> <div> <span class=\"phase-icon automatic\" title=\"When the release enters this phase, this environment will be automatically deployed to\"></span> {{ environmentsById[target].Name }} </div> </li> <li class=octo-list-group-item ng-repeat=\"target in phase.OptionalDeploymentTargets\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=\"removeEnvironment(phase.OptionalDeploymentTargets, target)\">×</button> <div> <span class=phase-icon title=\"When the release enters this phase, this environment can be manually deployed to\"></span> {{ environmentsById[target].Name }} </div> </li> </ul> <button class=\"btn btn-default\" type=button ng-show=\"envCount(phase) > 0\" ng-click=addEnvironment(phase)>Add environment</button> </div> </control-group> <div ng-show=\"(envCount(phase)) > 1\"> <control-group label=\"Required to progress\"> <span class=\"pad-text gray\" ng-show=\"phase.MinimumEnvironmentsBeforePromotion == 0\"> All environments must be deployed to before progressing to the next phase. <a href ng-click=\"phase.MinimumEnvironmentsBeforePromotion = (envCount(phase))\">Change</a>. </span> <div ng-show=\"phase.MinimumEnvironmentsBeforePromotion != 0\"> <input class=\"input-small form-control\" type=number min=0 max=50 data-placeholder ng-model=phase.MinimumEnvironmentsBeforePromotion> <p class=gray> <span ng-show=\"phase.MinimumEnvironmentsBeforePromotion == 0\">All environments must be deployed to before progressing to the next phase.</span> <span ng-show=\"phase.MinimumEnvironmentsBeforePromotion == 1\">Only one environment is required before progressing to the next phase.</span> <span ng-show=\"phase.MinimumEnvironmentsBeforePromotion > 1 && phase.MinimumEnvironmentsBeforePromotion < envCount(phase)\">Any {{phase.MinimumEnvironmentsBeforePromotion}} environments are required before progressing to the next phase.</span> <span ng-show=\"phase.MinimumEnvironmentsBeforePromotion == envCount(phase)\">All environments must be deployed to before progressing to the next phase.</span> </p> </div> </control-group> </div> <div ng-hide=phase.ReleaseRetentionPolicy> <control-group label=\"Retention policy\"> <div class=pad-text> <div class=gray>Inherited from <span ng-show=\"getParentPolicy(phase, $index) == lifecycle\">default lifecycle policy</span><span ng-hide=\"getParentPolicy(phase, $index) == lifecycle\">phase: {{ getParentPolicy(phase, $index).Name }}</span></div> <div>Releases: <retention-summary policy=\"getParentPolicy(phase, $index).ReleaseRetentionPolicy\"></retention-summary></div> <div>Files on Tentacles: <retention-summary policy=\"getParentPolicy(phase, $index).TentacleRetentionPolicy\"></retention-summary></div> <div> <a href ng-click=changeRetentionPolicy(phase)>Override</a> </div> </div> </control-group> </div> <div ng-show=phase.ReleaseRetentionPolicy> <control-group label=\"Retention policy\"> <div class=pad-text> <div>Releases: <retention-summary policy=phase.ReleaseRetentionPolicy></retention-summary></div> <div>Files on Tentacles: <retention-summary policy=phase.TentacleRetentionPolicy></retention-summary></div> <div> <a href ng-click=changeRetentionPolicy(phase)>Change</a>   <a href ng-click=resetRetentionPolicy(phase)>Reset</a> </div> </div> <p class=help-block>Retention policies dictate how long releases and deployments are kept for.</p> </control-group> </div> </div> </div> </div> </div> <div> <control-group label> <a class=\"btn btn-info\" href ng-click=addPhase()><i class=\"fa fa-plus\"></i> Add phase</a> <a class=\"btn btn-link btn-default\" href ng-click=reorder() ng-show=\"lifecycle.Phases.length > 1\">Reorder</a> </control-group> </div> <last-modified model=lifecycle></last-modified> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 801 */
/***/ function(module, exports) {

	var path = 'areas/library/lifecycles/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/lifecycles\">Lifecycles</a></li> </script> <script octo-section=library_tools type=text/ng-template> <a octo-permission=\"LifecycleCreate\" wildcard class='btn btn-success' href=\"#/library/lifecycles/new\">Add\r\n        lifecycle</a> </script> <div> <h3>Lifecycles</h3> <p>Lifecycles can be used to automatically promote deployments between environments, and limit environments that can be deployed to until a release has been thoroughly tested.</p> <loading-wrapper busy=isLoading once=true> <div ng-show=\"lifecycles.length > 0\"> <div class=\"octo-list-group narrow-left narrow650\"> <a class=\"octo-list-group-item clickable\" href=#/library/lifecycles/{{lifecycle.Id}} ng-repeat=\"lifecycle in lifecycles track by lifecycle.Id\"> <h4 class=octo-list-group-item-heading>{{ lifecycle.Name }}</h4> <markdown text=lifecycle.Description></markdown> <lifecycle-map lifecycle=previews[lifecycle.Id] environments=environments></lifecycle-map> </a> </div> </div> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 802 */
/***/ function(module, exports) {

	var path = 'areas/library/lifecycles/views/policy_edit_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Change Retention Policy</h3> </div> <form ng-submit=save()> <div class=modal-body> <control-group label=Releases> <div class=radio><label><input type=radio ng-model=policy.ReleaseRetentionPolicy.ShouldKeepForever ng-value=true ng-change=reset(policy.ReleaseRetentionPolicy)> Keep all</label></div> <div class=radio><label><input type=radio ng-model=policy.ReleaseRetentionPolicy.ShouldKeepForever ng-value=false ng-change=reset(policy.ReleaseRetentionPolicy)> Keep a limited number</label></div> <div class=pad-left-30 ng-hide=policy.ReleaseRetentionPolicy.ShouldKeepForever> <input class=\"input-small form-control pull-left\" style=margin-right:1em type=text ng-model=policy.ReleaseRetentionPolicy.QuantityToKeep> <select class=\"input-medium form-control\" ng-model=policy.ReleaseRetentionPolicy.Unit> <option value=Days>Days</option> <option value=Items>Releases</option> </select> </div> <p class=help-block>How long should we keep releases?</p> </control-group> <control-group label=\"Files on Tentacle\"> <div class=radio><label><input type=radio ng-model=policy.TentacleRetentionPolicy.ShouldKeepForever ng-value=true ng-change=reset(policy.TentacleRetentionPolicy)> Keep all</label></div> <div class=radio><label><input type=radio ng-model=policy.TentacleRetentionPolicy.ShouldKeepForever ng-value=false ng-change=reset(policy.TentacleRetentionPolicy)> Keep a limited number</label></div> <div class=pad-left-30 ng-hide=policy.TentacleRetentionPolicy.ShouldKeepForever> <input class=\"input-small form-control pull-left\" style=margin-right:1em type=text ng-model=policy.TentacleRetentionPolicy.QuantityToKeep> <select class=\"input-medium form-control\" ng-model=policy.TentacleRetentionPolicy.Unit> <option value=Days>Days</option> <option value=Items>Releases</option> </select> </div> <p class=help-block>How long should we keep extracted packages and files on disk on Tentacles?</p> </control-group> </div> <div class=modal-footer> <button class=\"btn btn-success\" type=submit ng-click=save() ng-show=!isLoading.busy>Apply</button> <button class=\"btn btn-default\" type=button ng-click=close()>Cancel</button> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 803 */
/***/ function(module, exports) {

	var path = 'areas/library/packages/views/index.html';
	var html = "<script octo-section=library_tools type=text/ng-template> <a octo-permission=\"BuiltInFeedPush\" wildcard class='btn btn-success' href=\"#/library/packages/upload\">Upload package</a> </script> <script octo-section=breadcrumbs type=text/ng-template> <li><a ui-sref=\"app.library.packages\">Packages</a></li> </script> <loading-wrapper busy=isLoading once=true> <div class=row> <div class=col-sm-8> <h3>Packages</h3> <p>This page shows packages stored in the Octopus Server's built-in package repository. The repository accepts NuGet, zip, tar, tar gzip and tar bzip2 packages. <span octo-permission=BuiltInFeedPush wildcard>Use the <strong>Upload package</strong> button above to add a package to the library.</span></p> <p octo-permission=BuiltInFeedPush wildcard>Push NuGet packages using a NuGet client to add them here:</p> <pre octo-permission=BuiltInFeedPush wildcard>NuGet.exe push <em>YourApp.nupkg</em> -ApiKey <em><a href=#/users/me>Your API Key</a></em> -Source <strong>{{ builtIn.nuGetPushUrl }}</strong></pre> <p octo-permission=BuiltInFeedPush wildcard>Upload packages via the api with PowerShell:</p> <pre octo-permission=BuiltInFeedPush wildcard>$wc = new-object System.Net.WebClient\r\n$wc.UploadFile(\"<strong>{{ builtIn.apiPushUrl }}</strong>?apiKey=<em>&lt;<a href=#/users/me>Your API Key</a>&gt;</em>\", \"<em>YourApp.1.0.0.zip</em>\")</pre> <p class=help-block>Octopus does not allow NuGet clients to connect to this feed to retrieve packages; the feed only supports deployable packages, and doesn't allow NuGet packages to be consumed from <em>Visual Studio</em> and other tools.</p> <div ng-show=\"view.filtering || packages.Items.length > 0\"> <h3 class=margin-top-20>Available packages</h3> <form name=filterForm class=form-inline ng-submit=filter()> <div class=input-append> <input class=\"input input-xlarge form-control\" type=text placeholder=\"Show all\" ng-model=view.filter> <button class=\"btn btn-default\" type=submit ng-disabled=isFiltering.busy>Filter</button> </div> </form> <spin active=isFiltering.busy></spin> <error-box error=isFiltering.error></error-box> <table class=\"table table-bordered table-striped margin-top-10\"> <thead> <tr> <th>ID</th> <th width=160px>Latest version</th> <th>Description</th> </tr> </thead> <tbody> <tr ng-repeat=\"package in packages.Items track by package.Id\"> <th><a href=#/library/packages/versions/{{package.PackageId}}>{{ package.PackageId }}</a></th> <td><a href=\"{{package.Links.Raw |resolveLink}}\"><i class=\"fa fa-download\" title=\"Download package\"></i></a>   <a href=#/library/packages/{{package.Id}}>{{ package.Version }}</a></td> <td>{{ (package.Description || package.Summary || package.Title) | ellipsis:140 }}</td> </tr> </tbody> </table> <octo-paginator collection=packages></octo-paginator> </div> </div> <div class=col-sm-4> <h3>Repository status</h3> <table class=\"table table-bordered narrow-left\"> <tbody> <tr> <th width=55%>Total packages stored</th><td>{{ builtIn.totalPackages }}</td> </tr> </tbody> </table> <div ng-show=repository> <h3 class=margin-top-20>Repository retention</h3> <p ng-show=repository.DeleteUnreleasedPackagesAfterDays>Packages not used in a release will be automatically deleted from the repository after <strong>{{ repository.DeleteUnreleasedPackagesAfterDays | pluralize:\"day\" }}</strong>.</p> <p ng-show=repository.DeleteUnreleasedPackagesAfterDays>Packages used in a release will not be deleted unless the release is deleted.</p> <p ng-hide=repository.DeleteUnreleasedPackagesAfterDays>Packages stored in the repository will be <strong>retained indefinitely</strong>.</p> <p><a href=#/library/packages/retention>Change »</a></p> <p></p> </div> <div ng-show=repository> <h3 class=margin-top-20>Package Indexing</h3> <p>Octopus automatically re-indexes the built-in package repository at startup. <a href=http://g.octopushq.com/ReIndexBuiltInRepository target=_blank class=\"external alert-link\">Learn more</a>.</p> <div class=margin-bottom-10> <span ng-if=lastSyncTaskUrl ng-class=lastSyncTextClass> Last sync <a ng-if=lastSyncTaskUrl href={{lastSyncTaskUrl}}>{{lastSyncFailed ? 'failed' : 'succeeded'}}</a> </span> <span ng-if=!lastSyncTaskUrl>Never synced</span> </div> <div> <input id=builtInRepositorySyncSwitch type=checkbox bs-switch ng-model=config.IsBuiltInRepoSyncEnabled switch-on-color=success switch-on-label=On switch-off-label=Off switch-size=small ng-change=save()> <button class=\"btn btn-default\" type=submit ng-disabled=isLoading.busy ng-click=synchronizeBuiltInPackageRepositoryIndex()>Sync now</button> </div> <control-group label=\"\"> </control-group> </div> </div> </div> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 804 */
/***/ function(module, exports) {

	var path = 'areas/library/packages/views/package_details.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/packages\">Packages</a></li>\r\n    <li><a href=\"#/library/packages/versions/{{package.PackageId}}\">{{package.PackageId}}</a></li>\r\n    <li><a href=\"#/library/packages/{{package.Id}}\">{{package.Version}}</a></li> </script> <div> <h3>{{package.PackageId}} <small>{{ package.Version }}</small> </h3> <p class=\"tutorial tutorial-left\">The information below is from the specification embedded in the <strong>{{package.PackageId}}.{{package.Version}}{{package.FileExtension}}</strong> file. To change these details, <a href=#/library/packages/upload>upload a new version</a> of the package.</p> <p><a class=\"btn btn-info\" href=\"{{package.Links.Raw |resolveLink}}\"><i class=\"fa fa-download\"></i> Download</a></p> <table class=table> <tbody> <tr> <th width=200px>ID</th> <td>{{package.PackageId}}</td> </tr> <tr> <th>Version</th> <td>{{package.Version}}</td> </tr> <tr> <th>Published</th> <td>{{package.Published}}</td> </tr> <tr ng-show=package.Title> <th>Title</th> <td>{{package.Title}}</td> </tr> <tr ng-show=package.Summary> <th>Summary</th> <td>{{package.Summary}}</td> </tr> <tr ng-show=package.Description> <th>Description</th> <td>{{package.Description}}</td> </tr> <tr ng-show=package.ReleaseNotes> <th>Release notes</th> <td> <markdown text=package.ReleaseNotes></markdown> </td> </tr> <tr ng-show=package.FileExtension> <th>File Extension</th> <td>{{package.FileExtension}}</td> </tr> <tr> <th>Size</th> <td>{{package.PackageSizeBytes | bytesToSize }}</td> </tr> <tr> <th>SHA1</th> <td>{{package.Hash}}</td> </tr> </tbody> </table> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 805 */
/***/ function(module, exports) {

	var path = 'areas/library/packages/views/package_versions.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/packages\">Packages</a></li>\r\n  <li><a href=\"#/library/packages/versions/{{package.PackageId}}\">{{package.PackageId || routePackageId }}</a></li> </script> <div class=row> <div class=col-sm-8> <h3>{{package.PackageId || routePackageId }}</h3> <p class=subtle ng-show=\"packageVersions.Items.length == 0\">There are no versions of this package stored.</p> <p class=subtle ng-show=\"packageVersions.Items.length > 0\">{{ package.Description || package.Summary || package.Title }}</p> <table class=\"table table-bordered\" ng-show=\"packageVersions.Items.length > 0\"> <thead> <tr> <th width=50px><input type=checkbox ng-model=view.allSelected></th> <th>Version</th> <th>Published</th> <th>Size</th> </tr> </thead> <tbody> <tr ng-repeat=\"pv in packageVersions.Items track by pv.Id\"> <td><input type=checkbox ng-model=pv.IsSelected ng-change=\"view.allSelected = false\"></td> <td><a href=\"{{pv.Links.Raw |resolveLink}}\"><i class=\"fa fa-download\" title=\"Download package\"></i></a>   <strong><a href=#/library/packages/{{pv.Id}}>{{ pv.Version}}</a></strong></td> <td>{{pv.Published}}</td> <td>{{pv.PackageSizeBytes | bytesToSize }}</td> </tr> </tbody> </table> <octo-paginator collection=packageVersions></octo-paginator> </div> <div class=\"other-actions col-sm-4\" octo-permission=BuiltInFeedAdminister wildcard ng-show=\"packageVersions.Items.length > 0\"> <div> <h3>Delete</h3> <p>If any projects depend on these packages, they will not be able to be deployed should you delete required versions from the repository.</p> <button class=\"btn btn-warning\" type=button ng-disabled=noneSelected() ng-click=deleteSelected()>Delete selected</button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 806 */
/***/ function(module, exports) {

	var path = 'areas/library/packages/views/retention.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/packages/retention\">Package Repository Retention</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>Package Repository Retention</h3> <p>Packages can be deleted automatically from the built-in repository when they're not associated with any releases.</p> <p class=help-block>To clean up packages that are associated with releases either remove them manually from the <a href=#/library/packages>Library</a> or set up retention policies that delete the releases in question.</p> <div class=\"note note-warning\"> <p>If you use <strong>variables</strong> such as <code>MyCompany.#{ProjectName}</code> in your deployment process to determine which <em>Package ID</em> to use for deployment, matching packages may be deleted by the clean-up process.</p> </div> <form ng-submit=save() name=packageRetentionForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=\"Unreleased packages\"> <label class=radio><input type=radio ng-model=view.KeepForever ng-value=true> Keep forever</label> <label class=radio><input type=radio ng-model=view.KeepForever ng-value=false> Keep for a limited time</label> <div class=pad-left-30 ng-hide=view.KeepForever> <input class=\"input-small form-control\" type=number ng-model=repositoryConfiguration.DeleteUnreleasedPackagesAfterDays> days </div> <p class=help-block>How long after publishing should unreleased packages be kept?</p> </control-group> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 807 */
/***/ function(module, exports) {

	var path = 'areas/library/packages/views/upload.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/packages/upload\">Upload</a></li> </script> <div> <h3>Upload a package</h3> <p class=\"tutorial tutorial-left\"> Upload packages containing application components to deploy.<br/>Details on supported packages can be found in our <a href=http://g.octopushq.com/SupportedPackages target=_blank class=\"external alert-link\">documentation</a>. </p> <form class=\"form form-horizontal\" id=packageUpload name=packageUpload ng-submit=beginUpload()> <error-box error=isUploading.error></error-box> <control-group label=\"Package file\"> <div class=\"input-group js-fileapi-wrapper\"> <input class=form-control type=text disabled=disabled value={{octoUpload.selectedFile}}> <input class=\"form-control uploader\" type=file nv-file-select uploader=octoUpload.uploader ng-disabled=isUploading.busy> <div class=input-group-btn> <div type=button class=\"btn btn-primary\" ng-disabled=isUploading.busy> <input class=\"form-control uploader\" type=file nv-file-select uploader=octoUpload.uploader ng-disabled=isUploading.busy> <div>Choose File</div> </div> <div type=button class=\"btn btn-primary\" ng-click=cancel(); ng-disabled=isUploading.busy> <div>Cancel</div> </div> </div> </div> </control-group> <control-group label> <label><input type=checkbox ng-model=uploadOptions.replace> Replace this version if it exists</label> </control-group> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=\"isUploading.busy || !octoUpload.uploader.queue.length\">Upload </button> <spin active=isUploading.busy class=spin-static></spin> </div> </form></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 808 */
/***/ function(module, exports) {

	var path = 'areas/library/scripts/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/scripts\">Script Modules</a></li>\r\n    <li><a href=\"#/library/scripts/new\">Create New</a></li> </script> <div class=form-horizontal> <h3>{{ pageTitle }}</h3> <form ng-submit=save() name=scriptModuleForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Name> <input class=form-control type=text ng-model=scriptModule.Name> <p class=help-block>A short, memorable, unique name for this script module. Example: <em>Service Configuration</em></p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=scriptModule.Description markitup rows=7></textarea> <p class=help-block>This summary will be presented to users when selecting the script module for inclusion in a project.</p> </control-group> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 809 */
/***/ function(module, exports) {

	var path = 'areas/library/scripts/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/scripts\">Script Modules</a></li>\r\n    <li><a href=\"#/library/scripts/{{ scriptModule.Id }}\">{{ scriptModule.Name }}</a></li> </script> <div> <error-box error=isSaving.error></error-box> <div class=\"tabbable tabs-top\"> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: tab == 'body'}\"><a href ng-click=\"changeTab('body')\">Body</a></li> <li ng-class=\"{active: tab == 'settings'}\"><a href ng-click=\"changeTab('settings')\">Settings</a></li> </ul> <div class=tab-content> <div class=tab-pane ng-class=\"{active: tab == 'body'}\"> <div class=row> <div class=col-sm-12> <div> <p>This script will be loaded as a <em>PowerShell</em> module (equivalent to a <code>.psm1</code> file). Functions and <em>cmdlets</em> from the module will be exported for use in deployment scripts.</p> <form name=moduleBodyForm track-unsaved-changes> <a class=fullscreen-button href octo-full-screen=#scriptEditorContainer></a> <div id=scriptEditorContainer> <div class=\"big-on-full full-height\" id=scriptEditor ui-ace=\"{ mode: 'powershell' }\" ng-model=view.scriptBody></div> </div> </form> <last-modified model=vs></last-modified> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button octo-permission=LibraryVariableSetEdit type=button class=\"btn btn-success\" ng-click=save()>Save </button> </div> </div> </div> </div> <div class=tab-pane ng-class=\"{active: tab == 'settings'}\"> <div class=row> <div class=col-sm-12> <div class=form-horizontal> <form class=\"\" ng-submit=save() name=scriptModuleForm id=scriptModuleForm track-unsaved-changes> <div class=form-body> <control-group label=Name> <input class=form-control type=text ng-model=scriptModule.Name> <p class=help-block>A short, memorable, unique name for this script module. Example: <em>Service Configuration</em></p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=scriptModule.Description markitup rows=7></textarea> <p class=help-block>This summary will be presented to users when selecting the script module for inclusion in a project.</p> </control-group> <last-modified model=scriptModule></last-modified> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button octo-permission=LibraryVariableSetEdit type=button class=\"btn btn-success\" ng-click=save()>Save </button> <delete-button class=pull-right model=scriptModule what=\"Script module\" redirect=/library/scripts></delete-button> </div> </form> </div> </div> </div> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 810 */
/***/ function(module, exports) {

	var path = 'areas/library/scripts/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/scripts\">Script Modules</a></li> </script> <script octo-section=library_tools type=text/ng-template> <a octo-permission=\"LibraryVariableSetCreate\" class='btn btn-success' href=\"#/library/scripts/new\">Add script\r\n        module</a> </script> <div> <h3>Script modules</h3> <p>Script modules are collections of PowerShell functions that can be included in multiple projects.</p> <p ng-show=\"scriptModules.Items.length == 0\">To create your first script module, use the <strong>Add script module</strong> button above.</p> <div class=\"octo-list-group margin-bottom-20\"> <a class=octo-list-group-item href=#/library/scripts/{{sm.Id}} ng-repeat=\"sm in scriptModules.Items\"> <h4 class=octo-list-group-item-heading>{{ sm.Name }}</h4> <markdown text=sm.Description></markdown> </a> </div> <octo-paginator collection=scriptModules content-type=\"'ScriptModule'\"></octo-paginator> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 811 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/change_logo.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/steptemplates\">Step Templates</a></li>\r\n    <li>\r\n        <a href=\"#/library/steptemplates/{{actionTemplate.Id}}\">\r\n            <step-template-logo ng-if=\"actionTemplate.Links['Logo']\" resolve-link=\"resolveLink\" size=\"'xx-small'\"\r\n                                url=\"actionTemplate.Links['Logo']\"></step-template-logo>\r\n            {{ actionTemplate.Name }}\r\n        </a>\r\n    </li>\r\n    <li><a href=\"#/library/steptemplates/{{actionTemplate.Id}}/logo\">Change Logo</a></li> </script> <div> <div class=\"form-box form-horizontal\"> <h3>Step Template logo</h3> <div class=\"narrow650 narrow-left\"> <form class=\"form form-horizontal\" name=logoUpload> <error-box error=isUploading.error></error-box> <control-group label=\"Image file\"> <div class=\"input-group js-fileapi-wrapper\"> <input class=form-control type=text disabled=disabled value={{octoUpload.selectedFile}}> <input class=\"form-control uploader\" type=file nv-file-select uploader=octoUpload.uploader ng-disabled=isUploading.busy> <div class=input-group-btn> <div type=button class=\"btn btn-primary\" ng-disabled=isUploading.busy> <input class=\"form-control uploader\" type=file nv-file-select uploader=octoUpload.uploader ng-disabled=isUploading.busy> <div>Choose File</div> </div> <div type=button class=\"btn btn-primary\" ng-click=cancel(); ng-disabled=isUploading.busy> <div>Cancel</div> </div> </div> </div> <p class=help-block>Select a logo or image to use for the step template. The recommended image size is 50x50 pixels or 80x50 pixels. The recommended format is PNG with transparency, though any browser-viewable image format will work.</p> </control-group> <div class=form-actions> <spin active=isUploading.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=\"isUploading.busy ||  !octoUpload.uploader.queue.length\" ng-click=beginUpload()>Upload </button> <button class=\"btn btn-warning delete-button\" type=submit ng-disabled=isUploading.busy ng-click=beginReset()>Use default </button> </div> </form> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 812 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/community_step_template_details.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/library/steptemplates/'>Step Templates</a></li>\r\n        <li><a href='#/library/steptemplates/community/{{ templateId }}/details/{{projectIdUrlFragment}}'>{{communityTemplate.Name}} template details</a></li> </script> <div> <error-box error=isLoading.error></error-box> <error-box error=isSaving.error></error-box> <div ng-if=communityTemplate> <library-step-template-details current-version=currentVersion template=communityTemplate cancel-button-name=cancelButtonName on-cancel=cancel update-button-name=updateButtonName on-update=update install-button-name=installButtonName on-install=install resolve-link=resolveLink></library-step-template-details> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 813 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/community_step_template_saveas.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-hide=isWorking.busy ng-click=close()>×</button> <h3>Copy of '{{action.Name}}'</h3> </div> <div class=modal-body> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <div class=\"alert alert-info\"> Save a copy to keep your changes. <a class=alert-link href=http://g.octopushq.com/CommunityContributedStepTemplates target=_blank>Community step templates</a> are read-only because they are linked to the <a class=alert-link href=http://g.octopushq.com/CommunityContributedStepTemplates>Community Library</a>. </div> <form class=form-inline> <div class=form-group style=margin-left:34px> <label for=newActionNameTextBox>Save as</label> <input id=newActionNameTextBox class=form-control style=width:384px type=text ng-model=newActionName> </div> </form> </div> </div> </div> <div class=modal-footer> <div> <button class=\"btn btn-default\" ng-click=cancel()>Cancel</button> <button class=\"btn btn-success\" ng-click=save()>Continue</button> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 814 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/community_step_template_update.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-hide=isWorking.busy ng-click=close()>×</button> <h3>Update '{{action.Name}}' step template</h3> </div> <div class=modal-body> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <p> Updating this step template will make the latest version available from within projects. Existing releases and deployments won't be automatically updated. To update existing usages, go to the usage tab. </p> </div> </div> </div> <div class=modal-footer> <button class=\"btn btn-link pull-left\" ng-click=showDetails()>View details</button> <button class=\"btn btn-default\" ng-click=cancel()>Cancel</button> <button class=\"btn btn-success\" ng-click=update()>Update</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 815 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/default_action_property_values.html';
	var html = "<div class=modal-header> <h3>Parameter Default Values</h3> <p class=\"alert alert-info\"> New version of '{{actionTemplateName}}' step template introduces either new parameters without default values or converts sensitive parameters to regular parameters. You can provide default values for them here or use empty values. <span ng-if=isGlobalUpdate>The same values will be used for all steps. </span> </p> </div> <form> <div class=\"modal-body help-scope\"> <div ng-repeat=\"parameter in parameters\"> <control-group label=\"{{ parameter.Label || parameter.Name }}\"> <action-template-field ng-model=defaultPropertyValues[parameter.Name] parameter=parameter select-options=\"{StepName: allSteps}\"></action-template-field> <div class=help-block ng-show=parameter.HelpText> <markdown text=parameter.HelpText></markdown> </div> </control-group> </div> </div> <div class=modal-footer> <button class=\"btn btn-default\" ng-click=cancel()>Cancel</button> <button type=submit class=\"btn btn-success\" ng-click=apply()>Apply</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 816 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/steptemplates\">Step Templates</a></li>\r\n    <li ng-if=\"!isLoading.busy\">\r\n        <a href=\"#/library/steptemplates/{{actionTemplate.Id}}\">\r\n            <step-template-logo ng-if=\"actionTemplate.Links['Logo']\" resolve-link=\"resolveLink\" size=\"'xx-small'\"\r\n                                url=\"actionTemplate.Links['Logo']\"></step-template-logo>\r\n            {{ actionTemplate.Name || 'New step template' }}\r\n        </a>\r\n    </li> </script> <script octo-section=library_tools type=text/ng-template> <button type=\"button\" class=\"btn btn-link\" ng-disabled=\"unsavedChanges.hasUnsavedChanges()\" ng-click=\"export()\">\r\n        Export\r\n    </button>\r\n    <button ng-if=\"!isCommunityTemplate && !actionTemplate.Id\" octo-permission=\"ActionTemplateCreate\" type=\"button\"\r\n            class=\"btn btn-success\" ng-click=\"save()\">Save\r\n    </button>\r\n    <button ng-if=\"!isCommunityTemplate && actionTemplate.Id\" octo-permission=\"ActionTemplateEdit\" type=\"button\"\r\n            class=\"btn btn-success\" ng-click=\"save()\">Save\r\n    </button>\r\n    <button ng-if=\"isCommunityTemplate\" octo-permission=\"ActionTemplateEdit\" type=\"button\" class=\"btn btn-success\"\r\n            ng-click=\"saveAsCopy()\">Save as copy\r\n    </button> </script> <div class=\"row step-templates\"> <div class=col-sm-12> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: tab == 'step'}\"><a href ng-click=\"changeTab('step')\">Step</a></li> <li ng-class=\"{active: tab == 'parameters'}\"><a href ng-click=\"changeTab('parameters')\">Parameters</a></li> <li ng-class=\"{active: tab == 'settings'}\"><a href ng-click=\"changeTab('settings')\">Settings <i class=\"fa fa-volume-down action-update-notification\" ng-show=hasUpdate></i></a></li> <li ng-class=\"{active: tab == 'usage'}\"><a href ng-click=\"changeTab('usage')\" ng-show=actionTemplate.Id>Usage <span class=\"badge badge-warning\" ng-show=\"pendingUpdates > 0\">{{ pendingUpdates }}</span></a></li> <a ng-if=\"actionTemplate.Id && actionTemplate.ActionType === 'Octopus.Script'\" class=\"btn btn-info pull-right\" href=\"#/library/steptemplates/{{ actionTemplate.Id }}/run\">Run</a> </ul> <div class=\"tab-content pills-content\"> <div class=tab-pane ng-class=\"{active: tab == 'step'}\"> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div class=form-horizontal> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <p ng-if=!isCommunityTemplate class=tutorial>Configure the step using the fields below. Use the <strong>Parameters</strong> tab to define variables that can be used in scripts and bound fields.</p> <p ng-if=isCommunityTemplate class=tutorial>This community step template can receive updates from the author and cannot be edited. To customise this template, save as copy.</p> <form class=\"\" ng-submit=save() name=stepTemplateFieldsForm id=stepTemplateFieldsForm track-unsaved-changes> <div class=form-body> <action-editor action=actionTemplate project=noprop step=noprop feeds=feeds local-names=localNames></action-editor> <feature-editor project={} action=actionTemplate step={} enabled-features='actionTemplate.Properties[\"Octopus.Action.EnabledFeatures\"]' local-names=localNames></feature-editor> <div ng-show=hasFeatures> <hr/> <div class=clearfix> <div class=text-center> <a class=\"btn btn-link btn-default\" href ng-click=showAddFeaturesDialog()>Configure features</a> </div> </div> <hr/> </div> </div> </form> </div> </div> </div> </div> <div class=tab-pane ng-class=\"{active: tab == 'parameters'}\"> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <div class=\"\"> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <p class=tutorial>Parameters define variables that are set when the step template is included in a project's deployment process.</p> <ul class=\"octo-list-group can-add\"> <li class=octo-list-group-item ng-repeat=\"parameter in actionTemplate.Parameters track by parameter.Name\"> <button class=\"close remove-button\" type=button ng-click=templateEditor.removeTemplate(parameter)>× </button> <h4 class=octo-list-group-item-heading><a href ng-click=templateEditor.editTemplate(parameter)>{{ parameter.Label || parameter.Name }}</a></h4> <p><code><span>#{</span>{{parameter.Name}}<span>}</span><span ng-show=parameter.DefaultValue> = {{parameter.DefaultValue}}</span></code> </p> <markdown text=parameter.HelpText></markdown> </li> </ul> <div class=\"text-center margin-top-20 octo-list-group\"> <button class=\"btn btn-info\" octo-permission=ActionTemplateEdit type=button ng-class=\"{ 'octo-list-group-add': actionTemplate.Parameters.length }\" ng-click=templateEditor.addTemplate()><i class=icon-plus></i> Add parameter </button> </div> </div> </div> </div> </div> </div> <div class=tab-pane ng-class=\"{active: tab == 'settings'}\"> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <form class=\"\" ng-submit=save() name=stepTemplateForm id=stepTemplateForm track-unsaved-changes> <div class=form-body> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <p class=tutorial>These details will be shown in the deployment process <strong>Add step</strong> dialog.</p> <control-group label=Name> <input class=form-control type=text ng-model=actionTemplate.Name> <p class=help-block>A short, memorable, unique name for this step template. Example: <em>Success Notification</em></p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=actionTemplate.Description markitup rows=7></textarea> <p class=help-block>This summary will be presented to users when selecting the step template for inclusion in a project.</p> </control-group> <last-modified model=actionTemplate></last-modified> </div> </form> </div> </div> <div class=\"col-sm-3 col-md-3 col-lg-3\"> <div class=other-actions octo-permission=ActionTemplateDelete ng-show=hasUpdate> <h3>Update</h3> <p> Current version: <strong>{{actionTemplate.Version}}</strong><br> New version: <strong>{{communityStepTemplate.Version}}</strong><br><br> Please review the <a class=alert-link href={{communityStepTemplate.HistoryUrl}} target=_blank>history of this template</a> to find out what's changed.</p> <button ng-click=updateTemplate() class=\"btn btn-warning\">Update</button> </div> <br> <div class=other-actions ng-if=actionTemplate.Id> <h3>Logo</h3> <step-template-logo ng-if=\"actionTemplate.Links['Logo']\" size=\"'large'\" url=\"actionTemplate.Links['Logo']\" resolve-link=resolveLink></step-template-logo> <div class=margin-top-10> <a ng-if=!isCommunityTemplate octo-permission=ActionTemplateEdit class=\"btn btn-info\" href=#/library/steptemplates/{{actionTemplate.Id}}/logo>Change</a> <span ng-if=isCommunityTemplate>The logo of a community step template is read only. If you want to update it then you have to copy the template first. </span> </div> </div> <div class=other-actions octo-permission=ActionTemplateDelete ng-show=actionTemplate.Id> <h3>Delete</h3> <p>Step templates can only be deleted if they are no longer used by any deployment target.</p> <delete-button model=actionTemplate what=\"step template\" redirect=/library/steptemplates></delete-button> </div> </div> </div> </div> <div class=tab-pane ng-class=\"{active: tab == 'usage'}\"> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div class=\"form-box form-horizontal\"> <div class=\"\"> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <p>Current version: {{ actionTemplate.Version }}</p> <p class=help-block>Each time you update this template, the version number is incremented. You can see which versions of the template are being used in the table below.</p> <p class=tutorial ng-show=\"usage.length == 0\">This template has not been used by any projects yet.</p> <table class=\"table table-striped usage-list\" ng-show=\"usage.length > 0\"> <thead> <tr> <th>Project</th> <th>Step</th> <th>Version</th> <th class=action-status-header></th> </tr> </thead> <tbody> <tr ng-repeat=\"u in usage\"> <td class=project><a href=\"#/projects/{{ u.ProjectSlug }}\">{{ u.ProjectName }}</a></td> <td><a href=\"#/projects/{{ u.ProjectSlug }}/process/step/{{ u.ActionId }}\">{{ u.ActionName }}</a></td> <td> {{ u.Version }} </td> <td class=action-status> <div class=out-of-date-version ng-show=\"actionTemplate.Version != u.Version\"> <p>Out of date</p> </div> <div class=up-to-date-version ng-show=\"actionTemplate.Version == u.Version\"><p>Up to date</p></div> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 817 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/steptemplates\">Step Templates</a></li> </script> <div ng-if=\"userStepTemplates || communityStepTemplates\"> <loading-wrapper busy=isLoading> <installed-step-templates user-installed-templates=userStepTemplates add-custom-step-template-url=addCustomStepTemplateUrl community-step-templates-enabled=IsCommunityActionTemplatesEnabled community-installed-templates=communityStepTemplates install-community-step-template-url=installCommunityStepTempalteUrl resolve-link=resolveLink import=addImport></installed-step-templates> </loading-wrapper> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 818 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/run.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template ng-if=actionTemplate> <li><a href=\"#/library/steptemplates\">Step Templates</a></li>\r\n    <li>\r\n        <a href=\"#/library/steptemplates/{{actionTemplate.Id}}\">\r\n            <step-template-logo ng-if=\"actionTemplate.Links['Logo']\" resolve-link=\"resolveLink\" size=\"'xx-small'\"\r\n                                url=\"actionTemplate.Links['Logo']\"></step-template-logo>\r\n            {{ actionTemplate.Name || 'New step template' }}\r\n        </a>\r\n    </li>\r\n    <li><a href=\"#/library/steptemplates/{{actionTemplate.Id}}/run\">Run</a></li> </script> <div class=form-horizontal> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <h3>{{ actionTemplate.Name }}</h3> <markdown text=actionTemplate.Description></markdown> <p class=\"alert alert-warning\" ng-if=dependsOnStepName> One of the parameters of this step template depends on previous deployment step name which isn't available in this context. </p> <h4 class=separator>Targets</h4> <control-group label=Targets> <div class=radio> <label> <input type=radio ng-model=vm.selectionMode value=Machines> Select individual <em>deployment targets</em> to run the script on </label> </div> <div class=radio> <label> <input type=radio ng-model=vm.selectionMode value=Environments> Run the script on all deployment targets in set of <em>environments</em> and <em>roles</em> </label> </div> </control-group> <div ng-show=\"vm.selectionMode == 'Environments'\"> <control-group label=Environments> <select-environments placeholder=\"'All Environments'\" available=vm.environments ng-model=vm.environmentIds multiple=multiple></select-environments> </control-group> <control-group label=\"Target roles\"> <select-roles placeholder=\"'All Roles'\" available=vm.availableRoles ng-model=vm.targetRoles multiple=multiple></select-roles> <p class=help-block>Specify the deployment targets that the script will run on by selecting their roles.</p> </control-group> </div> <div ng-show=\"vm.selectionMode == 'Machines'\"> <control-group label=\"Target Endpoints\"> <select-machines placeholder=\"Select targets...\" available=vm.machines selected=vm.machineIds> </select-machines> </control-group> </div> <h4 class=separator>Parameters</h4> <form class=\"\" ng-submit=run() name=stepTemplateFieldsForm id=stepTemplateFieldsForm track-unsaved-changes> <div ng-repeat=\"parameter in actionTemplate.Parameters\"> <control-group label=\"{{ parameter.Label || parameter.Name }}\"> <bound-field local-names=localNames model=action.Properties[parameter.Name] reset-value=resetValues[parameter.Name] parameter=parameter> <action-template-field ng-model=action.Properties[parameter.Name] parameter=parameter></action-template-field> </bound-field> <div class=help-block ng-show=parameter.HelpText> <markdown text=parameter.HelpText></markdown> </div> </control-group> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Run now</button> <spin active=isSaving.busy></spin> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 819 */
/***/ function(module, exports) {

	var path = 'areas/library/steps/views/step_templates.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/library/steptemplates/'>Step Templates</a></li>\r\n    <li ng-if=\"installCommunityStep\">\r\n        <a href='#/library/steptemplates/community'>Community step templates</a>\r\n    </li>\r\n    <li ng-if=\"!installCommunityStep\">\r\n        <a href='#/library/steptemplates/builtin'>Custom step templates</a>\r\n    </li> </script> <div> <error-box error=isInstalling.error></error-box> <div class=step-templates> <h3>Choose step template</h3> <div class=search> <search-box input-text=inputText on-text-changed=filterTemplates placeholder=\"Filter by name, category or description\" auto-focus=true /> </div> <div ng-if=filteredBuiltInTemplates> <h4 class=separator>Installed step templates</h4> <step-templates templates=filteredBuiltInTemplates on-addition-requested=add add-button-name=addButtonName on-installation-requested=install install-button-name=installButtonName on-update-requested=update on-details-requested=details resolve-link=resolveLink></step-templates> <p ng-if=\"!filteredBuiltInTemplates.length && inputText\"> There are no installed step templates that match your filter criteria. </p> </div> <div ng-if=filteredLibraryTemplates> <h4 class=separator>Community contributed step templates</h4> <step-templates templates=filteredLibraryTemplates on-addition-requested=add add-button-name=addButtonName on-installation-requested=install install-button-name=installButtonName on-update-requested=update on-details-requested=details resolve-link=resolveLink enable-grouping=enableGrouping></step-templates> <p ng-if=\"!showLibraryTemplateTeaser && !showActionTemplateTeaser && filteredLibraryTemplates.length === 0 && !inputText\"> Community library integration is enabled but you don’t have access to the community step templates. Review the community step templates <a href=#/configuration/features target=_blank>feature toggle</a> for more information. </p> <p ng-if=\"!showLibraryTemplateTeaser && !showActionTemplateTeaser && !filteredLibraryTemplates.length && inputText\"> There are no community step templates that match your filter criteria. </p> </div> <p ng-if=showLibraryTemplateTeaser class=\"alert alert-info\"> Community library integration is disabled. If you want to access hundreds of step templates developed by our community members, please <a class=alert-link href=#/configuration/features>enable the integration feature.</a> </p> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 820 */
/***/ function(module, exports) {

	var path = 'areas/library/tagsets/views/color_picker.html';
	var html = "<span class=form-group> <script type=text/ng-template id=colorPickerTemplate> <span class=\"color-picker no-margin no-padding\">\r\n            <ul class=\"color-picker-list list-inline no-padding no-margin\">\r\n                <li class=\"no-margin no-padding\" ng-repeat=\"color in colorSet1\">\r\n                    <span class=\"color-picker-item\" ng-click=\"selectColor({message: color})\" ng-style=\"{ 'background-color': color }\"></span>\r\n                </li>\r\n            </ul>\r\n            <ul class=\"color-picker-list list-inline no-padding no-margin\">\r\n                <li class=\"no-margin no-padding\" ng-repeat=\"color in colorSet2\">\r\n                    <span class=\"color-picker-item\" ng-click=\"selectColor({message: color})\" ng-style=\"{ 'background-color': color }\"></span>\r\n                </li>\r\n            </ul>\r\n        </span> </script> <span class=color-picker-item ng-style=\"{ 'background-color': color }\"></span> <input class=\"form-control tagset-color\" id=newTagColor type=text ng-model=color uib-popover-template=\"'colorPickerTemplate'\" popover-trigger=focus /> </span> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 821 */
/***/ function(module, exports) {

	var path = 'areas/library/tagsets/views/create_tag_set.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/tagsets\">Tenant Tag Sets</a></li>\r\n    <li><a href=\"#/library/tagsets/new\">Create New</a></li> </script> <div> <error-box error=isSaving.error></error-box> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <form ng-submit=save() name=tagSetForm id=tagSetForm track-unsaved-changes> <div class=form-body> <control-group label=Name> <input class=form-control type=text ng-model=tagSet.Name id=Name> <p class=help-block>A short, memorable, unique name for this tag set. Examples: Customer Type, Hosting, Module.</p> </control-group> <control-group label=Description> <input class=form-control type=text ng-model=tagSet.Description id=Description> <p class=help-block>This summary will be presented to users when tagging the tenant, or applying tags to other entities.</p> </control-group> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 822 */
/***/ function(module, exports) {

	var path = 'areas/library/tagsets/views/edit_tag_set.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/tagsets\">Tenant Tag Sets</a></li>\r\n    <li><a href=\"#/library/tagsets/{{ tagSet.Id }}\">{{tagSet.Name}}</a></li> </script> <script octo-section=library_tools type=text/ng-template> <button octo-permission=\"TagSetEdit\" type=\"button\" class=\"btn btn-success\" ng-show=\"unsavedChanges.hasUnsavedChanges()\" ng-click=\"save()\">Save</button> </script> <div> <error-box error=isSaving.error></error-box> <div> <h3>Tag set</h3> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <form class=\"\" ng-submit=save() name=libraryTagSetForm id=libraryTagSetForm track-unsaved-changes> <div class=form-body> <control-group label=Name> <input class=form-control type=text ng-model=tagSet.Name> <p class=help-block>A short, memorable, unique name for this tag set. Examples: Customer Type, Hosting, Module.</p> </control-group> <control-group label=Description> <input class=form-control type=text ng-model=tagSet.Description> <p class=help-block>This summary will be presented to users when tagging the tenant, or applying tags to other entities.</p> </control-group> </div> <last-modified model=tagSet></last-modified> </form> </div> </div> <div class=\"col-sm-3 col-md-3 col-lg-3\"> <div class=other-actions octo-permission=TagSetDelete> <p>Tags that are in use cannot be deleted.</p> <delete-button model=tagSet what=\"tag set\" redirect=/library/tagsets></delete-button> </div> </div> </div> <h4 class=separator>Tags</h4> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div ng-if=\"tagSet.Tags.length <= 0\"> <p>Tags are like custom labels that can be applied to tenants to describe them, and work with them as groups.</p> </div> </div> </div> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div class=form-inline> <div> <form ng-submit=addTag() class=\"\" name=tagsForm id=tagsForm> <div class=form-group> <label class=sr-only for=newTagName>Name</label> <input type=text class=\"form-control tagset-name\" id=newTagName placeholder=\"New tag name...\" ng-model=newTag.Name> </div> <div class=form-group> <label class=sr-only for=newTagDesc>Description</label> <input type=text class=\"form-control tagset-description\" id=newTagDesc placeholder=\"Optional Description\" ng-model=newTag.Description> </div> <color-picker color=newTag.Color on-select-color=selectAddColor(message)></color-picker> <div class=form-group> <input type=submit ng-disabled=\"newTag.Name == null || newTag.Name === ''\" class=\"btn btn-success\" value=Add /> </div> <button type=button ng-if=\"tagSet.Tags.length > 1\" octo-permission=TagSetEdit class=\"btn btn-link pull-right\" ng-click=reorder()>Reorder tags</button> <last-modified model=tagSet></last-modified> </form> </div> </div> </div> </div> <div class=\"row margin-top-10\"> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div> <div class=\"alert alert-warning margin-top-5\" ng-if=showRemovedTagWarning> <p>You appear to be removing an existing tag. This action will fail if the tag is already in use.</p> </div> <table class=\"table table-bordered table-responsive\"> <tbody> <tr ng-repeat=\"tag in tagSet.Tags\"> <td ng-if=!tag.isEditing> <span class=tagset-tags ng-class=\"{'tag-delete' : tag.shouldBeRemoved}\"> <tenant-tag ng-model=tag></tenant-tag> </span> <small ng-class=\"{'tag-delete' : tag.shouldBeRemoved}\">{{ tag.Description }}</small> <div class=\"pull-right inline\" ng-show=\"!tag.isEditing && !tag.shouldBeRemoved\"> <span class=clickable ng-click=editTag(tag)><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp;<span class=clickable ng-click=removeTag(tag)><i class=\"fa fa-close\"></i> Delete</span> </div> <div class=\"pull-right inline\" ng-show=tag.shouldBeRemoved> <span class=clickable ng-click=undoRemoveTag(tag)><i class=\"fa fa-undo\"></i> Reset Changes</span> </div> </td> <td ng-if=tag.isEditing> <div class=form-inline> <form ng-submit=updateTag(tag) class=\"\" name=tagsEditorForm id=tagsEditorForm> <div class=form-group> <label class=sr-only for=editTagName>Name</label> <input type=text class=\"form-control tagset-name\" id=editTagName placeholder=\"New tag name...\" ng-model=tagToEdit.Name> </div> <div class=form-group> <label class=sr-only for=editTagDesc>Description</label> <input type=text class=\"form-control tagset-description\" id=editTagDesc placeholder=\"Optional Description\" ng-model=tagToEdit.Description> </div> <color-picker color=tagToEdit.Color on-select-color=selectEditColor(message)></color-picker> <div class=\"form-group pull-right\"> <button type=button class=\"btn btn-default\" ng-click=cancelEdit(tag)>Cancel</button> <input type=submit class=\"btn btn-success\" value=Update /> </div> <last-modified model=tagSet></last-modified> </form> </div> </td> </tr> </tbody> </table> </div> </div> </div> </div> <div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'areas/library/tagsets/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/tagsets\">Tag Sets</a></li> </script> <script octo-section=library_tools type=text/ng-template> <button type=\"button\" octo-permission=\"TagSetCreate\" class='btn btn-link' ng-click=\"reorder()\"\r\n            ng-show=\"tagSets.Items.length > 1\">Reorder\r\n    </button>\r\n    <a octo-permission=\"TagSetCreate\" class='btn btn-success' href=\"#/library/tagsets/new\">Add tenant tag set</a> </script> <div> <h3>Tenant tag sets</h3> <loading-wrapper busy=isLoading> <div ng-if=\"tagSets.Items.length <= 0\"> <div class=row> <div class=\"col-md-6 col-md-6\"> <p>Create tag sets to classify tenants and deal with tenants as groups throughout Octopus. By tagging your tenants you can: <ul> <li>more easily filter your dashboards,</li> <li>modify your deployment processes,</li> <li>scope variables,</li> <li>implement different hosting strategies, and</li> <li>deploy to groups of tenants.</li> </ul> </p> <p class=\"visible-sm visible-xs\"> <img class=img-responsive src=" + __webpack_require__(293) + " /> </p> <p>If you would like more information, or hints on how to get started with tags, take a look at our <a href=http://g.octopushq.com/MultiTenantTags target=_blank>documentation</a>.</p> <div class=text-center> <a octo-permission=TagSetCreate class=\"btn btn-lg btn-success\" href=#/library/tagsets/new>Create your first tenant tag set</a> </div> </div> <div class=\"col-md-6 col-lg-6 visible-lg visible-md\"> <img class=img-responsive src=" + __webpack_require__(293) + " /> </div> </div> </div> <div ng-if=\"tagSets.Items.length > 0\"> <p>Tags let you classify and deal with tenants as groups throughout Octopus. If you would like more information, or hints on getting the most benefit from your tags, take a look at our <a href=http://g.octopushq.com/MultiTenantTags target=_blank>documentation</a>.</p> </div> <div class=\"octo-list-group narrow-left narrow650 margin-bottom-20\"> <a class=\"octo-list-group-item clickable\" href=#/library/tagsets/{{tagSet.Id}} ng-repeat=\"tagSet in tagSets.Items\"> <h4 class=octo-list-group-item-heading>{{ tagSet.Name }}</h4> <p>{{ tagSet.Description }}</p> <tenant-tag ng-model=tag ng-repeat=\"tag in tagSet.Tags\"></tenant-tag> </a> </div> <octo-paginator collection=tagSets></octo-paginator> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 824 */
/***/ function(module, exports) {

	var path = 'areas/library/variables/views/create_variable_set.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/variables\">Variable Sets</a></li>\r\n    <li><a href=\"#/library/variables/new\">Create New</a></li> </script> <div> <error-box error=isSaving.error></error-box> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <form ng-submit=save() name=lvsForm id=lvsForm track-unsaved-changes> <div class=form-body> <control-group label=Name> <input class=form-control type=text ng-model=lvs.Name> <p class=help-block>A short, memorable, unique name for this variable set. Example: Connection Strings</p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=lvs.Description markitup rows=7></textarea> <p class=help-block>This summary will be presented to users when selecting the variable set for inclusion in a project.</p> </control-group> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 825 */
/***/ function(module, exports) {

	var path = 'areas/library/variables/views/edit_variable_set.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/variables\">Variable Sets</a></li>\r\n    <li><a href=\"#/library/variables/{{ lvs.Id }}\">{{lvs.Name}}</a></li> </script> <script octo-section=library_tools type=text/ng-template> <button octo-permission=\"LibraryVariableSetEdit\" type=\"button\" class=\"btn btn-success\" ng-show=\"unsavedChanges.hasUnsavedChanges()\" ng-click=\"save()\">Save</button> </script> <div> <loading-wrapper busy=isLoading> <div class=row> <div class=col-sm-12> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: tab == 'values'}\" ng-show=lvs.Id><a href ng-click=\"changeTab('values')\">Variables</a></li> <li octo-feature=IsMultiTenancyEnabled ng-class=\"{active: tab == 'templates'}\"><a href ng-click=\"changeTab('templates')\">Variable Templates</a></li> <li ng-class=\"{active: tab == 'settings'}\"><a href ng-click=\"changeTab('settings')\">Settings</a></li> </ul> </div> </div> <error-box error=isSaving.error></error-box> <div class=\"tabbable tabs-top\"> <div class=\"tab-content pills-content\"> <div class=tab-pane ng-class=\"{active: tab == 'values'}\" ng-include=\"'areas/library/variables/views/variable_set_values.html'\"></div> <div class=tab-pane octo-feature=IsMultiTenancyEnabled ng-class=\"{active: tab == 'templates'}\" ng-include=\"'areas/library/variables/views/variable_set_templates.html'\"></div> <div class=tab-pane ng-class=\"{active: tab == 'settings'}\" ng-include=\"'areas/library/variables/views/variable_set_settings.html'\"></div> </div> </div> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 826 */
/***/ function(module, exports) {

	var path = 'areas/library/variables/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/variables\">Variable Sets</a></li> </script> <script octo-section=library_tools type=text/ng-template> <a octo-permission=\"LibraryVariableSetCreate\" class='btn btn-success' href=\"#/library/variables/new\">Add variable set</a> </script> <div> <h3>Variable sets</h3> <p>Variable sets are collections of variables and variable templates that can be included in multiple projects.</p> <p ng-show=\"variableSets.Items.length == 0\">To create your first variable set, use the <strong>Add variable set</strong> button above.</p> <div class=\"octo-list-group narrow-left narrow650 margin-bottom-20\"> <a class=\"octo-list-group-item clickable\" href=#/library/variables/{{vs.Id}} ng-repeat=\"vs in variableSets.Items\"> <h4 class=octo-list-group-item-heading>{{ vs.Name }}</h4> <markdown text=vs.Description></markdown> </a> </div> <octo-paginator collection=variableSets content-type=\"'Variables'\"></octo-paginator> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 827 */
/***/ function(module, exports) {

	var path = 'areas/library/variables/views/variable_set_settings.html';
	var html = "<div class=row> <div class=\"col-xs-12 col-sm-9\"> <div class=\"form-box form-horizontal\"> <form ng-submit=save() track-unsaved-changes> <div class=form-body> <control-group label=Name> <input class=form-control type=text ng-model=lvs.Name> <p class=help-block>A short, memorable, unique name for this variable set. Example: Connection Strings</p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=lvs.Description markitup rows=7></textarea> <p class=help-block>This summary will be presented to users when selecting the variable set for inclusion in a project.</p> </control-group> </div> <last-modified model=lvs></last-modified> </form> </div> </div> <div class=\"col-xs-12 col-sm-3\"> <div class=other-actions octo-permission=LibraryVariableSetDelete> <p>Variable sets that are included in projects can't be deleted.</p> <delete-button model=lvs what=\"variable set\" redirect=/library/variables></delete-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 828 */
/***/ function(module, exports) {

	var path = 'areas/library/variables/views/variable_set_templates.html';
	var html = "<div class=row> <div class=col-xs-12> <p>Variable set templates define variables that are required when a project is deployed.</p> <div class=margin-top-bottom-10> <div class=\"tutorial tutorial-left\" ng-show=\"lvs.Templates.length == 0\"> <p>No variable templates have been defined yet. Use the <strong>Add variable template</strong> button below to get started.</p> </div> <div class=row> <div class=col-xs-9> <div class=\"form-box form-horizontal\"> <ul class=\"octo-list-group can-add\"> <li class=octo-list-group-item ng-repeat=\"template in lvs.Templates track by template.Name\"> <button class=\"close remove-button\" type=button ng-click=templateEditor.removeTemplate(template)>×</button> <h4 class=octo-list-group-item-heading><a href ng-click=templateEditor.editTemplate(template)>{{ template.Label || template.Name }}</a></h4> <p><code><span>#{</span>{{template.Name}}<span>}</span><span ng-show=template.DefaultValue> = {{template.DefaultValue}}</span></code></p> <markdown text=template.HelpText></markdown> </li> </ul> </div> </div> </div> </div> <div class=text-center> <a class=\"btn btn-info\" href ng-click=templateEditor.addTemplate()>Add variable template</a> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 829 */
/***/ function(module, exports) {

	var path = 'areas/library/variables/views/variable_set_values.html';
	var html = "<div class=row> <div class=col-xs-12> <div ng-show=vs> <variable-editor class=slick-grid-container-box ng-if=showVariableEditor data=variableEditorOptions tab=tab></variable-editor> <last-modified model=variableEditorOptions.variableSet></last-modified> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 830 */
/***/ function(module, exports) {

	var path = 'areas/library/views/library_layout.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library\">Library</a></li> </script> <script octo-section=tools type=text/ng-template> <spin active='isSaving.busy'></spin>\r\n  <unsaved-changes-indicator></unsaved-changes-indicator>\r\n  <div octo-placeholder=\"library_tools\" style=\"display: inline;\">\r\n  </div> </script> <div class=\"page-body layout-sidebar\"> <div id=sidebar style=display:inherit ng-cloak> <div class=list-group> <a class=list-group-item octo-permission=FeedView wildcard ng-class=\"{active: $root.layout.libraryTab == 'packages'}\" href=#/library/packages>Packages</a> <a class=list-group-item octo-permission=FeedView wildcard ng-class=\"{active: $root.layout.libraryTab == 'feeds'}\" href=#/library/feeds>External feeds</a> <a class=list-group-item octo-permission=LifecycleEdit wildcard ng-class=\"{active: $root.layout.libraryTab == 'lifecycles'}\" href=#/library/lifecycles>Lifecycles</a> <a class=list-group-item octo-permission=VariableView ng-class=\"{active: $root.layout.libraryTab == 'scripts'}\" href=#/library/scripts>Script modules</a> <a class=list-group-item octo-permission=ActionTemplateView ng-class=\"{active: $root.layout.libraryTab == 'steptemplates'}\" href=#/library/steptemplates>Step templates</a> <a class=list-group-item octo-permission=VariableView wildcard ng-class=\"{active: $root.layout.libraryTab == 'tagsets'}\" octo-feature=IsMultiTenancyEnabled href=#/library/tagsets>Tenant tag sets</a> <a class=list-group-item octo-permission=VariableView wildcard ng-class=\"{active: $root.layout.libraryTab == 'variables'}\" href=#/library/variables>Variable sets</a> </div> </div> <div id=content-wrapper ng-cloak> <div id=view-container height-magic> <ui-view></ui-view> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 831 */
/***/ function(module, exports) {

	var path = 'areas/management/views/console.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/tasks\">Tasks</a></li>\r\n    <li><a href=\"#/manage/console\">Script Console</a></li> </script> <script octo-section=tools type=text/ng-template> <spin active='vm.isLoading.busy'></spin> </script> <h3>Script Console</h3> <loading-wrapper busy=vm.isLoading> <form class=\"form-box form-horizontal\" name=scriptConsoleForm ng-submit=vm.run() track-after=1000 track-unsaved-changes> <p class=tutorial> Use the <em>Script Console</em> to run one-off scripts remotely on deployment targets. Scripts run this way are not associated with projects or deployments. </p> <div class=form-body> <error-box error=vm.isSaving.error></error-box> <control-group label=Targets> <div class=radio> <label> <input type=radio ng-model=vm.selectionMode value=Machines> Select individual <em>deployment targets</em> to run the script on </label> </div> <div class=radio> <label> <input type=radio ng-model=vm.selectionMode value=Environments> Run the script on all deployment targets in set of <em>environments</em> and <em>roles</em> </label> </div> </control-group> <div ng-show=\"vm.selectionMode == 'Environments'\"> <control-group label=Environments> <select-environments placeholder=\"'All Environments'\" available=vm.environments ng-model=vm.environmentIds multiple=multiple></select-environments> </control-group> <control-group label=\"Target roles\"> <select-roles placeholder=\"'All Roles'\" available=vm.availableRoles ng-model=vm.targetRoles multiple=multiple></select-roles> <p class=help-block>Specify the deployment targets that the script will run on by selecting their roles.</p> </control-group> </div> <div ng-show=\"vm.selectionMode == 'Machines'\"> <control-group label=\"Target Endpoints\"> <select-machines placeholder=\"Select targets...\" available=vm.machines selected=vm.machineIds> </select-machines> </control-group> </div> <control-group label=\"Script body\"> <script-editor id=scriptEditor syntax=vm.syntax body=vm.scriptBody no-variables=true> </script-editor> <p class=help-block> <strong>Tip —</strong> you can use the <code>New-OctopusArtifact &lt;filename&gt;</code> function to collect files from the remote deployment targets. </p> </control-group> </div> <div class=form-actions> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=vm.isSaving.busy>Run now</button> </div> </form> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 832 */
/***/ function(module, exports) {

	var path = 'areas/master/views/layout.html';
	var html = " <div id=main-navbar class=navbar role=navigation ng-cloak ng-if=\"$root.layout.layout !== 'layout-blank' || $root.isEarlyAccessProgram\"> <main-navigation-bar></main-navigation-bar> </div> <page-banners></page-banners> <div class=page-header> <div class=row> <div class=\"col-xs-12 col-sm-6\"> <ul class=breadcrumb octo-placeholder=breadcrumbs /> </div> <div class=\"col-xs-12 col-sm-6\"> <div octo-placeholder=tools class=pull-right-sm></div> </div> </div> <div class=\"row layout-tabbed-header\"> <div octo-placeholder=tabs></div> </div> </div> <div class=page-body> <div id=sidebar ng-cloak> <div octo-placeholder=sidebar></div> </div> <div id=content-wrapper ng-cloak> <div id=view-container> <div class=view-frame><ui-view></ui-view></div> </div> </div> </div> <div id=dynamicallyGeneratedContent></div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 833 */
/***/ function(module, exports) {

	var path = 'areas/master/views/main_navigation_bar.html';
	var html = "<div> <div class=navbar-inner> <div class=navbar-header ng-class=\"{'early-access-program': $root.isEarlyAccessProgram}\"> <a href=#/ class=navbar-brand> <i id=logo class=fontoctopus-octopus title=\"Octopus Deploy\"></i> </a> <a id=eap-message ng-if=$root.isEarlyAccessProgram href=http://g.octopushq.com/WhatIsEAP target=_blank class=\"hidden visible-lg-inline\" tooltip-placement=bottom uib-tooltip=\"Due to the unstable nature of EAP releases we do not recommend using them in production, or upgrading them to/from a production instance\"> <i class=\"fa fa-warning\"></i> EAP Release - {{$root.octopusVersion}} </a> <button ng-show=$root.isAuthenticated type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#main-navbar-collapse><i class=\"navbar-icon fa fa-bars\"></i></button> </div> <div id=main-navbar-collapse class=\"collapse navbar-collapse main-navbar-collapse\"> <div class=\"right clearfix\" ng-show=\"$root.isAuthenticated && $root.layout.layout !== 'layout-blank'\"> <ul class=\"nav navbar-nav pull-right right-navbar-nav\"> <li ng-class=\"{active: $root.layout.tab=='dashboard'}\"><a href=#/ >Dashboard</a></li> <li octo-permission=ProjectView wildcard ng-class=\"{active: $root.layout.tab=='projects', dropdown: true}\"> <a class=dropdown-toggle href=\"\" data-toggle=dropdown ng-click=beginRefreshProjects()>Projects <i class=\"fa fa-chevron-down hidden-xs\"></i></a> <ul class=dropdown-menu> <li><a href=#/projects>All</a></li> <li class=divider ng-show=hasProjects></li> <li class=dropdown-item-container ng-repeat=\"item in projectMenuItems\"> <span class=dropdown-header ng-hide=item.Slug>{{ item.Name }}</span> <a style=\"padding:3px 30px\" href ng-href=\"#/projects/{{ item.Slug }}\" ng-show=item.Slug>{{ item.Name }}</a> </li> </ul> </li> <li octo-permission=TenantView ng-class=\"{active: $root.layout.tab=='tenants'}\" octo-feature=IsMultiTenancyEnabled><a href=#/tenants>Tenants</a></li> <li octo-permission=MachineView wildcard ng-class=\"{active: $root.layout.tab=='environments'}\"><a href=#/environments>Environments</a></li> <li octo-permission=FeedView,LifecycleEdit,VariableView,ActionTemplateView wildcard ng-class=\"{active: $root.layout.tab=='library'}\"><a href=#/library>Library</a></li> <li octo-permission=TaskView wildcard ng-class=\"{active: $root.layout.tab=='tasks'}\"><a href=#/tasks>Tasks</a></li> <li ng-class=\"{active: $root.layout.tab=='user', dropdown: true}\" data-hovermenu=user_menu> <a class=dropdown-toggle href=# data-toggle=dropdown><div class=user-image><avatar model=$root.currentUser></avatar></div> {{$root.currentUser.DisplayName}} <i class=\"fa fa-chevron-down hidden-xs\"></i></a> <ul class=dropdown-menu> <li><a href=#/users/me>Profile</a></li> <li ng-if=canChangePassword()><a href=#/users/me>Change password</a></li> <li><a href=#/users/sign-out>Sign out</a></li> </ul> </li> <li octo-permission=AdministerSystem,AuditView,TeamView ng-class=\"{active: $root.layout.tab=='configuration', dropdown: ''}\"><a href=#/configuration>Configuration</a></li> <li ng-show=showUpgradeBullhorn> <a href=http://g.octopushq.com/ProductDownloadPage ng-href=\"https://octopus.com/downloads/compare?from={{$root.octopusVersion}}&to={{maximumAvailableVersion}}\" target=_blank uib-tooltip=\"Version {{maximumAvailableVersion}} of Octopus has been released{{canUpgradeFreeOfCharge ? ' and you can upgrade free of charge!' : '. Your license expired on ' + maintenanceExpires + ' and covers updates through to ' + maximumAvailableVersionCoveredByLicense + '. Please renew your license to upgrade to ' + maximumAvailableVersion + '.'}}\" tooltip-placement=bottom> <i class=\"fa fa-lg fa-bullhorn\"></i> </a> </li> <li class=dropdown> <a class=dropdown-toggle data-toggle=dropdown href=\"\"> <i class=\"fa fa-lg fa-question-circle\"></i> </a> <ul class=dropdown-menu> <li class=dropdown-header>Octopus {{$root.octopusVersion}}</li> <li class=divider></li> <li><a href=http://g.octopushq.com/DocumentationHome target=_blank class=external>Documentation</a></li> <li><a href=http://g.octopushq.com/HelpGeneral target=_blank class=external>Help &amp; Support</a></li> <li><a href=http://g.octopushq.com/TrainingVideos target=_blank class=external>Training Videos</a></li> <li><a href=http://g.octopushq.com/HelpMakeSuggestion target=_blank class=external>Suggestions</a></li> <li class=divider></li> <li><a href=http://octopusdeploy.com/downloads target=_blank class=external>Downloads</a></li> </ul> </li> </ul> </div> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 834 */
/***/ function(module, exports) {

	var path = 'areas/master/views/page-banners.html';
	var html = "<div id=page-banners> <div class=\"alert alert-warning alert-page\" ng-show=isInMaintenanceMode> <p>This Octopus server is currently undergoing maintenance, and is read-only. Only Octopus administrators may make changes.</p> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 835 */
/***/ function(module, exports) {

	var path = 'areas/projects/action-template-fields/field-AzureAccount.html';
	var html = "<div> <ui-select ng-model=vm.value append-to-body=true> <ui-select-match placeholder=\"{{vm.placeholder || 'Select Account'}}\" allow-clear=true> <i class=\"fa account-icon-{{$select.selected.AccountType}}\"></i>{{$select.selected.Name}} </ui-select-match> <ui-select-choices repeat=\"item.Id as item in vm.getSelectOptions() | filter: { AccountType: 'AzureSubscription'} | filter:{Name: $select.search} track by item.Id\"> <i class=\"fa account-icon-{{item.AccountType}}\"></i> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 836 */
/***/ function(module, exports) {

	var path = 'areas/projects/action-template-fields/field-Checkbox.html';
	var html = "<div> <input type=checkbox ng-model=vm.value name=\"checkbox_{{parameter.Name.replace('.', '_')}}\" ng-true-value=\"'True'\" ng-false-value=\"'False'\"> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 837 */
/***/ function(module, exports) {

	var path = 'areas/projects/action-template-fields/field-MultiLineText.html';
	var html = "<div> <textarea ng-model=vm.value class=form-control rows=6 placeholder={{vm.placeholder}}></textarea> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 838 */
/***/ function(module, exports) {

	var path = 'areas/projects/action-template-fields/field-Select.html';
	var html = "<div> <div style=position:absolute>{{vm.placeholder}}</div> <select class=form-control ng-model=vm.value ng-options=\"option.Value as option.DisplayText for option in vm.getSelectOptions()\"> </select> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 839 */
/***/ function(module, exports) {

	var path = 'areas/projects/action-template-fields/field-Sensitive.html';
	var html = "<div> <sensitive-input model=vm.value></sensitive-input> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 840 */
/***/ function(module, exports) {

	var path = 'areas/projects/action-template-fields/field-SingleLineText.html';
	var html = "<div> <input class=form-control type=text ng-model=vm.value placeholder={{vm.placeholder}}> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 841 */
/***/ function(module, exports) {

	var path = 'areas/projects/action-template-fields/field-StepName.html';
	var html = "<div> <ui-select ng-model=vm.value append-to-body=true class=form-control> <ui-select-match allow-clear=true placeholder=\"Select Step\">{{$select.selected}}</ui-select-match> <ui-select-choices repeat=\"item in vm.getSelectOptions() | filter:$select.search\"> <span ng-bind-html=\"item | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 842 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.Email_edit.html';
	var html = "<h4 class=separator>Send an email</h4> <div> <p class=help-block> This step sends an email. You'll need to configure an SMTP server before email will be sent. </p> <control-group label=To> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Email.To\"]' reset-value=\"''\" project-id=project.Id> <email-addresses-input model='action.Properties[\"Octopus.Action.Email.To\"]'></email-addresses-input> </bound-field> <p class=help-block>At least one <em>To</em> address or <em>Team</em> must be entered.</p> </control-group> <control-group label=\"To teams\"> <select-custom multiple=true allow-clear=true csv-split-formatter placeholder=\"'Select team(s)'\" available=teams ng-model='action.Properties[\"Octopus.Action.Email.ToTeamIds\"]'> </select-custom> <p class=help-block>Each member of these teams will receive an email.</p> </control-group> <div ng-hide=email.showCCBcc> <control-group label> <button class=\"btn btn-link btn-default\" type=button ng-click=showCCBcc()>CC, BCC…</button> </control-group> </div> <div ng-show=email.showCCBcc> <control-group label=CC> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Email.CC\"]' reset-value=\"''\" project-id=project.Id> <email-addresses-input model='action.Properties[\"Octopus.Action.Email.CC\"]'></email-addresses-input> </bound-field> </control-group> <control-group label=\"CC teams\"> <select-custom multiple=true allow-clear=true csv-split-formatter placeholder=\"'Select team(s)'\" available=teams ng-model='action.Properties[\"Octopus.Action.Email.CCTeamIds\"]'> </select-custom> </control-group> <control-group label=BCC> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Email.Bcc\"]' reset-value=\"''\" project-id=project.Id> <email-addresses-input model='action.Properties[\"Octopus.Action.Email.Bcc\"]'></email-addresses-input> </bound-field> </control-group> <control-group label=\"BCC teams\"> <select-custom multiple=true allow-clear=true csv-split-formatter placeholder=\"'Select team(s)'\" available=teams ng-model='action.Properties[\"Octopus.Action.Email.BccTeamIds\"]'> </select-custom> </control-group> </div> <control-group label=Subject> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Email.Subject\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Email.Subject\"]'> </bound-field> </control-group> <control-group label=Body> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Email.Body\"]' reset-value=\"''\" project-id=project.Id> <textarea class=form-control ng-model='action.Properties[\"Octopus.Action.Email.Body\"]' rows=7></textarea> </bound-field> <p class=help-block>This field supports extended template syntax. Conditional <code>if</code> and <code>unless</code>:</p> <pre class=help-block>#{if MyVar}...#{/if}</pre><br/> <p class=help-block>Iteration over variable sets or comma-separated values with <code>each</code>:</p> <pre class=help-block>#{each mv in MyVar}...#{mv}...#{/each}</pre> </control-group> <control-group label> <div class=checkbox><label><input type=checkbox ng-model='action.Properties[\"Octopus.Action.Email.IsHtml\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Body is HTML</label></div> </control-group> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 843 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.Email_summary.html';
	var html = "<p> Send an email to <a href=\"mailto:{{ properties['Octopus.Action.Email.To'] }}\">{{ properties[\"Octopus.Action.Email.To\"] }}</a> <tag-list tags=emailTeams></tag-list> <span ng-show=\"properties['Octopus.Action.Email.CC'] || properties['Octopus.Action.Email.CCTeamIds'] || properties['Octopus.Action.Email.Bcc'] || properties['Octopus.Action.Email.BccTeamIds']\"> (including CC/BCC)</span> </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 844 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.HealthCheck_edit.html';
	var html = "<h4 class=separator>Health check</h4> <control-group label=\"Health check type:\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.HealthCheck.Type\"]' value=FullHealthCheck> Perform a full health check</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.HealthCheck.Type\"]' value=ConnectionTest> Perform a connection-only test</label> </control-group> <control-group label=\"Health check errors:\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.HealthCheck.ErrorHandling\"]' value=TreatExceptionsAsErrors> Fail the deployment</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.HealthCheck.ErrorHandling\"]' value=TreatExceptionsAsWarnings> Skip deployment targets that are unavailable</label> </control-group> <h4 class=separator>Machine selection</h4> <control-group label=\"New deployment targets:\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.HealthCheck.IncludeMachinesInDeployment\"]' value=DoNotAlterMachines> Ignore any newly available deployment targets</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.HealthCheck.IncludeMachinesInDeployment\"]' value=IncludeCheckedMachines> Include new deployment targets in the deployment</label> </control-group> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 845 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.HealthCheck_summary.html';
	var html = "<p> Perform a <span ng-switch on='properties[\"Octopus.Action.HealthCheck.Type\"]'> <span ng-switch-when=FullHealthCheck>full health check</span> <span ng-switch-when=ConnectionTest>connection check</span> </span> <span ng-if='properties[\"Octopus.Action.TargetRoles\"]'> for roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list> </span> </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 846 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.IIS_summary.html';
	var html = "<p> Deploy IIS WebSite using package <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show=isSingleStep>to machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 847 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.Manual_edit.html';
	var html = "<h4 class=separator>Manual intervention</h4> <div> <p class=help-block> This step is used to pause deployment for a human to intervene. It can be used at the start of a deployment to check for approval, or during a deployment to perform an action or verify before continuing with a deployment. </p> <control-group label=Instructions> <div class=bound-field> <div class=insert-variable> <insert-variable-button syntax=Octopus project-id=project.Id local-names=localNames></insert-variable-button> </div> <textarea ng-model='action.Properties[\"Octopus.Action.Manual.Instructions\"]' markitup class=form-control rows=7></textarea> </div> <p class=help-block>These instructions will be presented to the user to follow.</p> </control-group> <control-group label=\"Responsible teams\"> <select-custom multiple=true csv-split-formatter placeholder=\"'All authorized teams'\" available=teams ng-model='action.Properties[\"Octopus.Action.Manual.ResponsibleTeamIds\"]'> </select-custom> <p class=help-block>If no teams are specified, all users who have permission to deploy the project will be able to perform the manual step. When one or more teams are specified, as in the case of an approval workflow, then only members of those teams will be able to perform the step.</p> <p class=help-block>Specifying responsible teams will make the step unable to be skipped.</p> </control-group> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 848 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.Manual_summary.html';
	var html = "<p> Manual intervention </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 849 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.Script_edit.html';
	var html = "<h4 class=separator>Script Source</h4> <control-group label=\"Script source\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Inline> Source code</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Package> Script file inside a package</label> </control-group> <div ng-if=\"action.Properties['Octopus.Action.Script.ScriptSource'] == 'Package'\"> <h4 class=separator>Package</h4> <package-selector action=action project=project feeds=feeds local-names=localNames></package-selector> <h4 class=separator>Script</h4> <control-group label=\"Script file name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Script.ScriptFileName\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Script.ScriptFileName\"]'> </bound-field> <p class=help-block>The relative path to the script file within the package.</p> <p class=help-block>e.g. <code>MyScript.ps1</code> or <code>Scripts\\MyScript.ps1</code></p> </control-group> <control-group label=\"Script parameters\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Script.ScriptParameters\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Script.ScriptParameters\"]'> </bound-field> <p class=help-block>Parameters expected by the script. Use platform specific calling convention.</p> <p class=help-block>e.g. <code>-Path #{VariableStoringPath}</code> for PowerShell or <code>-- #{VariableStoringPath}</code> for ScriptCS</p> </control-group> </div> <div ng-if=\"action.Properties['Octopus.Action.Script.ScriptSource'] != 'Package'\"> <h4 class=separator>Script</h4> <div> <div class=\"alert alert-info form-group-narrow\" ng-show='action.Properties[\"Octopus.Action.RunOnServer\"] === \"true\" && step.Properties[\"Octopus.Action.TargetRoles\"]'> When running a script step on the Octopus Server on behalf of deployment targets <a class=alert-link target=_blank href=http://g.octopushq.com/StandaloneScripts>variables in the scope of each deployment target are available to the script</a>. </div> <script-editor id=scriptEditor syntax=\"action.Properties['Octopus.Action.Script.Syntax']\" syntax-filter=syntaxFilter body=\"action.Properties['Octopus.Action.Script.ScriptBody']\" project-id=project.Id local-names=localNames></script-editor> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 850 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.Script_summary.html';
	var html = "<div ng-switch on='properties[\"Octopus.Action.RunOnServer\"]'> <p ng-switch-when=true> Run a script on the Octopus Server <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> <p ng-switch-default=\"\"> Run a script <span ng-show=isSingleStep>across targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 851 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.TentaclePackage_edit.html';
	var html = "<h4 class=separator>Package</h4> <div ng-show=\"feeds.length > 0\"> <p class=help-block> This step is used to deploy the contents of a package to one or more machines. You can configure the remote machines to deploy to in the <a href=#/environments>environments</a> tab. The package that you wish to deploy should contain all the files needed to run your application. Learn more about <a href=http://octopusdeploy.com/documentation/packaging>what your packages should contain, and how to create them</a>. </p> </div> <div> <spin active=isLoading.busy></spin> <package-selector action=action project=project feeds=feeds local-names=localNames></package-selector> <package-download-options action=action local-names=localNames></package-download-options> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 852 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.TentaclePackage_summary.html';
	var html = "<p> Deploy package <strong>{{ packageId }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ feedId }}</em> <span ng-show=isSingleStep>to machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 853 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/Octopus.WindowsService_summary.html';
	var html = "<p> Deploy Windows Service using package <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show=isSingleStep>to machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 854 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_edit.html';
	var html = "<azure-powershell-script-info></azure-powershell-script-info> <h4 class=separator>Package</h4> <div ng-show=\"feeds.length > 0\"> <p class=help-block> This step is used to deploy the contents of a package. The package that you wish to deploy should contain all the files needed to run your application. Learn more about <a href=http://octopusdeploy.com/documentation/packaging>what your packages should contain, and how to create them</a>. </p> </div> <div> <spin active=isLoading.busy></spin> <package-selector action=action project=project feeds=feeds local-names=localNames></package-selector> <h4 class=separator>Azure</h4> <div ng-show=usingLegacySubscriptionId ng-cloak> <div class=\"alert alert-warning\"> <p>This step is using a subscription ID value imported from Octopus Deploy 2. This value, along with the default Azure certificate, will be used until an Account is selected below. From then on the subscription details from the selected Account will be used.</p> </div> <control-group label=Subscription> <input type=text class=form-control disabled=true value='{{action.Properties[\"Octopus.Action.Azure.SubscriptionId\"]}}'> </control-group> </div> <control-group label=Account> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.AccountId\"]' reset-value=getAccountId() project-id=project.Id bound=account.bound> <account-selector endpoint=account type=AzureSubscription></account-selector> </bound-field> </control-group> <azure-cloud-service-selector model=azure project-id=project.Id get-account-id=getAccountId locked-to-bound=cloudServiceLockedToBound></azure-cloud-service-selector> <h4 class=separator>Deployment</h4> <control-group label=Slot> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.Slot\"]' reset-value=reset.slot project-id=project.Id> <select ng-model='action.Properties[\"Octopus.Action.Azure.Slot\"]' class=form-control required id=slot> <option>Staging</option> <option>Production</option> </select> </bound-field> <p class=help-block>Usually <em>Production</em> or <em>Staging</em>.</p> </control-group> <control-group label=Swap> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.SwapIfPossible\"]' value=False> Always deploy</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.SwapIfPossible\"]' value=True> Swap staging to production if possible</label> <p class=help-block> Azure allows staging and production deployments to be swapped, by switching virtual IP addresses. When deploying to production, Octopus can detect whether the current staging deployment can be swapped, and if so, it can do a swap rather than a new deployment. </p> </control-group> <control-group label=\"Instance count\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.UseCurrentInstanceCount\"]' value=True> Use the instance count from the current Azure deployment</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.UseCurrentInstanceCount\"]' value=False> Use the instance count defined in the service configuration XML file</label> <p class=help-block> If you have previously scaled your service by changing the number of instances using the Azure management portal, Octopus can retrieve these values and use them in the deployment, so that the instance count remains unchanged. </p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 855 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_summary.html';
	var html = "<p> Deploy Azure Cloud Service <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 856 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_cloud_service/azure_cloud_service_selector.html';
	var html = "<div> <control-group label=\"Cloud service\"> <loading-wrapper busy=vm.isLoading> <bound-field is-locked=lockedToBound local-names=localNames model=vm.model.cloudServiceName reset-value=vm.reset.cloudServiceName project-id=vm.projectId> <ui-select ng-model=vm.selectedCloudService ng-change=vm.changed() append-to-body=true> <ui-select-match placeholder=\"Select Cloud Service\" allow-clear=true>{{$select.selected.Name}} <i>- {{$select.selected.Location}}</i></ui-select-match> <ui-select-choices repeat=\"item in vm.cloudServices | filter:{Name: $select.search} track by item.Name\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> <i>- {{item.Location}}</i> </ui-select-choices> </ui-select> </bound-field> </loading-wrapper> <p class=help-block>The name of the cloud service to which files will be deployed.</p> </control-group> <control-group label=\"Storage account\"> <loading-wrapper busy=vm.isLoading> <bound-field is-locked=lockedToBound local-names=localNames model=vm.model.storageAccountName reset-value=vm.reset.storageAccountName project-id=vm.projectId> <ui-select ng-model=vm.selectedStorageAccount ng-change=vm.changed() append-to-body=true> <ui-select-match placeholder=\"Select Storage Account\" allow-clear=true>{{$select.selected.Name}} - {{$select.selected.Location}}</ui-select-match> <ui-select-choices repeat=\"item in vm.storageAccounts |  filter:{Name: $select.search} track by item.Name\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> <i>- {{item.Location}}</i> </ui-select-choices> </ui-select> </bound-field> </loading-wrapper> <p class=help-block>The name of a storage account that <em>CSPKG</em> files will be uploaded to before deployment.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 857 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_edit.html';
	var html = "<azure-powershell-script-info></azure-powershell-script-info> <h4 class=separator>Account</h4> <control-group label=Account> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.AccountId\"]' reset-value=reset.account project-id=project.Id> <account-selector endpoint=account type=AzureSubscription,AzureServicePrincipal></account-selector> </bound-field> </control-group> <control-group label=\"Script source\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Inline> Source code</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Package> Script file inside a package</label> </control-group> <div ng-show=\"action.Properties['Octopus.Action.Script.ScriptSource'] == 'Package'\"> <h4 class=separator>Package</h4> <package-selector action=action project=project feeds=feeds local-names=localNames></package-selector> <h4 class=separator>Script</h4> <azure-powershell-account-info></azure-powershell-account-info> <control-group label=\"Script file name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Script.ScriptFileName\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Script.ScriptFileName\"]'> </bound-field> <p class=help-block>The relative path to the script file within the package.</p> <p class=help-block>e.g. <code>MyScript.ps1</code> or <code>Scripts\\MyScript.ps1</code></p> </control-group> <control-group label=\"Script parameters\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Script.ScriptParameters\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Script.ScriptParameters\"]'> </bound-field> <p class=help-block>Parameters expected by the script. Use platform specific calling convention.</p> <p class=help-block>e.g. <code>-Path #{VariableStoringPath}</code> for PowerShell or <code>-- #{VariableStoringPath}</code> for ScriptCS</p> </control-group> </div> <div ng-hide=\"action.Properties['Octopus.Action.Script.ScriptSource'] == 'Package'\"> <h4 class=separator>Script</h4> <azure-powershell-account-info></azure-powershell-account-info> <div> <script-editor id=scriptEditor syntax=\"'PowerShell'\" syntax-selection-disabled=true body=\"action.Properties['Octopus.Action.Script.ScriptBody']\" project-id=project.Id local-names=localNames></script-editor> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 858 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_summary.html';
	var html = "<p> Run a PowerShell script using an Azure subscription with Azure modules loaded <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 859 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_powershell/azure_powershell_account_info.html';
	var html = "<div class=\"alert alert-info form-group-narrow\" ng-show=account.AccountType> <p ng-show=\"account.AccountType === 'AzureSubscription'\"> When using an Azure Management Certificate account, <a class=alert-link target=_blank href=http://g.octopushq.com/AzureResourceManagerCmdlets>Resource Manager</a> cmdlets can not be used. To use Resource Manager cmdlets, select an <a class=alert-link target=_blank href=http://g.octopushq.com/DocumentationCreatingAzureAccount>Azure Service Principal account</a>. </p> <p ng-show=\"account.AccountType === 'AzureServicePrincipal'\"> When using an Azure Service Principal account, <a class=alert-link target=_blank href=http://g.octopushq.com/AzureServiceManagementCmdlets>Service Management</a> cmdlets can not be used. To use Service Management cmdlets, select an <a class=alert-link target=_blank href=http://g.octopushq.com/DocumentationCreatingAzureAccount>Azure Management Certificate account</a>. </p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 860 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_edit.html';
	var html = "<azure-powershell-script-info></azure-powershell-script-info> <h4 class=separator>Azure</h4> <control-group label=Account> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.AccountId\"]' reset-value=getAccountId() project-id=project.Id bound=account.bound> <account-selector endpoint=account type=AzureServicePrincipal></account-selector> </bound-field> </control-group> <azure-resource-group-selector model=resourceGroup project-id=project.Id get-account-id=getAccountId is-account-bound=isAccountBound></azure-resource-group-selector> <control-group label=\"Deployment Mode\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.ResourceGroupDeploymentMode\"]' reset-value=Incremental project-id=project.Id> <select ng-model='action.Properties[\"Octopus.Action.Azure.ResourceGroupDeploymentMode\"]' class=form-control required id=deployment-mode> <option>Incremental</option> <option>Complete</option> </select> </bound-field> </control-group> <h4 class=separator>Template</h4> <control-group label=\"Template Source\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.TemplateSource\"]' ng-value='\"Inline\"'> Source Code</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.TemplateSource\"]' ng-value='\"Package\"'> File inside a package</label> <p class=help-block>Templates can be entered as source-code, or contained in a package</p> </control-group> <div ng-if='action.Properties[\"Octopus.Action.Azure.TemplateSource\"] === \"Package\"'> <package-selector action=action project=project feeds=feeds local-names=localNames></package-selector> <control-group label=\"Template Path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.ResourceGroupTemplate\"]' reset-value=\"\" project-id=project.Id> <input type=text class=form-control ng-model='action.Properties[\"Octopus.Action.Azure.ResourceGroupTemplate\"]'> </bound-field> <p class=help-block>Relative path to the JSON template file contained in the package</p> </control-group> <control-group label=\"Template Parameters Path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.ResourceGroupTemplateParameters\"]' reset-value=\"\" project-id=project.Id> <input type=text class=form-control ng-model='action.Properties[\"Octopus.Action.Azure.ResourceGroupTemplateParameters\"]'> </bound-field> <p class=help-block>Relative path to the JSON parameters file contained in the package</p> </control-group> </div> <div ng-if='action.Properties[\"Octopus.Action.Azure.TemplateSource\"] === \"Inline\"'> <div class=big-on-full ui-ace=\"{mode:'json', onLoad:editorLoaded}\" ng-model='action.Properties[\"Octopus.Action.Azure.ResourceGroupTemplate\"]'></div> <h4 class=separator>Parameters</h4> <azure-resource-group-parameters project=project action=action></azure-resource-group-parameters> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 861 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_summary.html';
	var html = "<p> Deploy an Azure Resource Manager Template <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 862 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_resource_group/azure_resource_group_parameters.html';
	var html = "<div> <div ng-repeat=\"(key, value) in parameterValues\"> <control-group label={{key}}> <div class=\"controls form-group-margin\" ng-if=\"value.type === 'securestring'\"> <label class=radio><input type=radio name={{key}}source value=octopus ng-model=value.source>From Octopus</label> <label class=radio><input type=radio name={{key}}source value=azureKeyVault ng-model=value.source>From Azure Key Vault</label> <p class=help-block ng-show=\"value.source === 'azureKeyVault'\"><a target=_blank href=https://azure.microsoft.com/en-us/documentation/articles/key-vault-get-started>Azure Key Vault</a> allows sensitive data to be stored outside of Octopus and then used in <a target=_blank href=https://azure.microsoft.com/en-us/documentation/articles/resource-manager-keyvault-parameter/ >Resource Manager templates.</a></p> </div> <div ng-if=\"value.source !== source.azureKeyVault\"> <bound-field model=value local-names=localNames project-id=project.Id ng-if=value.allowedValues> <ui-select ng-model=value.value> <ui-select-match>{{$select.selected}}</ui-select-match> <ui-select-choices repeat=\"item in value.allowedValues\"> <span ng-bind-html=item></span> </ui-select-choices> </ui-select> </bound-field> <div ng-if=!value.allowedValues ng-switch on=value.type> <div class=\"form-group form-group-narrow\"> <label class=\"control-label col-sm-3\" ng-if=\"value.type === 'securestring'\">Value</label> <div class=controls ng-class=\"{'col-sm-12': value.type !== 'securestring', 'col-sm-9': value.type === 'securestring'}\"> <div ng-switch-when=string> <bound-field model=value.value local-names=localNames project-id=project.Id> <input type=text class=form-control ng-model=value.value ng-model-options=\"{debounce: 500}\"> </bound-field> </div> <div ng-switch-when=securestring> <bound-field model=value.value local-names=localNames project-id=project.Id> <input type=text ng-model=value.value class=form-control ng-model-options=\"{debounce: 500}\"> <p class=\"text-warning help-block\"> This parameter's type is 'secureString'. To avoid it being stored in plain text, please do not enter values directly. Instead use either a <a target=_blank class=text-semibold href=http://g.octopushq.com/SensitiveVariables>Sensitive Variable</a> or <a class=text-semibold target=_blank href=https://azure.microsoft.com/en-us/documentation/articles/key-vault-get-started>Azure Key Vault</a>. </p> </bound-field> </div> <div ng-switch-when=bool> <bound-field model=value.value local-names=localNames project-id=project.Id> <input type=checkbox bs-switch ng-model=value.value switch-on-color=success switch-on-text=True switch-off-text=False switch-size=small /> </bound-field> </div> <div ng-switch-when=int> <bound-field model=value.value local-names=localNames project-id=project.Id> <input type=number class=form-control ng-model=value.value ng-model-options=\"{debounce: 500}\"> </bound-field> </div> <div ng-switch-default> <bound-field model=value.value local-names=localNames project-id=project.Id> <textarea class=form-control ng-model=value.value rows=5 ng-model-options=\"{debounce: 500}\"></textarea> </bound-field> </div> </div> </div> </div> </div> <div ng-if=\"value.source === source.azureKeyVault\"> <control-group label=\"Resource Id\"> <bound-field model=value.keyVaultId local-names=localNames project-id=project.Id> <input type=text class=form-control ng-model=value.keyVaultId ng-model-options=\"{debounce: 500}\"> <p class=help-block><a target=_blank href=\"https://msdn.microsoft.com/en-us/library/mt603612.aspx?f=255&MSPPError=-2147217396\">Get-AzureRMKeyVault</a> PowerShell cmdlet can be used to retrieve this value.</p> </bound-field> </control-group> <control-group label=\"Secret Name\"> <bound-field model=value.keyVaultSecretName local-names=localNames project-id=project.Id> <input type=text class=form-control ng-model=value.keyVaultSecretName ng-model-options=\"{debounce: 500}\"> </bound-field> </control-group> </div> <p class=help-block>{{value.description}}</p> </control-group> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 863 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_resource_group/azure_resource_group_selector.html';
	var html = "<div> <control-group label=\"Resource Group\"> <loading-wrapper busy=vm.isLoading> <bound-field local-names=localNames model=vm.model.name reset-value=vm.reset.name project-id=vm.projectId is-locked=isAccountBound> <ui-select ng-model=vm.selectedResourceGroup ng-change=vm.changed() append-to-body=true> <ui-select-match allow-clear=true placeholder=\"Select Resource Group\">{{$select.selected.Name}} </ui-select-match> <ui-select-choices repeat=\"item in vm.resourceGroups | filter:{Name: $select.search}\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </bound-field> <p class=\"alert alert-danger\" ng-show=vm.resourceGroupError>There was a problem loading resource groups for the selected account: {{vm.resourceGroupError}}</p> </loading-wrapper> <p class=help-block>The name of the Azure Resource Group.</p> <p class=help-block> The Resource Group must exist. A Resource Group can be created through the Azure Portal, or by using the <a target=_blank href=http://g.octopushq.com/NewAzureResourceGroupPowerShell>New-AzureRMResourceGroup</a> PowerShell cmdlet. </p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 864 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_web_app/Octopus.AzureWebApp_edit.html';
	var html = "<azure-powershell-script-info></azure-powershell-script-info> <h4 class=separator>Package</h4> <div ng-show=\"feeds.length > 0\"> <p class=help-block> This step is used to deploy the contents of a package. The package that you wish to deploy should contain all the files needed to run your application. Learn more about <a href=http://octopusdeploy.com/documentation/packaging>what your packages should contain, and how to create them</a>. </p> </div> <div> <spin active=isLoading.busy></spin> <package-selector action=action project=project feeds=feeds local-names=localNames></package-selector> <h4 class=separator>Azure</h4> <control-group label=Account> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.AccountId\"]' reset-value=reset.account project-id=project.Id bound=account.bound> <account-selector endpoint=account type=AzureSubscription,AzureServicePrincipal></account-selector> </bound-field> </control-group> <azure-web-site-selector model=site project-id=project.Id get-account-id=getAccountId is-account-bound=isAccountBound></azure-web-site-selector> <h4 class=separator>Deployment</h4> <control-group label=\"Physical Path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.PhysicalPath\"]' reset-value=\"''\" project-id=project.Id> <input type=text class=form-control ng-model='action.Properties[\"Octopus.Action.Azure.PhysicalPath\"]'/> </bound-field> <p class=help-block>Physical path relative to site root. e.g. 'foo' will deploy to 'site\\wwwroot\\foo'.<br> Leave blank to deploy to root.</p> </control-group> <control-group label=\"Remove additional files\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.RemoveAdditionalFiles\"]' reset-value=\"''\" project-id=project.Id> <div class=checkbox> <label><input type=checkbox ng-model='action.Properties[\"Octopus.Action.Azure.RemoveAdditionalFiles\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"/>Remove files on the destination that are not part of the deployment</label> </div> </bound-field> </control-group> <control-group label=\"Preserve App_Data\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.PreserveAppData\"]' reset-value=\"''\" project-id=project.Id> <div class=checkbox> <label><input type=checkbox ng-model='action.Properties[\"Octopus.Action.Azure.PreserveAppData\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"/>Do not remove files in the App_Data folder</label> </div> </bound-field> </control-group> <control-group label=\"Enable AppOffline\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.AppOffline\"]' reset-value=\"''\" project-id=project.Id> <div class=checkbox> <label><input type=checkbox ng-model='action.Properties[\"Octopus.Action.Azure.AppOffline\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"/>Safely bring down app domain by with blank <code>app_offline.html</code> in root.</label> </div> </bound-field> </control-group> <control-group label=\"File Comparison Method\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Azure.UseChecksum\"]' reset-value=\"'False'\" project-id=project.Id> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.UseChecksum\"]' value=False> Timestamp</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Azure.UseChecksum\"]' value=True> Checksum</label> </bound-field> <p class=help-block> There are two methods of determining which files will be updated when deploying to an Azure Web App: </p> <ul class=help-block> <li>File timestamp (default)</li> <li>File checksum</li> </ul> <p class=help-block> <em>Warning:</em> The checksum method may cause deployment times to increase significantly. </p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 865 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_web_app/Octopus.AzureWebApp_summary.html';
	var html = "<p> Deploy an Azure Web App <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=FeedName>{{ FeedName }}</strong><em ng-hide=FeedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 866 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_web_app/Octopus.MachineEvaluation_edit.html';
	var html = "<control-group label=\"Script source\"> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Inline> Full health check</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Script.ScriptSource\"]' value=Package> Only check connectivity</label> </control-group>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 867 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/azure_web_app/azure_web_site_selector.html';
	var html = "<div> <control-group label=\"Resource Group\" ng-show=vm.isBound> <bound-field local-names=localNames model=vm.model.resourceGroupName reset-value=vm.model.resourceGroupName project-id=vm.projectId bound=true> <input type=text class=form-control ng-model=vm.model.resourceGroupName /> </bound-field> <p class=help-block>The Resource Group of your Azure Web App.<br/>If not specified then all Resource Groups are searched.</p> </control-group> <control-group label=\"Web App\"> <loading-wrapper busy=vm.isLoading> <bound-field local-names=localNames model=vm.model.name reset-value=vm.reset.name project-id=vm.projectId is-locked=isAccountBound bound=vm> <ui-select ng-model=vm.selectedSite ng-change=vm.changed() append-to-body=true> <ui-select-match allow-clear=true placeholder=\"Select Web App\">{{$select.selected.Name}}<i ng-if=$select.selected.ResourceGroup> - {{$select.selected.ResourceGroup}}</i><i> - {{$select.selected.Region}}</i></ui-select-match> <ui-select-choices repeat=\"item in vm.sites | filter:{Name: $select.search}\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> <br/> <i ng-if=item.ResourceGroup>{{item.ResourceGroup}} ({{item.Region}})</i> <i ng-if=!item.ResourceGroup>{{item.Region}}</i> </ui-select-choices> </ui-select> </bound-field> </loading-wrapper> <p class=help-block>The name of your Azure Web App.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 868 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_network/Octopus.DockerNetwork_edit.html';
	var html = "<div> <h4 class=separator>Networking Options</h4> <control-group label=Driver> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.NetworkType\"]' reset-value=\"'bridge'\" project-id=project.Id> <select class=form-control ng-model='action.Properties[\"Octopus.Action.Docker.NetworkType\"]'> <option ng-repeat=\"(key, value) in networkTypes\" ng-selected='{{key == action.Properties[\"Octopus.Action.Docker.NetworkType\"]}}' value={{key}}>{{value.name}} </option> </select> </bound-field> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.NetworkCustomDriver\"]' reset-value=\"''\" ng-if='action.Properties[\"Octopus.Action.Docker.NetworkType\"] === \"other\"' project-id=project.Id style=margin-top:1em> <input class=form-control type=text placeholder=\"Custom driver\" ng-model='action.Properties[\"Octopus.Action.Docker.NetworkCustomDriver\"]'/> </bound-field> </control-group> <control-group label=Subnet> <single-value-adder action=::action project=::project local-names=localNames placeholder=\"CIDR format (e.g. 172.28.5.0/24)\" helptext=\"Subnet in CIDR format that represents a network segment. On a bridge network you can only specify a single subnet\" ng-model='action.Properties[\"Octopus.Action.Docker.NetworkSubnet\"]'></single-value-adder> </control-group> <control-group label=\"IP Range\"> <single-value-adder action=::action project=::project local-names=localNames placeholder=\"CIDR format (e.g. 172.28.5.0/24)\" helptext=\"Allocate container ip from a sub-range\" ng-model='action.Properties[\"Octopus.Action.Docker.NetworkIPRange\"]'></single-value-adder> </control-group> <control-group label=Gateway> <single-value-adder action=::action project=::project local-names=localNames placeholder=\"CIDR format (e.g. 172.28.5.0/24)\" helptext=\"IPv4 or IPv6 Gateway for the master subnet. By default the Docker engine will select one from inside a preferred pool.\" ng-model='action.Properties[\"Octopus.Action.Docker.NetworkGateway\"]'></single-value-adder> </control-group> <control-group label=\"Additional Arguments\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.Args\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Docker.Args\"]'/> </bound-field> <p class=help-block>Provide any other arguments that will be passed to the <code>docker network create</code> command.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 869 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_network/Octopus.DockerNetwork_summary.html';
	var html = "<p> Create a Docker Network <span ng-show=isSingleStep>on machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 870 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_network/dual-value-adder.html';
	var html = "<div class=dual-value-adder> <div class=dva-existing ng-repeat=\"item in vm.items\"> <div ng-if=!item.isEditing> <span class=itemTemplate></span> <div class=\"pull-right inline\"> <span class=clickable ng-click=\"item.isEditing = true;\"><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp; <span class=clickable ng-click=vm.remove(item)><i class=\"fa fa-close\"></i> Delete</span> </div> </div> <div ng-if=item.isEditing> <form ng-submit=vm.commitEdit(item) class=row> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=item.editItemVal1 reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder={{vm.placeholder1}} ng-model=item.editItemVal1> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>{{vm.seperator}}</div> </div> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=item.editItemVal2 reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder={{vm.placeholder2}} ng-model=item.editItemVal2> </bound-field> </div> <div class=col-md-4> <button type=button class=\"btn btn-default\" ng-click=vm.cancelEdit(item)>Cancel </button> <input type=submit class=\"btn btn-success\" value=Update /> </div> </form> </div> </div> <form ng-submit=vm.addItem() class=\"dva-new row\"> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newItemVal1 reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder={{vm.placeholder1}} ng-model=vm.newItemVal1> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>{{vm.seperator}}</div> </div> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newItemVal2 reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder={{vm.placeholder2}} ng-model=vm.newItemVal2> </bound-field> </div> <div class=col-md-2> <button type=button ng-disabled=!vm.newItemVal1 ng-click=vm.addItem() class=\"btn btn-info\">Add </button> </div> </form> <p class=help-block ng-bind-html=vm.helptext></p> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 871 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_network/single-value-adder.html';
	var html = "<div> <table class=\"table table-bordered table-responsive\" style=margin-top:.5em;margin-bottom:.5em ng-if=\"vm.items.length > 0\"> <tbody> <tr ng-repeat=\"item in vm.items\"> <td ng-if=!item.isEditing> <span>{{item.name}}</span> <div class=\"pull-right inline\"> <span class=clickable ng-click=\"item.isEditing = true;\"><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp; <span class=clickable ng-click=vm.remove(item)><i class=\"fa fa-close\"></i> Delete</span> </div> </td> <td ng-if=item.isEditing> <form ng-submit=vm.commitEdit(item) class=row> <div class=col-md-8> <bound-field local-names=vm.localNames class=tight-bound-field model=item.editName reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder={{vm.placeholder}} ng-model=item.editName> </bound-field> </div> <div class=col-md-4> <button type=button class=\"btn btn-default\" ng-click=vm.cancelEdit(item)>Cancel </button> <input type=submit class=\"btn btn-success\" value=Update /> </div> </form> </td> </tr> </tbody> </table> <div class=row> <div class=col-md-10> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newContainer reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder={{vm.placeholder}} ng-model=vm.newContainer> </bound-field> </div> <div class=col-md-2> <button type=button ng-disabled=!vm.newContainer ng-click=vm.addContainer() class=\"btn btn-info\">Add </button> </div> </div> <p class=help-block ng-bind-html=vm.helptext></p> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 872 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/Octopus.DockerRun_edit.html';
	var html = "<h4 class=separator>Package</h4> <div ng-show=\"feeds.length > 0\"> <p class=help-block> This step is used to run a docker container. The package that you wish to deploy should contain all the files needed to run your application. Learn more about <a href=http://octopusdeploy.com/documentation/packaging>what your packages should contain, and how to create them</a>. </p> </div> <div> <spin active=isLoading.busy></spin> <package-selector action=action project=project feeds=feeds local-names=localNames feed-type=\"'Docker'\"></package-selector> <h4 class=separator>Networking</h4> <control-group label=\"Network Type\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.NetworkType\"]' reset-value=\"'bridge'\" project-id=project.Id> <select class=form-control ng-model='action.Properties[\"Octopus.Action.Docker.NetworkType\"]'> <option ng-repeat=\"(key, value) in networkTypes\" ng-selected='{{key == action.Properties[\"Octopus.Action.Docker.NetworkType\"]}}' value={{key}}>{{value.name}} </option> </select> </bound-field> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.NetworkContainer\"]' reset-value=\"''\" ng-if='action.Properties[\"Octopus.Action.Docker.NetworkType\"] === \"container\"' project-id=project.Id style=margin-top:1em> <input class=form-control type=text placeholder=\"Container name or id\" ng-model='action.Properties[\"Octopus.Action.Docker.NetworkContainer\"]'/> </bound-field> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.NetworkName\"]' reset-value=\"''\" ng-if='action.Properties[\"Octopus.Action.Docker.NetworkType\"] === \"network\"' project-id=project.Id style=margin-top:1em> <input class=form-control type=text placeholder=\"Network name or id\" ng-model='action.Properties[\"Octopus.Action.Docker.NetworkName\"]'/> </bound-field> <p class=help-block> <b>{{ networkTypes[action.Properties[\"Octopus.Action.Docker.NetworkType\"]].name}}</b> <span ng-if='action.Properties[\"Octopus.Action.Docker.NetworkType\"] !== \"\"'>: {{ networkTypes[action.Properties[\"Octopus.Action.Docker.NetworkType\"]].description}}</span> See <a href=\"'https://docs.docker.com/engine/reference/run/#/network-settings\" target=_blank>Docker docs</a> for more information. </p> </control-group> <control-group label=\"Network Alias\" ng-if='action.Properties[\"Octopus.Action.Docker.NetworkType\"] === \"network\"'> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.NetworkAlias\"]' reset-value=\"\" project-id=vm.projectId bound=true> <input type=text class=form-control ng-model='action.Properties[\"Octopus.Action.Docker.NetworkAlias\"]'/> </bound-field> <p class=help-block>Containers in the same network will be able to reach the container by using this alias.</p> </control-group> <control-group label=\"Port Mapping\"> <port-mapping action=::action project=::project local-names=localNames></port-mapping> </control-group> <control-group label=\"\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.PortAutoMap\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox> <label><input type=checkbox ng-model='action.Properties[\"Octopus.Action.Docker.PortAutoMap\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"/>Automatically map to ephemeral port</label> </div> </bound-field> <p class=help-block>Allows mapping exposed network port in the container to ports on the host. See <a href=https://docs.docker.com/engine/userguide/networking/default_network/dockerlinks/#/connect-using-network-port-mapping>Docker docs</a> for more information about network port mapping.</p> </control-group> <control-group label=\"Add Host\"> <added-host action=::action project=::project local-names=localNames></added-host> </control-group> <h4 class=separator>Volumes</h4> <control-group label=\"Bind Mounts\"> <volume-binding action=::action project=::project local-names=localNames></volume-binding> </control-group> <control-group label=\"Volume Driver\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.VolumeDriver\"]' reset-value=\"\" project-id=vm.projectId bound=true> <input type=text class=form-control ng-model='action.Properties[\"Octopus.Action.Docker.VolumeDriver\"]'/> </bound-field> <p class=help-block>Optional volume driver for the container.</p> </control-group> <control-group label=\"Volumes From\"> <volumes-from action=::action project=::project local-names=localNames></volumes-from> </control-group> <h4 class=separator>Variables</h4> <control-group label=\"Explicit Variable Mapping\"> <variable-mapping action=::action project=::project local-names=localNames></variable-mapping> </control-group> <h4 class=separator>Additional Arguments</h4> <control-group label=\"Restart Policy\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.RestartPolicy\"]' reset-value=\"'no'\" project-id=project.Id> <select class=form-control ng-model='action.Properties[\"Octopus.Action.Docker.RestartPolicy\"]'> <option ng-repeat=\"(key, value) in restartPolicies\" ng-selected='{{key == action.Properties[\"Octopus.Action.Docker.RestartPolicy\"]}}' value={{key}}>{{value.name}} </option> </select> </bound-field> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.RestartPolicyMax\"]' reset-value=\"''\" ng-if='action.Properties[\"Octopus.Action.Docker.RestartPolicy\"] === \"on-failure\"' project-id=project.Id style=margin-top:1em> <input class=form-control type=text placeholder=\"Unlimited retry\" ng-model='action.Properties[\"Octopus.Action.Docker.RestartPolicyMax\"]'/> </bound-field> <p class=help-block> <b>{{ restartPolicies[action.Properties[\"Octopus.Action.Docker.RestartPolicy\"]].name}}</b>: {{ restartPolicies[action.Properties[\"Octopus.Action.Docker.RestartPolicy\"]].description}} See <a href=\"'https://docs.docker.com/engine/reference/run/#restart-policies-restart\" target=_blank>Docker docs</a> for more information. </p> </control-group> <control-group label=\"Don't Auto-Run\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.DontRun\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox> <label><input type=checkbox ng-model='action.Properties[\"Octopus.Action.Docker.DontRun\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"/>Issue <code>create</code> command instead of <code>run</code>.</label> </div> </bound-field> <p class=help-block>This creates the writable layer on top of the image and prepares it for running without actually starting it. This may be useful if there is other configuration you would like to perform before startup.</p> </control-group> <control-group label=Command> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.Command\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Docker.Command\"]'/> </bound-field> <p class=help-block><a href=https://docs.docker.com/engine/reference/run/#cmd-default-command-or-options>Override default</a> <code>CMD</code> instruction provided by the image.</p> </control-group> <control-group label=Args> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.Args\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Docker.Args\"]'/> </bound-field> <p class=help-block>Provide any other arguments that will be passed to the <code>docker run</code> command. A full description of the additional arguments which can be supplied can be found on the <a href=\"'https://docs.docker.com/engine/reference/commandline/run/\" target=_blank>Docker reference page</a>.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 873 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/Octopus.DockerRun_summary.html';
	var html = "<p> Deploy and Run a Docker Container <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show=isSingleStep>on machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 874 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/added-host.html';
	var html = "<div class=dual-value-adder> <div class=dva-existing ng-repeat=\"mapping in vm.addedHosts\"> <div ng-if=!mapping.isEditing> <span>{{mapping.formatted}}</span> <div class=\"pull-right inline\"> <span class=clickable ng-click=\"mapping.isEditing = true;\"><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp; <span class=clickable ng-click=vm.removeAddedHost(mapping)><i class=\"fa fa-close\"></i> Delete</span> </div> </div> <div ng-if=mapping.isEditing> <form ng-submit=mapping.commitEdit() class=row> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=mapping.editHost reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=HostName ng-model=mapping.editHost> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>:</div> </div> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=mapping.editIp reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=IP ng-model=mapping.editIp> </bound-field> </div> <div class=col-md-4> <button type=button class=\"btn btn-default\" ng-click=mapping.cancelEdit()>Cancel </button> <input type=submit ng-disabled=\"!mapping.editIp || !mapping.editHost\" class=\"btn btn-success\" value=Update /> </div> </form> </div> </div> <div class=\"dva-new row\"> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newHost reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=HostName ng-model=vm.newHost> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>:</div> </div> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newIp reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=IP ng-model=vm.newIp> </bound-field> </div> <div class=col-md-2> <button type=button ng-disabled=\"!vm.newIp || !vm.newHost\" ng-click=vm.addNewHost() class=\"btn btn-info\">Add </button> </div> </div> <p class=help-block>Adds a line to /etc/hosts<br/> </p> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 875 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/port-mapping.html';
	var html = "<div class=dual-value-adder> <div class=dva-existing ng-repeat=\"mapping in vm.portMappings\"> <div ng-if=!mapping.isEditing> <span ng-bind-html=mapping.formatted></span> <div class=\"pull-right inline\"> <span class=clickable ng-click=\"mapping.isEditing = true;\"><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp; <span class=clickable ng-click=vm.removePortMapping(mapping)><i class=\"fa fa-close\"></i> Delete</span> </div> </div> <div ng-if=mapping.isEditing> <form ng-submit=mapping.commitEdit() class=row> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=mapping.editHost reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Host ng-model=mapping.editHost> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>:</div> </div> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=mapping.editContainer reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Container ng-model=mapping.editContainer> </bound-field> </div> <div class=col-md-4> <button type=button class=\"btn btn-default\" ng-click=mapping.cancelEdit()>Cancel </button> <input type=submit class=\"btn btn-success\" value=Update /> </div> </form> </div> </div> <div class=\"dva-new row\"> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newHost reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Host ng-model=vm.newHost> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>:</div> </div> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newContainer reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Container ng-model=vm.newContainer> </bound-field> </div> <div class=col-md-2> <button type=button ng-disabled=!vm.newContainer ng-click=vm.addPortMapping() class=\"btn btn-info\">Add </button> </div> </div> <p class=help-block><a href=https://docs.docker.com/engine/reference/run/#/expose-incoming-ports target=_blank>Publish</a> a container's port or a range of ports to the host.<br/> </p> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 876 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/variable-mapping.html';
	var html = "<div class=dual-value-adder> <div ng-repeat=\"mapping in vm.variableMappings\" class=dva-existing> <div ng-if=!mapping.isEditing> <span>{{mapping.formatted}}</span> <div class=\"pull-right inline\"> <span class=clickable ng-click=\"mapping.isEditing = true;\"><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp; <span class=clickable ng-click=vm.removeVariable(mapping)><i class=\"fa fa-close\"></i> Delete</span> </div> </div> <div ng-if=mapping.isEditing> <form ng-submit=mapping.commitEdit() class=row> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=mapping.editVariable reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=\"Variable Name\" ng-model=mapping.editVariable> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>=</div> </div> <div class=col-md-4> <bound-field local-names=vm.localNames class=tight-bound-field model=mapping.editValue reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Value ng-model=mapping.editValue> </bound-field> </div> <div class=col-md-4> <button type=button class=\"btn btn-default\" ng-click=mapping.cancelEdit()>Cancel </button> <input type=submit class=\"btn btn-success\" value=Update /> </div> </form> </div> </div> <div class=\"dva-new row\"> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newVariable reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=\"Variable Name\" ng-model=vm.newVariable> </bound-field> </div> <div class=\"col-md-1 dva-seperator\"> <div>=</div> </div> <div class=col-md-5> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newValue reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Value ng-model=vm.newValue> </bound-field> </div> <div class=col-md-2> <button type=button ng-disabled=!vm.newVariable ng-click=vm.addVariable() class=\"btn btn-info\">Add </button> </div> </div> <p class=help-block>Passes through variables into the container accessible as environment variables. See <a href=https://docs.docker.com/engine/reference/run/#/env-environment-variables>Docker docs</a> for more information about environment variables.</p> <p></p> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 877 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/volume-binding-dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add Volume Binding</h3> </div> <div class=\"modal-body help-scope\"> <error-box error=isSaving.error></error-box> <div class=form-horizontal> <control-group label=\"Host Source\"> <bound-field local-names=localNames model=binding.host reset-value=\"''\" project-id=binding.projectId> <input class=form-control type=text ng-model=binding.host> </bound-field> <p class=help-block>An optional absolute path or a name value to a resource on the host.</p> </control-group> <control-group label=\"Container Dest\"> <bound-field local-names=localNames model=binding.container reset-value=\"''\" project-id=binding.projectId> <input class=form-control type=text ng-model=binding.container> </bound-field> <p class=help-block>Mount point inside container to create volume.</p> </control-group> <control-group label=\"Read Only\"> <bound-field local-names=localNames model=binding.readOnly reset-value=\"'False'\" project-id=binding.projectId> <input type=checkbox ng-model=binding.readOnly> </bound-field> <p class=help-block>Volume defaults mode to read-write.</p> </control-group> <control-group label=\"No Copy\"> <bound-field local-names=localNames model=binding.noCopy reset-value=\"'False'\" project-id=binding.projectId> <input type=checkbox ng-model=binding.noCopy> </bound-field> <p class=help-block>Disable automatic copying volume path in the container to the volume storage location.</p> </control-group> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save() ng-show=!isLoading.busy>Save</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 878 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/volume-binding.html';
	var html = "<div> <table class=\"table table-bordered table-responsive\" style=margin-top:.5em;margin-bottom:.5em ng-if=\"vm.volumeBindings.length > 0\"> <tbody> <tr ng-repeat=\"binding in vm.volumeBindings\"> <td> <span ng-bind-html=vm.formatBinding(binding)></span> <div class=\"pull-right inline\"> <span class=clickable ng-click=vm.openEditDialog(binding)><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp; <span class=clickable ng-click=vm.removeVolumeBinding(binding)><i class=\"fa fa-close\"></i> Delete</span> </div> </td> </tr> </tbody> </table> <div class=text-center> <button class=\"btn btn-info\" type=button ng-click=vm.openEditDialog()>Add Volume Mount</button> </div> <p class=help-block> A <a href=https://docs.docker.com/engine/tutorials/dockervolumes/ target=_blank>data volume</a> is a specially-designated directory within one or more containers that bypasses the <a href=https://docs.docker.com/engine/reference/glossary/#union-file-system target=_blank>Union File System</a>. </p></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 879 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_run/volumes-from.html';
	var html = "<div class=dual-value-adder> <div ng-repeat=\"container in vm.containers\" class=dva-existing> <div ng-if=!container.isEditing> <span>{{container.name}}</span> <div class=\"pull-right inline\"> <span class=clickable ng-click=\"container.isEditing = true;\"><i class=\"fa fa-pencil\"></i> Edit</span>&nbsp;&nbsp; <span class=clickable ng-click=vm.remove(container)><i class=\"fa fa-close\"></i> Delete</span> </div> </div> <div ng-if=container.isEditing> <form ng-submit=vm.commitEdit(container) class=row> <div class=col-md-8> <bound-field local-names=vm.localNames class=tight-bound-field model=container.editName reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Host ng-model=container.editName> </bound-field> </div> <div class=col-md-4> <button type=button class=\"btn btn-default\" ng-click=vm.cancelEdit(container)>Cancel </button> <input type=submit class=\"btn btn-success\" value=Update /> </div> </form> </div> </div> <div class=\"dva-new row\"> <div class=col-md-10> <bound-field local-names=vm.localNames class=tight-bound-field model=vm.newContainer reset-value=\"''\" project-id=vm.project.Id> <input class=form-control type=text placeholder=Host ng-model=vm.newContainer> </bound-field> </div> <div class=col-md-2> <button type=button ng-disabled=!vm.newContainer ng-click=vm.addContainer() class=\"btn btn-info\">Add </button> </div> </div> <p class=help-block>Mount all volumes from the given container(s)<br/> </p> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 880 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_stop/Octopus.DockerStop_edit.html';
	var html = "<div> <h4 class=separator>Removal Rules</h4> <control-group label=Perform> <div style=padding-left:20px> <label class=radio> <input type=radio ng-model='action.Properties[\"Octopus.Action.Docker.Remove\"]' value=False> Stop</label> <label class=radio> <input type=radio ng-model='action.Properties[\"Octopus.Action.Docker.Remove\"]' value=True> Stop and Remove</label> </div> </control-group> <control-group label=Steps> <select-custom available=actions ng-model=vm.selectedActions ng-change=actionsChanged() multiple=multiple></select-custom> <p class=help-text>Resources created from these Docker steps should be removed. <br/> Note that leaving blank will remove resources created from <i>all</i> docker steps and therefore may remove resources from the same release if this step runs after other Docker steps.</p> </control-group> <control-group label=Matching> <div> <div> <label> <input type=checkbox disabled=disabled checked=checked /> Project </label> <p class=help-text>Resources will be removed where they match the current project. This cannot be disabled.</p> </div> <div> <label> <input type=checkbox ng-model=filterBy.environment ng-true-value=\"'True'\" ng-false-value=\"'False'\" ng-change=filterChanged() /> Environment </label> <p class=help-text>Resources will be removed only where they also match the current environment.</p> </div> <div> <label> <input type=checkbox ng-model=filterBy.release ng-true-value=\"'True'\" ng-false-value=\"'False'\" ng-change=filterChanged() /> Release </label> <p class=help-text>Resources will be removed only where they also match the current release.</p> </div> <div> <label> <input type=checkbox ng-model=filterBy.tenant ng-true-value=\"'True'\" ng-false-value=\"'False'\" ng-change=filterChanged() /> Tenant (if applicable) </label> <p class=help-text>If the release includes tenants then resources will be removed only where they also match the currently deploying tenant.</p> </div> </div> </control-group> <control-group label=\"Custom Tag Filters\"> <dual-value-adder action=::action project=::project local-names=localNames placeholder1=Label placeholder2=Value seperator=\"=\" template=\"{{item.itemVal1}} <i ng-if='item.itemVal2'>= {{item.itemVal2}}</i>\" helptext='These tags will be included when searching for resources using the <code>--filter \"label=X\"</code>. Remember to include <code>=</code> if you want to filter based on a tag value, rather than just its presence' ng-model='action.Properties[\"Octopus.Action.Docker.RemoveCustomTags\"]'> </dual-value-adder> </control-group> <control-group label=Timeout> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Docker.StopTimeout\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Docker.StopTimeout\"]' placeholder=\"Time till process killed\"/> </bound-field> <p class=help-block>Seconds to wait for process to stop before killing it (Docker default 10). The main process inside the container will receive SIGTERM, and after a grace period, SIGKILL.</p> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 881 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/docker_stop/Octopus.DockerStop_summary.html';
	var html = "<p> Stop a Docker Resource <span ng-show=isSingleStep>on machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 882 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/transfer_package/Octopus.TransferPackage_edit.html';
	var html = "<h4 class=separator>Package</h4> <div ng-show=\"feeds.length > 0\"> <p class=help-block> This step is used to push the contents of a package to one or more machines which may be sourced from an external feed or the Octopus built-in feed. You can configure the remote machines to deploy to in the <a href=#/environments>environments</a> tab.. </p> </div> <div> <spin active=isLoading.busy></spin> <package-selector action=action project=project feeds=feeds local-names=localNames></package-selector> <package-download-options action=action local-names=localNames></package-download-options> <control-group label=\"Transfer Path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.TransferPath\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-model='action.Properties[\"Octopus.Action.Package.TransferPath\"]' placeholder=\"Directory Path to Package\"> </bound-field> <p class=help-block>The location that the package should be moved to once it is uploaded to the remote target.</p> </control-group> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 883 */
/***/ function(module, exports) {

	var path = 'areas/projects/actions/transfer_package/Octopus.TransferPackage_summary.html';
	var html = "<p> Transfer package <strong>{{ packageId }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ feedId }}</em> <span ng-show=isSingleStep>to machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 884 */
/***/ function(module, exports) {

	var path = 'areas/projects/channels/add_step_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add step</h3> </div> <form ng-submit=save()> <div class=modal-body> <div class=form-horizontal> <ui-select ng-model=adding.stepName> <ui-select-match placeholder=\"Select a step...\"> <span>{{$select.selected.Name}} - <em>{{$select.selected.Properties['Octopus.Action.Package.PackageId']}}</em></span> </ui-select-match> <ui-select-choices repeat=\"step.Name as step in steps | filter: $select.search\"> <div>{{step.Name}} - <i>{{step.Properties['Octopus.Action.Package.PackageId']}}</i></div> </ui-select-choices> </ui-select> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" type=submit ng-click=save() ng-disabled=!adding.stepName>Add</button> <button class=\"btn btn-default\" type=button ng-click=close()>Cancel</button> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 885 */
/***/ function(module, exports) {

	var path = 'areas/projects/channels/channel_create.html';
	var html = "<script octo-section=breadcrumb type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/channels/create'>Create New</a></li> </script> <channel-editor></channel-editor> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 886 */
/***/ function(module, exports) {

	var path = 'areas/projects/channels/channel_edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/channels/edit/{{model.Id}}'>{{model.Name}}</a></li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <channel-editor></channel-editor> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <h3>Delete</h3> <div> <p>Variables scoped to the deleted channel will also be deleted.</p> <p>The deleted channel will be removed from all deployment step restriction lists. Any steps restricted to only the deleted channel will also be deleted.</p> <p>Channels cannot be deleted while they have releases. You must first delete or re-assign all releases associated with the channel.</p> <delete-button model=model what=Channel redirect=/projects/{{project.Slug}}/channels></delete-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 887 */
/***/ function(module, exports) {

	var path = 'areas/projects/channels/channel_editor.html';
	var html = "<div class=\"form-box form-horizontal\"> <form ng-submit=save() name=channelForm track-unsaved-changes> <div class=form-body> <h3>Channel</h3> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <control-group label=\"Channel name\"> <input class=form-control type=text ng-model=model.Name focus-on=page-loaded /> <p class=help-block>A short, memorable, unique name for this channel. Examples: HotFix, Feature</p> </control-group> <control-group label=Description> <textarea class=form-control ng-model=model.Description markitup rows=5></textarea> </control-group> <control-group label=Lifecycle> <select class=form-control ng-model=model.LifecycleId ng-options=\"p.Id as p.Name for p in lifecycles\" aria-label=\"Lifecycle selector\"> <option value=\"\" selected=selected>Inherit from project</option> </select> <p class=help-block>The lifecycle defines how releases can be promoted between environments. Lifecycles can be defined in the <a href=#/library/lifecycles>Library</a>. If no lifecycle is selected, the default lifecycle for the project will be used.</p> </control-group> <control-group label=\"Is default channel\"> <div> <input type=checkbox bs-switch ng-model=model.IsDefault switch-on-color=success switch-on-text=Yes switch-off-text=No switch-size=small /> </div> <p class=help-block> The channel will be selected by default on the Create Release page. </p> </control-group> <h4 class=separator>Version Rules</h4> <div ng-show=\"model.Rules.length == 0\"> <p class=text-center> This channel has no version rules. </p> </div> <div class=channel-version-rule-edit ng-repeat=\"rule in model.Rules\"> <div> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=removeVersionRule(rule)>× </button> <control-group label=\"Package step(s)\"> <div ng-show=\"rule.Actions.length == 0\"> <strong class=pad-text>None</strong> </div> <div> <ul class=octo-list-group> <li class=octo-list-group-item ng-repeat=\"actionName in rule.Actions\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=\"removeRuleStep(rule, actionName)\">× </button> <div> {{ actionName }} - <em>{{actionsByName[actionName].Properties['Octopus.Action.Package.PackageId']}}</em> </div> </li> </ul> </div> <a class=\"btn btn-default\" type=button ng-click=addAction(rule) ng-if=\"rule.Actions.length < actions.length \"><i class=icon-plus></i> Add step</a> </control-group> </div> <control-group label=\"Version range\"> <input class=form-control type=text ng-model=rule.VersionRange ng-disabled=\"rule.Actions.length == 0\"/> <p class=help-block>Use the <a target=_blank href=http://g.octopushq.com/NuGetVersioning>NuGet versioning syntax</a> to specify the range of versions to include.</p> </control-group> <control-group label=Tag> <input class=form-control type=text ng-model=rule.Tag ng-disabled=\"rule.Actions.length == 0\"/> <p class=help-block>A regular-expression which will select on the <a target=_blank href=http://semver.org/ >SemVer</a> pre-release tag.</p> <p class=help-block>Check our <a target=_blank href=http://g.octopushq.com/ChannelVersionRuleTags>documentation</a> for more information on tags along with examples. </p> </control-group> <control-group> <div class=text-center> <a href ng-click=design(rule)>Design rule</a> </div> </control-group> </div> <control-group class=text-center> <a class=\"btn btn-info\" href ng-click=addVersionRule()><i class=\"fa fa-plus\"></i> Add version rule</a> </control-group> <p class=help-block> <a href=http://g.octopushq.com/ChannelVersionRules target=_blank>Version rules</a> are used to filter packages on the create-release page and when automatically creating releases as a result of a package being pushed. </p> <div ng-if=\"project.TenantedDeploymentMode !== 'Untenanted' || model.TenantTags.length > 0\" octo-feature=IsMultiTenancyEnabled> <h4 class=separator>Tenants</h4> <advanced-tenant-selector apply-border=false hide-tenants=true selected-tags=model.TenantTags filter-by-project-id=model.ProjectId> </advanced-tenant-selector> <p class=help-block> By applying a tenant filter to this channel, Octopus will ensure releases in this channel are only deployed to matching tenants. Leaving this blank implies that releases in this channel can be deployed to any tenant.</p> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin class=spin-static active=isSaving.busy></spin> </div> </div> </form> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 888 */
/***/ function(module, exports) {

	var path = 'areas/projects/channels/channels.html';
	var html = "<h3>Channels</h3> <loading-wrapper busy=isLoading> <div class=\"channels stack\" ng-show=\"channels.Items.length > 0\"> <div class=\"stack-item channel\" ng-repeat=\"channel in channels.Items track by channel.Id\"> <a href=#/projects/{{project.Slug}}/channels/edit/{{channel.Id}}> <div class=stack-content> <h4>{{ channel.Name }}</h4> <span ng-show=channel.IsDefault class=label uib-tooltip=\"When creating releases this channel will be the default.\">Default</span> <markdown text=channel.Description></markdown> <div class=row> <div class=col-sm-3> <label>Lifecycle</label> </div> <div class=col-sm-9> <p>{{getLifecycleName(channel)}}</p> </div> </div> <div class=row ng-if=\"project.TenantedDeploymentMode !== 'Untenanted' && channel.TenantTags.length > 0\"> <div class=col-sm-3><label>Restricted to tenants</label></div> <div class=col-sm-9> <p><tenant-tag ng-model=tag ng-repeat=\"tag in channel.TenantTags\"></tenant-tag></p> </div> </div> <div ng-show=\"channel.Rules.length > 0\"> <div class=version-rule ng-repeat=\"rule in channel.Rules\"> <div class=row> <div class=col-sm-3> <label>Step<span ng-show=\"rule.Actions.length > 1\">s</span></label> </div> <div class=col-sm-9> <div class=octo-list-group> <div class=octo-list-group-item ng-repeat=\"actionName in rule.Actions\"> <div class=step> <p><strong>{{actionName}}</strong> - {{getActionPackageName(actionName)}}</p> </div> </div> </div> </div> </div> <div class=\"row version-filter\" ng-show=rule.VersionRange> <div class=col-sm-3><label>Version range</label></div> <div class=col-sm-9> <p class=channel-rule-spec>{{rule.VersionRange}}</p> </div> </div> <div class=\"row version-filter\" ng-if=rule.Tag> <div class=col-sm-3><label>Pre-release tag</label></div> <div class=col-sm-9> <p class=channel-rule-spec>{{rule.Tag}}</p> </div> </div> <hr ng-hide=$last /> </div> </div> </div> </a> </div> </div> <div class=margin-top-bottom-10> <a octo-permission=ProcessEdit octo-project=project.Id class=\"btn btn-success\" href=#/projects/{{project.Slug}}/channels/create>Create channel</a> </div> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 889 */
/***/ function(module, exports) {

	var path = 'areas/projects/channels/design_rule_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Design version rule</h3> </div> <div class=\"modal-body version-rule\"> <div class=\"alert alert-warning\" ng-show=\"warnings.length > 0\"> <ul> <li ng-repeat=\"warn in warnings\">{{warn}}</li> </ul> </div> <div class=form-horizontal> <control-group label=\"Version range\" ng-class=rangeClass> <input class=form-control type=text ng-model=rule.versionRange ng-model-options=\"{ debounce: 500 }\"/> <p class=help-block>Use the <a target=_blank href=http://g.octopushq.com/NuGetVersioning>NuGet versioning syntax</a> to specify the range of versions to include. Examples:</p> <pre class=\"help-block col-sm-12\">1.0 = 1.0 ≤ x\r\n(1.1,1.2] = 1.1 &lt; x ≤ 1.2\r\n[2.0.0-alpha.1,2.0.0] = 2.0.0-alpha.1 ≤ x &lt; 2.0.0\r\n[1.0] = x == 1.0\r\nempty = latest version.</pre> </control-group> <control-group label=Tag ng-class=tagClass> <input class=form-control type=text ng-model=rule.tag ng-model-options=\"{ debounce: 500 }\"/> <p class=help-block>A regular-expression which will select on the <a target=_blank href=http://semver.org/ >SemVer</a> pre-release tag.</p> <p class=help-block>Check our <a target=_blank href=http://g.octopushq.com/ChannelVersionRuleTags>documentation</a> for more information on tags along with examples.</p> </control-group> <control-group label=\"Sample Versions\" ng-class=versionClass> <sample-versions class=form-control test-version=\"testVersion(version, done)\" version-range=rule.versionRange initial-data=samplePackages tag=rule.tag></sample-versions> <p class=help-block>Enter possible package versions to see if this rule matches. (Empty version range will match any)</p> </control-group> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" type=submit ng-click=save()>OK</button> <button class=\"btn btn-default\" type=button ng-click=close()>Cancel</button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 890 */
/***/ function(module, exports) {

	var path = 'areas/projects/deployment-create/deployment-create-environment-selector.html';
	var html = "<div> <control-group label=Environments> <div ng-if=!vm.edit style=padding-top:7px> <div class=selected-environment ng-repeat=\"env in vm.selectedEnvironments\"> <div> <strong>{{ vm.getEnvironmentName(env) }}</strong> <span class=\"gray smaller-fonts\" ng-show=vm.latest[env]> &nbsp;(currently <strong><a href=\"#/tasks/{{ vm.latest[env].TaskId }}\">{{vm.latest[env].ReleaseVersion}}</a></strong>) </span> <span class=\"gray smaller-fonts\" ng-hide=vm.latest[env]> (first time) </span> <div ng-if=\"vm.newDeployments[env] && vm.newDeployments[env][null]\"> <error-box ng-if=\"vm.newDeployments[env][null].state === 'error'\" error=vm.newDeployments[env][null].error></error-box> <div class=\"alert alert-success\" ng-if=\"vm.newDeployments[env][null].state === 'success'\"> Deployment queued: <a href=\"#/tasks/{{ vm.newDeployments[env][null].deployment.TaskId }}\">{{ vm.newDeployments[env][null].deployment.Name }}</a> </div> </div> </div> </div> </div> <a class=\"margin-top-5 btn btn-info\" href ng-click=\"vm.edit=true\" ng-if=!vm.edit>Change environments</a> <div ng-if=vm.edit> <select-environments available=vm.availableEnvironments ng-model=vm.selectedEnvironments multiple=true ng-change=vm.refreshPreview()></select-environments> <div class=\"padding-sm-vr text-center\"> <a class=\"btn btn-info\" href ng-click=\"vm.edit=false\">Use selected environments</a> </div> </div> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 891 */
/***/ function(module, exports) {

	var path = 'areas/projects/deployment-create/deployment-create-schedule.html';
	var html = "<div> <control-group label=When> <label class=radio> <input ng-model=vm.isScheduled type=radio ng-value=false ng-change=vm.updateScheduled()> Now</label> <label class=radio> <input ng-model=vm.isScheduled type=radio ng-value=true ng-change=vm.updateScheduled()> Later</label> </control-group> <control-group label=\"Scheduled start time\" ng-show=vm.isScheduled> <div class=laterDateTime> <div> <input-date-picker class=inline ng-model=vm.scheduledDate min-date=vm.minDate max-date=vm.maxDate ng-required=vm.isScheduled> </input-date-picker> </div> <div> <uib-timepicker class=timepicker ng-model=vm.scheduledTime ng-required=vm.isScheduled hour-step=1 minute-step=15 show-meridian=true ng-change=vm.updateScheduled()> </uib-timepicker> </div> <div class=\"inline center-line\">{{vm.userTimezone}}</div> </div> <div ng-show=vm.scheduledDate>The deployment will start in approximately {{vm.scheduledAt | momentFrom: vm.moment()}} </div> </control-group> <control-group label=\"Expiry time\" ng-show=vm.isScheduled> <div class=laterDateTime> <div> <input-date-picker class=inline ng-model=vm.expiryDate min-date=vm.scheduledDate max-date=vm.maxDate ng-required=vm.isScheduled> </input-date-picker> </div> <div> <uib-timepicker class=timepicker ng-model=vm.expiryTime ng-required=vm.isScheduled hour-step=1 minute-step=15 show-meridian=true ng-change=vm.updateExpiry()> </uib-timepicker> </div> <div class=\"inline center-line\">{{vm.userTimezone}}</div> </div> <div ng-show=\"vm.expiryDate && vm.expiresAt > vm.scheduledAt\">The deployment must begin within {{vm.expiresAt | momentFrom: vm.scheduledAt}} of the scheduled start time or it will time out </div> <div ng-show=\"vm.expiryDate && vm.expiresAt <= vm.scheduledAt\" class=\"alert alert-danger\">The expiry date must be after the scheduled date</div> </control-group> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 892 */
/***/ function(module, exports) {

	var path = 'areas/projects/deployment-create/deployment-create-tenant-selector.html';
	var html = "<div> <div class=\"alert alert-warning\" ng-if=vm.warning> <strong>{{vm.warning.title}}</strong><br/> {{vm.warning.message}} </div> <div ng-if=!vm.warning> <control-group label=Environment> <select-environments multiple=false ng-if=vm.edit available=vm.availableEnvironments ng-model=vm.selectedEnvironment ng-change=vm.setSelectedEnvironment()></select-environments> <div ng-if=!vm.edit style=padding-top:7px> <span class=label ng-class=label>{{ vm.selectedEnvironmentName }}</span> </div> </control-group> <control-group label=Tenants> <div style=padding-top:7px ng-if=vm.selectedEnvironment> <div ng-if=vm.anyTenantsInThisEnvironment> <div ng-if=!vm.edit> <a href ng-click=\"vm.edit=true\" ng-if=\"vm.selectedTenants.length <= 0 && vm.selectedTags.length <= 0 && !vm.edit\">Select tenants</a> <div class=selected-environment ng-repeat=\"tenantId in vm.selectedTenants\"> <div> <strong>{{ vm.tenantsById[tenantId].Name }}</strong> <span ng-if=\"vm.getMissingTenantVariables(tenantId).length > 0\"> <a ng-href=#tenants/{{tenantId}}/variables/projects uib-popover-template=\"'missingTagPopover.html'\" popover-trigger=mouseenter> <i class=\"fa fa-warning text-warning\"></i> <span class=text-warning>fix</span> </a> </span> <spin active=\"vm.newDeployments[vm.selectedEnvironment][tenantId].state === 'running'\" class=spin-static></spin> <div ng-if=\"vm.newDeployments[vm.selectedEnvironment] && vm.newDeployments[vm.selectedEnvironment][tenantId]\"> <error-box ng-if=\"vm.newDeployments[vm.selectedEnvironment][tenantId].state === 'error'\" error=vm.newDeployments[vm.selectedEnvironment][tenantId].error></error-box> <div class=\"alert alert-success\" ng-if=\"vm.newDeployments[vm.selectedEnvironment][tenantId].state === 'success'\"> Deployment queued: <a href=\"#/tasks/{{ vm.newDeployments[vm.selectedEnvironment][tenantId].deployment.TaskId }}\">{{ vm.newDeployments[vm.selectedEnvironment][tenantId].deployment.Name }}</a> </div> </div> </div> </div> <div ng-if=\"vm.selectedTags.length !== 0\"> {{vm.selectedTenants.length > 0 ? 'and any' : 'Any'}} tenants tagged with <missing-tag-list tag-list=vm.selectedTags tags-all=vm.tagSets></missing-tag-list> <i class=\"fa fa-warning text-warning\" ng-if=\"vm.tagMatchedTenants.length == 0\" uib-tooltip=\"There are no tenants that match the selected tags.\"></i> <div> {{vm.tagMatchedTenants.length}} matching tenant{{vm.tagMatchedTenants.length == 1 ? '' :'s'}} <i class=\"fa fa-warning text-warning\" ng-if=vm.isTagMatchedTenantMissingVariable uib-tooltip=\"Some of these tenants are missing variable values required to successfully deploy the release.\"></i> <a href ng-if=\"vm.tagMatchedTenants.length !== 0\" ng-click=\"vm.showMatched = !vm.showMatched\">{{vm.showMatched ? 'Hide «' : 'Show »'}}</a> </div> <div class=padding-sm-hr ng-if=vm.showMatched> <div class=selected-environment ng-repeat=\"tenant in vm.tagMatchedTenants\"> <div> <strong>{{ tenant.Name }}</strong> <span ng-if=\"vm.getMissingTenantVariables(tenant.Id).length > 0\"> <a ng-href=#tenants/{{tenant.Id}}/variables/projects uib-popover-template=\"'missingTagPopover2.html'\" popover-trigger=mouseenter> <i class=\"fa fa-warning text-warning\"></i> <span class=text-warning>fix</span> </a> </span> <spin active=\"vm.newDeployments[vm.selectedEnvironment][tenant.Id].state === 'running'\" class=spin-static></spin> <div ng-if=\"vm.newDeployments[vm.selectedEnvironment] && vm.newDeployments[vm.selectedEnvironment][tenant.Id]\"> <error-box ng-if=\"vm.newDeployments[vm.selectedEnvironment][tenant.Id].state === 'error'\" error=vm.newDeployments[vm.selectedEnvironment][tenant.Id].error></error-box> <div class=\"alert alert-success\" ng-if=\"vm.newDeployments[vm.selectedEnvironment][tenant.Id].state === 'success'\"> Deployment queued: <a href=\"#/tasks/{{ vm.newDeployments[vm.selectedEnvironment][tenant.Id].deployment.TaskId }}\">{{ vm.newDeployments[vm.selectedEnvironment][tenant.Id].deployment.Name }}</a> </div> </div> </div> </div> </div> </div> </div> <div ng-if=vm.edit> <advanced-tenant-selector available-tenants=vm.availableTenants selected-tenants=vm.selectedTenants selected-tags=vm.selectedTags selected-environment=vm.selectedEnvironment tenant-filter=vm.customTenantFilter(tenant)> </advanced-tenant-selector> <div class=\"padding-sm-vr text-center\"> <a class=\"btn btn-info\" ng-disabled=\"vm.selectedTenants.length <= 0 && vm.selectedTags.length <= 0\" href ng-click=vm.applySelection()>Use selected tenants</a> </div> </div> </div> <div ng-if=!vm.anyTenantsInThisEnvironment class=\"alert alert-info\"> There are no tenants connected to the {{vm.selectedEnvironment.Name || 'selected'}} environment. </div> </div> <div ng-if=!vm.selectedEnvironment class=\"alert alert-info\"> Select an environment, and then select tenants for this deployment. </div> </control-group> <control-group> <a class=\"btn btn-default\" href ng-click=\"vm.edit=true\" ng-if=\"(vm.selectedTenants.length > 0 || vm.selectedTags.length > 0) && !vm.edit\">Change tenants</a> </control-group> <div class=\"alert alert-warning padding-sm-vr\" ng-if=\"vm.isTagMatchedTenantMissingVariable || vm.hasSelectedTenantsWithMissingVariables()\"> Some of the selected tenants are missing variable values required for this deployment to succeed. Either provide a value for the tenant or configure a default value for the variable template. See <a class=alert-link href=http://g.octopushq.com/MultiTenantVariables target=_blank>http://g.octopushq.com/MultiTenantVariables</a> for more information. </div> </div> <script type=text/ng-template id=missingTagPopover.html> <div>\r\n            Missing variable values:<br />\r\n            <strong ng-repeat=\"name in vm.getMissingTenantVariables(tenantId)\">{{name}}{{$last ? '' : ', '}}</strong>\r\n        </div> </script> <script type=text/ng-template id=missingTagPopover2.html> <div>\r\n            Missing variable values:<br />\r\n            <strong ng-repeat=\"name in vm.getMissingTenantVariables(tenant.Id)\">{{name}}{{$last ? '' : ', '}}</strong>\r\n        </div> </script> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 893 */
/***/ function(module, exports) {

	var path = 'areas/projects/deployment-create/options.html';
	var html = "<div> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=deployment.ForcePackageDownload> Re-download packages from the feed server</label></div> <p class=help-block>When checked, the package will be re-retrieved from the appropriate feed (if applicable).</p> </control-group> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=deployment.UseGuidedFailure> Use guided failure mode</label></div> <p class=help-block>When checked, if an error is encountered during the deployment, Octopus will pause and allow you to correct the error before proceeding. When unchecked, any errors encountered will result in the deployment failing.</p> </control-group> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=$storage.alwaysShowAdvancedDeploymentOptions> Always show these options</label></div> <p class=help-block>When checked, these advanced deployment options will always be shown by default.</p> </control-group> <div ng-show=project.DefaultToSkipIfAlreadyInstalled> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=deployment.ForcePackageRedeployment> Force deployment of packages that are already installed</label></div> <p class=help-block> When checked, packages with the same version already installed will be re-deployed regardless of whether the <em>skip</em> option is set in the project settings or project variables. </p> </control-group> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 894 */
/***/ function(module, exports) {

	var path = 'areas/projects/deployment-create/preview.html';
	var html = "<div> <spin active=isPreviewing.busy></spin> <error-box error=isPreviewing.error></error-box> <div ng-show=\"steps && !isPreviewing.busy\"> <control-group label=Steps> <div class=margin-bottom-20 ng-show=canSkipAll> <div class=\"smaller-fonts subtle\" style=margin-top:6px> Skip: <a href ng-click=skipNone()>None</a> | <a href ng-click=skipAll()>All</a> </div> </div> <div ng-repeat=\"step in steps\"> <div class=form-group-margin> <div class=pull-left-100> <input type=checkbox bs-switch switch-active={{step.details.CanBeSkipped}} ng-model=step.enable switch-on-color=default switch-on-text=\"<i class='fa fa-check'></i>\" switch-off-color=warning switch-off-text=Skip switch-size=small> </div> <div class=\"indent-left-100 no-padding\" ng-class=\"{'not-enabled': !step.enable}\"> <div> {{ step.details.ActionNumber}}. <strong>{{ step.details.ActionName }}</strong> <div class=\"indent-left-10 smaller-fonts margin-top-5\" ng-show=step.details.Machines octo-permission=MachineView octo-project=project.Id octo-environment=\"'*'\"> <span style=margin-right:10px;display:inline-table ng-repeat=\"m in step.details.Machines\" ng-class=\"{ 'not-enabled': !isMachineIncludedInDeployment(m.Id) || !isMachineApplicableToThisDeployment(m.Id), 'offline': m.isUnavailable }\">{{m.Name}}</span> </div> </div> </div> <div class=indent-left-100> <div class=\"alert alert-warning\" ng-show=\"step.details.HasNoApplicableMachines && !allowDeploymentsToNoTargets\"> <strong>Warning: </strong> there are no enabled deployment targets in the roles specified by this step, in this environment. </div> </div> </div> </div> <div ng-if=showSkippedStepsWillAffectAutoDeploymentsWarning() class=\"alert alert-warning\"> <strong>Skipping steps affects automatic deployments</strong> <br/> These steps will also be skipped in any automatic deployments of this project that trigger after this manual deployment succeeds. </div> </control-group> </div> <div ng-if=\"view.selectedEnvironments.length === 1\" ng-hide=isPreviewing.busy octo-permission=MachineView octo-project=project.Id octo-environment=\"'*'\"> <div ng-if=canSelectSpecificMachines()> <control-group label=\"Deployment targets\"> <div class=radio> <label><input type=radio name=specificMachineOptions value=all ng-model=view.selectedSpecificMachineOption> Include all applicable deployment targets</label> </div> <div class=radio> <label><input type=radio name=specificMachineOptions value=include ng-model=view.selectedSpecificMachineOption> Include specific deployment targets</label> </div> <div ng-if=\"view.selectedSpecificMachineOption === 'include'\"> <select-machines placeholder=\"Include all deployment targets\" available=specificMachines selected=view.includeSpecificMachineIds> </select-machines> <p class=help-block>Choose the specific deployment targets you want included in this deployment.</p> </div> <div class=radio> <label><input type=radio name=specificMachineOptions value=exclude ng-model=view.selectedSpecificMachineOption> Exclude specific deployment targets</label> </div> <div ng-if=\"view.selectedSpecificMachineOption === 'exclude'\"> <select-machines placeholder=\"Include all deployment targets\" available=specificMachines selected=view.excludeSpecificMachineIds> </select-machines> <p class=help-block>Choose the deployment targets you want excluded from this deployment.</p> </div> </control-group> </div> <div class=\"alert alert-warning\" role=alert ng-show=isTargetingAnyUnavailableMachines()> Some of the deployment targets you are targeting were unavailable at the last health check and may cause your deployment to fail. <a href class=alert-link ng-click=onlyIncludeAvailableMachines();>Fix this for me</a>. </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 895 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.ConfigurationTransforms_edit.html';
	var html = "<h4 class=separator>Configuration transforms</h4> <control-group label=\"XML transforms\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=runConfigTransforms ng-model='action.Properties[\"Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Automatically run configuration transformation files </label></div> </bound-field> <p class=help-block> Octopus can run configuration transformation files. By default Octopus looks for <em>*.Release.config</em> and <em>*.&lt;EnvironmentName&gt;.config</em>. </p> </control-group> <control-group label=\"Additional transforms\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.AdditionalXmlConfigurationTransforms\"]' reset-value=\"''\" project-id=project.Id> <textarea class=form-control rows=5 id=customInstallDirectory ng-model='action.Properties[\"Octopus.Action.Package.AdditionalXmlConfigurationTransforms\"]'></textarea> </bound-field> <p class=help-block>A comma- or newline-separated list of additional configuration transformation file rules. Example:</p> <pre class=help-block>Web.Release.config => Web.config\r\n*.Foo.config => *.config\r\ncrossdomainpolicy.#{Octopus.Environment.Name}.xml => crossdomainpolicy.xml</pre> <p class=help-block>If your configuration file is named <em>Bar.xml</em>, and your transformation file is named <em>Foo.xml</em>, you should enter <em>Foo.xml=>Bar.xml</em>. Wildcards are supported so if you have config files named <em>xyz.Bar.config</em> and <em>abc.Bar.config</em>, and you have transform files named <em>xyz.Foo.config</em> and <em>abc.Foo.config</em>, you may enter <em>*.Foo.config=>*.Bar.config</em></p> </control-group> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 896 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.ConfigurationVariables_edit.html';
	var html = "<h4 class=separator>Configuration Variables</h4> <control-group label=\"Configuration Variables\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=updateAppSettings ng-model='action.Properties[\"Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Replace <em>appSettings</em> and <em>connectionString</em> entries in any <em>.config</em> files </label></div> </bound-field> <p class=help-block> Tentacle will look inside your <em>.config</em> files and attempt to replace any `appSettings` or `connectionStrings` entries that have a `key` or `name` that matches the name of a variable defined in Octopus. For more information, please <a href=http://octopusdeploy.com/documentation/features/xml-config>see the documentation</a>. </p> </control-group> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 897 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.CustomDirectory_edit.html';
	var html = "<h4 class=separator>Custom install directory</h4> <control-group label=\"Install to\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.CustomInstallationDirectory\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=customInstallDirectory ng-model='action.Properties[\"Octopus.Action.Package.CustomInstallationDirectory\"]'> </bound-field> <p class=help-block>After the package is extracted, it will be copied to this location on the remote machine.</p> </control-group> <control-group label=Purge> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=purgeInstallDir ng-model='action.Properties[\"Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Purge this directory before installation </label></div> </bound-field> <p class=help-block>Before the contents of the extracted package is copied, all files in this location will be removed.</p> </control-group> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 898 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.CustomScripts_edit.html';
	var html = "<h4 class=separator>Pre-deployment script</h4> <div> <p class=help-block> This script will run after the package is extracted, but before any configuration changes are made. </p> <script-editor id=preDeployScript body=scripts.preDeploy.scriptBody syntax=scripts.preDeploy.syntax project-id=project.Id local-names=localNames></script-editor> </div> <h4 class=separator>Deployment script</h4> <div> <p class=help-block> This script will run after XML configuration changes are made, but before any IIS or Windows Service changes are made. </p> <script-editor id=deployScript body=scripts.deploy.scriptBody syntax=scripts.deploy.syntax project-id=project.Id local-names=localNames></script-editor> </div> <h4 class=separator>Post-deployment script</h4> <div> <p class=help-block> This script will run after IIS or Windows Service changes are made. </p> <script-editor id=postDeployScript body=scripts.postDeploy.scriptBody syntax=scripts.postDeploy.syntax project-id=project.Id local-names=localNames></script-editor> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 899 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.IISWebSite_binding_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add binding</h3> </div> <div class=\"modal-body help-scope\"> <error-box error=isSaving.error></error-box> <div class=form-horizontal> <control-group label=Protocol> <bound-field local-names=localNames model=binding.protocol reset-value=\"'http'\" project-id=binding.projectId> <select class=form-control ng-model=binding.protocol ng-change=protocolChanged()> <option value=http>HTTP</option> <option value=https>HTTPS</option> </select> </bound-field> </control-group> <control-group label=Port> <bound-field local-names=localNames model=binding.port reset-value=\"'80'\" project-id=binding.projectId> <input class=form-control type=text id=portNumber ng-model=binding.port> </bound-field> <p class=help-block>The TCP port number that this binding will listen on.</p> </control-group> <control-group label=\"IP address\"> <bound-field local-names=localNames model=binding.ipAddress reset-value=\"'*'\" project-id=binding.projectId> <input class=form-control type=text id=ipAddress ng-model=binding.ipAddress> </bound-field> <p class=help-block>The IP address that the binding will listen on. Use <code>*</code> for any address, or specify an address such as <code>10.0.0.1</code>. If using a IPv6 address remember to enclose in square brackets such as <code>[::1]</code>.</p> </control-group> <control-group label=\"Host name\"> <bound-field local-names=localNames model=binding.host reset-value=\"''\" project-id=binding.projectId> <input class=form-control type=text id=bindingHost ng-model=binding.host> </bound-field> <p class=help-block>The host header that this binding will listen on. Example: <code>www.contoso.com</code>. Leave empty to use any host header.</p> </control-group> <div ng-show=\"binding.protocol != 'http'\"> <control-group label=\"SSL thumbprint\"> <bound-field local-names=localNames model=binding.thumbprint reset-value=\"''\" project-id=binding.projectId> <input class=form-control type=text id=thumbprint ng-model=binding.thumbprint> </bound-field> <p class=help-block>The X.509 certificate thumbprint to use.</p> </control-group> <control-group label=\"Require SNI\"> <bound-field local-names=localNames model=binding.requireSni reset-value=\"'False'\" project-id=binding.projectId> <input class=\"\" type=checkbox id=requireSni ng-model=binding.requireSni ng-true-value=true ng-false-value=false> </bound-field> <p class=help-block>Require Server Name Indication.</p> </control-group> </div> <control-group label=Enabled> <bound-field local-names=localNames model=binding.enabled reset-value=\"'False'\" project-id=binding.projectId> <input class=\"\" type=checkbox id=bindingEnabled ng-model=binding.enabled ng-true-value=true ng-false-value=false> </bound-field> <p class=help-block>Disable this binding to skip it (the binding will not be added).</p> </control-group> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save() ng-show=!isLoading.busy>Save</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 900 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.IISWebSite_edit.html';
	var html = "<h4 class=separator>IIS Deployment Type</h4> <control-group label=\"Deployment type\"> <div class=radio> <label><input type=radio ng-model='action.Properties[\"Octopus.Action.IISWebSite.DeploymentType\"]' value=webSite ng-click=selectWebSite()>IIS Web Site</label> <p class=help-block>Create or update an IIS Web Site</p> </div> <div class=radio> <label><input type=radio ng-model='action.Properties[\"Octopus.Action.IISWebSite.DeploymentType\"]' value=virtualDirectory ng-click=selectVirtualDirectory()>IIS Virtual Directory</label> <p class=help-block>Create or update an IIS Virtual Directory as a child of an existing IIS Web Site</p> </div> <div class=radio> <label><input type=radio ng-model='action.Properties[\"Octopus.Action.IISWebSite.DeploymentType\"]' value=webApplication ng-click=selectWebApplication()>IIS Web Application</label> <p class=help-block>Create or update an IIS Web Application as a child of an existing IIS Web Site</p> </div> </control-group> <p class=help-block>Learn more about deploying <a href=http://g.octopushq.com/IISWebsitesAndApplications target=_blank>IIS Websites and Applications</a>.</p> <div ng-if=\"action.Properties['Octopus.Action.IISWebSite.DeploymentType'] === 'webSite'\"> <h4 class=separator>IIS Web Site</h4> <control-group label=\"Web Site\" ng-if=!isIISStep> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.CreateOrUpdateWebSite\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=runConfigTransforms ng-model='action.Properties[\"Octopus.Action.IISWebSite.CreateOrUpdateWebSite\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Create or update an IIS Web Site and Application Pool </label></div> </bound-field> <p class=help-block> If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Web Site and Application Pool using the settings below. </p> </control-group> <control-group label=\"Web Site name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.WebSiteName\"]' reset-value=\"''\" project-id=project.Id> <input class=\"input-xlarge form-control\" type=text id=webSiteName ng-change=checkWebSiteName() ng-model='action.Properties[\"Octopus.Action.IISWebSite.WebSiteName\"]'> </bound-field> <octo-clippy ng-show=looksLikeVDir> <p>Hey there! It looks like you might be trying to configure a Virtual Directory. <em>IIS Web Site</em> doesn't support Virtual Directories. You might consider using either the <em>IIS Virtual Directory</em> or <em>IIS Web Application</em> deployment type for that, or check <a href=https://library.octopusdeploy.com>the template library</a> for more options.</p> </octo-clippy> <p class=help-block>The display name of the IIS Web Site to create or reconfigure.</p> </control-group> <control-group label=\"Physical path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.WebRoot\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text placeholder=\"Package root\" ng-change=checkWebRoot() id=homeDirectory ng-model='action.Properties[\"Octopus.Action.IISWebSite.WebRoot\"]'> </bound-field> <p class=help-block> The physical path on disk this Web Site will point to. You can specify an absolute path, or a relative path inside the package installation directory. </p> </control-group> <h4 class=separator>IIS Application Pool</h4> <application-pool-editor action=action project=project local-names=localNames path-to-root-property=Octopus.Action.IISWebSite></application-pool-editor> <h4 class=separator>IIS Bindings</h4> <div> <control-group label=Bindings> <ul class=\"octo-list-group can-add\" ng-show=iisBindings.length> <li class=octo-list-group-item ng-repeat=\"binding in iisBindings\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=removeBinding(binding)>×</button> <div> <p ng-show=binding.protocol>Protocol: <strong>{{ binding.protocol }}</strong></p> <p ng-show=binding.port>Port: <strong>{{ binding.port }}</strong></p> <p ng-show=binding.ipAddress>IP Address: <strong>{{ binding.ipAddress }}</strong></p> <p ng-show=binding.host>Host: <strong>{{ binding.host }}</strong></p> <p ng-show=binding.thumbprint>SSL certificate thumbprint: <strong>{{ binding.thumbprint }}</strong></p> <p ng-show=binding.requireSni>Require Server Name Indication (SNI): <strong>{{ binding.requireSni }}</strong></p> <p><a class=btn-link href ng-click=editBinding(binding)>Edit</a></p> </div> </li> </ul> <button class=\"btn btn-default\" type=button ng-class=\"{ 'octo-list-group-add': iisBindings.length }\" ng-click=addBinding()><i class=icon-plus></i> Add binding</button> <p class=help-block>Bindings define what protocols, ports and host names this site will listen on.</p> </control-group> </div> <h4 class=separator>IIS Authentication</h4> <control-group label=\"Authentication modes\"> <bound-field local-names=localNames label=\"Enable Anonymous authentication\" model='action.Properties[\"Octopus.Action.IISWebSite.EnableAnonymousAuthentication\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=enableAnonymous ng-model='action.Properties[\"Octopus.Action.IISWebSite.EnableAnonymousAuthentication\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Enable Anonymous authentication </label></div> </bound-field> <p class=help-block> Whether IIS should allow anonymous authentication. </p> </control-group> <control-group label> <bound-field local-names=localNames label=\"Enable Basic authentication\" model='action.Properties[\"Octopus.Action.IISWebSite.EnableBasicAuthentication\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=enableBasic ng-model='action.Properties[\"Octopus.Action.IISWebSite.EnableBasicAuthentication\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Enable Basic authentication </label></div> </bound-field> <p class=help-block> Whether IIS should allow basic authentication with a 401 challenge. </p> </control-group> <control-group label> <bound-field local-names=localNames label=\"Enable Windows authentication\" model='action.Properties[\"Octopus.Action.IISWebSite.EnableWindowsAuthentication\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=enableWindows ng-model='action.Properties[\"Octopus.Action.IISWebSite.EnableWindowsAuthentication\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Enable Windows authentication </label></div> </bound-field> <p class=help-block> Whether IIS should allow integrated Windows authentication with a 401 challenge. </p> </control-group> </div> <div ng-if=\"action.Properties['Octopus.Action.IISWebSite.DeploymentType'] === 'virtualDirectory'\"> <h4 class=separator>IIS Virtual Directory</h4> <control-group label=\"Virtual Directory\" ng-if=!isIISStep> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=runConfigTransforms ng-model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Create or update an IIS Virtual Directory </label></div> </bound-field> <p class=help-block> If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Virtual Directory and Application Pool using the settings below. </p> </control-group> <control-group label=\"Parent Web Site name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName\"]' reset-value=\"''\" project-id=project.Id> <input class=\"input-xlarge form-control\" type=text id=webSiteName ng-change=checkWebSiteName() ng-model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName\"]'> </bound-field> <p class=help-block>The name of the parent Web Site for this Virtual Directory in IIS. The Web Site should already exist when this step runs.</p> </control-group> <control-group label=\"Virtual path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath\"]' reset-value=\"''\" project-id=project.Id> <input class=\"input-xlarge form-control\" type=text id=webSiteName ng-model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath\"]'> </bound-field> <p class=help-block> The virtual path in IIS relative to the parent Web Site. E.g. <code>/application1/directory2/mydirectory</code>. <br/> Note: All parent directories/applications must already exist. </p> </control-group> <control-group label=\"Physical path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text placeholder=\"Package root\" ng-change=checkWebRoot() id=homeDirectory ng-model='action.Properties[\"Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath\"]'> </bound-field> <p class=help-block> The physical path on disk this Virtual Directory will point to. You can specify an absolute path, or a relative path inside the package installation directory. </p> </control-group> </div> <div ng-if=\"action.Properties['Octopus.Action.IISWebSite.DeploymentType'] === 'webApplication'\"> <h4 class=separator>IIS Web Application</h4> <control-group label=\"Web Application\" ng-if=!isIISStep> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=runConfigTransforms ng-model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Create or update an IIS Web Application and Application Pool </label></div> </bound-field> <p class=help-block> If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Web Application and Application Pool using the settings below. </p> </control-group> <control-group label=\"Parent Web Site name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.WebSiteName\"]' reset-value=\"''\" project-id=project.Id> <input class=\"input-xlarge form-control\" type=text id=webSiteName ng-change=checkWebSiteName() ng-model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.WebSiteName\"]'> </bound-field> <p class=help-block>The name of the parent Web Site for this Web Application in IIS. The Web Site should already exist when this step runs.</p> </control-group> <control-group label=\"Virtual path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.VirtualPath\"]' reset-value=\"''\" project-id=project.Id> <input class=\"input-xlarge form-control\" type=text id=webSiteName ng-model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.VirtualPath\"]'> </bound-field> <p class=help-block> The virtual path in IIS relative to the parent Web Site. E.g. <code>/myapplication</code>. <br/> Note: All parent directories/applications must already exist. </p> </control-group> <control-group label=\"Physical path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.PhysicalPath\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text placeholder=\"Package root\" ng-change=checkWebRoot() id=homeDirectory ng-model='action.Properties[\"Octopus.Action.IISWebSite.WebApplication.PhysicalPath\"]'> </bound-field> <p class=help-block> The physical path on disk this Web Application will point to. You can specify an absolute path, or a relative path inside the package installation directory. </p> </control-group> <h4 class=separator>IIS Application Pool</h4> <application-pool-editor action=action project=project local-names=localNames path-to-root-property=Octopus.Action.IISWebSite.WebApplication></application-pool-editor> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 901 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.IisHome_edit.html';
	var html = "<h4 class=separator>IIS home directory</h4> <control-group label=\"Update IIS website\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.UpdateIisWebsite\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=updateIisHome ng-model='action.Properties[\"Octopus.Action.Package.UpdateIisWebsite\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Attempt to automatically update IIS </label></div> </bound-field> <p class=help-block> Tentacle will look in IIS for a website with the same name as the current package (or the custom name below) and will attempt to change the home directory to point to the folder that the package was extracted to. </p> </control-group> <control-group label=\"Site/virtual directory\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.UpdateIisWebsiteName\"]' reset-value=\"''\" project-id=project.Id> <input class=\"input-xlarge form-control\" type=text id=customWebsiteName ng-model='action.Properties[\"Octopus.Action.Package.UpdateIisWebsiteName\"]'> </bound-field> <p class=help-block>The name of the IIS website, or virtual directory path, to attempt to update. To specify a virtual directory, use the format:</p> <pre class=help-block>WebsiteName/VirtualDirectory1/VirtualDirectory2</pre> <p class=help-block>If no name is specified, Tentacle will look for an IIS site named with the same name as the package ID.</p> </control-group> <hr/> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 902 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.JsonConfigurationVariables_edit.html';
	var html = "<h4 class=separator>JSON Configuration Variables</h4> <control-group label=\"Target files\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.JsonConfigurationVariablesTargets\"]' reset-value=\"''\" project-id=project.Id> <textarea rows=3 class=form-control id=customInstallDirectory ng-model='action.Properties[\"Octopus.Action.Package.JsonConfigurationVariablesTargets\"]'/>\r\n  </bound-field>\r\n  <p class=help-block>A comma- or newline-separated list of file names to replace settings in, relative to the package contents. Wildcards are supported.\r\n    E.g., <em>appsettings.json</em>, <em>Config\\*.json</em>. Configuration values can be replaced using a <code>:</code> separated key, starting from the root of the hierarchy.\r\n    <a href=\"\" detailed-help-toggle>Show example.</a>\r\n  </p>\r\n  <div class=\"detailed-help help-block\">\r\n    <p class=help-block>\r\n      Consider the following <em>appsettings.json</em> file:\r\n    </p>\r\n    <pre class=help-block>{\r\n    \"Data\": {\r\n      \"DefaultConnection\": {\r\n        \"ConnectionString\": \"Server=(localdb)\\\\SQLEXPRESS;Database=OctoFX;Trusted_Connection=True\"\r\n      }\r\n    }\r\n  }</pre>\r\n    <p class=help-block>\r\n      To replace the value of <code>ConnectionString</code> you would add a variable name <code>Data:DefaultConnection:ConnectionString</code> to your project variables / library variable set.\r\n    </p>\r\n    <p class=help-block>This field supports extended template syntax. Conditional <code>if</code> and <code>unless</code>:</p>\r\n    <pre class=help-block>#{if MyVar}...#{/if}</pre><br/>\r\n    <p class=help-block>Iteration over variable sets or comma-separated values with <code>each</code>:</p>\r\n    <pre class=help-block>#{each mv in MyVar}...#{mv}...#{/each}</pre>\r\n  </div>\r\n</control-group> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 903 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.RedGateDatabase_edit.html';
	var html = "<h4 class=separator>Red Gate Database (Deprecated)</h4> <div class=\"alert alert-warning\"> SQL Release has been replaced by DLM Automation. Don't worry: You can continue to use this feature until you decide to start using DLM Automation. For more information refer to our <a class=alert-link href=http://g.octopushq.com/RedGateSQLRelease target=_blank>documentation</a>. </div> <control-group label=\"Deploy database\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.RedGateDatabase.Enabled\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=runConfigTransforms ng-model='action.Properties[\"Octopus.Action.RedGateDatabase.Enabled\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Enable Red Gate database package deployment </label></div> </bound-field> </control-group> <control-group label=\"Database name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.RedGateDatabase.DatabaseName\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=databaseName ng-model='action.Properties[\"Octopus.Action.RedGateDatabase.DatabaseName\"]'> </bound-field> <p class=help-block>The name of the SQL database to deploy.</p> </control-group> <control-group label=\"SQL Servers\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.RedGateDatabase.ConnectionStrings\"]' reset-value=\"''\" project-id=project.Id> <textarea class=form-control id=connectionStrings ng-model='action.Properties[\"Octopus.Action.RedGateDatabase.ConnectionStrings\"]'></textarea> </bound-field> <p class=help-block>A list of SQL Server connection strings for the databases to deploy to. Each connection string should be on a new line.</p> <p class=help-block>You can use variables to define different connection strings for each environment, and then reference them:</p> <pre class=help-block>#{MyConnectionString}</pre> </control-group> <control-group label=\"Post-deploy validation\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.RedGateDatabase.PostDeployValidationEnabled\"]' reset-value=\"''\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=postDeployValidation ng-model='action.Properties[\"Octopus.Action.RedGateDatabase.PostDeployValidationEnabled\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Validate that no other changes to the database have been made outside this deployment. </label></div> </bound-field> <p class=help-block>Check that the deployment was successful, and that no changes were made outside of Octopus during the deployment. If validation fails, it stops the deployment after the database upgrade.</p> </control-group> <control-group label=\"SQLCI.exe Path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.RedGateDatabase.SqlCiPath\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=sqlCiPath ng-model='action.Properties[\"Octopus.Action.RedGateDatabase.SqlCiPath\"]'> </bound-field> <p class=help-block>The path to Red Gate's SQLCI.exe.</p> </control-group> <control-group label=\"SQLCompare.exe Path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.RedGateDatabase.SqlComparePath\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=sqlComparePath ng-model='action.Properties[\"Octopus.Action.RedGateDatabase.SqlComparePath\"]'> </bound-field> <p class=help-block>The path to the Red Gate's SQLCompare.exe.</p> </control-group> <control-group label=\"Comparison options\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.RedGateDatabase.CompareOptions\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=compareOptions ng-model='action.Properties[\"Octopus.Action.RedGateDatabase.CompareOptions\"]'> </bound-field> <p class=help-block>The options to pass to the SQL Compare engine. To use multiple options, separate each option with commas or semicolons..</p> </control-group> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 904 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.SubstituteInFiles_edit.html';
	var html = "<h4 class=separator>Substitute variables in files</h4> <control-group label=\"Target files\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.SubstituteInFiles.TargetFiles\"]' reset-value=\"''\" project-id=project.Id> <textarea rows=3 class=form-control id=subFiles ng-model='action.Properties[\"Octopus.Action.SubstituteInFiles.TargetFiles\"]'/>\r\n  </bound-field>\r\n  <p class=help-block>A newline-separated list of file names to transform, relative to the package contents. Wildcards are supported.\r\n    E.g., <em>Notes.txt</em>, <em>Config\\*.json</em>.</p>\r\n    <p class=help-block>This field supports extended template syntax. Conditional <code>if</code> and <code>unless</code>:</p>\r\n    <pre class=help-block>#{if MyVar}...#{/if}</pre><br/>\r\n    <p class=help-block>Iteration over variable sets or comma-separated values with <code>each</code>:</p>\r\n    <pre class=help-block>#{each mv in MyVar}...#{mv}...#{/each}</pre>\r\n</control-group>\r\n\r\n<control-group label=\"Output file encoding\">\r\n  <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.SubstituteInFiles.OutputEncoding\"]' reset-value=\"''\" project-id=project.Id>\r\n    <input type=text class=form-control placeholder=\"Detect from template\" id=outputEncoding ng-model='action.Properties[\"Octopus.Action.SubstituteInFiles.OutputEncoding\"]'/>\r\n  </bound-field>\r\n  <p class=help-block>The name of an encoding to use when writing the transformed file. E.g., <em>utf-8</em>.</p>\r\n  <p class=help-block>For a list of supported encoding names, see the Remarks section of the <a href=http://g.octopushq.com/EncodingNames target=_blank>System.Text.Encoding</a> class on MSDN.</p>\r\n</control-group> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 905 */
/***/ function(module, exports) {

	var path = 'areas/projects/features/Octopus.Features.WindowsService_edit.html';
	var html = "<h4 class=separator>Windows Service</h4> <control-group label=\"Install Service\" ng-if=!isWindowsServiceStep> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.CreateOrUpdateService\"]' reset-value=\"'False'\" project-id=project.Id> <div class=checkbox><label> <input type=checkbox id=runConfigTransforms ng-model='action.Properties[\"Octopus.Action.WindowsService.CreateOrUpdateService\"]' ng-true-value=\"'True'\" ng-false-value=\"'False'\"> Install a Windows Service </label></div> </bound-field> <p class=help-block> If enabled, Tentacle will use <code>sc.exe</code> to attempt to create a Windows Service using the settings below. If the service already exists, Tentacle will stop the service, reconfigure it, and start it again. </p> </control-group> <control-group label=\"Service name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.ServiceName\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=serviceName ng-model='action.Properties[\"Octopus.Action.WindowsService.ServiceName\"]'> </bound-field> <p class=help-block>The name of the Windows Service to create or configure.</p> </control-group> <control-group label=\"Display name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.DisplayName\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=displayName ng-model='action.Properties[\"Octopus.Action.WindowsService.DisplayName\"]'> </bound-field> <p class=help-block>Optional display name of the Windows Service.</p> </control-group> <control-group label=Description> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.Description\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=serviceDescription ng-model='action.Properties[\"Octopus.Action.WindowsService.Description\"]'> </bound-field> <p class=help-block>User-friendly description of the service.</p> </control-group> <h4 class=separator>Windows Service: Executable</h4> <control-group label=\"Executable path\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.ExecutablePath\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=executablePath ng-model='action.Properties[\"Octopus.Action.WindowsService.ExecutablePath\"]'> </bound-field> <p class=help-block>Path to the executable file for the service. The path should be relative to the package installation directory; for example:</p> <ul class=help-block> <li><code>MyService.exe</code></li> <li><code>bin\\MyService.exe</code></li> </ul> </control-group> <control-group label=Arguments> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.Arguments\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=serviceArguments ng-model='action.Properties[\"Octopus.Action.WindowsService.Arguments\"]'> </bound-field> <p class=help-block>Command line arguments that will be passed to the service when it starts each time.</p> </control-group> <h4 class=separator>Windows Service: Startup</h4> <control-group label=\"Service account\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.ServiceAccount\"]' reset-value=\"''\" project-id=project.Id bound=account.bound> <select class=form-control id=serviceAccount ng-model='action.Properties[\"Octopus.Action.WindowsService.ServiceAccount\"]'> <option value=LocalSystem>Local System</option> <option value=\"NT Authority\\Network Service\">Network Service</option> <option value=\"NT Authority\\Local Service\">Local Service</option> <option value=_CUSTOM>Custom user...</option> </select> </bound-field> <p class=help-block>Which built-in account will the service run under.</p> </control-group> <div ng-show='action.Properties[\"Octopus.Action.WindowsService.ServiceAccount\"] == \"_CUSTOM\" || account.bound.isBound'> <control-group label=\"Custom account name\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.CustomAccountName\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=customAccountName ng-model='action.Properties[\"Octopus.Action.WindowsService.CustomAccountName\"]'> </bound-field> <p class=help-block>The Windows/domain account of the custom user that the service will run under. Example: <code>YOURDOMAIN\\YourAccount</code>. You will need to ensure that this user has the 'Log on as a service' right.</p> </control-group> <control-group label=\"Custom account password\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.CustomAccountPassword\"]' reset-value=account.passwordReset project-id=project.Id> <sensitive-input model='action.Properties[\"Octopus.Action.WindowsService.CustomAccountPassword\"]'></sensitive-input> </bound-field> <p class=help-block>The password for the custom account given above.</p> </control-group> </div> <control-group label=\"Start mode\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.StartMode\"]' reset-value=\"'auto'\" project-id=project.Id> <select class=form-control id=startMode ng-model='action.Properties[\"Octopus.Action.WindowsService.StartMode\"]'> <option value=auto>Automatic</option> <option value=delayed-auto>Automatic (delayed)</option> <option value=demand>Manual</option> <option value=unchanged>Unchanged</option> </select> </bound-field> <p class=help-block>When will the service start? Use <em>Unchanged</em> to use the current status.</p> </control-group> <control-group label=Dependencies> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.WindowsService.Dependencies\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=serviceDependencies ng-model='action.Properties[\"Octopus.Action.WindowsService.Dependencies\"]'> </bound-field> <p class=help-block>Any dependencies that the service has. Separate the names using forward slashes (/). For example: <code>LanmanWorkstation/TCPIP/MSSQL</code>.</p> </control-group>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 906 */
/***/ function(module, exports) {

	var path = 'areas/projects/groups/ProjectGroupCreate.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projectgroups/new'>Create New</a></li> </script> <script octo-section=tools type=text/ng-template> </script> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <help-button></help-button> <h3>Create a project group</h3> <loading-wrapper busy=isLoading> <div class=\"form-box form-horizontal\"> <project-group-editor></project-group-editor> </div> </loading-wrapper> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 907 */
/***/ function(module, exports) {

	var path = 'areas/projects/groups/ProjectGroupEdit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/projectgroups/{{ projectGroup.Id }}\">{{ projectGroup.Name }}</a></li> </script> <script octo-section=tools type=text/ng-template> </script> <div class=row> <div class=col-sm-9> <help-button></help-button> <h3 class=no-margin-top>Project group settings</h3> <loading-wrapper busy=isLoading> <div class=\"form-box form-horizontal\"> <project-group-editor></project-group-editor> </div> </loading-wrapper> </div> <div class=col-sm-3> <div class=other-actions> <div octo-permission=ProjectGroupDelete octo-project-group=projectGroup.Id> <h3>Delete</h3> <p>Once you delete this project group, there is no going back. You cannot delete a project group that contains projects.</p> <delete-button model=projectGroup what=\"project group\" redirect=/projects></delete-button> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 908 */
/***/ function(module, exports) {

	var path = 'areas/projects/step-templates/step_templates.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/process'>Process</a></li>\r\n  <li><a href='#/projects/{{ project.Slug }}/steptemplates'>Step Templates</a></li> </script> <div> <error-box error=isInstalling.error></error-box> <div class=step-templates> <h3>Choose step template</h3> <div class=search> <search-box input-text=inputText on-text-changed=filterTemplates placeholder=\"Filter by name, category or description\" auto-focus=true /> </div> <h4 class=separator>Installed step templates</h4> <p ng-if=showActionTemplateTeaser class=\"alert alert-info\"> You can’t see custom installed step templates because you don't have <a class=alert-link href=http://g.octopushq.com/UserRoles target=_blank>ActionTemplateView</a> permission. </p> <step-templates templates=filteredInstalledTemplates on-addition-requested=add on-installation-requested=install on-update-requested=update on-details-requested=details resolve-link=resolveLink></step-templates> <p ng-if=\"!filteredInstalledTemplates.length && inputText\"> There are no installed step templates that match your filter criteria. </p> <h4 class=separator>Community contributed step templates</h4> <p ng-if=showLibraryTemplateTeaser class=\"alert alert-info\"> Community library integration is disabled. If you want to take advantage of hundreds great templates developed by the members of our community then please <a class=alert-link href=#/configuration/features>enable the integration feature.</a> </p> <p ng-if=\"!showLibraryTemplateTeaser && !showActionTemplateTeaser && filteredLibraryTemplates.length === 0 && !inputText\"> Community library integration is enabled but there aren't any community step templates available. Review the community step templates <a href=#/configuration/features target=_blank>feature toggle</a> for more information. </p> <step-templates templates=filteredLibraryTemplates on-addition-requested=add on-installation-requested=install on-update-requested=update on-details-requested=details resolve-link=resolveLink enable-grouping=enableGrouping></step-templates> <p ng-if=\"!showLibraryTemplateTeaser && !showActionTemplateTeaser && !filteredLibraryTemplates.length && inputText\"> There are no community step templates that match your filter criteria. </p> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 909 */
/***/ function(module, exports) {

	var path = 'areas/projects/triggers/trigger_create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/triggers/create'>Create New</a></li> </script> <project-trigger-editor></project-trigger-editor> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 910 */
/***/ function(module, exports) {

	var path = 'areas/projects/triggers/trigger_edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/triggers/edit/{{projectTrigger.Id}}'>{{projectTrigger.Name}}</a></li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <project-trigger-editor></project-trigger-editor> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <h3>Delete</h3> <div> <p>Deleting project triggers will stop any auto-deployments related to this trigger.</p> <delete-button model=projectTrigger what=\"Project Trigger\" redirect=/projects/{{project.Slug}}/triggers></delete-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 911 */
/***/ function(module, exports) {

	var path = 'areas/projects/triggers/trigger_editor.html';
	var html = "<div class=\"form-box form-horizontal\"> <form ng-submit=save() name=triggerForm track-unsaved-changes> <div class=form-body> <h3>Automatic Deployment Trigger</h3> <p>This type of trigger helps to automate your project's deployments in response to changes in your deployment targets, ensuring they always have the currently successful releases. Learn more about <a href=http://g.octopushq.com/AutomaticDeploymentTriggers target=_blank>Automatic Deployment Triggers</a> or read our <a href=http://g.octopushq.com/ElasticTransientEnvironments target=_blank>comprehensive guide</a> about deploying to elastic and transient environments.</p> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <control-group label=\"Trigger name\"> <input class=form-control type=text ng-model=projectTrigger.Name focus-on=page-loaded /> <p class=help-block>A short, memorable, unique name for this trigger. Example: <i>Staging Environment Auto-Deploy</i></p> </control-group> <h4 class=separator>Event Filter</h4> <event-filter environments=environments roles=roles event-groups=eventGroups event-categories=eventCategories selected-filters=selectedFilters></event-filter> <h4 class=separator>Auto Deploy</h4> <control-group label=Redeploy> <input type=checkbox bs-switch ng-model=projectTrigger.Action.ShouldRedeployWhenMachineHasBeenDeployedTo switch-on-color=danger switch-on-label=On switch-off-label=Off switch-size=small /> <p class=help-block>Re-deploy to machines even if they are already up-to-date with the current deployment.</p> </control-group> <div class=\"alert alert-info\"> <strong>Troubleshooting</strong>: Auto-deploy uses your project's dashboard to determine which release to deploy and will only re-queue deployments that are both <i>current</i> and <i>successful</i>. Please see <strong><a href=http://g.octopushq.com/AutoDeployTroubleshooting target=_blank>our documentation</a></strong> for more information. </div> <control-group label=Release> <p class=form-control-static>The currently successful release of this project for each environment<span ng-if=\"project.TenantedDeploymentMode !== 'Untenanted'\" octo-feature=IsMultiTenancyEnabled>/tenant combination</span> as shown on the <a href=#/projects/{{project.Slug}}>project overview</a>.</p> </control-group> <control-group label=Tenants ng-if=\"project.TenantedDeploymentMode !== 'Untenanted'\" octo-feature=IsMultiTenancyEnabled> <p class=form-control-static>If required, a deployment will be triggered for each tenant mapped to the deployment target. Learn more about multi-tenant hosting models in our <a href=http://g.octopushq.com/MultiTenantHostingModel target=_blank>documentation</a>.</p> </control-group> <control-group label=Steps> <p class=form-control-static>The goal of an automatic deployment to a deployment target is to make it the same as its counterparts in the same environment. Octopus does this by running the same steps that would be run for the deployment target as part of a manual deployment. Learn about <a href=http://g.octopushq.com/AutomaticDeploymentTriggers target=_blank>how the deployment process is calculated for automatic deployments</a>. </p></control-group> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin class=spin-static active=isSaving.busy></spin> </div> </div> </form> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 912 */
/***/ function(module, exports) {

	var path = 'areas/projects/triggers/triggers.html';
	var html = "<div class=row> <div class=\"col-sm-8 col-md-8 col-lg-8\"> <div class=\"form-box form-horizontal\"> <h3>Triggers</h3> <p>Triggers allow you to automate your project deployments by responding to changes in your deployment targets. Read our <a href=http://g.octopushq.com/ElasticTransientEnvironments target=_blank>documentation</a> to learn more about working with elastic environments using project triggers.</p> <loading-wrapper busy=isLoading> <div class=\"triggers stack\" ng-show=\"triggers.Items.length > 0\"> <div class=\"stack-item trigger\" ng-repeat=\"trigger in triggers.Items track by trigger.Id\"> <div class=stack-content> <a href=#/projects/{{project.Slug}}/triggers/edit/{{trigger.Id}}><h4>{{ trigger.Name }}</h4></a> <div> <p> Automatically deploy when <tag-list tags=trigger.events></tag-list> <span ng-if=trigger.environment> in the environments <tag-list tags=trigger.environment></tag-list> </span> <span ng-if=!trigger.environment> in any environment </span> for <span ng-if=\"trigger.Filter.Roles && trigger.Filter.Roles.length > 0\"> the roles <tag-list tags=trigger.roles></tag-list> </span> <span ng-if=\"!trigger.Filter.Roles || trigger.Filter.Roles.length === 0\"> any role </span> </p> </div> </div> </div> </div> <div class=margin-top-bottom-10> <a octo-permission=ProcessEdit octo-project=project.Id class=\"btn btn-success\" href=#/projects/{{project.Slug}}/triggers/create>Create trigger</a> </div> </loading-wrapper> </div> </div> <div class=\"col-sm-4 col-md-4 col-lg-4\"> <h3>Automatic Release Creation</h3> <p class=help-block>Learn about <a class=alert-link href=http://g.octopushq.com/AutoReleaseCreation target=_blank>Automatic Release Creation</a>.</p> <div ng-if=\"builtInFeedPackageActions.length <= 0\" class=help-block> There are no steps using the built-in package repository. At least one step must use a package from the <a href=#/library/packages>built-in package repository</a> for Automatic Release Creation to work. </div> <div ng-if=showAutomaticReleaseCreation> <form name=releaseCreation ng-submit=changeReleaseCreation() track-unsaved-changes> <error-box error=isSaving.error></error-box> <div class=margin-top-bottom-10> <div class=checkbox> <label> <input type=checkbox class=\"\" ng-model=project.AutoCreateRelease> Create a release when a package is pushed to the built-in package repository </label> </div> </div> <div ng-show=\"project.AutoCreateRelease && builtInFeedPackageActions\"> <div class=form-group> <label for=stepSelect>Release Creation package step</label> <select id=stepSelect class=form-control ng-model=project.ReleaseCreationStrategy.ReleaseCreationPackageStepId ng-options=\"action.Id as action.Name for action in builtInFeedPackageActions\"> </select> <p class=help-block>When the package for the selected step is pushed to the built-in package repository, a new release will be created automatically.</p> </div> <div class=form-group ng-show=\"channels.Items.length > 1\"> <label for=channelSelect>Channel</label> <select id=channelSelect class=form-control ng-model=project.ReleaseCreationStrategy.ChannelId ng-options=\"channel.Id as channel.Name for channel in channels.Items\"> </select> <p class=help-block>For the release to be created, the pushed package must satisfy the selected channel's versioning rules (if any). The release created will use the selected channel.</p> </div> </div> <div ng-show=unsavedChanges.hasUnsavedChanges()> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 913 */
/***/ function(module, exports) {

	var path = 'areas/projects/variables/layout.html';
	var html = "<div> <script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/variables'>Variables</a></li> </script> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: $root.layout.variableTab == 'variables'}\"> <a href=\"#/projects/{{ project.Slug }}/variables\">Variables</a> </li> <li ng-if=\"project.TenantedDeploymentMode !== 'Untenanted'\" octo-feature=IsMultiTenancyEnabled ng-class=\"{active: $root.layout.variableTab == 'projectvariabletemplates'}\"> <a href=\"#/projects/{{ project.Slug }}/variables/projectvariabletemplates\"> Project Variable Templates </a> </li> <li ng-if=\"project.TenantedDeploymentMode !== 'Untenanted'\" octo-feature=IsMultiTenancyEnabled ng-class=\"{active: $root.layout.variableTab == 'commonvariabletemplates'}\"> <a href=\"#/projects/{{ project.Slug }}/variables/commonvariabletemplates\"> Common Variable Templates </a> </li> <li ng-class=\"{active: $root.layout.variableTab == 'library'}\"> <a href=\"#/projects/{{ project.Slug }}/variables/library\"> {{libraryVariableSetCount}} Library Variable Set{{libraryVariableSetCount == 1 ? \"\" : \"s\"}} </a></li> <li ng-class=\"{active: $root.layout.variableTab == 'all'}\"> <a href=\"#/projects/{{ project.Slug }}/variables/all\"> All Variables </a></li> </ul> <error-box error=isSaving.error></error-box> <div class=\"tabbable tabs-top\"> <div class=\"tab-content pills-content\"> <loading-wrapper busy=isSaving> <loading-wrapper busy=isLoading> <ui-view></ui-view> </loading-wrapper> </loading-wrapper> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 914 */
/***/ function(module, exports) {

	var path = 'areas/projects/variables/project_variables.html';
	var html = " <script octo-section=project_tools_left type=text/ng-template> <spin active='isSaving.busy'></spin> </script> <script octo-section=project_tools type=text/ng-template> <button class=\"btn btn-success\" ng-show=\"canSave || canSaveProject\" ng-disabled=\"isSaving.busy || isLoading.busy\" ng-click=\"save()\">Save</button> </script> <div> <error-box error=isSaving.error></error-box> <h3>Project Variables</h3> <div class=margin-top-bottom-10> <variable-editor class=slick-grid-container-box ng-if=showVariableEditor data=variableEditorOptions></variable-editor> </div> <last-modified model=variableEditorOptions.variableSet></last-modified> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 915 */
/***/ function(module, exports) {

	var path = 'areas/projects/variables/project_variables_all.html';
	var html = "<div> <script octo-section=project_tools_left type=text/ng-template> <spin active='isSaving.busy'></spin> </script> <script octo-section=project_tools type=text/ng-template> <button class=\"btn btn-success\" ng-show=\"canSave || canSaveProject\" ng-disabled=\"isSaving.busy || isLoading.busy\" ng-click=\"save()\">Save</button> </script> <h3>All Variables</h3> <variable-editor class=slick-grid-container-box data=variableEditorOptions ng-show=showVariableEditor></variable-editor> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 916 */
/***/ function(module, exports) {

	var path = 'areas/projects/variables/project_variables_common_templates.html';
	var html = "<div> <error-box error=isSaving.error></error-box> <h3>Common Variable Templates</h3> <p>Variable templates define which variable values are required for each tenant connected to this project. They are defined in library variable sets and allow tenants to provide a common variable value that is shared across projects and environments. Learn more about <a href=http://g.octopushq.com/MultiTenantVariables target=_blank>tenant-specific variables</a>.</p> <p ng-if=\"libraryVariableSets.length > 0\">To change the common variable templates required by this project <a href=#/projects/{{project.Slug}}/variables/library>choose different library variable sets</a>.</p> <div class=margin-top-bottom-10> <div class=\"tutorial tutorial-left\" ng-if=\"libraryVariableSets.length <= 0\"> <p>This project doesn't include any common variable templates. <a href=#/projects/{{project.Slug}}/variables/library>Include a variable set</a> with some variable templates, or create a <a href=#/library/variables>library variable set with some variable templates</a> to get started.</p> </div> <div class=row ng-repeat=\"lvs in libraryVariableSets track by lvs.Id\"> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <h4><a href=#/library/variables/{{lvs.Id}}>{{lvs.Name}}</a></h4> <ul class=octo-list-group> <li class=octo-list-group-item ng-repeat=\"template in lvs.Templates track by template.Name\"> <h4 class=octo-list-group-item-heading>{{ template.Label || template.Name }}</h4> <p><code><span>#{</span>{{template.Name}}<span>}</span><span ng-show=template.DefaultValue> = {{template.DefaultValue}}</span></code></p> <markdown text=template.HelpText></markdown> </li> </ul> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 917 */
/***/ function(module, exports) {

	var path = 'areas/projects/variables/project_variables_library.html';
	var html = "<div> <script octo-section=project_tools_left type=text/ng-template> <spin active='isSaving.busy'></spin> </script> <script octo-section=project_tools type=text/ng-template> <button class=\"btn btn-success\"\r\n            ng-disabled=\"isSaving.busy || isLoading.busy\"\r\n            ng-show=\"unsavedChanges.hasUnsavedChanges()\"\r\n            ng-click=\"save()\">Save</button> </script> <error-box error=isSaving.error></error-box> <h3>Library Variable Sets</h3> <p>Library variable sets allow you to include common variable values and templates into your project. Learn more about <a href=http://g.octopushq.com/LibraryVariableSets target=_blank>library variable sets</a>.</p> <div class=\"alert alert-warning margin-top-5\" ng-if=showRemovedVariableSetWarning> <p>You appear to be removing a variable set.<br/>The values for any variable templates that are removed by this action will be permanently deleted from associated Tenants, there is no going back.</p> </div> <div ng-show=\"includedSets.length > 0\" class=\"well margin-bottom-10\"> <p><strong>Library variable sets:</strong></p> <ul> <li ng-repeat=\"lvs in includedSets\"><a href=#/library/variables/{{lvs.Id}}>{{lvs.Name}}</a></li> </ul> </div> <button class=\"btn btn-info\" ng-if=\"includedSets.length > 0\" ng-click=configureLibraryVariableSets()>Choose different library variable sets</button> <button class=\"btn btn-info\" ng-if=\"includedSets.length == 0\" ng-click=configureLibraryVariableSets()>Include variable sets from the Library</button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 918 */
/***/ function(module, exports) {

	var path = 'areas/projects/variables/project_variables_templates.html';
	var html = "<div> <script octo-section=project_tools_left type=text/ng-template> <spin active='isSaving.busy'></spin> </script> <script octo-section=project_tools type=text/ng-template> <button class=\"btn btn-success\"\r\n            ng-disabled=\"isSaving.busy || isLoading.busy\"\r\n            ng-show=\"unsavedChanges.hasUnsavedChanges()\"\r\n            ng-click=\"save()\">Save</button> </script> <error-box error=isSaving.error></error-box> <h3>Project Variable Templates</h3> <p>Project variable templates define which variable values are required for each tenant connected to this project. They allow tenants to provide different variable values for each project/environment combination. Learn more about <a href=http://g.octopushq.com/MultiTenantVariables target=_blank>tenant-specific variables</a>.</p> <div class=margin-top-bottom-10> <div class=\"tutorial tutorial-left\" ng-show=\"project.Templates.length == 0\"> <p>This project doesn't have any variable templates defined yet. Use the <strong>Add variable template</strong> button below to get started.</p> </div> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div class=\"form-box form-horizontal\"> <div class=\"\"> <ul class=\"octo-list-group can-add\"> <li class=octo-list-group-item ng-repeat=\"template in project.Templates track by template.Name\"> <button class=\"close remove-button\" type=button ng-click=templateEditor.removeTemplate(template)>×</button> <h4 class=octo-list-group-item-heading><a href ng-click=templateEditor.editTemplate(template)>{{ template.Label || template.Name }}</a></h4> <p><code><span>#{</span>{{template.Name}}<span>}</span><span ng-show=template.DefaultValue> = {{template.DefaultValue}}</span></code></p> <markdown text=template.HelpText></markdown> </li> </ul> </div> </div> </div> </div> </div> <a class=\"btn btn-info\" href ng-click=templateEditor.addTemplate()>Add variable template</a> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 919 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/action_editor.html';
	var html = "<div> <div class=action-details></div> <div class=action-features></div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 920 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/action_summary.html';
	var html = "<div class=action-summary-container> <step-template-logo ng-if=logoUrl class=\"'action-summary-image'\" size=\"'small'\" url=logoUrl></step-template-logo> <div class=action-summary-content> <h4>{{ number }}. <span ng-show=\"editLink != null\"><a ng-href=\"{{ editLink }}\">{{ action.Name }}</a></span> <span ng-show=\"editLink == null\">{{ action.Name }}</span></h4> <div> <div class=action-details></div> <div class=action-features> </div> <div class=smaller-fonts ng-show=action.environments>Only in: <environment-list tags=action.environments></environment-list></div> <div class=smaller-fonts ng-show=action.excludedEnvironments>Not in: <environment-list tags=action.excludedEnvironments></environment-list></div> <div class=smaller-fonts ng-show=action.channels>For channels: <environment-list tags=action.channels></environment-list></div> <div class=smaller-fonts ng-show=\"project.TenantedDeploymentMode !== 'Untenanted' && action.TenantTags.length > 0\" octo-feature=IsMultiTenancyEnabled>For tenants tagged: <tenant-tag ng-model=tag ng-repeat=\"tag in action.TenantTags\"></tenant-tag></div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 921 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/action_template_editor.html';
	var html = "<div> <h4 class=separator>{{actionTemplate.Name}}</h4> <p class=gray ng-if=action>This step is based on a <a href=#/library/steptemplates/{{actionTemplate.Id}}>custom step template</a>.</p> <div class=\"alert alert-warning\" ng-if=\"action && action.Properties['Octopus.Action.Template.Version'] != actionTemplate.Version\"> <p><strong>This step needs to be updated.</strong> The step template has changed since this step was configured. Press the button below to merge in the latest changes.</p> <p><button class=\"btn btn-warning\" type=button ng-click=mergeLatest()>Update</button></p> </div> <div> <div class=\"alert alert-success\" ng-if=\"action && action.Properties['Octopus.Action.Template.Version'] == actionTemplate.Version && actionUpdated\"> <p> The step has been updated successfully. Please review the changes below and provide missing values. </p> </div> <div> </div> <div ng-if=\"!action || action.Properties['Octopus.Action.Template.Version'] == actionTemplate.Version\"> <div ng-repeat=\"parameter in actionTemplate.Parameters\"> <control-group label=\"{{ parameter.Label || parameter.Name }}\"> <bound-field local-names=localNames model=action.Properties[parameter.Name] reset-value=resetValues[parameter.Name] project-id=project.Id parameter=parameter> <action-template-field ng-model=action.Properties[parameter.Name] parameter=parameter select-options=\"{StepName: allSteps}\"></action-template-field> </bound-field> <div class=help-block ng-show=parameter.HelpText> <markdown text=parameter.HelpText></markdown> </div> </control-group> </div> </div> </div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 922 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/add_step_list_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Choose step type</h3> </div> <div class=modal-body> <div ng-repeat=\"action in availableActions\"> <div class=\"action {{ action.cssClass }} margin-top-bottom-20\"> <a ng-click=accept(action.actionType) href>{{ action.title }}</a> <p>{{ action.description }}</p> </div> </div> <div ng-repeat=\"template in actionTemplates\"> <div class=\"action {{ actionsByType[template.ActionType].cssClass }} template margin-top-bottom-20\"> <a ng-click=accept(template) href>{{ template.Name }}</a> <markdown text=\"template.Description || 'This step type is based on a template from the _Library_.'\"></markdown> </div> </div> <p class=subtle>You can import or create additional step templates from the <a ng-click=close() href=#/library/steptemplates>Library</a>.</p> </div> <div class=modal-footer> <a href class=btn ng-click=close()>Cancel</a> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 923 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/application_pool_editor.html';
	var html = "<div> <control-group label=\"Application Pool name\"> <bound-field local-names=localNames model='action.Properties[fullPath(\"ApplicationPoolName\")]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=appPoolName ng-model='action.Properties[fullPath(\"ApplicationPoolName\")]'> </bound-field> <p class=help-block>Name of the application pool in IIS to create or reconfigure.</p> </control-group> <control-group label=\".NET CLR version\"> <bound-field local-names=localNames model='action.Properties[fullPath(\"ApplicationPoolFrameworkVersion\")]' reset-value=\"'v4.0'\" project-id=project.Id> <select class=\"input-large form-control\" id=clrMode ng-model='action.Properties[fullPath(\"ApplicationPoolFrameworkVersion\")]'> <option value=v4.0>v4.0</option> <option value=v2.0>v2.0</option> <option value=\"No Managed Code\">No Managed Code</option> </select> </bound-field> <p class=help-block>The version of the .NET common language runtime that this application pool will use. Choose <strong>v2.0</strong> for applications built against .NET 2.0, 3.0 or 3.5. Choose <strong>v4.0</strong> for .NET 4.0 or 4.5</p> </control-group> <control-group label=Identity> <bound-field local-names=localNames model='action.Properties[fullPath(\"ApplicationPoolIdentityType\")]' reset-value=\"'ApplicationPoolIdentity'\" project-id=project.Id bound=identity.identityTypeBound> <select class=form-control id=serviceAccount ng-model='action.Properties[fullPath(\"ApplicationPoolIdentityType\")]'> <option value=ApplicationPoolIdentity>Application Pool Identity</option> <option value=LocalService>Local Service</option> <option value=LocalSystem>Local System</option> <option value=NetworkService>Network Service</option> <option value=SpecificUser>Custom user...</option> </select> </bound-field> <p class=help-block>Which built-in account will the application pool run under.</p> </control-group> <div ng-show='action.Properties[fullPath(\"ApplicationPoolIdentityType\")] == \"SpecificUser\" || identity.identityTypeBound.isBound'> <control-group label=Username> <bound-field local-names=localNames model='action.Properties[fullPath(\"ApplicationPoolUsername\")]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=customAppPoolUser ng-model='action.Properties[fullPath(\"ApplicationPoolUsername\")]'> </bound-field> <p class=help-block>The Windows/domain account of the custom user that the application pool will run under. Example: <code>YOURDOMAIN\\YourAccount</code>. You will need to ensure that this user has permissions to run as an application pool.</p> </control-group> <control-group label=Password> <bound-field local-names=localNames model='action.Properties[fullPath(\"ApplicationPoolPassword\")]' reset-value=identity.applicationPoolPasswordResetValue project-id=project.Id> <sensitive-input model='action.Properties[fullPath(\"ApplicationPoolPassword\")]'></sensitive-input> </bound-field> <p class=help-block>The password for the custom account given above.</p> </control-group> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 924 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/azure_powershell_script_info.html';
	var html = "<div class=\"alert alert-info form-group-narrow\"> <p> <span ng-show=\"action.ActionType !== 'Octopus.AzurePowerShell'\">If you are running a PowerShell script as part of this step</span> <span ng-show=\"action.ActionType === 'Octopus.AzurePowerShell'\">As this step is running a PowerShell script</span> the <a class=alert-link target=_blank href=https://g.octopushq.com/WindowsManagementFramework3Download>Windows Management Framework 3</a> (or newer) must be installed on the <strong>Octopus Server</strong>. </p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 925 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/change_logo.html';
	var html = "<div> <script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/settings'>Settings</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>Project logo</h3> <div class=\"narrow650 narrow-left\"> <form class=\"form form-horizontal\" name=logoUpload> <error-box error=isUploading.error></error-box> <control-group label=\"Image file\"> <div class=\"input-group js-fileapi-wrapper\"> <input class=form-control type=text disabled=disabled value={{octoUpload.selectedFile}}> <input class=\"form-control uploader\" type=file nv-file-select uploader=octoUpload.uploader ng-disabled=isUploading.busy> <div class=input-group-btn> <div type=button class=\"btn btn-primary\" ng-disabled=isUploading.busy> <input class=\"form-control uploader\" type=file nv-file-select uploader=octoUpload.uploader ng-disabled=isUploading.busy> <div>Choose File</div> </div> <div type=button class=\"btn btn-primary\" ng-click=cancel(); ng-disabled=isUploading.busy> <div>Cancel</div> </div> </div> </div> <p class=help-block>Select a logo or image to use for the project. The recommended image size is 50x50 pixels or 80x50 pixels. The recommended format is PNG with transparency, though any browser-viewable image format will work.</p> </control-group> <div class=form-actions> <spin active=isUploading.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=\"isUploading.busy ||  !octoUpload.uploader.queue.length\" ng-click=beginUpload()>Upload </button> <button class=\"btn btn-warning delete-button\" type=submit ng-disabled=isUploading.busy ng-click=beginReset()>Use default </button> </div> </form> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 926 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/new'>Create New</a></li> </script> <script octo-section=tools type=text/ng-template> </script> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <help-button></help-button> <h3>Create a project</h3> <loading-wrapper busy=isLoading> <div class=\"form-box form-horizontal\"> <alerts list=alerts></alerts> <project-editor></project-editor> </div> </loading-wrapper> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 927 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/deploy_buttons.html';
	var html = "<div> <div class=margin-bottom-10 octo-permission=DeploymentCreate octo-environment=\"'*'\" octo-project=project.Id> <div class=btn-group ng-show=\"nextDeployments.length > 1\"> <a class=\"btn dropdown-toggle btn-success\" ng-class=customClasses data-toggle=dropdown href=#> {{ deployOrPromote }} <span class=caret></span> </a> <ul class=dropdown-menu> <li><a href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}/deployments/create/to/{{nextDeploymentsCombined}}\" ng-show=\"nextDeployments.length == 2\">{{ deployOrPromote }} to both environments</a></li> <li><a href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}/deployments/create/to/{{nextDeploymentsCombined}}\" ng-show=\"nextDeployments.length > 2\">{{ deployOrPromote }} to all {{nextDeployments.length}} environments</a></li> <li class=divider></li> <li ng-repeat=\"env in nextDeployments\"><a href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}/deployments/create/to/{{env}}\">{{ environmentsById[env].Name }}</a></li> </ul> </div> <a class=\"btn btn-success\" octo-permission=DeploymentCreate octo-environment=nextDeployments[0] octo-project=project.Id ng-class=customClasses ng-show=\"nextDeployments.length == 1\" href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}/deployments/create/to/{{nextDeployments[0]}}\">{{ deployOrPromote }} to {{ environmentsById[nextDeployments[0]].Name }}</a> <a class=\"btn btn-link btn-default\" href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}/deployments/create\" ng-show=\"project && release\">Deploy to...</a> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 928 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/deployment_create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-show=\"release\"><a href='#/projects/{{ project.Slug }}/releases/{{ release.Version }}'>{{ release.Version\r\n        }}</a>\r\n        <channel-label project=\"project\" channel-id=\"release.ChannelId\" channels=\"channel\"\r\n                       ng-if=\"channel\"></channel-label>\r\n    </li>\r\n    <li ng-show=\"release\"><a href='#/projects/{{ project.Slug }}/releases/{{ release.Version }}/deployments/create'>Deploy</a>\r\n    </li> </script> <div class=form-horizontal> <h3>Deploy release {{ release.Version }}</h3> <form ng-submit=deploy()> <div class=form-body> <div class=row> <h4 class=separator ng-if=canPerformTenantedDeployments()> Deploy to one or more <span ng-if=\"!requireTenantedDeployment && isMultitenancyEnabled\"> <label class=\"padding-sm-hr no-margin-vr\"> <input class=\"radio radio-inline\" type=radio ng-model=view.deploymentType value=normal>&nbsp;Environments </label> <label class=\"padding-sm-hr no-margin-vr\"> <input class=\"radio radio-inline\" type=radio ng-model=view.deploymentType ng-click=setTenantEnvironment() value=tenant>&nbsp;Tenants </label> </span> <span ng-if=\"requireTenantedDeployment && isMultitenancyEnabled\"> tenants </span> </h4> <div ng-if=\"view.deploymentType === 'normal'\"> <deployment-create-environment-selector ng-if=\"!!project && !!promoteTo\" edit=view.modifyDestination available-environments=promoteTo selected-environments=view.selectedEnvironments project=project new-deployments=newDeployments> </deployment-create-environment-selector> </div> <div ng-if=\"view.deploymentType === 'tenant'\"> <deployment-create-tenant-selector ng-if=\"!!project && !!template && !!channel && !!allTenants\" edit=view.modifyDestination selected-environments=view.selectedEnvironments all-tenants=allTenants selected-tenants=view.selectedTenants selected-tags=view.selectedTenantTags resultant-tenants=view.resultantTenants resultant-tenant-count=view.resultantTenantCount project=project template=template channel=channel new-deployments=newDeployments load-matches=view.loadMatchingTenants></deployment-create-tenant-selector> </div> </div> <div class=row> <div ng-if=\"view.selectedEnvironments.length > 0 && view.showAdvanced\"> <h4 class=separator>When</h4> <deployment-create-schedule scheduled-at=view.queueTime expires-at=view.queueTimeExpiry></deployment-create-schedule> </div> <h4 class=separator ng-show=\"preview.Form.Elements.length > 0\">Parameters</h4> <octo-form form=preview.Form></octo-form> <div ng-show=\"view.selectedEnvironments.length > 0 && view.showAdvanced\"> <h4 class=separator>Preview</h4> <div ng-include=\"'areas/projects/deployment-create/preview.html'\"></div> <h4 class=separator>Options</h4> <div ng-include=\"'areas/projects/deployment-create/options.html'\"></div> </div> </div> <div class=row ng-hide=\"isPreviewing.busy || view.selectedEnvironments.length === 0\"> <div class=\"alert alert-info\" ng-show=hasMachineWithOldCalamariVersion> <strong>Please note: </strong> there are machines in this environment that do not have the latest version of Calamari. These machines will upgrade Calamari automatically as part of the deployment. If you want to manually update the Calamari version on these machines, you can do this via the <a href=#/environments style=text-decoration:underline>environments page</a> </div> <div class=\"alert alert-warning\" ng-show=\"template.IsDeploymentProcessModified || template.IsVariableSetModified || template.IsLibraryVariableSetModified\"> <strong>Something has changed since this snapshot was taken.</strong> <br/> For consistency, this deployment will use a snapshot of the variables and deployment process that was taken when the release was created, which does not include the latest changes that have been made to the project. A changed process can only be incorporated by creating a new release (this one may be renamed if desired). Variables can be updated via the <a class=alert-link href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}\">release page</a>, clicking <strong>Show</strong> to show the variables from the snapshot, and clicking the <strong>Update variables</strong> button. </div> <div class=form-actions ng-show=canDeploy()> <span> <button class=\"btn btn-success\" type=submit ng-disabled=\"isSaving.busy || (view.deploymentType === 'tenant' && view.resultantTenantCount === 0)\" ng-show=!view.showAdvanced>Deploy now</button> <a class=\"btn btn-link btn-default\" href ng-click=\"view.showAdvanced = true\" ng-show=!view.showAdvanced>Advanced »</a> </span> <spin active=isSaving.busy class=spin-static></spin> </div> <div class=form-actions ng-show=view.showAdvanced> <button class=\"btn btn-success\" type=submit ng-disabled=\"isSaving.busy || (view.deploymentType === 'tenant' && view.resultantTenantCount === 0)\"> Deploy release </button> <spin active=isSaving.busy class=spin-static></spin> </div> </div> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 929 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/settings'>Settings</a></li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <div class=\"form-box form-horizontal\"> <h3>Project settings</h3> <loading-wrapper busy=isLoading> <project-editor></project-editor> </loading-wrapper> </div> </div> <div class=\"col-sm-3 col-md-3 col-lg-3\"> <div class=other-actions> <h3>Logo</h3> <project-logo project=project class=margin-top-10></project-logo> <div class=margin-top-10> <a class=\"btn btn-info\" href=#/projects/{{project.Slug}}/logo>Change</a> </div> </div> <div class=other-actions octo-permission=ProjectCreate octo-project-group=project.ProjectGroupId> <h3>Clone</h3> <p>Clone this project to reuse its deployment process and variables.</p> <a class=\"btn btn-info\" href=\"#/projects/new?clone={{project.Id}}&grpid={{project.ProjectGroupId}}\">Clone</a> </div> <div class=other-actions> <div octo-permission=ProjectDelete octo-project=project.Id> <h3>Delete</h3> <p>Once you delete this project, there is no going back. All releases and deployments for this project will be permanently deleted.</p> <delete-button model=project what=project redirect=/projects></delete-button> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 930 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/editor.html';
	var html = "<form ng-submit=save() name=projectForm track-unsaved-changes track-after=1000> <div class=form-body> <error-box error=isSaving.error on-dismiss=\"isSaving.error = null\"></error-box> <control-group label=Name> <input id=name-input class=form-control type=text ng-model=project.Name /> </control-group> <control-group label=Description> <textarea id=description-input class=form-control ng-model=project.Description markitup rows=7></textarea> </control-group> <control-group label=\"Project group\"> <select id=group-input class=\"input-xlarge form-control\" fix-ie-select ng-model=project.ProjectGroupId ng-options=\"g.Id as g.Name for g in projectGroups\"></select> </control-group> <div ng-hide=project.Id> <control-group label=Lifecycle> <select id=lifecycle-input class=\"input-xlarge form-control\" fix-ie-select ng-model=project.LifecycleId ng-options=\"l.Id as l.Name for l in lifecycles\"></select> <p class=help-block>Lifecycles determine which environments the project can be deployed to, and the promotion rules between those environments. <a href=#/library/lifecycles>Create or modify lifecycles.</a></p> <div class=margin-top-5> <markdown text=lifecyclesById[project.LifecycleId].Description></markdown> <p> <span ng-repeat=\"p in lifecyclesById[project.LifecycleId].Phases\"><strong>{{ p.Name }}</strong> <span ng-hide=$last> » </span></span> </p> </div> </control-group> </div> <div ng-hide=\"project.Id || !createOptions.clone\"> <control-group label=\"Clone from\"> <select id=clone-from-input class=form-control ng-model=createOptions.clone ng-options=\"p.Id as p.Name for p in otherProjects\"> <option value=\"\"></option> </select> <p class=help-block>Select an existing project to clone; the deployment process and variables set in the other project will be copied into the new project when it is created.</p> </control-group> </div> <div ng-show=project.Id> <control-group label=\"Release versioning\"> <div class=radio><label><input type=radio ng-model=view.versionFromPackage ng-value=false /> Generate version numbers using a template</label></div> <div class=radio><label><input type=radio ng-model=view.versionFromPackage ng-value=true /> Use the version number from an included package</label></div> </control-group> <div ng-hide=view.versionFromPackage> <control-group label=\"Version template\"> <textarea id=project-version-template-input class=\"form-control binder smaller-fonts\" rows=4 ng-model=project.VersioningStrategy.Template></textarea> <div ng-hide=project.VersioningStrategy.Template><a href ng-click=resetVersionTemplate()>Reset to default template</a></div> <p class=help-block>An expression used to generate the next release version number when creating a release. Certain variables are also available. <a href=\"\" detailed-help-toggle>Show examples.</a></p> <div class=\"detailed-help help-block\"> <p>You can use variables from the project (un-scoped or scoped only to a channel). In addition, some special variables are provided - example:</p><p> <pre><code>1.2.#{Octopus.Version.NextPatch}-pre</code></pre> </p><p>These special variables take the form:</p> <pre><code>Octopus.Version.(Last|Next)(Major|Minor|Patch|Build|Revision|Suffix)</code></pre> <p>If you are using channels, channel-specific special variables are also available: </p> <pre><code>Octopus.Version.Channel.(Last|Next)(Major|Minor|Patch|Build|Revision|Suffix)</code></pre> <p>The channel name can also be used (generally as part of the suffix):</p> <pre><code>Octopus.Release.Channel.Name</code></pre> <p>The version can also include Octopus <em>semantic version mask</em> characters <code>i</code> and <code>c</code> referring to the <strong>i</strong>ncremented and <strong>c</strong>urrent values of the version, respectively. For example:</p> <pre>2.1.c.i</pre> <p>Finally, date fields can be also be used, for example: </p> <pre>#{Octopus.Date.Year}.#{Octopus.Date.Month}.#{Octopus.Date.Day}</pre> <p>These take the form:</p> <pre><code>Octopus.Date.(Day|Month|Year|DayOfYear)</code><br/><code>Octopus.Time.(Hour|Minute|Second)</code></pre> </div> </control-group> </div> <div ng-show=view.versionFromPackage> <control-group label=\"Versioning package step\"> <select class=\"input-xlarge form-control\" ng-model=project.VersioningStrategy.DonorPackageStepId ng-options=\"action.Id as action.Name for action in packageActions\"> </select> </control-group> </div> <control-group label=\"Package re-deployment\"> <div class=radio><label><input type=radio ng-model=project.DefaultToSkipIfAlreadyInstalled ng-value=false> Always deploy all packages</label></div> <div class=radio><label><input type=radio ng-model=project.DefaultToSkipIfAlreadyInstalled ng-value=true> Skip any package step that is already installed</label></div> <p class=help-block>If the skip option is selected and Octopus detects the same package version is already installed on the deployment target, all features of a package step will be skipped. By default, Octopus will always re-deploy every included package.</p> </control-group> <control-group label=\"Multi-tenant deployments\" octo-feature=IsMultiTenancyEnabled> <div class=radio><label><input type=radio ng-model=project.TenantedDeploymentMode ng-value=\"'Untenanted'\"/> Disable tenanted deployments <strong>(default)</strong></label></div> <div class=radio><label><input type=radio ng-model=project.TenantedDeploymentMode ng-value=\"'TenantedOrUntenanted'\"/> Allow deployments <em>with</em> or <em>without</em> a tenant</label></div> <div class=radio><label><input type=radio ng-model=project.TenantedDeploymentMode ng-value=\"'Tenanted'\"/> Require a tenant for all deployments</label></div> <p class=help-block>By default all multi-tenant deployment features will be disabled for this project. Choose one of the other options to enable tenanted deployments of this project. Learn more about <a href=http://g.octopushq.com/ProjectTenantedDeploymentMode target=_blank>tenanted deployment modes</a>.</p> </control-group> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=project.IsDisabled /> Disable this project</label></div> <p class=help-block>Disable a project to prevent releases or deployments from being created.</p> </control-group> </div> <last-modified model=project></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 931 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/feature_editor.html';
	var html = "<div> <uib-accordion class=\"feature-list accordion arrows\"></uib-accordion> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 932 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/group_editor.html';
	var html = "<form ng-submit=save()> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Name> <input id=input-name class=form-control type=text ng-model=projectGroup.Name> </control-group> <control-group label=Description> <textarea id=input-desc ng-model=projectGroup.Description class=form-control markitup rows=7></textarea> </control-group> <last-modified model=projectGroup></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 933 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/include_variables_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Included {{ contentTypeDesc }}</h3> </div> <form ng-submit=save()> <div class=modal-body> <error-box error=isLoading.error></error-box> <loading-wrapper busy=isLoading> <div class=\"alert alert-info\" ng-show=\"libraryVariableSets.length == 0\"> <h4>The Library is empty</h4> <p>There are no {{ contentTypeDesc.toLowerCase() }}s in the Library to include.</p> </div> <table class=\"table table-bordered\" ng-show=\"libraryVariableSets.length > 0\"> <thead> <tr> <th>{{ contentTypeDesc }}</th> <th>Description</th> </tr> </thead> <tbody> <tr ng-repeat=\"lvs in libraryVariableSets\"> <td><div class=checkbox><label><input type=checkbox ng-model=lvs.isIncluded> {{ lvs.title }} </label></div></td> <td><markdown text=lvs.description></markdown></td> </tr> </tbody> </table> </loading-wrapper> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" ng-show=\"libraryVariableSets.length > 0\" ng-click=save()>Apply</button> <button class=\"btn btn-default\" ng-show=\"libraryVariableSets.length > 0\" ng-click=close()>Cancel</button> <button class=\"btn btn-primary\" ng-show=\"libraryVariableSets.length == 0\" ng-click=close()>Close</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 934 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/index.html';
	var html = "<script octo-section=tools type=text/ng-template> <a octo-permission=\"ProjectGroupCreate\" class='btn btn-link' ng-show=\"!isLoading.busy && (anyShowing() || projectGroups.length == 0)\" href=\"#/projectgroups/new\">Add project group</a>\r\n  <a octo-permission=\"ProjectCreate\" class='btn btn-success' ng-show=\"!anyLoading() && !anyShowing()\" href=\"#/projects/new\">Add project</a> </script> <loading-wrapper busy=isLoading> <div ng-show=projectGroups> <div class=\"tutorial tutorial-center\" ng-hide=\"projectGroups.length > 0\"> <p>You don't have any project groups to add a project to. <span octo-permission=ProjectGroupCreate>You can create a project group using the <strong>Add project group</strong> button above.</span></p> </div> <div class=\"tutorial tutorial-center\" ng-show=\"projectCount == 0 && projectGroupsWaitingForProjectsToLoad == 0\"> <p>You don't have any projects. <span octo-permission=ProjectCreate>You can create a project using the <strong>Add project</strong> button.</span></p> </div> </div> <div ng-repeat=\"projectGroup in projectGroups | filter:isGroupVisible\" class=\"panel panel-transparent\"> <div class=panel-heading> <span class=panel-title>{{ projectGroup.Name }}</span> <div class=panel-heading-controls> <a class=\"btn btn-link btn-default\" octo-permission=ProjectGroupEdit octo-project-group=projectGroup.Id href=\"#/projectgroups/{{ projectGroup.Id }}\">Edit</a> <a class=\"btn btn-success\" octo-permission=ProjectCreate octo-project-group=projectGroup.Id href=\"#/projects/new/{{ projectGroup.Id }}\">Add project</a> </div> </div> <div class=\"panel-body project-list\"> <markdown class=subtle text=projectGroup.Description></markdown> <loading-wrapper busy=projectsLoading[projectGroup.Id]> <div class=octo-tiles> <div class=octo-tile ng-repeat=\"project in projects[projectGroup.Id].Items\"> <a href=#/projects/{{project.Slug}} class=project> <project-logo project=project></project-logo> <span class=project-name>{{ project.Name }}</span> <markdown class=\"subtle project-description\" text=project.Description></markdown> </a> </div> </div> <octo-paginator is-loading=projectsLoading[projectGroup.Id] collection=projects[projectGroup.Id]></octo-paginator> </loading-wrapper> </div> </div> <div class=view-options ng-show=anyHiding()> <button class=\"btn btn-link btn-default\" type=button ng-click=\"view.showEmptyGroups = true\">Show empty groups »</button> </div> <div class=view-options ng-show=view.showEmptyGroups> <button class=\"btn btn-link btn-default\" type=button ng-click=\"view.showEmptyGroups = false\">« Hide empty groups</button> </div> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 935 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/lifecycle_map.html';
	var html = "<div class=lifecycle-map> <ul> <li class=phase ng-repeat=\"p in getPhaseCollection()\"> <div ng-show=\"envCount(p) == 1 && (p.Name == environmentsById[getSingleDeploymentTarget(p)].Name)\"> <span class=phase-icon ng-class=\"{ blocked: progress[p.Name] == 'Blocked', current: progress[p.Name] == 'Current', complete: progress[p.Name] == 'Complete', automatic: p.AutomaticDeploymentTargets.length > 0, 'deployed': deployed[getSingleDeploymentTarget(p)], 'queued': queued[getSingleDeploymentTarget(p)], 'warning': warning[getSingleDeploymentTarget(p)], 'executing': executing[getSingleDeploymentTarget(p)]}\"></span> <a class=phase-name ng-show=tasks[getSingleDeploymentTarget(p)] href=\"#/tasks/{{ tasks[getSingleDeploymentTarget(p)] }}\">{{ environmentsById[getSingleDeploymentTarget(p)].Name }}</a> <span class=phase-name ng-hide=tasks[getSingleDeploymentTarget(p)]>{{ environmentsById[getSingleDeploymentTarget(p)].Name }}</span> </div> <div ng-hide=\"envCount(p) == 1 && (p.Name == environmentsById[getSingleDeploymentTarget(p)].Name)\"> <span class=phase-icon ng-class=progress[p.Name].toLowerCase()></span> <span class=phase-name>{{ p.Name }}</span> <span class=phase-constraint ng-show=\"p.MinimumEnvironmentsBeforePromotion > 0 && p.MinimumEnvironmentsBeforePromotion < envCount(p)\">(any {{p.MinimumEnvironmentsBeforePromotion}})</span> <ul> <li ng-repeat=\"e in p.AutomaticDeploymentTargets\" title=\"Automatically deploy to this environment\" ng-show=environmentsById[e]> <span class=\"phase-icon automatic\" ng-class=\"{ blocked: progress[p.Name] == 'Blocked', 'deployed': deployed[e], 'warning': warning[e], 'executing': executing[e], 'queued': queued[e]  }\"></span> <a ng-show=tasks[e] href=\"#/tasks/{{ tasks[e] }}\">{{ environmentsById[e].Name }}</a> <span ng-hide=tasks[e]>{{ environmentsById[e].Name }}</span> </li> <li ng-repeat=\"e in p.OptionalDeploymentTargets\" title=\"Manually deploy to this environment\" ng-show=environmentsById[e]> <span class=\"phase-icon optional\" ng-class=\"{ blocked: progress[p.Name] == 'Blocked', 'deployed': deployed[e], 'warning': warning[e], 'executing': executing[e], 'queued': queued[e] }\"></span> <a ng-show=tasks[e] href=\"#/tasks/{{ tasks[e] }}\">{{ environmentsById[e].Name }}</a> <span ng-hide=tasks[e]>{{ environmentsById[e].Name }}</span> </li> </ul> </div> </li> </ul> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 936 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/lifecycle_selector_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Choose Lifecycle</h3> </div> <form ng-submit=accept()> <div class=modal-body> <error-box error=isSaving.error></error-box> <loading-wrapper busy=isLoading> <p> <select class=form-control ng-model=project.LifecycleId ng-change=preview() ng-options=\"p.Id as p.Name for p in lifecycles\" focus-on=page-loaded aria-label=\"Lifecycle selector\"> </select> </p> <markdown text=lifecyclesById[project.LifecycleId].Description></markdown> <div style=min-height:200px> <spin active=isPreviewing.busy></spin> <div ng-hide=isPreviewing.busy> <lifecycle-map lifecycle=previewLifecycle environments=environments></lifecycle-map> </div> </div> </loading-wrapper> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\">Apply</button> <button type=button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 937 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/overview.html';
	var html = "<loading-wrapper busy=vm.isLoading once=True> <div class=row> <div ng-show=\"vm.hasDeploymentSteps && vm.showFastboard\" class=dashboard-filter class=col-sm-12> <label class=control-label>Release:</label> <ui-select ng-model=vm.selectedRelease class=\"input-large form-control\"> <ui-select-match allow-clear=true placeholder=\"Show current releases\">{{$select.selected.Version}}</ui-select-match> <ui-select-choices repeat=\"item in vm.releases | filter: {Version: $select.search} track by item.Id\"> <span ng-bind-html=\"item.Version | highlight: $select.search\"></span> </ui-select-choices> </ui-select> <button type=button ng-click=vm.openTenantFilterDialog() class=\"btn btn-dashboard-filter\" ng-class=\"{'btn-success': vm.dashboardFilter.selectedTenants.length > 0 || vm.dashboardFilter.selectedTags.length > 0}\"> <i class=\"fa fa-fw fa-filter\"></i> {{ vm.isFiltered ? 'Filtering is on' : 'Filter tenants' }} <span ng-if=vm.isFiltered ng-click=\"vm.clearFilters = true\" class=clear-filter><i class=\"fa fa-fw fa-times\"></i></span> </button> <label ng-if=\"vm.groupByOptions && vm.groupByOptions.length > 0\" class=control-label>Grouped by:</label> <ui-select ng-if=\"vm.groupByOptions && vm.groupByOptions.length\" ng-model=vm.groupBy class=\"input-large form-control\"> <ui-select-match allow-clear=true placeholder=\"Group by...\">{{$select.selected.Name}}</ui-select-match> <ui-select-choices repeat=\"item in vm.groupByOptions | filter: {Name: $select.search} track by item.Id\"> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> </div> <div class=row> <div ng-show=!vm.hasDeploymentSteps class=col-sm-12> <h3>Overview</h3> <p class=subtle>Congratulations! You've got yourself a shiny new project. Click the <strong>Process</strong> tab on the left to add some deployment steps.</p> </div> <div ng-show=vm.hasDeploymentSteps class=col-sm-12> <div ng-show=\"vm.unsuccessfulDashboardItemExists == true\" class=margin-top-10> <p class=\"alert alert-warning\"> This project has triggers defined to help automate your project's deployments, however unsuccessful deployments have been detected in your dashboard. These unsuccessful deployments will block project-triggers from auto-deploying. For more information, please see <a class=alert-link href=http://g.octopushq.com/AutoDeployTroubleshooting target=_blank>our documentation</a>. </p> </div> <h3 ng-hide=\"vm.progression.Environments.length || vm.dashboardData.Environments.length || !vm.project \">Overview</h3> <div class=margin-top-bottom-20> <progression-matrix ng-if=!vm.showFastboard progression=vm.progression project=vm.project></progression-matrix> <fastboard ng-if=vm.showFastboard dashboard-data=vm.dashboardData tenant-promotions=vm.tenantPromotions dashboard-type=vm.dashboardType project=vm.project is-tenant-filtered=vm.isFiltered release=vm.selectedRelease></fastboard> </div> </div> </div>  </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 938 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/package_download_options.html';
	var html = "<div ng-show=\"action.Properties['Octopus.Action.Package.FeedId'] != 'feeds-builtin'\"> <control-group label=\"Download options\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.DownloadOnTentacle\"]' reset-value=\"'False'\" project-id=project.Id> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Package.DownloadOnTentacle\"]' value=False> Octopus Server will download the package, then securely upload it to the Tentacles</label> <label class=radio><input type=radio ng-model='action.Properties[\"Octopus.Action.Package.DownloadOnTentacle\"]' value=True> Each Tentacle will download the package directly from the remote server</label> </bound-field> <p class=help-block>Applies to machines running the Tentacle deployment agent only; packages deployed to other endpoint types are always downloaded by the Octopus Server.</p> </control-group> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 939 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/package_list.html';
	var html = "<ul class=packages> <li ng-repeat=\"pkg in packages\" ng-class=pkg.State> <h4><dfn title='{{ pkg.PackageId + \" from feed \" + pkg.FeedName }}'>{{ pkg.StepName }}: <span ng-show=\"pkg.StepName != pkg.PackageId\">{{ pkg.PackageId }}</span> version {{ pkg.Version }}</dfn></h4> <div ng-show=pkg.Notes ng-bind-html-unsafe=pkg.Notes></div> <div ng-show=pkg.ErrorNotes><div class=\"alert alert-warning\">{{pkg.ErrorNotes}}</div></div> </li> </ul> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 940 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/package_list_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>{{ package.PackageId }} previous versions</h3> </div> <div class=modal-body> <error-box error=isLoading.error></error-box> <p ng-show=packageResults>Prior versions of package {{ package.PackageId }} from feed {{ package.FeedName }}</p> <div class=\"form-inline margin-bottom-20\"> <div class=checkbox><label style=margin-right:20px><input type=checkbox ng-model=preRelease> Pre-release packages</label></div> <div class=checkbox><label style=margin-right:20px><input type=checkbox ng-model=channelRules> Only this channel</label></div> <div class=checkbox><label style=margin-right:20px><input type=checkbox ng-model=notes> Release notes</label></div> <a class=\"btn btn-success\" style=float:right ng-click=refresh() ng-disabled=isLoading.busy>Refresh</a> </div> <loading-wrapper busy=isLoading> <table class=\"table table-bordered\" ng-show=\"packageResults && !isLoading.busy\"> <thead> <tr> <th>Package</th> <th>Published</th> <th>Version</th> </tr> </thead> <tbody ng-repeat=\"row in packageResults\"> <tr> <td>{{ row.PackageId }}</td> <td>{{ row.Published }}</td> <td><a href ng-click=selectVersion(row.Version) focus-me=$first>{{ row.Version }}</a> <span class=\"fa pull-right text-default fa-exclamation\" uib-tooltip=\"Package version does not satisfy channel rules\" ng-if=row.IsNonChannelRule></span> </td> </tr> <tr ng-show=row.ReleaseNotes> <td class=\"gray smaller-fonts\" colspan=3>{{ row.ReleaseNotes }}</td> </tr> </tbody> </table> <div class=text-default ng-if=!channelRules> <span class=\"fa fa-exclamation\"></span> = Packages that don't match the selected channel version rules </div> </loading-wrapper> </div> <div class=modal-footer> <button class=\"btn btn-default\" ng-click=close() focus-me>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 941 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/package_selector.html';
	var html = "<div> <div class=\"alert alert-warning\" ng-show=\"feeds.length == 0\"> <p>A package feed is required before this step can be configured. Please add a feed in the <strong>Configuration</strong> area and try again.</p> </div> <div ng-show=\"feeds.length > 0\"> <control-group label=\"Package feed\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.FeedId\"]' reset-value=reset.feed project-id=project.Id> <select class=form-control id=feedSelector ng-model='action.Properties[\"Octopus.Action.Package.FeedId\"]' ng-change=feedChanged()> <option ng-repeat=\"feed in feeds | filter: {FeedType: feedType}\" value={{feed.Id}} ng-selected=\"{{feed.Id == action.Properties['Octopus.Action.Package.FeedId']}}\">{{feed.Name}}</option> </select> </bound-field> <p class=help-block>Select the feed that this package will be found in.</p> </control-group> <control-group label=\"Package ID\"> <bound-field local-names=localNames model='action.Properties[\"Octopus.Action.Package.PackageId\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text ng-change=checkIfLooksLikeVersion() id=packageId ng-model='action.Properties[\"Octopus.Action.Package.PackageId\"]' uib-typeahead=\"package.PackageId for package in getPackages($viewValue)\" typeahead-on-select=feedChanged() typeahead-wait-ms=300 autocomplete=off> </bound-field> <octo-clippy ng-show=looksLikeVersion> <p>Hey there! It looks like you might be including the package version number in this field. You shouldn't include the package version number here, just the package ID.</p> </octo-clippy> <p class=help-block>Enter the ID of the package to deploy.</p> </control-group> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 942 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/process.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/process'>Process</a></li> </script> <div> <div class=row> <div class=\"col-sm-8 col-md-8 col-lg-8\"> <div class=\"form-box form-horizontal\"> <error-box error=isSaving.error></error-box> <h3>Deployment process</h3> <div class=\"tutorial tutorial-left\" ng-show=\"deploymentProcess.Steps.length == 0\"> <p>This project doesn't have any deployment steps defined yet. Use the <strong>Add step</strong> button below to get started.</p> </div> <div> <div class=\"steps stack narrow650 margin-bottom-20\"> <div class=stack-item ng-class=\"{'stack-link-previous': step.StartTrigger == 'StartWithPrevious' && !$first, 'stack-disable': step.Actions.length == 1 && step.Actions[0].IsDisabled}\" ng-repeat=\"step in deploymentProcess.Steps\"> <div ng-show=\"step.Actions.length > 1\"> <div class=menu-button> <a class=dropdown-toggle href external-dropdown=\"{id: 'processEditDropdown', scope: { step: step } }\"><i class=\"fa fa-bars\"></i></a> </div> <div class=stack-content> <div class=action-summary-container> <div class=\"action-summary-image step-template-logo rolling-step-logo\"/> <div class=action-summary-content> <h4> {{ $index + 1 }}. <a href=\"{{ '#/projects/' + project.Slug + '/process/step/' + step.Id }}\">{{ step.Name }}</a> </h4> <p><span ng-show='step.Properties[\"Octopus.Action.MaxParallelism\"]'>Rolling deployment</span><span ng-hide='step.Properties[\"Octopus.Action.MaxParallelism\"]'>Multi-step deployment</span> across deployment targets in roles: <tag-list tags='step.Properties[\"Octopus.Action.TargetRoles\"]'></tag-list></p> </div> </div> </div> <div class=stack> <div class=stack-item ng-repeat=\"action in step.Actions\" ng-class=\"{ 'stack-disable': action.IsDisabled }\"> <div class=menu-button> <a class=dropdown-toggle href external-dropdown=\"{id: 'processEditDropdown', scope: { step: step, action: action, isChild: true } }\"><i class=\"fa fa-bars\"></i></a> </div> <div class=stack-content> <action-summary edit-link=\"'#/projects/' + project.Slug + '/process/step/' + action.Id\" number=\"($parent.$index + 1) + '.' + ($index + 1)\" action=action step=step></action-summary> </div> </div> <div class=\"text-center margin-top-bottom-10\"> <a class=\"btn btn-success\" href ng-click=addStep(step.Id)>Add step</a> <a class=\"btn btn-link btn-default\" href ng-click=reorderSteps(step.Id)>Reorder steps</a> </div> </div> </div> <div ng-show=\"step.Actions.length == 1\"> <div class=menu-button> <a class=dropdown-toggle href external-dropdown=\"{id: 'processEditDropdown', scope: { step: step, action: step.Actions[0] } }\"><i class=\"fa fa-bars\"></i></a> </div> <div class=stack-content> <action-summary edit-link=\"'#/projects/' + project.Slug + '/process/step/' + step.Actions[0].Id\" number=\"($index + 1)\" action=step.Actions[0] step=step></action-summary> </div> </div> </div> <div class=\"text-center margin-top-bottom-10\"> <a class=\"btn btn-success\" href ng-click=addStep()>Add step</a> <a class=\"btn btn-link btn-default\" ng-show=\"deploymentProcess.Steps.length > 1\" href ng-click=reorderSteps()>Reorder steps</a> </div> </div> </div> </div> </div> <div class=\"col-sm-4 col-md-4 col-lg-4\"> <h3>Project Lifecycle</h3> <div> <div class=well> <p><strong>{{ lifecycle.Name }}</strong></p> <lifecycle-map lifecycle=lifecycle environments=environments></lifecycle-map> </div> <a href ng-click=changeLifecycle()>Choose a different lifecycle</a> <p class=\"help-block margin-top-10\">This lifecycle defines how releases can be promoted between environments. Lifecycles can be defined in the <a href=#/library/lifecycles>Library</a>.</p> <p class=help-block>This is the default lifecycle for the project. It can be overridden by specifying <a href=#/projects/{{project.Slug}}/channels>Channels</a>.</p> </div> <h3>Deploying a release</h3> <a href ng-click=changeProjectConnectivityPolicy()>Deployment Target settings</a> <div ng-if=!project.ProjectConnectivityPolicy.AllowDeploymentsToNoTargets> <p class=\"help-block margin-top-10\">Deployments with no targets are not allowed.</p> </div> <div ng-if=project.ProjectConnectivityPolicy.AllowDeploymentsToNoTargets> <p class=\"help-block margin-top-10\">Deployments with no targets are <strong>allowed</strong>.</p> </div> <div ng-if=\"project.ProjectConnectivityPolicy.SkipMachineBehavior == 'None'\"> <p class=\"help-block margin-top-10\">Machines will not be skipped if they are unavailable during a deployment.</p> </div> <div ng-if=\"project.ProjectConnectivityPolicy.SkipMachineBehavior == 'SkipUnavailableMachines'\"> <p class=\"help-block margin-top-10\" ng-if=\"project.ProjectConnectivityPolicy.TargetRoles && project.ProjectConnectivityPolicy.TargetRoles.length > 0\">Machines in the following roles will be skipped if they are unavailable during a deployment: <span class=\"label truncate label-default\" ng-repeat=\"role in project.ProjectConnectivityPolicy.TargetRoles\">{{role}}</span> </p> <p class=\"help-block margin-top-10\" ng-if=\"!project.ProjectConnectivityPolicy.TargetRoles || project.ProjectConnectivityPolicy.TargetRoles.length === 0\">Any machine will be skipped if it is unavailable during the deployment.</p> </div> <div> <h3>Automatic Release Creation</h3> <p class=help-block>Please see the <a href=#/projects/{{project.Slug}}/triggers>Project Triggers</a> menu for Automatic Release Creation.</p> <div ng-if=\"builtInFeedPackageActions.length <= 0\" class=help-block> There are no steps using the built-in package repository. At least one step must use a package from the <a href=#/library/packages>built-in package repository</a> for Automatic Release Creation to work. </div> </div> <h3>Script modules</h3> <div ng-show=\"includedScriptModules.length == 0\"> <a href ng-click=configureLibraryScriptModules()>Include script modules</a> </div> <div ng-show=\"includedScriptModules.length > 0\" class=\"well margin-top-bottom-10\"> <p> <strong>Selected script modules: </strong> </p> <ul> <li ng-repeat=\"sm in includedScriptModules\"><a href=#/library/scripts/{{sm.Id}}>{{sm.Name}}</a></li> </ul> <div class=clearfix></div> <a href ng-click=configureLibraryScriptModules()>Choose different script modules</a> </div> <p class=\"help-block margin-top-10\">The Library includes <a href=#/library/scripts>PowerShell script modules</a> that can be shared between projects. Functions in the script modules are available to any PowerShell script executing during deployments of this project.</p> </div> </div> <script type=text/html id=processEditDropdown> <ul class=\"dropdown-menu\" role=\"menu\">\r\n    <li><a tabindex=\"-1\" ng-show=\"action\" href=\"{{ '#/projects/' + project.Slug + '/process/step/' + action.Id }}\">Edit</a></li>\r\n    <li><a tabindex=\"-1\" ng-hide=\"action\" href=\"{{ '#/projects/' + project.Slug + '/process/step/' + step.Id }}\">Edit</a></li>\r\n    <li class=\"divider\" ng-show=\"canHaveChildren(step) && !isChild\"></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"canHaveChildren(step) && !isChild\" ng-click=\"addStep(step.Id)\">Add child step</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"action && action.IsDisabled\" ng-click=\"enableAction(step.Id, action.Id)\">Enable</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"action && !action.IsDisabled\" ng-click=\"disableAction(step.Id, action.Id)\">Disable</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"canHaveChildren(step) && !isChild && !action\" ng-click=\"enableAllActions(step.Id)\">Enable all</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"canHaveChildren(step) && !isChild && !action\" ng-click=\"disableAllActions(step.Id)\">Disable all</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"isChild && action\" ng-click=\"moveOut(step.Id, action.Id)\">Move out</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"action\" ng-click=\"moveIn(step.Id, action.Id)\">Move into...</a></li>\r\n    <li class=\"divider\"></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"action\" ng-click=\"cloneStep(step.Id, action.Id, isChild)\">Clone</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-hide=\"action\" ng-click=\"cloneStep(step.Id, null, isChild)\">Clone</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-show=\"action\" ng-click=\"deleteStep(step.Id, action.Id)\">Delete</a></li>\r\n    <li><a tabindex=\"-1\" href=\"\" ng-hide=\"action\" ng-click=\"deleteStep(step.Id)\">Delete</a></li>\r\n  </ul> </script> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 943 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/process_features_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Enabled features</h3> </div> <form> <div class=modal-body> <div class=\"alert alert-warning\" ng-if=\"removedFeatures.length > 0\"> You have deselected the feature<span ng-if=\"removedFeatures.length > 1\">s</span> <span ng-repeat=\"feature in removedFeatures\"> {{$last && $index !=0 ? ' and ' : ''}} {{$middle ? ', ' : ''}}<b>{{feature}}</b></span>.<br> This will remove any related settings for {{removedFeatures.length > 1 ? 'these features' : 'this feature'}}. </div> <table class=\"table table-bordered table-striped\" ng-show=features> <thead> <tr> <th width=30%>Feature</th> <th>Description</th> </tr> </thead> <tbody> <tr ng-repeat=\"feature in features\"> <td><div class=checkbox><label><input type=checkbox ng-model=feature.isEnabled ng-change=featureToggled(feature)> {{ feature.title }} </label></div></td> <td><markdown text=feature.description></markdown></td> </tr> </tbody> </table> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" ng-click=save()>Apply</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 944 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/process_step_edit.html';
	var html = "<div> <script octo-section=breadcrumbs type=text/ng-template> <li ng-show=\"step\">\r\n            <a href='#/projects/{{ project.Slug }}/process'>Process</a>\r\n        </li>\r\n        <li ng-show=\"step && isMultiAction || !action && !isNew\">\r\n            <a href='#/projects/{{ project.Slug }}/process/step/{{ step.Id }}'>{{ originalStepName }}</a>\r\n        </li>\r\n        <li ng-show=\"step && action && !isNew\">\r\n            <a href='#/projects/{{ project.Slug }}/process/step/{{ action.Id }}'>{{ originalActionName }}</a>\r\n        </li>\r\n        <li ng-show=\"step && isNew\">\r\n            <a href='#/projects/{{ project.Slug }}/process/step/new/{{ action.ActionType }}'>{{ originalActionName\r\n                }}</a>\r\n        </li> </script> <loading-wrapper busy=isLoading> <form ng-submit=save() name=stepEditForm track-unsaved-changes> <div class=form-horizontal> <div> <error-box error=isSaving.error></error-box> <h3>Step details</h3> <div class=form-body> <div> <div ng-hide=action> <control-group label=\"Step name\"> <input class=\"input-xlarge form-control\" type=text id=stepNameTxt ng-model=step.Name> </control-group> </div> <div ng-show=action> <control-group label=\"Step name\"> <input class=\"input-xlarge form-control\" type=text id=actionNameTxt ng-model=action.Name> </control-group> </div> <h4 class=separator ng-show=action>Execution plan</h4> <div> <control-group label=\"Run on\"> <label ng-if=\"executionLocation === executionLocations.targetOrServer\" class=radio> <input type=radio ng-model='action.Properties[\"Octopus.Action.RunOnServer\"]' value=false> Deployment targets</label> <label ng-if=\"executionLocation === executionLocations.targetOrServer\" class=radio> <input type=radio ng-model='action.Properties[\"Octopus.Action.RunOnServer\"]' value=true class=run-on-server> Octopus Server</label> <label ng-if=\"executionLocation === executionLocations.alwaysOnServer\" class=radio>Octopus Server</label> <label ng-if=\"executionLocation === executionLocations.alwaysOnTarget\" class=radio>Deployment targets</label> </control-group> </div> <div ng-if=!canChooseRoles> <p class=text-muted>This step will run once on the Octopus Server.</p> </div> <div ng-show=\"canChooseRoles && rolesAreEditable\"> <control-group label=\"{{runsOnServer(action, executionLocation) ? 'On behalf of target roles' : 'Runs on targets in roles'}}\"> <select-roles multiple=true csv-split-formatter ng-model='step.Properties[\"Octopus.Action.TargetRoles\"]' available=availableRoles placeholder=\"'Select roles'\"></select-roles> </control-group> <div ng-show='runsOnServer(action, executionLocation) && !step.Properties[\"Octopus.Action.TargetRoles\"]'> <p class=text-muted>This step will run once on the Octopus Server.</p> </div> <div ng-hide=\"runsOnServer(action, executionLocation) && !step.Properties['Octopus.Action.TargetRoles']\"> <div ng-hide='step.Properties[\"Octopus.Action.MaxParallelism\"]'> <p class=text-muted>This step will be run on <span ng-show=\"runsOnServer(action, executionLocation)\">the Octopus Server on behalf of </span>all deployment targets in parallel. <a href ng-click='beginEditBatchSize(\"1\")'>Configure a rolling deployment</a>.</p> </div> <div ng-show='step.Properties[\"Octopus.Action.MaxParallelism\"]'> <p class=text-muted>This is a rolling step that will run on <span ng-show=\"runsOnServer(action, executionLocation)\">the Octopus Server on behalf of </span>a limited number of deployment targets at once. <a href ng-click='beginEditBatchSize(\"\")'>Deploy to all deployment targets in parallel</a>.</p> </div> <div ng-show='step.Properties[\"Octopus.Action.MaxParallelism\"]'> <control-group label=\"Window size\"> <bound-field local-names=localNames model='step.Properties[\"Octopus.Action.MaxParallelism\"]' reset-value=\"''\" project-id=project.Id> <input class=\"input-xlarge form-control\" type=text id=batchSizeTxt ng-model=view.editingBatchSize ng-focus=beginEditBatchSize() ng-blur=endEditBatchSize()> </bound-field> <p class=help-block>When deploying to multiple deployment targets, you can configure the rolling window size to use. For example:</p> <ul class=help-block> <li>A window size of 1 will deploy to a single deployment target at a time. Octopus will wait for the step to finish running on deployment target A before starting on deployment target B. </li> <li>A window size of 3 will deploy to three deployment targets at a time. Octopus will wait for the step to finish running on deployment targets A, B *or* C before starting on deployment target D. </li> </ul> <p class=help-block>Omitting the window size will run the step against all deployment targets at once.</p> </control-group> </div> </div> </div> <div ng-show=\"canChooseRoles && !rolesAreEditable\"> <h4 class=separator>Targets</h4> <div ng-switch on=\"runsOnServer(action, executionLocation)\"> <p ng-switch-when=true class=text-muted>This step is part of a rolling step, which runs on the Octopus Server on behalf of deployment targets in the following roles: <tag-list tags='step.Properties[\"Octopus.Action.TargetRoles\"]'></tag-list> </p> <p ng-switch-default=\"\" class=text-muted>This step is part of a rolling step, which runs on deployment targets in the following roles: <tag-list tags='step.Properties[\"Octopus.Action.TargetRoles\"]'></tag-list> </p> </div> </div> <div ng-if=!actionTemplate> <action-editor project=project action=action step=step feeds=feeds view-options=viewOptions></action-editor> <feature-editor project=project action=action step=step enabled-features='action.Properties[\"Octopus.Action.EnabledFeatures\"]'></feature-editor> <div ng-show=hasFeatures> <p class=help-block> Octopus comes with a variety of built-in features that help to make your deployments easier. You can enable these features by adding them below. </p> <hr/> <div class=clearfix> <div class=text-center> <a class=\"btn btn-link btn-default\" href ng-click=showAddFeaturesDialog(action)>Configure features</a> </div> </div> <hr/> </div> </div> <div ng-if=actionTemplate> <action-template-editor action-template=actionTemplate project=project process=deploymentProcess action=action></action-template-editor> </div> <h4 class=separator ng-show=\"action || conditionIsEditable\">Conditions</h4> <control-group label=Environments ng-show=action> <div class=radio> <label><input type=radio name=specificMachineOptions value=all ng-disabled=condition.hasHiddenEnvironments ng-model=condition.environmentOption> Run for all applicable Lifecycle environments</label> </div> <div class=radio> <label><input type=radio name=specificMachineOptions value=include ng-disabled=condition.hasHiddenEnvironments ng-model=condition.environmentOption> Run only for specific environments</label> </div> <div ng-if=\"condition.environmentOption === 'include'\"> <select-environments placeholder=\"'Include all environments'\" available=environments ng-model=condition.inclusiveEnvironments multiple=true> </select-environments> <p class=help-block>Choose the specific environments under which you want this step to run.</p> <div class=\"alert alert-info\" ng-if=condition.hasHiddenEnvironments> The environment condition type cannot be changed because you do not have access to an environment that is specifically marked for inclusion. </div> </div> <div class=radio> <label><input type=radio name=specificMachineOptions value=exclude ng-disabled=condition.hasHiddenEnvironments ng-model=condition.environmentOption> Skip specific environments</label> </div> <div ng-if=\"condition.environmentOption === 'exclude'\"> <select-environments placeholder=\"'Exclude no environments'\" available=environments ng-model=condition.exclusiveEnvironments multiple=true> </select-environments> <p class=help-block>Choose the environments for which you want this step to be skipped.</p> <div class=\"alert alert-info\" ng-if=condition.hasHiddenEnvironments> The environment condition type cannot be changed because you do not have access to an environment that is specifically marked for exclusion. </div> </div> <p class=help-block></p> </control-group> <div ng-show=\"action && (action.Channels.length > 0 || channels.length > 1)\"> <control-group label=Channels> <select-channels available=channels ng-model=action.Channels multiple=true></select-channels> <p class=help-block>This step will be skipped if the release channel is not in the list above.</p> </control-group> </div> <div ng-show=\"action && (project.TenantedDeploymentMode !== 'Untenanted' || action.TenantTags.length > 0)\" octo-feature=IsMultiTenancyEnabled> <control-group label=Tenants> <advanced-tenant-selector hide-tenants=true selected-tags=action.TenantTags filter-by-project-id=project.Id> </advanced-tenant-selector> <p class=help-block>When you deploy your project to a given tenant, this step will be skipped if the tenant does not match the tenant filter above. Note: if a tenant filter is specified, this step will be skipped when performing un-tenanted deployments.</p> </control-group> </div> <div ng-show=conditionIsEditable> <control-group label=\"Run condition\"> <select class=form-control ng-model=step.Condition ng-options=\"condition.value as condition.description for condition in runConditions\"> </select> <p class=help-block>Limit when this step runs by setting a condition.</p> </control-group> <control-group label=\"\" ng-show=\"step.Condition === 'Variable'\"> <bound-field local-names=localNames model='step.Properties[\"Octopus.Action.ConditionVariableExpression\"]' reset-value=\"''\" project-id=project.Id> <input class=form-control type=text id=runConditionVariableExpression ng-model='step.Properties[\"Octopus.Action.ConditionVariableExpression\"]' placeholder=\"Variable expression\"> </bound-field> <p class=help-block>Limit when this step runs by setting a boolean variable expression that will be evaluated at run-time. See the <a href=http://g.octopushq.com/VariableSubstitutionSyntax target=_blank>Variable Substitution Syntax</a> documentation for examples.</p> </control-group> <control-group label=\"Start trigger\"> <select class=form-control ng-model=step.StartTrigger ng-options=\"condition.value as condition.description for condition in startTriggers\"> </select> <p class=help-block>Control whether this step waits for the previous step to complete, or runs in parallel with it.</p> <div class=\"alert alert-warning margin-top-5\" ng-show=\"step.StartTrigger == 'StartWithPrevious'\"> <p>Please note that even with this setting, each target (excluding Azure endpoints) will still be limited to only performing a single deployment activity at once for safety reasons. See how to <a href=http://docs.octopusdeploy.com/display/OD/Run+multiple+processes+on+a+Tentacle+simultaneously target=_blank>override this behavior</a>.</p> </div> </control-group> </div> <div ng-show=viewOptions.canRunBeforeAcquisition> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=step.RequiresPackagesToBeAcquired> Wait for packages to be downloaded before running</label></div> <p class=help-block>Octopus will download the packages prior to running any package deployment steps. You can un-check this box to execute this step <em>prior</em> to package acquisition.</p> </control-group> </div> </div> </div> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit>Save</button> </div> </div> </form> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 945 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/project_layout.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/projects/{{ project.Slug }}\">{{project.Name}}</a></li> </script> <script octo-section=tools type=text/ng-template> <div octo-placeholder=\"project_tools_left\" style=\"display: inline;\">\r\n    </div>\r\n    <unsaved-changes-indicator></unsaved-changes-indicator>\r\n    <div octo-placeholder=\"project_tools\" style=\"display: inline;\">\r\n    </div> </script> <div class=\"page-body layout-sidebar\"> <div id=sidebar style=display:inherit ng-cloak> <div class=\"text-center hidden-xs\"> <project-logo project=project></project-logo> <h4 class=\"margin-top-bottom-10 text-wrap-break\">{{project.Name}}</h4> </div> <div class=text-center> <a class=\"btn btn-success\" octo-permission=ReleaseCreate octo-project=project.Id ng-show=\"project && !suppressCreateRelease && !project.IsDisabled\" href=\"#/projects/{{ project.Slug }}/releases/create\">Create release</a> </div> <hr> <div class=\"project-menu-buffer margin-top-20\"> <div class=list-group> <a class=list-group-item ng-class=\"{active: $root.layout.projectTab == 'overview'}\" href=#/projects/{{project.Slug}} octo-disable-link=project>Overview</a> <a class=list-group-item octo-permission=ProcessView octo-project=project.Id octo-environment=\"'*'\" ng-class=\"{active: $root.layout.projectTab ==  'process'}\" href=#/projects/{{project.Slug}}/process octo-disable-link=project>Process</a> <a class=list-group-item octo-permission=VariableView octo-project=project.Id octo-environment=\"'*'\" ng-class=\"{active: $root.layout.projectTab == 'variables'}\" href=#/projects/{{project.Slug}}/variables octo-disable-link=project>Variables</a> <a class=list-group-item octo-permission=ProcessEdit octo-project=project.Id octo-environment=\"'*'\" ng-class=\"{active: $root.layout.projectTab == 'triggers'}\" href=#/projects/{{project.Slug}}/triggers octo-disable-link=project>Triggers</a> <a class=list-group-item octo-permission=ProcessView octo-project=project.Id octo-environment=\"'*'\" ng-class=\"{active: $root.layout.projectTab == 'channels'}\" href=#/projects/{{project.Slug}}/channels octo-disable-link=project>Channels</a> <a class=list-group-item octo-permission=ReleaseView octo-project=project.Id octo-environment=\"'*'\" ng-class=\"{active: $root.layout.projectTab ==  'releases'}\" href=#/projects/{{project.Slug}}/releases octo-disable-link=project>Releases</a> <a class=list-group-item octo-permission=ProjectEdit octo-project=project.Id octo-environment=\"'*'\" ng-class=\"{active: $root.layout.projectTab ==  'settings'}\" href=#/projects/{{project.Slug}}/settings octo-disable-link=project>Settings</a> </div> </div> <div class=hidden-xs> <hr/> <markdown class=\"subtle project-description\" text=project.Description></markdown> </div> </div> <div id=content-wrapper> <div id=view-container height-magic ng-cloak> <loading-wrapper busy=isLoading> <ui-view></ui-view> </loading-wrapper> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 946 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/pulse.html';
	var html = "<div class=project-pulse ng-class=pulseFreshnessClass()> <div ng-show=anyPulse() class=pulse-time>{{ pulse.Deployed | momentAgo }}</div> <div ng-show=anyPulse() class=pulse-environment>{{ pulse.EnvironmentName }}</div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 947 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/release.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/releases/{{ release.Version }}'>{{ release.Version }}</a>\r\n      <channel-label project=\"project\" channel-id=\"release.ChannelId\" ng-if=\"project && release.ChannelId\" ></channel-label>\r\n    </li> </script> <div class=row ng-show=release> <div class=\"col-sm-6 col-md-6 col-lg-6\"> <h3 class=margin-bottom-10>Release {{ release.Version }}</h3> <update-wrapper busy=isRefreshing> <deploy-buttons class=\"\" project=project release=release lifecycle=lifecycle environments=environments progression=progression></deploy-buttons> </update-wrapper> <release-defects release=release progression=progression></release-defects> <h4 ng-if=\"channel && channels.length > 1\">Channel: {{channel.Name}}</h4> <h4>Lifecycle: {{lifecycle.Name}}</h4> <update-wrapper busy=isRefreshing> <lifecycle-map lifecycle=lifecycle environments=environments progression=progression></lifecycle-map> </update-wrapper> <hr octo-permission=DeploymentCreate octo-environment=\"'*'\" octo-project=project.Id> <markdown text=release.ReleaseNotes></markdown> <p> <a href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}/edit\" ng-show=\"project && release\">Edit this release</a> </p> <div ng-if=\"packages.length > 0\"> <h3 class=margin-top-20>Packages</h3> <package-list packages=packages></package-list> </div> <h3 class=margin-top-20>Variables</h3> <p class=subtle> When this release was created, a snapshot of the project variables was taken. <a href ng-hide=viewShowVariables ng-click=\"viewShowVariables = !(viewShowVariables)\">Show »</a> <span ng-show=viewShowVariables>You can overwrite the variable snapshot by re-importing the variables from the project. <a href ng-show=viewShowVariables ng-click=\"viewShowVariables = !(viewShowVariables)\">« Hide</a></span> </p> <div ng-if=viewShowVariables> <p> <button class=\"btn btn-default\" type=button ng-click=snapshotVariables()>Update variables</button> </p> <variable-set-snapshot id=release.ProjectVariableSetSnapshotId project=project limit-width=true></variable-set-snapshot> <div ng-repeat=\"id in release.LibraryVariableSetSnapshotIds\" project=project> <variable-set-snapshot id=id limit-width=true></variable-set-snapshot> </div> </div> </div> <div class=\"col-sm-6 col-md-6 col-lg-6\"> <h3>Deployments</h3> <deployment-listing deployments=deployments></deployment-listing> <h3 class=margin-top-20>Artifacts</h3> <div class=margin-top-bottom-10> <artifact-listing artifacts=artifacts></artifact-listing> </div> <h3 class=margin-top-20>History</h3> <div class=margin-top-bottom-10> <loading-wrapper busy=isEventsLoading once=true> <event-listing events=events></event-listing> </loading-wrapper> </div> <last-modified model=release></last-modified> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 948 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/release_create.html';
	var html = " <script octo-section=breadcrumbs type=text/ng-template> <li ng-hide='originalVersion'><a href='#/projects/{{ project.Slug }}/releases/create'>Create</a></li> </script> <release-editor></release-editor>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 949 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/release_defects.html';
	var html = "<div> <div class=margin-bottom-10> <a class=\"btn btn-link no-margin-left no-padding-hr\" ng-show=\"release && !defects.releaseHasDefect && !defects.showReportArea\" ng-click=defects.toggleReportArea() octo-permission=DefectReport octo-project=release.ProjectId>Block deployment</a> <div class=defect-panel ng-show=defects.showReportArea octo-permission=DefectReport octo-project=release.ProjectId> <form> <error-box error=isDefectSaving.error></error-box> <div class=textwrapper> <textarea rows=3 class=\"form-control auto-textarea\" placeholder=\"Describe the issue with this deployment\" ng-model=defects.newDefectDescription ng-required ng-minlength=2></textarea> </div> <button type=submit class=\"btn btn-warning\" ng-click=defects.reportDefect() ng-disabled=isDefectSaving.busy>Block</button> <button class=\"btn btn-default\" ng-click=defects.toggleReportArea()>Cancel</button> <spin active=isDefectSaving.busy></spin> </form> </div> <div class=\"note note-warning\" ng-show=defects.releaseHasDefect> <error-box error=isDefectSaving.error></error-box> <markdown text=defects.defectDescription></markdown> <button class=\"btn btn-warning\" ng-click=defects.resolveDefect() ns-disables=!isDefectSaving.busy octo-permission=DefectResolve octo-project=release.ProjectId>Resolve and unblock</button> <inline-spin active=isDefectSaving.busy></inline-spin> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 950 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/release_edit.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-show='originalVersion'>\r\n        <a href='#/projects/{{ project.Slug }}/releases/{{ originalVersion }}'>{{ originalVersion }}</a>\r\n        <channel-label project=\"project\" channel-id=\"release.ChannelId\" ng-if=\"project && release.ChannelId\">\r\n        </channel-label>\r\n    </li>\r\n    <li ng-show='originalVersion'><a href='#/projects/{{ project.Slug }}/releases/{{ originalVersion }}/edit'>Edit</a>\r\n    </li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <release-editor></release-editor> </div> <div class=\"col-sm-3 col-md-3 col-lg-3\"> <div class=other-actions> <div ng-show=release.Id octo-permission=ReleaseDelete octo-project=project.Id> <h3>Delete</h3> <p>Once you delete this release, there is no going back. The release and any of its deployments will be permanently deleted.</p> <delete-button model=release what=release redirect=\"/projects/{{ project.Slug }}/releases\"></delete-button> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 951 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/release_editor.html';
	var html = "<div class=\"form-box form-horizontal\"> <h3 ng-show=originalVersion>Edit release</h3> <h3 ng-hide=originalVersion>Create release</h3> <div class=\"tutorial tutorial-center\" ng-show=\"deploymentProcess.Steps.length == 0\"> <p>The project's deployment process doesn't have any steps. <span octo-permission=ProcessEdit>Add steps under the <strong>Process</strong> tab to the left.</span></p> </div> <form ng-show=deploymentProcess.Steps ng-submit=save() name=releaseCreateForm track-unsaved-changes> <div> <error-box error=isSaving.error></error-box> <div class=\"alert alert-info\" ng-if=\"originalChannelId && originalChannelId != release.ChannelId\"> Changing the channel of this release is only allowed where all the steps previously applicable (with respect to any channel filters) will still be applicable with the new channel. <br/>Please make sure you are aware which steps are now active as you may be unable to reverse this change. </div> <control-group label=Channel ng-show=\"channels.Items.length > 1\"> <select class=form-control ng-model=release.ChannelId ng-options=\"channel.Id as channel.Name for channel in channels.Items\" ng-change=channelSelected()> </select> </control-group> <control-group label=Version> <input class=form-control type=text ng-model=release.Version ng-change=versionModified()> <div class=margin-top-bottom-10 ng-show=\"template.LastReleaseVersion && !originalVersion\">Most recent release: <a href=\"#/projects/{{ project.Slug }}/releases/{{ template.LastReleaseVersion }}\">{{ template.LastReleaseVersion }}</a></div> <p class=help-block>Enter a unique version number for this release with at least two parts. <a href detailed-help-toggle>See examples.</a></p> <div class=\"detailed-help help-block\"> <p>You can use standard version numbers with two, three or four components:</p> <ul> <li><code>2.3</code></li> <li><code>2.3.16</code></li> <li><code>2.3.16.384</code></li> </ul> <p>You can also include <a class=external href=http://g.octopushq.com/SemVer target=_blank>semantic version</a> tags:</p> <ul> <li><code>2.3.16-beta</code></li> <li><code>2.3.16.384-pre-release</code></li> </ul> <p>You can also use the letter <code>i</code> to increment part of the last release, for example:</p> <ul> <li><code>1.i</code></li> <li><code>1.15.i</code></li> <li><code>2.i.i</code></li> </ul> </div> </control-group> <div ng-show=\"packageSelections.length > 0\"> <h4 class=divider>Packages</h4> <div class=\"alert alert-warning\" ng-show=feedLoadingError> <p>{{ feedLoadingError.ErrorMessage }}</p> </div> <table class=\"table table-bordered\"> <thead> <tr> <th style=width:20%>Step</th> <th style=width:20%>Package</th> <th style=width:15%><abbr title=\"The most recent package that we could find in the package feed that matches channel rules\"><a target=_blank href=http://g.octopushq.com/LatestPackage>Latest</a></abbr></th> <th style=width:15% ng-show=\"template.LastReleaseVersion && !originalVersion\"><abbr title=\"{{ 'The version selected for release ' + template.LastReleaseVersion }}\">Last</abbr></th> <th style=width:30%>Specific</th> </tr> </thead> <tbody> <tr ng-repeat=\"pack in packageSelections\"> <td class=valign-middle>{{ pack.StepName }}</td> <td class=valign-middle><abbr title=\"{{ pack.PackageId + ' from ' + pack.FeedName }}\">{{ pack.PackageId }}</abbr></td> <td class=valign-middle> <div class=form-inline> <label ng-hide=\"(!pack.LatestVersion && feedLoadingError) || !pack.IsResolvable\"> <input type=radio ng-model=pack.VersionType value=latest ng-change=\"packageVersionChanged(pack, pack.LatestVersion)\"> <span ng-show=pack.LatestVersion>{{ pack.LatestVersion }}</span> <span class=gray ng-hide=pack.LatestVersion>Loading...</span> </label> </div> </td> <td class=valign-middle ng-show=\"template.LastReleaseVersion && !originalVersion\"> <div class=form-inline> <label ng-show=pack.LastReleaseVersion> <input type=radio ng-model=pack.VersionType value=last ng-change=\"packageVersionChanged(pack, pack.LastReleaseVersion)\"> {{ pack.LastReleaseVersion }} <span class=\"fa text-default fa-exclamation ng-hide\" uib-tooltip=\"Package version does not satisfy channel rules\" ng-show=!pack.isLastReleaseVersionValid></span> </label> </div> </td> <td class=valign-middle> <span class=form-inline> <input type=radio ng-model=pack.VersionType value=specific ng-change=\"setVersionSatisfaction(pack, pack.SpecificVersion)\"> &nbsp; <input class=\"input-medium form-control inline\" type=text ng-model=pack.SpecificVersion ng-change=specificVersionSelected(pack)> &nbsp; <a class=btn-search href ng-click=showSearchDialog(pack)>Search</a> </span> </td> </tr> </tbody> </table> </div> <div class=\"alert alert-info\" ng-show=violatedPackages.length> <input type=checkbox ng-model=options.ignoreChannelRules name=force id=force> <label for=force>Force Version Selection</label> <div>You have selected a package version that violates the version rules specified by the selected channel. You must explicitly check the box above to force this selection and ignore the channel rules for the release to be created.</div> </div> <h4 class=divider>Release notes</h4> <div> <textarea ng-model=release.ReleaseNotes class=form-control rows=10 markitup></textarea> </div> <p class=help-block>Enter a summary of what has changed in this release, such as which features were added and which bugs were fixed. These notes will be shown on the release page. You can edit these notes later.</p> <last-modified model=release></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 952 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/releases.html';
	var html = "<div> <h3>Releases</h3> <loading-wrapper busy=isLoading> <div ng-if=\"channels.Items.length > 1\" class=row> <control-group label=\"Show releases in\"> <select-channels available=channels.Items ng-model=filter.channelId ng-change=refresh() allow-clear=true></select-channels> </control-group> </div> <div ng-repeat=\"release in releases.Items\" class=margin-top-bottom-30> <div><a class=text-bg href=\"#/projects/{{ project.Slug }}/releases/{{ release.Version }}\">{{ release.Version }}</a> <channel-label channel-id=release.ChannelId channels=channels ng-if=\"channels && release.ChannelId\"></channel-label> </div> <div class=\"subtle margin-top-bottom-5 small\">Assembled {{ release.Assembled | moment }}</div> <markdown text=release.ReleaseNotes></markdown> </div> <octo-paginator collection=releases></octo-paginator> <div class=\"alert alert-info\" ng-if=\"releases.Items.length == 0 && !filter.channelId\"> This project hasn't had any releases yet! <span ng-show=\"deploymentProcess.Steps.length < 1\"> Before creating your first release, you need to define your <a class=alert-link href=\"#/projects/{{ project.Slug }}/process\">deployment process</a>.</span> <span ng-hide=\"deploymentProcess.Steps.length < 1\"> <a class=alert-link octo-permission=ReleaseCreate octo-project=project.Id href=\"#/projects/{{ project.Slug }}/releases/create\">Create your first release</a>. </span> </div> <div class=\"alert alert-info\" ng-if=\"releases.Items.length == 0 && filter.channelId\"> There are no releases in the selected channel. <a class=alert-link octo-permission=ReleaseCreate octo-project=project.Id href=\"#/projects/{{ project.Slug }}/releases/create?channelId={{filter.channelId}}\">Create a release in this channel</a>. </div> </loading-wrapper> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 953 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/step_list_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Move into parent step {{ contentTypeDesc }}</h3> </div> <form ng-submit=save()> <div class=modal-body> <div class=form-inline> <p> Move the step <strong>{{ action.Name }}</strong> into the new parent step: </p> <select class=form-control ng-options=\"s.Name for s in steps\" ng-model=selectedStep></select> </div> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" ng-show=selectedStep ng-click=save()>Apply</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 954 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/target_settings_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Deployment Targets</h3> </div> <form name=projectConnectivityPolicy ng-submit=accept()> <div class=modal-body> <error-box error=isSaving.error></error-box> <loading-wrapper busy=isLoading> <div class=well> <control-group label=\"No Targets\"> <div class=checkbox><label><input type=checkbox ng-model=project.ProjectConnectivityPolicy.AllowDeploymentsToNoTargets> Allow deployments to be created when there are no deployment targets.</label></div> </control-group> </div> <div class=well> <control-group label=\"Skip machines\"> <div class=checkbox><label><input type=checkbox ng-model=project.ProjectConnectivityPolicy.SkipMachineBehavior ng-true-value=\"'SkipUnavailableMachines'\" ng-false-value=\"'None'\"> Skip machines if they are or become <strong>unavailable</strong></label></div> </control-group> <control-group label=Roles> <select-roles multiple=true ng-model=project.ProjectConnectivityPolicy.TargetRoles available=availableRoles></select-roles> </control-group> <p class=\"alert alert-info\" ng-show=\"project.ProjectConnectivityPolicy.SkipMachineBehavior === 'SkipUnavailableMachines'\">Machines that are unavailable at the start of the deployment or become unavailable during the deployment will be skipped and removed from the deployment.</p> </div> </loading-wrapper> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\">Apply</button> <button type=button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 955 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/variables_editor.html';
	var html = "<div> <div id=myGrid class=slick-grid-table style=width:100%;height:500px /> <script type=text/html id=variableDropdown> <ul class=\"dropdown-menu\" role=\"menu\">\r\n            <li><a tabindex=\"-1\" href=\"\" ng-click=\"duplicateVariable(variable, row)\">Duplicate</a></li>\r\n            <li class=\"divider\" ng-show=\"hasChanges\"></li>\r\n            <li><a tabindex=\"-1\" href=\"\" ng-show=\"hasChanges\" ng-click=\"resetChanges(variable)\">Reset changes</a></li>\r\n            <li class=\"divider\"></li>\r\n            <li><a tabindex=\"-1\" href=\"\" ng-click=\"deleteVariable(variable)\">Delete</a></li>\r\n        </ul> </script> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 956 */
/***/ function(module, exports) {

	var path = 'areas/projects/views/variables_editor_scope.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=vm.close()>×</button> <h3>{{vm.isFilter ? 'Filter on scope' : 'Variable scope'}}</h3> </div> <div class=modal-body> <div class=\"form-box form-horizontal\"> <control-group label=Environments> <select-custom available=vm.availableScopeValues.Environments ng-model=vm.selectedScopeValues.environments multiple=multiple></select-custom> </control-group> <control-group label=Roles> <select-custom available=vm.availableScopeValues.Roles ng-model=vm.selectedScopeValues.roles multiple=multiple></select-custom> </control-group> <control-group label=Targets> <select-custom available=vm.availableScopeValues.Machines ng-model=vm.selectedScopeValues.machines multiple=multiple></select-custom> </control-group> <control-group label=Steps> <select-custom available=vm.availableScopeValues.Actions ng-model=vm.selectedScopeValues.steps multiple=multiple></select-custom> </control-group> <control-group label=Channels ng-if=\"(vm.selectedScopeValues.channels && vm.selectedScopeValues.channels.length > 0) || (vm.availableScopeValues.Channels && vm.availableScopeValues.Channels.length > 1)\"> <select-custom available=vm.availableScopeValues.Channels ng-model=vm.selectedScopeValues.channels multiple=multiple></select-custom> </control-group> <advanced-tenant-selector ng-if=vm.canScopeToTenantTags octo-feature=IsMultiTenancyEnabled hide-tenants=true selected-tags=vm.selectedScopeValues.tenantTags> </advanced-tenant-selector> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" type=submit ng-click=vm.save()>{{vm.isFilter ? 'Filter' : 'Apply'}}</button> <button class=\"btn btn-default\" type=button ng-click=vm.close()>Cancel</button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 957 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/alerts.html';
	var html = "<div> <div ng-repeat=\"alert in list\"> <div class=alert ng-class=\"{ 'alert-danger': alert.Severity == 'Danger' }\"> {{ alert.Message }} </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 958 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/artifact-listing.html';
	var html = "<div> <p class=\"tutorial pad-text\" ng-show=!artifacts.Items.length> No artifacts have been added. Learn more about collecting artifacts <a href=http://g.octopushq.com/Artifacts target=_blank>here</a>. </p> <ul ng-show=artifacts class=file-list> <li ng-repeat=\"artifact in artifacts.Items\" class=\"ext-{{ artifact.Filename | extension }}\"> <a href=\"{{ formatDownload(artifact) }}\">{{ artifact.Filename }}</a> <span class=gray ng-show=artifact.Source>({{ artifact.Source }})</span> </li> </ul> <octo-paginator collection=artifacts></octo-paginator> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 959 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/deployment-listing.html';
	var html = "<div> <p class=tutorial ng-show=!deployments.Items.length> There are no deployments to show. </p> <div class=task-list> <a ng-repeat=\"dep in deployments.Items track by dep.Id\" class=task href=\"#/projects/{{ projects[dep.ProjectId].Slug }}/releases/{{ releases[dep.ReleaseId].Version }}/deployments/{{ dep.Id }}\"> <task-status task=tasks[dep.TaskId] pop-direction=right></task-status> <div class=details> <span class=title><span ng-show=\"prefix == 'release'\">{{ releases[dep.ReleaseId].Version }} &#x21E2; </span>{{ dep.Name }}</span> <span class=date>{{ tasks[dep.TaskId].QueueTime | moment }}</span> </div> </a> </div> <octo-paginator collection=deployments></octo-paginator> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 960 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/edit_parameter_dialog.html';
	var html = "<div class=modal-header> <h3>{{ title }}</h3> </div> <form> <div class=\"modal-body help-scope\"> <error-box error=isSaving.error></error-box> <help-button></help-button> <div class=form-horizontal> <control-group label=\"Variable name\"> <input class=\"input form-control\" type=text ng-model=parameter.Name> <p class=help-block>The name of the variable set by the parameter. The name can contain letters, digits, dashes and periods. Example: <code>ServerName</code>.</p> </control-group> <control-group label=Label> <input class=\"input form-control\" type=text ng-model=parameter.Label> <p class=help-block>The label shown beside the parameter when presented in the deployment process. Example: <em>Server name</em>.</p> </control-group> <control-group label=\"Help text\"> <textarea class=form-control ng-model=parameter.HelpText markitup rows=7></textarea> <p class=help-block>The help presented alongside the parameter input.</p> </control-group> <control-group label=\"Default value\"> <input class=form-control type=text ng-model=parameter.DefaultValue ng-if=\"parameter.DisplaySettings['Octopus.ControlType'] !== 'MultiLineText'\"> <textarea class=form-control type=text ng-model=parameter.DefaultValue ng-if=\"parameter.DisplaySettings['Octopus.ControlType'] === 'MultiLineText'\"> </textarea> <p class=help-block>A default value for the parameter, if applicable.</p> </control-group> <control-group label=\"Control type\"> <select ng-model=\"parameter.DisplaySettings['Octopus.ControlType']\" class=form-control> <option ng-repeat=\"(key, value) in controlTypes\" value={{key}} ng-if=\"invalidStepTypes.indexOf(key) === -1\" ng-selected=\"{{key === parameter.DisplaySettings['Octopus.ControlType'] ? 'true': 'false'}}\">{{value}}</option> </select> <p class=help-block>The type of control to display.</p> </control-group> <div ng-show=\"parameter.DisplaySettings['Octopus.ControlType'] == 'Select'\"> <control-group label=Options> <textarea class=form-control rows=4 ng-model=\"parameter.DisplaySettings['Octopus.SelectOptions']\"></textarea> <p class=\"tutorial no-margin\">Enter each option on a new line. Use | to separate values and display text - e.g.:</p> <pre>Value1|Display text 1\r\nValue2|Display text 2</pre> </control-group> </div> </div> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" ng-click=close() octo-permission={{requiredPermission}} octo-project=\"'{{projectId}}'\" octo-environment=\"'*'\" ng-show=!isLoading.busy>Apply</button> <button class=\"btn btn-default\" ng-click=cancel()>Cancel</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 961 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/event-listing.html';
	var html = "<div> <p class=\"tutorial pad-text\" ng-show=!events.Items.length> No events were found. </p> <div class=\"narrow-left margin-top-bottom-20\" ng-show=events.Items.length> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th>When</th> <th>Who</th> <th>What</th> </tr> </thead> <tbody> <tr ng-repeat=\"e in events.Items\"> <td><span title=\"{{ e.Occurred | moment }}\">{{ e.Occurred | momentAgo }}</span></td> <td>{{ e.Username }}</td> <td ng-bind-html-unsafe=formatMessageHtml(e)></td> </tr> </tbody> </table> <octo-paginator collection=events></octo-paginator> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 962 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/export_entity_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Export</h3> </div> <div class=modal-body> <div id=scriptEditor ui-ace=\"{ mode: 'json' }\" ng-model=entityJson></div> <p class=tutorial>Copy the entire contents of the editor to share this template with other Octopus Deploy servers.</p> </div> <div class=modal-footer> <button class=\"btn btn-default\" ng-click=close()>Close</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 963 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/import_entity_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Import</h3> </div> <div class=modal-body> <error-box error=isSaving.error></error-box> <div id=scriptEditor ui-ace=\"{ mode: 'JSON' }\" ng-model=entityJson></div> <p class=tutorial>Paste the entire exported JSON object.</p> </div> <div class=modal-footer> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" ng-click=save() ng-disabled=!entityJson>Import</button> <button class=\"btn btn-default\" ng-click=close()>Close</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 964 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/interrupt-fields/interrupt_Checkbox.html';
	var html = "<div class=checkbox><label> <input type=checkbox ng-model=element.value ng-true-value=\"'True'\" ng-false-value=\"'False'\" ng-disabled=isDisabled ng-init='element.value = \"false\";'> {{ element.properties.Text }} </label></div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 965 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/interrupt-fields/interrupt_Paragraph.html';
	var html = "<markdown text=element.properties.Text />";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 966 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/interrupt-fields/interrupt_SubmitButtonGroup.html';
	var html = "<div class=submit-button-group> <button class=\"btn btn-default\" ng-repeat=\"bt in element.properties.Buttons\" ng-click=\"submit(element, bt.Value)\" ng-disabled=isDisabled>{{ bt.Text }}</button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 967 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/interrupt-fields/interrupt_TextArea.html';
	var html = "<div class=\"form-group form-group-narrow\"> <label class=\"control-label col-sm-3\" ng-show=element.properties.Label for=\"{{ element.name }}\"> {{ element.properties.Label }} </label> <div class=\"controls col-sm-9\"> <textarea class=form-control rows=4 ng-model=element.value ng-disabled=isDisabled ng-change=changed() id=\"{{ element.name }}\">\r\n          </textarea> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 968 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/interrupt-fields/interrupt_Unknown.html';
	var html = "<div class=\"alert alert-danger\">Unknown field type: {{ element.properties.Type }}</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 969 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/interrupt-fields/interrupt_VariableValue.html';
	var html = "<div> <div class=\"form-group form-group-narrow\" ng-hide=element.properties.IsSecure> <label class=\"control-label col-sm-3\" for=\"{{ element.name }}_unsecure\">{{ element.properties.Label }}</label> <div class=\"controls col-sm-9\"> <textarea class=form-control style=height:40px;min-height:40px ng-model=element.value ng-disabled=isDisabled ng-change=changed() id=\"{{ element.name }}_unsecure\"></textarea> <p class=\"subtle margin-top-5\" ng-show=element.properties.Description>{{ element.properties.Description }}</p> </div> </div> <div class=\"form-group form-group-narrow\" ng-show=element.properties.IsSecure> <label class=\"control-label col-sm-3\" for=\"{{ element.name }}_secure\">{{ element.properties.Label }}</label> <div class=\"controls col-sm-9\"> <input class=form-control type=password ng-model=element.value ng-disabled=isDisabled ng-change=changed() id=\"{{ element.name }}_secure\"> <p class=\"subtle margin-top-5\" ng-show=element.properties.Description>{{ element.properties.Description }}</p> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 970 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/interruption-form.html';
	var html = "<div> <div ng-repeat=\"interruption in interruptionsModel.items track by interruption.original.Id\"> <div class=\"alert alert-warning\" ng-show=interruption.isPending> <div class=pull-right> <a href=\"\" class=padding-xs-hr ng-show=\"interruption.correlationId && correlateLog\" ng-click=correlateLog(interruption.correlationId)> log </a> <a href=\"\" ng-hide=\"interruption.isMine || interruption.isOpen\" ng-click=interruption.toggleOpen()> show details </a> <a href=\"\" ng-show=\"!interruption.isMine && interruption.isOpen\" ng-click=interruption.toggleOpen()> hide details </a> </div> <div class=pull-right> <p ng-show=interruption.isMine>assigned to: <strong>you</strong></p> <p ng-show=interruption.isAssignedToSomeoneElse> assigned to: <user-name user-id=interruption.responsibleUserId></user-name> <span ng-show=interruption.couldBeMine> (<a href=\"\" ng-click=confirmTakeResponsibility(interruption.original)>assign to me</a>) </span> </p> <p ng-show=interruption.isUnassigned> assigned to: <em>no one</em> <span ng-show=interruption.couldBeMine> (<a href=\"\" ng-click=takeResponsibility(interruption.original)>assign to me</a>) </span> </p> </div> <h4 class=text-bold>{{ interruption.title }}</h4> <div ng-show=interruption.isOpen> <div ng-repeat=\"element in interruption.elements track by element.name\"> <interruption-field submit=submit is-disabled=\"!interruption.isMine || isSubmitting\" element=element> </interruption-field> </div> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 971 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/not-found.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li>Not Found</li> </script> <p>Sorry, the page you are looking for could not be found.</p>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 972 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/octo-form.html';
	var html = "<div> <div ng-repeat=\"element in formElements\"> <interruption-field submit=submit is-submitting=isSubmitting is-disabled=isFormDisabled element=element></interruption-field> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 973 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/redirect.html';
	var html = "<div class=container-fluid> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <loading-wrapper busy=isLoading> <error-box error=isLoading.error></error-box> </loading-wrapper> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 974 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/script_editor.html';
	var html = "<div> <div ng-hide=syntaxSelectionDisabled> <label ng-repeat=\"s in syntaxes\" class=radio-inline><input type=radio ng-model=$parent.syntax value={{s.id}}>{{s.display}}</label> </div> <div class=insert-variable ng-if=!noVariables> <insert-variable-button ng-syntax=syntax project-id=projectId insert=insertVariable local-names=localNames rebind=#{{id}}></insert-variable-button> </div> <a href=\"\" class=fullscreen-button octo-full-screen=#{{id}}Container></a> <div id={{id}}Container> <div id={{id}} class=big-on-full ui-ace=\"{ mode: aceMode, onLoad: editorLoaded }\" ng-model=body></div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 975 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/select-machines.html';
	var html = "<div> <ui-select multiple=multiple ng-model=vm.selectedModels theme=bootstrap class=form-control style=\"min-height:36px;padding:3.5px 7px 0 5px\" on-remove=\"vm.onRemoved($item, $model)\" on-select=\"vm.onSelected($item, $model)\"> <ui-select-match placeholder={{vm.placeholder}}> <img alt={{$item.StatusSummary}} title={{$item.StatusSummary}} style=height:1.5em ng-src=\"{{ vm.calculateTargetIcon($item) }}\"/> {{$item.Name}} </ui-select-match> <ui-select-choices repeat=\"item in vm.available | filter:{Name: $select.search} track by item.Id\"> <img alt={{item.StatusSummary}} title={{item.StatusSummary}} style=height:2em ng-src=\"{{ vm.calculateTargetIcon(item) }}\"/> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 976 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/selector/select-multiple.html';
	var html = "<!DOCTYPE html> <html lang=en> <head> <meta charset=UTF-8> <title>Title</title> </head> <body> </body> </html>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 977 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/selector/select-projects.html';
	var html = "<div> <ui-select ng-if=vm.showControl() ng-model=vm.selected ng-change=vm.onChange() search-enabled=true append-to-body=true> <ui-select-match placeholder={{vm.placeholder}} allow-clear=true> {{vm.isMultiple ? $item.Name : $select.selected.Name}} </ui-select-match> <ui-select-choices repeat=\"item.Id as item in vm.available | filter: $select.search\"> <div ng-bind-html=\"item.Name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 978 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/sensitive-input.html';
	var html = "<div class=input-sensitive> <div class=input-group ng-if=!isEditingPassword> <input class=form-control type=password placeholder=\"{{ hasPassword ? '******' : '' }}\" disabled=disabled> <div class=input-group-btn> <a type=button class=\"btn btn-primary\" ng-click=set()>{{ setOrChange }}</a> <a type=button class=\"btn btn-primary\" ng-click=clear() ng-show=hasPassword>Remove</a> </div> </div> <div class=input-group ng-if=isEditingPassword> <input class=form-control type=password ng-model=model.NewValue ng-focus=isEditingPassword> <div class=input-group-btn> <a type=button class=\"btn btn-primary\" ng-click=undo()>Cancel</a> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 979 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/sensitive_file_input.html';
	var html = "<div class=input-sensitive> <div class=\"input-group js-fileapi-wrapper\" ng-show=model.HasValue> <spin active=isProcessing style=position:absolute;z-index:100;left:1em;top:.5em;pointer-events:none></spin> <input class=form-control type=text value={{displayName}} disabled=disabled> <div class=input-group-btn> <div type=button class=\"btn btn-primary\"> <input class=\"form-control uploader\" type=file on-new-content=onNewContent encode-content=true> <div>Change</div> </div> <div type=button class=\"btn btn-primary\" ng-click=remove()> <div>Remove</div> </div> <div type=button class=\"btn btn-primary\" ng-click=cancel() ng-if=canCancel> <div>Cancel</div> </div> </div> </div> <div class=\"input-group js-fileapi-wrapper\" ng-show=!model.HasValue> <spin active=isProcessing style=position:absolute;z-index:100;left:1em;top:.5em;pointer-events:none></spin> <input class=form-control type=text disabled=disabled> <input class=\"form-control uploader\" type=file on-new-content=onNewContent encode-content=true is-processing=isProcessing> <div class=input-group-btn> <div type=button class=\"btn btn-primary\"> <input class=\"form-control uploader\" type=file on-new-content=onNewContent encode-content=true> <div>Set</div> </div> <div type=button class=\"btn btn-primary\" ng-click=cancel() ng-if=canCancel> <div>Cancel</div> </div> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 980 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/user-name.html';
	var html = "<span><span ng-show=isLoading.busy><em class=gray>loading...</em></span><span ng-show=\"displayName && !isLoading.busy\" title=\"{{ username }}\">{{ displayName }}</span><span ng-show=\"nullText && !displayName && !isLoading.busy\">{{ nullText }}</span></span>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 981 */
/***/ function(module, exports) {

	var path = 'areas/shared/views/variable-set-snapshot.html';
	var html = "<div class=variables-snapshot> <spin active=isLoading.busy></spin> <error-box error=isLoading.error></error-box> <table class=\"table table-bordered\"> <thead> <tr><th>Name</th><th>Value</th><th>Scope</th></tr> </thead> <tbody class=smaller-fonts> <tr ng-repeat=\"variable in snapshot.Variables | orderBy:'Name' \"> <td><div ng-class=\"{'limit-width': limitWidth}\" title=\"{{ variable.Name }}\">{{ variable.Name }}</div></td> <td><div ng-class=\"{'limit-width-wrap': limitWidth}\"><span ng-show=variable.IsSensitive>&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;</span>{{ variable.Value }}</div></td> <td><div ng-class=\"{'limit-width': limitWidth}\" title=\"{{ formatScope(variable.Id, variable.Scope, scopeValues) }}\">{{ formatScope(variable.Id, variable.Scope, scopeValues) }}</div></td> </tr> </tbody> </table> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 982 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/index.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/tasks\">Tasks</a></li> </script> <script octo-section=tools type=text/ng-template> <spin active='isLoading.busy'></spin>\r\n    <a class=\"btn btn-link\" octo-permission=\"AdministerSystem\" href=\"#/manage/console\">Script Console</a> </script> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <error-box error=isLoading.error></error-box> <loading-wrapper busy=isLoading once=true> <div class=task-list> <form class=\"row form grid-gutter-margin-b\"> <div class=col-xs-3 octo-permission=ProjectView wildcard> <select-projects available=projects ng-model=filter.projectId ng-change=refresh() allow-clear=true></select-projects> </div> <div class=col-xs-3> <select-environments available=environments ng-model=filter.environmentId ng-change=refresh() allow-clear=true></select-environments> </div> <div class=col-xs-3> <ui-select ng-model=filter.name theme=select2 ng-change=refresh() append-to-body=true> <ui-select-match placeholder=\"Any Task Type\" allow-clear=true>{{$select.selected}} </ui-select-match> <ui-select-choices repeat=\"item in taskTypes | filter:$select.search | orderBy: 'toString()'\"> <span ng-bind-html=\"item | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> <div class=col-xs-3> <select-custom placeholder=\"'Any Server Node'\" available=nodes ng-model=filter.nodeId ng-change=refresh() allow-clear=true> </select-custom> </div> </form> <h3 ng-show=\"activeTasks.Items.length > 0\">Active</h3> <a class=task href=\"#/tasks/{{ task.Id }}\" ng-repeat=\"task in activeTasks.Items\"> <task-status task=task pop-direction=right></task-status> <div class=details> <span class=title>{{task.Description}}</span> <span class=date>{{ task.QueueTime | moment }}</span> </div> </a> <octo-paginator collection=activeTasks page-selected=loadActivePage></octo-paginator> <h3 ng-show=\"activeTasks.Items.length > 0\">Recent</h3> <div class=\"tutorial tutorial-center\" ng-hide=\"tasks.Items.length > 0\" style=min-height:200px> <p>The task list shows what the Octopus server is doing, and lets you examine the output from recent tasks like backups, deployments and upgrades. Nothing's happening right now, so there are no items to show in this view.</p> </div> <a class=task href=\"#/tasks/{{ task.Id }}\" ng-repeat=\"task in tasks.Items track by task.Id\"> <task-status task=task pop-direction=right></task-status> <div class=details> <span class=title>{{task.Description}}</span> <span class=date>{{ task.QueueTime | moment }}</span> </div> </a> <octo-paginator collection=tasks page-selected=loadRecentPage></octo-paginator> </div> </loading-wrapper> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 983 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/log-tab.html';
	var html = "<div class=container-fluid> <div class=row> <div> <span class=text-light-gray ng-show=!task.HasBeenPickedUpByProcessor>{{ task.QueueTime.isAfter(moment()) ? \"This task was queued\" : \"This task has been queued to run\" }} <span title=\"{{ task.QueueTime | moment }}\">{{ task.QueueTime | momentAgo }}</span></span> <span class=text-light-gray ng-show=\"task.HasBeenPickedUpByProcessor && task.IsCompleted\">This task started <span title=\"{{ task.StartTime | moment }}\">{{ (task.StartTime || task.QueueTime) | momentAgo }}</span> and ran for {{ task.Duration }}</span> <span class=text-light-gray ng-hide=\"!task.HasBeenPickedUpByProcessor || task.IsCompleted\">This task started <span title=\"{{ task.StartTime | moment }}\">{{ (task.StartTime || task.QueueTime) | momentAgo }}</span><span ng-show=progress.EstimatedTimeRemaining> and {{ progress.EstimatedTimeRemaining }}</span></span> <span class=\"pull-right text-right\"> <span class=expand-mode-selector> Expand: <a href ng-click=\"setExpanderMode('All')\" ng-class=\"{ current: expanderMode == 'All' }\">All</a> | <a href ng-click=\"setExpanderMode('Interesting')\" ng-class=\"{ current: expanderMode == 'Interesting' }\">Interesting</a> | <a href ng-click=\"setExpanderMode('Errors')\" ng-class=\"{ current: expanderMode == 'Errors' }\">Errors</a> | <a href ng-click=\"setExpanderMode('None')\" ng-class=\"{ current: expanderMode == 'None' }\">None</a> </span> <a class=\"btn btn-link btn-default\" href ng-hide=isVerbose ng-click=showVerbose()>Verbose</a> <a class=\"btn btn-link btn-default\" href=\"#/tasks/{{ task.Id }}/raw\">Raw</a> </span> </div> </div> <div class=\"\" ng-repeat=\"rootNode in rootNodes\"> <div class=row> <div class=activity-log ng-show=\"rootNode.children.length || rootNode.name\"> <activity-element-summary element=rootNode go-to-log=goToLog mode=details toggle-gap=toggleGap></activity-element-summary> </div> <p ng-hide=\"rootNode.children.length || rootNode.name\">The task has not written any information to the log yet.</p> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 984 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/log_line.html';
	var html = "<div class=log-line ng-class=\"[event.Category, {'full-date': fullDate }]\"> <div class=log-time title=\"{{ event.OccurredAt | moment }}\"> {{ event.OccurredAt | moment:dateFormat }} </div> <div class=log-category>{{ event.Category }}</div> <div class=log-message>{{ detail =='true' ? detailedMessage : summaryMessage }}</div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 985 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/script-tab.html';
	var html = "<div class=row> <div class=col-sm-12> <div ng-if=!task.Arguments.ActionTemplateId> <p class=\"gray pad-text\">The task ran the script shown below.</p> </div> <div ng-if=task.Arguments.ActionTemplateId> <p>This task ran the <strong>{{ task.Arguments.ActionTemplateName }}</strong> step template, version <strong>{{ task.Arguments.ActionTemplateVersion }}</strong></p> <h4 class=separator>Parameters</h4> <pre>{{ task.Arguments.Properties | json }}</pre> <h4 class=separator>Script</h4> </div> <div> <a class=fullscreen-button href octo-full-screen=#scriptEditorContainer></a> <div id=scriptEditorContainer> <div class=big-on-full id=scriptEditor ui-ace=\"{ mode: 'powershell' }\" readonly=true ng-model=task.Arguments.ScriptBody></div> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 986 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/summary-tab.html';
	var html = " <div class=row> <div class=col-sm-8> <error-box error=isLoadingInterrupts.error></error-box> <div> <interruption-form ng-if=!task.IsCompleted is-loading=isLoading.busy is-submitting=isSubmittingInterruption.busy take-responsibility=takeResponsibility submitted=submitInterruption interruptions=interruptions.Items correlate-log=goToLogById></interruption-form> </div> <h3>Task progress</h3> <loading-wrapper busy=isLoading once=true> <div class=margin-top-bottom-10> <div ng-if=!task.HasBeenPickedUpByProcessor> <span class=text-light-gray>{{ task.QueueTime.isAfter(moment()) ? \"This task was queued\" : \"This task has been queued to run\" }} <span title=\"{{ task.QueueTime | moment }}\">{{ task.QueueTime | momentAgo }}.</span></span> <span class=text-light-gray ng-show=task.QueueTimeExpiry>The task must begin execution within <span title=\"{{ task.QueueTimeExpiry | moment }}\">{{ task.QueueTimeExpiry | momentFrom: task.QueueTime }}</span> of the scheduled start time.</span> </div> <div ng-if=task.HasBeenPickedUpByProcessor> <div ng-if=task.IsCompleted ng-switch=task.State> <span ng-switch-when=TimedOut class=text-light-gray>The task was scheduled to run <span title=\"{{ task.QueueTime | moment }}\">{{ task.QueueTime | momentAgo }}</span> with an expiry of <span title=\"task.QueueTimeExpiry | moment\">{{ task.QueueTimeExpiry | momentFrom: task.QueueTime }}</span> but the Octopus Server attempted to run the task <span title=\"{{ task.LastUpdatedTime | moment }}\">{{ task.LastUpdatedTime | momentFrom: task.QueueTime }} after the scheduled time.</span></span> <span ng-switch-default class=text-light-gray>This task started <span title=\"{{ task.StartTime | moment }}\">{{ (task.StartTime || task.QueueTime) | momentAgo }}</span> and ran for {{ task.Duration }}</span> </div> <span class=text-light-gray ng-show=!task.IsCompleted>This task started <span title=\"{{ task.StartTime | moment }}\">{{ (task.StartTime || task.QueueTime) | momentAgo }}</span><span ng-show=progress.EstimatedTimeRemaining> and {{ progress.EstimatedTimeRemaining }}</span></span> </div> </div> <div ng-show=!task.HasBeenPickedUpByProcessor> <loading-wrapper busy=isLoadingQueue once=true> <div class=task-list> <div class=\"gray pad-text\" ng-show=\"behind.length > 0\"> <p>Waiting for the following {{ behind.length > 1 ? \"tasks\" : \"task\" }} to complete:</p> </div> <div ng-repeat=\"t in behind.Items\"> <a class=task href=\"#/tasks/{{ t.Id }}\"> <task-status task=t pop-direction=right></task-status> <div class=details> <span class=title>{{t.Description}}</span> <span class=date>{{ t.QueueTime | moment }}</span> </div> </a> </div> <octo-paginator collection=behind page-selected=pageQueuedTasks></octo-paginator> </div> </loading-wrapper> </div> <div class=\"activity-log summary\" octo-project=permScope.projectId octo-environment=permScope.environmentId> <div class=\"\" ng-repeat=\"rootNode in rootNodes\"> <activity-element-summary element=rootNode go-to-log=goToLog mode=summary></activity-element-summary> </div> </div> <div class=\"alert alert-info\" ng-show=\"details.PhysicalLogSize > 31457280\"> <octo-clippy> <p class=strong> This log takes up <strong>{{ details.PhysicalLogSize | bytesToSize }}</strong> on the Octopus Deploy server. Large log files can take a long time to render; we recommend keeping logs under 20 MB when possible. If you need detailed log output from commands run on remote deployment targets, consider writing them to a file and attaching the file as an artifact instead. <a href=http://g.octopushq.com/LargeLogs target=_blank>Learn more about dealing with large logs</a>. </p> </octo-clippy> </div> </loading-wrapper> </div> <div class=col-sm-4> <div ng-show=\"task.Name == 'SystemIntegrityCheck'\"> <h3>About</h3> For more information about Check System Integrity tasks, see our <a href=http://g.octopushq.com/SystemIntegrityCheck target=_blank>documentation</a>. </div> <div octo-permission=ArtifactView octo-project=permScope.projectId octo-environment=permScope.environmentId> <h3>Artifacts</h3> <loading-wrapper busy=isLoadingArtifacts once=true> <div class=margin-top-bottom-10> <error-box error=isLoadingArtifacts.error></error-box> <artifact-listing artifacts=artifacts></artifact-listing> </div> </loading-wrapper> </div> <div octo-permission=EventView octo-project=permScope.projectId octo-environment=permScope.environmentId> <h3>History</h3> <loading-wrapper busy=isLoadingEvents once=true> <div class=margin-top-bottom-10> <error-box error=isLoadingEvents.error></error-box> <event-listing events=events></event-listing> </div> </loading-wrapper> </div> <div ng-show=appContext.deployment> <h3>Environment</h3> <loading-wrapper busy=isLoadingPrevious once=true> <div class=margin-top-bottom-10> <error-box error=isLoadingPrevious.error></error-box> <deployment-listing deployments=previous prefix=release></deployment-listing> </div> </loading-wrapper> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 987 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/task-raw.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <ul class='breadcrumb' ng-show=\"task\">\r\n    <li><a href=\"#/tasks\">Tasks</a></li>\r\n    <li ng-show=\"task\">\r\n      <task-status task='task' pop-direction=\"right\" style=\"margin-top: -12px\"></task-status>\r\n      <a href='#/tasks/{{ task.Id }}'>{{ task.Description }}</a>\r\n    </li>\r\n    <li><a href='#/tasks/{{ task.Id }}/raw'>Raw log</a></li>\r\n  </ul> </script> <script octo-section=tools type=text/ng-template> <spin active='isLoading.busy'></spin>\r\n  <a href=\"{{ rawDownloadLink }}\"  class=\"btn\" ng-disabled=\"isLoading.busy\"><i class=\"icon-download\"></i> Download</a>\r\n  <a href=\"\" ng-click=\"refresh()\" class=\"btn btn-primary\" ng-disabled=\"isLoading.busy\">Refresh</a> </script> <div class=container-fluid> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <error-box error=isLoading.error></error-box> <div class=box-noshadow> <pre class=nowrap>{{ rawLog }}</pre> </div> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 988 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/task-status.html';
	var html = "<span class=status uib-popover={{vm.tip}} popover-title={{vm.title}} popover-trigger=mouseenter popover-placement={{vm.popDirection}} popover-class=task-status ng-class=\"[vm.stateClass,  {'status-previous': vm.previous, 'status-archive': vm.archive}]\"> <i class=fa ng-class=\"[vm.icon, {'fa-spin': vm.isSpinning }]\"></i> <span class=status-overlay ng-if=vm.isAlert><i class=\"fa fa-exclamation-triangle\"></i></span> </span> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 989 */
/***/ function(module, exports) {

	var path = 'areas/tasks/views/task.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-if=\"!appContext.deployment\"><a href=\"#/tasks\">Tasks</a></li>\r\n        <li ng-if=\"!appContext.deployment\">\r\n            <task-status task='task' pop-direction=\"right\" style=\"margin-top: -12px\"></task-status>\r\n            <a href='#/tasks/{{ task.Id }}'>{{ task.Description }}</a>\r\n        </li>\r\n\r\n        <li ng-if=\"appContext.deployment\">\r\n            <a href='#/projects/{{ appContext.project.Slug }}/releases/{{ appContext.release.Version }}'>{{ appContext.release.Version }}</a>\r\n            <channel-label project=\"appContext.project\" channel-id=\"appContext.release.ChannelId\" ng-if=\"appContext.project && appContext.release.ChannelId\" ></channel-label>\r\n        </li>\r\n        <li ng-if=\"appContext.deployment\">\r\n            <task-status task='task' pop-direction=\"right\"  style=\"margin-top: -12px\"></task-status>\r\n            <a href='#/projects/{{ appContext.project.Slug }}/releases/{{ appContext.release.Version }}/deployments/{{ appContext.deployment.Id }}'>\r\n                {{ appContext.deployment.Name }}\r\n            </a>\r\n        </li> </script> <script octo-section=tools type=text/ng-template> <spin active='isLoading.busy || isLoadingInterrupts.busy || isLoadingEvents.busy'></spin>\r\n    <spin active='isSubmitting.busy'></spin>\r\n    <button type=\"button\" class=\"btn btn-success\" ng-click=\"rerun()\"\r\n            octo-permission=\"TaskCreate\" octo-project=\"permScope.projectId\" octo-environment=\"permScope.environmentId\"\r\n            ng-show=\"task && task.CanRerun && task.IsCompleted && task.FinishedSuccessfully && task.Name != 'AdHocScript'\"\r\n            ng-disabled=\"isSubmitting.busy\">Re-run\r\n    </button>\r\n    <button type=\"button\" class=\"btn btn-success\" ng-click=\"rerun()\"\r\n            octo-permission=\"TaskCreate\" octo-project=\"permScope.projectId\" octo-environment=\"permScope.environmentId\"\r\n            ng-show=\"task && task.CanRerun && task.IsCompleted && !task.FinishedSuccessfully && task.Name != 'AdHocScript'\"\r\n            ng-disabled=\"isSubmitting.busy\">Try again\r\n    </button>\r\n    <a class=\"btn btn-success\"\r\n       href=\"#/projects/{{ appContext.project.Slug }}/releases/{{ appContext.release.Version }}/deployments/create/try-again/{{appContext.deployment.Id}}\"\r\n       octo-permission=\"DeploymentCreate\"\r\n       octo-project=\"permScope.projectId\"\r\n       octo-environment=\"permScope.environmentId\"\r\n       ng-show=\"appContext.deployment && task && task.IsCompleted && !task.FinishedSuccessfully\">\r\n        Try again\r\n    </a>\r\n    <a class=\"btn btn-success\"\r\n       href=\"#/manage/console?retry={{task.Id}}\"\r\n       octo-permission=\"AdministerSystem\"\r\n       ng-show=\"task && task.IsCompleted && task.Name == 'AdHocScript' && !task.Arguments.ActionTemplateId\">\r\n        Modify and re-run\r\n    </a>\r\n    <a class=\"btn btn-success\"\r\n       href=\"#/library/steptemplates/{{ task.Arguments.ActionTemplateId }}/run?retry={{task.Id}}\"\r\n       octo-permission=\"AdministerSystem\"\r\n       ng-show=\"task && task.IsCompleted && task.Name == 'AdHocScript' && task.Arguments.ActionTemplateId\">\r\n        Modify and re-run\r\n    </a>\r\n    <button type=\"button\"\r\n            class=\"btn btn-warning\"\r\n            ng-click=\"cancel()\"\r\n            octo-permission=\"TaskCancel\"\r\n            octo-project=\"permScope.projectId\"\r\n            octo-environment=\"permScope.environmentId\"\r\n            ng-hide=\"!task || task.IsCompleted\"\r\n            ng-disabled=\"isSubmitting.busy\">Cancel\r\n    </button>\r\n\r\n    <span ng-show=\"appContext.deployment && task.FinishedSuccessfully\">\r\n    <deploy-buttons project=\"appContext.project\"\r\n                    release=\"appContext.release\"\r\n                    lifecycle=\"appContext.lifecycle\"\r\n                    environments=\"appContext.environments\"\r\n                    progression=\"appContext.progression\"></deploy-buttons>\r\n  </span> </script> <error-box error=isLoading.error></error-box> <error-box error=isSubmitting.error></error-box> <error-box error=isSubmittingInterruption.error></error-box> <div class=\"progress progress-striped\" ng-hide=\"!task || task.IsCompleted || !progress.ProgressPercentage\" ng-class=\"{'progress-danger': task.State == 'Failed', 'progress-success': task.State == 'Success', active: !task.IsCompleted}\"> <div class=progress-bar style=width:{};></div> </div> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: tab == 'summary'}\"> <a href ng-click=\"changeTab('summary')\"> Task summary <span ng-repeat=\"interruption in interruptions.Items\" ng-if=!task.IsCompleted> <span class=\"badge badge-warning compact\" ng-show=\"interruption.IsPending && $first\">!</span> </span> </a> </li> <li ng-class=\"{active: tab == 'log'}\" octo-permission=TaskViewLog octo-project=permScope.projectId octo-environment=permScope.environmentId> <a href ng-click=\"changeTab('log')\">Task log</a> </li> <li ng-show=\"task.Name == 'AdHocScript'\" ng-class=\"{active: tab == 'script'}\" octo-permission=TaskViewLog octo-project=permScope.projectId octo-environment=permScope.environmentId> <a href ng-click=\"changeTab('script')\"> <span ng-if=task.Arguments.ActionTemplateId>Template Parameters</span> <span ng-if=!task.Arguments.ActionTemplateId>Script body</span> </a> </li> </ul> <div class=tab-content> <div class=tab-pane ng-class=\"{active: tab == 'summary'}\" ng-include=\"'areas/tasks/views/summary-tab.html'\"></div> <div class=tab-pane ng-class=\"{active: tab == 'log'}\" ng-include=\"'areas/tasks/views/log-tab.html'\"></div> <div class=tab-pane ng-class=\"{active: tab == 'script'}\" ng-include=\"'areas/tasks/views/script-tab.html'\"></div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 990 */
/***/ function(module, exports) {

	var path = 'areas/tenants/advanced_tenant_selector/advanced_tenant_selector.html';
	var html = "<div> <div octo-feature=IsMultiTenancyEnabled ng-class=\"{'with-border': !vm.applyBorder}\" class=advanced-selector> <control-group label=Tenants ng-if=!vm.hideTenants> <select-tenants available=vm.getAvailableTenants() ng-model=vm.selectedTenants multiple=multiple></select-tenants> </control-group> <div ng-repeat=\"tagSet in vm.availableTagSets\"> <control-group label={{tagSet.Name}}> <select-tags multiple=multiple available=tagSet.Tags ng-model=vm.selectedTags filter-tags-by-tagset={{tagSet.Name}} filter-tags-by-tagset-all=availableTagSets></select-tags> </control-group> </div> <div ng-if=vm.showEmptyMessage() class=margin-bottom-10> <div class=\"text-muted text-center\">Create a <a href=#/library/tagsets>tenant tag set</a> to select tenants using tags.</div> </div> <control-group ng-if=!vm.showEmptyMessage()> <div class=match-count ng-if=vm.matchingTenantText><abbr title={{vm.matchingTenantDescription}}>{{vm.matchingTenantText}}</abbr></div> <div class=text-center> <a href=\"\" style=display:block ng-click=vm.openTagDesigner()>Design/Preview</a> </div> </control-group> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 991 */
/***/ function(module, exports) {

	var path = 'areas/tenants/advanced_tenant_selector/design_selected_tags_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=vm.close()>×</button> <h3>Design tenant filter</h3> </div> <div class=\"modal-body tenant-tags-designer\"> <script type=text/ng-template id=myPopoverTemplate.html> <div>\r\n            <div ng-if=\"tenant.reason === 'Missing Tags'\">\r\n                <div style=\"text-align: center\">Missing Tags</div>\r\n                <missing-tag-list tag-list=\"tenant.missingTags\" tags-all=\"vm.tagSets\"></missing-tag-list>\r\n            </div>\r\n            <div ng-if=\"tenant.reason !== 'Missing Tags'\">\r\n                <div style=\"text-align: center\">{{tenant.reason}}</div>\r\n            </div>\r\n        </div> </script> <div ng-if=!vm.hideTenants> <h4 class=no-margin-vr>Include tenants by name</h4> <select-tenants class=padding-sm-vr available=vm.availableTenants ng-model=vm.selectedTenants ng-change=vm.tagsUpdated() multiple=multiple></select-tenants> </div> <h4>Include tenants by tags</h4> <div class=\"form-box form-horizontal\"> <div ng-repeat=\"tagSet in vm.tagSets\"> <control-group label={{tagSet.Name}}> <select-tags multiple=multiple available=tagSet.Tags ng-model=vm.selectedTags filter-tags-by-tagset={{tagSet.Name}} filter-tags-by-tagset-all=tagSets ng-change=vm.tagsUpdated()></select-tags> </control-group> </div> </div> <h4 class=pull-left>Preview - {{vm.matchedTenantText}}</h4> <span class=pull-right> <search-box input-text=vm.searchText placeholder=\"Filter results...\" auto-focus=false /> </span> <div class=\"checkbox pull-right clear-both\"> <label><input type=checkbox ng-model=vm.onlyShowMatching /> Only show matching tenants</label> </div> <div class=\"clear-both tenant-tag-results\"> <div ng-repeat=\"tenant in vm.matchedTenants | filter: vm.tenantFilter | filter: {name: vm.searchText}\" class=tenant-matches ng-class=\"{'textMuted': !tenant.isMatched}\"> <i class=\"fa fa-check match-success\"></i> {{tenant.name}} <div class=pull-right> <applied-tags-list ng-model=tenant.matchedTags ng-if=\"tenant.isMatched && !tenant.isMatchedByName\"></applied-tags-list> <i class=\"fa fa-info-circle tenant-status\" ng-if=!tenant.isMatched uib-popover-template=\"'myPopoverTemplate.html'\" popover-trigger=mouseenter></i> </div> <div class=clear-both></div> </div> </div> </div> <div class=modal-footer> <button class=\"btn btn-success\" type=submit ng-click=vm.save()>OK</button> <button class=\"btn btn-default\" type=button ng-click=vm.close()>Cancel</button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 992 */
/***/ function(module, exports) {

	var path = 'areas/tenants/variables/tenant_variables_library.html';
	var html = " <script octo-section=tenant_tools type=text/ng-template> <button class=\"btn btn-success\"\r\n            ng-disabled=\"vm.isSaving.busy\"\r\n            ng-show=\"unsavedChanges.hasUnsavedChanges()\"\r\n            ng-click=\"vm.save()\">Save\r\n    </button> </script> <form name=tenantForm ng-submit=vm.save() class=\"form-box form-horizontal\" track-unsaved-changes> <h3>Common Variables</h3> <div class=\"alert alert-info\" ng-if=!vm.hasLibraryTemplates>{{vm.tenant.Name || 'The tenant'}} is not connected to any projects which include library variable templates. You can connect {{vm.tenant.Name || 'the tenant'}} to a project on the <a class=alert-link href=#tenants/{{vm.tenant.Id}}>overview tab</a>, create a variable set in the <a class=alert-link href=#library/variables>library</a> or read our <a class=alert-link href=http://g.octopushq.com/MultiTenantVariables target=_blank>guide on working with tenant-specific variables</a> for more information. </div> <p ng-if=vm.hasLibraryTemplates> These values are required because {{vm.tenant.Name || 'the tenant'}} is connected to a project which includes some library variable templates. These are like custom fields for your tenant. </p> <div class=row ng-repeat=\"libraryTemplateDetail in vm.libraryTemplateDetails | filter:vm.isLibraryFiltered | orderBy:'template.Name'\"> <div class=col-lg-9> <div class=\"panel panel-default\"> <div class=panel-heading> <a octo-permission=VariableView class=pull-right ng-href=#library/variables/{{libraryTemplateDetail.id}}>Go to templates</a> <h4 class=panel-title>{{libraryTemplateDetail.name}}</h4> </div> <div class=\"panel-body text-center\" ng-if=\"libraryTemplateDetail.templates.length <= 0\"> There are no variable templates defined for {{libraryTemplateDetail.name}} yet. <span octo-permission=VariableView><a octo-permission=VariableView class=pull-right ng-href=#library/variables/{{libraryTemplateDetail.id}}>Create a variable template</a>.</span> </div> <div ng-if=\"libraryTemplateDetail.templates.length > 0\" class=panel-body> <div ng-repeat=\"template in libraryTemplateDetail.templates\"> <control-group label=\"{{ template.Label || template.Name }}\"> <bound-field local-names=libraryTemplateDetail.localNames reset-value=template.DefaultValue model=libraryTemplateDetail.Properties[template.Id] parameter=template> <div style=position:relative> <i class=\"fa fa-warning text-warning\" style=position:absolute;right:-1.5em;padding-top:.75em uib-tooltip=\"A value is required for this variable.\" ng-if=template.isMissingValue></i> <action-template-field ng-model=libraryTemplateDetail.Properties[template.Id] select-options=\"{ AzureAccount: vm.allAccounts }\" parameter=template></action-template-field> </div> </bound-field> <div class=help-block ng-show=template.HelpText> <markdown text=template.HelpText></markdown> </div> </control-group> </div> </div> </div> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 993 */
/***/ function(module, exports) {

	var path = 'areas/tenants/variables/tenant_variables_projects.html';
	var html = " <script octo-section=tenant_tools type=text/ng-template> <button class=\"btn btn-success\"\r\n            ng-disabled=\"vm.isSaving.busy\"\r\n            ng-show=\"unsavedChanges.hasUnsavedChanges()\"\r\n            ng-click=\"vm.save()\">Save\r\n    </button> </script> <form name=tenantForm ng-submit=vm.save() class=\"form-box form-horizontal\" track-unsaved-changes> <h3 class=no-margin-top>Project Variables</h3> <div class=\"alert alert-info\" ng-if=!vm.hasProjectTemplates>{{vm.tenant.Name || 'The tenant'}} is not connected to any projects defining variable templates. You can connect {{vm.tenant.Name || 'the tenant'}} to a project on the <a class=alert-link href=#tenants/{{vm.tenant.Id}}>overview tab</a>, create some variable templates in one of the connected projects, or read our <a class=alert-link href=http://g.octopushq.com/MultiTenantVariables target=_blank>guide on working with tenant-specific variables</a> for more information. </div> <p ng-if=vm.hasProjectTemplates>These values are required because {{vm.tenant.Name || 'the tenant'}} is connected to a project which defines some variable templates.</p> <div ng-if=vm.hasProjectTemplates> <control-group label=\"Select project\" ng-if=\"vm.tenantProjects.length > 1\"> <select-projects no-dirty-check available=vm.tenantProjects ng-model=vm.filteredProjectId ng-change=vm.refreshTenantVariables() allow-clear=true placeholder=\"'All projects'\"> </select-projects> </control-group> </div> <div class=row ng-if=vm.hasProjectTemplates ng-repeat=\"variableTemplateDetail in vm.projectTemplateDetails | filter:vm.isProjectFiltered | orderBy:'project.Name'\"> <div class=col-md-9 ng-class=\"{'col-lg-6': variableTemplateDetail.templatesByEnvironment.length > 1}\" ng-repeat=\"environmentTemplateSet in variableTemplateDetail.templatesByEnvironment | orderBy:'environment.SortOrder'\"> <div class=\"panel panel-default\"> <div class=panel-heading> <div class=media> <div class=\"media-left media-middle\"> <div class=media-object> <project-logo project=variableTemplateDetail.project max-size=37px></project-logo> </div> </div> <div class=\"media-body media-middle\"> <a octo-permission=VariableView octo-project=variableTemplateDetail.project.Id class=pull-right ng-href=#projects/{{variableTemplateDetail.project.Id}}/variables/projectvariabletemplates>Go to templates</a> <h4 class=panel-title>{{variableTemplateDetail.project.Name}} - {{environmentTemplateSet.environment.Name}}</h4> </div> </div> </div> <div class=\"panel-body text-center\" ng-if=\"environmentTemplateSet.templates.length <= 0\"> There are no variable templates defined for {{variableTemplateDetail.project.Name}} yet. <span octo-permission=VariableView octo-project=variableTemplateDetail.project.Id><a ng-href=#projects/{{variableTemplateDetail.project.Id}}/variables/projectvariabletemplates>Create a variable template</a>.</span> </div> <div ng-if=\"environmentTemplateSet.templates.length > 0\" class=panel-body> <div ng-repeat=\"template in environmentTemplateSet.templates\"> <control-group label=\"{{ template.Label || template.Name }}\"> <bound-field model=template.value reset-value=template.value project-id=variableTemplateDetail.project.Id project-environments-filter=variableTemplateDetail.environmentIds parameter=template> <div style=position:relative> <i class=\"fa fa-warning text-warning\" style=position:absolute;right:-1.5em;padding-top:.75em uib-tooltip=\"A value is required for this variable.\" ng-if=template.isMissingValue></i> <action-template-field ng-model=template.value select-options=template.selectOptions parameter=template></action-template-field> </div> </bound-field> </control-group> </div> </div> </div> </div> <div class=col-md-9> <div class=\"panel panel-warning\" ng-if=\"variableTemplateDetail.environmentIds.length === 0\"> <div class=panel-heading> <div class=media> <div class=\"media-left media-middle\"> <div class=media-object> <project-logo project=variableTemplateDetail.project max-size=37px></project-logo> </div> </div> <div class=\"media-body media-middle\"> <a octo-permission=VariableView octo-project=variableTemplateDetail.project.Id class=pull-right ng-href=#projects/{{variableTemplateDetail.project.Id}}/variables/projectvariabletemplates>Go to templates</a> <h4 class=panel-title>{{variableTemplateDetail.project.Name}}</h4> </div> </div> </div> <div class=\"panel-body text-center\"> There are currently no environments set up for this tenant on this project. Please go to the <a href=\"#/tenants/{{ vm.tenant.Id }}\" class=alert-link target=_blank>overview</a> page and include an environment. </div> </div> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 994 */
/***/ function(module, exports) {

	var path = 'areas/tenants/variables/tenant_variables_tab.html';
	var html = "<div> <script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/tenants/{{ vm.tenantId }}/variables\">Variables</a></li> </script> <div> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: $root.layout.variableTab == 'library'}\" octo-permission=LibraryVariableSetView> <a href=\"#/tenants/{{ vm.tenantId }}/variables/library\">Common Variables &nbsp;<i class=\"fa fa-warning text-warning\" ng-if=vm.tenantState.missingVariables.isMissingLibraryVariable uib-tooltip=\"Some of the required variable values have not been set.\"></i></a></li> <li ng-class=\"{active: $root.layout.variableTab == 'projects'}\"> <a href=\"#/tenants/{{ vm.tenantId }}/variables/projects\">Project Variables &nbsp;<i class=\"fa fa-warning text-warning\" ng-if=vm.tenantState.missingVariables.isMissingProjectVariable uib-tooltip=\"Some of the required variable values have not been set.\"></i></a></li> </ul> </div> <error-box error=vm.isSaving.error></error-box> <div class=\"tabbable tabs-top\"> <div class=\"tab-content pills-content\"> <loading-wrapper busy=vm.isSaving> <loading-wrapper busy=vm.isLoading> <div class=\"alert alert-warning\" ng-if=vm.showMissingVariablesMessage()>Some of the required variable values have not been set.<br/>You should complete the set of required variables otherwise deployments for this tenant are likely to fail.</div> <ui-view></ui-view> </loading-wrapper> </loading-wrapper> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 995 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/change_logo.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/tenants/{{ vm.tenant.Id }}/logo\">Logo</a></li> </script> <script octo-section=tenant_tools type=text/ng-template> </script> <div class=row> <div class=col-sm-12> <div class=\"form-box form-horizontal\"> <h3>Tenant logo</h3> <div class=\"narrow650 narrow-left\"> <form class=\"form form-horizontal\" name=logoUpload> <error-box error=vm.isUploading.error></error-box> <control-group label=Current> <tenant-logo tenant=vm.tenant max-size=250px></tenant-logo> </control-group> <control-group label=\"Image file\"> <div class=\"input-group js-fileapi-wrapper\"> <input class=form-control type=text disabled=disabled value={{vm.octoUpload.selectedFile}}> <input class=\"form-control uploader\" type=file nv-file-select uploader=vm.octoUpload.uploader ng-disabled=vm.isUploading.busy> <div class=input-group-btn> <div type=button class=\"btn btn-primary\" ng-disabled=vm.isUploading.busy> <input class=\"form-control uploader\" type=file nv-file-select uploader=vm.octoUpload.uploader ng-disabled=vm.isUploading.busy> <div>Choose File</div> </div> <div type=button class=\"btn btn-primary\" ng-click=vm.cancel(); ng-disabled=vm.isUploading.busy> <div>Cancel</div> </div> </div> </div> <p class=help-block>Select a logo or image to use for the tenant. The recommended image size is 50x50 pixels or 80x50 pixels. The recommended format is PNG with transparency, though any browser-viewable image format will work.</p> </control-group> <div class=form-actions> <spin active=vm.isUploading.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=\"vm.isUploading.busy ||  !vm.octoUpload.uploader.queue.length\" ng-click=vm.beginUpload()>Upload </button> <button class=\"btn btn-warning delete-button\" type=submit ng-disabled=vm.isUploading.busy ng-click=vm.beginReset()>Use default </button> </div> </form> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 996 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/create.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/tenants\">Tenants</a></li>\r\n    <li><a href='#/tenants/new'>Create New</a></li> </script> <div class=row> <div class=col-sm-12> <div class=\"form-box form-horizontal\"> <form ng-submit=vm.save() name=tenantForm track-unsaved-changes track-after=1000> <h3 class=no-margin-top ng-cloak>Create a tenant</h3> <div class=form-body> <error-box error=vm.isSaving.error></error-box> <control-group label=Name> <input type=text class=form-control id=Name placeholder=\"Tenant Name\" ng-model=vm.tenant.Name /> </control-group> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=vm.isSaving.busy>Save</button> <spin active=vm.isSaving.busy class=spin-static></spin> </div> </form> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 997 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/index.html';
	var html = "<script octo-section=tools type=text/ng-template> <spin active='vm.isLoading.busy'></spin>\r\n    <a class='btn' ng-show=\"vm.tenantsList.length >= 0 || vm.isFiltered\"\r\n       ng-class=\"{'btn-success': vm.tenantsList.length === 0 && !vm.isFiltered && !vm.isLoading.busy, 'btn-link': vm.tenantsList.length > 0 || (vm.tenantsList.length === 0 && vm.isFiltered) || (vm.tenantsList.length == 0 && vm.isLoading.busy)}\"\r\n       href=\"#/tenants/new\">Add tenant</a> </script> <div class=tenants> <div class=row ng-if=\"vm.tenantsList.length > 0 || vm.isFiltered\" ng-cloak> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <div class=pull-left> <form class=\"form-inline margin-bottom-15\" novalidate ng-submit=vm.searchTenantsByName()> <label class=search-box> <i class=\"fa fa-search clickable\" ng-click=vm.searchTenantsByName()></i> <input class=form-control type=text ng-model=vm.searchText placeholder=\"Search by name\"> </label> <label ng-if=\"vm.isFiltered || vm.searchApplied\">Filtered by <span class=\"label search-label\" ng-if=vm.searchApplied>Search '{{vm.searchApplied}}' <span class=\"fa fa-remove clickable\" ng-click=vm.clearSearch()></span></span> <span class=\"label label-info\" ng-repeat=\"selectedTag in vm.selectedTags\" ng-style=\"{ 'background-color': selectedTag.Color}\">{{selectedTag.CanonicalTagName}} <span class=\"fa fa-remove clickable\" ng-click=vm.removeTagFromFilter(selectedTag)></span></span> </label> </form> </div> </div> </div> <div id=tenant-sidebar> <div class=row ng-if=\"vm.tenantsList.length > 0 || vm.isFiltered\" ng-repeat=\"tenantTagSetDetail in vm.tenantTagSetDetails\"> <div class=\"col-lg-12 col-md-12 col-sm-12\"> <table class=\"table table-condensed table-borderless\"> <thead class=filter-header> <tr> <th>{{tenantTagSetDetail.tagSet.Name}}<span ng-class=\"tenantTagSetDetail.showTags ? 'fa-caret-down' : 'fa-caret-up'\" class=\"fa pull-right clickable\" ng-click=vm.toggleTagSetDisplay(tenantTagSetDetail)></span></th> </tr> </thead> <tbody> <tr class=\"no-padding-t no-padding-b\" ng-if=\"tenantTagSetDetail.showTags && tenantTagSetDetail.tagSet.Tags.length > 0\" ng-repeat=\"tag in tenantTagSetDetail.tagSet.Tags\"> <td class=\"no-padding-b no-border\"> <div> <span class=\"label label-info clickable\" ng-click=vm.addTagToFilter(tag) ng-style=\"{ 'background-color': tag.Color}\">{{tag.Name}}</span> </div> </td> </tr> <tr ng-if=\"tenantTagSetDetail.showTags && tenantTagSetDetail.tagSet.Tags.length === 0\"> <td class=no-border>Tenant tag set is empty</td> </tr> </tbody> </table> </div> </div> </div> <div id=tenant-content-wrapper ng-class=\"(vm.tenantsList.length === 0 && !vm.isFiltered) || vm.tenantTagSetDetails.length === 0 ? 'no-sidebar' : 'has-sidebar'\"> <loading-wrapper busy=vm.isLoading> <error-box error=vm.isLoading.error></error-box> <div class=\"row no-tenants\" ng-if=\"vm.tenantsList.length === 0 && vm.isFiltered\"> <div class=\"col-sm-12 col-md-12 col-lg-12\"><div><p>No tenants match the filters applied</p></div></div> </div> <div class=row ng-if=\"vm.tenantsList.length === 0 && !vm.isFiltered\"> <div class=\"col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2\"> <div class=row> <h2 class=text-center>Multi-tenant deployments in Octopus Deploy</h2> <p class=lead> Using tenants you can deploy your projects multiple times, once for each end-customer, manage unique configuration settings for each tenant, promote releases to your customers using safe customer-aware lifecycles, tailor the deployment process per-customer, implement dedicated and shared hosting models, and scale to thousands of customers using tags. </p> </div> <div class=row> <div class=\"col-lg-4 col-md-4 col-sm-4\"> <div class=panel> <div class=\"panel-body tenant-list-image\"> </div> <div class=panel-footer> Manage thousands of tenants easily all without leaving Octopus Deploy </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4\"> <div class=panel> <div class=\"panel-body tenant-projects-image\"> </div> <div class=panel-footer> Connect each tenant to a combination of projects and environments </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4\"> <div class=panel> <div class=\"panel-body global-dashboard-image\"> </div> <div class=panel-footer> The built-in dashboard provides an overview of the status of your tenants and deployments </div> </div> </div> </div> <div class=row> <div class=\"col-lg-4 col-md-4 col-sm-4\"> <div class=panel> <div class=\"panel-body project-tenant-dashboard-image\"> </div> <div class=panel-footer> See the status of your tenant deployments and upgrade with the click of a button </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4\"> <div class=panel> <div class=\"panel-body tenant-project-variables-image\"> </div> <div class=panel-footer> Manage tenant-specific configuration with an interface that adapts to your situation </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4\"> <div class=panel> <div class=\"panel-body tenant-tag-sets-image\"> </div> <div class=panel-footer> Conveniently work with your tenants as groups instead of individuals using tags </div> </div> </div> </div> <div class=\"row text-center\"> <p>Learn more in our <a href=http://g.octopushq.com/MultiTenantDeployments target=_blank>documentation</a>. </p> <a class=\"btn btn-lg btn-success\" href=#/tenants/new>Create your first tenant now</a> </div> </div> </div> <tenant-list tenants=vm.tenantsList></tenant-list> <octo-paginator collection=vm.tenants show-as-load-more=true load-more=vm.loadMoreTenants load-all=vm.loadAllTenants></octo-paginator> </loading-wrapper> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 998 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/overview.html';
	var html = " <script octo-section=tenant_tools type=text/ng-template> <button class=\"btn btn-success\"\r\n                ng-disabled=\"vm.isSaving.busy\"\r\n                ng-show=\"unsavedChanges.hasUnsavedChanges()\"\r\n                ng-click=\"vm.save()\">Save</button> </script> <div class=row> <form name=tenantForm ng-submit=vm.save() class=\"form-box form-horizontal\" track-unsaved-changes> <error-box error=vm.isSaving.error></error-box> <div class=col-sm-6> <div octo-permission=ProjectView wildcard> <h3 class=no-margin-top>Projects</h3> <tenants-project-selector tenant=vm.tenant ng-if=vm.tenant></tenants-project-selector> </div> </div> <div class=col-sm-6> <h3 class=no-margin-top>Tenant Tags</h3> <loading-wrapper busy=vm.isLoading> <div ng-if=!vm.hasTagSets> <p><a href=#/library/tagsets/ >Create tag sets</a> to classify tenants and deal with them as groups throughout Octopus. By tagging your tenants you can: <ul> <li>more easily filter your dashboards,</li> <li>modify your deployment processes,</li> <li>scope variables,</li> <li>implement different hosting strategies, and</li> <li>deploy to groups of tenants.</li> </ul> </p> <p>If you would like more information, or hints on how to get started with tags, take a look at our <a href=http://g.octopushq.com/MultiTenantTags target=_blank>documentation</a>.</p> </div> <div ng-if=vm.hasTagSets> <p>Tagging lets you deal with tenants in groups instead of as individuals. You can modify your tag sets in the <a href=#/library/tagsets>library</a>.</p> <div ng-repeat=\"tagSet in vm.tagSets\"> <div class=\"form-group form-group-narrow\"> <label class=\"control-label col-sm-3\" for=tagSetTags uib-tooltip={{tagSet.Description}} tooltip-placement=right>{{tagSet.Name}}</label> <div id=tagSetTags class=\"controls col-sm-9\"> <select-tags id=tagSetTags available=tagSet.Tags ng-model=vm.selectedTagSets[tagSet.Name] multiple=multiple></select-tags> </div> </div> </div> </div> </loading-wrapper> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 999 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/settings.html';
	var html = "<script octo-section=tenant_tools type=text/ng-template> <button class=\"btn btn-success\"\r\n                ng-disabled=\"vm.isSaving.busy\"\r\n                ng-show=\"unsavedChanges.hasUnsavedChanges()\"\r\n                ng-click=\"vm.save()\">Save</button> </script> <div class=row> <div class=col-sm-9> <form name=tenantForm ng-submit=vm.save() class=\"form-box form-horizontal\" track-unsaved-changes> <h3 class=no-margin-top ng-if=!vm.tenant.Id ng-cloak>Create a tenant</h3> <h3 class=no-margin-top ng-if=vm.tenant.Id>Tenant Settings</h3> <div class=form-body> <error-box error=vm.isSaving.error></error-box> <control-group label=Name> <input type=text class=form-control id=Name placeholder=\"Tenant Name\" ng-model=vm.tenant.Name /> </control-group> <control-group label=Logo> <div ng-if=vm.tenant.Id> <tenant-logo tenant=vm.tenant></tenant-logo> <a class=\"btn btn-info\" href=\"#/tenants/{{ vm.tenant.Id }}/logo\">Change</a> </div> <div ng-if=!vm.tenant.Id class=\"alert alert-info\"> A logo can only be uploaded once the tenant has been saved. </div> </control-group> </div> </form> </div> <div class=col-sm-3> <div class=other-actions octo-permission=TenantDelete ng-if=vm.tenant.Id> <div> <h3>Delete</h3> <p>Once you delete this tenant, there is no going back. The tenant will be permanently deleted.</p> <delete-button octo-permission=TenantDelete model=vm.tenant what=tenant redirect=/tenants></delete-button> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1000 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/tenant_add_project_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Connect to a project</h3> </div> <div class=modal-body> <control-group label=Project> <select-projects placeholder=\"'Select project'\" available=availableProjects ng-model=adding.ProjectId ng-change=getAvailableEnvironments()></select-projects> </control-group> <div ng-if=\"selectedProject.TenantedDeploymentMode === 'Untenanted'\" class=\"alert alert-info\"> <p>To connect this tenant to {{selectedProject.Name}} you need to enable tenanted deployments.</p> <p octo-permission=ProjectEdit octo-project=selectedProject.Id class=text-center><button class=\"btn btn-info\" ng-click=enableTenantedDeployments()>Enable tenanted deployments for {{selectedProject.Name}}</button></p> </div> <error-box error=isSavingProject.error></error-box> <loading-wrapper busy=isLoading> <control-group ng-if=\"selectedProject && selectedProject.TenantedDeploymentMode !== 'Untenanted'\" label=Environments> <select-environments placeholder=\"'Select environments'\" available=availableEnvironments ng-model=adding.Environments multiple=true></select-environments> <p class=help-block>The environments you want to deploy the project into for this tenant.</p> </control-group> </loading-wrapper> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save() ng-disabled=\"!adding.ProjectId || selectedProject.TenantedDeploymentMode === 'Untenanted'\" ng-show=!isLoading.busy>Add connection </button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1001 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/tenant_edit_project_dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Change connection to {{projectName}}</h3> </div> <div class=modal-body> <loading-wrapper busy=isLoading> <control-group label=Environments> <select-environments placeholder=\"'Select Environments'\" available=availableEnvironments ng-model=selected.environmentIds multiple=true></select-environments> <p class=help-block>The environments you want to deploy the project into for this tenant.</p> </control-group> </loading-wrapper> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save() ng-show=!isLoading.busy>Save</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1002 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/tenant_layout.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/tenants/{{ vm.tenantId }}\">{{ vm.tenant.Name }}</a></li> </script> <script octo-section=tools type=text/ng-template> <div octo-placeholder=\"tenant_tools_left\" style=\"display: inline;\">\r\n    </div>\r\n    <unsaved-changes-indicator></unsaved-changes-indicator>\r\n    <div octo-placeholder=\"tenant_tools\" style=\"display: inline;\">\r\n    </div> </script> <div class=\"page-body layout-sidebar\"> <div id=sidebar style=display:inherit ng-cloak> <div class=\"text-center hidden-xs\"> <a href=#/tenants/{{vm.tenantId}}/logo ng-if=vm.tenant> <tenant-logo tenant=vm.tenant max-size=214px></tenant-logo> </a> <h4 class=\"margin-top-bottom-10 text-wrap-break\">{{vm.tenant.Name}}</h4> </div> <hr> <div class=margin-top-20> <div class=list-group> <a class=list-group-item ng-class=\"{active: $root.layout.tenantTab == 'overview'}\" href=#/tenants/{{vm.tenantId}}>Overview</a> <a class=list-group-item ng-class=\"{active: $root.layout.tenantTab == 'variables'}\" href=#/tenants/{{vm.tenantId}}/variables>Variables <span class=pull-right> <i class=\"fa fa-warning text-warning\" ng-if=vm.tenantState.missingVariables.isMissingVariable uib-tooltip=\"Some of the required variable values have not been set.\"></i> </span> <a class=list-group-item ng-class=\"{active: $root.layout.tenantTab == 'settings'}\" href=#/tenants/{{vm.tenantId}}/settings>Settings</a> </a> </div> </div> </div> <div id=content-wrapper ng-cloak> <div id=view-container height-magic> <loading-wrapper busy=vm.isLoading once=true> <ui-view></ui-view> </loading-wrapper> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1003 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/tenant_status_popover.html';
	var html = "<i class=\"fa tenant-status\" ng-class=getIconStyle() uib-popover-template=\"'areas/tenants/views/tenant_status_popover_template.html'\" popover-trigger=mouseenter popover-placement=auto></i> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1004 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/tenant_status_popover_template.html';
	var html = "<div> <div> <p ng-if=tenant.isMissingVariable() class=text-warning><strong><i class=\"fa fa-warning\"></i> Some of the required variable values have not been set.</strong></p> <div octo-permission=ProjectView wildcard> <strong>Connected projects</strong> <div ng-repeat=\"map in tenant.projectEnvironmentMap track by map.project.Id | orderBy:'map.project.Name'\"> <span>{{map.project.Name}}</span> <span ng-if=\"map.environments.length <= 0\"> - no environments</span> </div> <div ng-if=\"tenant.projectEnvironmentMap.length <= 0\"> Not connected to any projects </div> </div> <br/> </div> <div ng-repeat=\"(tagSetName, tags) in tenant.selectedTagSets\"> <strong>{{tagSetName}}</strong> <tenant-tag ng-model=tag ng-repeat=\"tag in tags\"></tenant-tag> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1005 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/tenant_summary.html';
	var html = "<a class=\"octo-list-group-item tenant-tile\" href=\"#/tenants/{{ ::tenant.Id }}\"> <div class=octo-list-group-item-icon> <tenant-logo tenant=::tenant max-size=60px></tenant-logo> </div> <tenant-status-popover tenant=::tenant projects-by-id=::projectsById environments-by-id=::environmentsById></tenant-status-popover> <h4 class=octo-list-group-item-heading>{{ ::tenant.Name }}</h4> <div class=tenant-tags> <tenant-tag ng-model=::tag ng-repeat=\"tag in ::tenant.TenantTags\" mode=swatch></tenant-tag> </div> </a>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1006 */
/***/ function(module, exports) {

	var path = 'areas/tenants/views/tenants-project-selector.html';
	var html = "<div> <loading-wrapper busy=vm.isLoading> <ul class=\"octo-list-group can-add\"> <li class=\"octo-list-group-item tenant-project-mappings\" ng-repeat=\"map in vm.projectEnvironmentMap track by map.project.Id | orderBy:'map.project.Name'\"> <button class=\"close remove-button\" type=button aria-hidden=true ng-click=vm.removeProjectEnvironmentMapping(map.project.Id)>×</button> <project-logo project=map.project max-size=45px></project-logo> <a href=\"\" ng-click=vm.editProjectEnvironmentMapping(map.project.Id)><h4 class=octo-list-group-item-heading>{{ map.project.Name }}</h4></a> <div> <span ng-if=\"map.environments.length <= 0\" class=text-warning uib-tooltip=\"You will not be able to deploy {{map.project.Name}} to {{vm.tenant.Name || 'this tenant'}} until you connect to one of the environments.\"><i class=\"fa fa-warning text-warning\"></i> Not connected to any environments</span> <span ng-repeat=\"environment in map.environments track by environment.Id\" class=\"label truncate label-default\">{{ environment.Name }}</span> </div> <div style=clear:both></div> </li> </ul> <div ng-if=\"vm.projectEnvironmentMap.length <= 0\" class=\"alert alert-info\"> {{vm.tenant.Name || 'This tenant'}} is not connected to any projects. Connect {{vm.tenant.Name || 'this tenant'}} to a project and at least one environment to enable deployments. </div> <div class=\"text-center padding-sm\"> <button class=\"btn btn-info\" type=button ng-click=vm.addProjectEnvironmentMapping()><i class=icon-plus></i> Connect to {{vm.projectEnvironmentMap.length > 0 ? 'another' : 'a'}} project</button> </div> </loading-wrapper> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1007 */
/***/ function(module, exports) {

	var path = 'areas/users/views/auth_provider.html';
	var html = "<div> <div ng-bind-html-template=linkHtml></div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1008 */
/***/ function(module, exports) {

	var path = 'areas/users/views/profile.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/users/me\">{{ user.DisplayName }}</a></li> </script> <div> <div class=\"page-body layout-sidebar\"> <div id=sidebar style=display:inherit ng-cloak> <div class=user-profile-summary> <div class=user-profile-image> <avatar model=user size=440></avatar> </div> <p class=\"subtle margin-top-20 text-center\">You can change your picture at <a class=external href=http://g.octopushq.com/Gravatar target=_blank>Gravatar.com</a> </p> </div> </div> <div id=content-wrapper ng-cloak> <div id=view-container> <error-box error=isLoading.error></error-box> <div class=row> <div class=col-xs-12> <ul class=\"nav nav-tabs nav-tabs-simple\"> <li ng-class=\"{active: tab == 'profile'}\"><a href ng-click=\"changeTab('profile')\">My profile</a></li> <li ng-class=\"{active: tab == 'activity'}\" octo-permission=EventView octo-project=\"'*'\" octo-environment=\"'*'\"> <a href ng-click=\"changeTab('activity')\">Recent activity</a> </li> <li ng-class=\"{active: tab == 'apikeys'}\"><a href ng-click=\"changeTab('apikeys')\">API keys</a></li> </ul> </div> </div> <div class=row> <div class=col-xs-12> <div class=tab-content> <div class=tab-pane ng-class=\"{active: tab == 'profile'}\"> <div class=\"form-box form-horizontal help-scope\"> <form ng-submit=save()> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Username> <p class=form-control-static>{{ user.Username }}</p> </control-group> <control-group label=\"Display name\"> <input class=form-control type=text id=displayNameInput ng-model=user.DisplayName> </control-group> <control-group label=\"Email address\"> <input class=form-control type=text ng-model=user.EmailAddress id=emailInput> <p class=help-block>This address will be matched to your Gravatar if available.</p> </control-group> <div ng-show=user.CanPasswordBeEdited> <control-group label> <div class=checkbox><label><input type=checkbox ng-model=view.showPasswordChange> Change password</label></div> </control-group> <div ng-show=view.showPasswordChange> <control-group label=\"New password\"> <input class=form-control type=password ng-model=user.Password id=passInput> </control-group> <control-group label=\"Confirm new password\"> <input class=form-control type=password ng-model=view.confirmNewPassword id=confirmInput> </control-group> </div> </div> <last-modified model=user></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy> Save </button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> </div> </div> <div class=tab-pane ng-class=\"{active: tab == 'activity'}\"> <event-listing events=activity></event-listing> </div> <div class=tab-pane ng-class=\"{active: tab == 'apikeys'}\"> <div class=\"form-box form-horizontal help-scope\"> <p class=\"tutorial tutorial-left\"> You can use an API key to connect <a class=external href=http://g.octopushq.com/ExternalToolOctoTools target=_blank>automated tools</a> to Octopus, in place of a username and password. API keys are useful because they avoid the need to record your personal password in configuration files and scripts. A unique API key can be created for each use, and then individually revoked when no longer needed.</p> <user-api-keys user=user></user-api-keys> </div> </div> </div> </div> </div> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1009 */
/***/ function(module, exports) {

	var path = 'areas/users/views/register.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li>Register</li> </script> <div class=container-fluid> <div class=\"box-shadow narrow page-register\"> <div class=\"form-box form-horizontal register-panel\" id=loginForm> <form ng-submit=register()> <h3 class=no-margin-top>Let's get started</h3> <p class=intro>Welcome to <a class=external href=http://g.octopushq.com/ProductHomePage target=_blank>Octopus Deploy</a>! Since this is your first time here, you will need to create an account.</p> <error-box error=isSubmitting.error> </error-box> <div ng-show=invitationRequired> <control-group label=\"Invitation code\"> <input class=form-control type=text ng-model=fields.invitation> </control-group> </div> <control-group label=Username> <input class=form-control type=text ng-model=fields.username focus-me> </control-group> <control-group label=\"Display name\"> <input class=form-control type=text ng-model=fields.displayName> </control-group> <control-group label=\"Email address\"> <input class=form-control type=text ng-model=fields.emailAddress> <p class=subtle>This will be used to show your <a class=external tabindex=-1 href=http://g.octopushq.com/Gravatar target=_blank>Gravatar</a>.</p> </control-group> <control-group label=Password> <input class=form-control type=password ng-model=fields.password> </control-group> <control-group label=\"Confirm password\"> <input class=form-control type=password ng-model=fields.confirmPassword> </control-group> <div class=form-actions> <spin active=isSubmitting.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=isSubmitting.busy>Create account</button> or <a href=#/users/sign-in>sign in</a> </div> </form> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'areas/users/views/sign-in.html';
	var html = "<script octo-section=breadcrumbs type=text/ng-template> <li>Sign In</li> </script> <loading-wrapper busy=isRedirecting> <div ng-if=!anyAuthenticationProviders class=\"alert alert-warning\"> There are no authentication providers enabled. Learn about enabling <a class=alert-link href=http://g.octopushq.com/AuthenticationProviders target=_blank>authentication providers</a> </div> <div ng-if=anyAuthenticationProviders class=page-signin ng-class=\"{'narrow': !guestPanelVisible}\"> <div class=guest-panel ng-if=guestPanelVisible align=center> <div class=guest ng-click=signInAsGuest()><img src=" + __webpack_require__(1276) + " /><h1>I am a guest</h1></div> <div class=account ng-click=hideGuestPanel()><img src=" + __webpack_require__(111) + " /><h1>I have an account</h1></div> </div> <div class=login-panel ng-if=!guestPanelVisible> <div class=login-panel-heading> <img src=" + __webpack_require__(111) + " /> <h1 ng-if=\"!isSubmitting.error && !shouldAutoLogin\" class=panel-title>Welcome back! Please sign in.</h1> <h1 ng-if=\"!isSubmitting.error && shouldAutoLogin\" class=panel-title>Signing in, please wait...</h1> <div ng-if=isSubmitting.error class=login-errors-container> <div class=login-errors-icon><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i></div> <div class=login-errors> <div ng-repeat=\"error in isSubmitting.error.Errors\" class=login-error>{{error}}</div> </div> </div> </div> <div class=login-panel-body> <div ng-if=\"anyFormsAuthenticationProviders || formsProvidersWithLinks.length > 0\"> <form autofill-submit=signIn() class=\"form-box form-horizontal\" ng-if=anyFormsAuthenticationProviders> <div> <div class=login-panel-form> <div> <input type=text id=inputUsername placeholder=Username ng-model=fields.username focus-on=username autofill> </div> <div> <input type=password id=inputPassword placeholder=Password ng-model=fields.password autofill> </div> <div class=checkbox> <label for=chkRemember><input type=checkbox id=chkRemember ng-model=fields.rememberMe>Remember me on this computer</label> </div> </div> <div class=login-panel-footer> <div class=text-center> <spin active=isSubmitting.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=isSubmitting.busy>Sign in</button> </div> </div> </div> </form> <div ng-repeat=\"providerWithLink in formsProvidersWithLinks\" class=provider-link> <auth-provider provider=providerWithLink should-auto-login=shouldAutoLogin is-submitting=isSubmitting handle-sign-in-error=handleSignInError></auth-provider> </div> </div> <div class=external-providers ng-if=anyNonFormsAuthenticationProviders> <div class=external-provider ng-repeat=\"authenticationProvider in nonFormsAuthenticationProviders\"> <auth-provider provider=authenticationProvider should-auto-login=shouldAutoLogin is-submitting=isSubmitting handle-sign-in-error=handleSignInError></auth-provider> </div> </div> </div> <div class=guest-link ng-if=isGuestProviderEnabled ng-click=signInAsGuest()><a>I am a guest</a></div> </div> </div> </loading-wrapper>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'areas/users/views/sign-out.html';
	var html = "<div class=page-signout> <div class=signout-panel> <img src=" + __webpack_require__(111) + " /> <div class=\"form-box form-horizontal\" id=loginForm> <form ng-submit=signOut()> <div ng-if=isSubmitting.error class=login-errors-container> <div class=login-errors-icon><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i></div> <div class=login-errors> <div ng-repeat=\"error in isSubmitting.error.Errors\" class=login-error>{{error}}</div> </div> </div> <p>Are you sure you want to sign out?</p> <p>Clicking <strong>Sign out</strong> will clear our cookies and log you out on this device.</p> <div class=signout-actions> <spin active=isSubmitting.busy></spin> <button class=\"btn btn-success\" type=submit ng-disabled=isSubmitting.busy>Sign out</button> </div> </form> <a ng-click=cancel()>No, I want to stay!</a> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1012 */
/***/ function(module, exports) {

	var path = 'infrastructure/controllers/views/alert-dialog.html';
	var html = "<div class=modal-header> <i class=\"fa fa-warning\"></i> </div> <div class=modal-title> {{ options.title }} </div> <form> <div class=modal-body> <div ng-bind-html=options.message></div> </div> <div class=modal-footer> <button class=btn ng-click=close()>Close</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1013 */
/***/ function(module, exports) {

	var path = 'infrastructure/controllers/views/async-confirm-dialog.html';
	var html = "<div class=modal-header> <i class=\"fa fa-warning\"></i> </div> <div class=modal-title> {{ options.title }} </div> <form> <div class=modal-body> <error-box error=isWorking.error></error-box> <div ng-bind-html=options.message></div> <div class=text-left ng-if=\"(options.additionalDetails && options.additionalDetails.length > 0)\"> And in {{options.additionalDetails.length}} more locations. <a role=button data-toggle=collapse href=#additionalDetails aria-expanded=false aria-controls=additionalDetails>Show<i class=\"fa fa-fw fa-angle-double-down\"></i></a> <div class=collapse id=additionalDetails> <div ng-bind-html=\"options.additionalDetails.join('<br/>')\"></div> </div> </div> <div class=modal-footer> <spin active=isWorking.busy></spin> <button class=btn type=submit ng-disabled=\"isWorking.busy || isWorking.error\" ng-class=options.executeButtonClass ng-click=execute()>{{ options.executeButtonText }}</button> <button class=btn ng-disabled=isWorking.busy ng-click=close()>Cancel</button> </div> </div></form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1014 */
/***/ function(module, exports) {

	var path = 'infrastructure/controllers/views/message-box-dialog.html';
	var html = "<div class=modal-header> {{ options.caption }} </div> <div class=modal-body> <error-box error=isWorking.error></error-box> {{ options.message }} </div> <div class=modal-footer> <spin active=isWorking.busy style=position:relative;top:15px;left:15px></spin> <span ng-repeat=\"btn in options.buttons\"> <button class=btn ng-class=btn.cssClass ng-click=submit(btn.result)>{{ btn.label }}</button> </span> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1015 */
/***/ function(module, exports) {

	var path = 'infrastructure/controllers/views/prompt-dialog.html';
	var html = "<div class=modal-header> <i class=\"fa fa-check\"></i> </div> <form> <div class=modal-body> <error-box error=isWorking.error></error-box> <h3>{{ options.title }}</h3> <p>{{ options.message }}</p> <input class=\"input-xlarge form-control\" type=text ng-model=options.answer> </div> <div class=modal-footer> <spin active=isWorking.busy></spin> <button type=submit class=\"btn btn-default\" ng-disabled=isWorking.busy ng-class=options.executeButtonClass ng-click=execute()>{{ options.executeButtonText }}</button> <button class=\"btn btn-default\" ng-disabled=isWorking.busy ng-click=close()>Cancel</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1016 */
/***/ function(module, exports) {

	var path = 'infrastructure/controllers/views/sort-dialog.html';
	var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-hide=isSaving.busy ng-click=close()>×</button> <h3>{{ options.title }}</h3> </div> <form> <div class=modal-body> <error-box error=isLoading.error></error-box> <error-box error=isSaving.error></error-box> <spin active=isLoading.busy></spin> <div ng-show=isLoading.busy>Loading...</div> <div class=sort-list ui-sortable ng-model=items ng-show=items> <div class=sortable-item ng-repeat=\"item in items\" data-id=\"{{ item.id }}\"><i class=\"fa fa-sort\"></i> &nbsp; {{ item.name }}</div> </div> </div> <div class=modal-footer> <spin active=isSaving.busy></spin> <button type=submit class=\"btn btn-success\" ng-show=items ng-disabled=\"isLoading.busy || isSaving.busy\" ng-click=save()>{{options.saveButtonText}}</button> <button class=\"btn btn-default\" ng-disabled=isSaving.busy ng-click=close()>Cancel</button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1017 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/bound-field.html';
	var html = "<div class=\"bound-field control\"> <div class=\"dropdown bind-button\"> <insert-variable-button project-id=projectId project-environments-filter=projectEnvironmentsFilter ng-show=\"(needsSpecialTextBox && isBound) || !needsSpecialTextBox\" local-names=localNames> </insert-variable-button> <a tabindex=-1 href=\"\" title=\"{{ boundText() }}\" class=toggle-bound-field data-toggle=dropdown external-dropdown=\"{id: 'fieldBinderDropDown', scope: { bind: bind, unbind: unbind, isBound: isBound } }\" ng-show=\"needsSpecialTextBox && !isLocked()\" ng-class=\"{bound: isBound}\"></a> </div> <div class=\"transcluded input-boxes\" ng-hide=\"isBound && needsSpecialTextBox\" ng-transclude></div> <div class=transcluded ng-show=\"isBound && needsSpecialTextBox\"> <label class=text-normal ng-if=label>{{label}}</label> <textarea ng-model=model class=\"fixed binder smaller-fonts form-control\" style=height:120px></textarea> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1018 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/control-group.html';
	var html = "<div class=\"form-group form-group-narrow\"> <label class=\"control-label col-sm-3\" for={{for}}>{{label}}</label> <div class=\"controls col-sm-9\" ng-transclude></div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1019 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/error-box.html';
	var html = "<div class=\"validation-errors errors text-left alert alert-warning\" ng-show=\"hasError && isOpen\"> <button class=close type=button ng-click=dismiss() aria-label=\"Dismiss error box\">×</button> <p ng-bind=error.ErrorMessage></p> <ul ng-show=error.Errors> <li ng-repeat=\"err in error.Errors track by $index\"> {{err}}<br/> <a ng-show=error.ParsedHelpLinks[$index] class=\"external alert-link\" target=_blank href={{error.ParsedHelpLinks[$index]}}>More information...</a> </li> </ul> <p class=subtle ng-show=error.HelpText>{{ error.HelpText }}</p> <p ng-show=error.HelpLink><a class=\"external alert-link\" target=_blank href={{error.HelpLink}}>More information...</a></p> <pre ng-show=error.FullException ng-bind=error.FullException></pre> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1020 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/help-button.html';
	var html = "<div style=position:relative;z-index:100;float:right> <a style=position:absolute;right:0;margin-top:-5px href=\"\" ng-click=helpManager.toggleHelp() ng-show=helpManager.hasHelp()> <i class=context-help-available ng-class=\"{ 'help-enabled': helpManager.isHelpVisible }\" title=\"Show or hide context sensitive help\"></i> </a> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1021 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/loading-wrapper.html';
	var html = "<div> <div ng-show=!hasLoaded class=loading-wrapper-spinner> <spin active=busy.busy class=spin-static></spin> </div> <div ng-show=hasLoaded class=fade-in-when-loaded ng-class=\"{ 'has-loaded': hasLoaded }\"> <error-box error=busy.error></error-box> <div ng-show=!busy.error> <div ng-transclude></div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'infrastructure/directives/views/octo-clippy.html';
	var html = "<div class=\"clippy note note-info\"> <img src=" + __webpack_require__(1231) + " width=64 height=64 alt=\"Octoclippy is here to help!\" title=\"Octoclippy is here to help!\" class=pull-left /> <div class=\"clippy-says padding-sm-vr\" ng-transclude></div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1023 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/octo-paginator.html';
	var html = "<div> <div ng-show=show> <ul class=pagination ng-if=!showAsLoadMore> <li ng-repeat=\"page in pages\" ng-class=\"{active: page.isActive}\"><a href=\"\" ng-click=\"onPageSelected(page.skip, page.index)\">{{ page.number }}</a></li> </ul> <div class=\"col-md-12 text-center\" ng-if=showAsLoadMore> <button class=\"btn btn-default\" ng-click=onLoadMore(skip)>Load more</button> <button class=\"btn btn-link\" ng-if=\"show && !!loadAll\" ng-click=onLoadAll()>Load all</button> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1024 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/search-box.html';
	var html = "<label class=search-box> <i class=\"fa fa-search clickable\" ng-click=onSearchClicked(inputText)></i> <input type=text class=form-control ng-model=inputText placeholder={{placeholder}} ng-change=onTextChanged(inputText) focus-me=autoFocus> </label>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1025 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/spin.html';
	var html = "<span class=spin-container> <span ng-show=active class=spinny> <i class=\"fa fa-spinner fa-spin fa-lg\"></i> </span> </span>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1026 */
/***/ function(module, exports) {

	var path = 'infrastructure/directives/views/update-wrapper.html';
	var html = "<div> <div ng-show=busy.busy style=height:20px> <spin active=busy.busy></spin> </div> <div ng-show=!busy.busy> <error-box error=busy.error></error-box> <div ng-show=!busy.error> <div ng-transclude></div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1027 */
/***/ function(module, exports) {

	var path = 'infrastructure/style-guide/style_guide.html';
	var html = "<div class=style-guide> <h3>Live Style Guide</h3> <h4>Search box</h4> <ul> <li> <div class=\"search col-sm-12 col-md-5 col-lg-4\"> <search-box input-text=inputText on-text-changed=filterTemplates placeholder=\"Filter by name, category or description\"/> </div> </li> </ul> <div class=clearfix></div> <h4>Cards</h4> <script>!function(e,l,s){var a=e.querySelectorAll(\"html\")[0];a.className=a.className.replace(/(^|\\s)no-js(\\s|$)/,\"$1$2\")}(document,window,0)</script> <ul> <h4>Card with hover action</h4> <div><code> <card-action logo-url=\"\" title=\"\" content=\"\" footer-content=\"\" footer-icon=\"\" action=\"\" action-url=\"\"/></code></div> <div><code> &lt;card-footer content=\"\" icon=\"\" url=\"\"/></code></div> <li> <div class=\"step-templates card-concept\"> <card-block data=cards /> <ol class=card-block> <li class=\"card card-action col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=add-action> <button class=\"btn btn-success add\" type=button>Add step</button> <div class=\"add-action-details add-action-details-installed\"> </div> </div> <div class=card-footer> <span>card-footer</span> </div> </div> </li> <li class=\"card-blue card card-action col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span> </div> <div class=add-action> <button class=\"btn btn-success add\" type=button>Add step</button> <div class=\"add-action-details add-action-details-installed\"> </div> </div> </div> </li> <li class=\"card-grey card card-action col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span> </div> <div class=add-action> <button class=\"btn btn-success add\" type=button>Add step</button> <div class=\"add-action-details add-action-details-installed\"> </div> </div> </div> </li> <li class=\"card card-action col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span><i class=\"fa fa-users\" aria-hidden=true></i> </div> <div class=add-action> <button class=\"btn btn-success add\" type=button>Add step</button> <div class=\"add-action-details add-action-details-installed\"> </div> </div> </div> </li> <li class=\"card-grey card card-action col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span><i class=fontoctopus-octopus></i> </div> <div class=add-action> <button class=\"btn btn-success add\" type=button>Add step</button> <div class=\"add-action-details add-action-details-installed\"> </div> </div> </div> </li> <li class=\"card card-action col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span><i class=fontoctopus-octopus></i> </div> <div class=add-action> <button class=\"btn btn-success add\" type=button>Add step</button> <div class=\"add-action-details add-action-details-installed\"> </div> </div> </div> </li> </ol> </div> </li> <li> <h4>Card</h4> <div><code> &lt;card logo-url=\"\" title=\"\" content=\"\" footer-content=\"\" footer-icon=\"\" href=\"\"/></code></div> <div class=\"step-templates card-concept\"> <ol class=card-block> <li class=\"card col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <a href=# class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span> </div> </a> </li> <li class=\"card-blue card col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span> </div> </div> </li> <li class=\"card-grey card col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span> </div> </div> </li> <li class=\"card col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span><i class=\"fa fa-users\" aria-hidden=true></i> </div> </div> </li> <li class=\"card-grey card col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span><i class=fontoctopus-octopus></i> </div> </div> </li> <li class=\"card col-lg-2 col-md-3 col-sm-3 col-xs-4\"> <div class=\"card-content animated\"> <div class=\"logo logo-md\"> <img src=\"http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo?cb=1478738699\"></div> <div class=card-details> <h5>Card-title</h5> <p>Card-content</p> </div> <div class=card-footer> <span>card-footer</span><i class=fontoctopus-octopus></i> </div> </div> </li> </ol> </div> </li> <h4>Tiles</h4> <li> <div class=grouping-container> <ol class=\"tile-group categories\"> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> <li class=\"tile animated col-md-2 col-sm-2 col-xs-3\"> <div class=tile-content> <div> <div class=\"logo logo-md\"><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> <p>Category</p> </div> </div> </li> </ol> </div> </li> <h4>Logo</h4> <li> <div class=\"col-md-4 col-sm-4\"> <div class=logo-lg><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> </div> <div class=\"col-md-4 col-sm-4\"> <div class=logo-md><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> </div> <div class=\"col-md-4 col-sm-4\"> <div class=logo-sm><img src=http://dawops-addstep.octopushq.com/api/communityactiontemplates/CommunityActionTemplates-2/logo></div> </div> </li> </ul> </div> <script>!function(t,e,r,n){\"use strict\";var i=r.body||r.documentElement,i=i.style;if(\"\"==i.webkitFlexWrap||\"\"==i.msFlexWrap||\"\"==i.flexWrap)return!0;var o=t(\".card-block\"),a=o.find(\".card-content\"),c=function(){a.css(\"height\",\"auto\");var e=Math.floor(o.width()/a.width());if(null==e||e<2)return!0;for(var r=0,n=a.length;r<n;r+=e){var i=0,c=a.slice(r,r+e);c.each(function(){var e=parseInt(t(this).outerHeight());e>i&&(i=e)}),c.css(\"height\",i)}};c(),t(e).on(\"resize\",c),o.find(\"img\").on(\"load\",c)}(jQuery,window,document)</script> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "octoclippy.c6dd91f704d3e626b4f262534a870dcd.hashedasset.png";

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-CalamariNeedsUpgrade.Ssh.7796b92789dcb77d14da3a3b5e9907f7.hashedasset.png";

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-CalamariNeedsUpgrade.TentacleActive.0ac101d4c1f56c08b91e018d061b0c46.hashedasset.png";

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-CalamariNeedsUpgrade.TentaclePassive.0ac101d4c1f56c08b91e018d061b0c46.hashedasset.png";

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.AzureCloudService.d68b04fee6785efecca410b256e6f095.hashedasset.png";

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.AzureWebApp.ecac5ad1b123721e8de4c819cfa6f87c.hashedasset.png";

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.Ftp.c66a4515c75191d22d4da4342e1a9e71.hashedasset.png";

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.None.fcdf22e9f039f6d120cc140059e5e950.hashedasset.png";

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.OfflineDrop.2155edf5823a758ae3bc282b03dce72f.hashedasset.png";

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.Ssh.3678e386d6269cc2aae93179f4ec794b.hashedasset.png";

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.TentacleActive.b2c1c7c0cedd2009379e72ee0e1dc23a.hashedasset.png";

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Disabled.TentaclePassive.fcdd5005d2db66310452c55ad3159231.hashedasset.png";

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-HasWarnings.Ssh.7796b92789dcb77d14da3a3b5e9907f7.hashedasset.png";

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-HasWarnings.TentacleActive.0ac101d4c1f56c08b91e018d061b0c46.hashedasset.png";

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-HasWarnings.TentaclePassive.0ac101d4c1f56c08b91e018d061b0c46.hashedasset.png";

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.AzureCloudService.f244dff0476e14ce1df339ce61945790.hashedasset.png";

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.AzureWebApp.735ccede618abf1f4689de7c6cf90b76.hashedasset.png";

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.Ftp.d5c8f1b941272cab6e0b7b6d8e437fa0.hashedasset.png";

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.None.89c83aa25b2e4ff8b54fcde476c9f344.hashedasset.png";

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.OfflineDrop.5f275bdf370f635820a5ca394008bc08.hashedasset.png";

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.Ssh.7796b92789dcb77d14da3a3b5e9907f7.hashedasset.png";

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.TentacleActive.1f8d0d2ffd8e58fe8844ecbce562f98e.hashedasset.png";

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Healthy.TentaclePassive.588dcaddf80ba6632e75b2651a71c15f.hashedasset.png";

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-NeedsUpgrade.TentacleActive.0ac101d4c1f56c08b91e018d061b0c46.hashedasset.png";

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-NeedsUpgrade.TentaclePassive.0ac101d4c1f56c08b91e018d061b0c46.hashedasset.png";

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unavailable.AzureCloudService.c1a02803154fdb14d62b16af4df0de0d.hashedasset.png";

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unavailable.AzureWebApp.675564d3f15222dbfca0c3ff021fea19.hashedasset.png";

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unavailable.Ftp.3bcd4ad374a661d0bb16a411cd960a0b.hashedasset.png";

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unavailable.OfflineDrop.0b61574ca7501fd5cd8fc6cffb3eff2d.hashedasset.png";

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unavailable.Ssh.7704e850e691b9fd9d9c11fe14a09203.hashedasset.png";

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unavailable.TentacleActive.c6e6915dd0ed3e67c52aa23c41b60913.hashedasset.png";

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unavailable.TentaclePassive.821f4b7f80c7b6f67feacc02b1fa5fd6.hashedasset.png";

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unhealthy.Ssh.89e6faf15e7b150d025147c9abd62f9c.hashedasset.png";

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unhealthy.TentacleActive.f473525c9942c566bf2c9406b5b0a0a3.hashedasset.png";

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unhealthy.TentaclePassive.f473525c9942c566bf2c9406b5b0a0a3.hashedasset.png";

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unknown.AzureCloudService.b9a96059f6ec5d10440bdac70aecd2aa.hashedasset.png";

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unknown.AzureWebApp.517460f4d2d37bdc51f619c96c909ae0.hashedasset.png";

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unknown.Ftp.68fa9f63c8d7fffb7c4fdc9c0d699738.hashedasset.png";

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unknown.OfflineDrop.41043d5f078822837a403620b37cb1a9.hashedasset.png";

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unknown.Ssh.de70ef1a1f63f644a3511fefab70141c.hashedasset.png";

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unknown.TentacleActive.dd0a51b47eaf1f3f15f488db73332db9.hashedasset.png";

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Server-Unknown.TentaclePassive.cc0b582b60bbc0369593a01f16734d6d.hashedasset.png";

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "tenant-not-connected.6cb7bf68ce226522cdb29fd89a1332d5.hashedasset.png";

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "un-tenanted-deployment-logo.938c3b504dcc1234028a44b839fe042e.hashedasset.png";

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "avatar-placeholder.8ec08b3a5daa6459be10a22d459dee1d.hashedasset.png";

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "starfish.14e89850a112482b581e37d10bef7101.hashedasset.svg";

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "prompted.a846c8b2a7b93fed6f279c8744bd6d96.hashedasset.png";

/***/ },
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// application.2cd5fc19440a6124a44f.hashedasset.js